/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 112);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(119);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(41);
module.exports.easing = __webpack_require__(253);
module.exports.canvas = __webpack_require__(254);
module.exports.options = __webpack_require__(255);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);

module.exports = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers.merge(this[scope] || (this[scope] = {}), values);
	}
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports={checkBool:function checkBool(val){if(typeof value==='string'){if(val.toLowerCase()==='true')return true;if(val.toLowerCase()==='false')return false;}return val;},money:function money(val){return val.toLocaleString('it-IT',{style:'currency',currency:'EUR'});},grant:function grant(){return parseInt(window.localStorage.getItem('it.clubhub.grant'),10)>1;},grantAdmin:function grantAdmin(){return parseInt(window.localStorage.getItem('it.clubhub.grant'),10)===5;},grantMy:function grantMy(id){return parseInt(window.localStorage.getItem('it.clubhub.userid'),10)===id;},generateUrl:function generateUrl(prod,base,id,checksum){if(prod){return base+'/'+id+'/'+checksum+'/';}else{return base+'?id='+id+'&checksum='+checksum;}},validMail:function validMail(email){var re=/^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;return re.test(String(email).toLowerCase());}};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(132)();
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return URIS; });
/* harmony export (immutable) */ __webpack_exports__["b"] = loadHeaders;
// import { ENV } from './environment'
var apiBase='https://api.clubhub.it/';// if (!ENV.production) {
//   apiBase = 'http://127.0.0.1/cmapi/'
// }
if(window.location.hostname.indexOf('192.168')>-1){apiBase='http://'+window.location.hostname+'/cmapi/';}var URIS={apiBase:apiBase,login:apiBase+'login',club:apiBase+'club',members:apiBase+'members',courses:apiBase+'courses',instructors:apiBase+'instructors',receipts:apiBase+'receipts',pdf:apiBase+'pdf',doc:apiBase+'doc',balance:apiBase+'balance',fiscalyear:apiBase+'fiscalyear',attendances:apiBase+'attendances',dashboard:apiBase+'dashboard',notes:apiBase+'notes',version:apiBase+'version',export:apiBase+'export',exportFolder:apiBase+'tmp',axiosHeaders:{'Content-Type':'application/json'}};function loadHeaders(){return{'X-Bearer':window.localStorage['it.clubhub.bearer'],'X-Time':window.localStorage['it.clubhub.time'],'X-Email':window.localStorage['it.clubhub.email'],'X-Grant':window.localStorage['it.clubhub.grant'],'X-Club':window.localStorage['it.clubhub.club'],'X-Userid':window.localStorage['it.clubhub.userid'],'X-Fiscalyear':window.localStorage['it.clubhub.fiscalyear'],'Content-Type':'application/json'};}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=function(_Component){_inherits(Modal,_Component);function Modal(){_classCallCheck(this,Modal);return _possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).apply(this,arguments));}_createClass(Modal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},this.props.children));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(85);
var isBuffer = __webpack_require__(184);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(183);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = errorMessage;
function errorMessage(error){try{var e=error.response.statusText||error.response.data.error||error.message;if(!e){throw new Error('Generic Error');}return e;}catch(error){console.log(error);return'Generic Error';}}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DualRing=function(_Component){_inherits(DualRing,_Component);function DualRing(){_classCallCheck(this,DualRing);return _possibleConstructorReturn(this,(DualRing.__proto__||Object.getPrototypeOf(DualRing)).apply(this,arguments));}_createClass(DualRing,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-loader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lds-dual-ring'}));}}]);return DualRing;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DualRing);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var color = __webpack_require__(94);
var helpers = __webpack_require__(1);

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = color(origin);
				if (c0.valid) {
					c1 = color(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers.extend(Element.prototype, {

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers.clone(me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = model;
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
	}
});

Element.extend = helpers.inherits;

module.exports = Element;


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_COURSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_COURSES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_COURSES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SAVE_COURSES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_COURSES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COURSES_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COURSES_CLEAR_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_COURSES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_COURSES_FAILURE; });
/* harmony export (immutable) */ __webpack_exports__["l"] = loadCourses;
/* harmony export (immutable) */ __webpack_exports__["m"] = saveCourses;
/* harmony export (immutable) */ __webpack_exports__["k"] = deleteCourses;
/* unused harmony export deleteCoursesFailure */
/* harmony export (immutable) */ __webpack_exports__["j"] = clearAjaxCall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(11);
var FETCH_COURSES='FETCH_COURSES';var FETCH_COURSES_SUCCESS='FETCH_COURSES_SUCCESS';var FETCH_COURSES_FAILURE='FETCH_COURSES_FAILURE';var SAVE_COURSES_SUCCESS='SAVE_COURSES_SUCCESS';var SAVE_COURSES_FAILURE='SAVE_COURSES_FAILURE';var COURSES_AJAX_CALL='COURSES_AJAX_CALL';var COURSES_CLEAR_AJAX_CALL='COURSES_CLEAR_AJAX_CALL';var DELETE_COURSES_SUCCESS='DELETE_COURSES_SUCCESS';var DELETE_COURSES_FAILURE='DELETE_COURSES_FAILURE';function loadCourses(){return function(dispatch){dispatch(fetchCourses());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'GET',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].courses,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])()}).then(function(res){dispatch(fetchCoursesSuccess(res.data));}).catch(function(error){dispatch(fetchCoursesFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function fetchCourses(){return{type:FETCH_COURSES};}function fetchCoursesSuccess(payload){return{type:FETCH_COURSES_SUCCESS,payload:payload};}function fetchCoursesFailure(payload){return{type:FETCH_COURSES_FAILURE,payload:payload};}function saveCourses(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'POST',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].courses,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(saveCoursesSuccess(res.data));}).catch(function(error){dispatch(saveCoursesFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function saveCoursesSuccess(payload){return{type:SAVE_COURSES_SUCCESS,payload:payload};}function saveCoursesFailure(payload){return{type:SAVE_COURSES_FAILURE,payload:payload};}function deleteCourses(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'DELETE',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].courses,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(deleteCoursesSuccess(res.data.data));}).catch(function(error){dispatch(deleteCoursesFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function deleteCoursesSuccess(payload){return{type:DELETE_COURSES_SUCCESS,payload:payload};}function deleteCoursesFailure(payload){return{type:DELETE_COURSES_FAILURE,payload:payload};}function loadingAjaxCall(){return{type:COURSES_AJAX_CALL};}function clearAjaxCall(payload){return{type:COURSES_CLEAR_AJAX_CALL};}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Error=function(_Component){_inherits(Error,_Component);function Error(){_classCallCheck(this,Error);return _possibleConstructorReturn(this,(Error.__proto__||Object.getPrototypeOf(Error)).apply(this,arguments));}_createClass(Error,[{key:'render',value:function render(){var error=this.props.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-exclamation-triangle'}),' ',error);}}]);return Error;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Error);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(101);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule warning
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_MEMBERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_MEMBERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_MEMBERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SAVE_MEMBERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SAVE_MEMBERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MEMBERS_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MEMBERS_CLEAR_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_MEMBERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_MEMBERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MEMBERS_START_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MEMBERS_STOP_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_LAST_PAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXPORT_MEMBERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EXPORT_MEMBERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EXPORT_MEMBERS_FAILURE; });
/* harmony export (immutable) */ __webpack_exports__["s"] = loadMembers;
/* harmony export (immutable) */ __webpack_exports__["t"] = saveMembers;
/* harmony export (immutable) */ __webpack_exports__["u"] = saveMembersFailure;
/* harmony export (immutable) */ __webpack_exports__["q"] = deleteMembers;
/* unused harmony export deleteMembersFailure */
/* harmony export (immutable) */ __webpack_exports__["p"] = clearAjaxCall;
/* harmony export (immutable) */ __webpack_exports__["w"] = startUpload;
/* harmony export (immutable) */ __webpack_exports__["x"] = stopUpload;
/* harmony export (immutable) */ __webpack_exports__["v"] = setMemberLastPaid;
/* harmony export (immutable) */ __webpack_exports__["r"] = loadExportMembers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(11);
var FETCH_MEMBERS='FETCH_MEMBERS';var FETCH_MEMBERS_SUCCESS='FETCH_MEMBERS_SUCCESS';var FETCH_MEMBERS_FAILURE='FETCH_MEMBERS_FAILURE';var SAVE_MEMBERS_SUCCESS='SAVE_MEMBERS_SUCCESS';var SAVE_MEMBERS_FAILURE='SAVE_MEMBERS_FAILURE';var MEMBERS_AJAX_CALL='MEMBERS_AJAX_CALL';var MEMBERS_CLEAR_AJAX_CALL='MEMBERS_CLEAR_AJAX_CALL';var DELETE_MEMBERS_SUCCESS='DELETE_MEMBERS_SUCCESS';var DELETE_MEMBERS_FAILURE='DELETE_MEMBERS_FAILURE';var MEMBERS_START_UPLOAD='MEMBERS_START_UPLOAD';var MEMBERS_STOP_UPLOAD='MEMBERS_STOP_UPLOAD';var SET_LAST_PAID='SET_LAST_PAID';var EXPORT_MEMBERS='EXPORT_MEMBERS';var EXPORT_MEMBERS_SUCCESS='EXPORT_MEMBERS_SUCCESS';var EXPORT_MEMBERS_FAILURE='EXPORT_MEMBERS_FAILURE';function loadMembers(){return function(dispatch){dispatch(fetchMembers());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'GET',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].members,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])()}).then(function(res){dispatch(fetchMembersSuccess(res.data));}).catch(function(error){dispatch(fetchMembersFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function fetchMembers(){return{type:FETCH_MEMBERS};}function fetchMembersSuccess(payload){return{type:FETCH_MEMBERS_SUCCESS,payload:payload};}function fetchMembersFailure(payload){return{type:FETCH_MEMBERS_FAILURE,payload:payload};}function saveMembers(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'POST',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].members,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(saveMembersSuccess(res.data));}).catch(function(error){dispatch(saveMembersFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function saveMembersSuccess(payload){return{type:SAVE_MEMBERS_SUCCESS,payload:payload};}function saveMembersFailure(payload){return{type:SAVE_MEMBERS_FAILURE,payload:payload};}function deleteMembers(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'DELETE',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].members,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(deleteMembersSuccess(res.data.data));}).catch(function(error){dispatch(deleteMembersFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function deleteMembersSuccess(payload){return{type:DELETE_MEMBERS_SUCCESS,payload:payload};}function deleteMembersFailure(payload){return{type:DELETE_MEMBERS_FAILURE,payload:payload};}function loadingAjaxCall(){return{type:MEMBERS_AJAX_CALL};}function clearAjaxCall(payload){return{type:MEMBERS_CLEAR_AJAX_CALL};}function startUpload(){return{type:MEMBERS_START_UPLOAD};}function stopUpload(){return{type:MEMBERS_STOP_UPLOAD};}function setMemberLastPaid(payload){return{type:SET_LAST_PAID,payload:payload};}function loadExportMembers(payload){return function(dispatch){dispatch(exportMembers());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'POST',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].export,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(exportMembersSuccess(res.data));}).catch(function(error){dispatch(exportMembersFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function exportMembers(){return{type:EXPORT_MEMBERS};}function exportMembersSuccess(payload){return{type:EXPORT_MEMBERS_SUCCESS,payload:payload};}function exportMembersFailure(payload){return{type:EXPORT_MEMBERS_FAILURE,payload:payload};}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AjaxSpinner=function(_Component){_inherits(AjaxSpinner,_Component);function AjaxSpinner(){_classCallCheck(this,AjaxSpinner);return _possibleConstructorReturn(this,(AjaxSpinner.__proto__||Object.getPrototypeOf(AjaxSpinner)).apply(this,arguments));}_createClass(AjaxSpinner,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spinner ajax'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'circle'}));}}]);return AjaxSpinner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AjaxSpinner);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};
module.exports.Arc = __webpack_require__(261);
module.exports.Line = __webpack_require__(262);
module.exports.Point = __webpack_require__(263);
module.exports.Rectangle = __webpack_require__(264);


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = {"memberTypes":[{"value":"","label":"Tutti i soci"},{"value":true,"label":"Solo soci attivi"},{"value":false,"label":"Solo soci non attivi"}],"sexTypes":[{"value":"","label":"Tutti","search":true,"edit":false},{"value":"","label":"","search":false,"edit":true},{"value":"Maschio","label":"Maschio"},{"value":"Femmina","label":"Femmina"}],"tshirtSizes":[{"value":"","label":"Tutte le taglie","search":true,"edit":false},{"value":"","label":"","search":false,"edit":true},{"value":"XS","label":"XS"},{"value":"S","label":"S"},{"value":"M","label":"M"},{"value":"L","label":"L"},{"value":"XL","label":"XL"},{"value":"2XL","label":"2XL"},{"value":"3XL","label":"3XL"},{"value":"4XL","label":"4XL"}],"paymentTypes":[{"value":"Contanti","label":"Contanti"},{"value":"Banca","label":"Banca"},{"value":"PayPal","label":"PayPal"}],"directionTypes":[{"value":"0","label":"Uscita"},{"value":"1","label":"Entrata"}],"titles":["Atleta","Dirigente","Tecnico","Tutore legale","Agonista"]}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(309),
    getValue = __webpack_require__(314);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(26);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_INSTRUCTORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_INSTRUCTORS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_INSTRUCTORS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SAVE_INSTRUCTORS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_INSTRUCTORS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return INSTRUCTORS_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return INSTRUCTORS_CLEAR_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_INSTRUCTORS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_INSTRUCTORS_FAILURE; });
/* harmony export (immutable) */ __webpack_exports__["l"] = loadInstructors;
/* harmony export (immutable) */ __webpack_exports__["m"] = saveInstructors;
/* harmony export (immutable) */ __webpack_exports__["k"] = deleteInstructors;
/* unused harmony export deleteInstructorsFailure */
/* harmony export (immutable) */ __webpack_exports__["j"] = clearAjaxCall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(11);
var FETCH_INSTRUCTORS='FETCH_INSTRUCTORS';var FETCH_INSTRUCTORS_SUCCESS='FETCH_INSTRUCTORS_SUCCESS';var FETCH_INSTRUCTORS_FAILURE='FETCH_INSTRUCTORS_FAILURE';var SAVE_INSTRUCTORS_SUCCESS='SAVE_INSTRUCTORS_SUCCESS';var SAVE_INSTRUCTORS_FAILURE='SAVE_INSTRUCTORS_FAILURE';var INSTRUCTORS_AJAX_CALL='INSTRUCTORS_AJAX_CALL';var INSTRUCTORS_CLEAR_AJAX_CALL='INSTRUCTORS_CLEAR_AJAX_CALL';var DELETE_INSTRUCTORS_SUCCESS='DELETE_INSTRUCTORS_SUCCESS';var DELETE_INSTRUCTORS_FAILURE='DELETE_INSTRUCTORS_FAILURE';function loadInstructors(){return function(dispatch){dispatch(fetchInstructors());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'GET',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].instructors,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])()}).then(function(res){dispatch(fetchInstructorsSuccess(res.data));}).catch(function(error){dispatch(fetchInstructorsFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function fetchInstructors(){return{type:FETCH_INSTRUCTORS};}function fetchInstructorsSuccess(payload){return{type:FETCH_INSTRUCTORS_SUCCESS,payload:payload};}function fetchInstructorsFailure(payload){return{type:FETCH_INSTRUCTORS_FAILURE,payload:payload};}function saveInstructors(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'POST',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].instructors,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(saveInstructorsSuccess(res.data));}).catch(function(error){dispatch(saveInstructorsFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function saveInstructorsSuccess(payload){return{type:SAVE_INSTRUCTORS_SUCCESS,payload:payload};}function saveInstructorsFailure(payload){return{type:SAVE_INSTRUCTORS_FAILURE,payload:payload};}function deleteInstructors(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'DELETE',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].instructors,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(deleteInstructorsSuccess(res.data.data));}).catch(function(error){dispatch(deleteInstructorsFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function deleteInstructorsSuccess(payload){return{type:DELETE_INSTRUCTORS_SUCCESS,payload:payload};}function deleteInstructorsFailure(payload){return{type:DELETE_INSTRUCTORS_FAILURE,payload:payload};}function loadingAjaxCall(){return{type:INSTRUCTORS_AJAX_CALL};}function clearAjaxCall(payload){return{type:INSTRUCTORS_CLEAR_AJAX_CALL};}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_RECEIPTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_RECEIPTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_RECEIPTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SAVE_RECEIPTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_RECEIPTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RECEIPTS_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RECEIPTS_CLEAR_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_RECEIPTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_RECEIPTS_FAILURE; });
/* harmony export (immutable) */ __webpack_exports__["l"] = loadReceipts;
/* harmony export (immutable) */ __webpack_exports__["m"] = saveReceipts;
/* harmony export (immutable) */ __webpack_exports__["n"] = saveReceiptsFailure;
/* harmony export (immutable) */ __webpack_exports__["k"] = deleteReceipts;
/* unused harmony export deleteReceiptsFailure */
/* harmony export (immutable) */ __webpack_exports__["j"] = clearAjaxCall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(11);
var FETCH_RECEIPTS='FETCH_RECEIPTS';var FETCH_RECEIPTS_SUCCESS='FETCH_RECEIPTS_SUCCESS';var FETCH_RECEIPTS_FAILURE='FETCH_RECEIPTS_FAILURE';var SAVE_RECEIPTS_SUCCESS='SAVE_RECEIPTS_SUCCESS';var SAVE_RECEIPTS_FAILURE='SAVE_RECEIPTS_FAILURE';var RECEIPTS_AJAX_CALL='RECEIPTS_AJAX_CALL';var RECEIPTS_CLEAR_AJAX_CALL='RECEIPTS_CLEAR_AJAX_CALL';var DELETE_RECEIPTS_SUCCESS='DELETE_RECEIPTS_SUCCESS';var DELETE_RECEIPTS_FAILURE='DELETE_RECEIPTS_FAILURE';function loadReceipts(){return function(dispatch){dispatch(fetchReceipts());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'GET',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].receipts,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])()}).then(function(res){dispatch(fetchReceiptsSuccess(res.data));}).catch(function(error){dispatch(fetchReceiptsFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function fetchReceipts(){return{type:FETCH_RECEIPTS};}function fetchReceiptsSuccess(payload){return{type:FETCH_RECEIPTS_SUCCESS,payload:payload};}function fetchReceiptsFailure(payload){return{type:FETCH_RECEIPTS_FAILURE,payload:payload};}function saveReceipts(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'POST',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].receipts,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(saveReceiptsSuccess(res.data));}).catch(function(error){dispatch(saveReceiptsFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function saveReceiptsSuccess(payload){return{type:SAVE_RECEIPTS_SUCCESS,payload:payload};}function saveReceiptsFailure(payload){return{type:SAVE_RECEIPTS_FAILURE,payload:payload};}function deleteReceipts(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'DELETE',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].receipts,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(deleteReceiptsSuccess(res.data));}).catch(function(error){dispatch(deleteReceiptsFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function deleteReceiptsSuccess(payload){return{type:DELETE_RECEIPTS_SUCCESS,payload:payload};}function deleteReceiptsFailure(payload){return{type:DELETE_RECEIPTS_FAILURE,payload:payload};}function loadingAjaxCall(){return{type:RECEIPTS_AJAX_CALL};}function clearAjaxCall(payload){return{type:RECEIPTS_CLEAR_AJAX_CALL};}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_BALANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_BALANCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_BALANCE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_BALANCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_BALANCE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BALANCE_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BALANCE_CLEAR_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_BALANCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_BALANCE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BALANCE_START_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BALANCE_STOP_UPLOAD; });
/* harmony export (immutable) */ __webpack_exports__["n"] = loadBalance;
/* harmony export (immutable) */ __webpack_exports__["o"] = saveBalance;
/* harmony export (immutable) */ __webpack_exports__["p"] = saveBalanceFailure;
/* harmony export (immutable) */ __webpack_exports__["m"] = deleteBalance;
/* unused harmony export deleteBalanceFailure */
/* harmony export (immutable) */ __webpack_exports__["l"] = clearAjaxCall;
/* harmony export (immutable) */ __webpack_exports__["q"] = startUpload;
/* harmony export (immutable) */ __webpack_exports__["r"] = stopUpload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(11);
var FETCH_BALANCE='FETCH_BALANCE';var FETCH_BALANCE_SUCCESS='FETCH_BALANCE_SUCCESS';var FETCH_BALANCE_FAILURE='FETCH_BALANCE_FAILURE';var SAVE_BALANCE_SUCCESS='SAVE_BALANCE_SUCCESS';var SAVE_BALANCE_FAILURE='SAVE_BALANCE_FAILURE';var BALANCE_AJAX_CALL='BALANCE_AJAX_CALL';var BALANCE_CLEAR_AJAX_CALL='BALANCE_CLEAR_AJAX_CALL';var DELETE_BALANCE_SUCCESS='DELETE_BALANCE_SUCCESS';var DELETE_BALANCE_FAILURE='DELETE_BALANCE_FAILURE';var BALANCE_START_UPLOAD='BALANCE_START_UPLOAD';var BALANCE_STOP_UPLOAD='BALANCE_STOP_UPLOAD';function loadBalance(){return function(dispatch){dispatch(fetchBalance());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'GET',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].balance,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])()}).then(function(res){dispatch(fetchBalanceSuccess(res.data));}).catch(function(error){dispatch(fetchBalanceFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function fetchBalance(){return{type:FETCH_BALANCE};}function fetchBalanceSuccess(payload){return{type:FETCH_BALANCE_SUCCESS,payload:payload};}function fetchBalanceFailure(payload){return{type:FETCH_BALANCE_FAILURE,payload:payload};}function saveBalance(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'POST',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].balance,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(saveBalanceSuccess(res.data));}).catch(function(error){dispatch(saveBalanceFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function saveBalanceSuccess(payload){return{type:SAVE_BALANCE_SUCCESS,payload:payload};}function saveBalanceFailure(payload){return{type:SAVE_BALANCE_FAILURE,payload:payload};}function deleteBalance(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'DELETE',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].balance,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(deleteBalanceSuccess(res.data.data));}).catch(function(error){dispatch(deleteBalanceFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function deleteBalanceSuccess(payload){return{type:DELETE_BALANCE_SUCCESS,payload:payload};}function deleteBalanceFailure(payload){return{type:DELETE_BALANCE_FAILURE,payload:payload};}function loadingAjaxCall(){return{type:BALANCE_AJAX_CALL};}function clearAjaxCall(payload){return{type:BALANCE_CLEAR_AJAX_CALL};}function startUpload(){return{type:BALANCE_START_UPLOAD};}function stopUpload(){return{type:BALANCE_STOP_UPLOAD};}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);

function filterByPosition(array, position) {
	return helpers.where(array, function(v) {
		return v.position === position;
	});
}

function sortByWeight(array, reverse) {
	array.forEach(function(v, i) {
		v._tmpIndex_ = i;
		return v;
	});
	array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0._tmpIndex_ - v1._tmpIndex_ :
			v0.weight - v1.weight;
	});
	array.forEach(function(v) {
		delete v._tmpIndex_;
	});
}

/**
 * @interface ILayoutItem
 * @prop {String} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
 * @prop {Function} getPadding -  Returns an object with padding on the edges
 * @prop {Number} width - Width of item. Must be valid after update()
 * @prop {Number} height - Height of item. Must be valid after update()
 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
module.exports = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {Object} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {Object} item - the item to configure with the given options
	 * @param {Object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {Number} width - the width to fit into
	 * @param {Number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers.options.toPadding(layoutOptions.padding);
		var leftPadding = padding.left;
		var rightPadding = padding.right;
		var topPadding = padding.top;
		var bottomPadding = padding.bottom;

		var leftBoxes = filterByPosition(chart.boxes, 'left');
		var rightBoxes = filterByPosition(chart.boxes, 'right');
		var topBoxes = filterByPosition(chart.boxes, 'top');
		var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
		var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');

		// Sort boxes by weight. A higher weight is further away from the chart area
		sortByWeight(leftBoxes, true);
		sortByWeight(rightBoxes, false);
		sortByWeight(topBoxes, true);
		sortByWeight(bottomBoxes, false);

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//
		// What we do to find the best sizing, we do the following
		// 1. Determine the minimum size of the chart area.
		// 2. Split the remaining width equally between each vertical axis
		// 3. Split the remaining height equally between each horizontal axis
		// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
		// 5. Adjust the sizes of each axis based on it's minimum reported size.
		// 6. Refit each axis
		// 7. Position each axis in the final location
		// 8. Tell the chart the final location of the chart area
		// 9. Tell any axes that overlay the chart area the positions of the chart area

		// Step 1
		var chartWidth = width - leftPadding - rightPadding;
		var chartHeight = height - topPadding - bottomPadding;
		var chartAreaWidth = chartWidth / 2; // min 50%
		var chartAreaHeight = chartHeight / 2; // min 50%

		// Step 2
		var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);

		// Step 3
		var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);

		// Step 4
		var maxChartAreaWidth = chartWidth;
		var maxChartAreaHeight = chartHeight;
		var minBoxSizes = [];

		function getMinimumBoxSize(box) {
			var minSize;
			var isHorizontal = box.isHorizontal();

			if (isHorizontal) {
				minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
				maxChartAreaHeight -= minSize.height;
			} else {
				minSize = box.update(verticalBoxWidth, maxChartAreaHeight);
				maxChartAreaWidth -= minSize.width;
			}

			minBoxSizes.push({
				horizontal: isHorizontal,
				minSize: minSize,
				box: box,
			});
		}

		helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);

		// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
		var maxHorizontalLeftPadding = 0;
		var maxHorizontalRightPadding = 0;
		var maxVerticalTopPadding = 0;
		var maxVerticalBottomPadding = 0;

		helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
			if (horizontalBox.getPadding) {
				var boxPadding = horizontalBox.getPadding();
				maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
				maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
			}
		});

		helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
			if (verticalBox.getPadding) {
				var boxPadding = verticalBox.getPadding();
				maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
				maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
			}
		});

		// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
		// be if the axes are drawn at their minimum sizes.
		// Steps 5 & 6
		var totalLeftBoxesWidth = leftPadding;
		var totalRightBoxesWidth = rightPadding;
		var totalTopBoxesHeight = topPadding;
		var totalBottomBoxesHeight = bottomPadding;

		// Function to fit a box
		function fitBox(box) {
			var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
				return minBox.box === box;
			});

			if (minBoxSize) {
				if (box.isHorizontal()) {
					var scaleMargin = {
						left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
						right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
						top: 0,
						bottom: 0
					};

					// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
					// on the margin. Sometimes they need to increase in size slightly
					box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
				} else {
					box.update(minBoxSize.minSize.width, maxChartAreaHeight);
				}
			}
		}

		// Update, and calculate the left and right margins for the horizontal boxes
		helpers.each(leftBoxes.concat(rightBoxes), fitBox);

		helpers.each(leftBoxes, function(box) {
			totalLeftBoxesWidth += box.width;
		});

		helpers.each(rightBoxes, function(box) {
			totalRightBoxesWidth += box.width;
		});

		// Set the Left and Right margins for the horizontal boxes
		helpers.each(topBoxes.concat(bottomBoxes), fitBox);

		// Figure out how much margin is on the top and bottom of the vertical boxes
		helpers.each(topBoxes, function(box) {
			totalTopBoxesHeight += box.height;
		});

		helpers.each(bottomBoxes, function(box) {
			totalBottomBoxesHeight += box.height;
		});

		function finalFitVerticalBox(box) {
			var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
				return minSize.box === box;
			});

			var scaleMargin = {
				left: 0,
				right: 0,
				top: totalTopBoxesHeight,
				bottom: totalBottomBoxesHeight
			};

			if (minBoxSize) {
				box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
			}
		}

		// Let the left layout know the final margin
		helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);

		// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
		totalLeftBoxesWidth = leftPadding;
		totalRightBoxesWidth = rightPadding;
		totalTopBoxesHeight = topPadding;
		totalBottomBoxesHeight = bottomPadding;

		helpers.each(leftBoxes, function(box) {
			totalLeftBoxesWidth += box.width;
		});

		helpers.each(rightBoxes, function(box) {
			totalRightBoxesWidth += box.width;
		});

		helpers.each(topBoxes, function(box) {
			totalTopBoxesHeight += box.height;
		});
		helpers.each(bottomBoxes, function(box) {
			totalBottomBoxesHeight += box.height;
		});

		// We may be adding some padding to account for rotated x axis labels
		var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
		totalLeftBoxesWidth += leftPaddingAddition;
		totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);

		var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
		totalTopBoxesHeight += topPaddingAddition;
		totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);

		// Figure out if our chart area changed. This would occur if the dataset layout label rotation
		// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
		// without calling `fit` again
		var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
		var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;

		if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
			helpers.each(leftBoxes, function(box) {
				box.height = newMaxChartAreaHeight;
			});

			helpers.each(rightBoxes, function(box) {
				box.height = newMaxChartAreaHeight;
			});

			helpers.each(topBoxes, function(box) {
				if (!box.fullWidth) {
					box.width = newMaxChartAreaWidth;
				}
			});

			helpers.each(bottomBoxes, function(box) {
				if (!box.fullWidth) {
					box.width = newMaxChartAreaWidth;
				}
			});

			maxChartAreaHeight = newMaxChartAreaHeight;
			maxChartAreaWidth = newMaxChartAreaWidth;
		}

		// Step 7 - Position the boxes
		var left = leftPadding + leftPaddingAddition;
		var top = topPadding + topPaddingAddition;

		function placeBox(box) {
			if (box.isHorizontal()) {
				box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
				box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
				box.top = top;
				box.bottom = top + box.height;

				// Move to next point
				top = box.bottom;

			} else {

				box.left = left;
				box.right = left + box.width;
				box.top = totalTopBoxesHeight;
				box.bottom = totalTopBoxesHeight + maxChartAreaHeight;

				// Move to next point
				left = box.right;
			}
		}

		helpers.each(leftBoxes.concat(topBoxes), placeBox);

		// Account for chart width and height
		left += maxChartAreaWidth;
		top += maxChartAreaHeight;

		helpers.each(rightBoxes, placeBox);
		helpers.each(bottomBoxes, placeBox);

		// Step 8
		chart.chartArea = {
			left: totalLeftBoxesWidth,
			top: totalTopBoxesHeight,
			right: totalLeftBoxesWidth + maxChartAreaWidth,
			bottom: totalTopBoxesHeight + maxChartAreaHeight
		};

		// Step 9
		helpers.each(chartAreaBoxes, function(box) {
			box.left = chart.chartArea.left;
			box.top = chart.chartArea.top;
			box.right = chart.chartArea.right;
			box.bottom = chart.chartArea.bottom;

			box.update(maxChartAreaWidth, maxChartAreaHeight);
		});
	}
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
module.exports = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {String|Array} the label to display
		 */
		values: function(value) {
			return helpers.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {Number} the value to be formatted
		 * @param index {Number} the position of the tickValue parameter in the ticks array
		 * @param ticks {Array<Number>} the list of ticks being converted
		 * @return {String} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var numDecimal = -1 * Math.floor(logDelta);
				numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
				tickString = tickValue.toFixed(numDecimal);
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(44),
    getRawTag = __webpack_require__(310),
    objectToString = __webpack_require__(311);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(139);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(140);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(142);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(144);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(75);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(53);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(148);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(150);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(152);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(153);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(154);
/* unused harmony reexport withRouter */





























/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(26);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(156);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;

  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.REPLACE });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';

  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = createStore.apply(undefined, args);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */
function isCrushed() {}

if (false) {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DO_LOGIN; });
/* unused harmony export DO_LOGIN_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DO_LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DO_LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DO_LOGOUT; });
/* harmony export (immutable) */ __webpack_exports__["e"] = callLogin;
/* harmony export (immutable) */ __webpack_exports__["g"] = doLoginSuccess;
/* harmony export (immutable) */ __webpack_exports__["f"] = callLogout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(11);
var DO_LOGIN='DO_LOGIN';var DO_LOGIN_LOADING='DO_LOGIN_LOADING';var DO_LOGIN_SUCCESS='DO_LOGIN_SUCCESS';var DO_LOGIN_FAILURE='DO_LOGIN_FAILURE';var DO_LOGOUT='DO_LOGOUT';function callLogin(payload){return function(dispatch){dispatch(doLogin());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'POST',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].login,headers:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].axiosHeaders,data:payload}).then(function(res){dispatch(doLoginSuccess(res.data));}).catch(function(error){dispatch(doLoginFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function doLogin(){return{type:DO_LOGIN};}function doLoginSuccess(payload){return{type:DO_LOGIN_SUCCESS,payload:payload};}function doLoginFailure(payload){return{type:DO_LOGIN_FAILURE,payload:payload};}function callLogout(){return{type:DO_LOGOUT};}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_NOTES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_NOTES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SAVE_NOTES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_NOTES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NOTES_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NOTES_CLEAR_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_NOTES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_NOTES_FAILURE; });
/* harmony export (immutable) */ __webpack_exports__["l"] = loadNotes;
/* harmony export (immutable) */ __webpack_exports__["m"] = saveNotes;
/* harmony export (immutable) */ __webpack_exports__["n"] = saveNotesFailure;
/* harmony export (immutable) */ __webpack_exports__["k"] = deleteNotes;
/* unused harmony export deleteNotesFailure */
/* harmony export (immutable) */ __webpack_exports__["j"] = clearAjaxCall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(11);
var FETCH_NOTES='FETCH_NOTES';var FETCH_NOTES_SUCCESS='FETCH_NOTES_SUCCESS';var FETCH_NOTES_FAILURE='FETCH_NOTES_FAILURE';var SAVE_NOTES_SUCCESS='SAVE_NOTES_SUCCESS';var SAVE_NOTES_FAILURE='SAVE_NOTES_FAILURE';var NOTES_AJAX_CALL='NOTES_AJAX_CALL';var NOTES_CLEAR_AJAX_CALL='NOTES_CLEAR_AJAX_CALL';var DELETE_NOTES_SUCCESS='DELETE_NOTES_SUCCESS';var DELETE_NOTES_FAILURE='DELETE_NOTES_FAILURE';function loadNotes(){return function(dispatch){dispatch(fetchNotes());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'GET',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].notes,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])()}).then(function(res){dispatch(fetchNotesSuccess(res.data));}).catch(function(error){dispatch(fetchNotesFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function fetchNotes(){return{type:FETCH_NOTES};}function fetchNotesSuccess(payload){return{type:FETCH_NOTES_SUCCESS,payload:payload};}function fetchNotesFailure(payload){return{type:FETCH_NOTES_FAILURE,payload:payload};}function saveNotes(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'POST',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].notes,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(saveNotesSuccess(res.data));}).catch(function(error){dispatch(saveNotesFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function saveNotesSuccess(payload){return{type:SAVE_NOTES_SUCCESS,payload:payload};}function saveNotesFailure(payload){return{type:SAVE_NOTES_FAILURE,payload:payload};}function deleteNotes(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'DELETE',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].notes,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(deleteNotesSuccess(res.data.data));}).catch(function(error){dispatch(deleteNotesFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function deleteNotesSuccess(payload){return{type:DELETE_NOTES_SUCCESS,payload:payload};}function deleteNotesFailure(payload){return{type:DELETE_NOTES_FAILURE,payload:payload};}function loadingAjaxCall(){return{type:NOTES_AJAX_CALL};}function clearAjaxCall(payload){return{type:NOTES_CLEAR_AJAX_CALL};}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {Number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @function
	 */
	isArray: Array.isArray ? Array.isArray : function(value) {
		return Object.prototype.toString.call(value) === '[object Array]';
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {Number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {Function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {Object|Array} loopable - The object or array to be iterated.
	 * @param {Function} fn - The function to call for each item.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {Boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see http://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {Boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = {};
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): this method is also used by configMerge and scaleMerge as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @param {Object} [options] - Merging options:
	 * @param {Function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {Object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @returns {Object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {Object} target - The target object in which all objects are merged into.
	 * @param {Object} arg1 - Object containing additional properties to merge in target.
	 * @param {Object} argN - Additional objects containing properties to merge in target.
	 * @returns {Object} The `target` object.
	 */
	extend: function(target) {
		var setFn = function(value, key) {
			target[key] = value;
		};
		for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
			helpers.each(arguments[i], setFn);
		}
		return target;
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	}
};

module.exports = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(299),
    listCacheDelete = __webpack_require__(300),
    listCacheGet = __webpack_require__(301),
    listCacheHas = __webpack_require__(302),
    listCacheSet = __webpack_require__(303);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(99);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(17);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(323);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(343),
    baseKeys = __webpack_require__(350),
    isArrayLike = __webpack_require__(66);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(32),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(49);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(54);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(9);
var normalizeHeaderName = __webpack_require__(186);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(87);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(87);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(86)))

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_CLUB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_CLUB_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_CLUB_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_CLUB_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_CLUB_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLUB_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLUB_CLEAR_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPLOAD_SIGNATURE_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPLOAD_SIGNATURE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPLOAD_SIGNATURE_FAILURE; });
/* harmony export (immutable) */ __webpack_exports__["l"] = loadClub;
/* harmony export (immutable) */ __webpack_exports__["m"] = saveClub;
/* harmony export (immutable) */ __webpack_exports__["k"] = clearAjaxCall;
/* harmony export (immutable) */ __webpack_exports__["o"] = uploadSignatureStarted;
/* harmony export (immutable) */ __webpack_exports__["n"] = uploadSignature;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(11);
var FETCH_CLUB='FETCH_CLUB';var FETCH_CLUB_SUCCESS='FETCH_CLUB_SUCCESS';var FETCH_CLUB_FAILURE='FETCH_CLUB_FAILURE';var SAVE_CLUB_SUCCESS='SAVE_CLUB_SUCCESS';var SAVE_CLUB_FAILURE='SAVE_CLUB_FAILURE';var CLUB_AJAX_CALL='CLUB_AJAX_CALL';var CLUB_CLEAR_AJAX_CALL='CLUB_CLEAR_AJAX_CALL';var UPLOAD_SIGNATURE_STARTED='UPLOAD_SIGNATURE_STARTED';var UPLOAD_SIGNATURE_SUCCESS='UPLOAD_SIGNATURE_SUCCESS';var UPLOAD_SIGNATURE_FAILURE='UPLOAD_SIGNATURE_FAILURE';function loadClub(){return function(dispatch){dispatch(fetchClub());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'GET',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].club,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])()}).then(function(res){dispatch(fetchClubSuccess(res.data));}).catch(function(error){dispatch(fetchClubFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function fetchClub(){return{type:FETCH_CLUB};}function fetchClubSuccess(payload){return{type:FETCH_CLUB_SUCCESS,payload:payload};}function fetchClubFailure(payload){return{type:FETCH_CLUB_FAILURE,payload:payload};}function saveClub(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'POST',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].club,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(saveClubSuccess(res.data));}).catch(function(error){dispatch(saveClubFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function saveClubSuccess(payload){return{type:SAVE_CLUB_SUCCESS,payload:payload};}function saveClubFailure(payload){return{type:SAVE_CLUB_FAILURE,payload:payload};}function loadingAjaxCall(){return{type:CLUB_AJAX_CALL};}function clearAjaxCall(payload){return{type:CLUB_CLEAR_AJAX_CALL};}function uploadSignatureStarted(){return{type:UPLOAD_SIGNATURE_STARTED};}function uploadSignature(payload){return function(dispatch){__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'PUT',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].club,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(uploadSignatureSuccess(res.data));}).catch(function(){dispatch(uploadSignatureFailure());});};}function uploadSignatureSuccess(payload){return{type:UPLOAD_SIGNATURE_SUCCESS,payload:payload};}function uploadSignatureFailure(){return{type:UPLOAD_SIGNATURE_FAILURE};}

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ATTENDANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_ATTENDANCES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_ATTENDANCES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_ATTENDANCES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_ATTENDANCES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTENDANCES_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ATTENDANCES_CLEAR_AJAX_CALL; });
/* harmony export (immutable) */ __webpack_exports__["h"] = loadAttendances;
/* harmony export (immutable) */ __webpack_exports__["i"] = saveAttendances;
/* unused harmony export saveAttendancesFailure */
/* unused harmony export clearAjaxCall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(11);
var FETCH_ATTENDANCES='FETCH_ATTENDANCES';var FETCH_ATTENDANCES_SUCCESS='FETCH_ATTENDANCES_SUCCESS';var FETCH_ATTENDANCES_FAILURE='FETCH_ATTENDANCES_FAILURE';var SAVE_ATTENDANCES_SUCCESS='SAVE_ATTENDANCES_SUCCESS';var SAVE_ATTENDANCES_FAILURE='SAVE_ATTENDANCES_FAILURE';var ATTENDANCES_AJAX_CALL='ATTENDANCES_AJAX_CALL';var ATTENDANCES_CLEAR_AJAX_CALL='ATTENDANCES_CLEAR_AJAX_CALL';function loadAttendances(u){return function(dispatch){dispatch(fetchAttendances());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'GET',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].attendances+'?u='+u,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])()}).then(function(res){dispatch(fetchAttendancesSuccess(res.data));}).catch(function(error){dispatch(fetchAttendancesFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function fetchAttendances(){return{type:FETCH_ATTENDANCES};}function fetchAttendancesSuccess(payload){return{type:FETCH_ATTENDANCES_SUCCESS,payload:payload};}function fetchAttendancesFailure(payload){return{type:FETCH_ATTENDANCES_FAILURE,payload:payload};}function saveAttendances(payload){return function(dispatch){dispatch(loadingAjaxCall());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'POST',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].attendances,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])(),data:payload}).then(function(res){dispatch(saveAttendancesSuccess(res.data));}).catch(function(error){dispatch(saveAttendancesFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function saveAttendancesSuccess(payload){return{type:SAVE_ATTENDANCES_SUCCESS,payload:payload};}function saveAttendancesFailure(payload){return{type:SAVE_ATTENDANCES_FAILURE,payload:payload};}function loadingAjaxCall(){return{type:ATTENDANCES_AJAX_CALL};}function clearAjaxCall(payload){return{type:ATTENDANCES_CLEAR_AJAX_CALL};}

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENV; });
var ENV={production:!(window.location.hostname==='localhost')};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(298),
    isObjectLike = __webpack_require__(33);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(315),
    mapCacheDelete = __webpack_require__(322),
    mapCacheGet = __webpack_require__(324),
    mapCacheHas = __webpack_require__(325),
    mapCacheSet = __webpack_require__(326);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(100),
    isLength = __webpack_require__(65);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(361),
    baseMatchesProperty = __webpack_require__(364),
    identity = __webpack_require__(375),
    isArray = __webpack_require__(18),
    property = __webpack_require__(376);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(18),
    isSymbol = __webpack_require__(49);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(115);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(76);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(55);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(143)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(80);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(83);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(56);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(167);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var settle = __webpack_require__(187);
var buildURL = __webpack_require__(189);
var parseHeaders = __webpack_require__(190);
var isURLSameOrigin = __webpack_require__(191);
var createError = __webpack_require__(88);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(192);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(193);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(188);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_FISCALYEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_FISCALYEAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_FISCALYEAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_FISCALYEAR; });
/* harmony export (immutable) */ __webpack_exports__["f"] = loadFiscalyear;
/* harmony export (immutable) */ __webpack_exports__["e"] = changeFiscalyear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(11);
var FETCH_FISCALYEAR='FETCH_FISCALYEAR';var FETCH_FISCALYEAR_SUCCESS='FETCH_FISCALYEAR_SUCCESS';var FETCH_FISCALYEAR_FAILURE='FETCH_FISCALYEAR_FAILURE';var CHANGE_FISCALYEAR='CHANGE_FISCALYEAR';function loadFiscalyear(){return function(dispatch){dispatch(fetchFiscalyear());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'GET',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].fiscalyear,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])()}).then(function(res){dispatch(fetchFiscalyearSuccess(res.data));}).catch(function(error){dispatch(fetchFiscalyearFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function fetchFiscalyear(){return{type:FETCH_FISCALYEAR};}function fetchFiscalyearSuccess(payload){return{type:FETCH_FISCALYEAR_SUCCESS,payload:payload};}function fetchFiscalyearFailure(payload){return{type:FETCH_FISCALYEAR_FAILURE,payload:payload};}function changeFiscalyear(payload){return{type:CHANGE_FISCALYEAR,payload:payload};}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_DASHBOARD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_DASHBOARD_FAILURE; });
/* harmony export (immutable) */ __webpack_exports__["d"] = loadDashboard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(11);
var FETCH_DASHBOARD='FETCH_DASHBOARD';var FETCH_DASHBOARD_SUCCESS='FETCH_DASHBOARD_SUCCESS';var FETCH_DASHBOARD_FAILURE='FETCH_DASHBOARD_FAILURE';function loadDashboard(u){return function(dispatch){dispatch(fetchDashboard());__WEBPACK_IMPORTED_MODULE_0_axios___default()({method:'GET',url:__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].dashboard,headers:Object(__WEBPACK_IMPORTED_MODULE_1__Uris__["b" /* loadHeaders */])()}).then(function(res){dispatch(fetchDashboardSuccess(res.data));}).catch(function(error){dispatch(fetchDashboardFailure(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* errorMessage */])(error)));});};}function fetchDashboard(){return{type:FETCH_DASHBOARD};}function fetchDashboardSuccess(payload){return{type:FETCH_DASHBOARD_SUCCESS,payload:payload};}function fetchDashboardFailure(payload){return{type:FETCH_DASHBOARD_FAILURE,payload:payload};}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = {"countries":[{"value":"AG","label":"Agrigento"},{"value":"AL","label":"Alessandria"},{"value":"AN","label":"Ancona"},{"value":"AO","label":"Aosta"},{"value":"AR","label":"Arezzo"},{"value":"AP","label":"Ascoli Piceno"},{"value":"AT","label":"Asti"},{"value":"AV","label":"Avellino"},{"value":"BA","label":"Bari"},{"value":"BT","label":"Barletta-Andria-Trani"},{"value":"BL","label":"Belluno"},{"value":"BN","label":"Benevento"},{"value":"BG","label":"Bergamo"},{"value":"BI","label":"Biella"},{"value":"BO","label":"Bologna"},{"value":"BZ","label":"Bolzano"},{"value":"BS","label":"Brescia"},{"value":"BR","label":"Brindisi"},{"value":"CA","label":"Cagliari"},{"value":"CL","label":"Caltanissetta"},{"value":"CB","label":"Campobasso"},{"value":"CI","label":"Carbonia-Iglesias"},{"value":"CE","label":"Caserta"},{"value":"CT","label":"Catania"},{"value":"CZ","label":"Catanzaro"},{"value":"CH","label":"Chieti"},{"value":"CO","label":"Como"},{"value":"CS","label":"Cosenza"},{"value":"CR","label":"Cremona"},{"value":"KR","label":"Crotone"},{"value":"CN","label":"Cuneo"},{"value":"EN","label":"Enna"},{"value":"FM","label":"Fermo"},{"value":"FE","label":"Ferrara"},{"value":"FI","label":"Firenze"},{"value":"FG","label":"Foggia"},{"value":"FC","label":"Forlì-Cesena"},{"value":"FR","label":"Frosinone"},{"value":"GE","label":"Genova"},{"value":"GO","label":"Gorizia"},{"value":"GR","label":"Grosseto"},{"value":"IM","label":"Imperia"},{"value":"IS","label":"Isernia"},{"value":"SP","label":"La Spezia"},{"value":"AQ","label":"L'Aquila"},{"value":"LT","label":"Latina"},{"value":"LE","label":"Lecce"},{"value":"LC","label":"Lecco"},{"value":"LI","label":"Livorno"},{"value":"LO","label":"Lodi"},{"value":"LU","label":"Lucca"},{"value":"MC","label":"Macerata"},{"value":"MN","label":"Mantova"},{"value":"MS","label":"Massa-Carrara"},{"value":"MT","label":"Matera"},{"value":"ME","label":"Messina"},{"value":"MI","label":"Milano"},{"value":"MO","label":"Modena"},{"value":"MB","label":"Monza e della Brianza"},{"value":"NA","label":"Napoli"},{"value":"NO","label":"Novara"},{"value":"NU","label":"Nuoro"},{"value":"OT","label":"Olbia-Tempio"},{"value":"OR","label":"Oristano"},{"value":"PD","label":"Padova"},{"value":"PA","label":"Palermo"},{"value":"PR","label":"Parma"},{"value":"PV","label":"Pavia"},{"value":"PG","label":"Perugia"},{"value":"PU","label":"Pesaro e Urbino"},{"value":"PE","label":"Pescara"},{"value":"PC","label":"Piacenza"},{"value":"PI","label":"Pisa"},{"value":"PT","label":"Pistoia"},{"value":"PN","label":"Pordenone"},{"value":"PZ","label":"Potenza"},{"value":"PO","label":"Prato"},{"value":"RG","label":"Ragusa"},{"value":"RA","label":"Ravenna"},{"value":"RC","label":"Reggio Calabria"},{"value":"RE","label":"Reggio Emilia"},{"value":"RI","label":"Rieti"},{"value":"RN","label":"Rimini"},{"value":"RM","label":"Roma"},{"value":"RO","label":"Rovigo"},{"value":"SA","label":"Salerno"},{"value":"VS","label":"Medio Campidano"},{"value":"SS","label":"Sassari"},{"value":"SV","label":"Savona"},{"value":"SI","label":"Siena"},{"value":"SR","label":"Siracusa"},{"value":"SO","label":"Sondrio"},{"value":"TA","label":"Taranto"},{"value":"TE","label":"Teramo"},{"value":"TR","label":"Terni"},{"value":"TO","label":"Torino"},{"value":"OG","label":"Ogliastra"},{"value":"TP","label":"Trapani"},{"value":"TN","label":"Trento"},{"value":"TV","label":"Treviso"},{"value":"TS","label":"Trieste"},{"value":"UD","label":"Udine"},{"value":"VA","label":"Varese"},{"value":"VE","label":"Venezia"},{"value":"VB","label":"Verbano-Cusio-Ossola"},{"value":"VC","label":"Vercelli"},{"value":"VR","label":"Verona"},{"value":"VV","label":"Vibo Valentia"},{"value":"VI","label":"Vicenza"},{"value":"VT","label":"Viterbo"},{"value":"EE","label":"Estero"}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var convert = __webpack_require__(257);
var string = __webpack_require__(259);

var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = string.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = string.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = string.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return string.hexString(this.values.rgb);
	},
	rgbString: function () {
		return string.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return string.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return string.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return string.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return string.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return string.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return string.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = convert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

module.exports = Color;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {Point} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param chart {chart} the chart
 * @param handler {Function} the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var datasets = chart.data.datasets;
	var meta, i, j, ilen, jlen;

	for (i = 0, ilen = datasets.length; i < ilen; ++i) {
		if (!chart.isDatasetVisible(i)) {
			continue;
		}

		meta = chart.getDatasetMeta(i);
		for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
			var element = meta.data[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param items {ChartElement[]} elements to filter
 * @param position {Point} the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param chart {Chart} the chart to look at elements from
 * @param position {Point} the point to be nearest to
 * @param intersect {Boolean} if true, only consider items that intersect the position
 * @param distanceMetric {Function} function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);

		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {String} axis the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart.data.datasets.forEach(function(dataset, datasetIndex) {
		if (chart.isDatasetVisible(datasetIndex)) {
			var meta = chart.getDatasetMeta(datasetIndex);
			var element = meta.data[items[0]._index];

			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
module.exports = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var nearestItems = getNearestItems(chart, position, options.intersect, distanceMetric);

			// We have multiple items at the same distance from the event. Now sort by smallest
			if (nearestItems.length > 1) {
				nearestItems.sort(function(a, b) {
					var sizeA = a.getArea();
					var sizeB = b.getArea();
					var ret = sizeA - sizeB;

					if (ret === 0) {
						// if equal sort by dataset index
						ret = a._datasetIndex - b._datasetIndex;
					}

					return ret;
				});
			}

			// Return only 1 item
			return nearestItems.slice(0, 1);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);
var basic = __webpack_require__(265);
var dom = __webpack_require__(266);

// @TODO Make possible to select another platform at build time.
var implementation = dom._enabled ? dom : basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
module.exports = helpers.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {Object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {Boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {String} type - The ({@link IEvent}) type to listen for
	 * @param {Function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart -Chart from which to remove the listener
	 * @param {String} type - The ({@link IEvent}) type to remove
	 * @param {Function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

/**
 * @interface IPlatform
 * Allows abstracting platform dependencies away from the chart
 * @borrows Chart.platform.acquireContext as acquireContext
 * @borrows Chart.platform.releaseContext as releaseContext
 * @borrows Chart.platform.addEventListener as addEventListener
 * @borrows Chart.platform.removeEventListener as removeEventListener
 */

/**
 * @interface IEvent
 * @prop {String} type - The event type name, possible values are:
 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
 */


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var helpers = __webpack_require__(1);

defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
module.exports = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {Array|Object} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {Array|Object} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {Number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {Array} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Object} chart - The chart instance for which plugins should be called.
	 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {Boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {Array} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers.clone(defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

/**
 * Plugin extension hooks.
 * @interface IPlugin
 * @since 2.1.0
 */
/**
 * @method IPlugin#beforeInit
 * @desc Called before initializing `chart`.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#afterInit
 * @desc Called after `chart` has been initialized and before the first update.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeUpdate
 * @desc Called before updating `chart`. If any plugin returns `false`, the update
 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart update.
 */
/**
 * @method IPlugin#afterUpdate
 * @desc Called after `chart` has been updated and before rendering. Note that this
 * hook will not be called if the chart update has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDatasetsUpdate
 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
 * the datasets update is cancelled until another `update` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} false to cancel the datasets update.
 * @since version 2.1.5
*/
/**
 * @method IPlugin#afterDatasetsUpdate
 * @desc Called after the `chart` datasets have been updated. Note that this hook
 * will not be called if the datasets update has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @since version 2.1.5
 */
/**
 * @method IPlugin#beforeDatasetUpdate
 * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
 * returns `false`, the datasets update is cancelled until another `update` is triggered.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart datasets drawing.
 */
/**
 * @method IPlugin#afterDatasetUpdate
 * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
 * that this hook will not be called if the datasets update has been previously cancelled.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeLayout
 * @desc Called before laying out `chart`. If any plugin returns `false`,
 * the layout update is cancelled until another `update` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart layout.
 */
/**
 * @method IPlugin#afterLayout
 * @desc Called after the `chart` has been layed out. Note that this hook will not
 * be called if the layout update has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeRender
 * @desc Called before rendering `chart`. If any plugin returns `false`,
 * the rendering is cancelled until another `render` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart rendering.
 */
/**
 * @method IPlugin#afterRender
 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
 * that this hook will not be called if the rendering has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDraw
 * @desc Called before drawing `chart` at every animation frame specified by the given
 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
 * another `render` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart drawing.
 */
/**
 * @method IPlugin#afterDraw
 * @desc Called after the `chart` has been drawn for the specific easing value. Note
 * that this hook will not be called if the drawing has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDatasetsDraw
 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
 * the datasets drawing is cancelled until another `render` is triggered.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart datasets drawing.
 */
/**
 * @method IPlugin#afterDatasetsDraw
 * @desc Called after the `chart` datasets have been drawn. Note that this hook
 * will not be called if the datasets drawing has been previously cancelled.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeDatasetDraw
 * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
 * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
 * is cancelled until another `render` is triggered.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart datasets drawing.
 */
/**
 * @method IPlugin#afterDatasetDraw
 * @desc Called after the `chart` datasets at the given `args.index` have been drawn
 * (datasets are drawn in the reverse order). Note that this hook will not be called
 * if the datasets drawing has been previously cancelled.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Number} args.index - The dataset index.
 * @param {Object} args.meta - The dataset metadata.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeTooltipDraw
 * @desc Called before drawing the `tooltip`. If any plugin returns `false`,
 * the tooltip drawing is cancelled until another `render` is triggered.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Object} args.tooltip - The tooltip.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 * @returns {Boolean} `false` to cancel the chart tooltip drawing.
 */
/**
 * @method IPlugin#afterTooltipDraw
 * @desc Called after drawing the `tooltip`. Note that this hook will not
 * be called if the tooltip drawing has been previously cancelled.
 * @param {Chart} chart - The chart instance.
 * @param {Object} args - The call arguments.
 * @param {Object} args.tooltip - The tooltip.
 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#beforeEvent
 * @desc Called before processing the specified `event`. If any plugin returns `false`,
 * the event will be discarded.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {IEvent} event - The event object.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#afterEvent
 * @desc Called after the `event` has been consumed. Note that this hook
 * will not be called if the `event` has been previously discarded.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {IEvent} event - The event object.
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#resize
 * @desc Called after the chart as been resized.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
 * @param {Object} options - The plugin options.
 */
/**
 * @method IPlugin#destroy
 * @desc Called after the chart as been destroyed.
 * @param {Chart.Controller} chart - The chart instance.
 * @param {Object} options - The plugin options.
 */


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(42),
    stackClear = __webpack_require__(304),
    stackDelete = __webpack_require__(305),
    stackGet = __webpack_require__(306),
    stackHas = __webpack_require__(307),
    stackSet = __webpack_require__(308);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(32),
    isObject = __webpack_require__(45);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 102 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(327),
    arraySome = __webpack_require__(330),
    cacheHas = __webpack_require__(331);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(345),
    isObjectLike = __webpack_require__(33);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(17),
    stubFalse = __webpack_require__(346);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 106 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(347),
    baseUnary = __webpack_require__(348),
    nodeUtil = __webpack_require__(349);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(45);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(111),
    toKey = __webpack_require__(50);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(18),
    isKey = __webpack_require__(68),
    stringToPath = __webpack_require__(366),
    toString = __webpack_require__(369);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(113);
module.exports = __webpack_require__(118);


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(114).enable();
  window.Promise = __webpack_require__(116);
}

// fetch() polyfill for making API calls.
__webpack_require__(117);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(51);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(69);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(69);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registerServiceWorker__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_app_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_app_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(130);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_2__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(51),n=__webpack_require__(70),p=__webpack_require__(71),q=__webpack_require__(72),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.1",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(121);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.1
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(70),ba=__webpack_require__(0),m=__webpack_require__(122),p=__webpack_require__(51),v=__webpack_require__(72),da=__webpack_require__(123),ea=__webpack_require__(124),fa=__webpack_require__(125),ha=__webpack_require__(71);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},zc={};function Ac(a){if(zc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return zc[a]=!0;xc[a]=!0;return!1}
function Bc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Cc(a,b,c,d){if(null===b||"undefined"===typeof b||Bc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Dc=/[\-:]([a-z])/g;function Ec(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Dc,
Ec);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Dc,Ec);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
function Fc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Cc(b,c,e,d)&&(c=null),d||null===e?Ac(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Gc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Hc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ic(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Jc(a,b){b=b.checked;null!=b&&Fc(a,"checked",b,!1)}
function Kc(a,b){Jc(a,b);var c=Ic(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Lc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Lc(a,b.type,Ic(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Mc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Lc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Ic(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Nc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Oc(a,b,c){a=H.getPooled(Nc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Pc=null,Qc=null;function Rc(a){Ia(a,!1)}function Sc(a){var b=Oa(a);if(dc(b))return a}
function Tc(a,b){if("change"===a)return b}var Uc=!1;m.canUseDOM&&(Uc=$b("input")&&(!document.documentMode||9<document.documentMode));function Vc(){Pc&&(Pc.detachEvent("onpropertychange",Wc),Qc=Pc=null)}function Wc(a){"value"===a.propertyName&&Sc(Qc)&&(a=Oc(Qc,a,Zb(a)),Wb(Rc,a))}function Xc(a,b,c){"focus"===a?(Vc(),Pc=b,Qc=c,Pc.attachEvent("onpropertychange",Wc)):"blur"===a&&Vc()}function Yc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Sc(Qc)}
function Zc(a,b){if("click"===a)return Sc(b)}function $c(a,b){if("input"===a||"change"===a)return Sc(b)}
var ad={eventTypes:Nc,_isInputEventSupported:Uc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Tc:Yb(e)?Uc?f=$c:(f=Yc,g=Xc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Zc);if(f&&(f=f(a,b)))return Oc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Lc(e,"number",e.value)}},bd=H.extend({view:null,detail:null}),cd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}
var fd=bd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),gd=fd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),hd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},id={eventTypes:hd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=fd,h=hd.mouseLeave,k=hd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=gd,h=hd.pointerLeave,k=hd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function jd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function kd(a){2!==jd(a)?A("188"):void 0}
function ld(a){var b=a.alternate;if(!b)return b=jd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return kd(e),a;if(g===d)return kd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function md(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function nd(a){a=ld(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var od=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=bd.extend({relatedTarget:null});
function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=bd.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=fd.extend({dataTransfer:null}),wd=bd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed}),xd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=fd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=fd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case fb:case gb:case hb:a=od;break;case ib:a=xd;break;case "scroll":a=bd;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=gd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Hd=!0;function Id(a){Hd=!!a}function K(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!1)}
function Md(a,b){if(!b)return null;var c=(Ed(a)?Kd:Ld).bind(null,a);b.addEventListener(a,c,!0)}function Kd(a,b){Tb(Ld,a,b)}function Ld(a,b){if(Hd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===jd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}
var Nd={get _enabled(){return Hd},setEnabled:Id,isEnabled:function(){return Hd},trapBubbledEvent:K,trapCapturedEvent:Md,dispatchEvent:Ld},Od={},Pd=0,Qd="_reactListenersID"+(""+Math.random()).slice(2);function Rd(a){Object.prototype.hasOwnProperty.call(a,Qd)||(a[Qd]=Pd++,Od[a[Qd]]={});return Od[a[Qd]]}function Sd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Td(a,b){var c=Sd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Sd(c)}}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){if($d||null==Xd||Xd!==da())return null;var c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Zd&&ea(Zd,c)?null:(Zd=c,a=H.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ya(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Rd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:id,ChangeEventPlugin:ad,SelectEventPlugin:be,BeforeInputEventPlugin:Ib});
var ce="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,de=Date,ee=setTimeout,fe=clearTimeout,ge=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var he=performance;ge=function(){return he.now()}}else ge=function(){return de.now()};var ie=void 0,je=void 0;
if(m.canUseDOM){var ke="function"===typeof ce?ce:function(){A("276")},L=null,le=null,me=-1,ne=!1,oe=!1,pe=0,qe=33,re=33,se={didTimeout:!1,timeRemaining:function(){var a=pe-ge();return 0<a?a:0}},ue=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{je(a),d||(ne=!0,window.postMessage(te,"*"))}},te="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===te&&(ne=!1,null!==L)){if(null!==L){var b=ge();if(!(-1===
me||me>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(se.didTimeout=!0,b=0,d=c.length;b<d;b++)ue(c[b],se);me=a}}for(a=ge();0<pe-a&&null!==L;)a=L,se.didTimeout=!1,ue(a,se),a=ge();null===L||oe||(oe=!0,ke(ve))}},!1);var ve=function(a){oe=!1;var b=a-pe+re;b<re&&qe<re?(8>b&&(b=8),re=b<qe?qe:b):qe=b;pe=a+re;ne||(ne=!0,window.postMessage(te,"*"))};ie=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=ge()+
b.timeout);if(-1===me||-1!==c&&c<me)me=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=le,null!==b&&(b.next=a));le=a;oe||(oe=!0,ke(ve));return a};je=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,le=c):le=L=null}}}else{var we=new Map;ie=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=ee(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});we.set(a,c);return b};je=function(a){var b=we.get(a.scheduledCallback);we.delete(a);fe(b)}}function xe(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ye(a,b){a=p({children:void 0},b);if(b=xe(b.children))a.children=b;return a}
function ze(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ae(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Be(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function De(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function He(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ie=void 0,Je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Fe.svg||"innerHTML"in a)a.innerHTML=b;else{Ie=Ie||document.createElement("div");Ie.innerHTML="<svg>"+b+"</svg>";for(b=Ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Me=["Webkit","ms","Moz","O"];Object.keys(Le).forEach(function(a){Me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Le[b]=Le[a]})});
function Ne(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Le.hasOwnProperty(e)&&Le[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Oe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Pe(a,b,c){b&&(Oe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Qe(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Re=v.thatReturns("");
function Se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Rd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Md("scroll",a);break;case "focus":case "blur":Md("focus",a);Md("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Md(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
function Te(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Fe.html&&(d=Ge(a));d===Fe.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ue(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function Ve(a,b,c,d){var e=Qe(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Hc(a,c);f=Gc(a,c);K("invalid",a);Se(d,"onChange");break;case "option":f=ye(a,c);break;case "select":Ae(a,c);f=p({},c,{value:void 0});
K("invalid",a);Se(d,"onChange");break;case "textarea":Ce(a,c);f=Be(a,c);K("invalid",a);Se(d,"onChange");break;default:f=c}Pe(b,f,Re);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Ne(a,k,Re):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Je(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ke(a,k):"number"===typeof k&&Ke(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Se(d,
h):null!=k&&Fc(a,h,k,e))}switch(b){case "input":cc(a);Mc(a,c,!1);break;case "textarea":cc(a);Ee(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ze(a,!!c.multiple,b,!1):null!=c.defaultValue&&ze(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function We(a,b,c,d,e){var f=null;switch(b){case "input":c=Gc(a,c);d=Gc(a,d);f=[];break;case "option":c=ye(a,c);d=ye(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Be(a,c);d=Be(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Pe(b,d,Re);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Se(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Xe(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Jc(a,e);Qe(c,d);d=Qe(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Ne(a,h,Re):"dangerouslySetInnerHTML"===g?Je(a,h):"children"===g?Ke(a,h):Fc(a,g,h,d)}switch(c){case "input":Kc(a,e);break;case "textarea":De(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ze(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
ze(a,!!e.multiple,e.defaultValue,!0):ze(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ye(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Hc(a,c);K("invalid",a);Se(e,"onChange");break;case "select":Ae(a,c);K("invalid",a);Se(e,"onChange");break;case "textarea":Ce(a,c),K("invalid",a),Se(e,"onChange")}Pe(b,
c,Re);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Se(e,f)}switch(b){case "input":cc(a);Mc(a,c,!0);break;case "textarea":cc(a);Ee(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ze(a,b){return a.nodeValue!==b}
var $e={createElement:Te,createTextNode:Ue,setInitialProperties:Ve,diffProperties:We,updateProperties:Xe,diffHydratedProperties:Ye,diffHydratedText:Ze,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Kc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Kc(d,e)}}}break;case "textarea":De(a,c);break;case "select":b=c.value,null!=b&&ze(a,!!c.multiple,b,!1)}}},af=null,bf=null;function cf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function df(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ef=ge,ff=ie,gf=je;function hf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function jf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var kf=[],lf=-1;function mf(a){return{current:a}}
function M(a){0>lf||(a.current=kf[lf],kf[lf]=null,lf--)}function N(a,b){lf++;kf[lf]=a.current;a.current=b}var nf=mf(ha),O=mf(!1),of=ha;function pf(a){return qf(a)?of:nf.current}
function rf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function qf(a){return 2===a.tag&&null!=a.type.childContextTypes}function sf(a){qf(a)&&(M(O,a),M(nf,a))}function tf(a){M(O,a);M(nf,a)}
function uf(a,b,c){nf.current!==ha?A("168"):void 0;N(nf,b,a);N(O,c,a)}function vf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function wf(a){if(!qf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;of=nf.current;N(nf,b,a);N(O,O.current,a);return!0}
function xf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=vf(a,of);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(nf,a);N(nf,d,a)}else M(O,a);N(O,b,a)}
function yf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function zf(a,b,c){var d=a.alternate;null===d?(d=new yf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Af(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Bf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new yf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new yf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Bf(a,b,c,d){a=new yf(10,a,d,b);a.expirationTime=c;return a}function Cf(a,b,c){a=new yf(6,a,null,b);a.expirationTime=c;return a}function Df(a,b,c){b=new yf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ef(a,b,c){b=new yf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Ff=null,Gf=null;function Hf(a){return function(b){try{return a(b)}catch(c){}}}
function If(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ff=Hf(function(a){return b.onCommitFiberRoot(c,a)});Gf=Hf(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Jf(a){"function"===typeof Ff&&Ff(a)}function Kf(a){"function"===typeof Gf&&Gf(a)}var Lf=!1;
function Mf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Nf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Of(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Pf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Qf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Mf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Mf(a.memoizedState),f=d.updateQueue=Mf(d.memoizedState)):e=a.updateQueue=Nf(f):null===f&&(f=d.updateQueue=Nf(e));null===f||e===f?Pf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Pf(e,b,c),Pf(f,b,c)):(Pf(e,b,c),f.lastUpdate=b)}
function Rf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Mf(a.memoizedState):Sf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Sf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Nf(b));return b}
function Tf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Lf=!0}return d}
function Uf(a,b,c,d,e){Lf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Sf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Tf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Vf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Wf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Vf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Vf(b,c)),a=a.nextEffect}
function Xf(a,b){return{value:a,source:b,stack:vc(b)}}var Yf=mf(null),Zf=mf(null),$f=mf(0);function ag(a){var b=a.type._context;N($f,b._changedBits,a);N(Zf,b._currentValue,a);N(Yf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function bg(a){var b=$f.current,c=Zf.current;M(Yf,a);M(Zf,a);M($f,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var cg={},dg=mf(cg),eg=mf(cg),fg=mf(cg);function gg(a){a===cg?A("174"):void 0;return a}
function ig(a,b){N(fg,b,a);N(eg,a,a);N(dg,cg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:He(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=He(b,c)}M(dg,a);N(dg,b,a)}function jg(a){M(dg,a);M(eg,a);M(fg,a)}function kg(a){eg.current===a&&(M(dg,a),M(eg,a))}function lg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var pg={isMounted:function(a){return(a=a._reactInternalFiber)?2===jd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=mg();d=ng(d,a);var e=Of(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Qf(a,e,d);og(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=mg();c=ng(c,a);var d=Of(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Qf(a,d,c);og(a,c)}};function qg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function rg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&pg.enqueueReplaceState(b,b.state,null)}
function sg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=pf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=rf(a,f);f=a.updateQueue;null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(lg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&pg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Uf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var tg=Array.isArray;
function ug(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function vg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function wg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=zf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Cf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=ug(a,b,c),d.return=a,d;d=Af(c,a.mode,d);d.ref=ug(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Df(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Bf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Cf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Af(b,a.mode,c),c.ref=ug(a,null,b),c.return=a,c;case hc:return b=Df(b,a.mode,c),b.return=a,b}if(tg(b)||tc(b))return b=Bf(b,a.mode,c,null),b.return=
a,b;vg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(tg(c)||tc(c))return null!==e?null:r(a,b,c,d,null);vg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(tg(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);vg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=ug(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Bf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Af(f,a.mode,h),h.ref=ug(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Df(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Cf(f,a.mode,h),d.return=a,a=d),g(a);if(tg(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&vg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var xg=wg(!0),yg=wg(!1),zg=null,Ag=null,Bg=!1;function Cg(a,b){var c=new yf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Dg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Eg(a){if(Bg){var b=Ag;if(b){var c=b;if(!Dg(a,b)){b=hf(c);if(!b||!Dg(a,b)){a.effectTag|=2;Bg=!1;zg=a;return}Cg(zg,c)}zg=a;Ag=jf(b)}else a.effectTag|=2,Bg=!1,zg=a}}
function Fg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;zg=a}function Gg(a){if(a!==zg)return!1;if(!Bg)return Fg(a),Bg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!df(b,a.memoizedProps))for(b=Ag;b;)Cg(a,b),b=hf(b);Fg(a);Ag=zg?hf(a.stateNode):null;return!0}function Hg(){Ag=zg=null;Bg=!1}function Q(a,b,c){Ig(a,b,c,b.expirationTime)}function Ig(a,b,c,d){b.child=null===a?yg(b,null,c,d):xg(b,a.child,c,d)}
function Jg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Kg(a,b,c,d,e){Jg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&xf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Ig(a,b,null,e),b.child=null);Ig(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&xf(b,!0);return b.child}
function Lg(a){var b=a.stateNode;b.pendingContext?uf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&uf(a,b.context,!1);ig(a,b.containerInfo)}
function Mg(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Qg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,ag(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,ag(b),R(a,b)}else Mg(b,d,h,c)}b.stateNode=h;ag(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=zf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=zf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Rg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Lg(b);break;case 2:wf(b);break;case 4:ig(b,b.stateNode.containerInfo);break;case 13:ag(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=pf(b);f=rf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&lg(b,f,e),e=wf(b),d.updater=pg,b.stateNode=d,d._reactInternalFiber=b,sg(b,c),a=Kg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=pf(b),d=rf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=wf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=pf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?rf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=pg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);sg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=pf(b);g=rf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&rg(b,d,f,g);Lf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Uf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Lf?("function"===typeof r&&(lg(b,r,f),n=b.memoizedState),(k=Lf||qg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=pf(b),g=rf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&rg(b,d,k,g),Lf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Uf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Lf?("function"===typeof r&&(lg(b,r,k),w=b.memoizedState),(r=Lf||qg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Kg(a,b,d,e,c);case 3:Lg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Uf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Hg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Ag=jf(b.stateNode.containerInfo),zg=b,d=Bg=!0;d?(b.effectTag|=2,b.child=yg(b,null,e,c)):(Hg(),Q(a,b,e));a=b.child}else Hg(),a=R(a,b);return a;case 5:a:{gg(fg.current);e=gg(dg.current);d=He(e,
b.type);e!==d&&(N(eg,b,b),N(dg,d,b));null===a&&Eg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;df(e,d)?k=null:f&&df(e,f)&&(b.effectTag|=16);Jg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Eg(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return ig(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=xg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Qg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Mg(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Sg(a){a.effectTag|=4}var Tg=void 0,Ug=void 0,Vg=void 0;Tg=function(){};Ug=function(a,b,c){(b.updateQueue=c)&&Sg(b)};Vg=function(a,b,c,d){c!==d&&Sg(b)};
function Wg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return sf(b),null;case 3:jg(b);tf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Gg(b),b.effectTag&=-3;Tg(b);return null;case 5:kg(b);d=gg(fg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=gg(dg.current);g=We(g,e,f,c,d);Ug(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=gg(dg.current);if(Gg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ye(c,e,f,a,d),b.updateQueue=d,null!==d&&Sg(b);else{a=Te(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Ve(a,e,c,d);cf(e,c)&&Sg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Vg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=gg(fg.current);gg(dg.current);Gg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ze(d,c)&&Sg(b)):(d=Ue(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return jg(b),Tg(b),null;case 13:return bg(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Xg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Yg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Zg(a,c)}else b.current=null}
function $g(a){"function"===typeof Kf&&Kf(a);switch(a.tag){case 2:Yg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Zg(a,c)}break;case 5:Yg(a);break;case 4:ah(a)}}function bh(a){return 5===a.tag||3===a.tag||4===a.tag}
function ch(a){a:{for(var b=a.return;null!==b;){if(bh(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||bh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function ah(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if($g(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:$g(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function dh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Xe(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function eh(a,b,c){c=Of(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){fh(d);Xg(a,b)};return c}
function gh(a,b,c){c=Of(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===hh?hh=new Set([this]):hh.add(this);var c=b.value,d=b.stack;Xg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function ih(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Xf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=eh(a,d,f);Rf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===hh||!hh.has(c))){a.effectTag|=1024;d=gh(a,b,f);Rf(a,d,f);return}}a=a.return}while(null!==a)}
function jh(a){switch(a.tag){case 2:sf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return jg(a),tf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return kg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return jg(a),null;case 13:return bg(a),null;default:return null}}var kh=ef(),lh=2,mh=kh,nh=0,oh=0,ph=!1,S=null,qh=null,T=0,rh=-1,sh=!1,U=null,th=!1,uh=!1,hh=null;
function vh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:sf(b);break;case 3:jg(b);tf(b);break;case 5:kg(b);break;case 4:jg(b);break;case 13:bg(b)}a=a.return}qh=null;T=0;rh=-1;sh=!1;S=null;uh=!1}
function wh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Wg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{uh=!0;break}}else{a=jh(a,sh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function xh(a){var b=Rg(a.alternate,a,T);null===b&&(b=wh(a));ec.current=null;return b}
function yh(a,b,c){ph?A("243"):void 0;ph=!0;if(b!==T||a!==qh||null===S)vh(),qh=a,T=b,rh=-1,S=zf(qh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;sh=!c||T<=lh;do{try{if(c)for(;null!==S&&!zh();)S=xh(S);else for(;null!==S;)S=xh(S)}catch(f){if(null===S)d=!0,fh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;fh(f);break}ih(a,e,c,f,sh,T,mh);S=wh(c)}}break}while(1);ph=!1;if(d)return null;if(null===S){if(uh)return a.pendingCommitExpirationTime=b,a.current.alternate;sh?A("262"):
void 0;0<=rh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Ah(a,b)},rh);Bh(a.current.expirationTime)}return null}
function Zg(a,b){var c;a:{ph&&!th?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===hh||!hh.has(d))){a=Xf(b,a);a=gh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}break;case 3:a=Xf(b,a);a=eh(c,a,1);Qf(c,a,1);og(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Xf(b,a),c=eh(a,c,1),Qf(a,c,1),og(a,1));c=void 0}return c}
function Ch(){var a=2+25*(((mg()-2+500)/25|0)+1);a<=nh&&(a=nh+1);return nh=a}function ng(a,b){a=0!==oh?oh:ph?th?1:T:b.mode&1?Dh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Dh&&(0===Eh||a>Eh)&&(Eh=a);return a}
function og(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!ph&&0!==T&&b<T&&vh();var d=c.current.expirationTime;ph&&!th&&qh===c||Ah(c,d);Fh>Gh&&A("185")}else break;a=a.return}}function mg(){mh=ef()-kh;return lh=(mh/10|0)+2}
function Hh(a){var b=oh;oh=2+25*(((mg()-2+500)/25|0)+1);try{return a()}finally{oh=b}}function Ih(a,b,c,d,e){var f=oh;oh=1;try{return a(b,c,d,e)}finally{oh=f}}var Jh=null,V=null,Kh=0,Lh=void 0,W=!1,X=null,Y=0,Eh=0,Mh=!1,Nh=!1,Oh=null,Ph=null,Z=!1,Qh=!1,Dh=!1,Rh=null,Gh=1E3,Fh=0,Sh=1;function Th(a){if(0!==Kh){if(a>Kh)return;null!==Lh&&gf(Lh)}var b=ef()-kh;Kh=a;Lh=ff(Uh,{timeout:10*(a-2)-b})}
function Ah(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Jh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Jh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Qh&&(X=a,Y=1,Vh(a,1,!1)):1===b?Wh():Th(b))}
function Xh(){var a=0,b=null;if(null!==V)for(var c=V,d=Jh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Jh=V=d.nextScheduledRoot=null;break}else if(d===Jh)Jh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Jh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Fh++:Fh=0;X=b;Y=a}function Uh(a){Yh(0,!0,a)}function Wh(){Yh(1,!1,null)}function Yh(a,b,c){Ph=c;Xh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Mh||mg()>=Y);)mg(),Vh(X,Y,!Mh),Xh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Vh(X,Y,!1),Xh();null!==Ph&&(Kh=0,Lh=null);0!==Y&&Th(Y);Ph=null;Mh=!1;Zh()}function $h(a,b){W?A("253"):void 0;X=a;Y=b;Vh(a,b,!1);Wh();Zh()}
function Zh(){Fh=0;if(null!==Rh){var a=Rh;Rh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Nh||(Nh=!0,Oh=d)}}}if(Nh)throw a=Oh,Oh=null,Nh=!1,a;}function Vh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!0),null!==c&&(zh()?a.finishedWork=c:ai(a,c,b)))):(c=a.finishedWork,null!==c?ai(a,c,b):(c=yh(a,b,!1),null!==c&&ai(a,c,b)));W=!1}
function ai(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Rh?Rh=[d]:Rh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;th=ph=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;mg();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;af=Hd;var f=da();if(Ud(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;bf={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var mi=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=mi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Zg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ke(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:ch(U);U.effectTag&=-3;break;case 6:ch(U);U.effectTag&=-3;dh(U.alternate,
U);break;case 4:dh(U.alternate,U);break;case 8:D=U,ah(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Zg(U,y),null!==U&&(U=U.nextEffect))}l=bf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Ud(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Td(q,l),D=Td(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}bf=null;Id(af);af=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var hg=U.effectTag;if(hg&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var wi=oc.memoizedProps,xi=oc.memoizedState;ca.props=l.memoizedProps;
ca.state=l.memoizedState;ca.componentDidUpdate(wi,xi,ca.__reactInternalSnapshotBeforeUpdate)}var Ng=l.updateQueue;null!==Ng&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Wf(l,Ng,ca,u));break;case 3:var Og=l.updateQueue;if(null!==Og){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Wf(l,Og,y,u)}break;case 5:var yi=l.stateNode;null===oc&&l.effectTag&4&&cf(l.type,l.memoizedProps)&&yi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
default:A("163")}}if(hg&128){l=void 0;var yc=U.ref;if(null!==yc){var Pg=U.stateNode;switch(U.tag){case 5:l=Pg;break;default:l=Pg}"function"===typeof yc?yc(l):yc.current=l}}var zi=U.nextEffect;U.nextEffect=null;U=zi}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Zg(U,q),null!==U&&(U=U.nextEffect))}ph=th=!1;"function"===typeof Jf&&Jf(b.stateNode);b=c.current.expirationTime;0===b&&(hh=null);a.remainingExpirationTime=b}function zh(){return null===Ph||Ph.timeRemaining()>Sh?!1:Mh=!0}
function fh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Nh||(Nh=!0,Oh=a)}function Bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function bi(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Wh()}}function ci(a,b){if(Z&&!Qh){Qh=!0;try{return a(b)}finally{Qh=!1}}return a(b)}function di(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Ih(a,b)}finally{Z=c,Wh()}}
function ei(a,b,c){if(Dh)return a(b,c);Z||W||0===Eh||(Yh(Eh,!1,null),Eh=0);var d=Dh,e=Z;Z=Dh=!0;try{return a(b,c)}finally{Dh=d,(Z=e)||W||Wh()}}function fi(a){var b=Z;Z=!0;try{Ih(a)}finally{(Z=b)||W||Yh(1,!1,null)}}
function gi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===jd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(qf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=qf(c)?vf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Of(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Qf(f,e,d);og(f,d);return d}
function hi(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=md(b);return null===a?null:a.stateNode}function ii(a,b,c,d){var e=b.current,f=mg();e=ng(f,e);return gi(a,b,c,e,d)}function ji(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function ki(a){var b=a.findFiberByHostInstance;return If(p({},a,{findHostInstanceByFiber:function(a){a=md(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var li={updateContainerAtExpirationTime:gi,createContainer:function(a,b,c){return Ef(a,b,c)},updateContainer:ii,flushRoot:$h,requestWork:Ah,computeUniqueAsyncExpiration:Ch,batchedUpdates:bi,unbatchedUpdates:ci,deferredUpdates:Hh,syncUpdates:Ih,interactiveUpdates:ei,flushInteractiveUpdates:function(){W||0===Eh||(Yh(Eh,!1,null),Eh=0)},flushControlled:fi,flushSync:di,getPublicRootInstance:ji,findHostInstance:hi,findHostInstanceWithNoPortals:function(a){a=nd(a);return null===a?null:a.stateNode},injectIntoDevTools:ki};
function ni(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent($e);function oi(a){this._expirationTime=Ch();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
oi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new pi;gi(a,b,null,c,d._onCommit);return d};oi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
oi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;$h(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};oi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function pi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}pi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
pi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function qi(a,b,c){this._internalRoot=Ef(a,b,c)}qi.prototype.render=function(a,b){var c=this._internalRoot,d=new pi;b=void 0===b?null:b;null!==b&&d.then(b);ii(a,c,null,d._onCommit);return d};
qi.prototype.unmount=function(a){var b=this._internalRoot,c=new pi;a=void 0===a?null:a;null!==a&&c.then(a);ii(null,b,null,c._onCommit);return c};qi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new pi;c=void 0===c?null:c;null!==c&&e.then(c);ii(b,d,a,e._onCommit);return e};
qi.prototype.createBatch=function(){var a=new oi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ri(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=li.batchedUpdates;Tb=li.interactiveUpdates;Ub=li.flushInteractiveUpdates;
function si(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qi(a,!1,b)}
function ti(a,b,c,d,e){ri(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ji(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=si(c,d);if("function"===typeof e){var h=e;e=function(){var a=ji(f._internalRoot);h.call(a)}}ci(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ji(f._internalRoot)}
function ui(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ri(b)?void 0:A("200");return ni(a,b,null,c)}
var vi={createPortal:ui,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:hi(a)},hydrate:function(a,b,c){return ti(null,a,b,!0,c)},render:function(a,b,c){return ti(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ti(a,b,c,!1,d)},unmountComponentAtNode:function(a){ri(a)?void 0:A("40");return a._reactRootContainer?(ci(function(){ti(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return ui.apply(void 0,
arguments)},unstable_batchedUpdates:bi,unstable_deferredUpdates:Hh,unstable_interactiveUpdates:ei,flushSync:di,unstable_flushControlled:fi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Nd},unstable_createRoot:function(a,b){return new qi(a,!0,null!=b&&!0===b.hydrate)}};ki({findFiberByHostInstance:Na,bundleType:0,version:"16.4.1",rendererPackageName:"react-dom"});
var Ai={default:vi},Bi=Ai&&vi||Ai;module.exports=Bi.default?Bi.default:Bi;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(126);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(127);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
/* unused harmony export update */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}function update(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.update();});}}

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_thunk__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_locale_it__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_locale_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment_locale_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Bone_Layout__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Bone_AuthLayout__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Home__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Login__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Attendances__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Balance__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Courses__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Members__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Receipts__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Club__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Instructors__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Dashboard__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Howitworks__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Notes__ = __webpack_require__(398);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_5_moment___default.a.tz.setDefault('Europe/London');var store=Object(__WEBPACK_IMPORTED_MODULE_2_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_7__reducers__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__["composeWithDevTools"])(Object(__WEBPACK_IMPORTED_MODULE_2_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_8_redux_thunk__["a" /* default */])));// store.subscribe(() => console.log('store', store.getState()));
var App=function(_React$Component){_inherits(App,_React$Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{render:function render(_ref){var location=_ref.location;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Bone_Layout__["a" /* default */],{location:location},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */],{location:location},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/',component:__WEBPACK_IMPORTED_MODULE_12__components_Home__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/accedi',component:__WEBPACK_IMPORTED_MODULE_13__components_Login__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/come-funziona',component:__WEBPACK_IMPORTED_MODULE_22__components_Howitworks__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Bone_AuthLayout__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/dashboard',component:__WEBPACK_IMPORTED_MODULE_21__components_Dashboard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/presenze',component:__WEBPACK_IMPORTED_MODULE_14__components_Attendances__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/ricevute',component:__WEBPACK_IMPORTED_MODULE_18__components_Receipts__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/anagrafiche',component:__WEBPACK_IMPORTED_MODULE_17__components_Members__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/corsi',component:__WEBPACK_IMPORTED_MODULE_16__components_Courses__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/bilancio',component:__WEBPACK_IMPORTED_MODULE_15__components_Balance__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/associazione',component:__WEBPACK_IMPORTED_MODULE_19__components_Club__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/istruttori',component:__WEBPACK_IMPORTED_MODULE_20__components_Instructors__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/note',component:__WEBPACK_IMPORTED_MODULE_23__components_Notes__["a" /* default */]}))));}})));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(53);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(133);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(73);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(73);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(52);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(53);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(141);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(54);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(74);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(145);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(147);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(78);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(149);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(54);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(151);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(55);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(78);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(55);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(155);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(76);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(158);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34), __webpack_require__(157)(module)))

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(38).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(56);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(176);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(82);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(173);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(170);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(168);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34)))

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(84);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(172);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(82);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(83);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(177);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(56);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(179);
moment.tz.load(__webpack_require__(180));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.20
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(4)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.20",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		return b.zone.population - a.zone.population;
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {
		if (typeof name !== 'string') {
			throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
		}

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				mom.utcOffset(-offset, keepTime);
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc      = resetZoneWrap(fn.utc);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = {"version":"2018e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|012|-2le00 4i6N0","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le80 1XO3u 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BAu|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__club__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__members__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__courses__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__instructors__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__receipts__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__balance__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fiscalyear__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__attendances__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dashboard__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__notes__ = __webpack_require__(210);
var rootReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({auth:__WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */],club:__WEBPACK_IMPORTED_MODULE_2__club__["a" /* default */],members:__WEBPACK_IMPORTED_MODULE_3__members__["a" /* default */],courses:__WEBPACK_IMPORTED_MODULE_4__courses__["a" /* default */],instructors:__WEBPACK_IMPORTED_MODULE_5__instructors__["a" /* default */],receipts:__WEBPACK_IMPORTED_MODULE_6__receipts__["a" /* default */],balance:__WEBPACK_IMPORTED_MODULE_7__balance__["a" /* default */],fiscalyear:__WEBPACK_IMPORTED_MODULE_8__fiscalyear__["a" /* default */],attendances:__WEBPACK_IMPORTED_MODULE_9__attendances__["a" /* default */],dashboard:__WEBPACK_IMPORTED_MODULE_10__dashboard__["a" /* default */],notes:__WEBPACK_IMPORTED_MODULE_11__notes__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = auth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_Auth__ = __webpack_require__(39);
var initialState={user:null,error:null,loading:false,valid:false};function auth(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_Auth__["a" /* DO_LOGIN */]:return Object.assign({},state,{loading:true,error:null,valid:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Auth__["c" /* DO_LOGIN_SUCCESS */]:window.localStorage.setItem('it.clubhub.email',action.payload.email);window.localStorage.setItem('it.clubhub.bearer',action.payload.bearer);window.localStorage.setItem('it.clubhub.time',action.payload.time);window.localStorage.setItem('it.clubhub.grant',action.payload.grant);window.localStorage.setItem('it.clubhub.club',action.payload.club);window.localStorage.setItem('it.clubhub.userid',action.payload.userid);window.localStorage.setItem('it.clubhub.fiscalyear',action.payload.fiscalyear);return Object.assign({},state,{user:action.payload,loading:false,valid:true,error:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Auth__["b" /* DO_LOGIN_FAILURE */]:return Object.assign({},state,{error:action.payload,loading:false,valid:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Auth__["d" /* DO_LOGOUT */]:window.localStorage.removeItem('it.clubhub.email');window.localStorage.removeItem('it.clubhub.bearer');window.localStorage.removeItem('it.clubhub.time');window.localStorage.removeItem('it.clubhub.grant');window.localStorage.removeItem('it.clubhub.club');window.localStorage.removeItem('it.clubhub.userid');window.localStorage.removeItem('it.clubhub.fiscalyear');window.localStorage.clear();return Object.assign({},state,{error:null,loading:false,valid:false,user:null});default:return state;}}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var bind = __webpack_require__(85);
var Axios = __webpack_require__(185);
var defaults = __webpack_require__(58);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(90);
axios.CancelToken = __webpack_require__(199);
axios.isCancel = __webpack_require__(89);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(200);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var utils = __webpack_require__(9);
var InterceptorManager = __webpack_require__(194);
var dispatchRequest = __webpack_require__(195);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(88);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var transformData = __webpack_require__(196);
var isCancel = __webpack_require__(89);
var defaults = __webpack_require__(58);
var isAbsoluteURL = __webpack_require__(197);
var combineURLs = __webpack_require__(198);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(90);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = club;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_Club__ = __webpack_require__(59);
var initialState={info:null,error:null,loading:false,ajaxSpinner:false,ajaxStatus:null};function club(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_Club__["c" /* FETCH_CLUB */]:return Object.assign({},state,{loading:true,error:null,info:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Club__["e" /* FETCH_CLUB_SUCCESS */]:return Object.assign({},state,{info:action.payload,loading:false,error:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Club__["d" /* FETCH_CLUB_FAILURE */]:return Object.assign({},state,{error:action.payload,loading:false,info:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Club__["g" /* SAVE_CLUB_SUCCESS */]:return Object.assign({},state,{info:action.payload,ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Club__["f" /* SAVE_CLUB_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Club__["a" /* CLUB_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:true,ajaxStatus:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Club__["b" /* CLUB_CLEAR_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:false,ajaxStatus:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Club__["i" /* UPLOAD_SIGNATURE_STARTED */]:return Object.assign({},state,{ajaxSpinner:true,ajaxStatus:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Club__["j" /* UPLOAD_SIGNATURE_SUCCESS */]:return Object.assign({},state,{info:action.payload,ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Club__["h" /* UPLOAD_SIGNATURE_FAILURE */]:return Object.assign({},state,{ajaxStatus:null,ajaxSpinner:false});default:return state;}}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = members;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_Members__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uris__ = __webpack_require__(7);
var initialState={list:null,error:null,loading:false,ajaxSpinner:false,ajaxStatus:null,uploading:false};function members(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["f" /* FETCH_MEMBERS */]:return Object.assign({},state,{loading:true,error:null,list:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["h" /* FETCH_MEMBERS_SUCCESS */]:return Object.assign({},state,{list:action.payload,loading:false,error:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["g" /* FETCH_MEMBERS_FAILURE */]:return Object.assign({},state,{error:action.payload,loading:false,list:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["n" /* SAVE_MEMBERS_SUCCESS */]:return Object.assign({},state,{list:state.list.findIndex(function(x){return x.id===action.payload.id;})===-1?state.list.concat(action.payload):state.list.map(function(item){return item.id===action.payload.id?action.payload:item;}),ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["m" /* SAVE_MEMBERS_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["b" /* DELETE_MEMBERS_SUCCESS */]:return Object.assign({},state,{list:state.list.filter(function(item){return item.id!==action.payload;}),ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["a" /* DELETE_MEMBERS_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["i" /* MEMBERS_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:true,ajaxStatus:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["j" /* MEMBERS_CLEAR_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:false,ajaxStatus:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["k" /* MEMBERS_START_UPLOAD */]:return Object.assign({},state,{uploading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["l" /* MEMBERS_STOP_UPLOAD */]:return Object.assign({},state,{uploading:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["o" /* SET_LAST_PAID */]:return Object.assign({},state,{list:state.list.map(function(item){return item.id===action.payload.id?Object.assign({},item,{last_paid:action.payload.last_paid}):item;})});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["c" /* EXPORT_MEMBERS */]:return Object.assign({},state,{ajaxSpinner:true});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["e" /* EXPORT_MEMBERS_SUCCESS */]:window.open(__WEBPACK_IMPORTED_MODULE_1__Uris__["a" /* URIS */].apiBase+action.payload.data,'_blank');return Object.assign({},state,{ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Members__["d" /* EXPORT_MEMBERS_FAILURE */]:return Object.assign({},state,{ajaxSpinner:false,error:action.payload});default:return state;}}

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = courses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_Courses__ = __webpack_require__(15);
var initialState={list:null,error:null,loading:false,ajaxSpinner:false,ajaxStatus:null};function courses(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_Courses__["e" /* FETCH_COURSES */]:return Object.assign({},state,{loading:true,error:null,list:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Courses__["g" /* FETCH_COURSES_SUCCESS */]:return Object.assign({},state,{list:action.payload,loading:false,error:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Courses__["f" /* FETCH_COURSES_FAILURE */]:return Object.assign({},state,{error:action.payload,loading:false,list:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Courses__["i" /* SAVE_COURSES_SUCCESS */]:return Object.assign({},state,{list:state.list.findIndex(function(x){return x.id===action.payload.id;})===-1?state.list.concat(action.payload):state.list.map(function(item){return item.id===action.payload.id?action.payload:item;}),ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Courses__["h" /* SAVE_COURSES_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Courses__["d" /* DELETE_COURSES_SUCCESS */]:return Object.assign({},state,{list:state.list.filter(function(item){return item.id!==action.payload;}),ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Courses__["c" /* DELETE_COURSES_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Courses__["a" /* COURSES_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:true,ajaxStatus:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Courses__["b" /* COURSES_CLEAR_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:false,ajaxStatus:null});default:return state;}}

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = instructors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_Instructors__ = __webpack_require__(27);
var initialState={list:null,error:null,loading:false,ajaxSpinner:false,ajaxStatus:null};function instructors(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_Instructors__["c" /* FETCH_INSTRUCTORS */]:return Object.assign({},state,{loading:true,error:null,list:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Instructors__["e" /* FETCH_INSTRUCTORS_SUCCESS */]:return Object.assign({},state,{list:action.payload,loading:false,error:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Instructors__["d" /* FETCH_INSTRUCTORS_FAILURE */]:return Object.assign({},state,{error:action.payload,loading:false,list:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Instructors__["i" /* SAVE_INSTRUCTORS_SUCCESS */]:return Object.assign({},state,{list:state.list.findIndex(function(x){return x.id===action.payload.id;})===-1?state.list.concat(action.payload):state.list.map(function(item){return item.id===action.payload.id?action.payload:item;}),ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Instructors__["h" /* SAVE_INSTRUCTORS_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Instructors__["b" /* DELETE_INSTRUCTORS_SUCCESS */]:return Object.assign({},state,{list:state.list.filter(function(item){return item.id!==action.payload;}),ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Instructors__["a" /* DELETE_INSTRUCTORS_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Instructors__["f" /* INSTRUCTORS_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:true,ajaxStatus:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Instructors__["g" /* INSTRUCTORS_CLEAR_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:false,ajaxStatus:null});default:return state;}}

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = receipts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_Receipts__ = __webpack_require__(28);
var initialState={list:null,last:null,error:null,loading:false,ajaxSpinner:false,ajaxStatus:null};function receipts(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_Receipts__["c" /* FETCH_RECEIPTS */]:return Object.assign({},state,{loading:true,error:null,list:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Receipts__["e" /* FETCH_RECEIPTS_SUCCESS */]:return Object.assign({},state,{list:action.payload.list,last:action.payload.last,loading:false,error:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Receipts__["d" /* FETCH_RECEIPTS_FAILURE */]:return Object.assign({},state,{error:action.payload,last:null,loading:false,list:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Receipts__["i" /* SAVE_RECEIPTS_SUCCESS */]:return Object.assign({},state,{list:(state.list.findIndex(function(x){return x.id===action.payload.list.id;})===-1?state.list.concat(action.payload.list):state.list.map(function(item){return item.id===action.payload.list.id?action.payload.list:item;})).sort(function(a,b){return a.number<b.number?1:b.number<a.number?-1:0;}),last:action.payload.last,ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Receipts__["h" /* SAVE_RECEIPTS_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Receipts__["b" /* DELETE_RECEIPTS_SUCCESS */]:return Object.assign({},state,{list:state.list.filter(function(item){return item.id!==action.payload.list.id;}),last:action.payload.last,ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Receipts__["a" /* DELETE_RECEIPTS_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Receipts__["f" /* RECEIPTS_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:true,ajaxStatus:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Receipts__["g" /* RECEIPTS_CLEAR_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:false,ajaxStatus:null});default:return state;}}

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = balance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_Balance__ = __webpack_require__(29);
var initialState={list:null,error:null,loading:false,ajaxSpinner:false,ajaxStatus:null,uploading:false};function balance(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_Balance__["g" /* FETCH_BALANCE */]:return Object.assign({},state,{loading:true,error:null,list:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Balance__["i" /* FETCH_BALANCE_SUCCESS */]:return Object.assign({},state,{list:action.payload.sort(function(a,b){if(a.emission_date<b.emission_date)return 1;if(a.emission_date>b.emission_date)return-1;// emission_date is equal, sort by id desc
return b.id-a.id;}),loading:false,error:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Balance__["h" /* FETCH_BALANCE_FAILURE */]:return Object.assign({},state,{error:action.payload,loading:false,list:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Balance__["k" /* SAVE_BALANCE_SUCCESS */]:return Object.assign({},state,{list:(state.list.findIndex(function(x){return x.id===action.payload.id;})===-1?state.list.concat(action.payload):state.list.map(function(item){return item.id===action.payload.id?action.payload:item;})).sort(function(a,b){if(a.emission_date<b.emission_date)return 1;if(a.emission_date>b.emission_date)return-1;// emission_date is equal, sort by id desc
return b.id-a.id;}),ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Balance__["j" /* SAVE_BALANCE_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Balance__["f" /* DELETE_BALANCE_SUCCESS */]:return Object.assign({},state,{list:state.list.filter(function(item){return item.id!==action.payload;}),ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Balance__["e" /* DELETE_BALANCE_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Balance__["a" /* BALANCE_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:true,ajaxStatus:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Balance__["b" /* BALANCE_CLEAR_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:false,ajaxStatus:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Balance__["c" /* BALANCE_START_UPLOAD */]:return Object.assign({},state,{uploading:true});case __WEBPACK_IMPORTED_MODULE_0__actions_Balance__["d" /* BALANCE_STOP_UPLOAD */]:return Object.assign({},state,{uploading:false});default:return state;}}

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fiscalyear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_FiscalYear__ = __webpack_require__(91);
var initialState={list:null,current:null,error:null,loading:false};function fiscalyear(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_FiscalYear__["b" /* FETCH_FISCALYEAR */]:return Object.assign({},state,{loading:true,error:null,info:null});case __WEBPACK_IMPORTED_MODULE_0__actions_FiscalYear__["d" /* FETCH_FISCALYEAR_SUCCESS */]:window.localStorage.setItem('it.clubhub.fiscalyear',parseInt(action.payload[0].id,10));return Object.assign({},state,{list:action.payload,current:parseInt(action.payload[0].id,10),loading:false,error:null});case __WEBPACK_IMPORTED_MODULE_0__actions_FiscalYear__["c" /* FETCH_FISCALYEAR_FAILURE */]:return Object.assign({},state,{error:action.payload,current:null,loading:false,list:null});case __WEBPACK_IMPORTED_MODULE_0__actions_FiscalYear__["a" /* CHANGE_FISCALYEAR */]:window.localStorage.setItem('it.clubhub.fiscalyear',parseInt(action.payload,10));return Object.assign({},state,{current:parseInt(action.payload,10)});default:return state;}}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = attendances;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_Attendances__ = __webpack_require__(60);
var initialState={dates:null,ajaxSpinner:false,ajaxStatus:null};function attendances(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_Attendances__["c" /* FETCH_ATTENDANCES */]:return Object.assign({},state,{ajaxSpinner:true,error:null,dates:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Attendances__["e" /* FETCH_ATTENDANCES_SUCCESS */]:return Object.assign({},state,{dates:action.payload,ajaxSpinner:false,ajaxStatus:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Attendances__["d" /* FETCH_ATTENDANCES_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false,dates:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Attendances__["g" /* SAVE_ATTENDANCES_SUCCESS */]:return Object.assign({},state,{dates:state.dates.findIndex(function(x){return x.id===action.payload.id;})===-1?state.dates.concat(action.payload):state.dates.map(function(item){return item.id===action.payload.id?action.payload:item;}),ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Attendances__["f" /* SAVE_ATTENDANCES_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Attendances__["a" /* ATTENDANCES_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:true,ajaxStatus:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Attendances__["b" /* ATTENDANCES_CLEAR_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:false,ajaxStatus:null});default:return state;}}

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dashboard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_Dashboard__ = __webpack_require__(92);
var initialState={charts:null,error:null,loading:false};function dashboard(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_Dashboard__["a" /* FETCH_DASHBOARD */]:return Object.assign({},state,{loading:true,error:null,charts:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Dashboard__["c" /* FETCH_DASHBOARD_SUCCESS */]:return Object.assign({},state,{charts:action.payload,loading:false,error:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Dashboard__["b" /* FETCH_DASHBOARD_FAILURE */]:return Object.assign({},state,{error:action.payload,loading:false,charts:null});default:return state;}}

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = notes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_Notes__ = __webpack_require__(40);
var initialState={list:null,error:null,loading:false,ajaxSpinner:false,ajaxStatus:null};function notes(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_Notes__["c" /* FETCH_NOTES */]:return Object.assign({},state,{loading:true,error:null,list:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Notes__["e" /* FETCH_NOTES_SUCCESS */]:return Object.assign({},state,{list:action.payload,loading:false,error:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Notes__["d" /* FETCH_NOTES_FAILURE */]:return Object.assign({},state,{error:action.payload,loading:false,list:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Notes__["i" /* SAVE_NOTES_SUCCESS */]:return Object.assign({},state,{list:state.list.findIndex(function(x){return x.id===action.payload.id;})===-1?state.list.concat(action.payload):state.list.map(function(item){return item.id===action.payload.id?action.payload:item;}),ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Notes__["h" /* SAVE_NOTES_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Notes__["b" /* DELETE_NOTES_SUCCESS */]:return Object.assign({},state,{list:state.list.filter(function(item){return item.id!==action.payload;}),ajaxStatus:null,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Notes__["a" /* DELETE_NOTES_FAILURE */]:return Object.assign({},state,{ajaxStatus:action.payload,ajaxSpinner:false});case __WEBPACK_IMPORTED_MODULE_0__actions_Notes__["f" /* NOTES_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:true,ajaxStatus:null});case __WEBPACK_IMPORTED_MODULE_0__actions_Notes__["g" /* NOTES_CLEAR_AJAX_CALL */]:return Object.assign({},state,{ajaxSpinner:false,ajaxStatus:null});default:return state;}}

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Nav__ = __webpack_require__(214);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Version from './Version'
var Layout=function(_Component){_inherits(Layout,_Component);function Layout(){_classCallCheck(this,Layout);return _possibleConstructorReturn(this,(Layout.__proto__||Object.getPrototypeOf(Layout)).apply(this,arguments));}_createClass(Layout,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Nav__["a" /* default */],{location:this.props.location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bone'},this.props.children));}}]);return Layout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Layout);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_Auth__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FiscalYear__ = __webpack_require__(216);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Nav=function(_Component){_inherits(Nav,_Component);function Nav(){_classCallCheck(this,Nav);var _this=_possibleConstructorReturn(this,(Nav.__proto__||Object.getPrototypeOf(Nav)).call(this));_this.state={isOpen:false};return _this;}_createClass(Nav,[{key:'Hamburger',value:function Hamburger(){if(this.state.isOpen){this.setState({isOpen:false});}else{this.setState({isOpen:true});}}},{key:'logout',value:function logout(){this.Hamburger();this.props.callLogout();}},{key:'render',value:function render(){var _this2=this;var pathname=this.props.location.pathname;// const { valid } = this.props.auth
var bearer=window.localStorage.getItem('it.clubhub.bearer');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.isOpen?'open':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hamburger',onClick:function onClick(){return _this2.Hamburger();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menuOne'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line line-1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line line-2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line line-3'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:this.state.isOpen?'open':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inside-nav'},bearer===null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/',onClick:function onClick(){return _this2.Hamburger();},className:'lnk-nav '+(pathname==='/'?'active':'')},'home')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/come-funziona',onClick:function onClick(){return _this2.Hamburger();},className:'lnk-nav '+(pathname==='/come-funziona'?'active':'')},'Come Funziona')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/accedi',onClick:function onClick(){return _this2.Hamburger();},className:'lnk-nav '+(pathname==='/accedi'?'active':'')},'accedi'))),bearer!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-username'},window.localStorage.getItem('it.clubhub.email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FiscalYear__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/dashboard',onClick:function onClick(){return _this2.Hamburger();},className:'lnk-nav '+(pathname==='/dashboard'?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-tachometer-alt'}),' Dashboard')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/presenze',onClick:function onClick(){return _this2.Hamburger();},className:'lnk-nav '+(pathname==='/presenze'?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-clock'}),' presenze')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/ricevute',onClick:function onClick(){return _this2.Hamburger();},className:'lnk-nav '+(pathname==='/ricevute'?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-file-invoice'}),' ricevute')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/anagrafiche',onClick:function onClick(){return _this2.Hamburger();},className:'lnk-nav '+(pathname==='/anagrafiche'?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-users'}),' anagrafiche')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'csat'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/bilancio',onClick:function onClick(){return _this2.Hamburger();},className:'lnk-nav '+(pathname==='/bilancio'?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-money-bill-wave'}),' bilancio')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/associazione',onClick:function onClick(){return _this2.Hamburger();},className:'lnk-nav '+(pathname==='/associazione'?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-award'}),' Associazione')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/istruttori',onClick:function onClick(){return _this2.Hamburger();},className:'lnk-nav '+(pathname==='/istruttori'?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-gamepad'}),' istruttori')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/corsi',onClick:function onClick(){return _this2.Hamburger();},className:'lnk-nav '+(pathname==='/corsi'?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-chalkboard-teacher'}),' corsi')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'csat'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/note',onClick:function onClick(){return _this2.Hamburger();},className:'lnk-nav '+(pathname==='/note'?'active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-sticky-note'}),' note')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.logout();},className:'lnk-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-sign-out-alt'}),' Esci'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Footer__["a" /* default */],null))));}}]);return Nav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,{callLogout:__WEBPACK_IMPORTED_MODULE_3__actions_Auth__["f" /* callLogout */]})(Nav));

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_PureComponent){_inherits(Footer,_PureComponent);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,'\xA9',new Date().getFullYear(),' ClubHub ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' All Rights Reserved',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' v.',' ',document.head.querySelector('meta[name="build-version"]')['content']);}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_FiscalYear__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_Balance__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_Courses__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_Members__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_Receipts__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={year:''};var FiscalYear=function(_Component){_inherits(FiscalYear,_Component);function FiscalYear(){_classCallCheck(this,FiscalYear);var _this=_possibleConstructorReturn(this,(FiscalYear.__proto__||Object.getPrototypeOf(FiscalYear)).call(this));_this.state=initialState;return _this;}_createClass(FiscalYear,[{key:'changeYear',value:function changeYear(event){this.setState({year:event.target.value});this.props.changeFiscalyear(event.target.value);this.props.loadBalance();this.props.loadCourses();this.props.loadMembers();this.props.loadReceipts();}},{key:'componentWillMount',value:function componentWillMount(){if(this.props.fiscalyear.list===null){this.props.loadFiscalyear();}else{this.setState({year:this.props.fiscalyear.current});}}// componentDidUpdate (prevProps, prevState) {
//   console.log(prevProps.fiscalyear.current, this.props.fiscalyear.current)
//   if (prevProps.fiscalyear.current !== this.props.fiscalyear.current) {
//   }
// }
},{key:'render',value:function render(){var _this2=this;var list=this.props.fiscalyear.list;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Anno fiscale',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this2.changeYear(event);},value:this.state.year,className:'sel-fy'},list!==null&&list.map(function(y,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:y.id},__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(y.start_date).format('MMM YYYY'),' - ',__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(y.end_date).format('MMM YYYY'));})));}}]);return FiscalYear;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{loadFiscalyear:__WEBPACK_IMPORTED_MODULE_3__actions_FiscalYear__["f" /* loadFiscalyear */],changeFiscalyear:__WEBPACK_IMPORTED_MODULE_3__actions_FiscalYear__["e" /* changeFiscalyear */],loadBalance:__WEBPACK_IMPORTED_MODULE_4__actions_Balance__["n" /* loadBalance */],loadCourses:__WEBPACK_IMPORTED_MODULE_5__actions_Courses__["l" /* loadCourses */],loadMembers:__WEBPACK_IMPORTED_MODULE_6__actions_Members__["s" /* loadMembers */],loadReceipts:__WEBPACK_IMPORTED_MODULE_7__actions_Receipts__["l" /* loadReceipts */]})(FiscalYear));

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Validate__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DualRing__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AuthLayout=function(_Component){_inherits(AuthLayout,_Component);function AuthLayout(){_classCallCheck(this,AuthLayout);return _possibleConstructorReturn(this,(AuthLayout.__proto__||Object.getPrototypeOf(AuthLayout)).apply(this,arguments));}_createClass(AuthLayout,[{key:'render',value:function render(){var list=this.props.fiscalyear.list;if(list===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DualRing__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Validate__["a" /* default */],null),this.props.children);}}}]);return AuthLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{})(AuthLayout));

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_Auth__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={redirect:false};var Validate=function(_Component){_inherits(Validate,_Component);function Validate(){_classCallCheck(this,Validate);var _this=_possibleConstructorReturn(this,(Validate.__proto__||Object.getPrototypeOf(Validate)).call(this));_this.state=initialState;return _this;}_createClass(Validate,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.auth.valid&&!this.props.auth.valid){this.setState({redirect:true});}}},{key:'componentWillMount',value:function componentWillMount(){var bearer=window.localStorage.getItem('it.clubhub.bearer');if(bearer!==undefined&&bearer!==null){this.props.doLoginSuccess({bearer:bearer,email:window.localStorage.getItem('it.clubhub.email'),time:window.localStorage.getItem('it.clubhub.time'),grant:window.localStorage.getItem('it.clubhub.grant'),club:window.localStorage.getItem('it.clubhub.club'),userid:window.localStorage.getItem('it.clubhub.userid'),fiscalyear:window.localStorage.getItem('it.clubhub.fiscalyear')});}else{if(window.location.pathname!=='/accedi'){this.setState({redirect:true});}}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.redirect&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/accedi'}));}}]);return Validate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{doLoginSuccess:__WEBPACK_IMPORTED_MODULE_3__actions_Auth__["g" /* doLoginSuccess */]})(Validate));

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Home=function(_Component){_inherits(Home,_Component);function Home(){_classCallCheck(this,Home);return _possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).apply(this,arguments));}_createClass(Home,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inside centralize'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'site-name'},'ClubHub'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'site-payoff'},'la gestione smart della tua associazione')));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Auth__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loader__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={email:'',password:''};var Login=function(_Component){_inherits(Login,_Component);function Login(){_classCallCheck(this,Login);var _this=_possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).call(this));_this.state=initialState;return _this;}_createClass(Login,[{key:'tryLogin',value:function tryLogin(event){if(event.key==='Enter'){this.login();}}},{key:'login',value:function login(){var valid=true;if(this.state.email===''){valid=false;}if(this.state.password===''){valid=false;}if(valid){this.props.callLogin({email:this.state.email,password:this.state.password});}}},{key:'render',value:function render(){var _this2=this;var _props$auth=this.props.auth,loading=_props$auth.loading,error=_props$auth.error,valid=_props$auth.valid;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inside centralize'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Accedi'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ul-login'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'email',placeholder:'Email',onChange:function onChange(event){return _this2.setState({email:event.target.value});},onKeyPress:function onKeyPress(event){return _this2.tryLogin(event);},value:this.state.email}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',placeholder:'Password',onChange:function onChange(event){return _this2.setState({password:event.target.value});},onKeyPress:function onKeyPress(event){return _this2.tryLogin(event);},value:this.state.password}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-login',onClick:function onClick(e){return _this2.login();}},loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Loader__["a" /* default */],null),!loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Accedi')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'log-response'},error!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,error)),valid&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Redirect */],{to:'/dashboard'})));}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{callLogin:__WEBPACK_IMPORTED_MODULE_2__actions_Auth__["e" /* callLogin */]})(Login));

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Loader=function(_Component){_inherits(Loader,_Component);function Loader(){_classCallCheck(this,Loader);return _possibleConstructorReturn(this,(Loader.__proto__||Object.getPrototypeOf(Loader)).apply(this,arguments));}_createClass(Loader,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader '+(this.props.color!==''?this.props.color:'')});}}]);return Loader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Attendances__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_Members__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_Courses__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DualRing__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AjaxSpinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Error__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Attendances_Calendar__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Attendances_MemberItem__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__options_json__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__options_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__options_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={search:'',search_course:'',selected:null,search_member_type:'',selectedName:null};var Attendances=function(_Component){_inherits(Attendances,_Component);function Attendances(){_classCallCheck(this,Attendances);var _this=_possibleConstructorReturn(this,(Attendances.__proto__||Object.getPrototypeOf(Attendances)).call(this));_this.state=initialState;_this.showCalendar=_this.showCalendar.bind(_this);_this.closeCalendar=_this.closeCalendar.bind(_this);return _this;}_createClass(Attendances,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.members.list===null){this.props.loadMembers();}if(this.props.courses.list===null){this.props.loadCourses();}}},{key:'reloadmembers',value:function reloadmembers(){this.setState({selected:null});this.props.loadMembers();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){// const m = this.props.members.list
// if (this.state.selected === null && m !== null && m.length > 0) {
//   this.setState({ selected: m[0].id })
// }
if(prevState.selected!==this.state.selected&&this.state.selected!==null){this.props.loadAttendances(this.state.selected);}if(prevProps.fiscalyear.current!==this.props.fiscalyear.current){this.setState({selected:null});}// if (prevState.search_course !== this.state.search_course) {
//   this.setState({ selected: null })
// }
// if (prevProps.receipts.ajaxSpinner && (!this.props.receipts.ajaxSpinner && this.props.receipts.ajaxStatus === null)) {
//   this.hideModal()
// }
// if (prevProps.receipts.ajaxSpinner && (!this.props.receipts.ajaxSpinner && this.props.receipts.ajaxStatus !== null)) {
//   setTimeout(() => { this.props.clearAjaxCall('') }, 3000)
// }
}},{key:'closeCalendar',value:function closeCalendar(){this.setState({selected:null});}},{key:'showCalendar',value:function showCalendar(m){this.setState({selected:m.id,selectedName:m.name_surname});}},{key:'filterList',value:function filterList(list){var _this2=this;if(list===null){return null;}return list.filter(function(item){return _this2.state.search_member_type===''?true:item.active.toString()===_this2.state.search_member_type;}).filter(function(item){return _this2.state.search_course===''?true:item.course_id.toString()===_this2.state.search_course;}).filter(function(el){return el.name_surname.toLowerCase().indexOf(_this2.state.search.toLowerCase())>=0||el.email.toLowerCase().indexOf(_this2.state.search.toLowerCase())>=0||el.fiscal_code.toLowerCase().indexOf(_this2.state.search.toLowerCase())>=0;});}},{key:'render',value:function render(){var _this3=this;var _props$members=this.props.members,list=_props$members.list,error=_props$members.error,loading=_props$members.loading;var _props$attendances=this.props.attendances,dates=_props$attendances.dates,ajaxSpinner=_props$attendances.ajaxSpinner;var filteredList=this.filterList(list);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-title'},'Presenze'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-descr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ul-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Cerca anagrafiche',onChange:function onChange(event){return _this3.setState({search:event.target.value,selected:null});},value:this.state.search})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this3.setState({search_course:event.target.value,selected:null});},value:this.state.search_course},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Tutti i corsi'),this.props.courses.list!==null&&this.props.courses.list.map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:o.id},o.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this3.setState({search_member_type:event.target.value});},value:this.state.search_member_type},__WEBPACK_IMPORTED_MODULE_10__options_json__["memberTypes"].map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:o.value},o.label);}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ph-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3.reloadmembers();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-redo-alt'}),' ricarica'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-count'},filteredList!==null&&filteredList.length+(filteredList.length===1?' risultato':' risultati'),filteredList===null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-sync fa-spin'}))),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DualRing__["a" /* default */],null),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Error__["a" /* default */],{error:error}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'att-container'},this.state.selected!==null&&!loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'att-calendar'},dates!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Attendances_Calendar__["a" /* default */],{dates:dates,selected:this.state.selected,selectedName:this.state.selectedName,closeCalendar:this.closeCalendar}),dates===null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DualRing__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'att-list'},list!==null&&filteredList.map(function(m,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Attendances_MemberItem__["a" /* default */],{key:index,selected:_this3.state.selected,showCalendar:_this3.showCalendar,member:m});}))),ajaxSpinner&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AjaxSpinner__["a" /* default */],null));}}]);return Attendances;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{loadMembers:__WEBPACK_IMPORTED_MODULE_3__actions_Members__["s" /* loadMembers */],loadCourses:__WEBPACK_IMPORTED_MODULE_4__actions_Courses__["l" /* loadCourses */],loadAttendances:__WEBPACK_IMPORTED_MODULE_2__actions_Attendances__["h" /* loadAttendances */]})(Attendances));

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_Attendances__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_Members__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={grid:null,start_month:null,action:true,max:null,min:null,presenceCounter:null,course_id:null,course_color:null};var start=null;var wd=['L','M','M','G','V','S','D'];var Calendar=function(_Component){_inherits(Calendar,_Component);function Calendar(){_classCallCheck(this,Calendar);var _this=_possibleConstructorReturn(this,(Calendar.__proto__||Object.getPrototypeOf(Calendar)).call(this));_this.state=initialState;return _this;}_createClass(Calendar,[{key:'changeMonth',value:function changeMonth(n){if(n===0){this.setState({start_month:start});}else{var nm=__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(this.state.start_month).utc().add(n,'months').startOf('month').startOf('day').unix();//.utc().unix()
this.setState({start_month:nm});}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevState.start_month!==this.state.start_month){this.popolateGrid();}if(prevProps.attendances.ajaxSpinner&&!this.props.attendances.ajaxSpinner&&this.props.attendances.ajaxStatus===null){this.popolateGrid();}if(prevState.course_id!==this.state.course_id){this.popolateGrid();}}},{key:'popolateGrid',value:function popolateGrid(){var currentMonth=__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(this.state.start_month).utc();// console.log(currentMonth.startOf('month').unix())
var grid=[];var dates=this.props.dates;var presenceCounter=0;var lastPaid=0;for(var x=0;x<dates.length;x++){// if (dates[x].present === 1) {
if(dates[x].present===1){// && dates[x].course_id === this.state.course_id
presenceCounter++;}if(dates[x].paid===1){lastPaid=dates[x].emission_date;}}var courses=[];this.props.courses.list.forEach(function(obj){courses[obj.id]=obj;});for(var m=0;m<3;m++){var count=0;var sc=currentMonth.isoWeekday();var spacer=[];for(var s=1;s<sc;s++){count++;spacer.push(s);}var days=[];var _loop=function _loop(d){count++;var epoch=__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(currentMonth.unix()).add(d-1,'days').utc().startOf('day').unix();exists=dates.filter(function(obj){return obj.emission_date===epoch;});var paid=0;var present=0;var css='';if(exists.length>0){paid=exists[0].paid;present=exists[0].present;if(paid===1){css+=' paid '+courses[exists[0].course_id].color;}if(present===1){css+=' present x'+courses[exists[0].course_id].color;}if(present===1&&paid===0){css+=' alert';}if(__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc().startOf('day').unix()===epoch){css+=' today';}}days.push({number:d,epoch:epoch,css:css,paid:paid,present:present});};for(var d=1;d<=currentMonth.daysInMonth();d++){var exists;_loop(d);}var after=[];var hm=count%7-7;if(hm<7){hm=hm*-1;}if(hm===7){hm=0;}for(var _s=0;_s<hm;_s++){after.push(_s);}var month={label:currentMonth.format('MMMM YYYY'),spacer:spacer,days:days,after:after// if (currentMonth.unix() <= this.state.max) {
};grid.push(month);// }
currentMonth.add(1,'month');}this.setState({grid:grid,presenceCounter:presenceCounter});this.props.setMemberLastPaid({id:this.props.selected,last_paid:lastPaid});}},{key:'saveAction',value:function saveAction(d){var a={account_holder:this.props.selected,emission_date:d.epoch,paid:d.paid,present:d.present,course_id:this.state.course_id};if(this.state.action){a.present=a.present===1?0:1;}else{a.paid=a.paid===1?0:1;}this.props.saveAttendances(a);}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;// set start calendar
var today=__WEBPACK_IMPORTED_MODULE_2_moment___default()().utc().startOf('month').startOf('day').unix();var fy=this.props.fiscalyear;var cur=fy.list.filter(function(obj){return obj.id===fy.current;})[0];if(today>cur.end_date){start=cur.end_date;}else if(today<cur.start_date){start=cur.start_date;}else{start=today;}// set course id
var c=this.props.courses.list;var dow=__WEBPACK_IMPORTED_MODULE_2_moment___default()().utc().day();var cid=0;var color='';c.forEach(function(obj){obj.schedule_list.forEach(function(o){if(o.day_of_week===dow){cid=obj.id;color=obj.color;}});});if(cid===0&&c.length>0){cid=c[0].id;color=c[0].color;}if(this.props.courses.list){var course=this.props.courses.list.find(function(obj){return obj.schedule_list.some(function(o){return o.instructorid===_this2.props.auth.user.userid&&o.day_of_week===dow;});});if(course){cid=course.id;color=course.color;}}// set state
this.setState({start_month:start,min:cur.start_date,max:cur.end_date,course_id:cid,course_color:color});this.end.scrollIntoView({behavior:'smooth'});// this.popolateGrid()
}},{key:'changeCourse',value:function changeCourse(event){var val=parseInt(event.target.value,10);var course=this.props.courses.list.filter(function(obj){return obj.id===val;})[0];this.setState({course_id:val,course_color:course.color});// this.popolateGrid()
}},{key:'render',value:function render(){var _this3=this;var grid=this.state.grid;var courses=this.props.courses.list;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'att-grid',ref:function ref(el){_this3.end=el;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-cal',onClick:function onClick(){return _this3.props.closeCalendar();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-times'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.props.selectedName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Presenze totali: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.state.presenceCounter)),// (this.state.action && this.state.course_id !== null) && (
this.state.course_id!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'att-course'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Corso',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this3.changeCourse(event);},value:this.state.course_id},courses!==null&&courses.map(function(m,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:m.id},m.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'att-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'att-action'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'switch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(event){return _this3.setState({action:event.target.checked});},checked:this.state.action,value:this.state.action}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slider round'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sl-txt'},this.state.action&&'Gestisci presenze',!this.state.action&&'Gestisci pagamenti'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'att-move'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3.changeMonth(-1);},className:'lnk-cal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-arrow-left'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3.changeMonth(0);},className:'lnk-cal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3.changeMonth(1);},className:'lnk-cal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-arrow-right'})))),grid!==null&&grid.map(function(m,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'month'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'label'},m.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'days'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'day-labels'},wd.map(function(d,i2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'day-name',key:i2},d);})),m.spacer.map(function(d,i2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spacer',key:i2});}),m.days.map(function(d,i2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'day '+d.css,key:i2,onClick:function onClick(){return _this3.saveAction(d);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,d.number));}),m.after.map(function(d,i2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'spacer',key:i2});})));}));}}]);return Calendar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{saveAttendances:__WEBPACK_IMPORTED_MODULE_3__actions_Attendances__["i" /* saveAttendances */],setMemberLastPaid:__WEBPACK_IMPORTED_MODULE_4__actions_Members__["v" /* setMemberLastPaid */]})(Calendar));

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var today=__WEBPACK_IMPORTED_MODULE_1_moment___default()().utc().startOf('day').unix();var MemberItem=function(_Component){_inherits(MemberItem,_Component);function MemberItem(){_classCallCheck(this,MemberItem);return _possibleConstructorReturn(this,(MemberItem.__proto__||Object.getPrototypeOf(MemberItem)).apply(this,arguments));}_createClass(MemberItem,[{key:'cssClass',value:function cssClass(m,s){var unpaid=' unpaid';if(m.last_paid!==''){if(m.last_paid>=today){unpaid='';}}return'row-item selectable '+m.course_color+(s===m.id?' selected':'')+unpaid;}},{key:'render',value:function render(){var _this2=this;var m=this.props.member;var s=this.props.selected;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:this.cssClass(m,s),onClick:function onClick(){return _this2.props.showCalendar(m);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'member-avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:m.avatar,alt:m.name+' '+m.surname,className:'avatar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Nome'),m.name,' ',m.surname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Et\xE0'),m.age),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Tshirt'),m.tshirt_size));}}]);return MemberItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MemberItem);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Balance__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_Courses__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DualRing__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Error__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AjaxSpinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Balance_BalanceDetails__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Balance_EditBalance__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Balance_DeleteBalance__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__options_json__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__options_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__options_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Utils_Service__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={showDelete:false,showEdit:false,balance:{},search:'',search_course:'',search_payment:''};var Balance=function(_Component){_inherits(Balance,_Component);function Balance(){_classCallCheck(this,Balance);var _this=_possibleConstructorReturn(this,(Balance.__proto__||Object.getPrototypeOf(Balance)).call(this));_this.showDelete=_this.showDelete.bind(_this);_this.showEdit=_this.showEdit.bind(_this);_this.hideModal=_this.hideModal.bind(_this);_this.escFunction=_this.escFunction.bind(_this);_this.state=initialState;return _this;}_createClass(Balance,[{key:'escFunction',value:function escFunction(event){if(event.keyCode===27){this.hideModal();}}},{key:'componentWillMount',value:function componentWillMount(){if(this.props.balance.list===null){this.reloadBalance();}if(this.props.courses.list===null){this.props.loadCourses();}}},{key:'showDelete',value:function showDelete(balance){this.setState({showDelete:true,balance:balance});}},{key:'showEdit',value:function showEdit(balance){this.setState({showEdit:true,balance:balance});}},{key:'newBalance',value:function newBalance(subscription){this.setState({showEdit:true,balance:{id:null,number:'',direction:0,emitter:'',amount:'',causal:'',emission_date:'',payment_mode:'',course_id:'',doc:'',doc_name:'',doc_delete:false,notes:'',checksum:''}});}},{key:'hideModal',value:function hideModal(){this.setState({showDelete:false,showEdit:false});}},{key:'reloadBalance',value:function reloadBalance(){this.props.loadBalance();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this2=this;if(prevProps.balance.ajaxSpinner&&!this.props.balance.ajaxSpinner&&this.props.balance.ajaxStatus===null){this.hideModal();}if(prevProps.balance.ajaxSpinner&&!this.props.balance.ajaxSpinner&&this.props.balance.ajaxStatus!==null){setTimeout(function(){_this2.props.clearAjaxCall('');},3000);}}},{key:'filterList',value:function filterList(list){var _this3=this;if(list===null){return null;}return list.filter(function(item){return _this3.state.search_course===''?true:item.course_id.toString()===_this3.state.search_course;}).filter(function(item){return _this3.state.search_payment===''?true:item.payment_mode.toString()===_this3.state.search_payment;}).filter(function(el){return el.number.toString().indexOf(_this3.state.search.toLowerCase())>=0||el.causal.toLowerCase().indexOf(_this3.state.search.toLowerCase())>=0;});}},{key:'trend',value:function trend(filteredList){if(filteredList===null){return null;}var grps=[{label:'Totale',total:0,sf:'z'}];filteredList.forEach(function(el){var index=grps.map(function(e){return e.label;}).indexOf(el.payment_mode);if(index<0){grps.push({label:el.payment_mode,total:0,sf:el.payment_mode[0]});index=grps.map(function(e){return e.label;}).indexOf(el.payment_mode);}grps[index].total+=el.direction===1?el.amount:-el.amount;grps[0].total+=el.direction===1?el.amount:-el.amount;});return grps.sort(function(a,b){return a.sf>b.sf?1:b.sf>a.sf?-1:0;});}},{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('keydown',this.escFunction,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('keydown',this.escFunction,false);}},{key:'render',value:function render(){var _this4=this;var _props$balance=this.props.balance,list=_props$balance.list,error=_props$balance.error,loading=_props$balance.loading,ajaxSpinner=_props$balance.ajaxSpinner,uploading=_props$balance.uploading;var filteredList=this.filterList(list);var trend=this.trend(filteredList);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-title'},'Bilancio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-descr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ul-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Cerca movimenti',onChange:function onChange(event){return _this4.setState({search:event.target.value});},value:this.state.search})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({search_course:event.target.value});},value:this.state.search_course},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Tutti i corsi'),this.props.courses.list!==null&&this.props.courses.list.map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:o.id},o.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({search_payment:event.target.value});},value:this.state.search_payment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Tutti i tipi di pagamento'),__WEBPACK_IMPORTED_MODULE_10__options_json__["paymentTypes"].map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:o.value},o.label);}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-trend'},trend!==null&&trend.map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:index,className:'trend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'group'},o.label,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:o.total>=0?'green':'red'},Object(__WEBPACK_IMPORTED_MODULE_11__Utils_Service__["money"])(o.total)));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ph-btn'},Object(__WEBPACK_IMPORTED_MODULE_11__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this4.newBalance();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-money-bill-wave'}),' aggiungi')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this4.reloadBalance();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-redo-alt'}),' ricarica'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-count'},filteredList!==null&&filteredList.length+(filteredList.length===1?' risultato':' risultati'),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-sync fa-spin'}))),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DualRing__["a" /* default */],null),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Error__["a" /* default */],{error:error}),filteredList!==null&&filteredList.sort(function(a,b){return b.emission_date-a.emission_date||b.id-a.id;}).map(function(b,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Balance_BalanceDetails__["a" /* default */],{key:index,balance:b,showDelete:_this4.showDelete,showEdit:_this4.showEdit});}),this.state.showEdit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Balance_EditBalance__["a" /* default */],{b:this.state.balance,hideModal:this.hideModal}),this.state.showDelete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Balance_DeleteBalance__["a" /* default */],{b:this.state.balance,hideModal:this.hideModal}),(ajaxSpinner||uploading)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AjaxSpinner__["a" /* default */],null));}}]);return Balance;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{loadBalance:__WEBPACK_IMPORTED_MODULE_2__actions_Balance__["n" /* loadBalance */],saveBalance:__WEBPACK_IMPORTED_MODULE_2__actions_Balance__["o" /* saveBalance */],deleteBalance:__WEBPACK_IMPORTED_MODULE_2__actions_Balance__["m" /* deleteBalance */],loadCourses:__WEBPACK_IMPORTED_MODULE_3__actions_Courses__["l" /* loadCourses */],clearAjaxCall:__WEBPACK_IMPORTED_MODULE_2__actions_Balance__["l" /* clearAjaxCall */]})(Balance));

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__environment__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BalanceDetails=function(_PureComponent){_inherits(BalanceDetails,_PureComponent);function BalanceDetails(){_classCallCheck(this,BalanceDetails);return _possibleConstructorReturn(this,(BalanceDetails.__proto__||Object.getPrototypeOf(BalanceDetails)).apply(this,arguments));}_createClass(BalanceDetails,[{key:'render',value:function render(){var _this2=this;var b=this.props.balance;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'row-item '+b.color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Data'),__WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(b.emission_date).format('ll')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,!b.editable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Intestata a'),b.editable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Emessa da'),b.emitter),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'causale'),b.causal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'info-amount '+(b.direction===0?'red':'green')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Importo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__["money"])(b.amount),' ',b.payment_mode.toLowerCase()==='banca'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-university'}),b.payment_mode.toLowerCase()==='contanti'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-money-bill-wave'}),b.payment_mode.toLowerCase()==='paypal'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-paypal'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'info-buttons'},!b.editable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__["generateUrl"])(__WEBPACK_IMPORTED_MODULE_3__environment__["a" /* ENV */].production,__WEBPACK_IMPORTED_MODULE_2__Uris__["a" /* URIS */].pdf,b.id,b.checksum),className:'lnk-edits',target:'_blank',title:'Ricevuta'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-file-pdf'})),b.editable&&b.checksum!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__["generateUrl"])(__WEBPACK_IMPORTED_MODULE_3__environment__["a" /* ENV */].production,__WEBPACK_IMPORTED_MODULE_2__Uris__["a" /* URIS */].doc,b.id,b.checksum),className:'lnk-edits',target:'_blank',title:'Fattura'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-file-alt'})),b.editable&&Object(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-edits',onClick:function onClick(){return _this2.props.showEdit(b);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-edit'})),b.editable&&Object(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-edits',onClick:function onClick(){return _this2.props.showDelete(b);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-trash-alt'}))));}}]);return BalanceDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (BalanceDetails);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_Balance__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__options_json__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__options_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__options_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditReceipt=function(_Component){_inherits(EditReceipt,_Component);function EditReceipt(){_classCallCheck(this,EditReceipt);var _this=_possibleConstructorReturn(this,(EditReceipt.__proto__||Object.getPrototypeOf(EditReceipt)).call(this));_this._handleImageChange=_this._handleImageChange.bind(_this);return _this;}_createClass(EditReceipt,[{key:'saveBalance',value:function saveBalance(){var _this2=this;var b=this.state;if(b.amount===''){this.props.saveBalanceFailure('Verificare i dati immessi');setTimeout(function(){_this2.props.clearAjaxCall('');},3000);}else{this.props.saveBalance({id:b.id,number:b.number,direction:b.direction,emitter:b.emitter,amount:b.amount,causal:b.causal,emission_date:b.emission_date!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(b.emission_date).startOf('day').unix():'',payment_mode:b.payment_mode!==''?b.payment_mode:__WEBPACK_IMPORTED_MODULE_5__options_json__["paymentTypes"][0].value,course_id:b.course_id,doc:b.doc,doc_name:b.doc_name,doc_delete:b.doc_delete,notes:b.notes});}}},{key:'_handleImageChange',value:function _handleImageChange(e){var _this3=this;e.preventDefault();var reader=new window.FileReader();if(e.target.files.length>0){var file=e.target.files[0];this.props.startUpload();reader.onloadend=function(){_this3.setState({doc:reader.result,doc_name:file.name,doc_delete:true,doc_delete_lock:true});_this3.props.stopUpload();};reader.readAsDataURL(file);}else{this.setState({doc:'',doc_name:'',doc_delete:false,doc_delete_lock:false});}}},{key:'componentWillMount',value:function componentWillMount(){var b=this.props.b;this.setState({id:b.id,number:b.number,direction:b.direction,amount:b.amount,causal:b.causal,emitter:b.emitter,emission_date:b.emission_date!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(b.emission_date).format('YYYY-MM-DD'):__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),payment_mode:b.payment_mode,course_id:b.course_id,doc:'',doc_name:'',doc_delete:false,doc_delete_lock:false,checksum:b.checksum,notes:b.notes});}},{key:'render',value:function render(){var _this4=this;var ajaxStatus=this.props.balance.ajaxStatus;var list=this.props.courses.list;var b=this.state;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,b.id!==null?'Modifica':'Nuovo',' Movimento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-modal',onClick:function onClick(){return _this4.props.hideModal();},'aria-label':'Chiudi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Direzione',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({direction:event.target.value});},value:b.direction},__WEBPACK_IMPORTED_MODULE_5__options_json__["directionTypes"].map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:i.value},i.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Numero fattura \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',onChange:function onChange(event){return _this4.setState({number:event.target.value});},value:b.number})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Emessa da \xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',onChange:function onChange(event){return _this4.setState({emitter:event.target.value});},value:b.emitter})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Importo',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',placeholder:'Importo',onChange:function onChange(event){return _this4.setState({amount:event.target.value});},value:b.amount})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Corso',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({course_id:event.target.value});},value:b.course_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),list!==null&&list.map(function(m,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:m.id},m.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Causale',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Causale',onChange:function onChange(event){return _this4.setState({causal:event.target.value});},value:b.causal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Data emissione',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',placeholder:'Data emissione'// disabled={b.id !== null}
,onChange:function onChange(event){return _this4.setState({emission_date:event.target.value});},value:b.emission_date})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Modalit\xE0 pagamento',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({payment_mode:event.target.value});},value:b.payment_mode},__WEBPACK_IMPORTED_MODULE_5__options_json__["paymentTypes"].map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:i.value},i.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Allega documento',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',ref:function ref(_ref){return _this4.upload=_ref;},onChange:this._handleImageChange})),b.checksum!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'check-container'},'Elimina documento allegato precedentemente',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',disabled:b.doc_delete_lock?'disabled':'',onChange:function onChange(event){return _this4.setState({doc_delete:event.target.checked});},value:b.doc_delete,checked:b.doc_delete}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'checkmark'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Note',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Note',onChange:function onChange(event){return _this4.setState({notes:event.target.value});},value:b.notes})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submit-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ajax-error'},ajaxStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this4.props.hideModal();}},'annulla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this4.saveBalance();}},'salva'))));}}]);return EditReceipt;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{saveBalance:__WEBPACK_IMPORTED_MODULE_3__actions_Balance__["o" /* saveBalance */],saveBalanceFailure:__WEBPACK_IMPORTED_MODULE_3__actions_Balance__["p" /* saveBalanceFailure */],startUpload:__WEBPACK_IMPORTED_MODULE_3__actions_Balance__["q" /* startUpload */],stopUpload:__WEBPACK_IMPORTED_MODULE_3__actions_Balance__["r" /* stopUpload */],clearAjaxCall:__WEBPACK_IMPORTED_MODULE_3__actions_Balance__["l" /* clearAjaxCall */]})(EditReceipt));

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Utils_Service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_Balance__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteBalance=function(_Component){_inherits(DeleteBalance,_Component);function DeleteBalance(){_classCallCheck(this,DeleteBalance);return _possibleConstructorReturn(this,(DeleteBalance.__proto__||Object.getPrototypeOf(DeleteBalance)).apply(this,arguments));}_createClass(DeleteBalance,[{key:'deleteBalance',value:function deleteBalance(){this.props.deleteBalance({id:this.props.b.id});}},{key:'render',value:function render(){var _this2=this;var ajaxStatus=this.props.balance.ajaxStatus;var b=this.props.b;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Modal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Eliminare movimento'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-modal',onClick:function onClick(){return _this2.props.hideModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'delete-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Numero'),b.number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Emessa da'),b.emitter),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Data'),__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(b.emission_date).format('ll')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Importo'),Object(__WEBPACK_IMPORTED_MODULE_3__Utils_Service__["money"])(b.amount))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submit-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ajax-error'},ajaxStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.props.hideModal();}},'annulla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.deleteBalance();}},'elimna'))));}}]);return DeleteBalance;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{deleteBalance:__WEBPACK_IMPORTED_MODULE_4__actions_Balance__["m" /* deleteBalance */]})(DeleteBalance));

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Courses__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_Instructors__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DualRing__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Error__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AjaxSpinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Courses_CoursesDetails__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Courses_EditCourse__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Courses_DeleteCourse__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Utils_Service__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={showDelete:false,showEdit:false,course:{}};var Courses=function(_Component){_inherits(Courses,_Component);function Courses(){_classCallCheck(this,Courses);var _this=_possibleConstructorReturn(this,(Courses.__proto__||Object.getPrototypeOf(Courses)).call(this));_this.showDelete=_this.showDelete.bind(_this);_this.showEdit=_this.showEdit.bind(_this);_this.hideModal=_this.hideModal.bind(_this);_this.escFunction=_this.escFunction.bind(_this);_this.state=initialState;return _this;}_createClass(Courses,[{key:'escFunction',value:function escFunction(event){if(event.keyCode===27){this.hideModal();}}},{key:'componentWillMount',value:function componentWillMount(){if(this.props.courses.list===null){this.reloadCourses();}if(this.props.instructors.list===null){this.props.loadInstructors();}}},{key:'showDelete',value:function showDelete(course){this.setState({showDelete:true,course:course});}},{key:'showEdit',value:function showEdit(course){this.setState({showEdit:true,course:Object.assign({},course,{start_time:'',end_time:''})});}},{key:'newCourse',value:function newCourse(){this.setState({showEdit:true,course:{id:null,name:'',color:'',day_of_week:'',instructorid:'',start_time:'',end_time:'',notes:'',schedule_list:[]}});}},{key:'hideModal',value:function hideModal(){this.setState({showDelete:false,showEdit:false});}},{key:'reloadCourses',value:function reloadCourses(){this.props.loadCourses();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this2=this;if(prevProps.courses.ajaxSpinner&&!this.props.courses.ajaxSpinner&&this.props.courses.ajaxStatus===null){this.hideModal();}if(prevProps.courses.ajaxSpinner&&!this.props.courses.ajaxSpinner&&this.props.courses.ajaxStatus!==null){setTimeout(function(){_this2.props.clearAjaxCall('');},3000);}}},{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('keydown',this.escFunction,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('keydown',this.escFunction,false);}},{key:'render',value:function render(){var _this3=this;var _props$courses=this.props.courses,list=_props$courses.list,error=_props$courses.error,loading=_props$courses.loading,ajaxSpinner=_props$courses.ajaxSpinner;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-title'},'Corsi'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-descr txt'},'Assegna un colore ad ogni corso in modo da rendere pi\xF9 facile indentificare iscritti e ricevute.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ph-btn'},Object(__WEBPACK_IMPORTED_MODULE_10__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3.newCourse();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-clipboard'}),' aggiungi')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3.reloadCourses();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-redo-alt'}),' ricarica'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-count'},list!==null&&list.length+(list.length===1?' risultato':' risultati'),list===null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-sync fa-spin'}))),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DualRing__["a" /* default */],null),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Error__["a" /* default */],{error:error}),list!==null&&list.map(function(c,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Courses_CoursesDetails__["a" /* default */],{key:index,course:c,showDelete:_this3.showDelete,showEdit:_this3.showEdit});}),this.state.showEdit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Courses_EditCourse__["a" /* default */],{course:this.state.course,hideModal:this.hideModal}),this.state.showDelete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Courses_DeleteCourse__["a" /* default */],{course:this.state.course,hideModal:this.hideModal}),ajaxSpinner&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AjaxSpinner__["a" /* default */],null));}}]);return Courses;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{loadCourses:__WEBPACK_IMPORTED_MODULE_2__actions_Courses__["l" /* loadCourses */],saveCourses:__WEBPACK_IMPORTED_MODULE_2__actions_Courses__["m" /* saveCourses */],deleteCourses:__WEBPACK_IMPORTED_MODULE_2__actions_Courses__["k" /* deleteCourses */],loadInstructors:__WEBPACK_IMPORTED_MODULE_3__actions_Instructors__["l" /* loadInstructors */],clearAjaxCall:__WEBPACK_IMPORTED_MODULE_2__actions_Courses__["j" /* clearAjaxCall */]})(Courses));

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Utils_Service__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoursesDetails=function(_PureComponent){_inherits(CoursesDetails,_PureComponent);function CoursesDetails(){_classCallCheck(this,CoursesDetails);return _possibleConstructorReturn(this,(CoursesDetails.__proto__||Object.getPrototypeOf(CoursesDetails)).apply(this,arguments));}_createClass(CoursesDetails,[{key:'render',value:function render(){var _this2=this;var c=this.props.course;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'row-item '+c.color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Nome'),c.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'info-buttons'},Object(__WEBPACK_IMPORTED_MODULE_1__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-edits',onClick:function onClick(){return _this2.props.showEdit(c);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-edit'})),Object(__WEBPACK_IMPORTED_MODULE_1__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-edits',onClick:function onClick(){return _this2.props.showDelete(c);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-trash-alt'}))));}}]);return CoursesDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (CoursesDetails);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Courses__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var days=['Lunedì','Martedì','Mercoledì','Giovedì','Venerdì','Sabato','Domenica'];var colors=[{value:'orange',name:'Arancione'},{value:'deep-orange',name:'Arancione scuro'},{value:'amber',name:'Ambra'},{value:'brown',name:'Marrone'},{value:'blue-grey',name:'Blu grigio'},{value:'blue',name:'Blu'},{value:'light-blue',name:'Blu chiaro'},{value:'yellow',name:'Giallo'},{value:'lime',name:'Lime'},{value:'cyan',name:'Ciano'},{value:'purple',name:'Porpora'},{value:'deep-purple',name:'Viola scuro'},{value:'indigo',name:'Indaco'},{value:'pink',name:'Rosa'},{value:'red',name:'Rosso'},{value:'green',name:'Verde'},{value:'light-green',name:'Verde chiaro'},{value:'teal',name:'Verde acqua'}];var EditCourse=function(_Component){_inherits(EditCourse,_Component);function EditCourse(){_classCallCheck(this,EditCourse);return _possibleConstructorReturn(this,(EditCourse.__proto__||Object.getPrototypeOf(EditCourse)).apply(this,arguments));}_createClass(EditCourse,[{key:'saveCourses',value:function saveCourses(){this.props.saveCourses(this.state);}},{key:'addSchedule',value:function addSchedule(){if(this.state.day_of_week!==''&&this.state.instructorid!==''&&this.state.start_time!==''&&this.state.end_time!==''){this.setState({schedule_list:this.state.schedule_list.concat({day_of_week:this.state.day_of_week,day_name:days[this.state.day_of_week-1],instructorid:this.props.instructors.list[this.state.instructorid].id,instructor_name:this.props.instructors.list[this.state.instructorid].name,start_time:this.state.start_time,end_time:this.state.end_time}),day_of_week:'',instructorid:'',start_time:'',end_time:''});}}},{key:'removeSchedule',value:function removeSchedule(index){this.setState({schedule_list:this.state.schedule_list.filter(function(i,ind){return ind!==index;})});}},{key:'componentWillMount',value:function componentWillMount(){var i=this.props.course;var rnd=Math.floor(Math.random()*colors.length);this.setState({id:i.id,name:i.name,color:i.id===null?colors[rnd].value:i.color,day_of_week:i.day_of_week,instructorid:i.instructorid,start_time:i.start_time,end_time:i.end_time,notes:i.notes,schedule_list:i.schedule_list});}},{key:'render',value:function render(){var _this2=this;var ajaxStatus=this.props.courses.ajaxStatus;var c=this.state;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,c.id!==null?'Modifica':'Aggiungi',' corso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-modal',onClick:function onClick(){return _this2.props.hideModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Nome',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Nome',onChange:function onChange(event){return _this2.setState({name:event.target.value});},value:c.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Colore',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this2.setState({color:event.target.value});},value:c.color},colors.map(function(c,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:c.value},c.name);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cc-prev '+this.state.color})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Note',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Note',onChange:function onChange(event){return _this2.setState({notes:event.target.value});},value:c.notes})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'aggiungi Programmazione'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'course-schedule'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'schedule-day'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Giorno',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this2.setState({day_of_week:event.target.value});},value:c.day_of_week},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Luned\xEC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'2'},'Marted\xEC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'3'},'Mercoled\xEC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'4'},'Gioved\xEC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'5'},'Venerd\xEC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'6'},'Sabato'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'7'},'Domenica')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'schedule-instructor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Istruttore',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this2.setState({instructorid:event.target.value});},value:c.instructorid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),this.props.instructors.list!==null&&this.props.instructors.list.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:index},i.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'schedule-time'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Ora inizio',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'time',placeholder:'Ora inizio',onChange:function onChange(event){return _this2.setState({start_time:event.target.value});},value:c.start_time}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'schedule-time'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Ora fine',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'time',placeholder:'Ora fine',onChange:function onChange(event){return _this2.setState({end_time:event.target.value});},value:c.end_time}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'schedule-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.addSchedule();}},'aggiungi'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Programmazione'),c.schedule_list.map(function(s,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'schedule-view',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,s.day_name,' - ',s.instructor_name,' - ',s.start_time,'/',s.end_time),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.removeSchedule(index);}},'elimina')));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submit-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ajax-error'},ajaxStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.props.hideModal();}},'annulla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.saveCourses();}},'salva'))));}}]);return EditCourse;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{saveCourses:__WEBPACK_IMPORTED_MODULE_2__actions_Courses__["m" /* saveCourses */]})(EditCourse));

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Courses__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteCourse=function(_Component){_inherits(DeleteCourse,_Component);function DeleteCourse(){_classCallCheck(this,DeleteCourse);return _possibleConstructorReturn(this,(DeleteCourse.__proto__||Object.getPrototypeOf(DeleteCourse)).apply(this,arguments));}_createClass(DeleteCourse,[{key:'deleteCourses',value:function deleteCourses(){this.props.deleteCourses({id:this.props.course.id});}},{key:'render',value:function render(){var _this2=this;var ajaxStatus=this.props.courses.ajaxStatus;var c=this.props.course;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Eliminare corso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-modal',onClick:function onClick(){return _this2.props.hideModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})),c.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submit-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ajax-error'},ajaxStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.props.hideModal();}},'annulla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.deleteCourses();}},'elimna'))));}}]);return DeleteCourse;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{deleteCourses:__WEBPACK_IMPORTED_MODULE_2__actions_Courses__["k" /* deleteCourses */]})(DeleteCourse));

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Members__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_Courses__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DualRing__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AjaxSpinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Error__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Members_MemberDetails__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Members_EditMember__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Members_DeleteMember__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__options_json__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__options_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__options_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Utils_Service__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={showDelete:false,showEdit:false,member:{},search:'',search_member_type:'',search_sex_type:'',search_tshirt_size:'',search_course:'',expanded:false};var Members=function(_Component){_inherits(Members,_Component);function Members(props){_classCallCheck(this,Members);var _this=_possibleConstructorReturn(this,(Members.__proto__||Object.getPrototypeOf(Members)).call(this,props));_this.showDelete=_this.showDelete.bind(_this);_this.showEdit=_this.showEdit.bind(_this);_this.hideModal=_this.hideModal.bind(_this);_this.escFunction=_this.escFunction.bind(_this);_this.state=initialState;return _this;}_createClass(Members,[{key:'escFunction',value:function escFunction(event){if(event.keyCode===27){this.hideModal();}}},{key:'componentWillMount',value:function componentWillMount(){if(this.props.members.list===null){this.props.loadMembers();}if(this.props.courses.list===null){this.props.loadCourses();}}},{key:'showDelete',value:function showDelete(member){this.setState({showDelete:true,member:member});}},{key:'showEdit',value:function showEdit(member){this.setState({showEdit:true,member:member});}},{key:'newMember',value:function newMember(){this.setState({showEdit:true,member:{id:null,name:'',surname:'',sex:'',email:'',postal_code:'',city:'',address:'',country:'',born_date:'',age:'',born_city:'',born_country:'',fiscal_code:'',tutor_id:'',tshirt_size:'',phone:'',mobile:'',notes:'',course_id:'',insurance_date:'',medical_certificate:'',medical_certificate_doc:'',doc_name:'',medical_certificate_checksum:'',title:''}});}},{key:'hideModal',value:function hideModal(){this.setState({showDelete:false,showEdit:false});}},{key:'reloadmembers',value:function reloadmembers(){this.props.loadMembers();}},{key:'expand',value:function expand(){this.setState({expanded:!this.state.expanded});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this2=this;if(prevProps.members.ajaxSpinner&&!this.props.members.ajaxSpinner&&this.props.members.ajaxStatus===null){this.hideModal();}if(prevProps.members.ajaxSpinner&&!this.props.members.ajaxSpinner&&this.props.members.ajaxStatus!==null){setTimeout(function(){_this2.props.clearAjaxCall('');},3000);}}},{key:'filterList',value:function filterList(list){var _this3=this;if(list===null){return null;}return list.filter(function(item){return _this3.state.search_member_type===''?true:item.active.toString()===_this3.state.search_member_type;}).filter(function(item){return _this3.state.search_sex_type===''?true:item.sex===_this3.state.search_sex_type;}).filter(function(item){return _this3.state.search_tshirt_size===''?true:item.tshirt_size===_this3.state.search_tshirt_size;}).filter(function(item){return _this3.state.search_course===''?true:item.course_id.toString()===_this3.state.search_course;}).filter(function(el){return el.name_surname.toLowerCase().indexOf(_this3.state.search.toLowerCase())>=0||el.email.toLowerCase().indexOf(_this3.state.search.toLowerCase())>=0||el.fiscal_code.toLowerCase().indexOf(_this3.state.search.toLowerCase())>=0;});}},{key:'export',value:function _export(){var s=this.state;this.props.loadExportMembers({search:s.search,search_member_type:s.search_member_type,search_sex_type:s.search_sex_type,search_tshirt_size:s.search_tshirt_size,search_course:s.search_course});}},{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('keydown',this.escFunction,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('keydown',this.escFunction,false);}},{key:'render',value:function render(){var _this4=this;var _props$members=this.props.members,list=_props$members.list,error=_props$members.error,loading=_props$members.loading,ajaxSpinner=_props$members.ajaxSpinner,uploading=_props$members.uploading;var filteredList=this.filterList(list);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-title'},'Anagrafiche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-descr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ul-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Cerca anagrafiche',onChange:function onChange(event){return _this4.setState({search:event.target.value});},value:this.state.search})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({search_member_type:event.target.value});},value:this.state.search_member_type},__WEBPACK_IMPORTED_MODULE_10__options_json__["memberTypes"].map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:o.value},o.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({search_sex_type:event.target.value});},value:this.state.search_sex_type},__WEBPACK_IMPORTED_MODULE_10__options_json__["sexTypes"].filter(function(item){return item.search||item.search===undefined;}).map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:o.value},o.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({search_tshirt_size:event.target.value});},value:this.state.search_tshirt_size},__WEBPACK_IMPORTED_MODULE_10__options_json__["tshirtSizes"].filter(function(item){return item.search||item.search===undefined;}).map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:o.value},o.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({search_course:event.target.value});},value:this.state.search_course},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Tutti i corsi'),this.props.courses.list!==null&&this.props.courses.list.map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:o.id},o.name);}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ph-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this4.export();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-file-export'}),' esporta')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this4.expand();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-info-circle'}),' ',this.state.expanded?'Nascondi':'Visualizza',' dettagli')),Object(__WEBPACK_IMPORTED_MODULE_11__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this4.newMember();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-user-plus'}),' aggiungi')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this4.reloadmembers();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-redo-alt'}),' ricarica'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-count'},filteredList!==null&&filteredList.length+(filteredList.length===1?' risultato':' risultati'),filteredList===null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-sync fa-spin'}))),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DualRing__["a" /* default */],null),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Error__["a" /* default */],{error:error}),list!==null&&filteredList.sort(function(a,b){return a.surname>b.surname?1:b.surname>a.surname?-1:0;}).map(function(m,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Members_MemberDetails__["a" /* default */],{key:index,member:m,expanded:_this4.state.expanded,showDelete:_this4.showDelete,showEdit:_this4.showEdit});}),this.state.showEdit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Members_EditMember__["a" /* default */],{member:this.state.member,hideModal:this.hideModal}),this.state.showDelete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Members_DeleteMember__["a" /* default */],{member:this.state.member,hideModal:this.hideModal}),(ajaxSpinner||uploading)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AjaxSpinner__["a" /* default */],null));}}]);return Members;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{loadMembers:__WEBPACK_IMPORTED_MODULE_2__actions_Members__["s" /* loadMembers */],saveMembers:__WEBPACK_IMPORTED_MODULE_2__actions_Members__["t" /* saveMembers */],deleteMembers:__WEBPACK_IMPORTED_MODULE_2__actions_Members__["q" /* deleteMembers */],loadCourses:__WEBPACK_IMPORTED_MODULE_3__actions_Courses__["l" /* loadCourses */],clearAjaxCall:__WEBPACK_IMPORTED_MODULE_2__actions_Members__["p" /* clearAjaxCall */],loadExportMembers:__WEBPACK_IMPORTED_MODULE_2__actions_Members__["r" /* loadExportMembers */]})(Members));

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__environment__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MemberDetails=function(_PureComponent){_inherits(MemberDetails,_PureComponent);function MemberDetails(){_classCallCheck(this,MemberDetails);return _possibleConstructorReturn(this,(MemberDetails.__proto__||Object.getPrototypeOf(MemberDetails)).apply(this,arguments));}_createClass(MemberDetails,[{key:'render',value:function render(){var _this2=this;var m=this.props.member;var expanded=this.props.expanded;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'member-item '+m.course_color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'member-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'member-avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:m.avatar,alt:'usr',className:'avatar'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'member-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Cognome Nome'),m.surname,' ',m.name,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'member-status '+(m.active?'green':'red')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-circle'}),'Socio Attivo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'member-status '+(m.insurance_active?'green':'red')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-circle'}),'Assicurazione'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'member-status '+(m.medical_certificate_valid?'green':'red')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-circle'}),'Certificato medico ',m.medical_certificate_valid),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'info-buttons'},m.medical_certificate_checksum!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__["generateUrl"])(__WEBPACK_IMPORTED_MODULE_3__environment__["a" /* ENV */].production,__WEBPACK_IMPORTED_MODULE_2__Uris__["a" /* URIS */].doc,m.id,m.medical_certificate_checksum),className:'lnk-edits',target:'_blank',title:'Certificato medico'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-file-alt'})),Object(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-edits',onClick:function onClick(){return _this2.props.showEdit(m);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-edit'})),Object(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-edits',onClick:function onClick(){return _this2.props.showDelete(m);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-trash-alt'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'member-body '+(expanded?'expanded':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Codice fiscale'),m.fiscal_code,'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Data di nascita'),m.born_date!==''?__WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(m.born_date).format('ll'):'','\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Et\xE0'),m.age,'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Tshirt'),m.tshirt_size,'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Qualifica'),m.title,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Corso'),m.course_name,'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Email'),m.email,'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Cellulare'),m.mobile,'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Telefono'),m.phone,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Indirizzo'),m.address,'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Citt\xE0'),m.city,'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Provincia'),m.country,'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Tutore legale'),m.tutor_name,'\xA0')));}}]);return MemberDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (MemberDetails);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_Members__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cities_json__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cities_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__cities_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__geo_json__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__geo_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__geo_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__options_json__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__options_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__options_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditMember=function(_Component){_inherits(EditMember,_Component);function EditMember(){_classCallCheck(this,EditMember);var _this=_possibleConstructorReturn(this,(EditMember.__proto__||Object.getPrototypeOf(EditMember)).call(this));_this._handleImageChange=_this._handleImageChange.bind(_this);_this._handleAvatarChange=_this._handleAvatarChange.bind(_this);_this._handleBlur=_this._handleBlur.bind(_this);return _this;}_createClass(EditMember,[{key:'saveMembers',value:function saveMembers(){var _this2=this;var m=this.state;if(m.name!==''&&m.surname!==''&&m.address!==''&&m.city!==''&&m.postal_code!==''&&m.country!==''&&m.fiscal_code!==''&&m.born_date!==''&&m.title!==''&&m.sex!==''&&m.born_city!==''&&m.course_id!==''){if(m.age<18&&m.tutor_id===''){this.props.saveMembersFailure('Assegnare tutore legale');setTimeout(function(){_this2.props.clearAjaxCall('');},3000);}else{this.props.saveMembers({id:m.id,name:m.name,surname:m.surname,sex:m.sex,email:m.email,postal_code:m.postal_code,city:m.city,address:m.address,country:m.country,born_date:m.born_date!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(m.born_date).startOf('day').unix():'',born_city:m.born_city,born_country:m.born_country,fiscal_code:m.fiscal_code,tutor_id:m.tutor_id,tshirt_size:m.tshirt_size,phone:m.phone,mobile:m.mobile,notes:m.notes,course_id:m.course_id,insurance_date:m.insurance_date!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(m.insurance_date).startOf('day').unix():'',medical_certificate:m.medical_certificate!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(m.medical_certificate).startOf('day').unix():'',doc:m.doc,doc_name:m.doc_name,doc_delete:m.doc_delete,avatar:m.avatar,title:m.title});}}else{this.props.saveMembersFailure('Verificare i dati obbligatori');setTimeout(function(){_this2.props.clearAjaxCall('');},3000);}}},{key:'_handleAvatarChange',value:function _handleAvatarChange(e){var _this3=this;e.preventDefault();var reader=new window.FileReader();if(e.target.files.length>0){var file=e.target.files[0];this.props.startUpload();reader.onloadend=function(){_this3.setState({avatar:reader.result});_this3.props.stopUpload();};reader.readAsDataURL(file);}else{this.setState({avatar:''});}}},{key:'_handleImageChange',value:function _handleImageChange(e){var _this4=this;e.preventDefault();var reader=new window.FileReader();if(e.target.files.length>0){var file=e.target.files[0];this.props.startUpload();reader.onloadend=function(){_this4.setState({doc:reader.result,doc_name:file.name,doc_delete:true,doc_delete_lock:true});_this4.props.stopUpload();};reader.readAsDataURL(file);}else{this.setState({doc:'',doc_delete:false,doc_name:'',doc_delete_lock:false});}}},{key:'_handleCityChange',value:function _handleCityChange(event){var city=__WEBPACK_IMPORTED_MODULE_5__cities_json___default.a.find(function(c){return c.nome===event.target.value;});this.setState({city:event.target.value,country:city.district});}},{key:'_handleBornCityChange',value:function _handleBornCityChange(event){var city=__WEBPACK_IMPORTED_MODULE_5__cities_json___default.a.find(function(c){return c.nome===event.target.value;});this.setState({born_city:event.target.value,born_country:city.district});}},{key:'componentWillMount',value:function componentWillMount(){var m=this.props.member;this.setState({id:m.id,name:m.name,surname:m.surname,sex:m.sex,email:m.email,postal_code:m.postal_code,city:m.city,address:m.address,country:m.country,born_date:m.born_date!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(m.born_date).format('YYYY-MM-DD'):'',age:m.age,born_city:m.born_city,born_country:m.born_country,fiscal_code:m.fiscal_code,tutor_id:m.tutor_id,tshirt_size:m.tshirt_size,phone:m.phone,mobile:m.mobile,notes:m.notes,course_id:m.course_id,insurance_date:m.insurance_date!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(m.insurance_date).format('YYYY-MM-DD'):'',medical_certificate:m.medical_certificate!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(m.medical_certificate).format('YYYY-MM-DD'):'',medical_certificate_doc:m.medical_certificate_doc,doc_name:'',medical_certificate_checksum:m.medical_certificate_checksum,doc_delete:false,doc_delete_lock:false,avatar:'',title:m.title});}},{key:'_handleBlur',value:function _handleBlur(){this.setState({age:__WEBPACK_IMPORTED_MODULE_2_moment___default()().diff(this.state.born_date,'years')});}},{key:'render',value:function render(){var _this5=this;var _props$members=this.props.members,list=_props$members.list,ajaxStatus=_props$members.ajaxStatus;var m=this.state;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,m.id!==null?'Modifica':'Aggiungi',' anagrafica'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-modal',onClick:function onClick(){return _this5.props.hideModal();},'aria-label':'Chiudi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'first'},'Informazioni obbligatorie'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Nome',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Nome',onChange:function onChange(event){return _this5.setState({name:event.target.value});},value:m.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Cognome',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Cognome',onChange:function onChange(event){return _this5.setState({surname:event.target.value});},value:m.surname})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Indirizzo',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Indirizzo',onChange:function onChange(event){return _this5.setState({address:event.target.value});},value:m.address})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Citt\xE0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this5._handleCityChange(event);},value:m.city},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),__WEBPACK_IMPORTED_MODULE_5__cities_json___default.a.map(function(c,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:c.nome},c.nome);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'CAP',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this5.setState({postal_code:event.target.value});},value:this.state.postal_code,disabled:this.state.city===''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),((__WEBPACK_IMPORTED_MODULE_5__cities_json___default.a.find(function(x){return x.nome===_this5.state.city;})||[]).cap||[]).map(function(c,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:c},c);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Provincia',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'age'},m.country,'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Codice fiscale',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Codice fiscale',onChange:function onChange(event){return _this5.setState({fiscal_code:event.target.value});},value:m.fiscal_code})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Data di nascita',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',placeholder:'Data di nascita',onChange:function onChange(event){return _this5.setState({born_date:event.target.value});},value:m.born_date,onBlur:this._handleBlur})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Et\xE0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'age'},m.age,'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Tutore legale',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this5.setState({tutor_id:event.target.value});},value:m.tutor_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),(list||[]).map(function(m,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:m.id},m.name,' ',m.surname);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Qualifica',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this5.setState({title:event.target.value});},value:m.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),__WEBPACK_IMPORTED_MODULE_7__options_json__["titles"].map(function(c,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:c},c);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Sesso',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this5.setState({sex:event.target.value});},value:m.sex},__WEBPACK_IMPORTED_MODULE_7__options_json__["sexTypes"].filter(function(item){return item.edit||item.edit===undefined;}).map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:o.value},o.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label-double'},'Citt\xE0 di nascita',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Citt\xE0 di nascita',onChange:function onChange(event){return _this5.setState({born_city:event.target.value});}// onChange={(event) => this._handleBornCityChange(event)}
,value:m.born_city})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Provincia di nascita',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this5.setState({born_country:event.target.value});},value:m.born_country},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),__WEBPACK_IMPORTED_MODULE_6__geo_json__["countries"].map(function(c,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:c.value},c.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Informazioni corso'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Corso',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this5.setState({course_id:event.target.value});},value:m.course_id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),(this.props.courses.list||[]).map(function(m,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:m.id},m.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Taglia T-shirt',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this5.setState({tshirt_size:event.target.value});},value:m.tshirt_size},__WEBPACK_IMPORTED_MODULE_7__options_json__["tshirtSizes"].filter(function(item){return item.edit||item.edit===undefined;}).map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:o.value},o.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Data scadenza assicurazione',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',placeholder:'Data scadenza assicurazione',onChange:function onChange(event){return _this5.setState({insurance_date:event.target.value});},value:m.insurance_date})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Contatti'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Email',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'email',placeholder:'Email',onChange:function onChange(event){return _this5.setState({email:event.target.value});},value:m.email})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Telefono',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'tel',placeholder:'Telefono',onChange:function onChange(event){return _this5.setState({phone:event.target.value});},value:m.phone})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Cellulare',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'tel',placeholder:'Cellulare',onChange:function onChange(event){return _this5.setState({mobile:event.target.value});},value:m.mobile})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Certificato medico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Scadenza certificato medico',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',placeholder:'Data scadenza certificato medico',onChange:function onChange(event){return _this5.setState({medical_certificate:event.target.value});},value:m.medical_certificate})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Allega certificato medico',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',ref:function ref(_ref){return _this5.upload=_ref;},onChange:this._handleImageChange})),m.medical_certificate_checksum!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'check-container'},'Elimina certificato medico precedentemente caricato',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',disabled:m.doc_delete_lock?'disabled':'',onChange:function onChange(event){return _this5.setState({doc_delete:event.target.checked});},value:m.doc_delete,checked:m.doc_delete}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'checkmark'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Aggiungi immagine socio',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',ref:function ref(_ref2){return _this5.uploadAvatar=_ref2;},onChange:this._handleAvatarChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Note',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Note',onChange:function onChange(event){return _this5.setState({notes:event.target.value});},value:m.notes})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submit-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ajax-error'},ajaxStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this5.props.hideModal();}},'annulla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this5.saveMembers();}},'salva'))));}}]);return EditMember;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{saveMembers:__WEBPACK_IMPORTED_MODULE_3__actions_Members__["t" /* saveMembers */],startUpload:__WEBPACK_IMPORTED_MODULE_3__actions_Members__["w" /* startUpload */],stopUpload:__WEBPACK_IMPORTED_MODULE_3__actions_Members__["x" /* stopUpload */],clearAjaxCall:__WEBPACK_IMPORTED_MODULE_3__actions_Members__["p" /* clearAjaxCall */],saveMembersFailure:__WEBPACK_IMPORTED_MODULE_3__actions_Members__["u" /* saveMembersFailure */]})(EditMember));

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = [{"nome":"Abano Terme","cap":["35031"],"district":"PD","districtName":"Padova"},{"nome":"Abbadia Cerreto","cap":["26834"],"district":"LO","districtName":"Lodi"},{"nome":"Abbadia Lariana","cap":["23821"],"district":"LC","districtName":"Lecco"},{"nome":"Abbadia San Salvatore","cap":["53021"],"district":"SI","districtName":"Siena"},{"nome":"Abbasanta","cap":["09071"],"district":"OR","districtName":"Oristano"},{"nome":"Abbateggio","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Abbiategrasso","cap":["20081"],"district":"MI","districtName":"Milano"},{"nome":"Abetone Cutigliano","cap":["51024"],"district":"PT","districtName":"Pistoia"},{"nome":"Abriola","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Acate","cap":["97011"],"district":"RG","districtName":"Ragusa"},{"nome":"Accadia","cap":["71021"],"district":"FG","districtName":"Foggia"},{"nome":"Acceglio","cap":["12021"],"district":"CN","districtName":"Cuneo"},{"nome":"Accettura","cap":["75011"],"district":"MT","districtName":"Matera"},{"nome":"Acciano","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Accumoli","cap":["02011"],"district":"RI","districtName":"Rieti"},{"nome":"Acerenza","cap":["85011"],"district":"PZ","districtName":"Potenza"},{"nome":"Acerno","cap":["84042"],"district":"SA","districtName":"Salerno"},{"nome":"Acerra","cap":["80011"],"district":"NA","districtName":"Napoli"},{"nome":"Aci Bonaccorsi","cap":["95020"],"district":"CT","districtName":"Catania"},{"nome":"Aci Castello","cap":["95021"],"district":"CT","districtName":"Catania"},{"nome":"Aci Catena","cap":["95022"],"district":"CT","districtName":"Catania"},{"nome":"Aci Sant'Antonio","cap":["95025"],"district":"CT","districtName":"Catania"},{"nome":"Acireale","cap":["95024"],"district":"CT","districtName":"Catania"},{"nome":"Acquafondata","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Acquaformosa","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Acquafredda","cap":["25010"],"district":"BS","districtName":"Brescia"},{"nome":"Acqualagna","cap":["61041"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Acquanegra Cremonese","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Acquanegra sul Chiese","cap":["46011"],"district":"MN","districtName":"Mantova"},{"nome":"Acquapendente","cap":["01021"],"district":"VT","districtName":"Viterbo"},{"nome":"Acquappesa","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Acquaro","cap":["89832"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Acquasanta Terme","cap":["63095"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Acquasparta","cap":["05021"],"district":"TR","districtName":"Terni"},{"nome":"Acquaviva Collecroce","cap":["86030"],"district":"CB","districtName":"Campobasso"},{"nome":"Acquaviva d'Isernia","cap":["86080"],"district":"IS","districtName":"Isernia"},{"nome":"Acquaviva delle Fonti","cap":["70021"],"district":"BA","districtName":"Bari"},{"nome":"Acquaviva Picena","cap":["63075"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Acquaviva Platani","cap":["93010"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Acquedolci","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Acqui Terme","cap":["15011"],"district":"AL","districtName":"Alessandria"},{"nome":"Acri","cap":["87041"],"district":"CS","districtName":"Cosenza"},{"nome":"Acuto","cap":["03010"],"district":"FR","districtName":"Frosinone"},{"nome":"Adelfia","cap":["70010"],"district":"BA","districtName":"Bari"},{"nome":"Adrano","cap":["95031"],"district":"CT","districtName":"Catania"},{"nome":"Adrara San Martino","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Adrara San Rocco","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Adria","cap":["45011"],"district":"RO","districtName":"Rovigo"},{"nome":"Adro","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Affi","cap":["37010"],"district":"VR","districtName":"Verona"},{"nome":"Affile","cap":["00021"],"district":"RM","districtName":"Roma"},{"nome":"Afragola","cap":["80021"],"district":"NA","districtName":"Napoli"},{"nome":"Africo","cap":["89030"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Agazzano","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Agerola","cap":["80051"],"district":"NA","districtName":"Napoli"},{"nome":"Aggius","cap":["07020"],"district":"SS","districtName":"Sassari"},{"nome":"Agira","cap":["94011"],"district":"EN","districtName":"Enna"},{"nome":"Agliana","cap":["51031"],"district":"PT","districtName":"Pistoia"},{"nome":"Agliano Terme","cap":["14041"],"district":"AT","districtName":"Asti"},{"nome":"Agliè","cap":["10011"],"district":"TO","districtName":"Torino"},{"nome":"Aglientu","cap":["07020"],"district":"SS","districtName":"Sassari"},{"nome":"Agna","cap":["35021"],"district":"PD","districtName":"Padova"},{"nome":"Agnadello","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Agnana Calabra","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Agnone","cap":["86081"],"district":"IS","districtName":"Isernia"},{"nome":"Agnosine","cap":["25071"],"district":"BS","districtName":"Brescia"},{"nome":"Agordo","cap":["32021"],"district":"BL","districtName":"Belluno"},{"nome":"Agosta","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Agra","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Agrate Brianza","cap":["20864"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Agrate Conturbia","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Agrigento","cap":["92100"],"district":"AG","districtName":"Agrigento"},{"nome":"Agropoli","cap":["84043"],"district":"SA","districtName":"Salerno"},{"nome":"Agugliano","cap":["60020"],"district":"AN","districtName":"Ancona"},{"nome":"Agugliaro","cap":["36020"],"district":"VI","districtName":"Vicenza"},{"nome":"Aicurzio","cap":["20886"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Aidomaggiore","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Aidone","cap":["94010"],"district":"EN","districtName":"Enna"},{"nome":"Aielli","cap":["67041"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Aiello Calabro","cap":["87031"],"district":"CS","districtName":"Cosenza"},{"nome":"Aiello del Friuli","cap":["33041"],"district":"UD","districtName":"Udine"},{"nome":"Aiello del Sabato","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Aieta","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Ailano","cap":["81010"],"district":"CE","districtName":"Caserta"},{"nome":"Ailoche","cap":["13861"],"district":"BI","districtName":"Biella"},{"nome":"Airasca","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Airola","cap":["82011"],"district":"BN","districtName":"Benevento"},{"nome":"Airole","cap":["18030"],"district":"IM","districtName":"Imperia"},{"nome":"Airuno","cap":["23881"],"district":"LC","districtName":"Lecco"},{"nome":"Aisone","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Ala","cap":["38061"],"district":"TN","districtName":"Trento"},{"nome":"Alà dei Sardi","cap":["07020"],"district":"SS","districtName":"Sassari"},{"nome":"Ala di Stura","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Alagna","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Alagna Valsesia","cap":["13021"],"district":"VC","districtName":"Vercelli"},{"nome":"Alanno","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Alano di Piave","cap":["32031"],"district":"BL","districtName":"Belluno"},{"nome":"Alassio","cap":["17021"],"district":"SV","districtName":"Savona"},{"nome":"Alatri","cap":["03011"],"district":"FR","districtName":"Frosinone"},{"nome":"Alba","cap":["12051"],"district":"CN","districtName":"Cuneo"},{"nome":"Alba Adriatica","cap":["64011"],"district":"TE","districtName":"Teramo"},{"nome":"Albagiara","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Albairate","cap":["20080"],"district":"MI","districtName":"Milano"},{"nome":"Albanella","cap":["84044"],"district":"SA","districtName":"Salerno"},{"nome":"Albano di Lucania","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Albano Laziale","cap":["00041"],"district":"RM","districtName":"Roma"},{"nome":"Albano Sant'Alessandro","cap":["24061"],"district":"BG","districtName":"Bergamo"},{"nome":"Albano Vercellese","cap":["13030"],"district":"VC","districtName":"Vercelli"},{"nome":"Albaredo Arnaboldi","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Albaredo d'Adige","cap":["37041"],"district":"VR","districtName":"Verona"},{"nome":"Albaredo per San Marco","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Albareto","cap":["43051"],"district":"PR","districtName":"Parma"},{"nome":"Albaretto della Torre","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Albavilla","cap":["22031"],"district":"CO","districtName":"Como"},{"nome":"Albenga","cap":["17031"],"district":"SV","districtName":"Savona"},{"nome":"Albera Ligure","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Alberobello","cap":["70011"],"district":"BA","districtName":"Bari"},{"nome":"Alberona","cap":["71031"],"district":"FG","districtName":"Foggia"},{"nome":"Albese con Cassano","cap":["22032"],"district":"CO","districtName":"Como"},{"nome":"Albettone","cap":["36020"],"district":"VI","districtName":"Vicenza"},{"nome":"Albi","cap":["88055"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Albiano","cap":["38041"],"district":"TN","districtName":"Trento"},{"nome":"Albiano d'Ivrea","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Albiate","cap":["20847"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Albidona","cap":["87070"],"district":"CS","districtName":"Cosenza"},{"nome":"Albignasego","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Albinea","cap":["42020"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Albino","cap":["24021"],"district":"BG","districtName":"Bergamo"},{"nome":"Albiolo","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Albisola Superiore","cap":["17011"],"district":"SV","districtName":"Savona"},{"nome":"Albissola Marina","cap":["17012"],"district":"SV","districtName":"Savona"},{"nome":"Albizzate","cap":["21041"],"district":"VA","districtName":"Varese"},{"nome":"Albonese","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Albosaggia","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Albugnano","cap":["14022"],"district":"AT","districtName":"Asti"},{"nome":"Albuzzano","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Alcamo","cap":["91011"],"district":"TP","districtName":"Trapani"},{"nome":"Alcara li Fusi","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Aldeno","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Aldino","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Ales","cap":["09091"],"district":"OR","districtName":"Oristano"},{"nome":"Alessandria","cap":["15121","15122"],"district":"AL","districtName":"Alessandria"},{"nome":"Alessandria del Carretto","cap":["87070"],"district":"CS","districtName":"Cosenza"},{"nome":"Alessandria della Rocca","cap":["92010"],"district":"AG","districtName":"Agrigento"},{"nome":"Alessano","cap":["73031"],"district":"LE","districtName":"Lecce"},{"nome":"Alezio","cap":["73011"],"district":"LE","districtName":"Lecce"},{"nome":"Alfano","cap":["84040"],"district":"SA","districtName":"Salerno"},{"nome":"Alfedena","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Alfianello","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Alfiano Natta","cap":["15021"],"district":"AL","districtName":"Alessandria"},{"nome":"Alfonsine","cap":["48011"],"district":"RA","districtName":"Ravenna"},{"nome":"Alghero","cap":["07041"],"district":"SS","districtName":"Sassari"},{"nome":"Algua","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Alì","cap":["98020"],"district":"ME","districtName":"Messina"},{"nome":"Alì Terme","cap":["98021"],"district":"ME","districtName":"Messina"},{"nome":"Alia","cap":["90021"],"district":"PA","districtName":"Palermo"},{"nome":"Aliano","cap":["75010"],"district":"MT","districtName":"Matera"},{"nome":"Alice Bel Colle","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Alice Castello","cap":["13040"],"district":"VC","districtName":"Vercelli"},{"nome":"Alife","cap":["81011"],"district":"CE","districtName":"Caserta"},{"nome":"Alimena","cap":["90020"],"district":"PA","districtName":"Palermo"},{"nome":"Aliminusa","cap":["90020"],"district":"PA","districtName":"Palermo"},{"nome":"Allai","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Alleghe","cap":["32022"],"district":"BL","districtName":"Belluno"},{"nome":"Allein","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Allerona","cap":["05011"],"district":"TR","districtName":"Terni"},{"nome":"Alliste","cap":["73040"],"district":"LE","districtName":"Lecce"},{"nome":"Allumiere","cap":["00051"],"district":"RM","districtName":"Roma"},{"nome":"Alluvioni Piovera","cap":["15047"],"district":"AL","districtName":"Alessandria"},{"nome":"Almè","cap":["24011"],"district":"BG","districtName":"Bergamo"},{"nome":"Almenno San Bartolomeo","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Almenno San Salvatore","cap":["24031"],"district":"BG","districtName":"Bergamo"},{"nome":"Almese","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Alonte","cap":["36045"],"district":"VI","districtName":"Vicenza"},{"nome":"Alpago","cap":["32016"],"district":"BL","districtName":"Belluno"},{"nome":"Alpette","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Alpignano","cap":["10091"],"district":"TO","districtName":"Torino"},{"nome":"Alseno","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Alserio","cap":["22040"],"district":"CO","districtName":"Como"},{"nome":"Alta Val Tidone","cap":["29031"],"district":"PC","districtName":"Piacenza"},{"nome":"Alta Valle Intelvi","cap":["22024"],"district":"CO","districtName":"Como"},{"nome":"Altamura","cap":["70022"],"district":"BA","districtName":"Bari"},{"nome":"Altare","cap":["17041"],"district":"SV","districtName":"Savona"},{"nome":"Altavalle","cap":["38092"],"district":"TN","districtName":"Trento"},{"nome":"Altavilla Irpina","cap":["83011"],"district":"AV","districtName":"Avellino"},{"nome":"Altavilla Milicia","cap":["90010"],"district":"PA","districtName":"Palermo"},{"nome":"Altavilla Monferrato","cap":["15041"],"district":"AL","districtName":"Alessandria"},{"nome":"Altavilla Silentina","cap":["84045"],"district":"SA","districtName":"Salerno"},{"nome":"Altavilla Vicentina","cap":["36077"],"district":"VI","districtName":"Vicenza"},{"nome":"Altidona","cap":["63824"],"district":"FM","districtName":"Fermo"},{"nome":"Altilia","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Altino","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Altissimo","cap":["36070"],"district":"VI","districtName":"Vicenza"},{"nome":"Altivole","cap":["31030"],"district":"TV","districtName":"Treviso"},{"nome":"Alto","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Alto Reno Terme","cap":["40046"],"district":"BO","districtName":"Bologna"},{"nome":"Alto Sermenza","cap":["13029"],"district":"VC","districtName":"Vercelli"},{"nome":"Altofonte","cap":["90030"],"district":"PA","districtName":"Palermo"},{"nome":"Altomonte","cap":["87042"],"district":"CS","districtName":"Cosenza"},{"nome":"Altopascio","cap":["55011"],"district":"LU","districtName":"Lucca"},{"nome":"Altopiano della Vigolana","cap":["38049"],"district":"TN","districtName":"Trento"},{"nome":"Alviano","cap":["05020"],"district":"TR","districtName":"Terni"},{"nome":"Alvignano","cap":["81012"],"district":"CE","districtName":"Caserta"},{"nome":"Alvito","cap":["03041"],"district":"FR","districtName":"Frosinone"},{"nome":"Alzano Lombardo","cap":["24022"],"district":"BG","districtName":"Bergamo"},{"nome":"Alzano Scrivia","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Alzate Brianza","cap":["22040"],"district":"CO","districtName":"Como"},{"nome":"Amalfi","cap":["84011"],"district":"SA","districtName":"Salerno"},{"nome":"Amandola","cap":["63857"],"district":"FM","districtName":"Fermo"},{"nome":"Amantea","cap":["87032"],"district":"CS","districtName":"Cosenza"},{"nome":"Amaro","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Amaroni","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Amaseno","cap":["03021"],"district":"FR","districtName":"Frosinone"},{"nome":"Amato","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Amatrice","cap":["02012"],"district":"RI","districtName":"Rieti"},{"nome":"Ambivere","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Amblar-Don","cap":["38011"],"district":"TN","districtName":"Trento"},{"nome":"Ameglia","cap":["19031"],"district":"SP","districtName":"La Spezia"},{"nome":"Amelia","cap":["05022"],"district":"TR","districtName":"Terni"},{"nome":"Amendolara","cap":["87071"],"district":"CS","districtName":"Cosenza"},{"nome":"Ameno","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Amorosi","cap":["82031"],"district":"BN","districtName":"Benevento"},{"nome":"Ampezzo","cap":["33021"],"district":"UD","districtName":"Udine"},{"nome":"Anacapri","cap":["80071"],"district":"NA","districtName":"Napoli"},{"nome":"Anagni","cap":["03012"],"district":"FR","districtName":"Frosinone"},{"nome":"Ancarano","cap":["64010"],"district":"TE","districtName":"Teramo"},{"nome":"Ancona","cap":["60121","60122","60123","60124","60125","60126","60127","60128","60129","60130","60131"],"district":"AN","districtName":"Ancona"},{"nome":"Andali","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Andalo","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Andalo Valtellino","cap":["23014"],"district":"SO","districtName":"Sondrio"},{"nome":"Andezeno","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Andora","cap":["17051"],"district":"SV","districtName":"Savona"},{"nome":"Andorno Micca","cap":["13811"],"district":"BI","districtName":"Biella"},{"nome":"Andrano","cap":["73032"],"district":"LE","districtName":"Lecce"},{"nome":"Andrate","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Andreis","cap":["33080"],"district":"PN","districtName":"Pordenone"},{"nome":"Andretta","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Andria","cap":["76123"],"district":"BT","districtName":"Barletta-Andria-Trani"},{"nome":"Andriano","cap":["39010"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Anela","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Anfo","cap":["25070"],"district":"BS","districtName":"Brescia"},{"nome":"Angera","cap":["21021"],"district":"VA","districtName":"Varese"},{"nome":"Anghiari","cap":["52031"],"district":"AR","districtName":"Arezzo"},{"nome":"Angiari","cap":["37050"],"district":"VR","districtName":"Verona"},{"nome":"Angolo Terme","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Angri","cap":["84012"],"district":"SA","districtName":"Salerno"},{"nome":"Angrogna","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Anguillara Sabazia","cap":["00061"],"district":"RM","districtName":"Roma"},{"nome":"Anguillara Veneta","cap":["35022"],"district":"PD","districtName":"Padova"},{"nome":"Annicco","cap":["26021"],"district":"CR","districtName":"Cremona"},{"nome":"Annone di Brianza","cap":["23841"],"district":"LC","districtName":"Lecco"},{"nome":"Annone Veneto","cap":["30020"],"district":"VE","districtName":"Venezia"},{"nome":"Anoia","cap":["89020"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Antegnate","cap":["24051"],"district":"BG","districtName":"Bergamo"},{"nome":"Anterivo","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Antey-Saint-André","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Anticoli Corrado","cap":["00022"],"district":"RM","districtName":"Roma"},{"nome":"Antignano","cap":["14010"],"district":"AT","districtName":"Asti"},{"nome":"Antillo","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Antonimina","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Antrodoco","cap":["02013"],"district":"RI","districtName":"Rieti"},{"nome":"Antrona Schieranco","cap":["28841"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Anversa degli Abruzzi","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Anzano del Parco","cap":["22040"],"district":"CO","districtName":"Como"},{"nome":"Anzano di Puglia","cap":["71020"],"district":"FG","districtName":"Foggia"},{"nome":"Anzi","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Anzio","cap":["00042"],"district":"RM","districtName":"Roma"},{"nome":"Anzola d'Ossola","cap":["28877"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Anzola dell'Emilia","cap":["40011"],"district":"BO","districtName":"Bologna"},{"nome":"Aosta","cap":["11100"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Apecchio","cap":["61042"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Apice","cap":["82021"],"district":"BN","districtName":"Benevento"},{"nome":"Apiro","cap":["62021"],"district":"MC","districtName":"Macerata"},{"nome":"Apollosa","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Appiano Gentile","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Appiano sulla strada del vino","cap":["39057"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Appignano","cap":["62010"],"district":"MC","districtName":"Macerata"},{"nome":"Appignano del Tronto","cap":["63083"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Aprica","cap":["23031"],"district":"SO","districtName":"Sondrio"},{"nome":"Apricale","cap":["18035"],"district":"IM","districtName":"Imperia"},{"nome":"Apricena","cap":["71011"],"district":"FG","districtName":"Foggia"},{"nome":"Aprigliano","cap":["87051"],"district":"CS","districtName":"Cosenza"},{"nome":"Aprilia","cap":["04011"],"district":"LT","districtName":"Latina"},{"nome":"Aquara","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Aquila d'Arroscia","cap":["18020"],"district":"IM","districtName":"Imperia"},{"nome":"Aquileia","cap":["33051"],"district":"UD","districtName":"Udine"},{"nome":"Aquilonia","cap":["83041"],"district":"AV","districtName":"Avellino"},{"nome":"Aquino","cap":["03031"],"district":"FR","districtName":"Frosinone"},{"nome":"Aradeo","cap":["73040"],"district":"LE","districtName":"Lecce"},{"nome":"Aragona","cap":["92021"],"district":"AG","districtName":"Agrigento"},{"nome":"Aramengo","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Arba","cap":["33090"],"district":"PN","districtName":"Pordenone"},{"nome":"Arborea","cap":["09092"],"district":"OR","districtName":"Oristano"},{"nome":"Arborio","cap":["13031"],"district":"VC","districtName":"Vercelli"},{"nome":"Arbus","cap":["09031"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Arcade","cap":["31030"],"district":"TV","districtName":"Treviso"},{"nome":"Arce","cap":["03032"],"district":"FR","districtName":"Frosinone"},{"nome":"Arcene","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Arcevia","cap":["60011"],"district":"AN","districtName":"Ancona"},{"nome":"Archi","cap":["66044"],"district":"CH","districtName":"Chieti"},{"nome":"Arcidosso","cap":["58031"],"district":"GR","districtName":"Grosseto"},{"nome":"Arcinazzo Romano","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Arcisate","cap":["21051"],"district":"VA","districtName":"Varese"},{"nome":"Arco","cap":["38062"],"district":"TN","districtName":"Trento"},{"nome":"Arcola","cap":["19021"],"district":"SP","districtName":"La Spezia"},{"nome":"Arcole","cap":["37040"],"district":"VR","districtName":"Verona"},{"nome":"Arconate","cap":["20020"],"district":"MI","districtName":"Milano"},{"nome":"Arcore","cap":["20862"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Arcugnano","cap":["36057"],"district":"VI","districtName":"Vicenza"},{"nome":"Ardara","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Ardauli","cap":["09081"],"district":"OR","districtName":"Oristano"},{"nome":"Ardea","cap":["00040"],"district":"RM","districtName":"Roma"},{"nome":"Ardenno","cap":["23011"],"district":"SO","districtName":"Sondrio"},{"nome":"Ardesio","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Ardore","cap":["89031"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Arena","cap":["89832"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Arena Po","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Arenzano","cap":["16011"],"district":"GE","districtName":"Genova"},{"nome":"Arese","cap":["20020"],"district":"MI","districtName":"Milano"},{"nome":"Arezzo","cap":["52100"],"district":"AR","districtName":"Arezzo"},{"nome":"Argegno","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Argelato","cap":["40050"],"district":"BO","districtName":"Bologna"},{"nome":"Argenta","cap":["44011"],"district":"FE","districtName":"Ferrara"},{"nome":"Argentera","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Arguello","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Argusto","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Ari","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Ariano Irpino","cap":["83031"],"district":"AV","districtName":"Avellino"},{"nome":"Ariano nel Polesine","cap":["45012"],"district":"RO","districtName":"Rovigo"},{"nome":"Ariccia","cap":["00072"],"district":"RM","districtName":"Roma"},{"nome":"Arielli","cap":["66030"],"district":"CH","districtName":"Chieti"},{"nome":"Arienzo","cap":["81021"],"district":"CE","districtName":"Caserta"},{"nome":"Arignano","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Aritzo","cap":["08031"],"district":"NU","districtName":"Nuoro"},{"nome":"Arizzano","cap":["28811"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Arlena di Castro","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Arluno","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Armeno","cap":["28011"],"district":"NO","districtName":"Novara"},{"nome":"Armento","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Armo","cap":["18026"],"district":"IM","districtName":"Imperia"},{"nome":"Armungia","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Arnad","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Arnara","cap":["03020"],"district":"FR","districtName":"Frosinone"},{"nome":"Arnasco","cap":["17032"],"district":"SV","districtName":"Savona"},{"nome":"Arnesano","cap":["73010"],"district":"LE","districtName":"Lecce"},{"nome":"Arola","cap":["28899"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Arona","cap":["28041"],"district":"NO","districtName":"Novara"},{"nome":"Arosio","cap":["22060"],"district":"CO","districtName":"Como"},{"nome":"Arpaia","cap":["82011"],"district":"BN","districtName":"Benevento"},{"nome":"Arpaise","cap":["82010"],"district":"BN","districtName":"Benevento"},{"nome":"Arpino","cap":["03033"],"district":"FR","districtName":"Frosinone"},{"nome":"Arquà Petrarca","cap":["35032"],"district":"PD","districtName":"Padova"},{"nome":"Arquà Polesine","cap":["45031"],"district":"RO","districtName":"Rovigo"},{"nome":"Arquata del Tronto","cap":["63096"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Arquata Scrivia","cap":["15061"],"district":"AL","districtName":"Alessandria"},{"nome":"Arre","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Arrone","cap":["05031"],"district":"TR","districtName":"Terni"},{"nome":"Arsago Seprio","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Arsiè","cap":["32030"],"district":"BL","districtName":"Belluno"},{"nome":"Arsiero","cap":["36011"],"district":"VI","districtName":"Vicenza"},{"nome":"Arsita","cap":["64031"],"district":"TE","districtName":"Teramo"},{"nome":"Arsoli","cap":["00023"],"district":"RM","districtName":"Roma"},{"nome":"Arta Terme","cap":["33022"],"district":"UD","districtName":"Udine"},{"nome":"Artegna","cap":["33011"],"district":"UD","districtName":"Udine"},{"nome":"Artena","cap":["00031"],"district":"RM","districtName":"Roma"},{"nome":"Artogne","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Arvier","cap":["11011"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Arzachena","cap":["07021"],"district":"SS","districtName":"Sassari"},{"nome":"Arzago d'Adda","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Arzana","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Arzano","cap":["80022"],"district":"NA","districtName":"Napoli"},{"nome":"Arzergrande","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Arzignano","cap":["36071"],"district":"VI","districtName":"Vicenza"},{"nome":"Ascea","cap":["84046"],"district":"SA","districtName":"Salerno"},{"nome":"Asciano","cap":["53041"],"district":"SI","districtName":"Siena"},{"nome":"Ascoli Piceno","cap":["63100"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Ascoli Satriano","cap":["71022"],"district":"FG","districtName":"Foggia"},{"nome":"Ascrea","cap":["02020"],"district":"RI","districtName":"Rieti"},{"nome":"Asiago","cap":["36012"],"district":"VI","districtName":"Vicenza"},{"nome":"Asigliano Veneto","cap":["36020"],"district":"VI","districtName":"Vicenza"},{"nome":"Asigliano Vercellese","cap":["13032"],"district":"VC","districtName":"Vercelli"},{"nome":"Asola","cap":["46041"],"district":"MN","districtName":"Mantova"},{"nome":"Asolo","cap":["31011"],"district":"TV","districtName":"Treviso"},{"nome":"Assago","cap":["20090"],"district":"MI","districtName":"Milano"},{"nome":"Assemini","cap":["09032"],"district":"CA","districtName":"Cagliari"},{"nome":"Assisi","cap":["06081"],"district":"PG","districtName":"Perugia"},{"nome":"Asso","cap":["22033"],"district":"CO","districtName":"Como"},{"nome":"Assolo","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Assoro","cap":["94010"],"district":"EN","districtName":"Enna"},{"nome":"Asti","cap":["14100"],"district":"AT","districtName":"Asti"},{"nome":"Asuni","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Ateleta","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Atella","cap":["85020"],"district":"PZ","districtName":"Potenza"},{"nome":"Atena Lucana","cap":["84030"],"district":"SA","districtName":"Salerno"},{"nome":"Atessa","cap":["66041"],"district":"CH","districtName":"Chieti"},{"nome":"Atina","cap":["03042"],"district":"FR","districtName":"Frosinone"},{"nome":"Atrani","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"Atri","cap":["64032"],"district":"TE","districtName":"Teramo"},{"nome":"Atripalda","cap":["83042"],"district":"AV","districtName":"Avellino"},{"nome":"Attigliano","cap":["05012"],"district":"TR","districtName":"Terni"},{"nome":"Attimis","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Atzara","cap":["08030"],"district":"NU","districtName":"Nuoro"},{"nome":"Augusta","cap":["96011"],"district":"SR","districtName":"Siracusa"},{"nome":"Auletta","cap":["84031"],"district":"SA","districtName":"Salerno"},{"nome":"Aulla","cap":["54011"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Aurano","cap":["28812"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Aurigo","cap":["18020"],"district":"IM","districtName":"Imperia"},{"nome":"Auronzo di Cadore","cap":["32041"],"district":"BL","districtName":"Belluno"},{"nome":"Ausonia","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Austis","cap":["08030"],"district":"NU","districtName":"Nuoro"},{"nome":"Avegno","cap":["16036"],"district":"GE","districtName":"Genova"},{"nome":"Avelengo","cap":["39010"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Avella","cap":["83021"],"district":"AV","districtName":"Avellino"},{"nome":"Avellino","cap":["83100"],"district":"AV","districtName":"Avellino"},{"nome":"Averara","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Aversa","cap":["81031"],"district":"CE","districtName":"Caserta"},{"nome":"Avetrana","cap":["74020"],"district":"TA","districtName":"Taranto"},{"nome":"Avezzano","cap":["67051"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Aviano","cap":["33081"],"district":"PN","districtName":"Pordenone"},{"nome":"Aviatico","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Avigliana","cap":["10051"],"district":"TO","districtName":"Torino"},{"nome":"Avigliano","cap":["85021"],"district":"PZ","districtName":"Potenza"},{"nome":"Avigliano Umbro","cap":["05020"],"district":"TR","districtName":"Terni"},{"nome":"Avio","cap":["38063"],"district":"TN","districtName":"Trento"},{"nome":"Avise","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Avola","cap":["96012"],"district":"SR","districtName":"Siracusa"},{"nome":"Avolasca","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Ayas","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Aymavilles","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Azeglio","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Azzanello","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Azzano d'Asti","cap":["14030"],"district":"AT","districtName":"Asti"},{"nome":"Azzano Decimo","cap":["33082"],"district":"PN","districtName":"Pordenone"},{"nome":"Azzano Mella","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Azzano San Paolo","cap":["24052"],"district":"BG","districtName":"Bergamo"},{"nome":"Azzate","cap":["21022"],"district":"VA","districtName":"Varese"},{"nome":"Azzio","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Azzone","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Baceno","cap":["28861"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Bacoli","cap":["80070"],"district":"NA","districtName":"Napoli"},{"nome":"Badalucco","cap":["18010"],"district":"IM","districtName":"Imperia"},{"nome":"Badesi","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Badia","cap":["39036"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Badia Calavena","cap":["37030"],"district":"VR","districtName":"Verona"},{"nome":"Badia Pavese","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Badia Polesine","cap":["45021"],"district":"RO","districtName":"Rovigo"},{"nome":"Badia Tedalda","cap":["52032"],"district":"AR","districtName":"Arezzo"},{"nome":"Badolato","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Bagaladi","cap":["89060"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Bagheria","cap":["90011"],"district":"PA","districtName":"Palermo"},{"nome":"Bagnacavallo","cap":["48012"],"district":"RA","districtName":"Ravenna"},{"nome":"Bagnara Calabra","cap":["89011"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Bagnara di Romagna","cap":["48031"],"district":"RA","districtName":"Ravenna"},{"nome":"Bagnaria","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Bagnaria Arsa","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Bagnasco","cap":["12071"],"district":"CN","districtName":"Cuneo"},{"nome":"Bagnatica","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Bagni di Lucca","cap":["55022"],"district":"LU","districtName":"Lucca"},{"nome":"Bagno a Ripoli","cap":["50012"],"district":"FI","districtName":"Firenze"},{"nome":"Bagno di Romagna","cap":["47021"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Bagnoli del Trigno","cap":["86091"],"district":"IS","districtName":"Isernia"},{"nome":"Bagnoli di Sopra","cap":["35023"],"district":"PD","districtName":"Padova"},{"nome":"Bagnoli Irpino","cap":["83043"],"district":"AV","districtName":"Avellino"},{"nome":"Bagnolo Cremasco","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Bagnolo del Salento","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Bagnolo di Po","cap":["45022"],"district":"RO","districtName":"Rovigo"},{"nome":"Bagnolo in Piano","cap":["42011"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Bagnolo Mella","cap":["25021"],"district":"BS","districtName":"Brescia"},{"nome":"Bagnolo Piemonte","cap":["12031"],"district":"CN","districtName":"Cuneo"},{"nome":"Bagnolo San Vito","cap":["46031"],"district":"MN","districtName":"Mantova"},{"nome":"Bagnone","cap":["54021"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Bagnoregio","cap":["01022"],"district":"VT","districtName":"Viterbo"},{"nome":"Bagolino","cap":["25072"],"district":"BS","districtName":"Brescia"},{"nome":"Baia e Latina","cap":["81010"],"district":"CE","districtName":"Caserta"},{"nome":"Baiano","cap":["83022"],"district":"AV","districtName":"Avellino"},{"nome":"Bairo","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Baiso","cap":["42031"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Bajardo","cap":["18031"],"district":"IM","districtName":"Imperia"},{"nome":"Balangero","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Baldichieri d'Asti","cap":["14011"],"district":"AT","districtName":"Asti"},{"nome":"Baldissero Canavese","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Baldissero d'Alba","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Baldissero Torinese","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Balestrate","cap":["90041"],"district":"PA","districtName":"Palermo"},{"nome":"Balestrino","cap":["17020"],"district":"SV","districtName":"Savona"},{"nome":"Ballabio","cap":["23811"],"district":"LC","districtName":"Lecco"},{"nome":"Ballao","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Balme","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Balmuccia","cap":["13020"],"district":"VC","districtName":"Vercelli"},{"nome":"Balocco","cap":["13040"],"district":"VC","districtName":"Vercelli"},{"nome":"Balsorano","cap":["67052"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Balvano","cap":["85050"],"district":"PZ","districtName":"Potenza"},{"nome":"Balzola","cap":["15031"],"district":"AL","districtName":"Alessandria"},{"nome":"Banari","cap":["07040"],"district":"SS","districtName":"Sassari"},{"nome":"Banchette","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Bannio Anzino","cap":["28871"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Banzi","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Baone","cap":["35030"],"district":"PD","districtName":"Padova"},{"nome":"Baradili","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Baragiano","cap":["85050"],"district":"PZ","districtName":"Potenza"},{"nome":"Baranello","cap":["86011"],"district":"CB","districtName":"Campobasso"},{"nome":"Barano d'Ischia","cap":["80072"],"district":"NA","districtName":"Napoli"},{"nome":"Baranzate","cap":["20021"],"district":"MI","districtName":"Milano"},{"nome":"Barasso","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Baratili San Pietro","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Barbania","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Barbara","cap":["60010"],"district":"AN","districtName":"Ancona"},{"nome":"Barbarano Mossano","cap":["36048"],"district":"VI","districtName":"Vicenza"},{"nome":"Barbarano Romano","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Barbaresco","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Barbariga","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Barbata","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Barberino di Mugello","cap":["50031"],"district":"FI","districtName":"Firenze"},{"nome":"Barberino Tavarnelle","cap":["50028"],"district":"FI","districtName":"Firenze"},{"nome":"Barbianello","cap":["27041"],"district":"PV","districtName":"Pavia"},{"nome":"Barbiano","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Barbona","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Barcellona Pozzo di Gotto","cap":["98051"],"district":"ME","districtName":"Messina"},{"nome":"Barcis","cap":["33080"],"district":"PN","districtName":"Pordenone"},{"nome":"Bard","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Bardello","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Bardi","cap":["43032"],"district":"PR","districtName":"Parma"},{"nome":"Bardineto","cap":["17057"],"district":"SV","districtName":"Savona"},{"nome":"Bardolino","cap":["37011"],"district":"VR","districtName":"Verona"},{"nome":"Bardonecchia","cap":["10052"],"district":"TO","districtName":"Torino"},{"nome":"Bareggio","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Barengo","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Baressa","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Barete","cap":["67010"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Barga","cap":["55051"],"district":"LU","districtName":"Lucca"},{"nome":"Bargagli","cap":["16021"],"district":"GE","districtName":"Genova"},{"nome":"Barge","cap":["12032"],"district":"CN","districtName":"Cuneo"},{"nome":"Barghe","cap":["25070"],"district":"BS","districtName":"Brescia"},{"nome":"Bari","cap":["70121","70122","70123","70124","70125","70126","70127","70128","70129","70130","70131","70132"],"district":"BA","districtName":"Bari"},{"nome":"Bari Sardo","cap":["08042"],"district":"NU","districtName":"Nuoro"},{"nome":"Bariano","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Baricella","cap":["40052"],"district":"BO","districtName":"Bologna"},{"nome":"Barile","cap":["85022"],"district":"PZ","districtName":"Potenza"},{"nome":"Barisciano","cap":["67021"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Barlassina","cap":["20825"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Barletta","cap":["76121"],"district":"BT","districtName":"Barletta-Andria-Trani"},{"nome":"Barni","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Barolo","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Barone Canavese","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Baronissi","cap":["84081"],"district":"SA","districtName":"Salerno"},{"nome":"Barrafranca","cap":["94012"],"district":"EN","districtName":"Enna"},{"nome":"Barrali","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Barrea","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Barumini","cap":["09021"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Barzago","cap":["23890"],"district":"LC","districtName":"Lecco"},{"nome":"Barzana","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Barzanò","cap":["23891"],"district":"LC","districtName":"Lecco"},{"nome":"Barzio","cap":["23816"],"district":"LC","districtName":"Lecco"},{"nome":"Basaluzzo","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Bascapè","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Baschi","cap":["05023"],"district":"TR","districtName":"Terni"},{"nome":"Basciano","cap":["64030"],"district":"TE","districtName":"Teramo"},{"nome":"Baselga di Pinè","cap":["38042"],"district":"TN","districtName":"Trento"},{"nome":"Baselice","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Basiano","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Basicò","cap":["98060"],"district":"ME","districtName":"Messina"},{"nome":"Basiglio","cap":["20080"],"district":"MI","districtName":"Milano"},{"nome":"Basiliano","cap":["33031"],"district":"UD","districtName":"Udine"},{"nome":"Bassano Bresciano","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Bassano del Grappa","cap":["36061"],"district":"VI","districtName":"Vicenza"},{"nome":"Bassano in Teverina","cap":["01030"],"district":"VT","districtName":"Viterbo"},{"nome":"Bassano Romano","cap":["01030"],"district":"VT","districtName":"Viterbo"},{"nome":"Bassiano","cap":["04010"],"district":"LT","districtName":"Latina"},{"nome":"Bassignana","cap":["15042"],"district":"AL","districtName":"Alessandria"},{"nome":"Bastia Mondovì","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Bastia Umbra","cap":["06083"],"district":"PG","districtName":"Perugia"},{"nome":"Bastida Pancarana","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Bastiglia","cap":["41030"],"district":"MO","districtName":"Modena"},{"nome":"Battaglia Terme","cap":["35041"],"district":"PD","districtName":"Padova"},{"nome":"Battifollo","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Battipaglia","cap":["84091"],"district":"SA","districtName":"Salerno"},{"nome":"Battuda","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Baucina","cap":["90020"],"district":"PA","districtName":"Palermo"},{"nome":"Bauladu","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Baunei","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Baveno","cap":["28831"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Bedero Valcuvia","cap":["21039"],"district":"VA","districtName":"Varese"},{"nome":"Bedizzole","cap":["25081"],"district":"BS","districtName":"Brescia"},{"nome":"Bedollo","cap":["38043"],"district":"TN","districtName":"Trento"},{"nome":"Bedonia","cap":["43041"],"district":"PR","districtName":"Parma"},{"nome":"Bedulita","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Bee","cap":["28813"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Beinasco","cap":["10092"],"district":"TO","districtName":"Torino"},{"nome":"Beinette","cap":["12081"],"district":"CN","districtName":"Cuneo"},{"nome":"Belcastro","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Belfiore","cap":["37050"],"district":"VR","districtName":"Verona"},{"nome":"Belforte all'Isauro","cap":["61026"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Belforte del Chienti","cap":["62020"],"district":"MC","districtName":"Macerata"},{"nome":"Belforte Monferrato","cap":["15070"],"district":"AL","districtName":"Alessandria"},{"nome":"Belgioioso","cap":["27011"],"district":"PV","districtName":"Pavia"},{"nome":"Belgirate","cap":["28832"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Bella","cap":["85051"],"district":"PZ","districtName":"Potenza"},{"nome":"Bellagio","cap":["22021"],"district":"CO","districtName":"Como"},{"nome":"Bellano","cap":["23822"],"district":"LC","districtName":"Lecco"},{"nome":"Bellante","cap":["64020"],"district":"TE","districtName":"Teramo"},{"nome":"Bellaria-Igea Marina","cap":["47814"],"district":"RN","districtName":"Rimini"},{"nome":"Bellegra","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"Bellino","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Bellinzago Lombardo","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Bellinzago Novarese","cap":["28043"],"district":"NO","districtName":"Novara"},{"nome":"Bellizzi","cap":["84092"],"district":"SA","districtName":"Salerno"},{"nome":"Bellona","cap":["81041"],"district":"CE","districtName":"Caserta"},{"nome":"Bellosguardo","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Belluno","cap":["32100"],"district":"BL","districtName":"Belluno"},{"nome":"Bellusco","cap":["20882"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Belmonte Calabro","cap":["87033"],"district":"CS","districtName":"Cosenza"},{"nome":"Belmonte Castello","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Belmonte del Sannio","cap":["86080"],"district":"IS","districtName":"Isernia"},{"nome":"Belmonte in Sabina","cap":["02020"],"district":"RI","districtName":"Rieti"},{"nome":"Belmonte Mezzagno","cap":["90031"],"district":"PA","districtName":"Palermo"},{"nome":"Belmonte Piceno","cap":["63838"],"district":"FM","districtName":"Fermo"},{"nome":"Belpasso","cap":["95032"],"district":"CT","districtName":"Catania"},{"nome":"Belsito","cap":["87030"],"district":"CS","districtName":"Cosenza"},{"nome":"Belvedere di Spinello","cap":["88824"],"district":"KR","districtName":"Crotone"},{"nome":"Belvedere Langhe","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Belvedere Marittimo","cap":["87021"],"district":"CS","districtName":"Cosenza"},{"nome":"Belvedere Ostrense","cap":["60030"],"district":"AN","districtName":"Ancona"},{"nome":"Belveglio","cap":["14040"],"district":"AT","districtName":"Asti"},{"nome":"Belvì","cap":["08030"],"district":"NU","districtName":"Nuoro"},{"nome":"Bema","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Bene Lario","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Bene Vagienna","cap":["12041"],"district":"CN","districtName":"Cuneo"},{"nome":"Benestare","cap":["89030"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Benetutti","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Benevello","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Benevento","cap":["82100"],"district":"BN","districtName":"Benevento"},{"nome":"Benna","cap":["13871"],"district":"BI","districtName":"Biella"},{"nome":"Bentivoglio","cap":["40010"],"district":"BO","districtName":"Bologna"},{"nome":"Berbenno","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Berbenno di Valtellina","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Berceto","cap":["43042"],"district":"PR","districtName":"Parma"},{"nome":"Berchidda","cap":["07022"],"district":"SS","districtName":"Sassari"},{"nome":"Beregazzo con Figliaro","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Bereguardo","cap":["27021"],"district":"PV","districtName":"Pavia"},{"nome":"Bergamasco","cap":["15022"],"district":"AL","districtName":"Alessandria"},{"nome":"Bergamo","cap":["24121","24122","24123","24124","24125","24126","24127","24128","24129"],"district":"BG","districtName":"Bergamo"},{"nome":"Bergantino","cap":["45032"],"district":"RO","districtName":"Rovigo"},{"nome":"Bergeggi","cap":["17028"],"district":"SV","districtName":"Savona"},{"nome":"Bergolo","cap":["12074"],"district":"CN","districtName":"Cuneo"},{"nome":"Berlingo","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Bernalda","cap":["75012"],"district":"MT","districtName":"Matera"},{"nome":"Bernareggio","cap":["20881"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Bernate Ticino","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Bernezzo","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Bertinoro","cap":["47032"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Bertiolo","cap":["33032"],"district":"UD","districtName":"Udine"},{"nome":"Bertonico","cap":["26821"],"district":"LO","districtName":"Lodi"},{"nome":"Berzano di San Pietro","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Berzano di Tortona","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Berzo Demo","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Berzo Inferiore","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Berzo San Fermo","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Besana in Brianza","cap":["20842"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Besano","cap":["21050"],"district":"VA","districtName":"Varese"},{"nome":"Besate","cap":["20080"],"district":"MI","districtName":"Milano"},{"nome":"Besenello","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Besenzone","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Besnate","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Besozzo","cap":["21023"],"district":"VA","districtName":"Varese"},{"nome":"Bessude","cap":["07040"],"district":"SS","districtName":"Sassari"},{"nome":"Bettola","cap":["29021"],"district":"PC","districtName":"Piacenza"},{"nome":"Bettona","cap":["06084"],"district":"PG","districtName":"Perugia"},{"nome":"Beura-Cardezza","cap":["28851"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Bevagna","cap":["06031"],"district":"PG","districtName":"Perugia"},{"nome":"Beverino","cap":["19020"],"district":"SP","districtName":"La Spezia"},{"nome":"Bevilacqua","cap":["37040"],"district":"VR","districtName":"Verona"},{"nome":"Biancavilla","cap":["95033"],"district":"CT","districtName":"Catania"},{"nome":"Bianchi","cap":["87050"],"district":"CS","districtName":"Cosenza"},{"nome":"Bianco","cap":["89032"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Biandrate","cap":["28061"],"district":"NO","districtName":"Novara"},{"nome":"Biandronno","cap":["21024"],"district":"VA","districtName":"Varese"},{"nome":"Bianzano","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Bianzè","cap":["13041"],"district":"VC","districtName":"Vercelli"},{"nome":"Bianzone","cap":["23030"],"district":"SO","districtName":"Sondrio"},{"nome":"Biassono","cap":["20853"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Bibbiano","cap":["42021"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Bibbiena","cap":["52011"],"district":"AR","districtName":"Arezzo"},{"nome":"Bibbona","cap":["57020"],"district":"LI","districtName":"Livorno"},{"nome":"Bibiana","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Biccari","cap":["71032"],"district":"FG","districtName":"Foggia"},{"nome":"Bicinicco","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Bidonì","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Biella","cap":["13900"],"district":"BI","districtName":"Biella"},{"nome":"Bienno","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Bieno","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Bientina","cap":["56031"],"district":"PI","districtName":"Pisa"},{"nome":"Binago","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Binasco","cap":["20082"],"district":"MI","districtName":"Milano"},{"nome":"Binetto","cap":["70020"],"district":"BA","districtName":"Bari"},{"nome":"Bioglio","cap":["13841"],"district":"BI","districtName":"Biella"},{"nome":"Bionaz","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Bione","cap":["25070"],"district":"BS","districtName":"Brescia"},{"nome":"Birori","cap":["08010"],"district":"NU","districtName":"Nuoro"},{"nome":"Bisaccia","cap":["83044"],"district":"AV","districtName":"Avellino"},{"nome":"Bisacquino","cap":["90032"],"district":"PA","districtName":"Palermo"},{"nome":"Bisceglie","cap":["76011"],"district":"BT","districtName":"Barletta-Andria-Trani"},{"nome":"Bisegna","cap":["67050"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Bisenti","cap":["64033"],"district":"TE","districtName":"Teramo"},{"nome":"Bisignano","cap":["87043"],"district":"CS","districtName":"Cosenza"},{"nome":"Bistagno","cap":["15012"],"district":"AL","districtName":"Alessandria"},{"nome":"Bisuschio","cap":["21050"],"district":"VA","districtName":"Varese"},{"nome":"Bitetto","cap":["70020"],"district":"BA","districtName":"Bari"},{"nome":"Bitonto","cap":["70032"],"district":"BA","districtName":"Bari"},{"nome":"Bitritto","cap":["70020"],"district":"BA","districtName":"Bari"},{"nome":"Bitti","cap":["08021"],"district":"NU","districtName":"Nuoro"},{"nome":"Bivona","cap":["92010"],"district":"AG","districtName":"Agrigento"},{"nome":"Bivongi","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Bizzarone","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Bleggio Superiore","cap":["38071"],"district":"TN","districtName":"Trento"},{"nome":"Blello","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Blera","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Blessagno","cap":["22028"],"district":"CO","districtName":"Como"},{"nome":"Blevio","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Blufi","cap":["90020"],"district":"PA","districtName":"Palermo"},{"nome":"Boara Pisani","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Bobbio","cap":["29022"],"district":"PC","districtName":"Piacenza"},{"nome":"Bobbio Pellice","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Boca","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Bocchigliero","cap":["87060"],"district":"CS","districtName":"Cosenza"},{"nome":"Boccioleto","cap":["13022"],"district":"VC","districtName":"Vercelli"},{"nome":"Bocenago","cap":["38080"],"district":"TN","districtName":"Trento"},{"nome":"Bodio Lomnago","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Boffalora d'Adda","cap":["26811"],"district":"LO","districtName":"Lodi"},{"nome":"Boffalora sopra Ticino","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Bogliasco","cap":["16031"],"district":"GE","districtName":"Genova"},{"nome":"Bognanco","cap":["28842"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Bogogno","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Boissano","cap":["17054"],"district":"SV","districtName":"Savona"},{"nome":"Bojano","cap":["86021"],"district":"CB","districtName":"Campobasso"},{"nome":"Bolano","cap":["19020"],"district":"SP","districtName":"La Spezia"},{"nome":"Bolgare","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Bollate","cap":["20021"],"district":"MI","districtName":"Milano"},{"nome":"Bollengo","cap":["10012"],"district":"TO","districtName":"Torino"},{"nome":"Bologna","cap":["40121","40122","40123","40124","40125","40126","40127","40128","40129","40130","40131","40132","40133","40134","40135","40136","40137","40138","40139","40140","40141"],"district":"BO","districtName":"Bologna"},{"nome":"Bolognano","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Bolognetta","cap":["90030"],"district":"PA","districtName":"Palermo"},{"nome":"Bolognola","cap":["62035"],"district":"MC","districtName":"Macerata"},{"nome":"Bolotana","cap":["08011"],"district":"NU","districtName":"Nuoro"},{"nome":"Bolsena","cap":["01023"],"district":"VT","districtName":"Viterbo"},{"nome":"Boltiere","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Bolzano","cap":["39100"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Bolzano Novarese","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Bolzano Vicentino","cap":["36050"],"district":"VI","districtName":"Vicenza"},{"nome":"Bomarzo","cap":["01020"],"district":"VT","districtName":"Viterbo"},{"nome":"Bomba","cap":["66042"],"district":"CH","districtName":"Chieti"},{"nome":"Bompensiere","cap":["93010"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Bompietro","cap":["90020"],"district":"PA","districtName":"Palermo"},{"nome":"Bomporto","cap":["41030"],"district":"MO","districtName":"Modena"},{"nome":"Bonarcado","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Bonassola","cap":["19011"],"district":"SP","districtName":"La Spezia"},{"nome":"Bonate Sopra","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Bonate Sotto","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Bonavigo","cap":["37040"],"district":"VR","districtName":"Verona"},{"nome":"Bondeno","cap":["44012"],"district":"FE","districtName":"Ferrara"},{"nome":"Bondone","cap":["38080"],"district":"TN","districtName":"Trento"},{"nome":"Bonea","cap":["82013"],"district":"BN","districtName":"Benevento"},{"nome":"Bonefro","cap":["86041"],"district":"CB","districtName":"Campobasso"},{"nome":"Bonemerse","cap":["26040"],"district":"CR","districtName":"Cremona"},{"nome":"Bonifati","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Bonito","cap":["83032"],"district":"AV","districtName":"Avellino"},{"nome":"Bonnanaro","cap":["07043"],"district":"SS","districtName":"Sassari"},{"nome":"Bono","cap":["07011"],"district":"SS","districtName":"Sassari"},{"nome":"Bonorva","cap":["07012"],"district":"SS","districtName":"Sassari"},{"nome":"Bonvicino","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Borbona","cap":["02010"],"district":"RI","districtName":"Rieti"},{"nome":"Borca di Cadore","cap":["32040"],"district":"BL","districtName":"Belluno"},{"nome":"Bordano","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Bordighera","cap":["18012"],"district":"IM","districtName":"Imperia"},{"nome":"Bordolano","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Bore","cap":["43030"],"district":"PR","districtName":"Parma"},{"nome":"Boretto","cap":["42022"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Borgarello","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Borgaro Torinese","cap":["10071"],"district":"TO","districtName":"Torino"},{"nome":"Borgetto","cap":["90042"],"district":"PA","districtName":"Palermo"},{"nome":"Borghetto d'Arroscia","cap":["18020"],"district":"IM","districtName":"Imperia"},{"nome":"Borghetto di Borbera","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Borghetto di Vara","cap":["19020"],"district":"SP","districtName":"La Spezia"},{"nome":"Borghetto Lodigiano","cap":["26812"],"district":"LO","districtName":"Lodi"},{"nome":"Borghetto Santo Spirito","cap":["17052"],"district":"SV","districtName":"Savona"},{"nome":"Borghi","cap":["47030"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Borgia","cap":["88021"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Borgiallo","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Borgio Verezzi","cap":["17022"],"district":"SV","districtName":"Savona"},{"nome":"Borgo a Mozzano","cap":["55023"],"district":"LU","districtName":"Lucca"},{"nome":"Borgo Chiese","cap":["38083"],"district":"TN","districtName":"Trento"},{"nome":"Borgo d'Ale","cap":["13040"],"district":"VC","districtName":"Vercelli"},{"nome":"Borgo d'Anaunia","cap":["38013","38020"],"district":"TN","districtName":"Trento"},{"nome":"Borgo di Terzo","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Borgo Lares","cap":["38079"],"district":"TN","districtName":"Trento"},{"nome":"Borgo Mantovano","cap":["46036"],"district":"MN","districtName":"Mantova"},{"nome":"Borgo Pace","cap":["61040"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Borgo Priolo","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Borgo San Dalmazzo","cap":["12011"],"district":"CN","districtName":"Cuneo"},{"nome":"Borgo San Giacomo","cap":["25022"],"district":"BS","districtName":"Brescia"},{"nome":"Borgo San Giovanni","cap":["26851"],"district":"LO","districtName":"Lodi"},{"nome":"Borgo San Lorenzo","cap":["50032"],"district":"FI","districtName":"Firenze"},{"nome":"Borgo San Martino","cap":["15032"],"district":"AL","districtName":"Alessandria"},{"nome":"Borgo San Siro","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Borgo Ticino","cap":["28040"],"district":"NO","districtName":"Novara"},{"nome":"Borgo Tossignano","cap":["40021"],"district":"BO","districtName":"Bologna"},{"nome":"Borgo Val di Taro","cap":["43043"],"district":"PR","districtName":"Parma"},{"nome":"Borgo Valbelluna","cap":["32026"],"district":"BL","districtName":"Belluno"},{"nome":"Borgo Valsugana","cap":["38051"],"district":"TN","districtName":"Trento"},{"nome":"Borgo Velino","cap":["02010"],"district":"RI","districtName":"Rieti"},{"nome":"Borgo Veneto","cap":["35046"],"district":"PD","districtName":"Padova"},{"nome":"Borgo Vercelli","cap":["13012"],"district":"VC","districtName":"Vercelli"},{"nome":"Borgo Virgilio","cap":["46034"],"district":"MN","districtName":"Mantova"},{"nome":"Borgocarbonara","cap":["46021"],"district":"MN","districtName":"Mantova"},{"nome":"Borgofranco d'Ivrea","cap":["10013"],"district":"TO","districtName":"Torino"},{"nome":"Borgolavezzaro","cap":["28071"],"district":"NO","districtName":"Novara"},{"nome":"Borgomale","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Borgomanero","cap":["28021"],"district":"NO","districtName":"Novara"},{"nome":"Borgomaro","cap":["18021"],"district":"IM","districtName":"Imperia"},{"nome":"Borgomasino","cap":["10031"],"district":"TO","districtName":"Torino"},{"nome":"Borgomezzavalle","cap":["28846"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Borgone Susa","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Borgonovo Val Tidone","cap":["29011"],"district":"PC","districtName":"Piacenza"},{"nome":"Borgoratto Alessandrino","cap":["15013"],"district":"AL","districtName":"Alessandria"},{"nome":"Borgoratto Mormorolo","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Borgoricco","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Borgorose","cap":["02021"],"district":"RI","districtName":"Rieti"},{"nome":"Borgosatollo","cap":["25010"],"district":"BS","districtName":"Brescia"},{"nome":"Borgosesia","cap":["13011"],"district":"VC","districtName":"Vercelli"},{"nome":"Bormida","cap":["17045"],"district":"SV","districtName":"Savona"},{"nome":"Bormio","cap":["23032"],"district":"SO","districtName":"Sondrio"},{"nome":"Bornasco","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Borno","cap":["25042"],"district":"BS","districtName":"Brescia"},{"nome":"Boroneddu","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Borore","cap":["08016"],"district":"NU","districtName":"Nuoro"},{"nome":"Borrello","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Borriana","cap":["13872"],"district":"BI","districtName":"Biella"},{"nome":"Borso del Grappa","cap":["31030"],"district":"TV","districtName":"Treviso"},{"nome":"Bortigali","cap":["08012"],"district":"NU","districtName":"Nuoro"},{"nome":"Bortigiadas","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Borutta","cap":["07040"],"district":"SS","districtName":"Sassari"},{"nome":"Borzonasca","cap":["16041"],"district":"GE","districtName":"Genova"},{"nome":"Bosa","cap":["09089"],"district":"OR","districtName":"Oristano"},{"nome":"Bosaro","cap":["45033"],"district":"RO","districtName":"Rovigo"},{"nome":"Boschi Sant'Anna","cap":["37040"],"district":"VR","districtName":"Verona"},{"nome":"Bosco Chiesanuova","cap":["37021"],"district":"VR","districtName":"Verona"},{"nome":"Bosco Marengo","cap":["15062"],"district":"AL","districtName":"Alessandria"},{"nome":"Bosconero","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Boscoreale","cap":["80041"],"district":"NA","districtName":"Napoli"},{"nome":"Boscotrecase","cap":["80042"],"district":"NA","districtName":"Napoli"},{"nome":"Bosia","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Bosio","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Bosisio Parini","cap":["23842"],"district":"LC","districtName":"Lecco"},{"nome":"Bosnasco","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Bossico","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Bossolasco","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Botricello","cap":["88070"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Botrugno","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Bottanuco","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Botticino","cap":["25082"],"district":"BS","districtName":"Brescia"},{"nome":"Bottidda","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Bova","cap":["89033"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Bova Marina","cap":["89035"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Bovalino","cap":["89034"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Bovegno","cap":["25061"],"district":"BS","districtName":"Brescia"},{"nome":"Boves","cap":["12012"],"district":"CN","districtName":"Cuneo"},{"nome":"Bovezzo","cap":["25073"],"district":"BS","districtName":"Brescia"},{"nome":"Boville Ernica","cap":["03022"],"district":"FR","districtName":"Frosinone"},{"nome":"Bovino","cap":["71023"],"district":"FG","districtName":"Foggia"},{"nome":"Bovisio-Masciago","cap":["20813"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Bovolenta","cap":["35024"],"district":"PD","districtName":"Padova"},{"nome":"Bovolone","cap":["37051"],"district":"VR","districtName":"Verona"},{"nome":"Bozzole","cap":["15040"],"district":"AL","districtName":"Alessandria"},{"nome":"Bozzolo","cap":["46012"],"district":"MN","districtName":"Mantova"},{"nome":"Bra","cap":["12042"],"district":"CN","districtName":"Cuneo"},{"nome":"Bracca","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Bracciano","cap":["00062"],"district":"RM","districtName":"Roma"},{"nome":"Bracigliano","cap":["84082"],"district":"SA","districtName":"Salerno"},{"nome":"Braies","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Brallo di Pregola","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Brancaleone","cap":["89036"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Brandico","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Brandizzo","cap":["10032"],"district":"TO","districtName":"Torino"},{"nome":"Branzi","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Braone","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Brebbia","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Breda di Piave","cap":["31030"],"district":"TV","districtName":"Treviso"},{"nome":"Bregano","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Breganze","cap":["36042"],"district":"VI","districtName":"Vicenza"},{"nome":"Bregnano","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Brembate","cap":["24041"],"district":"BG","districtName":"Bergamo"},{"nome":"Brembate di Sopra","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Brembio","cap":["26822"],"district":"LO","districtName":"Lodi"},{"nome":"Breme","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Brendola","cap":["36040"],"district":"VI","districtName":"Vicenza"},{"nome":"Brenna","cap":["22040"],"district":"CO","districtName":"Como"},{"nome":"Brennero","cap":["39041"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Breno","cap":["25043"],"district":"BS","districtName":"Brescia"},{"nome":"Brenta","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Brentino Belluno","cap":["37020"],"district":"VR","districtName":"Verona"},{"nome":"Brentonico","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Brenzone sul Garda","cap":["37010"],"district":"VR","districtName":"Verona"},{"nome":"Brescello","cap":["42041"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Brescia","cap":["25121","25122","25123","25124","25125","25126","25127","25128","25129","25130","25131","25132","25133","25134","25135","25136"],"district":"BS","districtName":"Brescia"},{"nome":"Bresimo","cap":["38020"],"district":"TN","districtName":"Trento"},{"nome":"Bressana Bottarone","cap":["27042"],"district":"PV","districtName":"Pavia"},{"nome":"Bressanone","cap":["39042"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Bressanvido","cap":["36050"],"district":"VI","districtName":"Vicenza"},{"nome":"Bresso","cap":["20091"],"district":"MI","districtName":"Milano"},{"nome":"Brezzo di Bedero","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Briaglia","cap":["12080"],"district":"CN","districtName":"Cuneo"},{"nome":"Briatico","cap":["89817"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Bricherasio","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Brienno","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Brienza","cap":["85050"],"district":"PZ","districtName":"Potenza"},{"nome":"Briga Alta","cap":["18025"],"district":"CN","districtName":"Cuneo"},{"nome":"Briga Novarese","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Brignano Gera d'Adda","cap":["24053"],"district":"BG","districtName":"Bergamo"},{"nome":"Brignano-Frascata","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Brindisi","cap":["72100"],"district":"BR","districtName":"Brindisi"},{"nome":"Brindisi Montagna","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Brinzio","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Briona","cap":["28072"],"district":"NO","districtName":"Novara"},{"nome":"Brione","cap":["25060"],"district":"BS","districtName":"Brescia"},{"nome":"Briosco","cap":["20836"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Brisighella","cap":["48013"],"district":"RA","districtName":"Ravenna"},{"nome":"Brissago-Valtravaglia","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Brissogne","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Brittoli","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Brivio","cap":["23883"],"district":"LC","districtName":"Lecco"},{"nome":"Broccostella","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Brogliano","cap":["36070"],"district":"VI","districtName":"Vicenza"},{"nome":"Brognaturo","cap":["89822"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Brolo","cap":["98061"],"district":"ME","districtName":"Messina"},{"nome":"Brondello","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Broni","cap":["27043"],"district":"PV","districtName":"Pavia"},{"nome":"Bronte","cap":["95034"],"district":"CT","districtName":"Catania"},{"nome":"Bronzolo","cap":["39051"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Brossasco","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Brosso","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Brovello-Carpugnino","cap":["28833"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Brozolo","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Brugherio","cap":["20861"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Brugine","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Brugnato","cap":["19020"],"district":"SP","districtName":"La Spezia"},{"nome":"Brugnera","cap":["33070"],"district":"PN","districtName":"Pordenone"},{"nome":"Bruino","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Brumano","cap":["24037"],"district":"BG","districtName":"Bergamo"},{"nome":"Brunate","cap":["22034"],"district":"CO","districtName":"Como"},{"nome":"Brunello","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Brunico","cap":["39031"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Bruno","cap":["14046"],"district":"AT","districtName":"Asti"},{"nome":"Brusaporto","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Brusasco","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Brusciano","cap":["80031"],"district":"NA","districtName":"Napoli"},{"nome":"Brusimpiano","cap":["21050"],"district":"VA","districtName":"Varese"},{"nome":"Brusnengo","cap":["13862"],"district":"BI","districtName":"Biella"},{"nome":"Brusson","cap":["11022"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Bruzolo","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Bruzzano Zeffirio","cap":["89030"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Bubbiano","cap":["20080"],"district":"MI","districtName":"Milano"},{"nome":"Bubbio","cap":["14051"],"district":"AT","districtName":"Asti"},{"nome":"Buccheri","cap":["96010"],"district":"SR","districtName":"Siracusa"},{"nome":"Bucchianico","cap":["66011"],"district":"CH","districtName":"Chieti"},{"nome":"Bucciano","cap":["82010"],"district":"BN","districtName":"Benevento"},{"nome":"Buccinasco","cap":["20090"],"district":"MI","districtName":"Milano"},{"nome":"Buccino","cap":["84021"],"district":"SA","districtName":"Salerno"},{"nome":"Bucine","cap":["52021"],"district":"AR","districtName":"Arezzo"},{"nome":"Buddusò","cap":["07020"],"district":"SS","districtName":"Sassari"},{"nome":"Budoia","cap":["33070"],"district":"PN","districtName":"Pordenone"},{"nome":"Budoni","cap":["07051"],"district":"SS","districtName":"Sassari"},{"nome":"Budrio","cap":["40054"],"district":"BO","districtName":"Bologna"},{"nome":"Buggerru","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Buggiano","cap":["51011"],"district":"PT","districtName":"Pistoia"},{"nome":"Buglio in Monte","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Bugnara","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Buguggiate","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Buja","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"Bulciago","cap":["23892"],"district":"LC","districtName":"Lecco"},{"nome":"Bulgarograsso","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Bultei","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Bulzi","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Buonabitacolo","cap":["84032"],"district":"SA","districtName":"Salerno"},{"nome":"Buonalbergo","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Buonconvento","cap":["53022"],"district":"SI","districtName":"Siena"},{"nome":"Buonvicino","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Burago di Molgora","cap":["20875"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Burcei","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Burgio","cap":["92010"],"district":"AG","districtName":"Agrigento"},{"nome":"Burgos","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Buriasco","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Burolo","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Buronzo","cap":["13040"],"district":"VC","districtName":"Vercelli"},{"nome":"Busachi","cap":["09082"],"district":"OR","districtName":"Oristano"},{"nome":"Busalla","cap":["16012"],"district":"GE","districtName":"Genova"},{"nome":"Busano","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Busca","cap":["12022"],"district":"CN","districtName":"Cuneo"},{"nome":"Buscate","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Buscemi","cap":["96010"],"district":"SR","districtName":"Siracusa"},{"nome":"Buseto Palizzolo","cap":["91012"],"district":"TP","districtName":"Trapani"},{"nome":"Busnago","cap":["20874"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Bussero","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Busseto","cap":["43011"],"district":"PR","districtName":"Parma"},{"nome":"Bussi sul Tirino","cap":["65022"],"district":"PE","districtName":"Pescara"},{"nome":"Busso","cap":["86010"],"district":"CB","districtName":"Campobasso"},{"nome":"Bussolengo","cap":["37012"],"district":"VR","districtName":"Verona"},{"nome":"Bussoleno","cap":["10053"],"district":"TO","districtName":"Torino"},{"nome":"Busto Arsizio","cap":["21052"],"district":"VA","districtName":"Varese"},{"nome":"Busto Garolfo","cap":["20020"],"district":"MI","districtName":"Milano"},{"nome":"Butera","cap":["93011"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Buti","cap":["56032"],"district":"PI","districtName":"Pisa"},{"nome":"Buttapietra","cap":["37060"],"district":"VR","districtName":"Verona"},{"nome":"Buttigliera Alta","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Buttigliera d'Asti","cap":["14021"],"district":"AT","districtName":"Asti"},{"nome":"Buttrio","cap":["33042"],"district":"UD","districtName":"Udine"},{"nome":"Cabella Ligure","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Cabiate","cap":["22060"],"district":"CO","districtName":"Como"},{"nome":"Cabras","cap":["09072"],"district":"OR","districtName":"Oristano"},{"nome":"Caccamo","cap":["90012"],"district":"PA","districtName":"Palermo"},{"nome":"Caccuri","cap":["88833"],"district":"KR","districtName":"Crotone"},{"nome":"Cadegliano-Viconago","cap":["21031"],"district":"VA","districtName":"Varese"},{"nome":"Cadelbosco di Sopra","cap":["42023"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Cadeo","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Caderzone Terme","cap":["38080"],"district":"TN","districtName":"Trento"},{"nome":"Cadoneghe","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Cadorago","cap":["22071"],"district":"CO","districtName":"Como"},{"nome":"Cadrezzate con Osmate","cap":["21062"],"district":"VA","districtName":"Varese"},{"nome":"Caerano di San Marco","cap":["31031"],"district":"TV","districtName":"Treviso"},{"nome":"Cafasse","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Caggiano","cap":["84030"],"district":"SA","districtName":"Salerno"},{"nome":"Cagli","cap":["61043"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Cagliari","cap":["09121","09122","09123","09124","09125","09126","09127","09128","09129","09130","09131","09132","09133","09134"],"district":"CA","districtName":"Cagliari"},{"nome":"Caglio","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Cagnano Amiterno","cap":["67012"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Cagnano Varano","cap":["71010"],"district":"FG","districtName":"Foggia"},{"nome":"Caianello","cap":["81059"],"district":"CE","districtName":"Caserta"},{"nome":"Caiazzo","cap":["81013"],"district":"CE","districtName":"Caserta"},{"nome":"Caines","cap":["39010"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Caino","cap":["25070"],"district":"BS","districtName":"Brescia"},{"nome":"Caiolo","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Cairano","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Cairate","cap":["21050"],"district":"VA","districtName":"Varese"},{"nome":"Cairo Montenotte","cap":["17014"],"district":"SV","districtName":"Savona"},{"nome":"Caivano","cap":["80023"],"district":"NA","districtName":"Napoli"},{"nome":"Calabritto","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Calalzo di Cadore","cap":["32042"],"district":"BL","districtName":"Belluno"},{"nome":"Calamandrana","cap":["14042"],"district":"AT","districtName":"Asti"},{"nome":"Calamonaci","cap":["92010"],"district":"AG","districtName":"Agrigento"},{"nome":"Calangianus","cap":["07023"],"district":"SS","districtName":"Sassari"},{"nome":"Calanna","cap":["89050"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Calasca-Castiglione","cap":["28873"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Calascibetta","cap":["94010"],"district":"EN","districtName":"Enna"},{"nome":"Calascio","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Calasetta","cap":["09011"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Calatabiano","cap":["95011"],"district":"CT","districtName":"Catania"},{"nome":"Calatafimi-Segesta","cap":["91013"],"district":"TP","districtName":"Trapani"},{"nome":"Calcata","cap":["01030"],"district":"VT","districtName":"Viterbo"},{"nome":"Calceranica al Lago","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Calci","cap":["56011"],"district":"PI","districtName":"Pisa"},{"nome":"Calciano","cap":["75010"],"district":"MT","districtName":"Matera"},{"nome":"Calcinaia","cap":["56012"],"district":"PI","districtName":"Pisa"},{"nome":"Calcinate","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Calcinato","cap":["25011"],"district":"BS","districtName":"Brescia"},{"nome":"Calcio","cap":["24054"],"district":"BG","districtName":"Bergamo"},{"nome":"Calco","cap":["23885"],"district":"LC","districtName":"Lecco"},{"nome":"Caldaro sulla strada del vino","cap":["39052"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Caldarola","cap":["62020"],"district":"MC","districtName":"Macerata"},{"nome":"Calderara di Reno","cap":["40012"],"district":"BO","districtName":"Bologna"},{"nome":"Caldes","cap":["38022"],"district":"TN","districtName":"Trento"},{"nome":"Caldiero","cap":["37042"],"district":"VR","districtName":"Verona"},{"nome":"Caldogno","cap":["36030"],"district":"VI","districtName":"Vicenza"},{"nome":"Caldonazzo","cap":["38052"],"district":"TN","districtName":"Trento"},{"nome":"Calendasco","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Calenzano","cap":["50041"],"district":"FI","districtName":"Firenze"},{"nome":"Calestano","cap":["43030"],"district":"PR","districtName":"Parma"},{"nome":"Calice al Cornoviglio","cap":["19020"],"district":"SP","districtName":"La Spezia"},{"nome":"Calice Ligure","cap":["17020"],"district":"SV","districtName":"Savona"},{"nome":"Calimera","cap":["73021"],"district":"LE","districtName":"Lecce"},{"nome":"Calitri","cap":["83045"],"district":"AV","districtName":"Avellino"},{"nome":"Calizzano","cap":["17057"],"district":"SV","districtName":"Savona"},{"nome":"Callabiana","cap":["13821"],"district":"BI","districtName":"Biella"},{"nome":"Calliano","cap":["14031"],"district":"AT","districtName":"Asti"},{"nome":"Calliano","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Calolziocorte","cap":["23801"],"district":"LC","districtName":"Lecco"},{"nome":"Calopezzati","cap":["87060"],"district":"CS","districtName":"Cosenza"},{"nome":"Calosso","cap":["14052"],"district":"AT","districtName":"Asti"},{"nome":"Caloveto","cap":["87060"],"district":"CS","districtName":"Cosenza"},{"nome":"Caltabellotta","cap":["92010"],"district":"AG","districtName":"Agrigento"},{"nome":"Caltagirone","cap":["95041"],"district":"CT","districtName":"Catania"},{"nome":"Caltanissetta","cap":["93100"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Caltavuturo","cap":["90022"],"district":"PA","districtName":"Palermo"},{"nome":"Caltignaga","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Calto","cap":["45030"],"district":"RO","districtName":"Rovigo"},{"nome":"Caltrano","cap":["36030"],"district":"VI","districtName":"Vicenza"},{"nome":"Calusco d'Adda","cap":["24033"],"district":"BG","districtName":"Bergamo"},{"nome":"Caluso","cap":["10014"],"district":"TO","districtName":"Torino"},{"nome":"Calvagese della Riviera","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Calvanico","cap":["84080"],"district":"SA","districtName":"Salerno"},{"nome":"Calvatone","cap":["26030"],"district":"CR","districtName":"Cremona"},{"nome":"Calvello","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Calvene","cap":["36030"],"district":"VI","districtName":"Vicenza"},{"nome":"Calvenzano","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Calvera","cap":["85030"],"district":"PZ","districtName":"Potenza"},{"nome":"Calvi","cap":["82018"],"district":"BN","districtName":"Benevento"},{"nome":"Calvi dell'Umbria","cap":["05032"],"district":"TR","districtName":"Terni"},{"nome":"Calvi Risorta","cap":["81042"],"district":"CE","districtName":"Caserta"},{"nome":"Calvignano","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Calvignasco","cap":["20080"],"district":"MI","districtName":"Milano"},{"nome":"Calvisano","cap":["25012"],"district":"BS","districtName":"Brescia"},{"nome":"Calvizzano","cap":["80012"],"district":"NA","districtName":"Napoli"},{"nome":"Camagna Monferrato","cap":["15030"],"district":"AL","districtName":"Alessandria"},{"nome":"Camaiore","cap":["55041"],"district":"LU","districtName":"Lucca"},{"nome":"Camandona","cap":["13821"],"district":"BI","districtName":"Biella"},{"nome":"Camastra","cap":["92020"],"district":"AG","districtName":"Agrigento"},{"nome":"Cambiago","cap":["20040"],"district":"MI","districtName":"Milano"},{"nome":"Cambiano","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Cambiasca","cap":["28814"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Camburzano","cap":["13891"],"district":"BI","districtName":"Biella"},{"nome":"Camerana","cap":["12072"],"district":"CN","districtName":"Cuneo"},{"nome":"Camerano","cap":["60021"],"district":"AN","districtName":"Ancona"},{"nome":"Camerano Casasco","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Camerata Cornello","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Camerata Nuova","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Camerata Picena","cap":["60020"],"district":"AN","districtName":"Ancona"},{"nome":"Cameri","cap":["28062"],"district":"NO","districtName":"Novara"},{"nome":"Camerino","cap":["62032"],"district":"MC","districtName":"Macerata"},{"nome":"Camerota","cap":["84059"],"district":"SA","districtName":"Salerno"},{"nome":"Camigliano","cap":["81050"],"district":"CE","districtName":"Caserta"},{"nome":"Camini","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Camino","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Camino al Tagliamento","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"Camisano","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Camisano Vicentino","cap":["36043"],"district":"VI","districtName":"Vicenza"},{"nome":"Cammarata","cap":["92022"],"district":"AG","districtName":"Agrigento"},{"nome":"Camogli","cap":["16032"],"district":"GE","districtName":"Genova"},{"nome":"Campagna","cap":["84022"],"district":"SA","districtName":"Salerno"},{"nome":"Campagna Lupia","cap":["30010"],"district":"VE","districtName":"Venezia"},{"nome":"Campagnano di Roma","cap":["00063"],"district":"RM","districtName":"Roma"},{"nome":"Campagnatico","cap":["58042"],"district":"GR","districtName":"Grosseto"},{"nome":"Campagnola Cremasca","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Campagnola Emilia","cap":["42012"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Campana","cap":["87061"],"district":"CS","districtName":"Cosenza"},{"nome":"Camparada","cap":["20857"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Campegine","cap":["42040"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Campello sul Clitunno","cap":["06042"],"district":"PG","districtName":"Perugia"},{"nome":"Campertogno","cap":["13023"],"district":"VC","districtName":"Vercelli"},{"nome":"Campi Bisenzio","cap":["50013"],"district":"FI","districtName":"Firenze"},{"nome":"Campi Salentina","cap":["73012"],"district":"LE","districtName":"Lecce"},{"nome":"Campiglia Cervo","cap":["13812"],"district":"BI","districtName":"Biella"},{"nome":"Campiglia dei Berici","cap":["36020"],"district":"VI","districtName":"Vicenza"},{"nome":"Campiglia Marittima","cap":["57021"],"district":"LI","districtName":"Livorno"},{"nome":"Campiglione Fenile","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Campione d'Italia","cap":["22060"],"district":"CO","districtName":"Como"},{"nome":"Campitello di Fassa","cap":["38031"],"district":"TN","districtName":"Trento"},{"nome":"Campli","cap":["64012"],"district":"TE","districtName":"Teramo"},{"nome":"Campo Calabro","cap":["89052"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Campo di Giove","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Campo di Trens","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Campo Ligure","cap":["16013"],"district":"GE","districtName":"Genova"},{"nome":"Campo nell'Elba","cap":["57034"],"district":"LI","districtName":"Livorno"},{"nome":"Campo San Martino","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Campo Tures","cap":["39032"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Campobasso","cap":["86100"],"district":"CB","districtName":"Campobasso"},{"nome":"Campobello di Licata","cap":["92023"],"district":"AG","districtName":"Agrigento"},{"nome":"Campobello di Mazara","cap":["91021"],"district":"TP","districtName":"Trapani"},{"nome":"Campochiaro","cap":["86020"],"district":"CB","districtName":"Campobasso"},{"nome":"Campodarsego","cap":["35011"],"district":"PD","districtName":"Padova"},{"nome":"Campodenno","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Campodimele","cap":["04020"],"district":"LT","districtName":"Latina"},{"nome":"Campodipietra","cap":["86010"],"district":"CB","districtName":"Campobasso"},{"nome":"Campodolcino","cap":["23021"],"district":"SO","districtName":"Sondrio"},{"nome":"Campodoro","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Campofelice di Fitalia","cap":["90030"],"district":"PA","districtName":"Palermo"},{"nome":"Campofelice di Roccella","cap":["90010"],"district":"PA","districtName":"Palermo"},{"nome":"Campofilone","cap":["63828"],"district":"FM","districtName":"Fermo"},{"nome":"Campofiorito","cap":["90030"],"district":"PA","districtName":"Palermo"},{"nome":"Campoformido","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"Campofranco","cap":["93010"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Campogalliano","cap":["41011"],"district":"MO","districtName":"Modena"},{"nome":"Campolattaro","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Campoli Appennino","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Campoli del Monte Taburno","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Campolieto","cap":["86040"],"district":"CB","districtName":"Campobasso"},{"nome":"Campolongo Maggiore","cap":["30010"],"district":"VE","districtName":"Venezia"},{"nome":"Campolongo Tapogliano","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Campomaggiore","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Campomarino","cap":["86042"],"district":"CB","districtName":"Campobasso"},{"nome":"Campomorone","cap":["16014"],"district":"GE","districtName":"Genova"},{"nome":"Camponogara","cap":["30010"],"district":"VE","districtName":"Venezia"},{"nome":"Campora","cap":["84040"],"district":"SA","districtName":"Salerno"},{"nome":"Camporeale","cap":["90043"],"district":"PA","districtName":"Palermo"},{"nome":"Camporgiano","cap":["55031"],"district":"LU","districtName":"Lucca"},{"nome":"Camporosso","cap":["18033"],"district":"IM","districtName":"Imperia"},{"nome":"Camporotondo di Fiastrone","cap":["62020"],"district":"MC","districtName":"Macerata"},{"nome":"Camporotondo Etneo","cap":["95040"],"district":"CT","districtName":"Catania"},{"nome":"Camposampiero","cap":["35012"],"district":"PD","districtName":"Padova"},{"nome":"Camposano","cap":["80030"],"district":"NA","districtName":"Napoli"},{"nome":"Camposanto","cap":["41031"],"district":"MO","districtName":"Modena"},{"nome":"Campospinoso","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Campotosto","cap":["67013"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Camugnano","cap":["40032"],"district":"BO","districtName":"Bologna"},{"nome":"Canal San Bovo","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Canale","cap":["12043"],"district":"CN","districtName":"Cuneo"},{"nome":"Canale d'Agordo","cap":["32020"],"district":"BL","districtName":"Belluno"},{"nome":"Canale Monterano","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Canaro","cap":["45034"],"district":"RO","districtName":"Rovigo"},{"nome":"Canazei","cap":["38032"],"district":"TN","districtName":"Trento"},{"nome":"Cancellara","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Cancello ed Arnone","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Canda","cap":["45020"],"district":"RO","districtName":"Rovigo"},{"nome":"Candela","cap":["71024"],"district":"FG","districtName":"Foggia"},{"nome":"Candelo","cap":["13878"],"district":"BI","districtName":"Biella"},{"nome":"Candia Canavese","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Candia Lomellina","cap":["27031"],"district":"PV","districtName":"Pavia"},{"nome":"Candiana","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Candida","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Candidoni","cap":["89020"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Candiolo","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Canegrate","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Canelli","cap":["14053"],"district":"AT","districtName":"Asti"},{"nome":"Canepina","cap":["01030"],"district":"VT","districtName":"Viterbo"},{"nome":"Caneva","cap":["33070"],"district":"PN","districtName":"Pordenone"},{"nome":"Canicattì","cap":["92024"],"district":"AG","districtName":"Agrigento"},{"nome":"Canicattini Bagni","cap":["96010"],"district":"SR","districtName":"Siracusa"},{"nome":"Canino","cap":["01011"],"district":"VT","districtName":"Viterbo"},{"nome":"Canischio","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Canistro","cap":["67050"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Canna","cap":["87070"],"district":"CS","districtName":"Cosenza"},{"nome":"Cannalonga","cap":["84040"],"district":"SA","districtName":"Salerno"},{"nome":"Cannara","cap":["06033"],"district":"PG","districtName":"Perugia"},{"nome":"Cannero Riviera","cap":["28821"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Canneto Pavese","cap":["27044"],"district":"PV","districtName":"Pavia"},{"nome":"Canneto sull'Oglio","cap":["46013"],"district":"MN","districtName":"Mantova"},{"nome":"Cannobio","cap":["28822"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Cannole","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Canolo","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Canonica d'Adda","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Canosa di Puglia","cap":["76012"],"district":"BT","districtName":"Barletta-Andria-Trani"},{"nome":"Canosa Sannita","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Canosio","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Canossa","cap":["42026"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Cansano","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Cantagallo","cap":["59025"],"district":"PO","districtName":"Prato"},{"nome":"Cantalice","cap":["02014"],"district":"RI","districtName":"Rieti"},{"nome":"Cantalupa","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Cantalupo in Sabina","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Cantalupo Ligure","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Cantalupo nel Sannio","cap":["86092"],"district":"IS","districtName":"Isernia"},{"nome":"Cantarana","cap":["14010"],"district":"AT","districtName":"Asti"},{"nome":"Cantello","cap":["21050"],"district":"VA","districtName":"Varese"},{"nome":"Canterano","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Cantiano","cap":["61044"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Cantoira","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Cantù","cap":["22063"],"district":"CO","districtName":"Como"},{"nome":"Canzano","cap":["64020"],"district":"TE","districtName":"Teramo"},{"nome":"Canzo","cap":["22035"],"district":"CO","districtName":"Como"},{"nome":"Caorle","cap":["30021"],"district":"VE","districtName":"Venezia"},{"nome":"Caorso","cap":["29012"],"district":"PC","districtName":"Piacenza"},{"nome":"Capaccio Paestum","cap":["84047"],"district":"SA","districtName":"Salerno"},{"nome":"Capaci","cap":["90040"],"district":"PA","districtName":"Palermo"},{"nome":"Capalbio","cap":["58011"],"district":"GR","districtName":"Grosseto"},{"nome":"Capannoli","cap":["56033"],"district":"PI","districtName":"Pisa"},{"nome":"Capannori","cap":["55012"],"district":"LU","districtName":"Lucca"},{"nome":"Capena","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Capergnanica","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Capestrano","cap":["67022"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Capiago Intimiano","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Capistrano","cap":["89818"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Capistrello","cap":["67053"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Capitignano","cap":["67014"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Capizzi","cap":["98031"],"district":"ME","districtName":"Messina"},{"nome":"Capizzone","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Capo d'Orlando","cap":["98071"],"district":"ME","districtName":"Messina"},{"nome":"Capo di Ponte","cap":["25044"],"district":"BS","districtName":"Brescia"},{"nome":"Capodimonte","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Capodrise","cap":["81020"],"district":"CE","districtName":"Caserta"},{"nome":"Capoliveri","cap":["57031"],"district":"LI","districtName":"Livorno"},{"nome":"Capolona","cap":["52010"],"district":"AR","districtName":"Arezzo"},{"nome":"Caponago","cap":["20867"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Caporciano","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Caposele","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Capoterra","cap":["09012"],"district":"CA","districtName":"Cagliari"},{"nome":"Capovalle","cap":["25070"],"district":"BS","districtName":"Brescia"},{"nome":"Cappadocia","cap":["67060"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Cappella Cantone","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Cappella de' Picenardi","cap":["26030"],"district":"CR","districtName":"Cremona"},{"nome":"Cappella Maggiore","cap":["31012"],"district":"TV","districtName":"Treviso"},{"nome":"Cappelle sul Tavo","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Capracotta","cap":["86082"],"district":"IS","districtName":"Isernia"},{"nome":"Capraia e Limite","cap":["50050"],"district":"FI","districtName":"Firenze"},{"nome":"Capraia Isola","cap":["57032"],"district":"LI","districtName":"Livorno"},{"nome":"Capralba","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Capranica","cap":["01012"],"district":"VT","districtName":"Viterbo"},{"nome":"Capranica Prenestina","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"Caprarica di Lecce","cap":["73010"],"district":"LE","districtName":"Lecce"},{"nome":"Caprarola","cap":["01032"],"district":"VT","districtName":"Viterbo"},{"nome":"Caprauna","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Caprese Michelangelo","cap":["52033"],"district":"AR","districtName":"Arezzo"},{"nome":"Caprezzo","cap":["28815"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Capri","cap":["80073"],"district":"NA","districtName":"Napoli"},{"nome":"Capri Leone","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Capriana","cap":["38030"],"district":"TN","districtName":"Trento"},{"nome":"Capriano del Colle","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Capriata d'Orba","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Capriate San Gervasio","cap":["24042"],"district":"BG","districtName":"Bergamo"},{"nome":"Capriati a Volturno","cap":["81014"],"district":"CE","districtName":"Caserta"},{"nome":"Caprie","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Capriglia Irpina","cap":["83010"],"district":"AV","districtName":"Avellino"},{"nome":"Capriglio","cap":["14014"],"district":"AT","districtName":"Asti"},{"nome":"Caprile","cap":["13864"],"district":"BI","districtName":"Biella"},{"nome":"Caprino Bergamasco","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Caprino Veronese","cap":["37013"],"district":"VR","districtName":"Verona"},{"nome":"Capriolo","cap":["25031"],"district":"BS","districtName":"Brescia"},{"nome":"Capriva del Friuli","cap":["34070"],"district":"GO","districtName":"Gorizia"},{"nome":"Capua","cap":["81043"],"district":"CE","districtName":"Caserta"},{"nome":"Capurso","cap":["70010"],"district":"BA","districtName":"Bari"},{"nome":"Caraffa del Bianco","cap":["89030"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Caraffa di Catanzaro","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Caraglio","cap":["12023"],"district":"CN","districtName":"Cuneo"},{"nome":"Caramagna Piemonte","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Caramanico Terme","cap":["65023"],"district":"PE","districtName":"Pescara"},{"nome":"Carapelle","cap":["71041"],"district":"FG","districtName":"Foggia"},{"nome":"Carapelle Calvisio","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Carasco","cap":["16042"],"district":"GE","districtName":"Genova"},{"nome":"Carassai","cap":["63063"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Carate Brianza","cap":["20841"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Carate Urio","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Caravaggio","cap":["24043"],"district":"BG","districtName":"Bergamo"},{"nome":"Caravate","cap":["21032"],"district":"VA","districtName":"Varese"},{"nome":"Caravino","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Caravonica","cap":["18020"],"district":"IM","districtName":"Imperia"},{"nome":"Carbognano","cap":["01030"],"district":"VT","districtName":"Viterbo"},{"nome":"Carbonara al Ticino","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Carbonara di Nola","cap":["80030"],"district":"NA","districtName":"Napoli"},{"nome":"Carbonara Scrivia","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Carbonate","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Carbone","cap":["85030"],"district":"PZ","districtName":"Potenza"},{"nome":"Carbonera","cap":["31030"],"district":"TV","districtName":"Treviso"},{"nome":"Carbonia","cap":["09013"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Carcare","cap":["17043"],"district":"SV","districtName":"Savona"},{"nome":"Carceri","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Carcoforo","cap":["13026"],"district":"VC","districtName":"Vercelli"},{"nome":"Cardano al Campo","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Cardè","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Cardedu","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Cardeto","cap":["89060"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Cardinale","cap":["88062"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Cardito","cap":["80024"],"district":"NA","districtName":"Napoli"},{"nome":"Careggine","cap":["55030"],"district":"LU","districtName":"Lucca"},{"nome":"Carema","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Carenno","cap":["23802"],"district":"LC","districtName":"Lecco"},{"nome":"Carentino","cap":["15026"],"district":"AL","districtName":"Alessandria"},{"nome":"Careri","cap":["89030"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Caresana","cap":["13010"],"district":"VC","districtName":"Vercelli"},{"nome":"Caresanablot","cap":["13030"],"district":"VC","districtName":"Vercelli"},{"nome":"Carezzano","cap":["15051"],"district":"AL","districtName":"Alessandria"},{"nome":"Carfizzi","cap":["88817"],"district":"KR","districtName":"Crotone"},{"nome":"Cargeghe","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Cariati","cap":["87062"],"district":"CS","districtName":"Cosenza"},{"nome":"Carife","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Carignano","cap":["10041"],"district":"TO","districtName":"Torino"},{"nome":"Carimate","cap":["22060"],"district":"CO","districtName":"Como"},{"nome":"Carinaro","cap":["81032"],"district":"CE","districtName":"Caserta"},{"nome":"Carini","cap":["90044"],"district":"PA","districtName":"Palermo"},{"nome":"Carinola","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Carisio","cap":["13040"],"district":"VC","districtName":"Vercelli"},{"nome":"Carisolo","cap":["38080"],"district":"TN","districtName":"Trento"},{"nome":"Carlantino","cap":["71030"],"district":"FG","districtName":"Foggia"},{"nome":"Carlazzo","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Carlentini","cap":["96013"],"district":"SR","districtName":"Siracusa"},{"nome":"Carlino","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Carloforte","cap":["09014"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Carlopoli","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Carmagnola","cap":["10022"],"district":"TO","districtName":"Torino"},{"nome":"Carmiano","cap":["73041"],"district":"LE","districtName":"Lecce"},{"nome":"Carmignano","cap":["59015"],"district":"PO","districtName":"Prato"},{"nome":"Carmignano di Brenta","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Carnago","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Carnate","cap":["20866"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Carobbio degli Angeli","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Carolei","cap":["87030"],"district":"CS","districtName":"Cosenza"},{"nome":"Carona","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Caronia","cap":["98072"],"district":"ME","districtName":"Messina"},{"nome":"Caronno Pertusella","cap":["21042"],"district":"VA","districtName":"Varese"},{"nome":"Caronno Varesino","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Carosino","cap":["74021"],"district":"TA","districtName":"Taranto"},{"nome":"Carovigno","cap":["72012"],"district":"BR","districtName":"Brindisi"},{"nome":"Carovilli","cap":["86083"],"district":"IS","districtName":"Isernia"},{"nome":"Carpaneto Piacentino","cap":["29013"],"district":"PC","districtName":"Piacenza"},{"nome":"Carpanzano","cap":["87050"],"district":"CS","districtName":"Cosenza"},{"nome":"Carpegna","cap":["61021"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Carpenedolo","cap":["25013"],"district":"BS","districtName":"Brescia"},{"nome":"Carpeneto","cap":["15071"],"district":"AL","districtName":"Alessandria"},{"nome":"Carpi","cap":["41012"],"district":"MO","districtName":"Modena"},{"nome":"Carpiano","cap":["20080"],"district":"MI","districtName":"Milano"},{"nome":"Carpignano Salentino","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Carpignano Sesia","cap":["28064"],"district":"NO","districtName":"Novara"},{"nome":"Carpineti","cap":["42033"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Carpineto della Nora","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Carpineto Romano","cap":["00032"],"district":"RM","districtName":"Roma"},{"nome":"Carpineto Sinello","cap":["66030"],"district":"CH","districtName":"Chieti"},{"nome":"Carpino","cap":["71010"],"district":"FG","districtName":"Foggia"},{"nome":"Carpinone","cap":["86093"],"district":"IS","districtName":"Isernia"},{"nome":"Carrara","cap":["54033"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Carrè","cap":["36010"],"district":"VI","districtName":"Vicenza"},{"nome":"Carrega Ligure","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Carro","cap":["19012"],"district":"SP","districtName":"La Spezia"},{"nome":"Carrodano","cap":["19020"],"district":"SP","districtName":"La Spezia"},{"nome":"Carrosio","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Carrù","cap":["12061"],"district":"CN","districtName":"Cuneo"},{"nome":"Carsoli","cap":["67061"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Cartigliano","cap":["36050"],"district":"VI","districtName":"Vicenza"},{"nome":"Cartignano","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Cartoceto","cap":["61030"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Cartosio","cap":["15015"],"district":"AL","districtName":"Alessandria"},{"nome":"Cartura","cap":["35025"],"district":"PD","districtName":"Padova"},{"nome":"Carugate","cap":["20061"],"district":"MI","districtName":"Milano"},{"nome":"Carugo","cap":["22060"],"district":"CO","districtName":"Como"},{"nome":"Carunchio","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Carvico","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Carzano","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Casabona","cap":["88822"],"district":"KR","districtName":"Crotone"},{"nome":"Casacalenda","cap":["86043"],"district":"CB","districtName":"Campobasso"},{"nome":"Casacanditella","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Casagiove","cap":["81022"],"district":"CE","districtName":"Caserta"},{"nome":"Casal Cermelli","cap":["15072"],"district":"AL","districtName":"Alessandria"},{"nome":"Casal di Principe","cap":["81033"],"district":"CE","districtName":"Caserta"},{"nome":"Casal Velino","cap":["84040"],"district":"SA","districtName":"Salerno"},{"nome":"Casalanguida","cap":["66031"],"district":"CH","districtName":"Chieti"},{"nome":"Casalattico","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Casalbeltrame","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"Casalbordino","cap":["66021"],"district":"CH","districtName":"Chieti"},{"nome":"Casalbore","cap":["83034"],"district":"AV","districtName":"Avellino"},{"nome":"Casalborgone","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Casalbuono","cap":["84030"],"district":"SA","districtName":"Salerno"},{"nome":"Casalbuttano ed Uniti","cap":["26011"],"district":"CR","districtName":"Cremona"},{"nome":"Casalciprano","cap":["86010"],"district":"CB","districtName":"Campobasso"},{"nome":"Casalduni","cap":["82027"],"district":"BN","districtName":"Benevento"},{"nome":"Casale Corte Cerro","cap":["28881"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Casale Cremasco-Vidolasco","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Casale di Scodosia","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Casale Litta","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Casale Marittimo","cap":["56040"],"district":"PI","districtName":"Pisa"},{"nome":"Casale Monferrato","cap":["15033"],"district":"AL","districtName":"Alessandria"},{"nome":"Casale sul Sile","cap":["31032"],"district":"TV","districtName":"Treviso"},{"nome":"Casalecchio di Reno","cap":["40033"],"district":"BO","districtName":"Bologna"},{"nome":"Casaleggio Boiro","cap":["15070"],"district":"AL","districtName":"Alessandria"},{"nome":"Casaleggio Novara","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"Casaleone","cap":["37052"],"district":"VR","districtName":"Verona"},{"nome":"Casaletto Ceredano","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Casaletto di Sopra","cap":["26014"],"district":"CR","districtName":"Cremona"},{"nome":"Casaletto Lodigiano","cap":["26852"],"district":"LO","districtName":"Lodi"},{"nome":"Casaletto Spartano","cap":["84030"],"district":"SA","districtName":"Salerno"},{"nome":"Casaletto Vaprio","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Casalfiumanese","cap":["40020"],"district":"BO","districtName":"Bologna"},{"nome":"Casalgrande","cap":["42013"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Casalgrasso","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Casali del Manco","cap":["87059"],"district":"CS","districtName":"Cosenza"},{"nome":"Casalincontrada","cap":["66012"],"district":"CH","districtName":"Chieti"},{"nome":"Casalino","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"Casalmaggiore","cap":["26041"],"district":"CR","districtName":"Cremona"},{"nome":"Casalmaiocco","cap":["26831"],"district":"LO","districtName":"Lodi"},{"nome":"Casalmorano","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Casalmoro","cap":["46040"],"district":"MN","districtName":"Mantova"},{"nome":"Casalnoceto","cap":["15052"],"district":"AL","districtName":"Alessandria"},{"nome":"Casalnuovo di Napoli","cap":["80013"],"district":"NA","districtName":"Napoli"},{"nome":"Casalnuovo Monterotaro","cap":["71033"],"district":"FG","districtName":"Foggia"},{"nome":"Casaloldo","cap":["46040"],"district":"MN","districtName":"Mantova"},{"nome":"Casalpusterlengo","cap":["26841"],"district":"LO","districtName":"Lodi"},{"nome":"Casalromano","cap":["46040"],"district":"MN","districtName":"Mantova"},{"nome":"Casalserugo","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Casaluce","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Casalvecchio di Puglia","cap":["71030"],"district":"FG","districtName":"Foggia"},{"nome":"Casalvecchio Siculo","cap":["98032"],"district":"ME","districtName":"Messina"},{"nome":"Casalvieri","cap":["03034"],"district":"FR","districtName":"Frosinone"},{"nome":"Casalvolone","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"Casalzuigno","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Casamarciano","cap":["80032"],"district":"NA","districtName":"Napoli"},{"nome":"Casamassima","cap":["70010"],"district":"BA","districtName":"Bari"},{"nome":"Casamicciola Terme","cap":["80074"],"district":"NA","districtName":"Napoli"},{"nome":"Casandrino","cap":["80025"],"district":"NA","districtName":"Napoli"},{"nome":"Casanova Elvo","cap":["13030"],"district":"VC","districtName":"Vercelli"},{"nome":"Casanova Lerrone","cap":["17033"],"district":"SV","districtName":"Savona"},{"nome":"Casanova Lonati","cap":["27041"],"district":"PV","districtName":"Pavia"},{"nome":"Casape","cap":["00010"],"district":"RM","districtName":"Roma"},{"nome":"Casapesenna","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Casapinta","cap":["13866"],"district":"BI","districtName":"Biella"},{"nome":"Casaprota","cap":["02030"],"district":"RI","districtName":"Rieti"},{"nome":"Casapulla","cap":["81020"],"district":"CE","districtName":"Caserta"},{"nome":"Casarano","cap":["73042"],"district":"LE","districtName":"Lecce"},{"nome":"Casargo","cap":["23831"],"district":"LC","districtName":"Lecco"},{"nome":"Casarile","cap":["20080"],"district":"MI","districtName":"Milano"},{"nome":"Casarsa della Delizia","cap":["33072"],"district":"PN","districtName":"Pordenone"},{"nome":"Casarza Ligure","cap":["16030"],"district":"GE","districtName":"Genova"},{"nome":"Casasco","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Casatenovo","cap":["23880"],"district":"LC","districtName":"Lecco"},{"nome":"Casatisma","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Casavatore","cap":["80020"],"district":"NA","districtName":"Napoli"},{"nome":"Casazza","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Cascia","cap":["06043"],"district":"PG","districtName":"Perugia"},{"nome":"Casciago","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Casciana Terme Lari","cap":["56035"],"district":"PI","districtName":"Pisa"},{"nome":"Cascina","cap":["56021"],"district":"PI","districtName":"Pisa"},{"nome":"Cascinette d'Ivrea","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Casei Gerola","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Caselette","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Casella","cap":["16015"],"district":"GE","districtName":"Genova"},{"nome":"Caselle in Pittari","cap":["84030"],"district":"SA","districtName":"Salerno"},{"nome":"Caselle Landi","cap":["26842"],"district":"LO","districtName":"Lodi"},{"nome":"Caselle Lurani","cap":["26853"],"district":"LO","districtName":"Lodi"},{"nome":"Caselle Torinese","cap":["10072"],"district":"TO","districtName":"Torino"},{"nome":"Caserta","cap":["81100"],"district":"CE","districtName":"Caserta"},{"nome":"Casier","cap":["31030"],"district":"TV","districtName":"Treviso"},{"nome":"Casignana","cap":["89030"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Casina","cap":["42034"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Casirate d'Adda","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Caslino d'Erba","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Casnate con Bernate","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Casnigo","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Casola di Napoli","cap":["80050"],"district":"NA","districtName":"Napoli"},{"nome":"Casola in Lunigiana","cap":["54014"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Casola Valsenio","cap":["48032"],"district":"RA","districtName":"Ravenna"},{"nome":"Casole d'Elsa","cap":["53031"],"district":"SI","districtName":"Siena"},{"nome":"Casoli","cap":["66043"],"district":"CH","districtName":"Chieti"},{"nome":"Casorate Primo","cap":["27022"],"district":"PV","districtName":"Pavia"},{"nome":"Casorate Sempione","cap":["21011"],"district":"VA","districtName":"Varese"},{"nome":"Casorezzo","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Casoria","cap":["80026"],"district":"NA","districtName":"Napoli"},{"nome":"Casorzo","cap":["14032"],"district":"AT","districtName":"Asti"},{"nome":"Casperia","cap":["02041"],"district":"RI","districtName":"Rieti"},{"nome":"Caspoggio","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Cassacco","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Cassago Brianza","cap":["23893"],"district":"LC","districtName":"Lecco"},{"nome":"Cassano all'Ionio","cap":["87011"],"district":"CS","districtName":"Cosenza"},{"nome":"Cassano d'Adda","cap":["20062"],"district":"MI","districtName":"Milano"},{"nome":"Cassano delle Murge","cap":["70020"],"district":"BA","districtName":"Bari"},{"nome":"Cassano Irpino","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Cassano Magnago","cap":["21012"],"district":"VA","districtName":"Varese"},{"nome":"Cassano Spinola","cap":["15063"],"district":"AL","districtName":"Alessandria"},{"nome":"Cassano Valcuvia","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Cassaro","cap":["96010"],"district":"SR","districtName":"Siracusa"},{"nome":"Cassiglio","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Cassina de' Pecchi","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Cassina Rizzardi","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Cassina Valsassina","cap":["23817"],"district":"LC","districtName":"Lecco"},{"nome":"Cassinasco","cap":["14050"],"district":"AT","districtName":"Asti"},{"nome":"Cassine","cap":["15016"],"district":"AL","districtName":"Alessandria"},{"nome":"Cassinelle","cap":["15070"],"district":"AL","districtName":"Alessandria"},{"nome":"Cassinetta di Lugagnano","cap":["20081"],"district":"MI","districtName":"Milano"},{"nome":"Cassino","cap":["03043"],"district":"FR","districtName":"Frosinone"},{"nome":"Cassola","cap":["36022"],"district":"VI","districtName":"Vicenza"},{"nome":"Cassolnovo","cap":["27023"],"district":"PV","districtName":"Pavia"},{"nome":"Castagnaro","cap":["37043"],"district":"VR","districtName":"Verona"},{"nome":"Castagneto Carducci","cap":["57022"],"district":"LI","districtName":"Livorno"},{"nome":"Castagneto Po","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Castagnito","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Castagnole delle Lanze","cap":["14054"],"district":"AT","districtName":"Asti"},{"nome":"Castagnole Monferrato","cap":["14030"],"district":"AT","districtName":"Asti"},{"nome":"Castagnole Piemonte","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Castana","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Castano Primo","cap":["20022"],"district":"MI","districtName":"Milano"},{"nome":"Casteggio","cap":["27045"],"district":"PV","districtName":"Pavia"},{"nome":"Castegnato","cap":["25045"],"district":"BS","districtName":"Brescia"},{"nome":"Castegnero","cap":["36020"],"district":"VI","districtName":"Vicenza"},{"nome":"Castel Baronia","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Castel Boglione","cap":["14040"],"district":"AT","districtName":"Asti"},{"nome":"Castel Bolognese","cap":["48014"],"district":"RA","districtName":"Ravenna"},{"nome":"Castel Campagnano","cap":["81010"],"district":"CE","districtName":"Caserta"},{"nome":"Castel Castagna","cap":["64030"],"district":"TE","districtName":"Teramo"},{"nome":"Castel Condino","cap":["38082"],"district":"TN","districtName":"Trento"},{"nome":"Castel d'Aiano","cap":["40034"],"district":"BO","districtName":"Bologna"},{"nome":"Castel d'Ario","cap":["46033"],"district":"MN","districtName":"Mantova"},{"nome":"Castel d'Azzano","cap":["37060"],"district":"VR","districtName":"Verona"},{"nome":"Castel del Giudice","cap":["86080"],"district":"IS","districtName":"Isernia"},{"nome":"Castel del Monte","cap":["67023"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Castel del Piano","cap":["58033"],"district":"GR","districtName":"Grosseto"},{"nome":"Castel del Rio","cap":["40022"],"district":"BO","districtName":"Bologna"},{"nome":"Castel di Casio","cap":["40030"],"district":"BO","districtName":"Bologna"},{"nome":"Castel di Ieri","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Castel di Iudica","cap":["95040"],"district":"CT","districtName":"Catania"},{"nome":"Castel di Lama","cap":["63082"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Castel di Lucio","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Castel di Sangro","cap":["67031"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Castel di Sasso","cap":["81040"],"district":"CE","districtName":"Caserta"},{"nome":"Castel di Tora","cap":["02020"],"district":"RI","districtName":"Rieti"},{"nome":"Castel Focognano","cap":["52016"],"district":"AR","districtName":"Arezzo"},{"nome":"Castel Frentano","cap":["66032"],"district":"CH","districtName":"Chieti"},{"nome":"Castel Gabbiano","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Castel Gandolfo","cap":["00073"],"district":"RM","districtName":"Roma"},{"nome":"Castel Giorgio","cap":["05013"],"district":"TR","districtName":"Terni"},{"nome":"Castel Goffredo","cap":["46042"],"district":"MN","districtName":"Mantova"},{"nome":"Castel Guelfo di Bologna","cap":["40023"],"district":"BO","districtName":"Bologna"},{"nome":"Castel Ivano","cap":["38059"],"district":"TN","districtName":"Trento"},{"nome":"Castel Madama","cap":["00024"],"district":"RM","districtName":"Roma"},{"nome":"Castel Maggiore","cap":["40013"],"district":"BO","districtName":"Bologna"},{"nome":"Castel Mella","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Castel Morrone","cap":["81020"],"district":"CE","districtName":"Caserta"},{"nome":"Castel Ritaldi","cap":["06044"],"district":"PG","districtName":"Perugia"},{"nome":"Castel Rocchero","cap":["14044"],"district":"AT","districtName":"Asti"},{"nome":"Castel Rozzone","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Castel San Giorgio","cap":["84083"],"district":"SA","districtName":"Salerno"},{"nome":"Castel San Giovanni","cap":["29015"],"district":"PC","districtName":"Piacenza"},{"nome":"Castel San Lorenzo","cap":["84049"],"district":"SA","districtName":"Salerno"},{"nome":"Castel San Niccolò","cap":["52018"],"district":"AR","districtName":"Arezzo"},{"nome":"Castel San Pietro Romano","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"Castel San Pietro Terme","cap":["40024"],"district":"BO","districtName":"Bologna"},{"nome":"Castel San Vincenzo","cap":["86071"],"district":"IS","districtName":"Isernia"},{"nome":"Castel Sant'Angelo","cap":["02010"],"district":"RI","districtName":"Rieti"},{"nome":"Castel Sant'Elia","cap":["01030"],"district":"VT","districtName":"Viterbo"},{"nome":"Castel Viscardo","cap":["05014"],"district":"TR","districtName":"Terni"},{"nome":"Castel Vittorio","cap":["18030"],"district":"IM","districtName":"Imperia"},{"nome":"Castel Volturno","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Castelbaldo","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Castelbelforte","cap":["46032"],"district":"MN","districtName":"Mantova"},{"nome":"Castelbellino","cap":["60030"],"district":"AN","districtName":"Ancona"},{"nome":"Castelbello-Ciardes","cap":["39020"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Castelbianco","cap":["17030"],"district":"SV","districtName":"Savona"},{"nome":"Castelbottaccio","cap":["86030"],"district":"CB","districtName":"Campobasso"},{"nome":"Castelbuono","cap":["90013"],"district":"PA","districtName":"Palermo"},{"nome":"Castelcivita","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Castelcovati","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Castelcucco","cap":["31030"],"district":"TV","districtName":"Treviso"},{"nome":"Casteldaccia","cap":["90014"],"district":"PA","districtName":"Palermo"},{"nome":"Casteldelci","cap":["47861"],"district":"RN","districtName":"Rimini"},{"nome":"Casteldelfino","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Casteldidone","cap":["26030"],"district":"CR","districtName":"Cremona"},{"nome":"Castelfidardo","cap":["60022"],"district":"AN","districtName":"Ancona"},{"nome":"Castelfiorentino","cap":["50051"],"district":"FI","districtName":"Firenze"},{"nome":"Castelforte","cap":["04021"],"district":"LT","districtName":"Latina"},{"nome":"Castelfranci","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Castelfranco di Sotto","cap":["56022"],"district":"PI","districtName":"Pisa"},{"nome":"Castelfranco Emilia","cap":["41013"],"district":"MO","districtName":"Modena"},{"nome":"Castelfranco in Miscano","cap":["82022"],"district":"BN","districtName":"Benevento"},{"nome":"Castelfranco Piandiscò","cap":["52026"],"district":"AR","districtName":"Arezzo"},{"nome":"Castelfranco Veneto","cap":["31033"],"district":"TV","districtName":"Treviso"},{"nome":"Castelgerundo","cap":["26844"],"district":"LO","districtName":"Lodi"},{"nome":"Castelgomberto","cap":["36070"],"district":"VI","districtName":"Vicenza"},{"nome":"Castelgrande","cap":["85050"],"district":"PZ","districtName":"Potenza"},{"nome":"Castelguglielmo","cap":["45020"],"district":"RO","districtName":"Rovigo"},{"nome":"Castelguidone","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Castell'Alfero","cap":["14033"],"district":"AT","districtName":"Asti"},{"nome":"Castell'Arquato","cap":["29014"],"district":"PC","districtName":"Piacenza"},{"nome":"Castell'Azzara","cap":["58034"],"district":"GR","districtName":"Grosseto"},{"nome":"Castell'Umberto","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Castellabate","cap":["84048"],"district":"SA","districtName":"Salerno"},{"nome":"Castellafiume","cap":["67050"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Castellalto","cap":["64020"],"district":"TE","districtName":"Teramo"},{"nome":"Castellammare del Golfo","cap":["91014"],"district":"TP","districtName":"Trapani"},{"nome":"Castellammare di Stabia","cap":["80053"],"district":"NA","districtName":"Napoli"},{"nome":"Castellamonte","cap":["10081"],"district":"TO","districtName":"Torino"},{"nome":"Castellana Grotte","cap":["70013"],"district":"BA","districtName":"Bari"},{"nome":"Castellana Sicula","cap":["90020"],"district":"PA","districtName":"Palermo"},{"nome":"Castellaneta","cap":["74011"],"district":"TA","districtName":"Taranto"},{"nome":"Castellania Coppi","cap":["15051"],"district":"AL","districtName":"Alessandria"},{"nome":"Castellanza","cap":["21053"],"district":"VA","districtName":"Varese"},{"nome":"Castellar Guidobono","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Castellarano","cap":["42014"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Castellaro","cap":["18011"],"district":"IM","districtName":"Imperia"},{"nome":"Castellazzo Bormida","cap":["15073"],"district":"AL","districtName":"Alessandria"},{"nome":"Castellazzo Novarese","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"Castelleone","cap":["26012"],"district":"CR","districtName":"Cremona"},{"nome":"Castelleone di Suasa","cap":["60010"],"district":"AN","districtName":"Ancona"},{"nome":"Castellero","cap":["14013"],"district":"AT","districtName":"Asti"},{"nome":"Castelletto Cervo","cap":["13851"],"district":"BI","districtName":"Biella"},{"nome":"Castelletto d'Erro","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Castelletto d'Orba","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Castelletto di Branduzzo","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Castelletto Merli","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Castelletto Molina","cap":["14040"],"district":"AT","districtName":"Asti"},{"nome":"Castelletto Monferrato","cap":["15040"],"district":"AL","districtName":"Alessandria"},{"nome":"Castelletto sopra Ticino","cap":["28053"],"district":"NO","districtName":"Novara"},{"nome":"Castelletto Stura","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Castelletto Uzzone","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Castelli","cap":["64041"],"district":"TE","districtName":"Teramo"},{"nome":"Castelli Calepio","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Castellina in Chianti","cap":["53011"],"district":"SI","districtName":"Siena"},{"nome":"Castellina Marittima","cap":["56040"],"district":"PI","districtName":"Pisa"},{"nome":"Castellinaldo d'Alba","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Castellino del Biferno","cap":["86020"],"district":"CB","districtName":"Campobasso"},{"nome":"Castellino Tanaro","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Castelliri","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Castello Cabiaglio","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Castello d'Agogna","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Castello d'Argile","cap":["40050"],"district":"BO","districtName":"Bologna"},{"nome":"Castello del Matese","cap":["81016"],"district":"CE","districtName":"Caserta"},{"nome":"Castello dell'Acqua","cap":["23030"],"district":"SO","districtName":"Sondrio"},{"nome":"Castello di Annone","cap":["14034"],"district":"AT","districtName":"Asti"},{"nome":"Castello di Brianza","cap":["23884"],"district":"LC","districtName":"Lecco"},{"nome":"Castello di Cisterna","cap":["80030"],"district":"NA","districtName":"Napoli"},{"nome":"Castello di Godego","cap":["31030"],"district":"TV","districtName":"Treviso"},{"nome":"Castello Tesino","cap":["38053"],"district":"TN","districtName":"Trento"},{"nome":"Castello-Molina di Fiemme","cap":["38030"],"district":"TN","districtName":"Trento"},{"nome":"Castellucchio","cap":["46014"],"district":"MN","districtName":"Mantova"},{"nome":"Castelluccio dei Sauri","cap":["71025"],"district":"FG","districtName":"Foggia"},{"nome":"Castelluccio Inferiore","cap":["85040"],"district":"PZ","districtName":"Potenza"},{"nome":"Castelluccio Superiore","cap":["85040"],"district":"PZ","districtName":"Potenza"},{"nome":"Castelluccio Valmaggiore","cap":["71020"],"district":"FG","districtName":"Foggia"},{"nome":"Castelmagno","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Castelmarte","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Castelmassa","cap":["45035"],"district":"RO","districtName":"Rovigo"},{"nome":"Castelmauro","cap":["86031"],"district":"CB","districtName":"Campobasso"},{"nome":"Castelmezzano","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Castelmola","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Castelnovetto","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Castelnovo Bariano","cap":["45030"],"district":"RO","districtName":"Rovigo"},{"nome":"Castelnovo del Friuli","cap":["33090"],"district":"PN","districtName":"Pordenone"},{"nome":"Castelnovo di Sotto","cap":["42024"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Castelnovo ne' Monti","cap":["42035"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Castelnuovo","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Castelnuovo Belbo","cap":["14043"],"district":"AT","districtName":"Asti"},{"nome":"Castelnuovo Berardenga","cap":["53019"],"district":"SI","districtName":"Siena"},{"nome":"Castelnuovo Bocca d'Adda","cap":["26843"],"district":"LO","districtName":"Lodi"},{"nome":"Castelnuovo Bormida","cap":["15017"],"district":"AL","districtName":"Alessandria"},{"nome":"Castelnuovo Bozzente","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Castelnuovo Calcea","cap":["14040"],"district":"AT","districtName":"Asti"},{"nome":"Castelnuovo Cilento","cap":["84040"],"district":"SA","districtName":"Salerno"},{"nome":"Castelnuovo del Garda","cap":["37014"],"district":"VR","districtName":"Verona"},{"nome":"Castelnuovo della Daunia","cap":["71034"],"district":"FG","districtName":"Foggia"},{"nome":"Castelnuovo di Ceva","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Castelnuovo di Conza","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Castelnuovo di Farfa","cap":["02031"],"district":"RI","districtName":"Rieti"},{"nome":"Castelnuovo di Garfagnana","cap":["55032"],"district":"LU","districtName":"Lucca"},{"nome":"Castelnuovo di Porto","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Castelnuovo di Val di Cecina","cap":["56041"],"district":"PI","districtName":"Pisa"},{"nome":"Castelnuovo Don Bosco","cap":["14022"],"district":"AT","districtName":"Asti"},{"nome":"Castelnuovo Magra","cap":["19033"],"district":"SP","districtName":"La Spezia"},{"nome":"Castelnuovo Nigra","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Castelnuovo Parano","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Castelnuovo Rangone","cap":["41051"],"district":"MO","districtName":"Modena"},{"nome":"Castelnuovo Scrivia","cap":["15053"],"district":"AL","districtName":"Alessandria"},{"nome":"Castelpagano","cap":["82024"],"district":"BN","districtName":"Benevento"},{"nome":"Castelpetroso","cap":["86090"],"district":"IS","districtName":"Isernia"},{"nome":"Castelpizzuto","cap":["86090"],"district":"IS","districtName":"Isernia"},{"nome":"Castelplanio","cap":["60031"],"district":"AN","districtName":"Ancona"},{"nome":"Castelpoto","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Castelraimondo","cap":["62022"],"district":"MC","districtName":"Macerata"},{"nome":"Castelrotto","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Castelsantangelo sul Nera","cap":["62039"],"district":"MC","districtName":"Macerata"},{"nome":"Castelsaraceno","cap":["85031"],"district":"PZ","districtName":"Potenza"},{"nome":"Castelsardo","cap":["07031"],"district":"SS","districtName":"Sassari"},{"nome":"Castelseprio","cap":["21050"],"district":"VA","districtName":"Varese"},{"nome":"Castelsilano","cap":["88834"],"district":"KR","districtName":"Crotone"},{"nome":"Castelspina","cap":["15070"],"district":"AL","districtName":"Alessandria"},{"nome":"Casteltermini","cap":["92025"],"district":"AG","districtName":"Agrigento"},{"nome":"Castelveccana","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Castelvecchio Calvisio","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Castelvecchio di Rocca Barbena","cap":["17034"],"district":"SV","districtName":"Savona"},{"nome":"Castelvecchio Subequo","cap":["67024"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Castelvenere","cap":["82037"],"district":"BN","districtName":"Benevento"},{"nome":"Castelverde","cap":["26022"],"district":"CR","districtName":"Cremona"},{"nome":"Castelverrino","cap":["86080"],"district":"IS","districtName":"Isernia"},{"nome":"Castelvetere in Val Fortore","cap":["82023"],"district":"BN","districtName":"Benevento"},{"nome":"Castelvetere sul Calore","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Castelvetrano","cap":["91022"],"district":"TP","districtName":"Trapani"},{"nome":"Castelvetro di Modena","cap":["41014"],"district":"MO","districtName":"Modena"},{"nome":"Castelvetro Piacentino","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Castelvisconti","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Castenaso","cap":["40055"],"district":"BO","districtName":"Bologna"},{"nome":"Castenedolo","cap":["25014"],"district":"BS","districtName":"Brescia"},{"nome":"Castiadas","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Castiglion Fibocchi","cap":["52029"],"district":"AR","districtName":"Arezzo"},{"nome":"Castiglion Fiorentino","cap":["52043"],"district":"AR","districtName":"Arezzo"},{"nome":"Castiglione a Casauria","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Castiglione Chiavarese","cap":["16030"],"district":"GE","districtName":"Genova"},{"nome":"Castiglione Cosentino","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Castiglione d'Adda","cap":["26823"],"district":"LO","districtName":"Lodi"},{"nome":"Castiglione d'Orcia","cap":["53023"],"district":"SI","districtName":"Siena"},{"nome":"Castiglione dei Pepoli","cap":["40035"],"district":"BO","districtName":"Bologna"},{"nome":"Castiglione del Genovesi","cap":["84090"],"district":"SA","districtName":"Salerno"},{"nome":"Castiglione del Lago","cap":["06061"],"district":"PG","districtName":"Perugia"},{"nome":"Castiglione della Pescaia","cap":["58043"],"district":"GR","districtName":"Grosseto"},{"nome":"Castiglione delle Stiviere","cap":["46043"],"district":"MN","districtName":"Mantova"},{"nome":"Castiglione di Garfagnana","cap":["55033"],"district":"LU","districtName":"Lucca"},{"nome":"Castiglione di Sicilia","cap":["95012"],"district":"CT","districtName":"Catania"},{"nome":"Castiglione Falletto","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Castiglione in Teverina","cap":["01024"],"district":"VT","districtName":"Viterbo"},{"nome":"Castiglione Messer Marino","cap":["66033"],"district":"CH","districtName":"Chieti"},{"nome":"Castiglione Messer Raimondo","cap":["64034"],"district":"TE","districtName":"Teramo"},{"nome":"Castiglione Olona","cap":["21043"],"district":"VA","districtName":"Varese"},{"nome":"Castiglione Tinella","cap":["12053"],"district":"CN","districtName":"Cuneo"},{"nome":"Castiglione Torinese","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Castignano","cap":["63072"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Castilenti","cap":["64035"],"district":"TE","districtName":"Teramo"},{"nome":"Castino","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Castione Andevenno","cap":["23012"],"district":"SO","districtName":"Sondrio"},{"nome":"Castione della Presolana","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Castions di Strada","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Castiraga Vidardo","cap":["26866"],"district":"LO","districtName":"Lodi"},{"nome":"Casto","cap":["25070"],"district":"BS","districtName":"Brescia"},{"nome":"Castorano","cap":["63081"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Castrezzato","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Castri di Lecce","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Castrignano de' Greci","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Castrignano del Capo","cap":["73040"],"district":"LE","districtName":"Lecce"},{"nome":"Castro","cap":["24063"],"district":"BG","districtName":"Bergamo"},{"nome":"Castro","cap":["73030"],"district":"LE","districtName":"Lecce"},{"nome":"Castro dei Volsci","cap":["03020"],"district":"FR","districtName":"Frosinone"},{"nome":"Castrocaro Terme e Terra del Sole","cap":["47011"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Castrocielo","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Castrofilippo","cap":["92020"],"district":"AG","districtName":"Agrigento"},{"nome":"Castrolibero","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Castronno","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Castronovo di Sicilia","cap":["90030"],"district":"PA","districtName":"Palermo"},{"nome":"Castronuovo di Sant'Andrea","cap":["85030"],"district":"PZ","districtName":"Potenza"},{"nome":"Castropignano","cap":["86010"],"district":"CB","districtName":"Campobasso"},{"nome":"Castroreale","cap":["98053"],"district":"ME","districtName":"Messina"},{"nome":"Castroregio","cap":["87070"],"district":"CS","districtName":"Cosenza"},{"nome":"Castrovillari","cap":["87012"],"district":"CS","districtName":"Cosenza"},{"nome":"Catania","cap":["95121","95122","95123","95124","95125","95126","95127","95128","95129","95130","95131"],"district":"CT","districtName":"Catania"},{"nome":"Catanzaro","cap":["88100"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Catenanuova","cap":["94010"],"district":"EN","districtName":"Enna"},{"nome":"Catignano","cap":["65011"],"district":"PE","districtName":"Pescara"},{"nome":"Cattolica","cap":["47841"],"district":"RN","districtName":"Rimini"},{"nome":"Cattolica Eraclea","cap":["92011"],"district":"AG","districtName":"Agrigento"},{"nome":"Caulonia","cap":["89041"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Cautano","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Cava de' Tirreni","cap":["84013"],"district":"SA","districtName":"Salerno"},{"nome":"Cava Manara","cap":["27051"],"district":"PV","districtName":"Pavia"},{"nome":"Cavaglià","cap":["13881"],"district":"BI","districtName":"Biella"},{"nome":"Cavaglietto","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Cavaglio d'Agogna","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Cavagnolo","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Cavaion Veronese","cap":["37010"],"district":"VR","districtName":"Verona"},{"nome":"Cavalese","cap":["38033"],"district":"TN","districtName":"Trento"},{"nome":"Cavallerleone","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Cavallermaggiore","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Cavallino","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Cavallino-Treporti","cap":["30013"],"district":"VE","districtName":"Venezia"},{"nome":"Cavallirio","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Cavareno","cap":["38011"],"district":"TN","districtName":"Trento"},{"nome":"Cavargna","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Cavaria con Premezzo","cap":["21044"],"district":"VA","districtName":"Varese"},{"nome":"Cavarzere","cap":["30014"],"district":"VE","districtName":"Venezia"},{"nome":"Cavaso del Tomba","cap":["31034"],"district":"TV","districtName":"Treviso"},{"nome":"Cavasso Nuovo","cap":["33092"],"district":"PN","districtName":"Pordenone"},{"nome":"Cavatore","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Cavazzo Carnico","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Cave","cap":["00033"],"district":"RM","districtName":"Roma"},{"nome":"Cavedago","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Cavedine","cap":["38073"],"district":"TN","districtName":"Trento"},{"nome":"Cavenago d'Adda","cap":["26824"],"district":"LO","districtName":"Lodi"},{"nome":"Cavenago di Brianza","cap":["20873"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Cavernago","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Cavezzo","cap":["41032"],"district":"MO","districtName":"Modena"},{"nome":"Cavizzana","cap":["38022"],"district":"TN","districtName":"Trento"},{"nome":"Cavour","cap":["10061"],"district":"TO","districtName":"Torino"},{"nome":"Cavriago","cap":["42025"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Cavriana","cap":["46040"],"district":"MN","districtName":"Mantova"},{"nome":"Cavriglia","cap":["52022"],"district":"AR","districtName":"Arezzo"},{"nome":"Cazzago Brabbia","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Cazzago San Martino","cap":["25046"],"district":"BS","districtName":"Brescia"},{"nome":"Cazzano di Tramigna","cap":["37030"],"district":"VR","districtName":"Verona"},{"nome":"Cazzano Sant'Andrea","cap":["24026"],"district":"BG","districtName":"Bergamo"},{"nome":"Ceccano","cap":["03023"],"district":"FR","districtName":"Frosinone"},{"nome":"Cecima","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Cecina","cap":["57023"],"district":"LI","districtName":"Livorno"},{"nome":"Cedegolo","cap":["25051"],"district":"BS","districtName":"Brescia"},{"nome":"Cedrasco","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Cefalà Diana","cap":["90030"],"district":"PA","districtName":"Palermo"},{"nome":"Cefalù","cap":["90015"],"district":"PA","districtName":"Palermo"},{"nome":"Ceggia","cap":["30022"],"district":"VE","districtName":"Venezia"},{"nome":"Ceglie Messapica","cap":["72013"],"district":"BR","districtName":"Brindisi"},{"nome":"Celano","cap":["67043"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Celenza sul Trigno","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Celenza Valfortore","cap":["71035"],"district":"FG","districtName":"Foggia"},{"nome":"Celico","cap":["87053"],"district":"CS","districtName":"Cosenza"},{"nome":"Cella Dati","cap":["26040"],"district":"CR","districtName":"Cremona"},{"nome":"Cella Monte","cap":["15034"],"district":"AL","districtName":"Alessandria"},{"nome":"Cellamare","cap":["70010"],"district":"BA","districtName":"Bari"},{"nome":"Cellara","cap":["87050"],"district":"CS","districtName":"Cosenza"},{"nome":"Cellarengo","cap":["14010"],"district":"AT","districtName":"Asti"},{"nome":"Cellatica","cap":["25060"],"district":"BS","districtName":"Brescia"},{"nome":"Celle di Bulgheria","cap":["84040"],"district":"SA","districtName":"Salerno"},{"nome":"Celle di Macra","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Celle di San Vito","cap":["71020"],"district":"FG","districtName":"Foggia"},{"nome":"Celle Enomondo","cap":["14010"],"district":"AT","districtName":"Asti"},{"nome":"Celle Ligure","cap":["17015"],"district":"SV","districtName":"Savona"},{"nome":"Celleno","cap":["01020"],"district":"VT","districtName":"Viterbo"},{"nome":"Cellere","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Cellino Attanasio","cap":["64036"],"district":"TE","districtName":"Teramo"},{"nome":"Cellino San Marco","cap":["72020"],"district":"BR","districtName":"Brindisi"},{"nome":"Cellio con Breia","cap":["13024"],"district":"VC","districtName":"Vercelli"},{"nome":"Cellole","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Cembra Lisignago","cap":["38034"],"district":"TN","districtName":"Trento"},{"nome":"Cenadi","cap":["88067"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Cenate Sopra","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Cenate Sotto","cap":["24069"],"district":"BG","districtName":"Bergamo"},{"nome":"Cencenighe Agordino","cap":["32020"],"district":"BL","districtName":"Belluno"},{"nome":"Cene","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Ceneselli","cap":["45030"],"district":"RO","districtName":"Rovigo"},{"nome":"Cengio","cap":["17056"],"district":"SV","districtName":"Savona"},{"nome":"Centallo","cap":["12044"],"district":"CN","districtName":"Cuneo"},{"nome":"Cento","cap":["44042"],"district":"FE","districtName":"Ferrara"},{"nome":"Centola","cap":["84051"],"district":"SA","districtName":"Salerno"},{"nome":"Centrache","cap":["88067"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Centro Valle Intelvi","cap":["22023"],"district":"CO","districtName":"Como"},{"nome":"Centuripe","cap":["94010"],"district":"EN","districtName":"Enna"},{"nome":"Cepagatti","cap":["65012"],"district":"PE","districtName":"Pescara"},{"nome":"Ceppaloni","cap":["82014"],"district":"BN","districtName":"Benevento"},{"nome":"Ceppo Morelli","cap":["28875"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Ceprano","cap":["03024"],"district":"FR","districtName":"Frosinone"},{"nome":"Cerami","cap":["94010"],"district":"EN","districtName":"Enna"},{"nome":"Ceranesi","cap":["16014"],"district":"GE","districtName":"Genova"},{"nome":"Cerano","cap":["28065"],"district":"NO","districtName":"Novara"},{"nome":"Cerano d'Intelvi","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Ceranova","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Ceraso","cap":["84052"],"district":"SA","districtName":"Salerno"},{"nome":"Cercemaggiore","cap":["86012"],"district":"CB","districtName":"Campobasso"},{"nome":"Cercenasco","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Cercepiccola","cap":["86010"],"district":"CB","districtName":"Campobasso"},{"nome":"Cerchiara di Calabria","cap":["87070"],"district":"CS","districtName":"Cosenza"},{"nome":"Cerchio","cap":["67044"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Cercino","cap":["23016"],"district":"SO","districtName":"Sondrio"},{"nome":"Cercivento","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Cercola","cap":["80040"],"district":"NA","districtName":"Napoli"},{"nome":"Cerda","cap":["90010"],"district":"PA","districtName":"Palermo"},{"nome":"Cerea","cap":["37053"],"district":"VR","districtName":"Verona"},{"nome":"Ceregnano","cap":["45010"],"district":"RO","districtName":"Rovigo"},{"nome":"Cerenzia","cap":["88833"],"district":"KR","districtName":"Crotone"},{"nome":"Ceres","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Ceresara","cap":["46040"],"district":"MN","districtName":"Mantova"},{"nome":"Cereseto","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Ceresole Alba","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Ceresole Reale","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Cerete","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Ceretto Lomellina","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Cergnago","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Ceriale","cap":["17023"],"district":"SV","districtName":"Savona"},{"nome":"Ceriana","cap":["18034"],"district":"IM","districtName":"Imperia"},{"nome":"Ceriano Laghetto","cap":["20816"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Cerignale","cap":["29020"],"district":"PC","districtName":"Piacenza"},{"nome":"Cerignola","cap":["71042"],"district":"FG","districtName":"Foggia"},{"nome":"Cerisano","cap":["87044"],"district":"CS","districtName":"Cosenza"},{"nome":"Cermenate","cap":["22072"],"district":"CO","districtName":"Como"},{"nome":"Cermes","cap":["39010"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Cermignano","cap":["64037"],"district":"TE","districtName":"Teramo"},{"nome":"Cernobbio","cap":["22012"],"district":"CO","districtName":"Como"},{"nome":"Cernusco Lombardone","cap":["23870"],"district":"LC","districtName":"Lecco"},{"nome":"Cernusco sul Naviglio","cap":["20063"],"district":"MI","districtName":"Milano"},{"nome":"Cerreto d'Asti","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Cerreto d'Esi","cap":["60043"],"district":"AN","districtName":"Ancona"},{"nome":"Cerreto di Spoleto","cap":["06041"],"district":"PG","districtName":"Perugia"},{"nome":"Cerreto Grue","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Cerreto Guidi","cap":["50050"],"district":"FI","districtName":"Firenze"},{"nome":"Cerreto Laziale","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Cerreto Sannita","cap":["82032"],"district":"BN","districtName":"Benevento"},{"nome":"Cerretto Langhe","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Cerrina Monferrato","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Cerrione","cap":["13882"],"district":"BI","districtName":"Biella"},{"nome":"Cerro al Lambro","cap":["20070"],"district":"MI","districtName":"Milano"},{"nome":"Cerro al Volturno","cap":["86072"],"district":"IS","districtName":"Isernia"},{"nome":"Cerro Maggiore","cap":["20023"],"district":"MI","districtName":"Milano"},{"nome":"Cerro Tanaro","cap":["14030"],"district":"AT","districtName":"Asti"},{"nome":"Cerro Veronese","cap":["37020"],"district":"VR","districtName":"Verona"},{"nome":"Cersosimo","cap":["85030"],"district":"PZ","districtName":"Potenza"},{"nome":"Certaldo","cap":["50052"],"district":"FI","districtName":"Firenze"},{"nome":"Certosa di Pavia","cap":["27012"],"district":"PV","districtName":"Pavia"},{"nome":"Cerva","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Cervara di Roma","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Cervarese Santa Croce","cap":["35030"],"district":"PD","districtName":"Padova"},{"nome":"Cervaro","cap":["03044"],"district":"FR","districtName":"Frosinone"},{"nome":"Cervasca","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Cervatto","cap":["13025"],"district":"VC","districtName":"Vercelli"},{"nome":"Cerveno","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Cervere","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Cervesina","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Cerveteri","cap":["00052"],"district":"RM","districtName":"Roma"},{"nome":"Cervia","cap":["48015"],"district":"RA","districtName":"Ravenna"},{"nome":"Cervicati","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Cervignano d'Adda","cap":["26832"],"district":"LO","districtName":"Lodi"},{"nome":"Cervignano del Friuli","cap":["33052"],"district":"UD","districtName":"Udine"},{"nome":"Cervinara","cap":["83012"],"district":"AV","districtName":"Avellino"},{"nome":"Cervino","cap":["81023"],"district":"CE","districtName":"Caserta"},{"nome":"Cervo","cap":["18010"],"district":"IM","districtName":"Imperia"},{"nome":"Cerzeto","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Cesa","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Cesana Brianza","cap":["23861"],"district":"LC","districtName":"Lecco"},{"nome":"Cesana Torinese","cap":["10054"],"district":"TO","districtName":"Torino"},{"nome":"Cesano Boscone","cap":["20090"],"district":"MI","districtName":"Milano"},{"nome":"Cesano Maderno","cap":["20811"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Cesara","cap":["28891"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Cesarò","cap":["98033"],"district":"ME","districtName":"Messina"},{"nome":"Cesate","cap":["20020"],"district":"MI","districtName":"Milano"},{"nome":"Cesena","cap":["47521","47522"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Cesenatico","cap":["47042"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Cesinali","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Cesio","cap":["18022"],"district":"IM","districtName":"Imperia"},{"nome":"Cesiomaggiore","cap":["32030"],"district":"BL","districtName":"Belluno"},{"nome":"Cessalto","cap":["31040"],"district":"TV","districtName":"Treviso"},{"nome":"Cessaniti","cap":["89816"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Cessapalombo","cap":["62020"],"district":"MC","districtName":"Macerata"},{"nome":"Cessole","cap":["14050"],"district":"AT","districtName":"Asti"},{"nome":"Cetara","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"Ceto","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Cetona","cap":["53040"],"district":"SI","districtName":"Siena"},{"nome":"Cetraro","cap":["87022"],"district":"CS","districtName":"Cosenza"},{"nome":"Ceva","cap":["12073"],"district":"CN","districtName":"Cuneo"},{"nome":"Cevo","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Challand-Saint-Anselme","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Challand-Saint-Victor","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Chambave","cap":["11023"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Chamois","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Champdepraz","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Champorcher","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Charvensod","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Châtillon","cap":["11024"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Cherasco","cap":["12062"],"district":"CN","districtName":"Cuneo"},{"nome":"Cheremule","cap":["07040"],"district":"SS","districtName":"Sassari"},{"nome":"Chialamberto","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Chiampo","cap":["36072"],"district":"VI","districtName":"Vicenza"},{"nome":"Chianche","cap":["83010"],"district":"AV","districtName":"Avellino"},{"nome":"Chianciano Terme","cap":["53042"],"district":"SI","districtName":"Siena"},{"nome":"Chianni","cap":["56034"],"district":"PI","districtName":"Pisa"},{"nome":"Chianocco","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Chiaramonte Gulfi","cap":["97012"],"district":"RG","districtName":"Ragusa"},{"nome":"Chiaramonti","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Chiarano","cap":["31040"],"district":"TV","districtName":"Treviso"},{"nome":"Chiaravalle","cap":["60033"],"district":"AN","districtName":"Ancona"},{"nome":"Chiaravalle Centrale","cap":["88064"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Chiari","cap":["25032"],"district":"BS","districtName":"Brescia"},{"nome":"Chiaromonte","cap":["85032"],"district":"PZ","districtName":"Potenza"},{"nome":"Chiauci","cap":["86097"],"district":"IS","districtName":"Isernia"},{"nome":"Chiavari","cap":["16043"],"district":"GE","districtName":"Genova"},{"nome":"Chiavenna","cap":["23022"],"district":"SO","districtName":"Sondrio"},{"nome":"Chiaverano","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Chienes","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Chieri","cap":["10023"],"district":"TO","districtName":"Torino"},{"nome":"Chies d'Alpago","cap":["32010"],"district":"BL","districtName":"Belluno"},{"nome":"Chiesa in Valmalenco","cap":["23023"],"district":"SO","districtName":"Sondrio"},{"nome":"Chiesanuova","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Chiesina Uzzanese","cap":["51013"],"district":"PT","districtName":"Pistoia"},{"nome":"Chieti","cap":["66100"],"district":"CH","districtName":"Chieti"},{"nome":"Chieuti","cap":["71010"],"district":"FG","districtName":"Foggia"},{"nome":"Chieve","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Chignolo d'Isola","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Chignolo Po","cap":["27013"],"district":"PV","districtName":"Pavia"},{"nome":"Chioggia","cap":["30015"],"district":"VE","districtName":"Venezia"},{"nome":"Chiomonte","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Chions","cap":["33083"],"district":"PN","districtName":"Pordenone"},{"nome":"Chiopris-Viscone","cap":["33048"],"district":"UD","districtName":"Udine"},{"nome":"Chitignano","cap":["52010"],"district":"AR","districtName":"Arezzo"},{"nome":"Chiuduno","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Chiuppano","cap":["36010"],"district":"VI","districtName":"Vicenza"},{"nome":"Chiuro","cap":["23030"],"district":"SO","districtName":"Sondrio"},{"nome":"Chiusa","cap":["39043"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Chiusa di Pesio","cap":["12013"],"district":"CN","districtName":"Cuneo"},{"nome":"Chiusa di San Michele","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Chiusa Sclafani","cap":["90033"],"district":"PA","districtName":"Palermo"},{"nome":"Chiusaforte","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Chiusanico","cap":["18027"],"district":"IM","districtName":"Imperia"},{"nome":"Chiusano d'Asti","cap":["14025"],"district":"AT","districtName":"Asti"},{"nome":"Chiusano di San Domenico","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Chiusavecchia","cap":["18027"],"district":"IM","districtName":"Imperia"},{"nome":"Chiusdino","cap":["53012"],"district":"SI","districtName":"Siena"},{"nome":"Chiusi","cap":["53043"],"district":"SI","districtName":"Siena"},{"nome":"Chiusi della Verna","cap":["52010"],"district":"AR","districtName":"Arezzo"},{"nome":"Chivasso","cap":["10034"],"district":"TO","districtName":"Torino"},{"nome":"Ciampino","cap":["00043"],"district":"RM","districtName":"Roma"},{"nome":"Cianciana","cap":["92012"],"district":"AG","districtName":"Agrigento"},{"nome":"Cibiana di Cadore","cap":["32040"],"district":"BL","districtName":"Belluno"},{"nome":"Cicagna","cap":["16044"],"district":"GE","districtName":"Genova"},{"nome":"Cicala","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Cicciano","cap":["80033"],"district":"NA","districtName":"Napoli"},{"nome":"Cicerale","cap":["84053"],"district":"SA","districtName":"Salerno"},{"nome":"Ciciliano","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Cicognolo","cap":["26030"],"district":"CR","districtName":"Cremona"},{"nome":"Ciconio","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Cigliano","cap":["13043"],"district":"VC","districtName":"Vercelli"},{"nome":"Cigliè","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Cigognola","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Cigole","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Cilavegna","cap":["27024"],"district":"PV","districtName":"Pavia"},{"nome":"Cimadolmo","cap":["31010"],"district":"TV","districtName":"Treviso"},{"nome":"Cimbergo","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Ciminà","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Ciminna","cap":["90023"],"district":"PA","districtName":"Palermo"},{"nome":"Cimitile","cap":["80030"],"district":"NA","districtName":"Napoli"},{"nome":"Cimolais","cap":["33080"],"district":"PN","districtName":"Pordenone"},{"nome":"Cimone","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Cinaglio","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Cineto Romano","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Cingia de' Botti","cap":["26042"],"district":"CR","districtName":"Cremona"},{"nome":"Cingoli","cap":["62011"],"district":"MC","districtName":"Macerata"},{"nome":"Cinigiano","cap":["58044"],"district":"GR","districtName":"Grosseto"},{"nome":"Cinisello Balsamo","cap":["20092"],"district":"MI","districtName":"Milano"},{"nome":"Cinisi","cap":["90045"],"district":"PA","districtName":"Palermo"},{"nome":"Cino","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Cinquefrondi","cap":["89021"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Cintano","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Cinte Tesino","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Cinto Caomaggiore","cap":["30020"],"district":"VE","districtName":"Venezia"},{"nome":"Cinto Euganeo","cap":["35030"],"district":"PD","districtName":"Padova"},{"nome":"Cinzano","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Ciorlano","cap":["81010"],"district":"CE","districtName":"Caserta"},{"nome":"Cipressa","cap":["18017"],"district":"IM","districtName":"Imperia"},{"nome":"Circello","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Ciriè","cap":["10073"],"district":"TO","districtName":"Torino"},{"nome":"Cirigliano","cap":["75010"],"district":"MT","districtName":"Matera"},{"nome":"Cirimido","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Cirò","cap":["88813"],"district":"KR","districtName":"Crotone"},{"nome":"Cirò Marina","cap":["88811"],"district":"KR","districtName":"Crotone"},{"nome":"Cis","cap":["38020"],"district":"TN","districtName":"Trento"},{"nome":"Cisano Bergamasco","cap":["24034"],"district":"BG","districtName":"Bergamo"},{"nome":"Cisano sul Neva","cap":["17035"],"district":"SV","districtName":"Savona"},{"nome":"Ciserano","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Cislago","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Cisliano","cap":["20080"],"district":"MI","districtName":"Milano"},{"nome":"Cison di Valmarino","cap":["31030"],"district":"TV","districtName":"Treviso"},{"nome":"Cissone","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Cisterna d'Asti","cap":["14010"],"district":"AT","districtName":"Asti"},{"nome":"Cisterna di Latina","cap":["04012"],"district":"LT","districtName":"Latina"},{"nome":"Cisternino","cap":["72014"],"district":"BR","districtName":"Brindisi"},{"nome":"Citerna","cap":["06010"],"district":"PG","districtName":"Perugia"},{"nome":"Città della Pieve","cap":["06062"],"district":"PG","districtName":"Perugia"},{"nome":"Città di Castello","cap":["06012"],"district":"PG","districtName":"Perugia"},{"nome":"Città Sant'Angelo","cap":["65013"],"district":"PE","districtName":"Pescara"},{"nome":"Cittadella","cap":["35013"],"district":"PD","districtName":"Padova"},{"nome":"Cittaducale","cap":["02015"],"district":"RI","districtName":"Rieti"},{"nome":"Cittanova","cap":["89022"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Cittareale","cap":["02010"],"district":"RI","districtName":"Rieti"},{"nome":"Cittiglio","cap":["21033"],"district":"VA","districtName":"Varese"},{"nome":"Civate","cap":["23862"],"district":"LC","districtName":"Lecco"},{"nome":"Civezza","cap":["18017"],"district":"IM","districtName":"Imperia"},{"nome":"Civezzano","cap":["38045"],"district":"TN","districtName":"Trento"},{"nome":"Civiasco","cap":["13010"],"district":"VC","districtName":"Vercelli"},{"nome":"Cividale del Friuli","cap":["33043"],"district":"UD","districtName":"Udine"},{"nome":"Cividate al Piano","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Cividate Camuno","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Civita","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Civita Castellana","cap":["01033"],"district":"VT","districtName":"Viterbo"},{"nome":"Civita d'Antino","cap":["67050"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Civitacampomarano","cap":["86030"],"district":"CB","districtName":"Campobasso"},{"nome":"Civitaluparella","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Civitanova del Sannio","cap":["86094"],"district":"IS","districtName":"Isernia"},{"nome":"Civitanova Marche","cap":["62012"],"district":"MC","districtName":"Macerata"},{"nome":"Civitaquana","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Civitavecchia","cap":["00053"],"district":"RM","districtName":"Roma"},{"nome":"Civitella Alfedena","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Civitella Casanova","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Civitella d'Agliano","cap":["01020"],"district":"VT","districtName":"Viterbo"},{"nome":"Civitella del Tronto","cap":["64010"],"district":"TE","districtName":"Teramo"},{"nome":"Civitella di Romagna","cap":["47012"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Civitella in Val di Chiana","cap":["52041"],"district":"AR","districtName":"Arezzo"},{"nome":"Civitella Messer Raimondo","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Civitella Paganico","cap":["58045"],"district":"GR","districtName":"Grosseto"},{"nome":"Civitella Roveto","cap":["67054"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Civitella San Paolo","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Civo","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Claino con Osteno","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Claut","cap":["33080"],"district":"PN","districtName":"Pordenone"},{"nome":"Clauzetto","cap":["33090"],"district":"PN","districtName":"Pordenone"},{"nome":"Clavesana","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Claviere","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Cles","cap":["38023"],"district":"TN","districtName":"Trento"},{"nome":"Cleto","cap":["87030"],"district":"CS","districtName":"Cosenza"},{"nome":"Clivio","cap":["21050"],"district":"VA","districtName":"Varese"},{"nome":"Clusone","cap":["24023"],"district":"BG","districtName":"Bergamo"},{"nome":"Coassolo Torinese","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Coazze","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Coazzolo","cap":["14054"],"district":"AT","districtName":"Asti"},{"nome":"Coccaglio","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Cocconato","cap":["14023"],"district":"AT","districtName":"Asti"},{"nome":"Cocquio-Trevisago","cap":["21034"],"district":"VA","districtName":"Varese"},{"nome":"Cocullo","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Codevigo","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Codevilla","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Codigoro","cap":["44021"],"district":"FE","districtName":"Ferrara"},{"nome":"Codognè","cap":["31013"],"district":"TV","districtName":"Treviso"},{"nome":"Codogno","cap":["26845"],"district":"LO","districtName":"Lodi"},{"nome":"Codroipo","cap":["33033"],"district":"UD","districtName":"Udine"},{"nome":"Codrongianos","cap":["07040"],"district":"SS","districtName":"Sassari"},{"nome":"Coggiola","cap":["13863"],"district":"BI","districtName":"Biella"},{"nome":"Cogliate","cap":["20815"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Cogne","cap":["11012"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Cogoleto","cap":["16016"],"district":"GE","districtName":"Genova"},{"nome":"Cogollo del Cengio","cap":["36010"],"district":"VI","districtName":"Vicenza"},{"nome":"Cogorno","cap":["16030"],"district":"GE","districtName":"Genova"},{"nome":"Colazza","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Colceresa","cap":["36064"],"district":"VI","districtName":"Vicenza"},{"nome":"Colere","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Colfelice","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Coli","cap":["29020"],"district":"PC","districtName":"Piacenza"},{"nome":"Colico","cap":["23823"],"district":"LC","districtName":"Lecco"},{"nome":"Collalto Sabino","cap":["02022"],"district":"RI","districtName":"Rieti"},{"nome":"Collarmele","cap":["67040"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Collazzone","cap":["06050"],"district":"PG","districtName":"Perugia"},{"nome":"Colle Brianza","cap":["23886"],"district":"LC","districtName":"Lecco"},{"nome":"Colle d'Anchise","cap":["86020"],"district":"CB","districtName":"Campobasso"},{"nome":"Colle di Tora","cap":["02020"],"district":"RI","districtName":"Rieti"},{"nome":"Colle di Val d'Elsa","cap":["53034"],"district":"SI","districtName":"Siena"},{"nome":"Colle San Magno","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Colle Sannita","cap":["82024"],"district":"BN","districtName":"Benevento"},{"nome":"Colle Santa Lucia","cap":["32020"],"district":"BL","districtName":"Belluno"},{"nome":"Colle Umberto","cap":["31014"],"district":"TV","districtName":"Treviso"},{"nome":"Collebeato","cap":["25060"],"district":"BS","districtName":"Brescia"},{"nome":"Collecchio","cap":["43044"],"district":"PR","districtName":"Parma"},{"nome":"Collecorvino","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Colledara","cap":["64042"],"district":"TE","districtName":"Teramo"},{"nome":"Colledimacine","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Colledimezzo","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Colleferro","cap":["00034"],"district":"RM","districtName":"Roma"},{"nome":"Collegiove","cap":["02020"],"district":"RI","districtName":"Rieti"},{"nome":"Collegno","cap":["10093"],"district":"TO","districtName":"Torino"},{"nome":"Collelongo","cap":["67050"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Collepardo","cap":["03010"],"district":"FR","districtName":"Frosinone"},{"nome":"Collepasso","cap":["73040"],"district":"LE","districtName":"Lecce"},{"nome":"Collepietro","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Colleretto Castelnuovo","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Colleretto Giacosa","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Collesalvetti","cap":["57014"],"district":"LI","districtName":"Livorno"},{"nome":"Collesano","cap":["90016"],"district":"PA","districtName":"Palermo"},{"nome":"Colletorto","cap":["86044"],"district":"CB","districtName":"Campobasso"},{"nome":"Collevecchio","cap":["02042"],"district":"RI","districtName":"Rieti"},{"nome":"Colli a Volturno","cap":["86073"],"district":"IS","districtName":"Isernia"},{"nome":"Colli al Metauro","cap":["61036"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Colli del Tronto","cap":["63079"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Colli sul Velino","cap":["02010"],"district":"RI","districtName":"Rieti"},{"nome":"Colli Verdi","cap":["27061"],"district":"PV","districtName":"Pavia"},{"nome":"Colliano","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Collinas","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Collio","cap":["25060"],"district":"BS","districtName":"Brescia"},{"nome":"Collobiano","cap":["13030"],"district":"VC","districtName":"Vercelli"},{"nome":"Colloredo di Monte Albano","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Colmurano","cap":["62020"],"district":"MC","districtName":"Macerata"},{"nome":"Colobraro","cap":["75021"],"district":"MT","districtName":"Matera"},{"nome":"Cologna Veneta","cap":["37044"],"district":"VR","districtName":"Verona"},{"nome":"Cologne","cap":["25033"],"district":"BS","districtName":"Brescia"},{"nome":"Cologno al Serio","cap":["24055"],"district":"BG","districtName":"Bergamo"},{"nome":"Cologno Monzese","cap":["20093"],"district":"MI","districtName":"Milano"},{"nome":"Colognola ai Colli","cap":["37030"],"district":"VR","districtName":"Verona"},{"nome":"Colonna","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"Colonnella","cap":["64010"],"district":"TE","districtName":"Teramo"},{"nome":"Colonno","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Colorina","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Colorno","cap":["43052"],"district":"PR","districtName":"Parma"},{"nome":"Colosimi","cap":["87050"],"district":"CS","districtName":"Cosenza"},{"nome":"Colturano","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Colverde","cap":["22041"],"district":"CO","districtName":"Como"},{"nome":"Colzate","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Comabbio","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Comacchio","cap":["44022"],"district":"FE","districtName":"Ferrara"},{"nome":"Comano","cap":["54015"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Comano Terme","cap":["38077"],"district":"TN","districtName":"Trento"},{"nome":"Comazzo","cap":["26833"],"district":"LO","districtName":"Lodi"},{"nome":"Comeglians","cap":["33023"],"district":"UD","districtName":"Udine"},{"nome":"Comelico Superiore","cap":["32040"],"district":"BL","districtName":"Belluno"},{"nome":"Comerio","cap":["21025"],"district":"VA","districtName":"Varese"},{"nome":"Comezzano-Cizzago","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Comignago","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"Comiso","cap":["97013"],"district":"RG","districtName":"Ragusa"},{"nome":"Comitini","cap":["92020"],"district":"AG","districtName":"Agrigento"},{"nome":"Comiziano","cap":["80030"],"district":"NA","districtName":"Napoli"},{"nome":"Commessaggio","cap":["46010"],"district":"MN","districtName":"Mantova"},{"nome":"Commezzadura","cap":["38020"],"district":"TN","districtName":"Trento"},{"nome":"Como","cap":["22100"],"district":"CO","districtName":"Como"},{"nome":"Compiano","cap":["43053"],"district":"PR","districtName":"Parma"},{"nome":"Comun Nuovo","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Comunanza","cap":["63087"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Cona","cap":["30010"],"district":"VE","districtName":"Venezia"},{"nome":"Conca Casale","cap":["86070"],"district":"IS","districtName":"Isernia"},{"nome":"Conca dei Marini","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"Conca della Campania","cap":["81044"],"district":"CE","districtName":"Caserta"},{"nome":"Concamarise","cap":["37050"],"district":"VR","districtName":"Verona"},{"nome":"Concerviano","cap":["02020"],"district":"RI","districtName":"Rieti"},{"nome":"Concesio","cap":["25062"],"district":"BS","districtName":"Brescia"},{"nome":"Concordia Sagittaria","cap":["30023"],"district":"VE","districtName":"Venezia"},{"nome":"Concordia sulla Secchia","cap":["41033"],"district":"MO","districtName":"Modena"},{"nome":"Concorezzo","cap":["20863"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Condofuri","cap":["89030"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Condove","cap":["10055"],"district":"TO","districtName":"Torino"},{"nome":"Condrò","cap":["98040"],"district":"ME","districtName":"Messina"},{"nome":"Conegliano","cap":["31015"],"district":"TV","districtName":"Treviso"},{"nome":"Confienza","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Configni","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Conflenti","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Coniolo","cap":["15030"],"district":"AL","districtName":"Alessandria"},{"nome":"Conselice","cap":["48017"],"district":"RA","districtName":"Ravenna"},{"nome":"Conselve","cap":["35026"],"district":"PD","districtName":"Padova"},{"nome":"Contà","cap":["38093"],"district":"TN","districtName":"Trento"},{"nome":"Contessa Entellina","cap":["90030"],"district":"PA","districtName":"Palermo"},{"nome":"Contigliano","cap":["02043"],"district":"RI","districtName":"Rieti"},{"nome":"Contrada","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Controguerra","cap":["64010"],"district":"TE","districtName":"Teramo"},{"nome":"Controne","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Contursi Terme","cap":["84024"],"district":"SA","districtName":"Salerno"},{"nome":"Conversano","cap":["70014"],"district":"BA","districtName":"Bari"},{"nome":"Conza della Campania","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Conzano","cap":["15030"],"district":"AL","districtName":"Alessandria"},{"nome":"Copertino","cap":["73043"],"district":"LE","districtName":"Lecce"},{"nome":"Copiano","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Copparo","cap":["44034"],"district":"FE","districtName":"Ferrara"},{"nome":"Corana","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Corato","cap":["70033"],"district":"BA","districtName":"Bari"},{"nome":"Corbara","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"Corbetta","cap":["20011"],"district":"MI","districtName":"Milano"},{"nome":"Corbola","cap":["45015"],"district":"RO","districtName":"Rovigo"},{"nome":"Corchiano","cap":["01030"],"district":"VT","districtName":"Viterbo"},{"nome":"Corciano","cap":["06073"],"district":"PG","districtName":"Perugia"},{"nome":"Cordenons","cap":["33084"],"district":"PN","districtName":"Pordenone"},{"nome":"Cordignano","cap":["31016"],"district":"TV","districtName":"Treviso"},{"nome":"Cordovado","cap":["33075"],"district":"PN","districtName":"Pordenone"},{"nome":"Coreglia Antelminelli","cap":["55025"],"district":"LU","districtName":"Lucca"},{"nome":"Coreglia Ligure","cap":["16040"],"district":"GE","districtName":"Genova"},{"nome":"Coreno Ausonio","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Corfinio","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Cori","cap":["04010"],"district":"LT","districtName":"Latina"},{"nome":"Coriano","cap":["47853"],"district":"RN","districtName":"Rimini"},{"nome":"Corigliano d'Otranto","cap":["73022"],"district":"LE","districtName":"Lecce"},{"nome":"Corigliano-Rossano","cap":["87064"],"district":"CS","districtName":"Cosenza"},{"nome":"Corinaldo","cap":["60013"],"district":"AN","districtName":"Ancona"},{"nome":"Corio","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Corleone","cap":["90034"],"district":"PA","districtName":"Palermo"},{"nome":"Corleto Monforte","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Corleto Perticara","cap":["85012"],"district":"PZ","districtName":"Potenza"},{"nome":"Cormano","cap":["20032"],"district":"MI","districtName":"Milano"},{"nome":"Cormons","cap":["34071"],"district":"GO","districtName":"Gorizia"},{"nome":"Corna Imagna","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Cornalba","cap":["24017"],"district":"BG","districtName":"Bergamo"},{"nome":"Cornale e Bastida","cap":["27056"],"district":"PV","districtName":"Pavia"},{"nome":"Cornaredo","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Cornate d'Adda","cap":["20872"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Cornedo all'Isarco","cap":["39053"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Cornedo Vicentino","cap":["36073"],"district":"VI","districtName":"Vicenza"},{"nome":"Cornegliano Laudense","cap":["26854"],"district":"LO","districtName":"Lodi"},{"nome":"Corneliano d'Alba","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Corniglio","cap":["43021"],"district":"PR","districtName":"Parma"},{"nome":"Corno di Rosazzo","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Corno Giovine","cap":["26846"],"district":"LO","districtName":"Lodi"},{"nome":"Cornovecchio","cap":["26842"],"district":"LO","districtName":"Lodi"},{"nome":"Cornuda","cap":["31041"],"district":"TV","districtName":"Treviso"},{"nome":"Correggio","cap":["42015"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Correzzana","cap":["20856"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Correzzola","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Corrido","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Corridonia","cap":["62014"],"district":"MC","districtName":"Macerata"},{"nome":"Corropoli","cap":["64013"],"district":"TE","districtName":"Teramo"},{"nome":"Corsano","cap":["73033"],"district":"LE","districtName":"Lecce"},{"nome":"Corsico","cap":["20094"],"district":"MI","districtName":"Milano"},{"nome":"Corsione","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Cortaccia sulla strada del vino","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Cortale","cap":["88020"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Cortandone","cap":["14013"],"district":"AT","districtName":"Asti"},{"nome":"Cortanze","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Cortazzone","cap":["14010"],"district":"AT","districtName":"Asti"},{"nome":"Corte Brugnatella","cap":["29020"],"district":"PC","districtName":"Piacenza"},{"nome":"Corte de' Cortesi con Cignone","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Corte de' Frati","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Corte Franca","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Corte Palasio","cap":["26834"],"district":"LO","districtName":"Lodi"},{"nome":"Cortemaggiore","cap":["29016"],"district":"PC","districtName":"Piacenza"},{"nome":"Cortemilia","cap":["12074"],"district":"CN","districtName":"Cuneo"},{"nome":"Corteno Golgi","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Cortenova","cap":["23813"],"district":"LC","districtName":"Lecco"},{"nome":"Cortenuova","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Corteolona e Genzone","cap":["27014"],"district":"PV","districtName":"Pavia"},{"nome":"Cortiglione","cap":["14040"],"district":"AT","districtName":"Asti"},{"nome":"Cortina d'Ampezzo","cap":["32043"],"district":"BL","districtName":"Belluno"},{"nome":"Cortina sulla strada del vino","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Cortino","cap":["64040"],"district":"TE","districtName":"Teramo"},{"nome":"Cortona","cap":["52044"],"district":"AR","districtName":"Arezzo"},{"nome":"Corvara","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Corvara in Badia","cap":["39033"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Corvino San Quirico","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Corzano","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Coseano","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"Cosenza","cap":["87100"],"district":"CS","districtName":"Cosenza"},{"nome":"Cosio d'Arroscia","cap":["18023"],"district":"IM","districtName":"Imperia"},{"nome":"Cosio Valtellino","cap":["23013"],"district":"SO","districtName":"Sondrio"},{"nome":"Cosoleto","cap":["89050"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Cossano Belbo","cap":["12054"],"district":"CN","districtName":"Cuneo"},{"nome":"Cossano Canavese","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Cossato","cap":["13836"],"district":"BI","districtName":"Biella"},{"nome":"Cosseria","cap":["17017"],"district":"SV","districtName":"Savona"},{"nome":"Cossignano","cap":["63067"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Cossogno","cap":["28801"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Cossoine","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Cossombrato","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Costa de' Nobili","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Costa di Mezzate","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Costa di Rovigo","cap":["45023"],"district":"RO","districtName":"Rovigo"},{"nome":"Costa Masnaga","cap":["23845"],"district":"LC","districtName":"Lecco"},{"nome":"Costa Serina","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Costa Valle Imagna","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Costa Vescovato","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Costa Volpino","cap":["24062"],"district":"BG","districtName":"Bergamo"},{"nome":"Costabissara","cap":["36030"],"district":"VI","districtName":"Vicenza"},{"nome":"Costacciaro","cap":["06021"],"district":"PG","districtName":"Perugia"},{"nome":"Costanzana","cap":["13033"],"district":"VC","districtName":"Vercelli"},{"nome":"Costarainera","cap":["18017"],"district":"IM","districtName":"Imperia"},{"nome":"Costermano sul Garda","cap":["37010"],"district":"VR","districtName":"Verona"},{"nome":"Costigliole d'Asti","cap":["14055"],"district":"AT","districtName":"Asti"},{"nome":"Costigliole Saluzzo","cap":["12024"],"district":"CN","districtName":"Cuneo"},{"nome":"Cotignola","cap":["48033"],"district":"RA","districtName":"Ravenna"},{"nome":"Cotronei","cap":["88836"],"district":"KR","districtName":"Crotone"},{"nome":"Cottanello","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Courmayeur","cap":["11013"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Covo","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Cozzo","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Craco","cap":["75010"],"district":"MT","districtName":"Matera"},{"nome":"Crandola Valsassina","cap":["23832"],"district":"LC","districtName":"Lecco"},{"nome":"Cravagliana","cap":["13020"],"district":"VC","districtName":"Vercelli"},{"nome":"Cravanzana","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Craveggia","cap":["28852"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Creazzo","cap":["36051"],"district":"VI","districtName":"Vicenza"},{"nome":"Crecchio","cap":["66014"],"district":"CH","districtName":"Chieti"},{"nome":"Credaro","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Credera Rubbiano","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Crema","cap":["26013"],"district":"CR","districtName":"Cremona"},{"nome":"Cremella","cap":["23894"],"district":"LC","districtName":"Lecco"},{"nome":"Cremenaga","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Cremeno","cap":["23814"],"district":"LC","districtName":"Lecco"},{"nome":"Cremia","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Cremolino","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Cremona","cap":["26100"],"district":"CR","districtName":"Cremona"},{"nome":"Cremosano","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Crescentino","cap":["13044"],"district":"VC","districtName":"Vercelli"},{"nome":"Crespadoro","cap":["36070"],"district":"VI","districtName":"Vicenza"},{"nome":"Crespiatica","cap":["26835"],"district":"LO","districtName":"Lodi"},{"nome":"Crespina Lorenzana","cap":["56042"],"district":"PI","districtName":"Pisa"},{"nome":"Crespino","cap":["45030"],"district":"RO","districtName":"Rovigo"},{"nome":"Cressa","cap":["28012"],"district":"NO","districtName":"Novara"},{"nome":"Crevacuore","cap":["13864"],"district":"BI","districtName":"Biella"},{"nome":"Crevalcore","cap":["40014"],"district":"BO","districtName":"Bologna"},{"nome":"Crevoladossola","cap":["28865"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Crispano","cap":["80020"],"district":"NA","districtName":"Napoli"},{"nome":"Crispiano","cap":["74012"],"district":"TA","districtName":"Taranto"},{"nome":"Crissolo","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Crocefieschi","cap":["16010"],"district":"GE","districtName":"Genova"},{"nome":"Crocetta del Montello","cap":["31035"],"district":"TV","districtName":"Treviso"},{"nome":"Crodo","cap":["28862"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Crognaleto","cap":["64043"],"district":"TE","districtName":"Teramo"},{"nome":"Cropalati","cap":["87060"],"district":"CS","districtName":"Cosenza"},{"nome":"Cropani","cap":["88051"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Crosia","cap":["87060"],"district":"CS","districtName":"Cosenza"},{"nome":"Crosio della Valle","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Crotone","cap":["88900"],"district":"KR","districtName":"Crotone"},{"nome":"Crotta d'Adda","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Crova","cap":["13040"],"district":"VC","districtName":"Vercelli"},{"nome":"Croviana","cap":["38027"],"district":"TN","districtName":"Trento"},{"nome":"Crucoli","cap":["88812"],"district":"KR","districtName":"Crotone"},{"nome":"Cuasso al Monte","cap":["21050"],"district":"VA","districtName":"Varese"},{"nome":"Cuccaro Vetere","cap":["84050"],"district":"SA","districtName":"Salerno"},{"nome":"Cucciago","cap":["22060"],"district":"CO","districtName":"Como"},{"nome":"Cuceglio","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Cuggiono","cap":["20012"],"district":"MI","districtName":"Milano"},{"nome":"Cugliate-Fabiasco","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Cuglieri","cap":["09073"],"district":"OR","districtName":"Oristano"},{"nome":"Cugnoli","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Cumiana","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Cumignano sul Naviglio","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Cunardo","cap":["21035"],"district":"VA","districtName":"Varese"},{"nome":"Cuneo","cap":["12100"],"district":"CN","districtName":"Cuneo"},{"nome":"Cunico","cap":["14026"],"district":"AT","districtName":"Asti"},{"nome":"Cuorgnè","cap":["10082"],"district":"TO","districtName":"Torino"},{"nome":"Cupello","cap":["66051"],"district":"CH","districtName":"Chieti"},{"nome":"Cupra Marittima","cap":["63064"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Cupramontana","cap":["60034"],"district":"AN","districtName":"Ancona"},{"nome":"Cura Carpignano","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Curcuris","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Cureggio","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"Curiglia con Monteviasco","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Curinga","cap":["88022"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Curino","cap":["13865"],"district":"BI","districtName":"Biella"},{"nome":"Curno","cap":["24035"],"district":"BG","districtName":"Bergamo"},{"nome":"Curon Venosta","cap":["39027"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Cursi","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Curtarolo","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Curtatone","cap":["46010"],"district":"MN","districtName":"Mantova"},{"nome":"Curti","cap":["81040"],"district":"CE","districtName":"Caserta"},{"nome":"Cusago","cap":["20090"],"district":"MI","districtName":"Milano"},{"nome":"Cusano Milanino","cap":["20095"],"district":"MI","districtName":"Milano"},{"nome":"Cusano Mutri","cap":["82033"],"district":"BN","districtName":"Benevento"},{"nome":"Cusino","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Cusio","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Custonaci","cap":["91015"],"district":"TP","districtName":"Trapani"},{"nome":"Cutro","cap":["88842"],"district":"KR","districtName":"Crotone"},{"nome":"Cutrofiano","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Cuveglio","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Cuvio","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Dairago","cap":["20020"],"district":"MI","districtName":"Milano"},{"nome":"Dalmine","cap":["24044"],"district":"BG","districtName":"Bergamo"},{"nome":"Dambel","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Danta di Cadore","cap":["32040"],"district":"BL","districtName":"Belluno"},{"nome":"Darfo Boario Terme","cap":["25047"],"district":"BS","districtName":"Brescia"},{"nome":"Dasà","cap":["89832"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Davagna","cap":["16022"],"district":"GE","districtName":"Genova"},{"nome":"Daverio","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Davoli","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Dazio","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Decimomannu","cap":["09033"],"district":"CA","districtName":"Cagliari"},{"nome":"Decimoputzu","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Decollatura","cap":["88041"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Dego","cap":["17058"],"district":"SV","districtName":"Savona"},{"nome":"Deiva Marina","cap":["19013"],"district":"SP","districtName":"La Spezia"},{"nome":"Delebio","cap":["23014"],"district":"SO","districtName":"Sondrio"},{"nome":"Delia","cap":["93010"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Delianuova","cap":["89012"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Deliceto","cap":["71026"],"district":"FG","districtName":"Foggia"},{"nome":"Dello","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Demonte","cap":["12014"],"district":"CN","districtName":"Cuneo"},{"nome":"Denice","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Denno","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Dernice","cap":["15056"],"district":"AL","districtName":"Alessandria"},{"nome":"Derovere","cap":["26040"],"district":"CR","districtName":"Cremona"},{"nome":"Deruta","cap":["06053"],"district":"PG","districtName":"Perugia"},{"nome":"Dervio","cap":["23824"],"district":"LC","districtName":"Lecco"},{"nome":"Desana","cap":["13034"],"district":"VC","districtName":"Vercelli"},{"nome":"Desenzano del Garda","cap":["25015"],"district":"BS","districtName":"Brescia"},{"nome":"Desio","cap":["20832"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Desulo","cap":["08032"],"district":"NU","districtName":"Nuoro"},{"nome":"Diamante","cap":["87023"],"district":"CS","districtName":"Cosenza"},{"nome":"Diano Arentino","cap":["18013"],"district":"IM","districtName":"Imperia"},{"nome":"Diano Castello","cap":["18013"],"district":"IM","districtName":"Imperia"},{"nome":"Diano d'Alba","cap":["12055"],"district":"CN","districtName":"Cuneo"},{"nome":"Diano Marina","cap":["18013"],"district":"IM","districtName":"Imperia"},{"nome":"Diano San Pietro","cap":["18013"],"district":"IM","districtName":"Imperia"},{"nome":"Dicomano","cap":["50062"],"district":"FI","districtName":"Firenze"},{"nome":"Dignano","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"Dimaro Folgarida","cap":["38025"],"district":"TN","districtName":"Trento"},{"nome":"Dinami","cap":["89833"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Dipignano","cap":["87045"],"district":"CS","districtName":"Cosenza"},{"nome":"Diso","cap":["73030"],"district":"LE","districtName":"Lecce"},{"nome":"Divignano","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Dizzasco","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Dobbiaco","cap":["39034"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Doberdò del Lago","cap":["34070"],"district":"GO","districtName":"Gorizia"},{"nome":"Dogliani","cap":["12063"],"district":"CN","districtName":"Cuneo"},{"nome":"Dogliola","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Dogna","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Dolcè","cap":["37020"],"district":"VR","districtName":"Verona"},{"nome":"Dolceacqua","cap":["18035"],"district":"IM","districtName":"Imperia"},{"nome":"Dolcedo","cap":["18020"],"district":"IM","districtName":"Imperia"},{"nome":"Dolegna del Collio","cap":["34070"],"district":"GO","districtName":"Gorizia"},{"nome":"Dolianova","cap":["09041"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Dolo","cap":["30031"],"district":"VE","districtName":"Venezia"},{"nome":"Dolzago","cap":["23843"],"district":"LC","districtName":"Lecco"},{"nome":"Domanico","cap":["87030"],"district":"CS","districtName":"Cosenza"},{"nome":"Domaso","cap":["22013"],"district":"CO","districtName":"Como"},{"nome":"Domegge di Cadore","cap":["32040"],"district":"BL","districtName":"Belluno"},{"nome":"Domicella","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Domodossola","cap":["28845"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Domus de Maria","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Domusnovas","cap":["09015"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Donato","cap":["13893"],"district":"BI","districtName":"Biella"},{"nome":"Dongo","cap":["22014"],"district":"CO","districtName":"Como"},{"nome":"Donnas","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Donori","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Dorgali","cap":["08022"],"district":"NU","districtName":"Nuoro"},{"nome":"Dorio","cap":["23824"],"district":"LC","districtName":"Lecco"},{"nome":"Dormelletto","cap":["28040"],"district":"NO","districtName":"Novara"},{"nome":"Dorno","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Dorzano","cap":["13881"],"district":"BI","districtName":"Biella"},{"nome":"Dosolo","cap":["46030"],"district":"MN","districtName":"Mantova"},{"nome":"Dossena","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Dosso del Liro","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Doues","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Dovadola","cap":["47013"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Dovera","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Dozza","cap":["40060"],"district":"BO","districtName":"Bologna"},{"nome":"Dragoni","cap":["81010"],"district":"CE","districtName":"Caserta"},{"nome":"Drapia","cap":["89862"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Drena","cap":["38074"],"district":"TN","districtName":"Trento"},{"nome":"Drenchia","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Dresano","cap":["20070"],"district":"MI","districtName":"Milano"},{"nome":"Dro","cap":["38074"],"district":"TN","districtName":"Trento"},{"nome":"Dronero","cap":["12025"],"district":"CN","districtName":"Cuneo"},{"nome":"Druento","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Druogno","cap":["28853"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Dualchi","cap":["08010"],"district":"NU","districtName":"Nuoro"},{"nome":"Dubino","cap":["23015"],"district":"SO","districtName":"Sondrio"},{"nome":"Due Carrare","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Dueville","cap":["36031"],"district":"VI","districtName":"Vicenza"},{"nome":"Dugenta","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Duino Aurisina","cap":["34011"],"district":"TS","districtName":"Trieste"},{"nome":"Dumenza","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Duno","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Durazzano","cap":["82015"],"district":"BN","districtName":"Benevento"},{"nome":"Duronia","cap":["86020"],"district":"CB","districtName":"Campobasso"},{"nome":"Dusino San Michele","cap":["14010"],"district":"AT","districtName":"Asti"},{"nome":"Eboli","cap":["84025"],"district":"SA","districtName":"Salerno"},{"nome":"Edolo","cap":["25048"],"district":"BS","districtName":"Brescia"},{"nome":"Egna","cap":["39044"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Elice","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Elini","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Ello","cap":["23848"],"district":"LC","districtName":"Lecco"},{"nome":"Elmas","cap":["09067"],"district":"CA","districtName":"Cagliari"},{"nome":"Elva","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Emarèse","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Empoli","cap":["50053"],"district":"FI","districtName":"Firenze"},{"nome":"Endine Gaiano","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Enego","cap":["36052"],"district":"VI","districtName":"Vicenza"},{"nome":"Enemonzo","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Enna","cap":["94100"],"district":"EN","districtName":"Enna"},{"nome":"Entracque","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Entratico","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Envie","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Episcopia","cap":["85033"],"district":"PZ","districtName":"Potenza"},{"nome":"Eraclea","cap":["30020"],"district":"VE","districtName":"Venezia"},{"nome":"Erba","cap":["22036"],"district":"CO","districtName":"Como"},{"nome":"Erbè","cap":["37060"],"district":"VR","districtName":"Verona"},{"nome":"Erbezzo","cap":["37020"],"district":"VR","districtName":"Verona"},{"nome":"Erbusco","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Erchie","cap":["72020"],"district":"BR","districtName":"Brindisi"},{"nome":"Ercolano","cap":["80056"],"district":"NA","districtName":"Napoli"},{"nome":"Erice","cap":["91016"],"district":"TP","districtName":"Trapani"},{"nome":"Erli","cap":["17030"],"district":"SV","districtName":"Savona"},{"nome":"Erto e Casso","cap":["33080"],"district":"PN","districtName":"Pordenone"},{"nome":"Erula","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Erve","cap":["23805"],"district":"LC","districtName":"Lecco"},{"nome":"Esanatoglia","cap":["62024"],"district":"MC","districtName":"Macerata"},{"nome":"Escalaplano","cap":["09051"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Escolca","cap":["09052"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Esine","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Esino Lario","cap":["23825"],"district":"LC","districtName":"Lecco"},{"nome":"Esperia","cap":["03045"],"district":"FR","districtName":"Frosinone"},{"nome":"Esporlatu","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Este","cap":["35042"],"district":"PD","districtName":"Padova"},{"nome":"Esterzili","cap":["09053"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Etroubles","cap":["11014"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Eupilio","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Exilles","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Fabbrica Curone","cap":["15054"],"district":"AL","districtName":"Alessandria"},{"nome":"Fabbriche di Vergemoli","cap":["55021"],"district":"LU","districtName":"Lucca"},{"nome":"Fabbrico","cap":["42042"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Fabriano","cap":["60044"],"district":"AN","districtName":"Ancona"},{"nome":"Fabrica di Roma","cap":["01034"],"district":"VT","districtName":"Viterbo"},{"nome":"Fabrizia","cap":["89823"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Fabro","cap":["05015"],"district":"TR","districtName":"Terni"},{"nome":"Faedis","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Faedo Valtellino","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Faenza","cap":["48018"],"district":"RA","districtName":"Ravenna"},{"nome":"Faeto","cap":["71020"],"district":"FG","districtName":"Foggia"},{"nome":"Fagagna","cap":["33034"],"district":"UD","districtName":"Udine"},{"nome":"Faggeto Lario","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Faggiano","cap":["74020"],"district":"TA","districtName":"Taranto"},{"nome":"Fagnano Alto","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Fagnano Castello","cap":["87013"],"district":"CS","districtName":"Cosenza"},{"nome":"Fagnano Olona","cap":["21054"],"district":"VA","districtName":"Varese"},{"nome":"Fai della Paganella","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Faicchio","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Falcade","cap":["32020"],"district":"BL","districtName":"Belluno"},{"nome":"Falciano del Massico","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Falconara Albanese","cap":["87030"],"district":"CS","districtName":"Cosenza"},{"nome":"Falconara Marittima","cap":["60015"],"district":"AN","districtName":"Ancona"},{"nome":"Falcone","cap":["98060"],"district":"ME","districtName":"Messina"},{"nome":"Faleria","cap":["01030"],"district":"VT","districtName":"Viterbo"},{"nome":"Falerna","cap":["88042"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Falerone","cap":["63837"],"district":"FM","districtName":"Fermo"},{"nome":"Fallo","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Faloppio","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Falvaterra","cap":["03020"],"district":"FR","districtName":"Frosinone"},{"nome":"Falzes","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Fanano","cap":["41021"],"district":"MO","districtName":"Modena"},{"nome":"Fanna","cap":["33092"],"district":"PN","districtName":"Pordenone"},{"nome":"Fano","cap":["61032"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Fano Adriano","cap":["64044"],"district":"TE","districtName":"Teramo"},{"nome":"Fara Filiorum Petri","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Fara Gera d'Adda","cap":["24045"],"district":"BG","districtName":"Bergamo"},{"nome":"Fara in Sabina","cap":["02032"],"district":"RI","districtName":"Rieti"},{"nome":"Fara Novarese","cap":["28073"],"district":"NO","districtName":"Novara"},{"nome":"Fara Olivana con Sola","cap":["24058"],"district":"BG","districtName":"Bergamo"},{"nome":"Fara San Martino","cap":["66015"],"district":"CH","districtName":"Chieti"},{"nome":"Fara Vicentino","cap":["36030"],"district":"VI","districtName":"Vicenza"},{"nome":"Fardella","cap":["85034"],"district":"PZ","districtName":"Potenza"},{"nome":"Farigliano","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Farindola","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Farini","cap":["29023"],"district":"PC","districtName":"Piacenza"},{"nome":"Farnese","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Farra d'Isonzo","cap":["34072"],"district":"GO","districtName":"Gorizia"},{"nome":"Farra di Soligo","cap":["31010"],"district":"TV","districtName":"Treviso"},{"nome":"Fasano","cap":["72015"],"district":"BR","districtName":"Brindisi"},{"nome":"Fascia","cap":["16020"],"district":"GE","districtName":"Genova"},{"nome":"Fauglia","cap":["56043"],"district":"PI","districtName":"Pisa"},{"nome":"Faule","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Favale di Malvaro","cap":["16040"],"district":"GE","districtName":"Genova"},{"nome":"Favara","cap":["92026"],"district":"AG","districtName":"Agrigento"},{"nome":"Favignana","cap":["91023"],"district":"TP","districtName":"Trapani"},{"nome":"Favria","cap":["10083"],"district":"TO","districtName":"Torino"},{"nome":"Feisoglio","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Feletto","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Felino","cap":["43035"],"district":"PR","districtName":"Parma"},{"nome":"Felitto","cap":["84055"],"district":"SA","districtName":"Salerno"},{"nome":"Felizzano","cap":["15023"],"district":"AL","districtName":"Alessandria"},{"nome":"Feltre","cap":["32032"],"district":"BL","districtName":"Belluno"},{"nome":"Fenegrò","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Fenestrelle","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Fénis","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Ferentillo","cap":["05034"],"district":"TR","districtName":"Terni"},{"nome":"Ferentino","cap":["03013"],"district":"FR","districtName":"Frosinone"},{"nome":"Ferla","cap":["96010"],"district":"SR","districtName":"Siracusa"},{"nome":"Fermignano","cap":["61033"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Fermo","cap":["63900"],"district":"FM","districtName":"Fermo"},{"nome":"Ferno","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Feroleto Antico","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Feroleto della Chiesa","cap":["89050"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Ferrandina","cap":["75013"],"district":"MT","districtName":"Matera"},{"nome":"Ferrara","cap":["44121","44122","44123","44124"],"district":"FE","districtName":"Ferrara"},{"nome":"Ferrara di Monte Baldo","cap":["37020"],"district":"VR","districtName":"Verona"},{"nome":"Ferrazzano","cap":["86010"],"district":"CB","districtName":"Campobasso"},{"nome":"Ferrera di Varese","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Ferrera Erbognone","cap":["27032"],"district":"PV","districtName":"Pavia"},{"nome":"Ferrere","cap":["14012"],"district":"AT","districtName":"Asti"},{"nome":"Ferriere","cap":["29024"],"district":"PC","districtName":"Piacenza"},{"nome":"Ferruzzano","cap":["89030"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Fiamignano","cap":["02023"],"district":"RI","districtName":"Rieti"},{"nome":"Fiano","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Fiano Romano","cap":["00065"],"district":"RM","districtName":"Roma"},{"nome":"Fiastra","cap":["62035"],"district":"MC","districtName":"Macerata"},{"nome":"Fiavè","cap":["38075"],"district":"TN","districtName":"Trento"},{"nome":"Ficarazzi","cap":["90010"],"district":"PA","districtName":"Palermo"},{"nome":"Ficarolo","cap":["45036"],"district":"RO","districtName":"Rovigo"},{"nome":"Ficarra","cap":["98062"],"district":"ME","districtName":"Messina"},{"nome":"Ficulle","cap":["05016"],"district":"TR","districtName":"Terni"},{"nome":"Fidenza","cap":["43036"],"district":"PR","districtName":"Parma"},{"nome":"Fiè allo Sciliar","cap":["39050"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Fierozzo","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Fiesco","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Fiesole","cap":["50014"],"district":"FI","districtName":"Firenze"},{"nome":"Fiesse","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Fiesso d'Artico","cap":["30032"],"district":"VE","districtName":"Venezia"},{"nome":"Fiesso Umbertiano","cap":["45024"],"district":"RO","districtName":"Rovigo"},{"nome":"Figino Serenza","cap":["22060"],"district":"CO","districtName":"Como"},{"nome":"Figline e Incisa Valdarno","cap":["50063"],"district":"FI","districtName":"Firenze"},{"nome":"Figline Vegliaturo","cap":["87050"],"district":"CS","districtName":"Cosenza"},{"nome":"Filacciano","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Filadelfia","cap":["89814"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Filago","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Filandari","cap":["89841"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Filattiera","cap":["54023"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Filettino","cap":["03010"],"district":"FR","districtName":"Frosinone"},{"nome":"Filetto","cap":["66030"],"district":"CH","districtName":"Chieti"},{"nome":"Filiano","cap":["85020"],"district":"PZ","districtName":"Potenza"},{"nome":"Filighera","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Filignano","cap":["86074"],"district":"IS","districtName":"Isernia"},{"nome":"Filogaso","cap":["89843"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Filottrano","cap":["60024"],"district":"AN","districtName":"Ancona"},{"nome":"Finale Emilia","cap":["41034"],"district":"MO","districtName":"Modena"},{"nome":"Finale Ligure","cap":["17024"],"district":"SV","districtName":"Savona"},{"nome":"Fino del Monte","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Fino Mornasco","cap":["22073"],"district":"CO","districtName":"Como"},{"nome":"Fiorano al Serio","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Fiorano Canavese","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Fiorano Modenese","cap":["41042"],"district":"MO","districtName":"Modena"},{"nome":"Fiorenzuola d'Arda","cap":["29017"],"district":"PC","districtName":"Piacenza"},{"nome":"Firenze","cap":["50121","50122","50123","50124","50125","50126","50127","50128","50129","50130","50131","50132","50133","50134","50135","50136","50137","50138","50139","50140","50141","50142","50143","50144","50145"],"district":"FI","districtName":"Firenze"},{"nome":"Firenzuola","cap":["50033"],"district":"FI","districtName":"Firenze"},{"nome":"Firmo","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Fiscaglia","cap":["44027"],"district":"FE","districtName":"Ferrara"},{"nome":"Fisciano","cap":["84084"],"district":"SA","districtName":"Salerno"},{"nome":"Fiuggi","cap":["03014"],"district":"FR","districtName":"Frosinone"},{"nome":"Fiumalbo","cap":["41022"],"district":"MO","districtName":"Modena"},{"nome":"Fiumara","cap":["89050"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Fiume Veneto","cap":["33080"],"district":"PN","districtName":"Pordenone"},{"nome":"Fiumedinisi","cap":["98022"],"district":"ME","districtName":"Messina"},{"nome":"Fiumefreddo Bruzio","cap":["87030"],"district":"CS","districtName":"Cosenza"},{"nome":"Fiumefreddo di Sicilia","cap":["95013"],"district":"CT","districtName":"Catania"},{"nome":"Fiumicello Villa Vicentina","cap":["33059"],"district":"UD","districtName":"Udine"},{"nome":"Fiumicino","cap":["00054"],"district":"RM","districtName":"Roma"},{"nome":"Fiuminata","cap":["62025"],"district":"MC","districtName":"Macerata"},{"nome":"Fivizzano","cap":["54013"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Flaibano","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"Flero","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Floresta","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Floridia","cap":["96014"],"district":"SR","districtName":"Siracusa"},{"nome":"Florinas","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Flumeri","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Fluminimaggiore","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Flussio","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Fobello","cap":["13025"],"district":"VC","districtName":"Vercelli"},{"nome":"Foggia","cap":["71121","71122"],"district":"FG","districtName":"Foggia"},{"nome":"Foglianise","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Fogliano Redipuglia","cap":["34070"],"district":"GO","districtName":"Gorizia"},{"nome":"Foglizzo","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Foiano della Chiana","cap":["52045"],"district":"AR","districtName":"Arezzo"},{"nome":"Foiano di Val Fortore","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Folgaria","cap":["38064"],"district":"TN","districtName":"Trento"},{"nome":"Folignano","cap":["63084"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Foligno","cap":["06034"],"district":"PG","districtName":"Perugia"},{"nome":"Follina","cap":["31051"],"district":"TV","districtName":"Treviso"},{"nome":"Follo","cap":["19020"],"district":"SP","districtName":"La Spezia"},{"nome":"Follonica","cap":["58022"],"district":"GR","districtName":"Grosseto"},{"nome":"Fombio","cap":["26861"],"district":"LO","districtName":"Lodi"},{"nome":"Fondachelli-Fantina","cap":["98050"],"district":"ME","districtName":"Messina"},{"nome":"Fondi","cap":["04022"],"district":"LT","districtName":"Latina"},{"nome":"Fonni","cap":["08023"],"district":"NU","districtName":"Nuoro"},{"nome":"Fontainemore","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Fontana Liri","cap":["03035"],"district":"FR","districtName":"Frosinone"},{"nome":"Fontanafredda","cap":["33074"],"district":"PN","districtName":"Pordenone"},{"nome":"Fontanarosa","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Fontanelice","cap":["40025"],"district":"BO","districtName":"Bologna"},{"nome":"Fontanella","cap":["24056"],"district":"BG","districtName":"Bergamo"},{"nome":"Fontanellato","cap":["43012"],"district":"PR","districtName":"Parma"},{"nome":"Fontanelle","cap":["31043"],"district":"TV","districtName":"Treviso"},{"nome":"Fontaneto d'Agogna","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Fontanetto Po","cap":["13040"],"district":"VC","districtName":"Vercelli"},{"nome":"Fontanigorda","cap":["16023"],"district":"GE","districtName":"Genova"},{"nome":"Fontanile","cap":["14044"],"district":"AT","districtName":"Asti"},{"nome":"Fontaniva","cap":["35014"],"district":"PD","districtName":"Padova"},{"nome":"Fonte","cap":["31010"],"district":"TV","districtName":"Treviso"},{"nome":"Fonte Nuova","cap":["00013"],"district":"RM","districtName":"Roma"},{"nome":"Fontecchio","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Fontechiari","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Fontegreca","cap":["81014"],"district":"CE","districtName":"Caserta"},{"nome":"Fonteno","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Fontevivo","cap":["43010"],"district":"PR","districtName":"Parma"},{"nome":"Fonzaso","cap":["32030"],"district":"BL","districtName":"Belluno"},{"nome":"Foppolo","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Forano","cap":["02044"],"district":"RI","districtName":"Rieti"},{"nome":"Force","cap":["63086"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Forchia","cap":["82011"],"district":"BN","districtName":"Benevento"},{"nome":"Forcola","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Fordongianus","cap":["09083"],"district":"OR","districtName":"Oristano"},{"nome":"Forenza","cap":["85023"],"district":"PZ","districtName":"Potenza"},{"nome":"Foresto Sparso","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Forgaria nel Friuli","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"Forino","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Forio","cap":["80075"],"district":"NA","districtName":"Napoli"},{"nome":"Forlì","cap":["47121","47122"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Forlì del Sannio","cap":["86084"],"district":"IS","districtName":"Isernia"},{"nome":"Forlimpopoli","cap":["47034"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Formazza","cap":["28863"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Formello","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Formia","cap":["04023"],"district":"LT","districtName":"Latina"},{"nome":"Formicola","cap":["81040"],"district":"CE","districtName":"Caserta"},{"nome":"Formigara","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Formigine","cap":["41043"],"district":"MO","districtName":"Modena"},{"nome":"Formigliana","cap":["13030"],"district":"VC","districtName":"Vercelli"},{"nome":"Fornace","cap":["38040"],"district":"TN","districtName":"Trento"},{"nome":"Fornelli","cap":["86070"],"district":"IS","districtName":"Isernia"},{"nome":"Forni Avoltri","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Forni di Sopra","cap":["33024"],"district":"UD","districtName":"Udine"},{"nome":"Forni di Sotto","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Forno Canavese","cap":["10084"],"district":"TO","districtName":"Torino"},{"nome":"Fornovo di Taro","cap":["43045"],"district":"PR","districtName":"Parma"},{"nome":"Fornovo San Giovanni","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Forte dei Marmi","cap":["55042"],"district":"LU","districtName":"Lucca"},{"nome":"Fortezza","cap":["39045"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Fortunago","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Forza d'Agrò","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Fosciandora","cap":["55020"],"district":"LU","districtName":"Lucca"},{"nome":"Fosdinovo","cap":["54035"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Fossa","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Fossacesia","cap":["66022"],"district":"CH","districtName":"Chieti"},{"nome":"Fossalta di Piave","cap":["30020"],"district":"VE","districtName":"Venezia"},{"nome":"Fossalta di Portogruaro","cap":["30025"],"district":"VE","districtName":"Venezia"},{"nome":"Fossalto","cap":["86020"],"district":"CB","districtName":"Campobasso"},{"nome":"Fossano","cap":["12045"],"district":"CN","districtName":"Cuneo"},{"nome":"Fossato di Vico","cap":["06022"],"district":"PG","districtName":"Perugia"},{"nome":"Fossato Serralta","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Fossò","cap":["30030"],"district":"VE","districtName":"Venezia"},{"nome":"Fossombrone","cap":["61034"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Foza","cap":["36010"],"district":"VI","districtName":"Vicenza"},{"nome":"Frabosa Soprana","cap":["12082"],"district":"CN","districtName":"Cuneo"},{"nome":"Frabosa Sottana","cap":["12083"],"district":"CN","districtName":"Cuneo"},{"nome":"Fraconalto","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Fragagnano","cap":["74022"],"district":"TA","districtName":"Taranto"},{"nome":"Fragneto l'Abate","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Fragneto Monforte","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Fraine","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Framura","cap":["19014"],"district":"SP","districtName":"La Spezia"},{"nome":"Francavilla al Mare","cap":["66023"],"district":"CH","districtName":"Chieti"},{"nome":"Francavilla Angitola","cap":["89815"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Francavilla Bisio","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Francavilla d'Ete","cap":["63816"],"district":"FM","districtName":"Fermo"},{"nome":"Francavilla di Sicilia","cap":["98034"],"district":"ME","districtName":"Messina"},{"nome":"Francavilla Fontana","cap":["72021"],"district":"BR","districtName":"Brindisi"},{"nome":"Francavilla in Sinni","cap":["85034"],"district":"PZ","districtName":"Potenza"},{"nome":"Francavilla Marittima","cap":["87072"],"district":"CS","districtName":"Cosenza"},{"nome":"Francica","cap":["89851"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Francofonte","cap":["96015"],"district":"SR","districtName":"Siracusa"},{"nome":"Francolise","cap":["81050"],"district":"CE","districtName":"Caserta"},{"nome":"Frascaro","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Frascarolo","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Frascati","cap":["00044"],"district":"RM","districtName":"Roma"},{"nome":"Frascineto","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Frassilongo","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Frassinelle Polesine","cap":["45030"],"district":"RO","districtName":"Rovigo"},{"nome":"Frassinello Monferrato","cap":["15035"],"district":"AL","districtName":"Alessandria"},{"nome":"Frassineto Po","cap":["15040"],"district":"AL","districtName":"Alessandria"},{"nome":"Frassinetto","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Frassino","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Frassinoro","cap":["41044"],"district":"MO","districtName":"Modena"},{"nome":"Frasso Sabino","cap":["02030"],"district":"RI","districtName":"Rieti"},{"nome":"Frasso Telesino","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Fratta Polesine","cap":["45025"],"district":"RO","districtName":"Rovigo"},{"nome":"Fratta Todina","cap":["06054"],"district":"PG","districtName":"Perugia"},{"nome":"Frattamaggiore","cap":["80027"],"district":"NA","districtName":"Napoli"},{"nome":"Frattaminore","cap":["80020"],"district":"NA","districtName":"Napoli"},{"nome":"Fratte Rosa","cap":["61040"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Frazzanò","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Fregona","cap":["31010"],"district":"TV","districtName":"Treviso"},{"nome":"Fresagrandinaria","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Fresonara","cap":["15064"],"district":"AL","districtName":"Alessandria"},{"nome":"Frigento","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Frignano","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Frinco","cap":["14030"],"district":"AT","districtName":"Asti"},{"nome":"Frisa","cap":["66030"],"district":"CH","districtName":"Chieti"},{"nome":"Frisanco","cap":["33080"],"district":"PN","districtName":"Pordenone"},{"nome":"Front","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Frontino","cap":["61021"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Frontone","cap":["61040"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Frosinone","cap":["03100"],"district":"FR","districtName":"Frosinone"},{"nome":"Frosolone","cap":["86095"],"district":"IS","districtName":"Isernia"},{"nome":"Frossasco","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Frugarolo","cap":["15065"],"district":"AL","districtName":"Alessandria"},{"nome":"Fubine Monferrato","cap":["15043"],"district":"AL","districtName":"Alessandria"},{"nome":"Fucecchio","cap":["50054"],"district":"FI","districtName":"Firenze"},{"nome":"Fuipiano Valle Imagna","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Fumane","cap":["37022"],"district":"VR","districtName":"Verona"},{"nome":"Fumone","cap":["03010"],"district":"FR","districtName":"Frosinone"},{"nome":"Funes","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Furci","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Furci Siculo","cap":["98023"],"district":"ME","districtName":"Messina"},{"nome":"Furnari","cap":["98054"],"district":"ME","districtName":"Messina"},{"nome":"Furore","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"Furtei","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Fuscaldo","cap":["87024"],"district":"CS","districtName":"Cosenza"},{"nome":"Fusignano","cap":["48034"],"district":"RA","districtName":"Ravenna"},{"nome":"Fusine","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Futani","cap":["84050"],"district":"SA","districtName":"Salerno"},{"nome":"Gabbioneta-Binanuova","cap":["26030"],"district":"CR","districtName":"Cremona"},{"nome":"Gabiano","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Gabicce Mare","cap":["61011"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Gaby","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Gadesco-Pieve Delmona","cap":["26030"],"district":"CR","districtName":"Cremona"},{"nome":"Gadoni","cap":["08030"],"district":"NU","districtName":"Nuoro"},{"nome":"Gaeta","cap":["04024"],"district":"LT","districtName":"Latina"},{"nome":"Gaggi","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Gaggiano","cap":["20083"],"district":"MI","districtName":"Milano"},{"nome":"Gaggio Montano","cap":["40041"],"district":"BO","districtName":"Bologna"},{"nome":"Gaglianico","cap":["13894"],"district":"BI","districtName":"Biella"},{"nome":"Gagliano Aterno","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Gagliano Castelferrato","cap":["94010"],"district":"EN","districtName":"Enna"},{"nome":"Gagliano del Capo","cap":["73034"],"district":"LE","districtName":"Lecce"},{"nome":"Gagliato","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Gagliole","cap":["62022"],"district":"MC","districtName":"Macerata"},{"nome":"Gaiarine","cap":["31018"],"district":"TV","districtName":"Treviso"},{"nome":"Gaiba","cap":["45030"],"district":"RO","districtName":"Rovigo"},{"nome":"Gaiola","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Gaiole in Chianti","cap":["53013"],"district":"SI","districtName":"Siena"},{"nome":"Gairo","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Gais","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Galati Mamertino","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Galatina","cap":["73013"],"district":"LE","districtName":"Lecce"},{"nome":"Galatone","cap":["73044"],"district":"LE","districtName":"Lecce"},{"nome":"Galatro","cap":["89054"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Galbiate","cap":["23851"],"district":"LC","districtName":"Lecco"},{"nome":"Galeata","cap":["47010"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Galgagnano","cap":["26832"],"district":"LO","districtName":"Lodi"},{"nome":"Gallarate","cap":["21013"],"district":"VA","districtName":"Varese"},{"nome":"Gallese","cap":["01035"],"district":"VT","districtName":"Viterbo"},{"nome":"Galliate","cap":["28066"],"district":"NO","districtName":"Novara"},{"nome":"Galliate Lombardo","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Galliavola","cap":["27034"],"district":"PV","districtName":"Pavia"},{"nome":"Gallicano","cap":["55027"],"district":"LU","districtName":"Lucca"},{"nome":"Gallicano nel Lazio","cap":["00010"],"district":"RM","districtName":"Roma"},{"nome":"Gallicchio","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Galliera","cap":["40015"],"district":"BO","districtName":"Bologna"},{"nome":"Galliera Veneta","cap":["35015"],"district":"PD","districtName":"Padova"},{"nome":"Gallinaro","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Gallio","cap":["36032"],"district":"VI","districtName":"Vicenza"},{"nome":"Gallipoli","cap":["73014"],"district":"LE","districtName":"Lecce"},{"nome":"Gallo Matese","cap":["81010"],"district":"CE","districtName":"Caserta"},{"nome":"Gallodoro","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Galluccio","cap":["81044"],"district":"CE","districtName":"Caserta"},{"nome":"Galtellì","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Galzignano Terme","cap":["35030"],"district":"PD","districtName":"Padova"},{"nome":"Gamalero","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Gambara","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Gambarana","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Gambasca","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Gambassi Terme","cap":["50050"],"district":"FI","districtName":"Firenze"},{"nome":"Gambatesa","cap":["86013"],"district":"CB","districtName":"Campobasso"},{"nome":"Gambellara","cap":["36053"],"district":"VI","districtName":"Vicenza"},{"nome":"Gamberale","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Gambettola","cap":["47035"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Gambolò","cap":["27025"],"district":"PV","districtName":"Pavia"},{"nome":"Gambugliano","cap":["36050"],"district":"VI","districtName":"Vicenza"},{"nome":"Gandellino","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Gandino","cap":["24024"],"district":"BG","districtName":"Bergamo"},{"nome":"Gandosso","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Gangi","cap":["90024"],"district":"PA","districtName":"Palermo"},{"nome":"Garaguso","cap":["75010"],"district":"MT","districtName":"Matera"},{"nome":"Garbagna","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Garbagna Novarese","cap":["28070"],"district":"NO","districtName":"Novara"},{"nome":"Garbagnate Milanese","cap":["20024"],"district":"MI","districtName":"Milano"},{"nome":"Garbagnate Monastero","cap":["23846"],"district":"LC","districtName":"Lecco"},{"nome":"Garda","cap":["37016"],"district":"VR","districtName":"Verona"},{"nome":"Gardone Riviera","cap":["25083"],"district":"BS","districtName":"Brescia"},{"nome":"Gardone Val Trompia","cap":["25063"],"district":"BS","districtName":"Brescia"},{"nome":"Garessio","cap":["12075"],"district":"CN","districtName":"Cuneo"},{"nome":"Gargallo","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Gargazzone","cap":["39010"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Gargnano","cap":["25084"],"district":"BS","districtName":"Brescia"},{"nome":"Garlasco","cap":["27026"],"district":"PV","districtName":"Pavia"},{"nome":"Garlate","cap":["23852"],"district":"LC","districtName":"Lecco"},{"nome":"Garlenda","cap":["17033"],"district":"SV","districtName":"Savona"},{"nome":"Garniga Terme","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Garzeno","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Garzigliana","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Gasperina","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Gassino Torinese","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Gattatico","cap":["42043"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Gatteo","cap":["47043"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Gattico-Veruno","cap":["28013"],"district":"NO","districtName":"Novara"},{"nome":"Gattinara","cap":["13045"],"district":"VC","districtName":"Vercelli"},{"nome":"Gavardo","cap":["25085"],"district":"BS","districtName":"Brescia"},{"nome":"Gavello","cap":["45010"],"district":"RO","districtName":"Rovigo"},{"nome":"Gaverina Terme","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Gavi","cap":["15066"],"district":"AL","districtName":"Alessandria"},{"nome":"Gavignano","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"Gavirate","cap":["21026"],"district":"VA","districtName":"Varese"},{"nome":"Gavoi","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Gavorrano","cap":["58023"],"district":"GR","districtName":"Grosseto"},{"nome":"Gazoldo degli Ippoliti","cap":["46040"],"district":"MN","districtName":"Mantova"},{"nome":"Gazzada Schianno","cap":["21045"],"district":"VA","districtName":"Varese"},{"nome":"Gazzaniga","cap":["24025"],"district":"BG","districtName":"Bergamo"},{"nome":"Gazzo","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Gazzo Veronese","cap":["37060"],"district":"VR","districtName":"Verona"},{"nome":"Gazzola","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Gazzuolo","cap":["46010"],"district":"MN","districtName":"Mantova"},{"nome":"Gela","cap":["93012"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Gemmano","cap":["47855"],"district":"RN","districtName":"Rimini"},{"nome":"Gemona del Friuli","cap":["33013"],"district":"UD","districtName":"Udine"},{"nome":"Gemonio","cap":["21036"],"district":"VA","districtName":"Varese"},{"nome":"Genazzano","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"Genga","cap":["60040"],"district":"AN","districtName":"Ancona"},{"nome":"Genivolta","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Genola","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Genoni","cap":["09054"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Genova","cap":["16121","16122","16123","16124","16125","16126","16127","16128","16129","16130","16131","16132","16133","16134","16135","16136","16137","16138","16139","16140","16141","16142","16143","16144","16145","16146","16147","16148","16149","16150","16151","16152","16153","16154","16155","16156","16157","16158","16159","16160","16161","16162","16163","16164","16165","16166","16167"],"district":"GE","districtName":"Genova"},{"nome":"Genuri","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Genzano di Lucania","cap":["85013"],"district":"PZ","districtName":"Potenza"},{"nome":"Genzano di Roma","cap":["00045"],"district":"RM","districtName":"Roma"},{"nome":"Gera Lario","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Gerace","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Geraci Siculo","cap":["90010"],"district":"PA","districtName":"Palermo"},{"nome":"Gerano","cap":["00025"],"district":"RM","districtName":"Roma"},{"nome":"Gerenzago","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Gerenzano","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Gergei","cap":["09055"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Germagnano","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Germagno","cap":["28887"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Germignaga","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Gerocarne","cap":["89831"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Gerola Alta","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Gerre de' Caprioli","cap":["26040"],"district":"CR","districtName":"Cremona"},{"nome":"Gesico","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Gessate","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Gessopalena","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Gesturi","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Gesualdo","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Ghedi","cap":["25016"],"district":"BS","districtName":"Brescia"},{"nome":"Ghemme","cap":["28074"],"district":"NO","districtName":"Novara"},{"nome":"Ghiffa","cap":["28823"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Ghilarza","cap":["09074"],"district":"OR","districtName":"Oristano"},{"nome":"Ghisalba","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Ghislarengo","cap":["13030"],"district":"VC","districtName":"Vercelli"},{"nome":"Giacciano con Baruchella","cap":["45020"],"district":"RO","districtName":"Rovigo"},{"nome":"Giaglione","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Gianico","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Giano dell'Umbria","cap":["06030"],"district":"PG","districtName":"Perugia"},{"nome":"Giano Vetusto","cap":["81042"],"district":"CE","districtName":"Caserta"},{"nome":"Giardinello","cap":["90040"],"district":"PA","districtName":"Palermo"},{"nome":"Giardini-Naxos","cap":["98035"],"district":"ME","districtName":"Messina"},{"nome":"Giarole","cap":["15036"],"district":"AL","districtName":"Alessandria"},{"nome":"Giarratana","cap":["97010"],"district":"RG","districtName":"Ragusa"},{"nome":"Giarre","cap":["95014"],"district":"CT","districtName":"Catania"},{"nome":"Giave","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Giaveno","cap":["10094"],"district":"TO","districtName":"Torino"},{"nome":"Giavera del Montello","cap":["31040"],"district":"TV","districtName":"Treviso"},{"nome":"Giba","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Gibellina","cap":["91024"],"district":"TP","districtName":"Trapani"},{"nome":"Gifflenga","cap":["13874"],"district":"BI","districtName":"Biella"},{"nome":"Giffone","cap":["89020"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Giffoni Sei Casali","cap":["84090"],"district":"SA","districtName":"Salerno"},{"nome":"Giffoni Valle Piana","cap":["84095"],"district":"SA","districtName":"Salerno"},{"nome":"Gignese","cap":["28836"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Gignod","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Gildone","cap":["86010"],"district":"CB","districtName":"Campobasso"},{"nome":"Gimigliano","cap":["88045"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Ginestra","cap":["85020"],"district":"PZ","districtName":"Potenza"},{"nome":"Ginestra degli Schiavoni","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Ginosa","cap":["74013"],"district":"TA","districtName":"Taranto"},{"nome":"Gioi","cap":["84056"],"district":"SA","districtName":"Salerno"},{"nome":"Gioia dei Marsi","cap":["67055"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Gioia del Colle","cap":["70023"],"district":"BA","districtName":"Bari"},{"nome":"Gioia Sannitica","cap":["81010"],"district":"CE","districtName":"Caserta"},{"nome":"Gioia Tauro","cap":["89013"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Gioiosa Ionica","cap":["89042"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Gioiosa Marea","cap":["98063"],"district":"ME","districtName":"Messina"},{"nome":"Giove","cap":["05024"],"district":"TR","districtName":"Terni"},{"nome":"Giovinazzo","cap":["70054"],"district":"BA","districtName":"Bari"},{"nome":"Giovo","cap":["38030"],"district":"TN","districtName":"Trento"},{"nome":"Girasole","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Girifalco","cap":["88024"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Gissi","cap":["66052"],"district":"CH","districtName":"Chieti"},{"nome":"Giuggianello","cap":["73030"],"district":"LE","districtName":"Lecce"},{"nome":"Giugliano in Campania","cap":["80014"],"district":"NA","districtName":"Napoli"},{"nome":"Giuliana","cap":["90030"],"district":"PA","districtName":"Palermo"},{"nome":"Giuliano di Roma","cap":["03020"],"district":"FR","districtName":"Frosinone"},{"nome":"Giuliano Teatino","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Giulianova","cap":["64021"],"district":"TE","districtName":"Teramo"},{"nome":"Giungano","cap":["84050"],"district":"SA","districtName":"Salerno"},{"nome":"Giurdignano","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Giussago","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Giussano","cap":["20833"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Giustenice","cap":["17027"],"district":"SV","districtName":"Savona"},{"nome":"Giustino","cap":["38086"],"district":"TN","districtName":"Trento"},{"nome":"Giusvalla","cap":["17010"],"district":"SV","districtName":"Savona"},{"nome":"Givoletto","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Gizzeria","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Glorenza","cap":["39020"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Godega di Sant'Urbano","cap":["31010"],"district":"TV","districtName":"Treviso"},{"nome":"Godiasco Salice Terme","cap":["27052"],"district":"PV","districtName":"Pavia"},{"nome":"Godrano","cap":["90030"],"district":"PA","districtName":"Palermo"},{"nome":"Goito","cap":["46044"],"district":"MN","districtName":"Mantova"},{"nome":"Golasecca","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Golferenzo","cap":["27047"],"district":"PV","districtName":"Pavia"},{"nome":"Golfo Aranci","cap":["07020"],"district":"SS","districtName":"Sassari"},{"nome":"Gombito","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Gonars","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Goni","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Gonnesa","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Gonnoscodina","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Gonnosfanadiga","cap":["09035"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Gonnosnò","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Gonnostramatza","cap":["09093"],"district":"OR","districtName":"Oristano"},{"nome":"Gonzaga","cap":["46023"],"district":"MN","districtName":"Mantova"},{"nome":"Gordona","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Gorga","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"Gorgo al Monticano","cap":["31040"],"district":"TV","districtName":"Treviso"},{"nome":"Gorgoglione","cap":["75010"],"district":"MT","districtName":"Matera"},{"nome":"Gorgonzola","cap":["20064"],"district":"MI","districtName":"Milano"},{"nome":"Goriano Sicoli","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Gorizia","cap":["34170"],"district":"GO","districtName":"Gorizia"},{"nome":"Gorla Maggiore","cap":["21050"],"district":"VA","districtName":"Varese"},{"nome":"Gorla Minore","cap":["21055"],"district":"VA","districtName":"Varese"},{"nome":"Gorlago","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Gorle","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Gornate Olona","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Gorno","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Goro","cap":["44020"],"district":"FE","districtName":"Ferrara"},{"nome":"Gorreto","cap":["16020"],"district":"GE","districtName":"Genova"},{"nome":"Gorzegno","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Gosaldo","cap":["32020"],"district":"BL","districtName":"Belluno"},{"nome":"Gossolengo","cap":["29020"],"district":"PC","districtName":"Piacenza"},{"nome":"Gottasecca","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Gottolengo","cap":["25023"],"district":"BS","districtName":"Brescia"},{"nome":"Govone","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Gozzano","cap":["28024"],"district":"NO","districtName":"Novara"},{"nome":"Gradara","cap":["61012"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Gradisca d'Isonzo","cap":["34072"],"district":"GO","districtName":"Gorizia"},{"nome":"Grado","cap":["34073"],"district":"GO","districtName":"Gorizia"},{"nome":"Gradoli","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Graffignana","cap":["26813"],"district":"LO","districtName":"Lodi"},{"nome":"Graffignano","cap":["01020"],"district":"VT","districtName":"Viterbo"},{"nome":"Graglia","cap":["13895"],"district":"BI","districtName":"Biella"},{"nome":"Gragnano","cap":["80054"],"district":"NA","districtName":"Napoli"},{"nome":"Gragnano Trebbiense","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Grammichele","cap":["95042"],"district":"CT","districtName":"Catania"},{"nome":"Grana","cap":["14031"],"district":"AT","districtName":"Asti"},{"nome":"Granarolo dell'Emilia","cap":["40057"],"district":"BO","districtName":"Bologna"},{"nome":"Grandate","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Grandola ed Uniti","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Graniti","cap":["98036"],"district":"ME","districtName":"Messina"},{"nome":"Granozzo con Monticello","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"Grantola","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Grantorto","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Granze","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Grassano","cap":["75014"],"district":"MT","districtName":"Matera"},{"nome":"Grassobbio","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Gratteri","cap":["90010"],"district":"PA","districtName":"Palermo"},{"nome":"Gravedona ed Uniti","cap":["22015"],"district":"CO","districtName":"Como"},{"nome":"Gravellona Lomellina","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Gravellona Toce","cap":["28883"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Gravere","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Gravina di Catania","cap":["95030"],"district":"CT","districtName":"Catania"},{"nome":"Gravina in Puglia","cap":["70024"],"district":"BA","districtName":"Bari"},{"nome":"Grazzanise","cap":["81046"],"district":"CE","districtName":"Caserta"},{"nome":"Grazzano Badoglio","cap":["14035"],"district":"AT","districtName":"Asti"},{"nome":"Greccio","cap":["02045"],"district":"RI","districtName":"Rieti"},{"nome":"Greci","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Greggio","cap":["13030"],"district":"VC","districtName":"Vercelli"},{"nome":"Gremiasco","cap":["15056"],"district":"AL","districtName":"Alessandria"},{"nome":"Gressan","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Gressoney-La-Trinité","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Gressoney-Saint-Jean","cap":["11025"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Greve in Chianti","cap":["50022"],"district":"FI","districtName":"Firenze"},{"nome":"Grezzago","cap":["20056"],"district":"MI","districtName":"Milano"},{"nome":"Grezzana","cap":["37023"],"district":"VR","districtName":"Verona"},{"nome":"Griante","cap":["22011"],"district":"CO","districtName":"Como"},{"nome":"Gricignano di Aversa","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Grignasco","cap":["28075"],"district":"NO","districtName":"Novara"},{"nome":"Grigno","cap":["38055"],"district":"TN","districtName":"Trento"},{"nome":"Grimacco","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Grimaldi","cap":["87034"],"district":"CS","districtName":"Cosenza"},{"nome":"Grinzane Cavour","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Grisignano di Zocco","cap":["36040"],"district":"VI","districtName":"Vicenza"},{"nome":"Grisolia","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Grizzana Morandi","cap":["40030"],"district":"BO","districtName":"Bologna"},{"nome":"Grognardo","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Gromo","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Grondona","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Grone","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Grontardo","cap":["26044"],"district":"CR","districtName":"Cremona"},{"nome":"Gropello Cairoli","cap":["27027"],"district":"PV","districtName":"Pavia"},{"nome":"Gropparello","cap":["29025"],"district":"PC","districtName":"Piacenza"},{"nome":"Groscavallo","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Grosio","cap":["23033"],"district":"SO","districtName":"Sondrio"},{"nome":"Grosotto","cap":["23034"],"district":"SO","districtName":"Sondrio"},{"nome":"Grosseto","cap":["58100"],"district":"GR","districtName":"Grosseto"},{"nome":"Grosso","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Grottaferrata","cap":["00046"],"district":"RM","districtName":"Roma"},{"nome":"Grottaglie","cap":["74023"],"district":"TA","districtName":"Taranto"},{"nome":"Grottaminarda","cap":["83035"],"district":"AV","districtName":"Avellino"},{"nome":"Grottammare","cap":["63066"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Grottazzolina","cap":["63844"],"district":"FM","districtName":"Fermo"},{"nome":"Grotte","cap":["92020"],"district":"AG","districtName":"Agrigento"},{"nome":"Grotte di Castro","cap":["01025"],"district":"VT","districtName":"Viterbo"},{"nome":"Grotteria","cap":["89043"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Grottole","cap":["75010"],"district":"MT","districtName":"Matera"},{"nome":"Grottolella","cap":["83010"],"district":"AV","districtName":"Avellino"},{"nome":"Gruaro","cap":["30020"],"district":"VE","districtName":"Venezia"},{"nome":"Grugliasco","cap":["10095"],"district":"TO","districtName":"Torino"},{"nome":"Grumello Cremonese ed Uniti","cap":["26023"],"district":"CR","districtName":"Cremona"},{"nome":"Grumello del Monte","cap":["24064"],"district":"BG","districtName":"Bergamo"},{"nome":"Grumento Nova","cap":["85050"],"district":"PZ","districtName":"Potenza"},{"nome":"Grumo Appula","cap":["70025"],"district":"BA","districtName":"Bari"},{"nome":"Grumo Nevano","cap":["80028"],"district":"NA","districtName":"Napoli"},{"nome":"Grumolo delle Abbadesse","cap":["36040"],"district":"VI","districtName":"Vicenza"},{"nome":"Guagnano","cap":["73010"],"district":"LE","districtName":"Lecce"},{"nome":"Gualdo","cap":["62020"],"district":"MC","districtName":"Macerata"},{"nome":"Gualdo Cattaneo","cap":["06035"],"district":"PG","districtName":"Perugia"},{"nome":"Gualdo Tadino","cap":["06023"],"district":"PG","districtName":"Perugia"},{"nome":"Gualtieri","cap":["42044"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Gualtieri Sicaminò","cap":["98040"],"district":"ME","districtName":"Messina"},{"nome":"Guamaggiore","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Guanzate","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Guarcino","cap":["03016"],"district":"FR","districtName":"Frosinone"},{"nome":"Guarda Veneta","cap":["45030"],"district":"RO","districtName":"Rovigo"},{"nome":"Guardabosone","cap":["13010"],"district":"VC","districtName":"Vercelli"},{"nome":"Guardamiglio","cap":["26862"],"district":"LO","districtName":"Lodi"},{"nome":"Guardavalle","cap":["88065"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Guardea","cap":["05025"],"district":"TR","districtName":"Terni"},{"nome":"Guardia Lombardi","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Guardia Perticara","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Guardia Piemontese","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Guardia Sanframondi","cap":["82034"],"district":"BN","districtName":"Benevento"},{"nome":"Guardiagrele","cap":["66016"],"district":"CH","districtName":"Chieti"},{"nome":"Guardialfiera","cap":["86030"],"district":"CB","districtName":"Campobasso"},{"nome":"Guardiaregia","cap":["86014"],"district":"CB","districtName":"Campobasso"},{"nome":"Guardistallo","cap":["56040"],"district":"PI","districtName":"Pisa"},{"nome":"Guarene","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Guasila","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Guastalla","cap":["42016"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Guazzora","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Gubbio","cap":["06024"],"district":"PG","districtName":"Perugia"},{"nome":"Gudo Visconti","cap":["20088"],"district":"MI","districtName":"Milano"},{"nome":"Guglionesi","cap":["86034"],"district":"CB","districtName":"Campobasso"},{"nome":"Guidizzolo","cap":["46040"],"district":"MN","districtName":"Mantova"},{"nome":"Guidonia Montecelio","cap":["00012"],"district":"RM","districtName":"Roma"},{"nome":"Guiglia","cap":["41052"],"district":"MO","districtName":"Modena"},{"nome":"Guilmi","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Gurro","cap":["28828"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Guspini","cap":["09036"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Gussago","cap":["25064"],"district":"BS","districtName":"Brescia"},{"nome":"Gussola","cap":["26040"],"district":"CR","districtName":"Cremona"},{"nome":"Hône","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Idro","cap":["25074"],"district":"BS","districtName":"Brescia"},{"nome":"Iglesias","cap":["09016"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Igliano","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Ilbono","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Illasi","cap":["37031"],"district":"VR","districtName":"Verona"},{"nome":"Illorai","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Imbersago","cap":["23898"],"district":"LC","districtName":"Lecco"},{"nome":"Imer","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Imola","cap":["40026"],"district":"BO","districtName":"Bologna"},{"nome":"Imperia","cap":["18100"],"district":"IM","districtName":"Imperia"},{"nome":"Impruneta","cap":["50023"],"district":"FI","districtName":"Firenze"},{"nome":"Inarzo","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Incisa Scapaccino","cap":["14045"],"district":"AT","districtName":"Asti"},{"nome":"Incudine","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Induno Olona","cap":["21056"],"district":"VA","districtName":"Varese"},{"nome":"Ingria","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Intragna","cap":["28816"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Introbio","cap":["23815"],"district":"LC","districtName":"Lecco"},{"nome":"Introd","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Introdacqua","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Inverigo","cap":["22044"],"district":"CO","districtName":"Como"},{"nome":"Inverno e Monteleone","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Inverso Pinasca","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Inveruno","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Invorio","cap":["28045"],"district":"NO","districtName":"Novara"},{"nome":"Inzago","cap":["20065"],"district":"MI","districtName":"Milano"},{"nome":"Ionadi","cap":["89851"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Irgoli","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Irma","cap":["25061"],"district":"BS","districtName":"Brescia"},{"nome":"Irsina","cap":["75022"],"district":"MT","districtName":"Matera"},{"nome":"Isasca","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Isca sullo Ionio","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Ischia","cap":["80077"],"district":"NA","districtName":"Napoli"},{"nome":"Ischia di Castro","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Ischitella","cap":["71010"],"district":"FG","districtName":"Foggia"},{"nome":"Iseo","cap":["25049"],"district":"BS","districtName":"Brescia"},{"nome":"Isera","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Isernia","cap":["86170"],"district":"IS","districtName":"Isernia"},{"nome":"Isili","cap":["09056"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Isnello","cap":["90010"],"district":"PA","districtName":"Palermo"},{"nome":"Isola d'Asti","cap":["14057"],"district":"AT","districtName":"Asti"},{"nome":"Isola del Cantone","cap":["16017"],"district":"GE","districtName":"Genova"},{"nome":"Isola del Giglio","cap":["58012"],"district":"GR","districtName":"Grosseto"},{"nome":"Isola del Gran Sasso d'Italia","cap":["64045"],"district":"TE","districtName":"Teramo"},{"nome":"Isola del Liri","cap":["03036"],"district":"FR","districtName":"Frosinone"},{"nome":"Isola del Piano","cap":["61030"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Isola della Scala","cap":["37063"],"district":"VR","districtName":"Verona"},{"nome":"Isola delle Femmine","cap":["90040"],"district":"PA","districtName":"Palermo"},{"nome":"Isola di Capo Rizzuto","cap":["88841"],"district":"KR","districtName":"Crotone"},{"nome":"Isola di Fondra","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Isola Dovarese","cap":["26031"],"district":"CR","districtName":"Cremona"},{"nome":"Isola Rizza","cap":["37050"],"district":"VR","districtName":"Verona"},{"nome":"Isola Sant'Antonio","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Isola Vicentina","cap":["36033"],"district":"VI","districtName":"Vicenza"},{"nome":"Isolabella","cap":["10046"],"district":"TO","districtName":"Torino"},{"nome":"Isolabona","cap":["18035"],"district":"IM","districtName":"Imperia"},{"nome":"Isole Tremiti","cap":["71051"],"district":"FG","districtName":"Foggia"},{"nome":"Isorella","cap":["25010"],"district":"BS","districtName":"Brescia"},{"nome":"Ispani","cap":["84050"],"district":"SA","districtName":"Salerno"},{"nome":"Ispica","cap":["97014"],"district":"RG","districtName":"Ragusa"},{"nome":"Ispra","cap":["21027"],"district":"VA","districtName":"Varese"},{"nome":"Issiglio","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Issime","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Isso","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Issogne","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Istrana","cap":["31036"],"district":"TV","districtName":"Treviso"},{"nome":"Itala","cap":["98025"],"district":"ME","districtName":"Messina"},{"nome":"Itri","cap":["04020"],"district":"LT","districtName":"Latina"},{"nome":"Ittireddu","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Ittiri","cap":["07044"],"district":"SS","districtName":"Sassari"},{"nome":"Ivrea","cap":["10015"],"district":"TO","districtName":"Torino"},{"nome":"Izano","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Jacurso","cap":["88020"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Jelsi","cap":["86015"],"district":"CB","districtName":"Campobasso"},{"nome":"Jenne","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Jerago con Orago","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Jerzu","cap":["08044"],"district":"NU","districtName":"Nuoro"},{"nome":"Jesi","cap":["60035"],"district":"AN","districtName":"Ancona"},{"nome":"Jesolo","cap":["30016"],"district":"VE","districtName":"Venezia"},{"nome":"Jolanda di Savoia","cap":["44037"],"district":"FE","districtName":"Ferrara"},{"nome":"Joppolo","cap":["89863"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Joppolo Giancaxio","cap":["92010"],"district":"AG","districtName":"Agrigento"},{"nome":"Jovençan","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"L'Aquila","cap":["67100"],"district":"AQ","districtName":"L'Aquila"},{"nome":"La Cassa","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"La Loggia","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"La Maddalena","cap":["07024"],"district":"SS","districtName":"Sassari"},{"nome":"La Magdeleine","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"La Morra","cap":["12064"],"district":"CN","districtName":"Cuneo"},{"nome":"La Salle","cap":["11015"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"La Spezia","cap":["19121","19122","19123","19124","19125","19126","19127","19128","19129","19130","19131","19132","19133","19134","19135","19136","19137"],"district":"SP","districtName":"La Spezia"},{"nome":"La Thuile","cap":["11016"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"La Valle","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"La Valle Agordina","cap":["32020"],"district":"BL","districtName":"Belluno"},{"nome":"La Valletta Brianza","cap":["23888"],"district":"LC","districtName":"Lecco"},{"nome":"Labico","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"Labro","cap":["02010"],"district":"RI","districtName":"Rieti"},{"nome":"Lacchiarella","cap":["20084"],"district":"MI","districtName":"Milano"},{"nome":"Lacco Ameno","cap":["80076"],"district":"NA","districtName":"Napoli"},{"nome":"Lacedonia","cap":["83046"],"district":"AV","districtName":"Avellino"},{"nome":"Laces","cap":["39021"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Laconi","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Ladispoli","cap":["00055"],"district":"RM","districtName":"Roma"},{"nome":"Laerru","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Laganadi","cap":["89050"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Laghi","cap":["36010"],"district":"VI","districtName":"Vicenza"},{"nome":"Laglio","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Lagnasco","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Lago","cap":["87035"],"district":"CS","districtName":"Cosenza"},{"nome":"Lagonegro","cap":["85042"],"district":"PZ","districtName":"Potenza"},{"nome":"Lagosanto","cap":["44023"],"district":"FE","districtName":"Ferrara"},{"nome":"Lagundo","cap":["39022"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Laigueglia","cap":["17053"],"district":"SV","districtName":"Savona"},{"nome":"Lainate","cap":["20020"],"district":"MI","districtName":"Milano"},{"nome":"Laino","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Laino Borgo","cap":["87014"],"district":"CS","districtName":"Cosenza"},{"nome":"Laino Castello","cap":["87015"],"district":"CS","districtName":"Cosenza"},{"nome":"Laion","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Laives","cap":["39055"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Lajatico","cap":["56030"],"district":"PI","districtName":"Pisa"},{"nome":"Lallio","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Lama dei Peligni","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Lama Mocogno","cap":["41023"],"district":"MO","districtName":"Modena"},{"nome":"Lambrugo","cap":["22045"],"district":"CO","districtName":"Como"},{"nome":"Lamezia Terme","cap":["88046"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Lamon","cap":["32033"],"district":"BL","districtName":"Belluno"},{"nome":"Lampedusa e Linosa","cap":["92031"],"district":"AG","districtName":"Agrigento"},{"nome":"Lamporecchio","cap":["51035"],"district":"PT","districtName":"Pistoia"},{"nome":"Lamporo","cap":["13046"],"district":"VC","districtName":"Vercelli"},{"nome":"Lana","cap":["39011"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Lanciano","cap":["66034"],"district":"CH","districtName":"Chieti"},{"nome":"Landiona","cap":["28064"],"district":"NO","districtName":"Novara"},{"nome":"Landriano","cap":["27015"],"district":"PV","districtName":"Pavia"},{"nome":"Langhirano","cap":["43013"],"district":"PR","districtName":"Parma"},{"nome":"Langosco","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Lanusei","cap":["08045"],"district":"NU","districtName":"Nuoro"},{"nome":"Lanuvio","cap":["00075"],"district":"RM","districtName":"Roma"},{"nome":"Lanzada","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Lanzo Torinese","cap":["10074"],"district":"TO","districtName":"Torino"},{"nome":"Lapedona","cap":["63823"],"district":"FM","districtName":"Fermo"},{"nome":"Lapio","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Lappano","cap":["87050"],"district":"CS","districtName":"Cosenza"},{"nome":"Larciano","cap":["51036"],"district":"PT","districtName":"Pistoia"},{"nome":"Lardirago","cap":["27016"],"district":"PV","districtName":"Pavia"},{"nome":"Lariano","cap":["00076"],"district":"RM","districtName":"Roma"},{"nome":"Larino","cap":["86035"],"district":"CB","districtName":"Campobasso"},{"nome":"Las Plassas","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Lasa","cap":["39023"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Lascari","cap":["90010"],"district":"PA","districtName":"Palermo"},{"nome":"Lasnigo","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Lastebasse","cap":["36040"],"district":"VI","districtName":"Vicenza"},{"nome":"Lastra a Signa","cap":["50055"],"district":"FI","districtName":"Firenze"},{"nome":"Latera","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Laterina Pergine Valdarno","cap":["52019"],"district":"AR","districtName":"Arezzo"},{"nome":"Laterza","cap":["74014"],"district":"TA","districtName":"Taranto"},{"nome":"Latiano","cap":["72022"],"district":"BR","districtName":"Brindisi"},{"nome":"Latina","cap":["04100"],"district":"LT","districtName":"Latina"},{"nome":"Latisana","cap":["33053"],"district":"UD","districtName":"Udine"},{"nome":"Latronico","cap":["85043"],"district":"PZ","districtName":"Potenza"},{"nome":"Lattarico","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Lauco","cap":["33029"],"district":"UD","districtName":"Udine"},{"nome":"Laureana Cilento","cap":["84050"],"district":"SA","districtName":"Salerno"},{"nome":"Laureana di Borrello","cap":["89023"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Lauregno","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Laurenzana","cap":["85014"],"district":"PZ","districtName":"Potenza"},{"nome":"Lauria","cap":["85044"],"district":"PZ","districtName":"Potenza"},{"nome":"Lauriano","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Laurino","cap":["84057"],"district":"SA","districtName":"Salerno"},{"nome":"Laurito","cap":["84050"],"district":"SA","districtName":"Salerno"},{"nome":"Lauro","cap":["83023"],"district":"AV","districtName":"Avellino"},{"nome":"Lavagna","cap":["16033"],"district":"GE","districtName":"Genova"},{"nome":"Lavagno","cap":["37030"],"district":"VR","districtName":"Verona"},{"nome":"Lavarone","cap":["38046"],"district":"TN","districtName":"Trento"},{"nome":"Lavello","cap":["85024"],"district":"PZ","districtName":"Potenza"},{"nome":"Lavena Ponte Tresa","cap":["21037"],"district":"VA","districtName":"Varese"},{"nome":"Laveno-Mombello","cap":["21014"],"district":"VA","districtName":"Varese"},{"nome":"Lavenone","cap":["25074"],"district":"BS","districtName":"Brescia"},{"nome":"Laviano","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Lavis","cap":["38015"],"district":"TN","districtName":"Trento"},{"nome":"Lazise","cap":["37017"],"district":"VR","districtName":"Verona"},{"nome":"Lazzate","cap":["20824"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Lecce","cap":["73100"],"district":"LE","districtName":"Lecce"},{"nome":"Lecce nei Marsi","cap":["67050"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Lecco","cap":["23900"],"district":"LC","districtName":"Lecco"},{"nome":"Ledro","cap":["38067"],"district":"TN","districtName":"Trento"},{"nome":"Leffe","cap":["24026"],"district":"BG","districtName":"Bergamo"},{"nome":"Leggiuno","cap":["21038"],"district":"VA","districtName":"Varese"},{"nome":"Legnago","cap":["37045"],"district":"VR","districtName":"Verona"},{"nome":"Legnano","cap":["20025"],"district":"MI","districtName":"Milano"},{"nome":"Legnaro","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Lei","cap":["08010"],"district":"NU","districtName":"Nuoro"},{"nome":"Leini","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Leivi","cap":["16040"],"district":"GE","districtName":"Genova"},{"nome":"Lemie","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Lendinara","cap":["45026"],"district":"RO","districtName":"Rovigo"},{"nome":"Leni","cap":["98050"],"district":"ME","districtName":"Messina"},{"nome":"Lenna","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Leno","cap":["25024"],"district":"BS","districtName":"Brescia"},{"nome":"Lenola","cap":["04025"],"district":"LT","districtName":"Latina"},{"nome":"Lenta","cap":["13035"],"district":"VC","districtName":"Vercelli"},{"nome":"Lentate sul Seveso","cap":["20823"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Lentella","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Lentini","cap":["96016"],"district":"SR","districtName":"Siracusa"},{"nome":"Leonessa","cap":["02016"],"district":"RI","districtName":"Rieti"},{"nome":"Leonforte","cap":["94013"],"district":"EN","districtName":"Enna"},{"nome":"Leporano","cap":["74020"],"district":"TA","districtName":"Taranto"},{"nome":"Lequile","cap":["73010"],"district":"LE","districtName":"Lecce"},{"nome":"Lequio Berria","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Lequio Tanaro","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Lercara Friddi","cap":["90025"],"district":"PA","districtName":"Palermo"},{"nome":"Lerici","cap":["19032"],"district":"SP","districtName":"La Spezia"},{"nome":"Lerma","cap":["15070"],"district":"AL","districtName":"Alessandria"},{"nome":"Lesa","cap":["28040"],"district":"NO","districtName":"Novara"},{"nome":"Lesegno","cap":["12076"],"district":"CN","districtName":"Cuneo"},{"nome":"Lesignano de' Bagni","cap":["43037"],"district":"PR","districtName":"Parma"},{"nome":"Lesina","cap":["71010"],"district":"FG","districtName":"Foggia"},{"nome":"Lesmo","cap":["20855"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Lessolo","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Lessona","cap":["13853"],"district":"BI","districtName":"Biella"},{"nome":"Lestizza","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Letino","cap":["81010"],"district":"CE","districtName":"Caserta"},{"nome":"Letojanni","cap":["98037"],"district":"ME","districtName":"Messina"},{"nome":"Lettere","cap":["80050"],"district":"NA","districtName":"Napoli"},{"nome":"Lettomanoppello","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Lettopalena","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Levanto","cap":["19015"],"district":"SP","districtName":"La Spezia"},{"nome":"Levate","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Leverano","cap":["73045"],"district":"LE","districtName":"Lecce"},{"nome":"Levice","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Levico Terme","cap":["38056"],"district":"TN","districtName":"Trento"},{"nome":"Levone","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Lezzeno","cap":["22025"],"district":"CO","districtName":"Como"},{"nome":"Liberi","cap":["81040"],"district":"CE","districtName":"Caserta"},{"nome":"Librizzi","cap":["98064"],"district":"ME","districtName":"Messina"},{"nome":"Licata","cap":["92027"],"district":"AG","districtName":"Agrigento"},{"nome":"Licciana Nardi","cap":["54016"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Licenza","cap":["00026"],"district":"RM","districtName":"Roma"},{"nome":"Licodia Eubea","cap":["95040"],"district":"CT","districtName":"Catania"},{"nome":"Lierna","cap":["23827"],"district":"LC","districtName":"Lecco"},{"nome":"Lignana","cap":["13034"],"district":"VC","districtName":"Vercelli"},{"nome":"Lignano Sabbiadoro","cap":["33054"],"district":"UD","districtName":"Udine"},{"nome":"Lillianes","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Limana","cap":["32020"],"district":"BL","districtName":"Belluno"},{"nome":"Limatola","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Limbadi","cap":["89844"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Limbiate","cap":["20812"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Limena","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Limido Comasco","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Limina","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Limone Piemonte","cap":["12015"],"district":"CN","districtName":"Cuneo"},{"nome":"Limone sul Garda","cap":["25010"],"district":"BS","districtName":"Brescia"},{"nome":"Limosano","cap":["86022"],"district":"CB","districtName":"Campobasso"},{"nome":"Linarolo","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Linguaglossa","cap":["95015"],"district":"CT","districtName":"Catania"},{"nome":"Lioni","cap":["83047"],"district":"AV","districtName":"Avellino"},{"nome":"Lipari","cap":["98055"],"district":"ME","districtName":"Messina"},{"nome":"Lipomo","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Lirio","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Liscate","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Liscia","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Lisciano Niccone","cap":["06060"],"district":"PG","districtName":"Perugia"},{"nome":"Lisio","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Lissone","cap":["20851"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Liveri","cap":["80030"],"district":"NA","districtName":"Napoli"},{"nome":"Livigno","cap":["23030"],"district":"SO","districtName":"Sondrio"},{"nome":"Livinallongo del Col di Lana","cap":["32020"],"district":"BL","districtName":"Belluno"},{"nome":"Livo","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Livo","cap":["38020"],"district":"TN","districtName":"Trento"},{"nome":"Livorno","cap":["57121","57122","57123","57124","57125","57126","57127","57128"],"district":"LI","districtName":"Livorno"},{"nome":"Livorno Ferraris","cap":["13046"],"district":"VC","districtName":"Vercelli"},{"nome":"Livraga","cap":["26814"],"district":"LO","districtName":"Lodi"},{"nome":"Lizzanello","cap":["73023"],"district":"LE","districtName":"Lecce"},{"nome":"Lizzano","cap":["74020"],"district":"TA","districtName":"Taranto"},{"nome":"Lizzano in Belvedere","cap":["40042"],"district":"BO","districtName":"Bologna"},{"nome":"Loano","cap":["17025"],"district":"SV","districtName":"Savona"},{"nome":"Loazzolo","cap":["14051"],"district":"AT","districtName":"Asti"},{"nome":"Locana","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Locate di Triulzi","cap":["20085"],"district":"MI","districtName":"Milano"},{"nome":"Locate Varesino","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Locatello","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Loceri","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Locorotondo","cap":["70010"],"district":"BA","districtName":"Bari"},{"nome":"Locri","cap":["89044"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Loculi","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Lodè","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Lodi","cap":["26900"],"district":"LO","districtName":"Lodi"},{"nome":"Lodi Vecchio","cap":["26855"],"district":"LO","districtName":"Lodi"},{"nome":"Lodine","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Lodrino","cap":["25060"],"district":"BS","districtName":"Brescia"},{"nome":"Lograto","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Loiano","cap":["40050"],"district":"BO","districtName":"Bologna"},{"nome":"Loiri Porto San Paolo","cap":["07020"],"district":"SS","districtName":"Sassari"},{"nome":"Lomagna","cap":["23871"],"district":"LC","districtName":"Lecco"},{"nome":"Lomazzo","cap":["22074"],"district":"CO","districtName":"Como"},{"nome":"Lombardore","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Lombriasco","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Lomello","cap":["27034"],"district":"PV","districtName":"Pavia"},{"nome":"Lona-Lases","cap":["38040"],"district":"TN","districtName":"Trento"},{"nome":"Lonate Ceppino","cap":["21050"],"district":"VA","districtName":"Varese"},{"nome":"Lonate Pozzolo","cap":["21015"],"district":"VA","districtName":"Varese"},{"nome":"Lonato del Garda","cap":["25017"],"district":"BS","districtName":"Brescia"},{"nome":"Londa","cap":["50060"],"district":"FI","districtName":"Firenze"},{"nome":"Longano","cap":["86090"],"district":"IS","districtName":"Isernia"},{"nome":"Longare","cap":["36023"],"district":"VI","districtName":"Vicenza"},{"nome":"Longarone","cap":["32013"],"district":"BL","districtName":"Belluno"},{"nome":"Longhena","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Longi","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Longiano","cap":["47020"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Longobardi","cap":["87030"],"district":"CS","districtName":"Cosenza"},{"nome":"Longobucco","cap":["87066"],"district":"CS","districtName":"Cosenza"},{"nome":"Longone al Segrino","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Longone Sabino","cap":["02020"],"district":"RI","districtName":"Rieti"},{"nome":"Lonigo","cap":["36045"],"district":"VI","districtName":"Vicenza"},{"nome":"Loranzè","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Loreggia","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Loreglia","cap":["28893"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Lorenzago di Cadore","cap":["32040"],"district":"BL","districtName":"Belluno"},{"nome":"Loreo","cap":["45017"],"district":"RO","districtName":"Rovigo"},{"nome":"Loreto","cap":["60025"],"district":"AN","districtName":"Ancona"},{"nome":"Loreto Aprutino","cap":["65014"],"district":"PE","districtName":"Pescara"},{"nome":"Loria","cap":["31037"],"district":"TV","districtName":"Treviso"},{"nome":"Loro Ciuffenna","cap":["52024"],"district":"AR","districtName":"Arezzo"},{"nome":"Loro Piceno","cap":["62020"],"district":"MC","districtName":"Macerata"},{"nome":"Lorsica","cap":["16045"],"district":"GE","districtName":"Genova"},{"nome":"Losine","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Lotzorai","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Lovere","cap":["24065"],"district":"BG","districtName":"Bergamo"},{"nome":"Lovero","cap":["23030"],"district":"SO","districtName":"Sondrio"},{"nome":"Lozio","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Lozza","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Lozzo Atestino","cap":["35034"],"district":"PD","districtName":"Padova"},{"nome":"Lozzo di Cadore","cap":["32040"],"district":"BL","districtName":"Belluno"},{"nome":"Lozzolo","cap":["13045"],"district":"VC","districtName":"Vercelli"},{"nome":"Lu e Cuccaro Monferrato","cap":["15037"],"district":"AL","districtName":"Alessandria"},{"nome":"Lubriano","cap":["01020"],"district":"VT","districtName":"Viterbo"},{"nome":"Lucca","cap":["55100"],"district":"LU","districtName":"Lucca"},{"nome":"Lucca Sicula","cap":["92010"],"district":"AG","districtName":"Agrigento"},{"nome":"Lucera","cap":["71036"],"district":"FG","districtName":"Foggia"},{"nome":"Lucignano","cap":["52046"],"district":"AR","districtName":"Arezzo"},{"nome":"Lucinasco","cap":["18020"],"district":"IM","districtName":"Imperia"},{"nome":"Lucito","cap":["86030"],"district":"CB","districtName":"Campobasso"},{"nome":"Luco dei Marsi","cap":["67056"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Lucoli","cap":["67045"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Lugagnano Val d'Arda","cap":["29018"],"district":"PC","districtName":"Piacenza"},{"nome":"Lugnano in Teverina","cap":["05020"],"district":"TR","districtName":"Terni"},{"nome":"Lugo","cap":["48022"],"district":"RA","districtName":"Ravenna"},{"nome":"Lugo di Vicenza","cap":["36030"],"district":"VI","districtName":"Vicenza"},{"nome":"Luino","cap":["21016"],"district":"VA","districtName":"Varese"},{"nome":"Luisago","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Lula","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Lumarzo","cap":["16024"],"district":"GE","districtName":"Genova"},{"nome":"Lumezzane","cap":["25065"],"district":"BS","districtName":"Brescia"},{"nome":"Lunamatrona","cap":["09022"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Lunano","cap":["61026"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Lungavilla","cap":["27053"],"district":"PV","districtName":"Pavia"},{"nome":"Lungro","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Luni","cap":["19034"],"district":"SP","districtName":"La Spezia"},{"nome":"Luogosano","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Luogosanto","cap":["07020"],"district":"SS","districtName":"Sassari"},{"nome":"Lupara","cap":["86030"],"district":"CB","districtName":"Campobasso"},{"nome":"Lurago d'Erba","cap":["22040"],"district":"CO","districtName":"Como"},{"nome":"Lurago Marinone","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Lurano","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Luras","cap":["07025"],"district":"SS","districtName":"Sassari"},{"nome":"Lurate Caccivio","cap":["22075"],"district":"CO","districtName":"Como"},{"nome":"Lusciano","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Luserna","cap":["38040"],"district":"TN","districtName":"Trento"},{"nome":"Luserna San Giovanni","cap":["10062"],"district":"TO","districtName":"Torino"},{"nome":"Lusernetta","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Lusevera","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Lusia","cap":["45020"],"district":"RO","districtName":"Rovigo"},{"nome":"Lusiana Conco","cap":["36046"],"district":"VI","districtName":"Vicenza"},{"nome":"Lusigliè","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Luson","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Lustra","cap":["84050"],"district":"SA","districtName":"Salerno"},{"nome":"Luvinate","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Luzzana","cap":["24069"],"district":"BG","districtName":"Bergamo"},{"nome":"Luzzara","cap":["42045"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Luzzi","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Maccagno con Pino e Veddasca","cap":["21061"],"district":"VA","districtName":"Varese"},{"nome":"Maccastorna","cap":["26843"],"district":"LO","districtName":"Lodi"},{"nome":"Macchia d'Isernia","cap":["86070"],"district":"IS","districtName":"Isernia"},{"nome":"Macchia Valfortore","cap":["86040"],"district":"CB","districtName":"Campobasso"},{"nome":"Macchiagodena","cap":["86096"],"district":"IS","districtName":"Isernia"},{"nome":"Macello","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Macerata","cap":["62100"],"district":"MC","districtName":"Macerata"},{"nome":"Macerata Campania","cap":["81047"],"district":"CE","districtName":"Caserta"},{"nome":"Macerata Feltria","cap":["61023"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Macherio","cap":["20846"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Maclodio","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Macomer","cap":["08015"],"district":"NU","districtName":"Nuoro"},{"nome":"Macra","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Macugnaga","cap":["28876"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Maddaloni","cap":["81024"],"district":"CE","districtName":"Caserta"},{"nome":"Madesimo","cap":["23024"],"district":"SO","districtName":"Sondrio"},{"nome":"Madignano","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Madone","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Madonna del Sasso","cap":["28894"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Madruzzo","cap":["38076"],"district":"TN","districtName":"Trento"},{"nome":"Maenza","cap":["04010"],"district":"LT","districtName":"Latina"},{"nome":"Mafalda","cap":["86030"],"district":"CB","districtName":"Campobasso"},{"nome":"Magasa","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Magenta","cap":["20013"],"district":"MI","districtName":"Milano"},{"nome":"Maggiora","cap":["28014"],"district":"NO","districtName":"Novara"},{"nome":"Magherno","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Magione","cap":["06063"],"district":"PG","districtName":"Perugia"},{"nome":"Magisano","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Magliano Alfieri","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Magliano Alpi","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Magliano de' Marsi","cap":["67062"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Magliano di Tenna","cap":["63832"],"district":"FM","districtName":"Fermo"},{"nome":"Magliano in Toscana","cap":["58051"],"district":"GR","districtName":"Grosseto"},{"nome":"Magliano Romano","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Magliano Sabina","cap":["02046"],"district":"RI","districtName":"Rieti"},{"nome":"Magliano Vetere","cap":["84050"],"district":"SA","districtName":"Salerno"},{"nome":"Maglie","cap":["73024"],"district":"LE","districtName":"Lecce"},{"nome":"Magliolo","cap":["17020"],"district":"SV","districtName":"Savona"},{"nome":"Maglione","cap":["10030"],"district":"TO","districtName":"Torino"},{"nome":"Magnacavallo","cap":["46020"],"district":"MN","districtName":"Mantova"},{"nome":"Magnago","cap":["20020"],"district":"MI","districtName":"Milano"},{"nome":"Magnano","cap":["13887"],"district":"BI","districtName":"Biella"},{"nome":"Magnano in Riviera","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Magomadas","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Magrè sulla strada del vino","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Magreglio","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Maida","cap":["88025"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Maierà","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Maierato","cap":["89843"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Maiolati Spontini","cap":["60030"],"district":"AN","districtName":"Ancona"},{"nome":"Maiolo","cap":["47862"],"district":"RN","districtName":"Rimini"},{"nome":"Maiori","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"Mairago","cap":["26825"],"district":"LO","districtName":"Lodi"},{"nome":"Mairano","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Maissana","cap":["19010"],"district":"SP","districtName":"La Spezia"},{"nome":"Majano","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"Malagnino","cap":["26030"],"district":"CR","districtName":"Cremona"},{"nome":"Malalbergo","cap":["40051"],"district":"BO","districtName":"Bologna"},{"nome":"Malborghetto Valbruna","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Malcesine","cap":["37018"],"district":"VR","districtName":"Verona"},{"nome":"Malé","cap":["38027"],"district":"TN","districtName":"Trento"},{"nome":"Malegno","cap":["25053"],"district":"BS","districtName":"Brescia"},{"nome":"Maleo","cap":["26847"],"district":"LO","districtName":"Lodi"},{"nome":"Malesco","cap":["28854"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Maletto","cap":["95035"],"district":"CT","districtName":"Catania"},{"nome":"Malfa","cap":["98050"],"district":"ME","districtName":"Messina"},{"nome":"Malgesso","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Malgrate","cap":["23864"],"district":"LC","districtName":"Lecco"},{"nome":"Malito","cap":["87030"],"district":"CS","districtName":"Cosenza"},{"nome":"Mallare","cap":["17045"],"district":"SV","districtName":"Savona"},{"nome":"Malles Venosta","cap":["39024"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Malnate","cap":["21046"],"district":"VA","districtName":"Varese"},{"nome":"Malo","cap":["36034"],"district":"VI","districtName":"Vicenza"},{"nome":"Malonno","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Maltignano","cap":["63085"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Malvagna","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Malvicino","cap":["15015"],"district":"AL","districtName":"Alessandria"},{"nome":"Malvito","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Mammola","cap":["89045"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Mamoiada","cap":["08024"],"district":"NU","districtName":"Nuoro"},{"nome":"Manciano","cap":["58014"],"district":"GR","districtName":"Grosseto"},{"nome":"Mandanici","cap":["98020"],"district":"ME","districtName":"Messina"},{"nome":"Mandas","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Mandatoriccio","cap":["87060"],"district":"CS","districtName":"Cosenza"},{"nome":"Mandela","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Mandello del Lario","cap":["23826"],"district":"LC","districtName":"Lecco"},{"nome":"Mandello Vitta","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"Manduria","cap":["74024"],"district":"TA","districtName":"Taranto"},{"nome":"Manerba del Garda","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Manerbio","cap":["25025"],"district":"BS","districtName":"Brescia"},{"nome":"Manfredonia","cap":["71043"],"district":"FG","districtName":"Foggia"},{"nome":"Mango","cap":["12056"],"district":"CN","districtName":"Cuneo"},{"nome":"Mangone","cap":["87050"],"district":"CS","districtName":"Cosenza"},{"nome":"Maniace","cap":["95030"],"district":"CT","districtName":"Catania"},{"nome":"Maniago","cap":["33085"],"district":"PN","districtName":"Pordenone"},{"nome":"Manocalzati","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Manoppello","cap":["65024"],"district":"PE","districtName":"Pescara"},{"nome":"Mansuè","cap":["31040"],"district":"TV","districtName":"Treviso"},{"nome":"Manta","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Mantello","cap":["23016"],"district":"SO","districtName":"Sondrio"},{"nome":"Mantova","cap":["46100"],"district":"MN","districtName":"Mantova"},{"nome":"Manzano","cap":["33044"],"district":"UD","districtName":"Udine"},{"nome":"Manziana","cap":["00066"],"district":"RM","districtName":"Roma"},{"nome":"Mapello","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Mappano","cap":["10079"],"district":"TO","districtName":"Torino"},{"nome":"Mara","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Maracalagonis","cap":["09069"],"district":"CA","districtName":"Cagliari"},{"nome":"Maranello","cap":["41053"],"district":"MO","districtName":"Modena"},{"nome":"Marano di Napoli","cap":["80016"],"district":"NA","districtName":"Napoli"},{"nome":"Marano di Valpolicella","cap":["37020"],"district":"VR","districtName":"Verona"},{"nome":"Marano Equo","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Marano Lagunare","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Marano Marchesato","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Marano Principato","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Marano sul Panaro","cap":["41054"],"district":"MO","districtName":"Modena"},{"nome":"Marano Ticino","cap":["28040"],"district":"NO","districtName":"Novara"},{"nome":"Marano Vicentino","cap":["36035"],"district":"VI","districtName":"Vicenza"},{"nome":"Maranzana","cap":["14040"],"district":"AT","districtName":"Asti"},{"nome":"Maratea","cap":["85046"],"district":"PZ","districtName":"Potenza"},{"nome":"Marcallo con Casone","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Marcaria","cap":["46010"],"district":"MN","districtName":"Mantova"},{"nome":"Marcedusa","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Marcellina","cap":["00010"],"district":"RM","districtName":"Roma"},{"nome":"Marcellinara","cap":["88044"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Marcetelli","cap":["02020"],"district":"RI","districtName":"Rieti"},{"nome":"Marcheno","cap":["25060"],"district":"BS","districtName":"Brescia"},{"nome":"Marchirolo","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Marciana","cap":["57030"],"district":"LI","districtName":"Livorno"},{"nome":"Marciana Marina","cap":["57033"],"district":"LI","districtName":"Livorno"},{"nome":"Marcianise","cap":["81025"],"district":"CE","districtName":"Caserta"},{"nome":"Marciano della Chiana","cap":["52047"],"district":"AR","districtName":"Arezzo"},{"nome":"Marcignago","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Marcon","cap":["30020"],"district":"VE","districtName":"Venezia"},{"nome":"Marebbe","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Marene","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Mareno di Piave","cap":["31010"],"district":"TV","districtName":"Treviso"},{"nome":"Marentino","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Maretto","cap":["14018"],"district":"AT","districtName":"Asti"},{"nome":"Margarita","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Margherita di Savoia","cap":["76016"],"district":"BT","districtName":"Barletta-Andria-Trani"},{"nome":"Margno","cap":["23832"],"district":"LC","districtName":"Lecco"},{"nome":"Mariana Mantovana","cap":["46010"],"district":"MN","districtName":"Mantova"},{"nome":"Mariano Comense","cap":["22066"],"district":"CO","districtName":"Como"},{"nome":"Mariano del Friuli","cap":["34070"],"district":"GO","districtName":"Gorizia"},{"nome":"Marianopoli","cap":["93010"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Mariglianella","cap":["80030"],"district":"NA","districtName":"Napoli"},{"nome":"Marigliano","cap":["80034"],"district":"NA","districtName":"Napoli"},{"nome":"Marina di Gioiosa Ionica","cap":["89046"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Marineo","cap":["90035"],"district":"PA","districtName":"Palermo"},{"nome":"Marino","cap":["00047"],"district":"RM","districtName":"Roma"},{"nome":"Marlengo","cap":["39020"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Marliana","cap":["51010"],"district":"PT","districtName":"Pistoia"},{"nome":"Marmentino","cap":["25060"],"district":"BS","districtName":"Brescia"},{"nome":"Marmirolo","cap":["46045"],"district":"MN","districtName":"Mantova"},{"nome":"Marmora","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Marnate","cap":["21050"],"district":"VA","districtName":"Varese"},{"nome":"Marone","cap":["25054"],"district":"BS","districtName":"Brescia"},{"nome":"Maropati","cap":["89020"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Marostica","cap":["36063"],"district":"VI","districtName":"Vicenza"},{"nome":"Marradi","cap":["50034"],"district":"FI","districtName":"Firenze"},{"nome":"Marrubiu","cap":["09094"],"district":"OR","districtName":"Oristano"},{"nome":"Marsaglia","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Marsala","cap":["91025"],"district":"TP","districtName":"Trapani"},{"nome":"Marsciano","cap":["06055"],"district":"PG","districtName":"Perugia"},{"nome":"Marsico Nuovo","cap":["85052"],"district":"PZ","districtName":"Potenza"},{"nome":"Marsicovetere","cap":["85050"],"district":"PZ","districtName":"Potenza"},{"nome":"Marta","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Martano","cap":["73025"],"district":"LE","districtName":"Lecce"},{"nome":"Martellago","cap":["30030"],"district":"VE","districtName":"Venezia"},{"nome":"Martello","cap":["39020"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Martignacco","cap":["33035"],"district":"UD","districtName":"Udine"},{"nome":"Martignana di Po","cap":["26040"],"district":"CR","districtName":"Cremona"},{"nome":"Martignano","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Martina Franca","cap":["74015"],"district":"TA","districtName":"Taranto"},{"nome":"Martinengo","cap":["24057"],"district":"BG","districtName":"Bergamo"},{"nome":"Martiniana Po","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Martinsicuro","cap":["64014"],"district":"TE","districtName":"Teramo"},{"nome":"Martirano","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Martirano Lombardo","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Martis","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Martone","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Marudo","cap":["26866"],"district":"LO","districtName":"Lodi"},{"nome":"Maruggio","cap":["74020"],"district":"TA","districtName":"Taranto"},{"nome":"Marzabotto","cap":["40043"],"district":"BO","districtName":"Bologna"},{"nome":"Marzano","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Marzano Appio","cap":["81035"],"district":"CE","districtName":"Caserta"},{"nome":"Marzano di Nola","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Marzi","cap":["87050"],"district":"CS","districtName":"Cosenza"},{"nome":"Marzio","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Masainas","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Masate","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Mascali","cap":["95016"],"district":"CT","districtName":"Catania"},{"nome":"Mascalucia","cap":["95030"],"district":"CT","districtName":"Catania"},{"nome":"Maschito","cap":["85020"],"district":"PZ","districtName":"Potenza"},{"nome":"Masciago Primo","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Maser","cap":["31010"],"district":"TV","districtName":"Treviso"},{"nome":"Masera","cap":["28855"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Maserà di Padova","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Maserada sul Piave","cap":["31052"],"district":"TV","districtName":"Treviso"},{"nome":"Masi","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Masi Torello","cap":["44020"],"district":"FE","districtName":"Ferrara"},{"nome":"Masio","cap":["15024"],"district":"AL","districtName":"Alessandria"},{"nome":"Maslianico","cap":["22026"],"district":"CO","districtName":"Como"},{"nome":"Masone","cap":["16010"],"district":"GE","districtName":"Genova"},{"nome":"Massa","cap":["54100"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Massa d'Albe","cap":["67050"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Massa di Somma","cap":["80040"],"district":"NA","districtName":"Napoli"},{"nome":"Massa e Cozzile","cap":["51010"],"district":"PT","districtName":"Pistoia"},{"nome":"Massa Fermana","cap":["63834"],"district":"FM","districtName":"Fermo"},{"nome":"Massa Lombarda","cap":["48024"],"district":"RA","districtName":"Ravenna"},{"nome":"Massa Lubrense","cap":["80061"],"district":"NA","districtName":"Napoli"},{"nome":"Massa Marittima","cap":["58024"],"district":"GR","districtName":"Grosseto"},{"nome":"Massa Martana","cap":["06056"],"district":"PG","districtName":"Perugia"},{"nome":"Massafra","cap":["74016"],"district":"TA","districtName":"Taranto"},{"nome":"Massalengo","cap":["26815"],"district":"LO","districtName":"Lodi"},{"nome":"Massanzago","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Massarosa","cap":["55054"],"district":"LU","districtName":"Lucca"},{"nome":"Massazza","cap":["13873"],"district":"BI","districtName":"Biella"},{"nome":"Massello","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Masserano","cap":["13866"],"district":"BI","districtName":"Biella"},{"nome":"Massignano","cap":["63061"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Massimeno","cap":["38086"],"district":"TN","districtName":"Trento"},{"nome":"Massimino","cap":["12071"],"district":"SV","districtName":"Savona"},{"nome":"Massino Visconti","cap":["28040"],"district":"NO","districtName":"Novara"},{"nome":"Massiola","cap":["28895"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Masullas","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Matelica","cap":["62024"],"district":"MC","districtName":"Macerata"},{"nome":"Matera","cap":["75100"],"district":"MT","districtName":"Matera"},{"nome":"Mathi","cap":["10075"],"district":"TO","districtName":"Torino"},{"nome":"Matino","cap":["73046"],"district":"LE","districtName":"Lecce"},{"nome":"Matrice","cap":["86030"],"district":"CB","districtName":"Campobasso"},{"nome":"Mattie","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Mattinata","cap":["71030"],"district":"FG","districtName":"Foggia"},{"nome":"Mazara del Vallo","cap":["91026"],"district":"TP","districtName":"Trapani"},{"nome":"Mazzano","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Mazzano Romano","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Mazzarino","cap":["93013"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Mazzarrà Sant'Andrea","cap":["98056"],"district":"ME","districtName":"Messina"},{"nome":"Mazzarrone","cap":["95040"],"district":"CT","districtName":"Catania"},{"nome":"Mazzè","cap":["10035"],"district":"TO","districtName":"Torino"},{"nome":"Mazzin","cap":["38030"],"district":"TN","districtName":"Trento"},{"nome":"Mazzo di Valtellina","cap":["23030"],"district":"SO","districtName":"Sondrio"},{"nome":"Meana di Susa","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Meana Sardo","cap":["08030"],"district":"NU","districtName":"Nuoro"},{"nome":"Meda","cap":["20821"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Mede","cap":["27035"],"district":"PV","districtName":"Pavia"},{"nome":"Medea","cap":["34076"],"district":"GO","districtName":"Gorizia"},{"nome":"Medesano","cap":["43014"],"district":"PR","districtName":"Parma"},{"nome":"Medicina","cap":["40059"],"district":"BO","districtName":"Bologna"},{"nome":"Mediglia","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Medolago","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Medole","cap":["46046"],"district":"MN","districtName":"Mantova"},{"nome":"Medolla","cap":["41036"],"district":"MO","districtName":"Modena"},{"nome":"Meduna di Livenza","cap":["31040"],"district":"TV","districtName":"Treviso"},{"nome":"Meduno","cap":["33092"],"district":"PN","districtName":"Pordenone"},{"nome":"Megliadino San Vitale","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Meina","cap":["28046"],"district":"NO","districtName":"Novara"},{"nome":"Melara","cap":["45037"],"district":"RO","districtName":"Rovigo"},{"nome":"Melazzo","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Meldola","cap":["47014"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Mele","cap":["16010"],"district":"GE","districtName":"Genova"},{"nome":"Melegnano","cap":["20077"],"district":"MI","districtName":"Milano"},{"nome":"Melendugno","cap":["73026"],"district":"LE","districtName":"Lecce"},{"nome":"Meleti","cap":["26843"],"district":"LO","districtName":"Lodi"},{"nome":"Melfi","cap":["85025"],"district":"PZ","districtName":"Potenza"},{"nome":"Melicuccà","cap":["89020"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Melicucco","cap":["89020"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Melilli","cap":["96010"],"district":"SR","districtName":"Siracusa"},{"nome":"Melissa","cap":["88814"],"district":"KR","districtName":"Crotone"},{"nome":"Melissano","cap":["73040"],"district":"LE","districtName":"Lecce"},{"nome":"Melito di Napoli","cap":["80017"],"district":"NA","districtName":"Napoli"},{"nome":"Melito di Porto Salvo","cap":["89063"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Melito Irpino","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Melizzano","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Melle","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Mello","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Melpignano","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Meltina","cap":["39010"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Melzo","cap":["20066"],"district":"MI","districtName":"Milano"},{"nome":"Menaggio","cap":["22017"],"district":"CO","districtName":"Como"},{"nome":"Menconico","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Mendatica","cap":["18025"],"district":"IM","districtName":"Imperia"},{"nome":"Mendicino","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Menfi","cap":["92013"],"district":"AG","districtName":"Agrigento"},{"nome":"Mentana","cap":["00013"],"district":"RM","districtName":"Roma"},{"nome":"Meolo","cap":["30020"],"district":"VE","districtName":"Venezia"},{"nome":"Merana","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Merano","cap":["39012"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Merate","cap":["23807"],"district":"LC","districtName":"Lecco"},{"nome":"Mercallo","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Mercatello sul Metauro","cap":["61040"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Mercatino Conca","cap":["61013"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Mercato San Severino","cap":["84085"],"district":"SA","districtName":"Salerno"},{"nome":"Mercato Saraceno","cap":["47025"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Mercenasco","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Mercogliano","cap":["83013"],"district":"AV","districtName":"Avellino"},{"nome":"Mereto di Tomba","cap":["33036"],"district":"UD","districtName":"Udine"},{"nome":"Mergo","cap":["60030"],"district":"AN","districtName":"Ancona"},{"nome":"Mergozzo","cap":["28802"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Merì","cap":["98040"],"district":"ME","districtName":"Messina"},{"nome":"Merlara","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Merlino","cap":["26833"],"district":"LO","districtName":"Lodi"},{"nome":"Merone","cap":["22046"],"district":"CO","districtName":"Como"},{"nome":"Mesagne","cap":["72023"],"district":"BR","districtName":"Brindisi"},{"nome":"Mese","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Mesenzana","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Mesero","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Mesola","cap":["44026"],"district":"FE","districtName":"Ferrara"},{"nome":"Mesoraca","cap":["88838"],"district":"KR","districtName":"Crotone"},{"nome":"Messina","cap":["98121","98122","98123","98124","98125","98126","98127","98128","98129","98130","98131","98132","98133","98134","98135","98136","98137","98138","98139","98140","98141","98142","98143","98144","98145","98146","98147","98148","98149","98150","98151","98152","98153","98154","98155","98156","98157","98158","98159","98160","98161","98162","98163","98164","98165","98166","98167","98168"],"district":"ME","districtName":"Messina"},{"nome":"Mestrino","cap":["35035"],"district":"PD","districtName":"Padova"},{"nome":"Meta","cap":["80062"],"district":"NA","districtName":"Napoli"},{"nome":"Mezzago","cap":["20883"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Mezzana","cap":["38020"],"district":"TN","districtName":"Trento"},{"nome":"Mezzana Bigli","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Mezzana Mortigliengo","cap":["13831"],"district":"BI","districtName":"Biella"},{"nome":"Mezzana Rabattone","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Mezzane di Sotto","cap":["37030"],"district":"VR","districtName":"Verona"},{"nome":"Mezzanego","cap":["16046"],"district":"GE","districtName":"Genova"},{"nome":"Mezzanino","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Mezzano","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Mezzenile","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Mezzocorona","cap":["38016"],"district":"TN","districtName":"Trento"},{"nome":"Mezzojuso","cap":["90030"],"district":"PA","districtName":"Palermo"},{"nome":"Mezzoldo","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Mezzolombardo","cap":["38017"],"district":"TN","districtName":"Trento"},{"nome":"Mezzomerico","cap":["28040"],"district":"NO","districtName":"Novara"},{"nome":"Miagliano","cap":["13816"],"district":"BI","districtName":"Biella"},{"nome":"Miane","cap":["31050"],"district":"TV","districtName":"Treviso"},{"nome":"Miasino","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Miazzina","cap":["28817"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Micigliano","cap":["02010"],"district":"RI","districtName":"Rieti"},{"nome":"Miggiano","cap":["73035"],"district":"LE","districtName":"Lecce"},{"nome":"Miglianico","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Miglierina","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Miglionico","cap":["75010"],"district":"MT","districtName":"Matera"},{"nome":"Mignanego","cap":["16018"],"district":"GE","districtName":"Genova"},{"nome":"Mignano Monte Lungo","cap":["81049"],"district":"CE","districtName":"Caserta"},{"nome":"Milano","cap":["20121","20122","20123","20124","20125","20126","20127","20128","20129","20130","20131","20132","20133","20134","20135","20136","20137","20138","20139","20140","20141","20142","20143","20144","20145","20146","20147","20148","20149","20150","20151","20152","20153","20154","20155","20156","20157","20158","20159","20160","20161","20162"],"district":"MI","districtName":"Milano"},{"nome":"Milazzo","cap":["98057"],"district":"ME","districtName":"Messina"},{"nome":"Milena","cap":["93010"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Mileto","cap":["89852"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Milis","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Militello in Val di Catania","cap":["95043"],"district":"CT","districtName":"Catania"},{"nome":"Militello Rosmarino","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Millesimo","cap":["17017"],"district":"SV","districtName":"Savona"},{"nome":"Milo","cap":["95010"],"district":"CT","districtName":"Catania"},{"nome":"Milzano","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Mineo","cap":["95044"],"district":"CT","districtName":"Catania"},{"nome":"Minerbe","cap":["37046"],"district":"VR","districtName":"Verona"},{"nome":"Minerbio","cap":["40061"],"district":"BO","districtName":"Bologna"},{"nome":"Minervino di Lecce","cap":["73027"],"district":"LE","districtName":"Lecce"},{"nome":"Minervino Murge","cap":["76013"],"district":"BT","districtName":"Barletta-Andria-Trani"},{"nome":"Minori","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"Minturno","cap":["04026"],"district":"LT","districtName":"Latina"},{"nome":"Minucciano","cap":["55034"],"district":"LU","districtName":"Lucca"},{"nome":"Mioglia","cap":["17040"],"district":"SV","districtName":"Savona"},{"nome":"Mira","cap":["30034"],"district":"VE","districtName":"Venezia"},{"nome":"Mirabella Eclano","cap":["83036"],"district":"AV","districtName":"Avellino"},{"nome":"Mirabella Imbaccari","cap":["95040"],"district":"CT","districtName":"Catania"},{"nome":"Mirabello Monferrato","cap":["15040"],"district":"AL","districtName":"Alessandria"},{"nome":"Mirabello Sannitico","cap":["86010"],"district":"CB","districtName":"Campobasso"},{"nome":"Miradolo Terme","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Miranda","cap":["86080"],"district":"IS","districtName":"Isernia"},{"nome":"Mirandola","cap":["41037"],"district":"MO","districtName":"Modena"},{"nome":"Mirano","cap":["30035"],"district":"VE","districtName":"Venezia"},{"nome":"Mirto","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Misano Adriatico","cap":["47843"],"district":"RN","districtName":"Rimini"},{"nome":"Misano di Gera d'Adda","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Misilmeri","cap":["90036"],"district":"PA","districtName":"Palermo"},{"nome":"Misinto","cap":["20826"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Missaglia","cap":["23873"],"district":"LC","districtName":"Lecco"},{"nome":"Missanello","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Misterbianco","cap":["95045"],"district":"CT","districtName":"Catania"},{"nome":"Mistretta","cap":["98073"],"district":"ME","districtName":"Messina"},{"nome":"Moasca","cap":["14050"],"district":"AT","districtName":"Asti"},{"nome":"Moconesi","cap":["16047"],"district":"GE","districtName":"Genova"},{"nome":"Modena","cap":["41121","41122","41123","41124","41125","41126"],"district":"MO","districtName":"Modena"},{"nome":"Modica","cap":["97015"],"district":"RG","districtName":"Ragusa"},{"nome":"Modigliana","cap":["47015"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Modolo","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Modugno","cap":["70026"],"district":"BA","districtName":"Bari"},{"nome":"Moena","cap":["38035"],"district":"TN","districtName":"Trento"},{"nome":"Moggio","cap":["23817"],"district":"LC","districtName":"Lecco"},{"nome":"Moggio Udinese","cap":["33015"],"district":"UD","districtName":"Udine"},{"nome":"Moglia","cap":["46024"],"district":"MN","districtName":"Mantova"},{"nome":"Mogliano","cap":["62010"],"district":"MC","districtName":"Macerata"},{"nome":"Mogliano Veneto","cap":["31021"],"district":"TV","districtName":"Treviso"},{"nome":"Mogorella","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Mogoro","cap":["09095"],"district":"OR","districtName":"Oristano"},{"nome":"Moiano","cap":["82010"],"district":"BN","districtName":"Benevento"},{"nome":"Moimacco","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Moio Alcantara","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Moio de' Calvi","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Moio della Civitella","cap":["84060"],"district":"SA","districtName":"Salerno"},{"nome":"Moiola","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Mola di Bari","cap":["70042"],"district":"BA","districtName":"Bari"},{"nome":"Molare","cap":["15074"],"district":"AL","districtName":"Alessandria"},{"nome":"Molazzana","cap":["55020"],"district":"LU","districtName":"Lucca"},{"nome":"Molfetta","cap":["70056"],"district":"BA","districtName":"Bari"},{"nome":"Molina Aterno","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Molinara","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Molinella","cap":["40062"],"district":"BO","districtName":"Bologna"},{"nome":"Molini di Triora","cap":["18010"],"district":"IM","districtName":"Imperia"},{"nome":"Molino dei Torti","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Molise","cap":["86020"],"district":"CB","districtName":"Campobasso"},{"nome":"Moliterno","cap":["85047"],"district":"PZ","districtName":"Potenza"},{"nome":"Mollia","cap":["13020"],"district":"VC","districtName":"Vercelli"},{"nome":"Molochio","cap":["89010"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Molteno","cap":["23847"],"district":"LC","districtName":"Lecco"},{"nome":"Moltrasio","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Molveno","cap":["38018"],"district":"TN","districtName":"Trento"},{"nome":"Mombaldone","cap":["14050"],"district":"AT","districtName":"Asti"},{"nome":"Mombarcaro","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Mombaroccio","cap":["61024"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Mombaruzzo","cap":["14046"],"district":"AT","districtName":"Asti"},{"nome":"Mombasiglio","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Mombello di Torino","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Mombello Monferrato","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Mombercelli","cap":["14047"],"district":"AT","districtName":"Asti"},{"nome":"Momo","cap":["28015"],"district":"NO","districtName":"Novara"},{"nome":"Mompantero","cap":["10059"],"district":"TO","districtName":"Torino"},{"nome":"Mompeo","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Momperone","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Monacilioni","cap":["86040"],"district":"CB","districtName":"Campobasso"},{"nome":"Monale","cap":["14013"],"district":"AT","districtName":"Asti"},{"nome":"Monasterace","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Monastero Bormida","cap":["14058"],"district":"AT","districtName":"Asti"},{"nome":"Monastero di Lanzo","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Monastero di Vasco","cap":["12080"],"district":"CN","districtName":"Cuneo"},{"nome":"Monasterolo Casotto","cap":["12080"],"district":"CN","districtName":"Cuneo"},{"nome":"Monasterolo del Castello","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Monasterolo di Savigliano","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Monastier di Treviso","cap":["31050"],"district":"TV","districtName":"Treviso"},{"nome":"Monastir","cap":["09023"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Moncalieri","cap":["10024"],"district":"TO","districtName":"Torino"},{"nome":"Moncalvo","cap":["14036"],"district":"AT","districtName":"Asti"},{"nome":"Moncenisio","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Moncestino","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Monchiero","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Monchio delle Corti","cap":["43010"],"district":"PR","districtName":"Parma"},{"nome":"Moncrivello","cap":["13040"],"district":"VC","districtName":"Vercelli"},{"nome":"Moncucco Torinese","cap":["14024"],"district":"AT","districtName":"Asti"},{"nome":"Mondaino","cap":["47836"],"district":"RN","districtName":"Rimini"},{"nome":"Mondavio","cap":["61040"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Mondolfo","cap":["61037"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Mondovì","cap":["12084"],"district":"CN","districtName":"Cuneo"},{"nome":"Mondragone","cap":["81034"],"district":"CE","districtName":"Caserta"},{"nome":"Moneglia","cap":["16030"],"district":"GE","districtName":"Genova"},{"nome":"Monesiglio","cap":["12077"],"district":"CN","districtName":"Cuneo"},{"nome":"Monfalcone","cap":["34074"],"district":"GO","districtName":"Gorizia"},{"nome":"Monforte d'Alba","cap":["12065"],"district":"CN","districtName":"Cuneo"},{"nome":"Monforte San Giorgio","cap":["98041"],"district":"ME","districtName":"Messina"},{"nome":"Monfumo","cap":["31010"],"district":"TV","districtName":"Treviso"},{"nome":"Mongardino","cap":["14040"],"district":"AT","districtName":"Asti"},{"nome":"Monghidoro","cap":["40063"],"district":"BO","districtName":"Bologna"},{"nome":"Mongiana","cap":["89823"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Mongiardino Ligure","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Mongiuffi Melia","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Mongrando","cap":["13888"],"district":"BI","districtName":"Biella"},{"nome":"Mongrassano","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Monguelfo-Tesido","cap":["39035"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Monguzzo","cap":["22040"],"district":"CO","districtName":"Como"},{"nome":"Moniga del Garda","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Monleale","cap":["15059"],"district":"AL","districtName":"Alessandria"},{"nome":"Monno","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Monopoli","cap":["70043"],"district":"BA","districtName":"Bari"},{"nome":"Monreale","cap":["90046"],"district":"PA","districtName":"Palermo"},{"nome":"Monrupino","cap":["34016"],"district":"TS","districtName":"Trieste"},{"nome":"Monsampietro Morico","cap":["63842"],"district":"FM","districtName":"Fermo"},{"nome":"Monsampolo del Tronto","cap":["63077"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Monsano","cap":["60030"],"district":"AN","districtName":"Ancona"},{"nome":"Monselice","cap":["35043"],"district":"PD","districtName":"Padova"},{"nome":"Monserrato","cap":["09042"],"district":"CA","districtName":"Cagliari"},{"nome":"Monsummano Terme","cap":["51015"],"district":"PT","districtName":"Pistoia"},{"nome":"Montà","cap":["12046"],"district":"CN","districtName":"Cuneo"},{"nome":"Montabone","cap":["14040"],"district":"AT","districtName":"Asti"},{"nome":"Montacuto","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Montafia","cap":["14014"],"district":"AT","districtName":"Asti"},{"nome":"Montagano","cap":["86023"],"district":"CB","districtName":"Campobasso"},{"nome":"Montagna","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Montagna in Valtellina","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Montagnana","cap":["35044"],"district":"PD","districtName":"Padova"},{"nome":"Montagnareale","cap":["98060"],"district":"ME","districtName":"Messina"},{"nome":"Montaguto","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Montaione","cap":["50050"],"district":"FI","districtName":"Firenze"},{"nome":"Montalbano Elicona","cap":["98065"],"district":"ME","districtName":"Messina"},{"nome":"Montalbano Jonico","cap":["75023"],"district":"MT","districtName":"Matera"},{"nome":"Montalcino","cap":["53024"],"district":"SI","districtName":"Siena"},{"nome":"Montaldeo","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Montaldo Bormida","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Montaldo di Mondovì","cap":["12080"],"district":"CN","districtName":"Cuneo"},{"nome":"Montaldo Roero","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Montaldo Scarampi","cap":["14048"],"district":"AT","districtName":"Asti"},{"nome":"Montaldo Torinese","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Montale","cap":["51037"],"district":"PT","districtName":"Pistoia"},{"nome":"Montalenghe","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Montallegro","cap":["92010"],"district":"AG","districtName":"Agrigento"},{"nome":"Montalto Carpasio","cap":["18028"],"district":"IM","districtName":"Imperia"},{"nome":"Montalto delle Marche","cap":["63068"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Montalto di Castro","cap":["01014"],"district":"VT","districtName":"Viterbo"},{"nome":"Montalto Dora","cap":["10016"],"district":"TO","districtName":"Torino"},{"nome":"Montalto Pavese","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Montalto Uffugo","cap":["87046"],"district":"CS","districtName":"Cosenza"},{"nome":"Montanaro","cap":["10017"],"district":"TO","districtName":"Torino"},{"nome":"Montanaso Lombardo","cap":["26836"],"district":"LO","districtName":"Lodi"},{"nome":"Montanera","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Montano Antilia","cap":["84060"],"district":"SA","districtName":"Salerno"},{"nome":"Montano Lucino","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Montappone","cap":["63835"],"district":"FM","districtName":"Fermo"},{"nome":"Montaquila","cap":["86070"],"district":"IS","districtName":"Isernia"},{"nome":"Montasola","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Montauro","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Montazzoli","cap":["66030"],"district":"CH","districtName":"Chieti"},{"nome":"Monte Argentario","cap":["58019"],"district":"GR","districtName":"Grosseto"},{"nome":"Monte Castello di Vibio","cap":["06057"],"district":"PG","districtName":"Perugia"},{"nome":"Monte Cavallo","cap":["62036"],"district":"MC","districtName":"Macerata"},{"nome":"Monte Cerignone","cap":["61010"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Monte Compatri","cap":["00077"],"district":"RM","districtName":"Roma"},{"nome":"Monte Cremasco","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Monte di Malo","cap":["36030"],"district":"VI","districtName":"Vicenza"},{"nome":"Monte di Procida","cap":["80070"],"district":"NA","districtName":"Napoli"},{"nome":"Monte Giberto","cap":["63846"],"district":"FM","districtName":"Fermo"},{"nome":"Monte Grimano Terme","cap":["61010"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Monte Isola","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Monte Marenzo","cap":["23804"],"district":"LC","districtName":"Lecco"},{"nome":"Monte Porzio","cap":["61040"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Monte Porzio Catone","cap":["00078"],"district":"RM","districtName":"Roma"},{"nome":"Monte Rinaldo","cap":["63852"],"district":"FM","districtName":"Fermo"},{"nome":"Monte Roberto","cap":["60030"],"district":"AN","districtName":"Ancona"},{"nome":"Monte Romano","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Monte San Biagio","cap":["04020"],"district":"LT","districtName":"Latina"},{"nome":"Monte San Giacomo","cap":["84030"],"district":"SA","districtName":"Salerno"},{"nome":"Monte San Giovanni Campano","cap":["03025"],"district":"FR","districtName":"Frosinone"},{"nome":"Monte San Giovanni in Sabina","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Monte San Giusto","cap":["62015"],"district":"MC","districtName":"Macerata"},{"nome":"Monte San Martino","cap":["62020"],"district":"MC","districtName":"Macerata"},{"nome":"Monte San Pietrangeli","cap":["63815"],"district":"FM","districtName":"Fermo"},{"nome":"Monte San Pietro","cap":["40050"],"district":"BO","districtName":"Bologna"},{"nome":"Monte San Savino","cap":["52048"],"district":"AR","districtName":"Arezzo"},{"nome":"Monte San Vito","cap":["60037"],"district":"AN","districtName":"Ancona"},{"nome":"Monte Sant'Angelo","cap":["71037"],"district":"FG","districtName":"Foggia"},{"nome":"Monte Santa Maria Tiberina","cap":["06010"],"district":"PG","districtName":"Perugia"},{"nome":"Monte Urano","cap":["63813"],"district":"FM","districtName":"Fermo"},{"nome":"Monte Vidon Combatte","cap":["63847"],"district":"FM","districtName":"Fermo"},{"nome":"Monte Vidon Corrado","cap":["63836"],"district":"FM","districtName":"Fermo"},{"nome":"Montebello della Battaglia","cap":["27054"],"district":"PV","districtName":"Pavia"},{"nome":"Montebello di Bertona","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Montebello Jonico","cap":["89064"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Montebello sul Sangro","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Montebello Vicentino","cap":["36054"],"district":"VI","districtName":"Vicenza"},{"nome":"Montebelluna","cap":["31044"],"district":"TV","districtName":"Treviso"},{"nome":"Montebruno","cap":["16025"],"district":"GE","districtName":"Genova"},{"nome":"Montebuono","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Montecalvo in Foglia","cap":["61020"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Montecalvo Irpino","cap":["83037"],"district":"AV","districtName":"Avellino"},{"nome":"Montecalvo Versiggia","cap":["27047"],"district":"PV","districtName":"Pavia"},{"nome":"Montecarlo","cap":["55015"],"district":"LU","districtName":"Lucca"},{"nome":"Montecarotto","cap":["60036"],"district":"AN","districtName":"Ancona"},{"nome":"Montecassiano","cap":["62010"],"district":"MC","districtName":"Macerata"},{"nome":"Montecastello","cap":["15040"],"district":"AL","districtName":"Alessandria"},{"nome":"Montecastrilli","cap":["05026"],"district":"TR","districtName":"Terni"},{"nome":"Montecatini Val di Cecina","cap":["56040"],"district":"PI","districtName":"Pisa"},{"nome":"Montecatini-Terme","cap":["51016"],"district":"PT","districtName":"Pistoia"},{"nome":"Montecchia di Crosara","cap":["37030"],"district":"VR","districtName":"Verona"},{"nome":"Montecchio","cap":["05020"],"district":"TR","districtName":"Terni"},{"nome":"Montecchio Emilia","cap":["42027"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Montecchio Maggiore","cap":["36075"],"district":"VI","districtName":"Vicenza"},{"nome":"Montecchio Precalcino","cap":["36030"],"district":"VI","districtName":"Vicenza"},{"nome":"Montechiaro d'Acqui","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Montechiaro d'Asti","cap":["14025"],"district":"AT","districtName":"Asti"},{"nome":"Montechiarugolo","cap":["43022"],"district":"PR","districtName":"Parma"},{"nome":"Monteciccardo","cap":["61024"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Montecilfone","cap":["86032"],"district":"CB","districtName":"Campobasso"},{"nome":"Montecopiolo","cap":["61014"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Montecorice","cap":["84060"],"district":"SA","districtName":"Salerno"},{"nome":"Montecorvino Pugliano","cap":["84090"],"district":"SA","districtName":"Salerno"},{"nome":"Montecorvino Rovella","cap":["84096"],"district":"SA","districtName":"Salerno"},{"nome":"Montecosaro","cap":["62010"],"district":"MC","districtName":"Macerata"},{"nome":"Montecrestese","cap":["28864"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Montecreto","cap":["41025"],"district":"MO","districtName":"Modena"},{"nome":"Montedinove","cap":["63069"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Montedoro","cap":["93010"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Montefalcione","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Montefalco","cap":["06036"],"district":"PG","districtName":"Perugia"},{"nome":"Montefalcone Appennino","cap":["63855"],"district":"FM","districtName":"Fermo"},{"nome":"Montefalcone di Val Fortore","cap":["82025"],"district":"BN","districtName":"Benevento"},{"nome":"Montefalcone nel Sannio","cap":["86033"],"district":"CB","districtName":"Campobasso"},{"nome":"Montefano","cap":["62010"],"district":"MC","districtName":"Macerata"},{"nome":"Montefelcino","cap":["61030"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Monteferrante","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Montefiascone","cap":["01027"],"district":"VT","districtName":"Viterbo"},{"nome":"Montefino","cap":["64030"],"district":"TE","districtName":"Teramo"},{"nome":"Montefiore Conca","cap":["47834"],"district":"RN","districtName":"Rimini"},{"nome":"Montefiore dell'Aso","cap":["63062"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Montefiorino","cap":["41045"],"district":"MO","districtName":"Modena"},{"nome":"Monteflavio","cap":["00010"],"district":"RM","districtName":"Roma"},{"nome":"Monteforte Cilento","cap":["84060"],"district":"SA","districtName":"Salerno"},{"nome":"Monteforte d'Alpone","cap":["37032"],"district":"VR","districtName":"Verona"},{"nome":"Monteforte Irpino","cap":["83024"],"district":"AV","districtName":"Avellino"},{"nome":"Montefortino","cap":["63858"],"district":"FM","districtName":"Fermo"},{"nome":"Montefranco","cap":["05030"],"district":"TR","districtName":"Terni"},{"nome":"Montefredane","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Montefusco","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Montegabbione","cap":["05010"],"district":"TR","districtName":"Terni"},{"nome":"Montegalda","cap":["36047"],"district":"VI","districtName":"Vicenza"},{"nome":"Montegaldella","cap":["36047"],"district":"VI","districtName":"Vicenza"},{"nome":"Montegallo","cap":["63094"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Montegioco","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Montegiordano","cap":["87070"],"district":"CS","districtName":"Cosenza"},{"nome":"Montegiorgio","cap":["63833"],"district":"FM","districtName":"Fermo"},{"nome":"Montegranaro","cap":["63812"],"district":"FM","districtName":"Fermo"},{"nome":"Montegridolfo","cap":["47837"],"district":"RN","districtName":"Rimini"},{"nome":"Montegrino Valtravaglia","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Montegrosso d'Asti","cap":["14048"],"district":"AT","districtName":"Asti"},{"nome":"Montegrosso Pian Latte","cap":["18025"],"district":"IM","districtName":"Imperia"},{"nome":"Montegrotto Terme","cap":["35036"],"district":"PD","districtName":"Padova"},{"nome":"Monteiasi","cap":["74020"],"district":"TA","districtName":"Taranto"},{"nome":"Montelabbate","cap":["61025"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Montelanico","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"Montelapiano","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Monteleone d'Orvieto","cap":["05017"],"district":"TR","districtName":"Terni"},{"nome":"Monteleone di Fermo","cap":["63841"],"district":"FM","districtName":"Fermo"},{"nome":"Monteleone di Puglia","cap":["71020"],"district":"FG","districtName":"Foggia"},{"nome":"Monteleone di Spoleto","cap":["06045"],"district":"PG","districtName":"Perugia"},{"nome":"Monteleone Rocca Doria","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Monteleone Sabino","cap":["02033"],"district":"RI","districtName":"Rieti"},{"nome":"Montelepre","cap":["90040"],"district":"PA","districtName":"Palermo"},{"nome":"Montelibretti","cap":["00010"],"district":"RM","districtName":"Roma"},{"nome":"Montella","cap":["83048"],"district":"AV","districtName":"Avellino"},{"nome":"Montello","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Montelongo","cap":["86040"],"district":"CB","districtName":"Campobasso"},{"nome":"Montelparo","cap":["63853"],"district":"FM","districtName":"Fermo"},{"nome":"Montelupo Albese","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Montelupo Fiorentino","cap":["50056"],"district":"FI","districtName":"Firenze"},{"nome":"Montelupone","cap":["62010"],"district":"MC","districtName":"Macerata"},{"nome":"Montemaggiore Belsito","cap":["90020"],"district":"PA","districtName":"Palermo"},{"nome":"Montemagno","cap":["14030"],"district":"AT","districtName":"Asti"},{"nome":"Montemale di Cuneo","cap":["12025"],"district":"CN","districtName":"Cuneo"},{"nome":"Montemarano","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Montemarciano","cap":["60018"],"district":"AN","districtName":"Ancona"},{"nome":"Montemarzino","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Montemesola","cap":["74020"],"district":"TA","districtName":"Taranto"},{"nome":"Montemezzo","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Montemignaio","cap":["52010"],"district":"AR","districtName":"Arezzo"},{"nome":"Montemiletto","cap":["83038"],"district":"AV","districtName":"Avellino"},{"nome":"Montemilone","cap":["85020"],"district":"PZ","districtName":"Potenza"},{"nome":"Montemitro","cap":["86030"],"district":"CB","districtName":"Campobasso"},{"nome":"Montemonaco","cap":["63088"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Montemurlo","cap":["59013"],"district":"PO","districtName":"Prato"},{"nome":"Montemurro","cap":["85053"],"district":"PZ","districtName":"Potenza"},{"nome":"Montenars","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Montenero di Bisaccia","cap":["86036"],"district":"CB","districtName":"Campobasso"},{"nome":"Montenero Sabino","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Montenero Val Cocchiara","cap":["86080"],"district":"IS","districtName":"Isernia"},{"nome":"Montenerodomo","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Monteodorisio","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Montepaone","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Monteparano","cap":["74020"],"district":"TA","districtName":"Taranto"},{"nome":"Monteprandone","cap":["63076"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Montepulciano","cap":["53045"],"district":"SI","districtName":"Siena"},{"nome":"Monterchi","cap":["52035"],"district":"AR","districtName":"Arezzo"},{"nome":"Montereale","cap":["67015"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Montereale Valcellina","cap":["33086"],"district":"PN","districtName":"Pordenone"},{"nome":"Monterenzio","cap":["40050"],"district":"BO","districtName":"Bologna"},{"nome":"Monteriggioni","cap":["53035"],"district":"SI","districtName":"Siena"},{"nome":"Monteroduni","cap":["86075"],"district":"IS","districtName":"Isernia"},{"nome":"Monteroni d'Arbia","cap":["53014"],"district":"SI","districtName":"Siena"},{"nome":"Monteroni di Lecce","cap":["73047"],"district":"LE","districtName":"Lecce"},{"nome":"Monterosi","cap":["01030"],"district":"VT","districtName":"Viterbo"},{"nome":"Monterosso al Mare","cap":["19016"],"district":"SP","districtName":"La Spezia"},{"nome":"Monterosso Almo","cap":["97010"],"district":"RG","districtName":"Ragusa"},{"nome":"Monterosso Calabro","cap":["89819"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Monterosso Grana","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Monterotondo","cap":["00015"],"district":"RM","districtName":"Roma"},{"nome":"Monterotondo Marittimo","cap":["58025"],"district":"GR","districtName":"Grosseto"},{"nome":"Monterubbiano","cap":["63825"],"district":"FM","districtName":"Fermo"},{"nome":"Montesano Salentino","cap":["73030"],"district":"LE","districtName":"Lecce"},{"nome":"Montesano sulla Marcellana","cap":["84033"],"district":"SA","districtName":"Salerno"},{"nome":"Montesarchio","cap":["82016"],"district":"BN","districtName":"Benevento"},{"nome":"Montescaglioso","cap":["75024"],"district":"MT","districtName":"Matera"},{"nome":"Montescano","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Montescheno","cap":["28843"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Montescudaio","cap":["56040"],"district":"PI","districtName":"Pisa"},{"nome":"Montescudo-Monte Colombo","cap":["47854"],"district":"RN","districtName":"Rimini"},{"nome":"Montese","cap":["41055"],"district":"MO","districtName":"Modena"},{"nome":"Montesegale","cap":["27052"],"district":"PV","districtName":"Pavia"},{"nome":"Montesilvano","cap":["65015"],"district":"PE","districtName":"Pescara"},{"nome":"Montespertoli","cap":["50025"],"district":"FI","districtName":"Firenze"},{"nome":"Monteu da Po","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Monteu Roero","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Montevago","cap":["92010"],"district":"AG","districtName":"Agrigento"},{"nome":"Montevarchi","cap":["52025"],"district":"AR","districtName":"Arezzo"},{"nome":"Montevecchia","cap":["23874"],"district":"LC","districtName":"Lecco"},{"nome":"Monteverde","cap":["83049"],"district":"AV","districtName":"Avellino"},{"nome":"Monteverdi Marittimo","cap":["56040"],"district":"PI","districtName":"Pisa"},{"nome":"Monteviale","cap":["36050"],"district":"VI","districtName":"Vicenza"},{"nome":"Montezemolo","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Monti","cap":["07020"],"district":"SS","districtName":"Sassari"},{"nome":"Montiano","cap":["47020"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Monticelli Brusati","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Monticelli d'Ongina","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Monticelli Pavese","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Monticello Brianza","cap":["23876"],"district":"LC","districtName":"Lecco"},{"nome":"Monticello Conte Otto","cap":["36010"],"district":"VI","districtName":"Vicenza"},{"nome":"Monticello d'Alba","cap":["12066"],"district":"CN","districtName":"Cuneo"},{"nome":"Montichiari","cap":["25018"],"district":"BS","districtName":"Brescia"},{"nome":"Monticiano","cap":["53015"],"district":"SI","districtName":"Siena"},{"nome":"Montieri","cap":["58026"],"district":"GR","districtName":"Grosseto"},{"nome":"Montiglio Monferrato","cap":["14026"],"district":"AT","districtName":"Asti"},{"nome":"Montignoso","cap":["54038"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Montirone","cap":["25010"],"district":"BS","districtName":"Brescia"},{"nome":"Montjovet","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Montodine","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Montoggio","cap":["16026"],"district":"GE","districtName":"Genova"},{"nome":"Montone","cap":["06014"],"district":"PG","districtName":"Perugia"},{"nome":"Montopoli di Sabina","cap":["02034"],"district":"RI","districtName":"Rieti"},{"nome":"Montopoli in Val d'Arno","cap":["56020"],"district":"PI","districtName":"Pisa"},{"nome":"Montorfano","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Montorio al Vomano","cap":["64046"],"district":"TE","districtName":"Teramo"},{"nome":"Montorio nei Frentani","cap":["86040"],"district":"CB","districtName":"Campobasso"},{"nome":"Montorio Romano","cap":["00010"],"district":"RM","districtName":"Roma"},{"nome":"Montoro","cap":["83025"],"district":"AV","districtName":"Avellino"},{"nome":"Montorso Vicentino","cap":["36050"],"district":"VI","districtName":"Vicenza"},{"nome":"Montottone","cap":["63843"],"district":"FM","districtName":"Fermo"},{"nome":"Montresta","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Montù Beccaria","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Monvalle","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Monza","cap":["20900"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Monzambano","cap":["46040"],"district":"MN","districtName":"Mantova"},{"nome":"Monzuno","cap":["40036"],"district":"BO","districtName":"Bologna"},{"nome":"Morano Calabro","cap":["87016"],"district":"CS","districtName":"Cosenza"},{"nome":"Morano sul Po","cap":["15025"],"district":"AL","districtName":"Alessandria"},{"nome":"Moransengo","cap":["14023"],"district":"AT","districtName":"Asti"},{"nome":"Moraro","cap":["34070"],"district":"GO","districtName":"Gorizia"},{"nome":"Morazzone","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Morbegno","cap":["23017"],"district":"SO","districtName":"Sondrio"},{"nome":"Morbello","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Morciano di Leuca","cap":["73040"],"district":"LE","districtName":"Lecce"},{"nome":"Morciano di Romagna","cap":["47833"],"district":"RN","districtName":"Rimini"},{"nome":"Morcone","cap":["82026"],"district":"BN","districtName":"Benevento"},{"nome":"Mordano","cap":["40027"],"district":"BO","districtName":"Bologna"},{"nome":"Morengo","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Mores","cap":["07013"],"district":"SS","districtName":"Sassari"},{"nome":"Moresco","cap":["63826"],"district":"FM","districtName":"Fermo"},{"nome":"Moretta","cap":["12033"],"district":"CN","districtName":"Cuneo"},{"nome":"Morfasso","cap":["29020"],"district":"PC","districtName":"Piacenza"},{"nome":"Morgano","cap":["31050"],"district":"TV","districtName":"Treviso"},{"nome":"Morgex","cap":["11017"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Morgongiori","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Mori","cap":["38065"],"district":"TN","districtName":"Trento"},{"nome":"Moriago della Battaglia","cap":["31010"],"district":"TV","districtName":"Treviso"},{"nome":"Moricone","cap":["00010"],"district":"RM","districtName":"Roma"},{"nome":"Morigerati","cap":["84030"],"district":"SA","districtName":"Salerno"},{"nome":"Morimondo","cap":["20081"],"district":"MI","districtName":"Milano"},{"nome":"Morino","cap":["67050"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Moriondo Torinese","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Morlupo","cap":["00067"],"district":"RM","districtName":"Roma"},{"nome":"Mormanno","cap":["87026"],"district":"CS","districtName":"Cosenza"},{"nome":"Mornago","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Mornese","cap":["15075"],"district":"AL","districtName":"Alessandria"},{"nome":"Mornico al Serio","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Mornico Losana","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Morolo","cap":["03017"],"district":"FR","districtName":"Frosinone"},{"nome":"Morozzo","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Morra De Sanctis","cap":["83040"],"district":"AV","districtName":"Avellino"},{"nome":"Morro d'Alba","cap":["60030"],"district":"AN","districtName":"Ancona"},{"nome":"Morro d'Oro","cap":["64020"],"district":"TE","districtName":"Teramo"},{"nome":"Morro Reatino","cap":["02010"],"district":"RI","districtName":"Rieti"},{"nome":"Morrone del Sannio","cap":["86040"],"district":"CB","districtName":"Campobasso"},{"nome":"Morrovalle","cap":["62010"],"district":"MC","districtName":"Macerata"},{"nome":"Morsano al Tagliamento","cap":["33075"],"district":"PN","districtName":"Pordenone"},{"nome":"Morsasco","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Mortara","cap":["27036"],"district":"PV","districtName":"Pavia"},{"nome":"Mortegliano","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Morterone","cap":["23811"],"district":"LC","districtName":"Lecco"},{"nome":"Moruzzo","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"Moscazzano","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Moschiano","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Mosciano Sant'Angelo","cap":["64023"],"district":"TE","districtName":"Teramo"},{"nome":"Moscufo","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Moso in Passiria","cap":["39013"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Mossa","cap":["34070"],"district":"GO","districtName":"Gorizia"},{"nome":"Motta Baluffi","cap":["26045"],"district":"CR","districtName":"Cremona"},{"nome":"Motta Camastra","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Motta d'Affermo","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Motta de' Conti","cap":["13010"],"district":"VC","districtName":"Vercelli"},{"nome":"Motta di Livenza","cap":["31045"],"district":"TV","districtName":"Treviso"},{"nome":"Motta Montecorvino","cap":["71030"],"district":"FG","districtName":"Foggia"},{"nome":"Motta San Giovanni","cap":["89065"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Motta Sant'Anastasia","cap":["95040"],"district":"CT","districtName":"Catania"},{"nome":"Motta Santa Lucia","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Motta Visconti","cap":["20086"],"district":"MI","districtName":"Milano"},{"nome":"Mottafollone","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Mottalciata","cap":["13874"],"district":"BI","districtName":"Biella"},{"nome":"Motteggiana","cap":["46020"],"district":"MN","districtName":"Mantova"},{"nome":"Mottola","cap":["74017"],"district":"TA","districtName":"Taranto"},{"nome":"Mozzagrogna","cap":["66030"],"district":"CH","districtName":"Chieti"},{"nome":"Mozzanica","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Mozzate","cap":["22076"],"district":"CO","districtName":"Como"},{"nome":"Mozzecane","cap":["37060"],"district":"VR","districtName":"Verona"},{"nome":"Mozzo","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Muccia","cap":["62034"],"district":"MC","districtName":"Macerata"},{"nome":"Muggia","cap":["34015"],"district":"TS","districtName":"Trieste"},{"nome":"Muggiò","cap":["20835"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Mugnano del Cardinale","cap":["83027"],"district":"AV","districtName":"Avellino"},{"nome":"Mugnano di Napoli","cap":["80018"],"district":"NA","districtName":"Napoli"},{"nome":"Mulazzano","cap":["26837"],"district":"LO","districtName":"Lodi"},{"nome":"Mulazzo","cap":["54026"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Mura","cap":["25070"],"district":"BS","districtName":"Brescia"},{"nome":"Muravera","cap":["09043"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Murazzano","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Murello","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Murialdo","cap":["17013"],"district":"SV","districtName":"Savona"},{"nome":"Murisengo","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Murlo","cap":["53016"],"district":"SI","districtName":"Siena"},{"nome":"Muro Leccese","cap":["73036"],"district":"LE","districtName":"Lecce"},{"nome":"Muro Lucano","cap":["85054"],"district":"PZ","districtName":"Potenza"},{"nome":"Muros","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Muscoline","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Musei","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Musile di Piave","cap":["30024"],"district":"VE","districtName":"Venezia"},{"nome":"Musso","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Mussolente","cap":["36065"],"district":"VI","districtName":"Vicenza"},{"nome":"Mussomeli","cap":["93014"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Muzzana del Turgnano","cap":["33055"],"district":"UD","districtName":"Udine"},{"nome":"Muzzano","cap":["13895"],"district":"BI","districtName":"Biella"},{"nome":"Nago-Torbole","cap":["38069"],"district":"TN","districtName":"Trento"},{"nome":"Nalles","cap":["39010"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Nanto","cap":["36024"],"district":"VI","districtName":"Vicenza"},{"nome":"Napoli","cap":["80121","80122","80123","80124","80125","80126","80127","80128","80129","80130","80131","80132","80133","80134","80135","80136","80137","80138","80139","80140","80141","80142","80143","80144","80145","80146","80147"],"district":"NA","districtName":"Napoli"},{"nome":"Narbolia","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Narcao","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Nardò","cap":["73048"],"district":"LE","districtName":"Lecce"},{"nome":"Nardodipace","cap":["89824"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Narni","cap":["05035"],"district":"TR","districtName":"Terni"},{"nome":"Naro","cap":["92028"],"district":"AG","districtName":"Agrigento"},{"nome":"Narzole","cap":["12068"],"district":"CN","districtName":"Cuneo"},{"nome":"Nasino","cap":["17030"],"district":"SV","districtName":"Savona"},{"nome":"Naso","cap":["98074"],"district":"ME","districtName":"Messina"},{"nome":"Naturno","cap":["39025"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Nave","cap":["25075"],"district":"BS","districtName":"Brescia"},{"nome":"Navelli","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Naz-Sciaves","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Nazzano","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Ne","cap":["16040"],"district":"GE","districtName":"Genova"},{"nome":"Nebbiuno","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Negrar di Valpolicella","cap":["37024"],"district":"VR","districtName":"Verona"},{"nome":"Neirone","cap":["16040"],"district":"GE","districtName":"Genova"},{"nome":"Neive","cap":["12052"],"district":"CN","districtName":"Cuneo"},{"nome":"Nembro","cap":["24027"],"district":"BG","districtName":"Bergamo"},{"nome":"Nemi","cap":["00074"],"district":"RM","districtName":"Roma"},{"nome":"Nemoli","cap":["85040"],"district":"PZ","districtName":"Potenza"},{"nome":"Neoneli","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Nepi","cap":["01036"],"district":"VT","districtName":"Viterbo"},{"nome":"Nereto","cap":["64015"],"district":"TE","districtName":"Teramo"},{"nome":"Nerola","cap":["00017"],"district":"RM","districtName":"Roma"},{"nome":"Nervesa della Battaglia","cap":["31040"],"district":"TV","districtName":"Treviso"},{"nome":"Nerviano","cap":["20014"],"district":"MI","districtName":"Milano"},{"nome":"Nespolo","cap":["02020"],"district":"RI","districtName":"Rieti"},{"nome":"Nesso","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Netro","cap":["13896"],"district":"BI","districtName":"Biella"},{"nome":"Nettuno","cap":["00048"],"district":"RM","districtName":"Roma"},{"nome":"Neviano","cap":["73040"],"district":"LE","districtName":"Lecce"},{"nome":"Neviano degli Arduini","cap":["43024"],"district":"PR","districtName":"Parma"},{"nome":"Neviglie","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Niardo","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Nibbiola","cap":["28070"],"district":"NO","districtName":"Novara"},{"nome":"Nibionno","cap":["23895"],"district":"LC","districtName":"Lecco"},{"nome":"Nichelino","cap":["10042"],"district":"TO","districtName":"Torino"},{"nome":"Nicolosi","cap":["95030"],"district":"CT","districtName":"Catania"},{"nome":"Nicorvo","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Nicosia","cap":["94014"],"district":"EN","districtName":"Enna"},{"nome":"Nicotera","cap":["89844"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Niella Belbo","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Niella Tanaro","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Nimis","cap":["33045"],"district":"UD","districtName":"Udine"},{"nome":"Niscemi","cap":["93015"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Nissoria","cap":["94010"],"district":"EN","districtName":"Enna"},{"nome":"Nizza di Sicilia","cap":["98026"],"district":"ME","districtName":"Messina"},{"nome":"Nizza Monferrato","cap":["14049"],"district":"AT","districtName":"Asti"},{"nome":"Noale","cap":["30033"],"district":"VE","districtName":"Venezia"},{"nome":"Noasca","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Nocara","cap":["87070"],"district":"CS","districtName":"Cosenza"},{"nome":"Nocciano","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Nocera Inferiore","cap":["84014"],"district":"SA","districtName":"Salerno"},{"nome":"Nocera Superiore","cap":["84015"],"district":"SA","districtName":"Salerno"},{"nome":"Nocera Terinese","cap":["88047"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Nocera Umbra","cap":["06025"],"district":"PG","districtName":"Perugia"},{"nome":"Noceto","cap":["43015"],"district":"PR","districtName":"Parma"},{"nome":"Noci","cap":["70015"],"district":"BA","districtName":"Bari"},{"nome":"Nociglia","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Noepoli","cap":["85035"],"district":"PZ","districtName":"Potenza"},{"nome":"Nogara","cap":["37054"],"district":"VR","districtName":"Verona"},{"nome":"Nogaredo","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Nogarole Rocca","cap":["37060"],"district":"VR","districtName":"Verona"},{"nome":"Nogarole Vicentino","cap":["36070"],"district":"VI","districtName":"Vicenza"},{"nome":"Noicattaro","cap":["70016"],"district":"BA","districtName":"Bari"},{"nome":"Nola","cap":["80035"],"district":"NA","districtName":"Napoli"},{"nome":"Nole","cap":["10076"],"district":"TO","districtName":"Torino"},{"nome":"Noli","cap":["17026"],"district":"SV","districtName":"Savona"},{"nome":"Nomaglio","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Nomi","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Nonantola","cap":["41015"],"district":"MO","districtName":"Modena"},{"nome":"None","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Nonio","cap":["28891"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Noragugume","cap":["08010"],"district":"NU","districtName":"Nuoro"},{"nome":"Norbello","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Norcia","cap":["06046"],"district":"PG","districtName":"Perugia"},{"nome":"Norma","cap":["04010"],"district":"LT","districtName":"Latina"},{"nome":"Nosate","cap":["20020"],"district":"MI","districtName":"Milano"},{"nome":"Notaresco","cap":["64024"],"district":"TE","districtName":"Teramo"},{"nome":"Noto","cap":["96017"],"district":"SR","districtName":"Siracusa"},{"nome":"Nova Levante","cap":["39056"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Nova Milanese","cap":["20834"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Nova Ponente","cap":["39050"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Nova Siri","cap":["75020"],"district":"MT","districtName":"Matera"},{"nome":"Novafeltria","cap":["47863"],"district":"RN","districtName":"Rimini"},{"nome":"Novaledo","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Novalesa","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Novara","cap":["28100"],"district":"NO","districtName":"Novara"},{"nome":"Novara di Sicilia","cap":["98058"],"district":"ME","districtName":"Messina"},{"nome":"Novate Mezzola","cap":["23025"],"district":"SO","districtName":"Sondrio"},{"nome":"Novate Milanese","cap":["20026"],"district":"MI","districtName":"Milano"},{"nome":"Nove","cap":["36055"],"district":"VI","districtName":"Vicenza"},{"nome":"Novedrate","cap":["22060"],"district":"CO","districtName":"Como"},{"nome":"Novella","cap":["38021","38028","38020"],"district":"TN","districtName":"Trento"},{"nome":"Novellara","cap":["42017"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Novello","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Noventa di Piave","cap":["30020"],"district":"VE","districtName":"Venezia"},{"nome":"Noventa Padovana","cap":["35027"],"district":"PD","districtName":"Padova"},{"nome":"Noventa Vicentina","cap":["36025"],"district":"VI","districtName":"Vicenza"},{"nome":"Novi di Modena","cap":["41016"],"district":"MO","districtName":"Modena"},{"nome":"Novi Ligure","cap":["15067"],"district":"AL","districtName":"Alessandria"},{"nome":"Novi Velia","cap":["84060"],"district":"SA","districtName":"Salerno"},{"nome":"Noviglio","cap":["20082"],"district":"MI","districtName":"Milano"},{"nome":"Novoli","cap":["73051"],"district":"LE","districtName":"Lecce"},{"nome":"Nucetto","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Nughedu San Nicolò","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Nughedu Santa Vittoria","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Nule","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Nulvi","cap":["07032"],"district":"SS","districtName":"Sassari"},{"nome":"Numana","cap":["60026"],"district":"AN","districtName":"Ancona"},{"nome":"Nuoro","cap":["08100"],"district":"NU","districtName":"Nuoro"},{"nome":"Nurachi","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Nuragus","cap":["09057"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Nurallao","cap":["09058"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Nuraminis","cap":["09024"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Nureci","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Nurri","cap":["09059"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Nus","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Nusco","cap":["83051"],"district":"AV","districtName":"Avellino"},{"nome":"Nuvolento","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Nuvolera","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Nuxis","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Occhieppo Inferiore","cap":["13897"],"district":"BI","districtName":"Biella"},{"nome":"Occhieppo Superiore","cap":["13898"],"district":"BI","districtName":"Biella"},{"nome":"Occhiobello","cap":["45030"],"district":"RO","districtName":"Rovigo"},{"nome":"Occimiano","cap":["15040"],"district":"AL","districtName":"Alessandria"},{"nome":"Ocre","cap":["67040"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Odalengo Grande","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Odalengo Piccolo","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Oderzo","cap":["31046"],"district":"TV","districtName":"Treviso"},{"nome":"Odolo","cap":["25076"],"district":"BS","districtName":"Brescia"},{"nome":"Ofena","cap":["67025"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Offagna","cap":["60020"],"district":"AN","districtName":"Ancona"},{"nome":"Offanengo","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Offida","cap":["63073"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Offlaga","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Oggebbio","cap":["28824"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Oggiona con Santo Stefano","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Oggiono","cap":["23848"],"district":"LC","districtName":"Lecco"},{"nome":"Oglianico","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Ogliastro Cilento","cap":["84061"],"district":"SA","districtName":"Salerno"},{"nome":"Olbia","cap":["07026"],"district":"SS","districtName":"Sassari"},{"nome":"Olcenengo","cap":["13047"],"district":"VC","districtName":"Vercelli"},{"nome":"Oldenico","cap":["13030"],"district":"VC","districtName":"Vercelli"},{"nome":"Oleggio","cap":["28047"],"district":"NO","districtName":"Novara"},{"nome":"Oleggio Castello","cap":["28040"],"district":"NO","districtName":"Novara"},{"nome":"Olevano di Lomellina","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Olevano Romano","cap":["00035"],"district":"RM","districtName":"Roma"},{"nome":"Olevano sul Tusciano","cap":["84062"],"district":"SA","districtName":"Salerno"},{"nome":"Olgiate Comasco","cap":["22077"],"district":"CO","districtName":"Como"},{"nome":"Olgiate Molgora","cap":["23887"],"district":"LC","districtName":"Lecco"},{"nome":"Olgiate Olona","cap":["21057"],"district":"VA","districtName":"Varese"},{"nome":"Olginate","cap":["23854"],"district":"LC","districtName":"Lecco"},{"nome":"Oliena","cap":["08025"],"district":"NU","districtName":"Nuoro"},{"nome":"Oliva Gessi","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Olivadi","cap":["88067"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Oliveri","cap":["98060"],"district":"ME","districtName":"Messina"},{"nome":"Oliveto Citra","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Oliveto Lario","cap":["23865"],"district":"LC","districtName":"Lecco"},{"nome":"Oliveto Lucano","cap":["75010"],"district":"MT","districtName":"Matera"},{"nome":"Olivetta San Michele","cap":["18030"],"district":"IM","districtName":"Imperia"},{"nome":"Olivola","cap":["15030"],"district":"AL","districtName":"Alessandria"},{"nome":"Ollastra","cap":["09088"],"district":"OR","districtName":"Oristano"},{"nome":"Ollolai","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Ollomont","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Olmedo","cap":["07040"],"district":"SS","districtName":"Sassari"},{"nome":"Olmeneta","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Olmo al Brembo","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Olmo Gentile","cap":["14050"],"district":"AT","districtName":"Asti"},{"nome":"Oltre il Colle","cap":["24013"],"district":"BG","districtName":"Bergamo"},{"nome":"Oltressenda Alta","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Oltrona di San Mamette","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Olzai","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Ome","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Omegna","cap":["28887"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Omignano","cap":["84060"],"district":"SA","districtName":"Salerno"},{"nome":"Onanì","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Onano","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Oncino","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Oneta","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Onifai","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Oniferi","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Ono San Pietro","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Onore","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Onzo","cap":["17037"],"district":"SV","districtName":"Savona"},{"nome":"Opera","cap":["20090"],"district":"MI","districtName":"Milano"},{"nome":"Opi","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Oppeano","cap":["37050"],"district":"VR","districtName":"Verona"},{"nome":"Oppido Lucano","cap":["85015"],"district":"PZ","districtName":"Potenza"},{"nome":"Oppido Mamertina","cap":["89014"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Ora","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Orani","cap":["08026"],"district":"NU","districtName":"Nuoro"},{"nome":"Oratino","cap":["86010"],"district":"CB","districtName":"Campobasso"},{"nome":"Orbassano","cap":["10043"],"district":"TO","districtName":"Torino"},{"nome":"Orbetello","cap":["58015"],"district":"GR","districtName":"Grosseto"},{"nome":"Orciano Pisano","cap":["56040"],"district":"PI","districtName":"Pisa"},{"nome":"Orco Feglino","cap":["17024"],"district":"SV","districtName":"Savona"},{"nome":"Ordona","cap":["71040"],"district":"FG","districtName":"Foggia"},{"nome":"Orero","cap":["16040"],"district":"GE","districtName":"Genova"},{"nome":"Orgiano","cap":["36040"],"district":"VI","districtName":"Vicenza"},{"nome":"Orgosolo","cap":["08027"],"district":"NU","districtName":"Nuoro"},{"nome":"Oria","cap":["72024"],"district":"BR","districtName":"Brindisi"},{"nome":"Oricola","cap":["67063"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Origgio","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Orino","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Orio al Serio","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Orio Canavese","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Orio Litta","cap":["26863"],"district":"LO","districtName":"Lodi"},{"nome":"Oriolo","cap":["87073"],"district":"CS","districtName":"Cosenza"},{"nome":"Oriolo Romano","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Oristano","cap":["09170"],"district":"OR","districtName":"Oristano"},{"nome":"Ormea","cap":["12078"],"district":"CN","districtName":"Cuneo"},{"nome":"Ormelle","cap":["31024"],"district":"TV","districtName":"Treviso"},{"nome":"Ornago","cap":["20876"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Ornavasso","cap":["28877"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Ornica","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Orosei","cap":["08028"],"district":"NU","districtName":"Nuoro"},{"nome":"Orotelli","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Orria","cap":["84060"],"district":"SA","districtName":"Salerno"},{"nome":"Orroli","cap":["09061"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Orsago","cap":["31010"],"district":"TV","districtName":"Treviso"},{"nome":"Orsara Bormida","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Orsara di Puglia","cap":["71027"],"district":"FG","districtName":"Foggia"},{"nome":"Orsenigo","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Orsogna","cap":["66036"],"district":"CH","districtName":"Chieti"},{"nome":"Orsomarso","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Orta di Atella","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Orta Nova","cap":["71045"],"district":"FG","districtName":"Foggia"},{"nome":"Orta San Giulio","cap":["28016"],"district":"NO","districtName":"Novara"},{"nome":"Ortacesus","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Orte","cap":["01028"],"district":"VT","districtName":"Viterbo"},{"nome":"Ortelle","cap":["73030"],"district":"LE","districtName":"Lecce"},{"nome":"Ortezzano","cap":["63851"],"district":"FM","districtName":"Fermo"},{"nome":"Ortignano Raggiolo","cap":["52010"],"district":"AR","districtName":"Arezzo"},{"nome":"Ortisei","cap":["39046"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Ortona","cap":["66026"],"district":"CH","districtName":"Chieti"},{"nome":"Ortona dei Marsi","cap":["67050"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Ortovero","cap":["17037"],"district":"SV","districtName":"Savona"},{"nome":"Ortucchio","cap":["67050"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Ortueri","cap":["08036"],"district":"NU","districtName":"Nuoro"},{"nome":"Orune","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Orvieto","cap":["05018"],"district":"TR","districtName":"Terni"},{"nome":"Orvinio","cap":["02035"],"district":"RI","districtName":"Rieti"},{"nome":"Orzinuovi","cap":["25034"],"district":"BS","districtName":"Brescia"},{"nome":"Orzivecchi","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Osasco","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Osasio","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Oschiri","cap":["07027"],"district":"SS","districtName":"Sassari"},{"nome":"Osidda","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Osiglia","cap":["17010"],"district":"SV","districtName":"Savona"},{"nome":"Osilo","cap":["07033"],"district":"SS","districtName":"Sassari"},{"nome":"Osimo","cap":["60027"],"district":"AN","districtName":"Ancona"},{"nome":"Osini","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Osio Sopra","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Osio Sotto","cap":["24046"],"district":"BG","districtName":"Bergamo"},{"nome":"Osnago","cap":["23875"],"district":"LC","districtName":"Lecco"},{"nome":"Osoppo","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Ospedaletti","cap":["18014"],"district":"IM","districtName":"Imperia"},{"nome":"Ospedaletto","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Ospedaletto d'Alpinolo","cap":["83014"],"district":"AV","districtName":"Avellino"},{"nome":"Ospedaletto Euganeo","cap":["35045"],"district":"PD","districtName":"Padova"},{"nome":"Ospedaletto Lodigiano","cap":["26864"],"district":"LO","districtName":"Lodi"},{"nome":"Ospitale di Cadore","cap":["32010"],"district":"BL","districtName":"Belluno"},{"nome":"Ospitaletto","cap":["25035"],"district":"BS","districtName":"Brescia"},{"nome":"Ossago Lodigiano","cap":["26816"],"district":"LO","districtName":"Lodi"},{"nome":"Ossana","cap":["38026"],"district":"TN","districtName":"Trento"},{"nome":"Ossi","cap":["07045"],"district":"SS","districtName":"Sassari"},{"nome":"Ossimo","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Ossona","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Ostana","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Ostellato","cap":["44020"],"district":"FE","districtName":"Ferrara"},{"nome":"Ostiano","cap":["26032"],"district":"CR","districtName":"Cremona"},{"nome":"Ostiglia","cap":["46035"],"district":"MN","districtName":"Mantova"},{"nome":"Ostra","cap":["60010"],"district":"AN","districtName":"Ancona"},{"nome":"Ostra Vetere","cap":["60010"],"district":"AN","districtName":"Ancona"},{"nome":"Ostuni","cap":["72017"],"district":"BR","districtName":"Brindisi"},{"nome":"Otranto","cap":["73028"],"district":"LE","districtName":"Lecce"},{"nome":"Otricoli","cap":["05030"],"district":"TR","districtName":"Terni"},{"nome":"Ottana","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Ottati","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Ottaviano","cap":["80044"],"district":"NA","districtName":"Napoli"},{"nome":"Ottiglio","cap":["15038"],"district":"AL","districtName":"Alessandria"},{"nome":"Ottobiano","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Ottone","cap":["29026"],"district":"PC","districtName":"Piacenza"},{"nome":"Oulx","cap":["10056"],"district":"TO","districtName":"Torino"},{"nome":"Ovada","cap":["15076"],"district":"AL","districtName":"Alessandria"},{"nome":"Ovaro","cap":["33025"],"district":"UD","districtName":"Udine"},{"nome":"Oviglio","cap":["15026"],"district":"AL","districtName":"Alessandria"},{"nome":"Ovindoli","cap":["67046"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Ovodda","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Oyace","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Ozegna","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Ozieri","cap":["07014"],"district":"SS","districtName":"Sassari"},{"nome":"Ozzano dell'Emilia","cap":["40064"],"district":"BO","districtName":"Bologna"},{"nome":"Ozzano Monferrato","cap":["15039"],"district":"AL","districtName":"Alessandria"},{"nome":"Ozzero","cap":["20080"],"district":"MI","districtName":"Milano"},{"nome":"Pabillonis","cap":["09030"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Pace del Mela","cap":["98042"],"district":"ME","districtName":"Messina"},{"nome":"Paceco","cap":["91027"],"district":"TP","districtName":"Trapani"},{"nome":"Pacentro","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Pachino","cap":["96018"],"district":"SR","districtName":"Siracusa"},{"nome":"Paciano","cap":["06060"],"district":"PG","districtName":"Perugia"},{"nome":"Padenghe sul Garda","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Paderna","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Paderno d'Adda","cap":["23877"],"district":"LC","districtName":"Lecco"},{"nome":"Paderno Dugnano","cap":["20037"],"district":"MI","districtName":"Milano"},{"nome":"Paderno Franciacorta","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Paderno Ponchielli","cap":["26024"],"district":"CR","districtName":"Cremona"},{"nome":"Padova","cap":["35121","35122","35123","35124","35125","35126","35127","35128","35129","35130","35131","35132","35133","35134","35135","35136","35137","35138","35139","35140","35141","35142","35143"],"district":"PD","districtName":"Padova"},{"nome":"Padria","cap":["07015"],"district":"SS","districtName":"Sassari"},{"nome":"Padru","cap":["07020"],"district":"SS","districtName":"Sassari"},{"nome":"Padula","cap":["84034"],"district":"SA","districtName":"Salerno"},{"nome":"Paduli","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Paesana","cap":["12034"],"district":"CN","districtName":"Cuneo"},{"nome":"Paese","cap":["31038"],"district":"TV","districtName":"Treviso"},{"nome":"Pagani","cap":["84016"],"district":"SA","districtName":"Salerno"},{"nome":"Paganico Sabino","cap":["02020"],"district":"RI","districtName":"Rieti"},{"nome":"Pagazzano","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Pagliara","cap":["98020"],"district":"ME","districtName":"Messina"},{"nome":"Paglieta","cap":["66020"],"district":"CH","districtName":"Chieti"},{"nome":"Pagnacco","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Pagno","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Pagnona","cap":["23833"],"district":"LC","districtName":"Lecco"},{"nome":"Pago del Vallo di Lauro","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Pago Veiano","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Paisco Loveno","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Paitone","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Paladina","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Palagano","cap":["41046"],"district":"MO","districtName":"Modena"},{"nome":"Palagianello","cap":["74018"],"district":"TA","districtName":"Taranto"},{"nome":"Palagiano","cap":["74019"],"district":"TA","districtName":"Taranto"},{"nome":"Palagonia","cap":["95046"],"district":"CT","districtName":"Catania"},{"nome":"Palaia","cap":["56036"],"district":"PI","districtName":"Pisa"},{"nome":"Palanzano","cap":["43025"],"district":"PR","districtName":"Parma"},{"nome":"Palata","cap":["86037"],"district":"CB","districtName":"Campobasso"},{"nome":"Palau","cap":["07020"],"district":"SS","districtName":"Sassari"},{"nome":"Palazzago","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Palazzo Adriano","cap":["90030"],"district":"PA","districtName":"Palermo"},{"nome":"Palazzo Canavese","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Palazzo Pignano","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Palazzo San Gervasio","cap":["85026"],"district":"PZ","districtName":"Potenza"},{"nome":"Palazzolo Acreide","cap":["96010"],"district":"SR","districtName":"Siracusa"},{"nome":"Palazzolo dello Stella","cap":["33056"],"district":"UD","districtName":"Udine"},{"nome":"Palazzolo sull'Oglio","cap":["25036"],"district":"BS","districtName":"Brescia"},{"nome":"Palazzolo Vercellese","cap":["13040"],"district":"VC","districtName":"Vercelli"},{"nome":"Palazzuolo sul Senio","cap":["50035"],"district":"FI","districtName":"Firenze"},{"nome":"Palena","cap":["66017"],"district":"CH","districtName":"Chieti"},{"nome":"Palermiti","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Palermo","cap":["90121","90122","90123","90124","90125","90126","90127","90128","90129","90130","90131","90132","90133","90134","90135","90136","90137","90138","90139","90140","90141","90142","90143","90144","90145","90146","90147","90148","90149","90150","90151"],"district":"PA","districtName":"Palermo"},{"nome":"Palestrina","cap":["00036"],"district":"RM","districtName":"Roma"},{"nome":"Palestro","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Paliano","cap":["03018"],"district":"FR","districtName":"Frosinone"},{"nome":"Palizzi","cap":["89038"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Pallagorio","cap":["88818"],"district":"KR","districtName":"Crotone"},{"nome":"Pallanzeno","cap":["28884"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Pallare","cap":["17043"],"district":"SV","districtName":"Savona"},{"nome":"Palma Campania","cap":["80036"],"district":"NA","districtName":"Napoli"},{"nome":"Palma di Montechiaro","cap":["92020"],"district":"AG","districtName":"Agrigento"},{"nome":"Palmanova","cap":["33057"],"district":"UD","districtName":"Udine"},{"nome":"Palmariggi","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Palmas Arborea","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Palmi","cap":["89015"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Palmiano","cap":["63092"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Palmoli","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Palo del Colle","cap":["70027"],"district":"BA","districtName":"Bari"},{"nome":"Palombara Sabina","cap":["00018"],"district":"RM","districtName":"Roma"},{"nome":"Palombaro","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Palomonte","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Palosco","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Palù","cap":["37050"],"district":"VR","districtName":"Verona"},{"nome":"Palù del Fersina","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Paludi","cap":["87060"],"district":"CS","districtName":"Cosenza"},{"nome":"Paluzza","cap":["33026"],"district":"UD","districtName":"Udine"},{"nome":"Pamparato","cap":["12087"],"district":"CN","districtName":"Cuneo"},{"nome":"Pancalieri","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Pancarana","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Panchià","cap":["38030"],"district":"TN","districtName":"Trento"},{"nome":"Pandino","cap":["26025"],"district":"CR","districtName":"Cremona"},{"nome":"Panettieri","cap":["87050"],"district":"CS","districtName":"Cosenza"},{"nome":"Panicale","cap":["06064"],"district":"PG","districtName":"Perugia"},{"nome":"Pannarano","cap":["82017"],"district":"BN","districtName":"Benevento"},{"nome":"Panni","cap":["71020"],"district":"FG","districtName":"Foggia"},{"nome":"Pantelleria","cap":["91017"],"district":"TP","districtName":"Trapani"},{"nome":"Pantigliate","cap":["20090"],"district":"MI","districtName":"Milano"},{"nome":"Paola","cap":["87027"],"district":"CS","districtName":"Cosenza"},{"nome":"Paolisi","cap":["82011"],"district":"BN","districtName":"Benevento"},{"nome":"Papasidero","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Papozze","cap":["45010"],"district":"RO","districtName":"Rovigo"},{"nome":"Parabiago","cap":["20015"],"district":"MI","districtName":"Milano"},{"nome":"Parabita","cap":["73052"],"district":"LE","districtName":"Lecce"},{"nome":"Paratico","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Parcines","cap":["39020"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Parella","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Parenti","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Parete","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Pareto","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Parghelia","cap":["89861"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Parlasco","cap":["23837"],"district":"LC","districtName":"Lecco"},{"nome":"Parma","cap":["43121","43122","43123","43124","43125","43126"],"district":"PR","districtName":"Parma"},{"nome":"Parodi Ligure","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Paroldo","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Parolise","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"Parona","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Parrano","cap":["05010"],"district":"TR","districtName":"Terni"},{"nome":"Parre","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Partanna","cap":["91028"],"district":"TP","districtName":"Trapani"},{"nome":"Partinico","cap":["90047"],"district":"PA","districtName":"Palermo"},{"nome":"Paruzzaro","cap":["28040"],"district":"NO","districtName":"Novara"},{"nome":"Parzanica","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Pasian di Prato","cap":["33037"],"district":"UD","districtName":"Udine"},{"nome":"Pasiano di Pordenone","cap":["33087"],"district":"PN","districtName":"Pordenone"},{"nome":"Paspardo","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Passerano Marmorito","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Passignano sul Trasimeno","cap":["06065"],"district":"PG","districtName":"Perugia"},{"nome":"Passirano","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Pastena","cap":["03020"],"district":"FR","districtName":"Frosinone"},{"nome":"Pastorano","cap":["81050"],"district":"CE","districtName":"Caserta"},{"nome":"Pastrengo","cap":["37010"],"district":"VR","districtName":"Verona"},{"nome":"Pasturana","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Pasturo","cap":["23818"],"district":"LC","districtName":"Lecco"},{"nome":"Paterno","cap":["85050"],"district":"PZ","districtName":"Potenza"},{"nome":"Paternò","cap":["95047"],"district":"CT","districtName":"Catania"},{"nome":"Paterno Calabro","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Paternopoli","cap":["83052"],"district":"AV","districtName":"Avellino"},{"nome":"Patrica","cap":["03010"],"district":"FR","districtName":"Frosinone"},{"nome":"Pattada","cap":["07016"],"district":"SS","districtName":"Sassari"},{"nome":"Patti","cap":["98066"],"district":"ME","districtName":"Messina"},{"nome":"Patù","cap":["73053"],"district":"LE","districtName":"Lecce"},{"nome":"Pau","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Paularo","cap":["33027"],"district":"UD","districtName":"Udine"},{"nome":"Pauli Arbarei","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Paulilatino","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Paullo","cap":["20067"],"district":"MI","districtName":"Milano"},{"nome":"Paupisi","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Pavarolo","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Pavia","cap":["27100"],"district":"PV","districtName":"Pavia"},{"nome":"Pavia di Udine","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Pavone Canavese","cap":["10018"],"district":"TO","districtName":"Torino"},{"nome":"Pavone del Mella","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Pavullo nel Frignano","cap":["41026"],"district":"MO","districtName":"Modena"},{"nome":"Pazzano","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Peccioli","cap":["56037"],"district":"PI","districtName":"Pisa"},{"nome":"Pecetto di Valenza","cap":["15040"],"district":"AL","districtName":"Alessandria"},{"nome":"Pecetto Torinese","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Pedara","cap":["95030"],"district":"CT","districtName":"Catania"},{"nome":"Pedaso","cap":["63827"],"district":"FM","districtName":"Fermo"},{"nome":"Pedavena","cap":["32034"],"district":"BL","districtName":"Belluno"},{"nome":"Pedemonte","cap":["36040"],"district":"VI","districtName":"Vicenza"},{"nome":"Pederobba","cap":["31040"],"district":"TV","districtName":"Treviso"},{"nome":"Pedesina","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Pedivigliano","cap":["87050"],"district":"CS","districtName":"Cosenza"},{"nome":"Pedrengo","cap":["24066"],"district":"BG","districtName":"Bergamo"},{"nome":"Peglio","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Peglio","cap":["61049"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Pegognaga","cap":["46020"],"district":"MN","districtName":"Mantova"},{"nome":"Peia","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Peio","cap":["38024"],"district":"TN","districtName":"Trento"},{"nome":"Pelago","cap":["50060"],"district":"FI","districtName":"Firenze"},{"nome":"Pella","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Pellegrino Parmense","cap":["43047"],"district":"PR","districtName":"Parma"},{"nome":"Pellezzano","cap":["84080"],"district":"SA","districtName":"Salerno"},{"nome":"Pellizzano","cap":["38020"],"district":"TN","districtName":"Trento"},{"nome":"Pelugo","cap":["38079"],"district":"TN","districtName":"Trento"},{"nome":"Penango","cap":["14030"],"district":"AT","districtName":"Asti"},{"nome":"Penna in Teverina","cap":["05028"],"district":"TR","districtName":"Terni"},{"nome":"Penna San Giovanni","cap":["62020"],"district":"MC","districtName":"Macerata"},{"nome":"Penna Sant'Andrea","cap":["64039"],"district":"TE","districtName":"Teramo"},{"nome":"Pennabilli","cap":["47864"],"district":"RN","districtName":"Rimini"},{"nome":"Pennadomo","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Pennapiedimonte","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Penne","cap":["65017"],"district":"PE","districtName":"Pescara"},{"nome":"Pentone","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Perano","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Perarolo di Cadore","cap":["32010"],"district":"BL","districtName":"Belluno"},{"nome":"Perca","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Percile","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Perdasdefogu","cap":["08046"],"district":"NU","districtName":"Nuoro"},{"nome":"Perdaxius","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Perdifumo","cap":["84060"],"district":"SA","districtName":"Salerno"},{"nome":"Pereto","cap":["67064"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Perfugas","cap":["07034"],"district":"SS","districtName":"Sassari"},{"nome":"Pergine Valsugana","cap":["38057"],"district":"TN","districtName":"Trento"},{"nome":"Pergola","cap":["61045"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Perinaldo","cap":["18032"],"district":"IM","districtName":"Imperia"},{"nome":"Perito","cap":["84060"],"district":"SA","districtName":"Salerno"},{"nome":"Perledo","cap":["23828"],"district":"LC","districtName":"Lecco"},{"nome":"Perletto","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Perlo","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Perloz","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Pernumia","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Pero","cap":["20016"],"district":"MI","districtName":"Milano"},{"nome":"Perosa Argentina","cap":["10063"],"district":"TO","districtName":"Torino"},{"nome":"Perosa Canavese","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Perrero","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Persico Dosimo","cap":["26043"],"district":"CR","districtName":"Cremona"},{"nome":"Pertengo","cap":["13030"],"district":"VC","districtName":"Vercelli"},{"nome":"Pertica Alta","cap":["25070"],"district":"BS","districtName":"Brescia"},{"nome":"Pertica Bassa","cap":["25078"],"district":"BS","districtName":"Brescia"},{"nome":"Pertosa","cap":["84030"],"district":"SA","districtName":"Salerno"},{"nome":"Pertusio","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Perugia","cap":["06121","06122","06123","06124","06125","06126","06127","06128","06129","06130","06131","06132","06133","06134","06135"],"district":"PG","districtName":"Perugia"},{"nome":"Pesaro","cap":["61121","61122"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Pescaglia","cap":["55064"],"district":"LU","districtName":"Lucca"},{"nome":"Pescantina","cap":["37026"],"district":"VR","districtName":"Verona"},{"nome":"Pescara","cap":["65121","65122","65123","65124","65125","65126","65127","65128","65129"],"district":"PE","districtName":"Pescara"},{"nome":"Pescarolo ed Uniti","cap":["26033"],"district":"CR","districtName":"Cremona"},{"nome":"Pescasseroli","cap":["67032"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Pescate","cap":["23855"],"district":"LC","districtName":"Lecco"},{"nome":"Pesche","cap":["86090"],"district":"IS","districtName":"Isernia"},{"nome":"Peschici","cap":["71010"],"district":"FG","districtName":"Foggia"},{"nome":"Peschiera Borromeo","cap":["20068"],"district":"MI","districtName":"Milano"},{"nome":"Peschiera del Garda","cap":["37019"],"district":"VR","districtName":"Verona"},{"nome":"Pescia","cap":["51017"],"district":"PT","districtName":"Pistoia"},{"nome":"Pescina","cap":["67057"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Pesco Sannita","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Pescocostanzo","cap":["67033"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Pescolanciano","cap":["86097"],"district":"IS","districtName":"Isernia"},{"nome":"Pescopagano","cap":["85020"],"district":"PZ","districtName":"Potenza"},{"nome":"Pescopennataro","cap":["86080"],"district":"IS","districtName":"Isernia"},{"nome":"Pescorocchiano","cap":["02024"],"district":"RI","districtName":"Rieti"},{"nome":"Pescosansonesco","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Pescosolido","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Pessano con Bornago","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Pessina Cremonese","cap":["26030"],"district":"CR","districtName":"Cremona"},{"nome":"Pessinetto","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Petacciato","cap":["86038"],"district":"CB","districtName":"Campobasso"},{"nome":"Petilia Policastro","cap":["88837"],"district":"KR","districtName":"Crotone"},{"nome":"Petina","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Petralia Soprana","cap":["90026"],"district":"PA","districtName":"Palermo"},{"nome":"Petralia Sottana","cap":["90027"],"district":"PA","districtName":"Palermo"},{"nome":"Petrella Salto","cap":["02025"],"district":"RI","districtName":"Rieti"},{"nome":"Petrella Tifernina","cap":["86024"],"district":"CB","districtName":"Campobasso"},{"nome":"Petriano","cap":["61020"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Petriolo","cap":["62014"],"district":"MC","districtName":"Macerata"},{"nome":"Petritoli","cap":["63848"],"district":"FM","districtName":"Fermo"},{"nome":"Petrizzi","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Petronà","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Petrosino","cap":["91020"],"district":"TP","districtName":"Trapani"},{"nome":"Petruro Irpino","cap":["83010"],"district":"AV","districtName":"Avellino"},{"nome":"Pettenasco","cap":["28028"],"district":"NO","districtName":"Novara"},{"nome":"Pettinengo","cap":["13843"],"district":"BI","districtName":"Biella"},{"nome":"Pettineo","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Pettoranello del Molise","cap":["86090"],"district":"IS","districtName":"Isernia"},{"nome":"Pettorano sul Gizio","cap":["67034"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Pettorazza Grimani","cap":["45010"],"district":"RO","districtName":"Rovigo"},{"nome":"Peveragno","cap":["12016"],"district":"CN","districtName":"Cuneo"},{"nome":"Pezzana","cap":["13010"],"district":"VC","districtName":"Vercelli"},{"nome":"Pezzaze","cap":["25060"],"district":"BS","districtName":"Brescia"},{"nome":"Pezzolo Valle Uzzone","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Piacenza","cap":["29121","29122"],"district":"PC","districtName":"Piacenza"},{"nome":"Piacenza d'Adige","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Piadena Drizzona","cap":["26034"],"district":"CR","districtName":"Cremona"},{"nome":"Piaggine","cap":["84065"],"district":"SA","districtName":"Salerno"},{"nome":"Pian Camuno","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Piana Crixia","cap":["17058"],"district":"SV","districtName":"Savona"},{"nome":"Piana degli Albanesi","cap":["90037"],"district":"PA","districtName":"Palermo"},{"nome":"Piana di Monte Verna","cap":["81013"],"district":"CE","districtName":"Caserta"},{"nome":"Piancastagnaio","cap":["53025"],"district":"SI","districtName":"Siena"},{"nome":"Piancogno","cap":["25052"],"district":"BS","districtName":"Brescia"},{"nome":"Piandimeleto","cap":["61026"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Piane Crati","cap":["87050"],"district":"CS","districtName":"Cosenza"},{"nome":"Pianella","cap":["65019"],"district":"PE","districtName":"Pescara"},{"nome":"Pianello del Lario","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Pianello Val Tidone","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Pianengo","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Pianezza","cap":["10044"],"district":"TO","districtName":"Torino"},{"nome":"Pianezze","cap":["36060"],"district":"VI","districtName":"Vicenza"},{"nome":"Pianfei","cap":["12080"],"district":"CN","districtName":"Cuneo"},{"nome":"Pianico","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Pianiga","cap":["30030"],"district":"VE","districtName":"Venezia"},{"nome":"Piano di Sorrento","cap":["80063"],"district":"NA","districtName":"Napoli"},{"nome":"Pianopoli","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Pianoro","cap":["40065"],"district":"BO","districtName":"Bologna"},{"nome":"Piansano","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Piantedo","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Piario","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Piasco","cap":["12026"],"district":"CN","districtName":"Cuneo"},{"nome":"Piateda","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Piatto","cap":["13844"],"district":"BI","districtName":"Biella"},{"nome":"Piazza al Serchio","cap":["55035"],"district":"LU","districtName":"Lucca"},{"nome":"Piazza Armerina","cap":["94015"],"district":"EN","districtName":"Enna"},{"nome":"Piazza Brembana","cap":["24014"],"district":"BG","districtName":"Bergamo"},{"nome":"Piazzatorre","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Piazzola sul Brenta","cap":["35016"],"district":"PD","districtName":"Padova"},{"nome":"Piazzolo","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Picciano","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Picerno","cap":["85055"],"district":"PZ","districtName":"Potenza"},{"nome":"Picinisco","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Pico","cap":["03020"],"district":"FR","districtName":"Frosinone"},{"nome":"Piea","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Piedicavallo","cap":["13812"],"district":"BI","districtName":"Biella"},{"nome":"Piedimonte Etneo","cap":["95017"],"district":"CT","districtName":"Catania"},{"nome":"Piedimonte Matese","cap":["81016"],"district":"CE","districtName":"Caserta"},{"nome":"Piedimonte San Germano","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Piedimulera","cap":["28885"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Piegaro","cap":["06066"],"district":"PG","districtName":"Perugia"},{"nome":"Pienza","cap":["53026"],"district":"SI","districtName":"Siena"},{"nome":"Pieranica","cap":["26017"],"district":"CR","districtName":"Cremona"},{"nome":"Pietra de' Giorgi","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Pietra Ligure","cap":["17027"],"district":"SV","districtName":"Savona"},{"nome":"Pietra Marazzi","cap":["15040"],"district":"AL","districtName":"Alessandria"},{"nome":"Pietrabbondante","cap":["86085"],"district":"IS","districtName":"Isernia"},{"nome":"Pietrabruna","cap":["18010"],"district":"IM","districtName":"Imperia"},{"nome":"Pietracamela","cap":["64047"],"district":"TE","districtName":"Teramo"},{"nome":"Pietracatella","cap":["86040"],"district":"CB","districtName":"Campobasso"},{"nome":"Pietracupa","cap":["86020"],"district":"CB","districtName":"Campobasso"},{"nome":"Pietradefusi","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Pietraferrazzana","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Pietrafitta","cap":["87050"],"district":"CS","districtName":"Cosenza"},{"nome":"Pietragalla","cap":["85016"],"district":"PZ","districtName":"Potenza"},{"nome":"Pietralunga","cap":["06026"],"district":"PG","districtName":"Perugia"},{"nome":"Pietramelara","cap":["81051"],"district":"CE","districtName":"Caserta"},{"nome":"Pietramontecorvino","cap":["71038"],"district":"FG","districtName":"Foggia"},{"nome":"Pietranico","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Pietrapaola","cap":["87060"],"district":"CS","districtName":"Cosenza"},{"nome":"Pietrapertosa","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Pietraperzia","cap":["94016"],"district":"EN","districtName":"Enna"},{"nome":"Pietraporzio","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Pietraroja","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Pietrarubbia","cap":["61023"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Pietrasanta","cap":["55045"],"district":"LU","districtName":"Lucca"},{"nome":"Pietrastornina","cap":["83015"],"district":"AV","districtName":"Avellino"},{"nome":"Pietravairano","cap":["81040"],"district":"CE","districtName":"Caserta"},{"nome":"Pietrelcina","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Pieve a Nievole","cap":["51018"],"district":"PT","districtName":"Pistoia"},{"nome":"Pieve Albignola","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Pieve d'Olmi","cap":["26040"],"district":"CR","districtName":"Cremona"},{"nome":"Pieve del Cairo","cap":["27037"],"district":"PV","districtName":"Pavia"},{"nome":"Pieve del Grappa","cap":["31017"],"district":"TV","districtName":"Treviso"},{"nome":"Pieve di Bono-Prezzo","cap":["38085"],"district":"TN","districtName":"Trento"},{"nome":"Pieve di Cadore","cap":["32044"],"district":"BL","districtName":"Belluno"},{"nome":"Pieve di Cento","cap":["40066"],"district":"BO","districtName":"Bologna"},{"nome":"Pieve di Soligo","cap":["31053"],"district":"TV","districtName":"Treviso"},{"nome":"Pieve di Teco","cap":["18026"],"district":"IM","districtName":"Imperia"},{"nome":"Pieve Emanuele","cap":["20090"],"district":"MI","districtName":"Milano"},{"nome":"Pieve Fissiraga","cap":["26854"],"district":"LO","districtName":"Lodi"},{"nome":"Pieve Fosciana","cap":["55036"],"district":"LU","districtName":"Lucca"},{"nome":"Pieve Ligure","cap":["16031"],"district":"GE","districtName":"Genova"},{"nome":"Pieve Porto Morone","cap":["27017"],"district":"PV","districtName":"Pavia"},{"nome":"Pieve San Giacomo","cap":["26035"],"district":"CR","districtName":"Cremona"},{"nome":"Pieve Santo Stefano","cap":["52036"],"district":"AR","districtName":"Arezzo"},{"nome":"Pieve Tesino","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Pieve Torina","cap":["62036"],"district":"MC","districtName":"Macerata"},{"nome":"Pieve Vergonte","cap":["28886"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Pievepelago","cap":["41027"],"district":"MO","districtName":"Modena"},{"nome":"Piglio","cap":["03010"],"district":"FR","districtName":"Frosinone"},{"nome":"Pigna","cap":["18037"],"district":"IM","districtName":"Imperia"},{"nome":"Pignataro Interamna","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Pignataro Maggiore","cap":["81052"],"district":"CE","districtName":"Caserta"},{"nome":"Pignola","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Pignone","cap":["19020"],"district":"SP","districtName":"La Spezia"},{"nome":"Pigra","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Pila","cap":["13020"],"district":"VC","districtName":"Vercelli"},{"nome":"Pimentel","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Pimonte","cap":["80050"],"district":"NA","districtName":"Napoli"},{"nome":"Pinarolo Po","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Pinasca","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Pincara","cap":["45020"],"district":"RO","districtName":"Rovigo"},{"nome":"Pinerolo","cap":["10064"],"district":"TO","districtName":"Torino"},{"nome":"Pineto","cap":["64025"],"district":"TE","districtName":"Teramo"},{"nome":"Pino d'Asti","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Pino Torinese","cap":["10025"],"district":"TO","districtName":"Torino"},{"nome":"Pinzano al Tagliamento","cap":["33094"],"district":"PN","districtName":"Pordenone"},{"nome":"Pinzolo","cap":["38086"],"district":"TN","districtName":"Trento"},{"nome":"Piobbico","cap":["61046"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Piobesi d'Alba","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Piobesi Torinese","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Piode","cap":["13020"],"district":"VC","districtName":"Vercelli"},{"nome":"Pioltello","cap":["20096"],"district":"MI","districtName":"Milano"},{"nome":"Piombino","cap":["57025"],"district":"LI","districtName":"Livorno"},{"nome":"Piombino Dese","cap":["35017"],"district":"PD","districtName":"Padova"},{"nome":"Pioraco","cap":["62025"],"district":"MC","districtName":"Macerata"},{"nome":"Piossasco","cap":["10045"],"district":"TO","districtName":"Torino"},{"nome":"Piovà Massaia","cap":["14026"],"district":"AT","districtName":"Asti"},{"nome":"Piove di Sacco","cap":["35028"],"district":"PD","districtName":"Padova"},{"nome":"Piovene Rocchette","cap":["36013"],"district":"VI","districtName":"Vicenza"},{"nome":"Piozzano","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Piozzo","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Piraino","cap":["98060"],"district":"ME","districtName":"Messina"},{"nome":"Pisa","cap":["56121","56122","56123","56124","56125","56126","56127","56128"],"district":"PI","districtName":"Pisa"},{"nome":"Pisano","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Piscina","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Piscinas","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Pisciotta","cap":["84066"],"district":"SA","districtName":"Salerno"},{"nome":"Pisogne","cap":["25055"],"district":"BS","districtName":"Brescia"},{"nome":"Pisoniano","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Pisticci","cap":["75015"],"district":"MT","districtName":"Matera"},{"nome":"Pistoia","cap":["51100"],"district":"PT","districtName":"Pistoia"},{"nome":"Pitigliano","cap":["58017"],"district":"GR","districtName":"Grosseto"},{"nome":"Piubega","cap":["46040"],"district":"MN","districtName":"Mantova"},{"nome":"Piuro","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Piverone","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Pizzale","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Pizzighettone","cap":["26026"],"district":"CR","districtName":"Cremona"},{"nome":"Pizzo","cap":["89812"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Pizzoferrato","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Pizzoli","cap":["67017"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Pizzone","cap":["86071"],"district":"IS","districtName":"Isernia"},{"nome":"Pizzoni","cap":["89834"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Placanica","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Plataci","cap":["87070"],"district":"CS","districtName":"Cosenza"},{"nome":"Platania","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Platì","cap":["89039"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Plaus","cap":["39025"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Plesio","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Ploaghe","cap":["07017"],"district":"SS","districtName":"Sassari"},{"nome":"Plodio","cap":["17043"],"district":"SV","districtName":"Savona"},{"nome":"Pocapaglia","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Pocenia","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Podenzana","cap":["54010"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Podenzano","cap":["29027"],"district":"PC","districtName":"Piacenza"},{"nome":"Pofi","cap":["03026"],"district":"FR","districtName":"Frosinone"},{"nome":"Poggiardo","cap":["73037"],"district":"LE","districtName":"Lecce"},{"nome":"Poggibonsi","cap":["53036"],"district":"SI","districtName":"Siena"},{"nome":"Poggio a Caiano","cap":["59016"],"district":"PO","districtName":"Prato"},{"nome":"Poggio Bustone","cap":["02018"],"district":"RI","districtName":"Rieti"},{"nome":"Poggio Catino","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Poggio Imperiale","cap":["71010"],"district":"FG","districtName":"Foggia"},{"nome":"Poggio Mirteto","cap":["02047"],"district":"RI","districtName":"Rieti"},{"nome":"Poggio Moiano","cap":["02037"],"district":"RI","districtName":"Rieti"},{"nome":"Poggio Nativo","cap":["02030"],"district":"RI","districtName":"Rieti"},{"nome":"Poggio Picenze","cap":["67026"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Poggio Renatico","cap":["44028"],"district":"FE","districtName":"Ferrara"},{"nome":"Poggio Rusco","cap":["46025"],"district":"MN","districtName":"Mantova"},{"nome":"Poggio San Lorenzo","cap":["02030"],"district":"RI","districtName":"Rieti"},{"nome":"Poggio San Marcello","cap":["60030"],"district":"AN","districtName":"Ancona"},{"nome":"Poggio San Vicino","cap":["62021"],"district":"MC","districtName":"Macerata"},{"nome":"Poggio Sannita","cap":["86086"],"district":"IS","districtName":"Isernia"},{"nome":"Poggio Torriana","cap":["47824"],"district":"RN","districtName":"Rimini"},{"nome":"Poggiodomo","cap":["06040"],"district":"PG","districtName":"Perugia"},{"nome":"Poggiofiorito","cap":["66030"],"district":"CH","districtName":"Chieti"},{"nome":"Poggiomarino","cap":["80040"],"district":"NA","districtName":"Napoli"},{"nome":"Poggioreale","cap":["91020"],"district":"TP","districtName":"Trapani"},{"nome":"Poggiorsini","cap":["70020"],"district":"BA","districtName":"Bari"},{"nome":"Poggiridenti","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Pogliano Milanese","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Pognana Lario","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Pognano","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Pogno","cap":["28076"],"district":"NO","districtName":"Novara"},{"nome":"Poirino","cap":["10046"],"district":"TO","districtName":"Torino"},{"nome":"Pojana Maggiore","cap":["36026"],"district":"VI","districtName":"Vicenza"},{"nome":"Polaveno","cap":["25060"],"district":"BS","districtName":"Brescia"},{"nome":"Polcenigo","cap":["33070"],"district":"PN","districtName":"Pordenone"},{"nome":"Polesella","cap":["45038"],"district":"RO","districtName":"Rovigo"},{"nome":"Polesine Zibello","cap":["43016"],"district":"PR","districtName":"Parma"},{"nome":"Poli","cap":["00010"],"district":"RM","districtName":"Roma"},{"nome":"Polia","cap":["89813"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Policoro","cap":["75025"],"district":"MT","districtName":"Matera"},{"nome":"Polignano a Mare","cap":["70044"],"district":"BA","districtName":"Bari"},{"nome":"Polinago","cap":["41040"],"district":"MO","districtName":"Modena"},{"nome":"Polino","cap":["05030"],"district":"TR","districtName":"Terni"},{"nome":"Polistena","cap":["89024"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Polizzi Generosa","cap":["90028"],"district":"PA","districtName":"Palermo"},{"nome":"Polla","cap":["84035"],"district":"SA","districtName":"Salerno"},{"nome":"Pollein","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Pollena Trocchia","cap":["80040"],"district":"NA","districtName":"Napoli"},{"nome":"Pollenza","cap":["62010"],"district":"MC","districtName":"Macerata"},{"nome":"Pollica","cap":["84068"],"district":"SA","districtName":"Salerno"},{"nome":"Pollina","cap":["90010"],"district":"PA","districtName":"Palermo"},{"nome":"Pollone","cap":["13814"],"district":"BI","districtName":"Biella"},{"nome":"Pollutri","cap":["66020"],"district":"CH","districtName":"Chieti"},{"nome":"Polonghera","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Polpenazze del Garda","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Polverara","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Polverigi","cap":["60020"],"district":"AN","districtName":"Ancona"},{"nome":"Pomarance","cap":["56045"],"district":"PI","districtName":"Pisa"},{"nome":"Pomaretto","cap":["10063"],"district":"TO","districtName":"Torino"},{"nome":"Pomarico","cap":["75016"],"district":"MT","districtName":"Matera"},{"nome":"Pomaro Monferrato","cap":["15040"],"district":"AL","districtName":"Alessandria"},{"nome":"Pomarolo","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Pombia","cap":["28050"],"district":"NO","districtName":"Novara"},{"nome":"Pomezia","cap":["00071"],"district":"RM","districtName":"Roma"},{"nome":"Pomigliano d'Arco","cap":["80038"],"district":"NA","districtName":"Napoli"},{"nome":"Pompei","cap":["80045"],"district":"NA","districtName":"Napoli"},{"nome":"Pompeiana","cap":["18015"],"district":"IM","districtName":"Imperia"},{"nome":"Pompiano","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Pomponesco","cap":["46030"],"district":"MN","districtName":"Mantova"},{"nome":"Pompu","cap":["09093"],"district":"OR","districtName":"Oristano"},{"nome":"Poncarale","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Ponderano","cap":["13875"],"district":"BI","districtName":"Biella"},{"nome":"Ponna","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Ponsacco","cap":["56038"],"district":"PI","districtName":"Pisa"},{"nome":"Ponso","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Pont-Canavese","cap":["10085"],"district":"TO","districtName":"Torino"},{"nome":"Pont-Saint-Martin","cap":["11026"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Pontassieve","cap":["50065"],"district":"FI","districtName":"Firenze"},{"nome":"Pontboset","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Ponte","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Ponte Buggianese","cap":["51019"],"district":"PT","districtName":"Pistoia"},{"nome":"Ponte dell'Olio","cap":["29028"],"district":"PC","districtName":"Piacenza"},{"nome":"Ponte di Legno","cap":["25056"],"district":"BS","districtName":"Brescia"},{"nome":"Ponte di Piave","cap":["31047"],"district":"TV","districtName":"Treviso"},{"nome":"Ponte Gardena","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Ponte in Valtellina","cap":["23026"],"district":"SO","districtName":"Sondrio"},{"nome":"Ponte Lambro","cap":["22037"],"district":"CO","districtName":"Como"},{"nome":"Ponte nelle Alpi","cap":["32014"],"district":"BL","districtName":"Belluno"},{"nome":"Ponte Nizza","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Ponte Nossa","cap":["24028"],"district":"BG","districtName":"Bergamo"},{"nome":"Ponte San Nicolò","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Ponte San Pietro","cap":["24036"],"district":"BG","districtName":"Bergamo"},{"nome":"Pontebba","cap":["33016"],"district":"UD","districtName":"Udine"},{"nome":"Pontecagnano Faiano","cap":["84098"],"district":"SA","districtName":"Salerno"},{"nome":"Pontecchio Polesine","cap":["45030"],"district":"RO","districtName":"Rovigo"},{"nome":"Pontechianale","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Pontecorvo","cap":["03037"],"district":"FR","districtName":"Frosinone"},{"nome":"Pontecurone","cap":["15055"],"district":"AL","districtName":"Alessandria"},{"nome":"Pontedassio","cap":["18027"],"district":"IM","districtName":"Imperia"},{"nome":"Pontedera","cap":["56025"],"district":"PI","districtName":"Pisa"},{"nome":"Pontelandolfo","cap":["82027"],"district":"BN","districtName":"Benevento"},{"nome":"Pontelatone","cap":["81040"],"district":"CE","districtName":"Caserta"},{"nome":"Pontelongo","cap":["35029"],"district":"PD","districtName":"Padova"},{"nome":"Pontenure","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Ponteranica","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Pontestura","cap":["15027"],"district":"AL","districtName":"Alessandria"},{"nome":"Pontevico","cap":["25026"],"district":"BS","districtName":"Brescia"},{"nome":"Pontey","cap":["11024"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Ponti","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Ponti sul Mincio","cap":["46040"],"district":"MN","districtName":"Mantova"},{"nome":"Pontida","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Pontinia","cap":["04014"],"district":"LT","districtName":"Latina"},{"nome":"Pontinvrea","cap":["17042"],"district":"SV","districtName":"Savona"},{"nome":"Pontirolo Nuovo","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Pontoglio","cap":["25037"],"district":"BS","districtName":"Brescia"},{"nome":"Pontremoli","cap":["54027"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Ponza","cap":["04027"],"district":"LT","districtName":"Latina"},{"nome":"Ponzano di Fermo","cap":["63845"],"district":"FM","districtName":"Fermo"},{"nome":"Ponzano Monferrato","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Ponzano Romano","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Ponzano Veneto","cap":["31050"],"district":"TV","districtName":"Treviso"},{"nome":"Ponzone","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Popoli","cap":["65026"],"district":"PE","districtName":"Pescara"},{"nome":"Poppi","cap":["52014"],"district":"AR","districtName":"Arezzo"},{"nome":"Porano","cap":["05010"],"district":"TR","districtName":"Terni"},{"nome":"Porcari","cap":["55016"],"district":"LU","districtName":"Lucca"},{"nome":"Porcia","cap":["33080"],"district":"PN","districtName":"Pordenone"},{"nome":"Pordenone","cap":["33170"],"district":"PN","districtName":"Pordenone"},{"nome":"Porlezza","cap":["22018"],"district":"CO","districtName":"Como"},{"nome":"Pornassio","cap":["18024"],"district":"IM","districtName":"Imperia"},{"nome":"Porpetto","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Portacomaro","cap":["14037"],"district":"AT","districtName":"Asti"},{"nome":"Portalbera","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Porte","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Porte di Rendena","cap":["38094"],"district":"TN","districtName":"Trento"},{"nome":"Portici","cap":["80055"],"district":"NA","districtName":"Napoli"},{"nome":"Portico di Caserta","cap":["81050"],"district":"CE","districtName":"Caserta"},{"nome":"Portico e San Benedetto","cap":["47010"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Portigliola","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Porto Azzurro","cap":["57036"],"district":"LI","districtName":"Livorno"},{"nome":"Porto Ceresio","cap":["21050"],"district":"VA","districtName":"Varese"},{"nome":"Porto Cesareo","cap":["73010"],"district":"LE","districtName":"Lecce"},{"nome":"Porto Empedocle","cap":["92014"],"district":"AG","districtName":"Agrigento"},{"nome":"Porto Mantovano","cap":["46047"],"district":"MN","districtName":"Mantova"},{"nome":"Porto Recanati","cap":["62017"],"district":"MC","districtName":"Macerata"},{"nome":"Porto San Giorgio","cap":["63822"],"district":"FM","districtName":"Fermo"},{"nome":"Porto Sant'Elpidio","cap":["63821"],"district":"FM","districtName":"Fermo"},{"nome":"Porto Tolle","cap":["45018"],"district":"RO","districtName":"Rovigo"},{"nome":"Porto Torres","cap":["07046"],"district":"SS","districtName":"Sassari"},{"nome":"Porto Valtravaglia","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Porto Viro","cap":["45014"],"district":"RO","districtName":"Rovigo"},{"nome":"Portobuffolè","cap":["31040"],"district":"TV","districtName":"Treviso"},{"nome":"Portocannone","cap":["86045"],"district":"CB","districtName":"Campobasso"},{"nome":"Portoferraio","cap":["57037"],"district":"LI","districtName":"Livorno"},{"nome":"Portofino","cap":["16034"],"district":"GE","districtName":"Genova"},{"nome":"Portogruaro","cap":["30026"],"district":"VE","districtName":"Venezia"},{"nome":"Portomaggiore","cap":["44015"],"district":"FE","districtName":"Ferrara"},{"nome":"Portopalo di Capo Passero","cap":["96010"],"district":"SR","districtName":"Siracusa"},{"nome":"Portoscuso","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Portovenere","cap":["19025"],"district":"SP","districtName":"La Spezia"},{"nome":"Portula","cap":["13833"],"district":"BI","districtName":"Biella"},{"nome":"Posada","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Posina","cap":["36010"],"district":"VI","districtName":"Vicenza"},{"nome":"Positano","cap":["84017"],"district":"SA","districtName":"Salerno"},{"nome":"Possagno","cap":["31054"],"district":"TV","districtName":"Treviso"},{"nome":"Posta","cap":["02019"],"district":"RI","districtName":"Rieti"},{"nome":"Posta Fibreno","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Postal","cap":["39014"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Postalesio","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Postiglione","cap":["84026"],"district":"SA","districtName":"Salerno"},{"nome":"Postua","cap":["13010"],"district":"VC","districtName":"Vercelli"},{"nome":"Potenza","cap":["85100"],"district":"PZ","districtName":"Potenza"},{"nome":"Potenza Picena","cap":["62018"],"district":"MC","districtName":"Macerata"},{"nome":"Pove del Grappa","cap":["36020"],"district":"VI","districtName":"Vicenza"},{"nome":"Povegliano","cap":["31050"],"district":"TV","districtName":"Treviso"},{"nome":"Povegliano Veronese","cap":["37064"],"district":"VR","districtName":"Verona"},{"nome":"Poviglio","cap":["42028"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Povoletto","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Pozzaglia Sabina","cap":["02030"],"district":"RI","districtName":"Rieti"},{"nome":"Pozzaglio ed Uniti","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Pozzallo","cap":["97016"],"district":"RG","districtName":"Ragusa"},{"nome":"Pozzilli","cap":["86077"],"district":"IS","districtName":"Isernia"},{"nome":"Pozzo d'Adda","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Pozzol Groppo","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Pozzolengo","cap":["25010"],"district":"BS","districtName":"Brescia"},{"nome":"Pozzoleone","cap":["36050"],"district":"VI","districtName":"Vicenza"},{"nome":"Pozzolo Formigaro","cap":["15068"],"district":"AL","districtName":"Alessandria"},{"nome":"Pozzomaggiore","cap":["07018"],"district":"SS","districtName":"Sassari"},{"nome":"Pozzonovo","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Pozzuoli","cap":["80078"],"district":"NA","districtName":"Napoli"},{"nome":"Pozzuolo del Friuli","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Pozzuolo Martesana","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Pradalunga","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Pradamano","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Pradleves","cap":["12027"],"district":"CN","districtName":"Cuneo"},{"nome":"Pragelato","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Praia a Mare","cap":["87028"],"district":"CS","districtName":"Cosenza"},{"nome":"Praiano","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"Pralboino","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Prali","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Pralormo","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Pralungo","cap":["13899"],"district":"BI","districtName":"Biella"},{"nome":"Pramaggiore","cap":["30020"],"district":"VE","districtName":"Venezia"},{"nome":"Pramollo","cap":["10065"],"district":"TO","districtName":"Torino"},{"nome":"Prarolo","cap":["13012"],"district":"VC","districtName":"Vercelli"},{"nome":"Prarostino","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Prasco","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Prascorsano","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Prata Camportaccio","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Prata d'Ansidonia","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Prata di Pordenone","cap":["33080"],"district":"PN","districtName":"Pordenone"},{"nome":"Prata di Principato Ultra","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Prata Sannita","cap":["81010"],"district":"CE","districtName":"Caserta"},{"nome":"Pratella","cap":["81010"],"district":"CE","districtName":"Caserta"},{"nome":"Pratiglione","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Prato","cap":["59100"],"district":"PO","districtName":"Prato"},{"nome":"Prato allo Stelvio","cap":["39026"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Prato Carnico","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Prato Sesia","cap":["28077"],"district":"NO","districtName":"Novara"},{"nome":"Pratola Peligna","cap":["67035"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Pratola Serra","cap":["83039"],"district":"AV","districtName":"Avellino"},{"nome":"Pratovecchio Stia","cap":["52015"],"district":"AR","districtName":"Arezzo"},{"nome":"Pravisdomini","cap":["33076"],"district":"PN","districtName":"Pordenone"},{"nome":"Pray","cap":["13867"],"district":"BI","districtName":"Biella"},{"nome":"Prazzo","cap":["12028"],"district":"CN","districtName":"Cuneo"},{"nome":"Pré-Saint-Didier","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Precenicco","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Preci","cap":["06047"],"district":"PG","districtName":"Perugia"},{"nome":"Predaia","cap":["38012"],"district":"TN","districtName":"Trento"},{"nome":"Predappio","cap":["47016"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Predazzo","cap":["38037"],"district":"TN","districtName":"Trento"},{"nome":"Predoi","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Predore","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Predosa","cap":["15077"],"district":"AL","districtName":"Alessandria"},{"nome":"Preganziol","cap":["31022"],"district":"TV","districtName":"Treviso"},{"nome":"Pregnana Milanese","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Prelà","cap":["18020"],"district":"IM","districtName":"Imperia"},{"nome":"Premana","cap":["23834"],"district":"LC","districtName":"Lecco"},{"nome":"Premariacco","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Premeno","cap":["28818"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Premia","cap":["28866"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Premilcuore","cap":["47010"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Premolo","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Premosello-Chiovenda","cap":["28803"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Preone","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Prepotto","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Preseglie","cap":["25070"],"district":"BS","districtName":"Brescia"},{"nome":"Presenzano","cap":["81050"],"district":"CE","districtName":"Caserta"},{"nome":"Presezzo","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Presicce-Acquarica","cap":["73054"],"district":"LE","districtName":"Lecce"},{"nome":"Pressana","cap":["37040"],"district":"VR","districtName":"Verona"},{"nome":"Pretoro","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Prevalle","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Prezza","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Priero","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Prignano Cilento","cap":["84060"],"district":"SA","districtName":"Salerno"},{"nome":"Prignano sulla Secchia","cap":["41048"],"district":"MO","districtName":"Modena"},{"nome":"Primaluna","cap":["23819"],"district":"LC","districtName":"Lecco"},{"nome":"Primiero San Martino di Castrozza","cap":["38054"],"district":"TN","districtName":"Trento"},{"nome":"Priocca","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Priola","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Priolo Gargallo","cap":["96010"],"district":"SR","districtName":"Siracusa"},{"nome":"Priverno","cap":["04015"],"district":"LT","districtName":"Latina"},{"nome":"Prizzi","cap":["90038"],"district":"PA","districtName":"Palermo"},{"nome":"Proceno","cap":["01020"],"district":"VT","districtName":"Viterbo"},{"nome":"Procida","cap":["80079"],"district":"NA","districtName":"Napoli"},{"nome":"Propata","cap":["16027"],"district":"GE","districtName":"Genova"},{"nome":"Proserpio","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Prossedi","cap":["04010"],"district":"LT","districtName":"Latina"},{"nome":"Provaglio d'Iseo","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Provaglio Val Sabbia","cap":["25070"],"district":"BS","districtName":"Brescia"},{"nome":"Proves","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Provvidenti","cap":["86040"],"district":"CB","districtName":"Campobasso"},{"nome":"Prunetto","cap":["12077"],"district":"CN","districtName":"Cuneo"},{"nome":"Puegnago del Garda","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Puglianello","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Pula","cap":["09050"],"district":"CA","districtName":"Cagliari"},{"nome":"Pulfero","cap":["33046"],"district":"UD","districtName":"Udine"},{"nome":"Pulsano","cap":["74026"],"district":"TA","districtName":"Taranto"},{"nome":"Pumenengo","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Pusiano","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Putifigari","cap":["07040"],"district":"SS","districtName":"Sassari"},{"nome":"Putignano","cap":["70017"],"district":"BA","districtName":"Bari"},{"nome":"Quadrelle","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Quadri","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Quagliuzzo","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Qualiano","cap":["80019"],"district":"NA","districtName":"Napoli"},{"nome":"Quaranti","cap":["14040"],"district":"AT","districtName":"Asti"},{"nome":"Quaregna Cerreto","cap":["13854"],"district":"BI","districtName":"Biella"},{"nome":"Quargnento","cap":["15044"],"district":"AL","districtName":"Alessandria"},{"nome":"Quarna Sopra","cap":["28898"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Quarna Sotto","cap":["28896"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Quarona","cap":["13017"],"district":"VC","districtName":"Vercelli"},{"nome":"Quarrata","cap":["51039"],"district":"PT","districtName":"Pistoia"},{"nome":"Quart","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Quarto","cap":["80010"],"district":"NA","districtName":"Napoli"},{"nome":"Quarto d'Altino","cap":["30020"],"district":"VE","districtName":"Venezia"},{"nome":"Quartu Sant'Elena","cap":["09045"],"district":"CA","districtName":"Cagliari"},{"nome":"Quartucciu","cap":["09044"],"district":"CA","districtName":"Cagliari"},{"nome":"Quassolo","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Quattordio","cap":["15028"],"district":"AL","districtName":"Alessandria"},{"nome":"Quattro Castella","cap":["42020"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Quero Vas","cap":["32038"],"district":"BL","districtName":"Belluno"},{"nome":"Quiliano","cap":["17047"],"district":"SV","districtName":"Savona"},{"nome":"Quincinetto","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Quindici","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Quingentole","cap":["46020"],"district":"MN","districtName":"Mantova"},{"nome":"Quintano","cap":["26017"],"district":"CR","districtName":"Cremona"},{"nome":"Quinto di Treviso","cap":["31055"],"district":"TV","districtName":"Treviso"},{"nome":"Quinto Vercellese","cap":["13030"],"district":"VC","districtName":"Vercelli"},{"nome":"Quinto Vicentino","cap":["36050"],"district":"VI","districtName":"Vicenza"},{"nome":"Quinzano d'Oglio","cap":["25027"],"district":"BS","districtName":"Brescia"},{"nome":"Quistello","cap":["46026"],"district":"MN","districtName":"Mantova"},{"nome":"Rabbi","cap":["38020"],"district":"TN","districtName":"Trento"},{"nome":"Racale","cap":["73055"],"district":"LE","districtName":"Lecce"},{"nome":"Racalmuto","cap":["92020"],"district":"AG","districtName":"Agrigento"},{"nome":"Racconigi","cap":["12035"],"district":"CN","districtName":"Cuneo"},{"nome":"Raccuja","cap":["98067"],"district":"ME","districtName":"Messina"},{"nome":"Racines","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Radda in Chianti","cap":["53017"],"district":"SI","districtName":"Siena"},{"nome":"Raddusa","cap":["95040"],"district":"CT","districtName":"Catania"},{"nome":"Radicofani","cap":["53040"],"district":"SI","districtName":"Siena"},{"nome":"Radicondoli","cap":["53030"],"district":"SI","districtName":"Siena"},{"nome":"Raffadali","cap":["92015"],"district":"AG","districtName":"Agrigento"},{"nome":"Ragalna","cap":["95030"],"district":"CT","districtName":"Catania"},{"nome":"Ragogna","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"Ragusa","cap":["97100"],"district":"RG","districtName":"Ragusa"},{"nome":"Raiano","cap":["67027"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Ramacca","cap":["95040"],"district":"CT","districtName":"Catania"},{"nome":"Rancio Valcuvia","cap":["21030"],"district":"VA","districtName":"Varese"},{"nome":"Ranco","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Randazzo","cap":["95036"],"district":"CT","districtName":"Catania"},{"nome":"Ranica","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Ranzanico","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Ranzo","cap":["18020"],"district":"IM","districtName":"Imperia"},{"nome":"Rapagnano","cap":["63831"],"district":"FM","districtName":"Fermo"},{"nome":"Rapallo","cap":["16035"],"district":"GE","districtName":"Genova"},{"nome":"Rapino","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Rapolano Terme","cap":["53040"],"district":"SI","districtName":"Siena"},{"nome":"Rapolla","cap":["85027"],"district":"PZ","districtName":"Potenza"},{"nome":"Rapone","cap":["85020"],"district":"PZ","districtName":"Potenza"},{"nome":"Rassa","cap":["13020"],"district":"VC","districtName":"Vercelli"},{"nome":"Rasun-Anterselva","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Rasura","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Ravanusa","cap":["92029"],"district":"AG","districtName":"Agrigento"},{"nome":"Ravarino","cap":["41017"],"district":"MO","districtName":"Modena"},{"nome":"Ravascletto","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Ravello","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"Ravenna","cap":["48121","48122","48123","48124","48125"],"district":"RA","districtName":"Ravenna"},{"nome":"Raveo","cap":["33029"],"district":"UD","districtName":"Udine"},{"nome":"Raviscanina","cap":["81017"],"district":"CE","districtName":"Caserta"},{"nome":"Re","cap":["28856"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Rea","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Realmonte","cap":["92010"],"district":"AG","districtName":"Agrigento"},{"nome":"Reana del Rojale","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Reano","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Recale","cap":["81020"],"district":"CE","districtName":"Caserta"},{"nome":"Recanati","cap":["62019"],"district":"MC","districtName":"Macerata"},{"nome":"Recco","cap":["16036"],"district":"GE","districtName":"Genova"},{"nome":"Recetto","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"Recoaro Terme","cap":["36076"],"district":"VI","districtName":"Vicenza"},{"nome":"Redavalle","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Redondesco","cap":["46010"],"district":"MN","districtName":"Mantova"},{"nome":"Refrancore","cap":["14030"],"district":"AT","districtName":"Asti"},{"nome":"Refrontolo","cap":["31020"],"district":"TV","districtName":"Treviso"},{"nome":"Regalbuto","cap":["94017"],"district":"EN","districtName":"Enna"},{"nome":"Reggello","cap":["50066"],"district":"FI","districtName":"Firenze"},{"nome":"Reggio di Calabria","cap":["89121","89122","89123","89124","89125","89126","89127","89128","89129","89130","89131","89132","89133","89134","89135"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Reggio nell'Emilia","cap":["42121","42122","42123","42124"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Reggiolo","cap":["42046"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Reino","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Reitano","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Remanzacco","cap":["33047"],"district":"UD","districtName":"Udine"},{"nome":"Remedello","cap":["25010"],"district":"BS","districtName":"Brescia"},{"nome":"Renate","cap":["20838"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Rende","cap":["87036"],"district":"CS","districtName":"Cosenza"},{"nome":"Renon","cap":["39054"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Resana","cap":["31023"],"district":"TV","districtName":"Treviso"},{"nome":"Rescaldina","cap":["20027"],"district":"MI","districtName":"Milano"},{"nome":"Resia","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Resiutta","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Resuttano","cap":["93010"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Retorbido","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Revello","cap":["12036"],"district":"CN","districtName":"Cuneo"},{"nome":"Revigliasco d'Asti","cap":["14010"],"district":"AT","districtName":"Asti"},{"nome":"Revine Lago","cap":["31020"],"district":"TV","districtName":"Treviso"},{"nome":"Rezzago","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Rezzato","cap":["25086"],"district":"BS","districtName":"Brescia"},{"nome":"Rezzo","cap":["18026"],"district":"IM","districtName":"Imperia"},{"nome":"Rezzoaglio","cap":["16048"],"district":"GE","districtName":"Genova"},{"nome":"Rhêmes-Notre-Dame","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Rhêmes-Saint-Georges","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Rho","cap":["20017"],"district":"MI","districtName":"Milano"},{"nome":"Riace","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Rialto","cap":["17020"],"district":"SV","districtName":"Savona"},{"nome":"Riano","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Riardo","cap":["81053"],"district":"CE","districtName":"Caserta"},{"nome":"Ribera","cap":["92016"],"district":"AG","districtName":"Agrigento"},{"nome":"Ribordone","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Ricadi","cap":["89866"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Ricaldone","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Riccia","cap":["86016"],"district":"CB","districtName":"Campobasso"},{"nome":"Riccione","cap":["47838"],"district":"RN","districtName":"Rimini"},{"nome":"Riccò del Golfo di Spezia","cap":["19020"],"district":"SP","districtName":"La Spezia"},{"nome":"Ricengo","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Ricigliano","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Riese Pio X","cap":["31039"],"district":"TV","districtName":"Treviso"},{"nome":"Riesi","cap":["93016"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Rieti","cap":["02100"],"district":"RI","districtName":"Rieti"},{"nome":"Rifiano","cap":["39010"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Rifreddo","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Rignano Flaminio","cap":["00068"],"district":"RM","districtName":"Roma"},{"nome":"Rignano Garganico","cap":["71010"],"district":"FG","districtName":"Foggia"},{"nome":"Rignano sull'Arno","cap":["50067"],"district":"FI","districtName":"Firenze"},{"nome":"Rigolato","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Rimella","cap":["13020"],"district":"VC","districtName":"Vercelli"},{"nome":"Rimini","cap":["47921","47922","47923","47924"],"district":"RN","districtName":"Rimini"},{"nome":"Rio","cap":["57038"],"district":"LI","districtName":"Livorno"},{"nome":"Rio di Pusteria","cap":["39037"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Rio Saliceto","cap":["42010"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Riofreddo","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Riola Sardo","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Riolo Terme","cap":["48025"],"district":"RA","districtName":"Ravenna"},{"nome":"Riolunato","cap":["41020"],"district":"MO","districtName":"Modena"},{"nome":"Riomaggiore","cap":["19017"],"district":"SP","districtName":"La Spezia"},{"nome":"Rionero in Vulture","cap":["85028"],"district":"PZ","districtName":"Potenza"},{"nome":"Rionero Sannitico","cap":["86087"],"district":"IS","districtName":"Isernia"},{"nome":"Ripa Teatina","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Ripabottoni","cap":["86040"],"district":"CB","districtName":"Campobasso"},{"nome":"Ripacandida","cap":["85020"],"district":"PZ","districtName":"Potenza"},{"nome":"Ripalimosani","cap":["86025"],"district":"CB","districtName":"Campobasso"},{"nome":"Ripalta Arpina","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Ripalta Cremasca","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Ripalta Guerina","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Riparbella","cap":["56046"],"district":"PI","districtName":"Pisa"},{"nome":"Ripatransone","cap":["63065"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Ripe San Ginesio","cap":["62020"],"district":"MC","districtName":"Macerata"},{"nome":"Ripi","cap":["03027"],"district":"FR","districtName":"Frosinone"},{"nome":"Riposto","cap":["95018"],"district":"CT","districtName":"Catania"},{"nome":"Rittana","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Riva del Garda","cap":["38066"],"district":"TN","districtName":"Trento"},{"nome":"Riva del Po","cap":["44033"],"district":"FE","districtName":"Ferrara"},{"nome":"Riva di Solto","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Riva Ligure","cap":["18015"],"district":"IM","districtName":"Imperia"},{"nome":"Riva presso Chieri","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Rivalba","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Rivalta Bormida","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Rivalta di Torino","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Rivamonte Agordino","cap":["32020"],"district":"BL","districtName":"Belluno"},{"nome":"Rivanazzano Terme","cap":["27055"],"district":"PV","districtName":"Pavia"},{"nome":"Rivara","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Rivarolo Canavese","cap":["10086"],"district":"TO","districtName":"Torino"},{"nome":"Rivarolo del Re ed Uniti","cap":["26036"],"district":"CR","districtName":"Cremona"},{"nome":"Rivarolo Mantovano","cap":["46017"],"district":"MN","districtName":"Mantova"},{"nome":"Rivarone","cap":["15040"],"district":"AL","districtName":"Alessandria"},{"nome":"Rivarossa","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Rive","cap":["13030"],"district":"VC","districtName":"Vercelli"},{"nome":"Rive d'Arcano","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"Rivello","cap":["85040"],"district":"PZ","districtName":"Potenza"},{"nome":"Rivergaro","cap":["29029"],"district":"PC","districtName":"Piacenza"},{"nome":"Rivignano Teor","cap":["33061"],"district":"UD","districtName":"Udine"},{"nome":"Rivisondoli","cap":["67036"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Rivodutri","cap":["02010"],"district":"RI","districtName":"Rieti"},{"nome":"Rivoli","cap":["10098"],"district":"TO","districtName":"Torino"},{"nome":"Rivoli Veronese","cap":["37010"],"district":"VR","districtName":"Verona"},{"nome":"Rivolta d'Adda","cap":["26027"],"district":"CR","districtName":"Cremona"},{"nome":"Rizziconi","cap":["89016"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Roana","cap":["36010"],"district":"VI","districtName":"Vicenza"},{"nome":"Roaschia","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Roascio","cap":["12073"],"district":"CN","districtName":"Cuneo"},{"nome":"Roasio","cap":["13060"],"district":"VC","districtName":"Vercelli"},{"nome":"Roatto","cap":["14018"],"district":"AT","districtName":"Asti"},{"nome":"Robassomero","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Robbiate","cap":["23899"],"district":"LC","districtName":"Lecco"},{"nome":"Robbio","cap":["27038"],"district":"PV","districtName":"Pavia"},{"nome":"Robecchetto con Induno","cap":["20020"],"district":"MI","districtName":"Milano"},{"nome":"Robecco d'Oglio","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Robecco Pavese","cap":["27042"],"district":"PV","districtName":"Pavia"},{"nome":"Robecco sul Naviglio","cap":["20087"],"district":"MI","districtName":"Milano"},{"nome":"Robella","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Robilante","cap":["12017"],"district":"CN","districtName":"Cuneo"},{"nome":"Roburent","cap":["12080"],"district":"CN","districtName":"Cuneo"},{"nome":"Rocca Canavese","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Rocca Canterano","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Rocca Cigliè","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Rocca d'Arazzo","cap":["14030"],"district":"AT","districtName":"Asti"},{"nome":"Rocca d'Arce","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Rocca d'Evandro","cap":["81040"],"district":"CE","districtName":"Caserta"},{"nome":"Rocca de' Baldi","cap":["12047"],"district":"CN","districtName":"Cuneo"},{"nome":"Rocca de' Giorgi","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Rocca di Botte","cap":["67066"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Rocca di Cambio","cap":["67047"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Rocca di Cave","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"Rocca di Mezzo","cap":["67048"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Rocca di Neto","cap":["88821"],"district":"KR","districtName":"Crotone"},{"nome":"Rocca di Papa","cap":["00040"],"district":"RM","districtName":"Roma"},{"nome":"Rocca Grimalda","cap":["15078"],"district":"AL","districtName":"Alessandria"},{"nome":"Rocca Imperiale","cap":["87074"],"district":"CS","districtName":"Cosenza"},{"nome":"Rocca Massima","cap":["04010"],"district":"LT","districtName":"Latina"},{"nome":"Rocca Pia","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Rocca Pietore","cap":["32023"],"district":"BL","districtName":"Belluno"},{"nome":"Rocca Priora","cap":["00079"],"district":"RM","districtName":"Roma"},{"nome":"Rocca San Casciano","cap":["47017"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Rocca San Felice","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"Rocca San Giovanni","cap":["66020"],"district":"CH","districtName":"Chieti"},{"nome":"Rocca Santa Maria","cap":["64010"],"district":"TE","districtName":"Teramo"},{"nome":"Rocca Santo Stefano","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"Rocca Sinibalda","cap":["02026"],"district":"RI","districtName":"Rieti"},{"nome":"Rocca Susella","cap":["27052"],"district":"PV","districtName":"Pavia"},{"nome":"Roccabascerana","cap":["83016"],"district":"AV","districtName":"Avellino"},{"nome":"Roccabernarda","cap":["88835"],"district":"KR","districtName":"Crotone"},{"nome":"Roccabianca","cap":["43010"],"district":"PR","districtName":"Parma"},{"nome":"Roccabruna","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Roccacasale","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Roccadaspide","cap":["84069"],"district":"SA","districtName":"Salerno"},{"nome":"Roccafiorita","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Roccafluvione","cap":["63093"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Roccaforte del Greco","cap":["89060"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Roccaforte Ligure","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Roccaforte Mondovì","cap":["12088"],"district":"CN","districtName":"Cuneo"},{"nome":"Roccaforzata","cap":["74020"],"district":"TA","districtName":"Taranto"},{"nome":"Roccafranca","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Roccagiovine","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Roccagloriosa","cap":["84060"],"district":"SA","districtName":"Salerno"},{"nome":"Roccagorga","cap":["04010"],"district":"LT","districtName":"Latina"},{"nome":"Roccalbegna","cap":["58053"],"district":"GR","districtName":"Grosseto"},{"nome":"Roccalumera","cap":["98027"],"district":"ME","districtName":"Messina"},{"nome":"Roccamandolfi","cap":["86092"],"district":"IS","districtName":"Isernia"},{"nome":"Roccamena","cap":["90040"],"district":"PA","districtName":"Palermo"},{"nome":"Roccamonfina","cap":["81035"],"district":"CE","districtName":"Caserta"},{"nome":"Roccamontepiano","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Roccamorice","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Roccanova","cap":["85036"],"district":"PZ","districtName":"Potenza"},{"nome":"Roccantica","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Roccapalumba","cap":["90020"],"district":"PA","districtName":"Palermo"},{"nome":"Roccapiemonte","cap":["84086"],"district":"SA","districtName":"Salerno"},{"nome":"Roccarainola","cap":["80030"],"district":"NA","districtName":"Napoli"},{"nome":"Roccaraso","cap":["67037"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Roccaromana","cap":["81051"],"district":"CE","districtName":"Caserta"},{"nome":"Roccascalegna","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Roccasecca","cap":["03038"],"district":"FR","districtName":"Frosinone"},{"nome":"Roccasecca dei Volsci","cap":["04010"],"district":"LT","districtName":"Latina"},{"nome":"Roccasicura","cap":["86080"],"district":"IS","districtName":"Isernia"},{"nome":"Roccasparvera","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Roccaspinalveti","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Roccastrada","cap":["58036"],"district":"GR","districtName":"Grosseto"},{"nome":"Roccavaldina","cap":["98040"],"district":"ME","districtName":"Messina"},{"nome":"Roccaverano","cap":["14050"],"district":"AT","districtName":"Asti"},{"nome":"Roccavignale","cap":["17017"],"district":"SV","districtName":"Savona"},{"nome":"Roccavione","cap":["12018"],"district":"CN","districtName":"Cuneo"},{"nome":"Roccavivara","cap":["86020"],"district":"CB","districtName":"Campobasso"},{"nome":"Roccella Ionica","cap":["89047"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Roccella Valdemone","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Rocchetta a Volturno","cap":["86070"],"district":"IS","districtName":"Isernia"},{"nome":"Rocchetta Belbo","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Rocchetta di Vara","cap":["19020"],"district":"SP","districtName":"La Spezia"},{"nome":"Rocchetta e Croce","cap":["81042"],"district":"CE","districtName":"Caserta"},{"nome":"Rocchetta Ligure","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Rocchetta Nervina","cap":["18030"],"district":"IM","districtName":"Imperia"},{"nome":"Rocchetta Palafea","cap":["14042"],"district":"AT","districtName":"Asti"},{"nome":"Rocchetta Sant'Antonio","cap":["71020"],"district":"FG","districtName":"Foggia"},{"nome":"Rocchetta Tanaro","cap":["14030"],"district":"AT","districtName":"Asti"},{"nome":"Rodano","cap":["20090"],"district":"MI","districtName":"Milano"},{"nome":"Roddi","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Roddino","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Rodello","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Rodengo","cap":["39037"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Rodengo Saiano","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Rodero","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Rodi Garganico","cap":["71012"],"district":"FG","districtName":"Foggia"},{"nome":"Rodì Milici","cap":["98059"],"district":"ME","districtName":"Messina"},{"nome":"Rodigo","cap":["46040"],"district":"MN","districtName":"Mantova"},{"nome":"Roè Volciano","cap":["25077"],"district":"BS","districtName":"Brescia"},{"nome":"Rofrano","cap":["84070"],"district":"SA","districtName":"Salerno"},{"nome":"Rogeno","cap":["23849"],"district":"LC","districtName":"Lecco"},{"nome":"Roggiano Gravina","cap":["87017"],"district":"CS","districtName":"Cosenza"},{"nome":"Roghudi","cap":["89060"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Rogliano","cap":["87054"],"district":"CS","districtName":"Cosenza"},{"nome":"Rognano","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Rogno","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Rogolo","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Roiate","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"Roio del Sangro","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Roisan","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Roletto","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Rolo","cap":["42047"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Roma","cap":["00118","00119","00120","00121","00122","00123","00124","00125","00126","00127","00128","00129","00130","00131","00132","00133","00134","00135","00136","00137","00138","00139","00140","00141","00142","00143","00144","00145","00146","00147","00148","00149","00150","00151","00152","00153","00154","00155","00156","00157","00158","00159","00160","00161","00162","00163","00164","00165","00166","00167","00168","00169","00170","00171","00172","00173","00174","00175","00176","00177","00178","00179","00180","00181","00182","00183","00184","00185","00186","00187","00188","00189","00190","00191","00192","00193","00194","00195","00196","00197","00198","00199"],"district":"RM","districtName":"Roma"},{"nome":"Romagnano al Monte","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Romagnano Sesia","cap":["28078"],"district":"NO","districtName":"Novara"},{"nome":"Romagnese","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Romana","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Romanengo","cap":["26014"],"district":"CR","districtName":"Cremona"},{"nome":"Romano Canavese","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Romano d'Ezzelino","cap":["36060"],"district":"VI","districtName":"Vicenza"},{"nome":"Romano di Lombardia","cap":["24058"],"district":"BG","districtName":"Bergamo"},{"nome":"Romans d'Isonzo","cap":["34076"],"district":"GO","districtName":"Gorizia"},{"nome":"Rombiolo","cap":["89841"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Romeno","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Romentino","cap":["28068"],"district":"NO","districtName":"Novara"},{"nome":"Rometta","cap":["98043"],"district":"ME","districtName":"Messina"},{"nome":"Ronago","cap":["22027"],"district":"CO","districtName":"Como"},{"nome":"Roncà","cap":["37030"],"district":"VR","districtName":"Verona"},{"nome":"Roncade","cap":["31056"],"district":"TV","districtName":"Treviso"},{"nome":"Roncadelle","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Roncaro","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Roncegno Terme","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Roncello","cap":["20877"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Ronchi dei Legionari","cap":["34077"],"district":"GO","districtName":"Gorizia"},{"nome":"Ronchi Valsugana","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Ronchis","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Ronciglione","cap":["01037"],"district":"VT","districtName":"Viterbo"},{"nome":"Ronco all'Adige","cap":["37055"],"district":"VR","districtName":"Verona"},{"nome":"Ronco Biellese","cap":["13845"],"district":"BI","districtName":"Biella"},{"nome":"Ronco Briantino","cap":["20885"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Ronco Canavese","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Ronco Scrivia","cap":["16019"],"district":"GE","districtName":"Genova"},{"nome":"Roncobello","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Roncoferraro","cap":["46037"],"district":"MN","districtName":"Mantova"},{"nome":"Roncofreddo","cap":["47020"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Roncola","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Rondanina","cap":["16025"],"district":"GE","districtName":"Genova"},{"nome":"Rondissone","cap":["10030"],"district":"TO","districtName":"Torino"},{"nome":"Ronsecco","cap":["13036"],"district":"VC","districtName":"Vercelli"},{"nome":"Ronzo-Chienis","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Ronzone","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Roppolo","cap":["13883"],"district":"BI","districtName":"Biella"},{"nome":"Rorà","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Rosà","cap":["36027"],"district":"VI","districtName":"Vicenza"},{"nome":"Rosarno","cap":["89025"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Rosasco","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Rosate","cap":["20088"],"district":"MI","districtName":"Milano"},{"nome":"Rosazza","cap":["13815"],"district":"BI","districtName":"Biella"},{"nome":"Rosciano","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Roscigno","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Rose","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Rosello","cap":["66040"],"district":"CH","districtName":"Chieti"},{"nome":"Roseto Capo Spulico","cap":["87070"],"district":"CS","districtName":"Cosenza"},{"nome":"Roseto degli Abruzzi","cap":["64026"],"district":"TE","districtName":"Teramo"},{"nome":"Roseto Valfortore","cap":["71039"],"district":"FG","districtName":"Foggia"},{"nome":"Rosignano Marittimo","cap":["57016"],"district":"LI","districtName":"Livorno"},{"nome":"Rosignano Monferrato","cap":["15030"],"district":"AL","districtName":"Alessandria"},{"nome":"Rosolina","cap":["45010"],"district":"RO","districtName":"Rovigo"},{"nome":"Rosolini","cap":["96019"],"district":"SR","districtName":"Siracusa"},{"nome":"Rosora","cap":["60030"],"district":"AN","districtName":"Ancona"},{"nome":"Rossa","cap":["13020"],"district":"VC","districtName":"Vercelli"},{"nome":"Rossana","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Rossano Veneto","cap":["36028"],"district":"VI","districtName":"Vicenza"},{"nome":"Rossiglione","cap":["16010"],"district":"GE","districtName":"Genova"},{"nome":"Rosta","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Rota d'Imagna","cap":["24037"],"district":"BG","districtName":"Bergamo"},{"nome":"Rota Greca","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Rotella","cap":["63071"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Rotello","cap":["86040"],"district":"CB","districtName":"Campobasso"},{"nome":"Rotonda","cap":["85048"],"district":"PZ","districtName":"Potenza"},{"nome":"Rotondella","cap":["75026"],"district":"MT","districtName":"Matera"},{"nome":"Rotondi","cap":["83017"],"district":"AV","districtName":"Avellino"},{"nome":"Rottofreno","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Rotzo","cap":["36010"],"district":"VI","districtName":"Vicenza"},{"nome":"Roure","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Rovasenda","cap":["13040"],"district":"VC","districtName":"Vercelli"},{"nome":"Rovato","cap":["25038"],"district":"BS","districtName":"Brescia"},{"nome":"Rovegno","cap":["16028"],"district":"GE","districtName":"Genova"},{"nome":"Rovellasca","cap":["22069"],"district":"CO","districtName":"Como"},{"nome":"Rovello Porro","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Roverbella","cap":["46048"],"district":"MN","districtName":"Mantova"},{"nome":"Roverchiara","cap":["37050"],"district":"VR","districtName":"Verona"},{"nome":"Roverè della Luna","cap":["38030"],"district":"TN","districtName":"Trento"},{"nome":"Roverè Veronese","cap":["37028"],"district":"VR","districtName":"Verona"},{"nome":"Roveredo di Guà","cap":["37040"],"district":"VR","districtName":"Verona"},{"nome":"Roveredo in Piano","cap":["33080"],"district":"PN","districtName":"Pordenone"},{"nome":"Rovereto","cap":["38068"],"district":"TN","districtName":"Trento"},{"nome":"Rovescala","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Rovetta","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Roviano","cap":["00027"],"district":"RM","districtName":"Roma"},{"nome":"Rovigo","cap":["45100"],"district":"RO","districtName":"Rovigo"},{"nome":"Rovito","cap":["87050"],"district":"CS","districtName":"Cosenza"},{"nome":"Rovolon","cap":["35030"],"district":"PD","districtName":"Padova"},{"nome":"Rozzano","cap":["20089"],"district":"MI","districtName":"Milano"},{"nome":"Rubano","cap":["35030"],"district":"PD","districtName":"Padova"},{"nome":"Rubiana","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Rubiera","cap":["42048"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Ruda","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Rudiano","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Rueglio","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Ruffano","cap":["73049"],"district":"LE","districtName":"Lecce"},{"nome":"Ruffia","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Ruffrè-Mendola","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Rufina","cap":["50068"],"district":"FI","districtName":"Firenze"},{"nome":"Ruinas","cap":["09085"],"district":"OR","districtName":"Oristano"},{"nome":"Rumo","cap":["38020"],"district":"TN","districtName":"Trento"},{"nome":"Ruoti","cap":["85056"],"district":"PZ","districtName":"Potenza"},{"nome":"Russi","cap":["48026"],"district":"RA","districtName":"Ravenna"},{"nome":"Rutigliano","cap":["70018"],"district":"BA","districtName":"Bari"},{"nome":"Rutino","cap":["84070"],"district":"SA","districtName":"Salerno"},{"nome":"Ruviano","cap":["81010"],"district":"CE","districtName":"Caserta"},{"nome":"Ruvo del Monte","cap":["85020"],"district":"PZ","districtName":"Potenza"},{"nome":"Ruvo di Puglia","cap":["70037"],"district":"BA","districtName":"Bari"},{"nome":"Sabaudia","cap":["04016"],"district":"LT","districtName":"Latina"},{"nome":"Sabbio Chiese","cap":["25070"],"district":"BS","districtName":"Brescia"},{"nome":"Sabbioneta","cap":["46018"],"district":"MN","districtName":"Mantova"},{"nome":"Sacco","cap":["84070"],"district":"SA","districtName":"Salerno"},{"nome":"Saccolongo","cap":["35030"],"district":"PD","districtName":"Padova"},{"nome":"Sacile","cap":["33077"],"district":"PN","districtName":"Pordenone"},{"nome":"Sacrofano","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Sadali","cap":["09062"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Sagama","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Sagliano Micca","cap":["13816"],"district":"BI","districtName":"Biella"},{"nome":"Sagrado","cap":["34078"],"district":"GO","districtName":"Gorizia"},{"nome":"Sagron Mis","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Saint-Christophe","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Saint-Denis","cap":["11023"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Saint-Marcel","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Saint-Nicolas","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Saint-Oyen","cap":["11014"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Saint-Pierre","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Saint-Rhémy-en-Bosses","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Saint-Vincent","cap":["11027"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Sala Baganza","cap":["43038"],"district":"PR","districtName":"Parma"},{"nome":"Sala Biellese","cap":["13884"],"district":"BI","districtName":"Biella"},{"nome":"Sala Bolognese","cap":["40010"],"district":"BO","districtName":"Bologna"},{"nome":"Sala Comacina","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Sala Consilina","cap":["84036"],"district":"SA","districtName":"Salerno"},{"nome":"Sala Monferrato","cap":["15030"],"district":"AL","districtName":"Alessandria"},{"nome":"Salandra","cap":["75017"],"district":"MT","districtName":"Matera"},{"nome":"Salaparuta","cap":["91020"],"district":"TP","districtName":"Trapani"},{"nome":"Salara","cap":["45030"],"district":"RO","districtName":"Rovigo"},{"nome":"Salasco","cap":["13040"],"district":"VC","districtName":"Vercelli"},{"nome":"Salassa","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Salbertrand","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Salcedo","cap":["36040"],"district":"VI","districtName":"Vicenza"},{"nome":"Salcito","cap":["86026"],"district":"CB","districtName":"Campobasso"},{"nome":"Sale","cap":["15045"],"district":"AL","districtName":"Alessandria"},{"nome":"Sale delle Langhe","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Sale Marasino","cap":["25057"],"district":"BS","districtName":"Brescia"},{"nome":"Sale San Giovanni","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Salemi","cap":["91018"],"district":"TP","districtName":"Trapani"},{"nome":"Salento","cap":["84070"],"district":"SA","districtName":"Salerno"},{"nome":"Salerano Canavese","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Salerano sul Lambro","cap":["26857"],"district":"LO","districtName":"Lodi"},{"nome":"Salerno","cap":["84121","84122","84123","84124","84125","84126","84127","84128","84129","84130","84131","84132","84133","84134","84135"],"district":"SA","districtName":"Salerno"},{"nome":"Salgareda","cap":["31040"],"district":"TV","districtName":"Treviso"},{"nome":"Sali Vercellese","cap":["13040"],"district":"VC","districtName":"Vercelli"},{"nome":"Salice Salentino","cap":["73015"],"district":"LE","districtName":"Lecce"},{"nome":"Saliceto","cap":["12079"],"district":"CN","districtName":"Cuneo"},{"nome":"Salisano","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Salizzole","cap":["37056"],"district":"VR","districtName":"Verona"},{"nome":"Salle","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Salmour","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Salò","cap":["25087"],"district":"BS","districtName":"Brescia"},{"nome":"Salorno","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Salsomaggiore Terme","cap":["43039"],"district":"PR","districtName":"Parma"},{"nome":"Saltrio","cap":["21050"],"district":"VA","districtName":"Varese"},{"nome":"Saludecio","cap":["47835"],"district":"RN","districtName":"Rimini"},{"nome":"Saluggia","cap":["13040"],"district":"VC","districtName":"Vercelli"},{"nome":"Salussola","cap":["13885"],"district":"BI","districtName":"Biella"},{"nome":"Saluzzo","cap":["12037"],"district":"CN","districtName":"Cuneo"},{"nome":"Salve","cap":["73050"],"district":"LE","districtName":"Lecce"},{"nome":"Salvirola","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Salvitelle","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Salza di Pinerolo","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Salza Irpina","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"Salzano","cap":["30030"],"district":"VE","districtName":"Venezia"},{"nome":"Samarate","cap":["21017"],"district":"VA","districtName":"Varese"},{"nome":"Samassi","cap":["09030"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Samatzai","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Sambuca di Sicilia","cap":["92017"],"district":"AG","districtName":"Agrigento"},{"nome":"Sambuca Pistoiese","cap":["51020"],"district":"PT","districtName":"Pistoia"},{"nome":"Sambuci","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Sambuco","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Sammichele di Bari","cap":["70010"],"district":"BA","districtName":"Bari"},{"nome":"Samo","cap":["89030"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Samolaco","cap":["23027"],"district":"SO","districtName":"Sondrio"},{"nome":"Samone","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Samone","cap":["38059"],"district":"TN","districtName":"Trento"},{"nome":"Sampeyre","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Samugheo","cap":["09086"],"district":"OR","districtName":"Oristano"},{"nome":"San Bartolomeo al Mare","cap":["18016"],"district":"IM","districtName":"Imperia"},{"nome":"San Bartolomeo in Galdo","cap":["82028"],"district":"BN","districtName":"Benevento"},{"nome":"San Bartolomeo Val Cavargna","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"San Basile","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"San Basilio","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"San Bassano","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"San Bellino","cap":["45020"],"district":"RO","districtName":"Rovigo"},{"nome":"San Benedetto Belbo","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"San Benedetto dei Marsi","cap":["67058"],"district":"AQ","districtName":"L'Aquila"},{"nome":"San Benedetto del Tronto","cap":["63074"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"San Benedetto in Perillis","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"San Benedetto Po","cap":["46027"],"district":"MN","districtName":"Mantova"},{"nome":"San Benedetto Ullano","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"San Benedetto Val di Sambro","cap":["40048"],"district":"BO","districtName":"Bologna"},{"nome":"San Benigno Canavese","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"San Bernardino Verbano","cap":["28804"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"San Biagio della Cima","cap":["18036"],"district":"IM","districtName":"Imperia"},{"nome":"San Biagio di Callalta","cap":["31048"],"district":"TV","districtName":"Treviso"},{"nome":"San Biagio Platani","cap":["92020"],"district":"AG","districtName":"Agrigento"},{"nome":"San Biagio Saracinisco","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"San Biase","cap":["86020"],"district":"CB","districtName":"Campobasso"},{"nome":"San Bonifacio","cap":["37047"],"district":"VR","districtName":"Verona"},{"nome":"San Buono","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"San Calogero","cap":["89842"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"San Candido","cap":["39038"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"San Canzian d'Isonzo","cap":["34075"],"district":"GO","districtName":"Gorizia"},{"nome":"San Carlo Canavese","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"San Casciano dei Bagni","cap":["53040"],"district":"SI","districtName":"Siena"},{"nome":"San Casciano in Val di Pesa","cap":["50026"],"district":"FI","districtName":"Firenze"},{"nome":"San Cassiano","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"San Cataldo","cap":["93017"],"district":"CL","districtName":"Caltanissetta"},{"nome":"San Cesareo","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"San Cesario di Lecce","cap":["73016"],"district":"LE","districtName":"Lecce"},{"nome":"San Cesario sul Panaro","cap":["41018"],"district":"MO","districtName":"Modena"},{"nome":"San Chirico Nuovo","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"San Chirico Raparo","cap":["85030"],"district":"PZ","districtName":"Potenza"},{"nome":"San Cipirello","cap":["90040"],"district":"PA","districtName":"Palermo"},{"nome":"San Cipriano d'Aversa","cap":["81036"],"district":"CE","districtName":"Caserta"},{"nome":"San Cipriano Picentino","cap":["84099"],"district":"SA","districtName":"Salerno"},{"nome":"San Cipriano Po","cap":["27043"],"district":"PV","districtName":"Pavia"},{"nome":"San Clemente","cap":["47832"],"district":"RN","districtName":"Rimini"},{"nome":"San Colombano al Lambro","cap":["20078"],"district":"MI","districtName":"Milano"},{"nome":"San Colombano Belmonte","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"San Colombano Certenoli","cap":["16040"],"district":"GE","districtName":"Genova"},{"nome":"San Cono","cap":["95040"],"district":"CT","districtName":"Catania"},{"nome":"San Cosmo Albanese","cap":["87060"],"district":"CS","districtName":"Cosenza"},{"nome":"San Costantino Albanese","cap":["85030"],"district":"PZ","districtName":"Potenza"},{"nome":"San Costantino Calabro","cap":["89851"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"San Costanzo","cap":["61039"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"San Cristoforo","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"San Damiano al Colle","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"San Damiano d'Asti","cap":["14015"],"district":"AT","districtName":"Asti"},{"nome":"San Damiano Macra","cap":["12029"],"district":"CN","districtName":"Cuneo"},{"nome":"San Daniele del Friuli","cap":["33038"],"district":"UD","districtName":"Udine"},{"nome":"San Daniele Po","cap":["26046"],"district":"CR","districtName":"Cremona"},{"nome":"San Demetrio Corone","cap":["87069"],"district":"CS","districtName":"Cosenza"},{"nome":"San Demetrio ne' Vestini","cap":["67028"],"district":"AQ","districtName":"L'Aquila"},{"nome":"San Didero","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"San Donà di Piave","cap":["30027"],"district":"VE","districtName":"Venezia"},{"nome":"San Donaci","cap":["72025"],"district":"BR","districtName":"Brindisi"},{"nome":"San Donato di Lecce","cap":["73010"],"district":"LE","districtName":"Lecce"},{"nome":"San Donato di Ninea","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"San Donato Milanese","cap":["20097"],"district":"MI","districtName":"Milano"},{"nome":"San Donato Val di Comino","cap":["03046"],"district":"FR","districtName":"Frosinone"},{"nome":"San Dorligo della Valle","cap":["34018"],"district":"TS","districtName":"Trieste"},{"nome":"San Fele","cap":["85020"],"district":"PZ","districtName":"Potenza"},{"nome":"San Felice a Cancello","cap":["81027"],"district":"CE","districtName":"Caserta"},{"nome":"San Felice Circeo","cap":["04017"],"district":"LT","districtName":"Latina"},{"nome":"San Felice del Benaco","cap":["25010"],"district":"BS","districtName":"Brescia"},{"nome":"San Felice del Molise","cap":["86030"],"district":"CB","districtName":"Campobasso"},{"nome":"San Felice sul Panaro","cap":["41038"],"district":"MO","districtName":"Modena"},{"nome":"San Ferdinando","cap":["89026"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"San Ferdinando di Puglia","cap":["76017"],"district":"BT","districtName":"Barletta-Andria-Trani"},{"nome":"San Fermo della Battaglia","cap":["22042"],"district":"CO","districtName":"Como"},{"nome":"San Fili","cap":["87037"],"district":"CS","districtName":"Cosenza"},{"nome":"San Filippo del Mela","cap":["98044"],"district":"ME","districtName":"Messina"},{"nome":"San Fior","cap":["31020"],"district":"TV","districtName":"Treviso"},{"nome":"San Fiorano","cap":["26848"],"district":"LO","districtName":"Lodi"},{"nome":"San Floriano del Collio","cap":["34070"],"district":"GO","districtName":"Gorizia"},{"nome":"San Floro","cap":["88021"],"district":"CZ","districtName":"Catanzaro"},{"nome":"San Francesco al Campo","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"San Fratello","cap":["98075"],"district":"ME","districtName":"Messina"},{"nome":"San Gavino Monreale","cap":["09037"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"San Gemini","cap":["05029"],"district":"TR","districtName":"Terni"},{"nome":"San Genesio Atesino","cap":["39050"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"San Genesio ed Uniti","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"San Gennaro Vesuviano","cap":["80040"],"district":"NA","districtName":"Napoli"},{"nome":"San Germano Chisone","cap":["10065"],"district":"TO","districtName":"Torino"},{"nome":"San Germano Vercellese","cap":["13047"],"district":"VC","districtName":"Vercelli"},{"nome":"San Gervasio Bresciano","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"San Giacomo degli Schiavoni","cap":["86030"],"district":"CB","districtName":"Campobasso"},{"nome":"San Giacomo delle Segnate","cap":["46020"],"district":"MN","districtName":"Mantova"},{"nome":"San Giacomo Filippo","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"San Giacomo Vercellese","cap":["13030"],"district":"VC","districtName":"Vercelli"},{"nome":"San Gillio","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"San Gimignano","cap":["53037"],"district":"SI","districtName":"Siena"},{"nome":"San Ginesio","cap":["62026"],"district":"MC","districtName":"Macerata"},{"nome":"San Giorgio a Cremano","cap":["80046"],"district":"NA","districtName":"Napoli"},{"nome":"San Giorgio a Liri","cap":["03047"],"district":"FR","districtName":"Frosinone"},{"nome":"San Giorgio Albanese","cap":["87060"],"district":"CS","districtName":"Cosenza"},{"nome":"San Giorgio Bigarello","cap":["46051"],"district":"MN","districtName":"Mantova"},{"nome":"San Giorgio Canavese","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"San Giorgio del Sannio","cap":["82018"],"district":"BN","districtName":"Benevento"},{"nome":"San Giorgio della Richinvelda","cap":["33095"],"district":"PN","districtName":"Pordenone"},{"nome":"San Giorgio delle Pertiche","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"San Giorgio di Lomellina","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"San Giorgio di Nogaro","cap":["33058"],"district":"UD","districtName":"Udine"},{"nome":"San Giorgio di Piano","cap":["40016"],"district":"BO","districtName":"Bologna"},{"nome":"San Giorgio in Bosco","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"San Giorgio Ionico","cap":["74027"],"district":"TA","districtName":"Taranto"},{"nome":"San Giorgio La Molara","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"San Giorgio Lucano","cap":["75027"],"district":"MT","districtName":"Matera"},{"nome":"San Giorgio Monferrato","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"San Giorgio Morgeto","cap":["89017"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"San Giorgio Piacentino","cap":["29019"],"district":"PC","districtName":"Piacenza"},{"nome":"San Giorgio Scarampi","cap":["14059"],"district":"AT","districtName":"Asti"},{"nome":"San Giorgio su Legnano","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"San Giorio di Susa","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"San Giovanni a Piro","cap":["84070"],"district":"SA","districtName":"Salerno"},{"nome":"San Giovanni al Natisone","cap":["33048"],"district":"UD","districtName":"Udine"},{"nome":"San Giovanni Bianco","cap":["24015"],"district":"BG","districtName":"Bergamo"},{"nome":"San Giovanni del Dosso","cap":["46020"],"district":"MN","districtName":"Mantova"},{"nome":"San Giovanni di Fassa","cap":["38036"],"district":"TN","districtName":"Trento"},{"nome":"San Giovanni di Gerace","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"San Giovanni Gemini","cap":["92020"],"district":"AG","districtName":"Agrigento"},{"nome":"San Giovanni Ilarione","cap":["37035"],"district":"VR","districtName":"Verona"},{"nome":"San Giovanni in Croce","cap":["26037"],"district":"CR","districtName":"Cremona"},{"nome":"San Giovanni in Fiore","cap":["87055"],"district":"CS","districtName":"Cosenza"},{"nome":"San Giovanni in Galdo","cap":["86010"],"district":"CB","districtName":"Campobasso"},{"nome":"San Giovanni in Marignano","cap":["47842"],"district":"RN","districtName":"Rimini"},{"nome":"San Giovanni in Persiceto","cap":["40017"],"district":"BO","districtName":"Bologna"},{"nome":"San Giovanni Incarico","cap":["03028"],"district":"FR","districtName":"Frosinone"},{"nome":"San Giovanni la Punta","cap":["95037"],"district":"CT","districtName":"Catania"},{"nome":"San Giovanni Lipioni","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"San Giovanni Lupatoto","cap":["37057"],"district":"VR","districtName":"Verona"},{"nome":"San Giovanni Rotondo","cap":["71013"],"district":"FG","districtName":"Foggia"},{"nome":"San Giovanni Suergiu","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"San Giovanni Teatino","cap":["66020"],"district":"CH","districtName":"Chieti"},{"nome":"San Giovanni Valdarno","cap":["52027"],"district":"AR","districtName":"Arezzo"},{"nome":"San Giuliano del Sannio","cap":["86010"],"district":"CB","districtName":"Campobasso"},{"nome":"San Giuliano di Puglia","cap":["86040"],"district":"CB","districtName":"Campobasso"},{"nome":"San Giuliano Milanese","cap":["20098"],"district":"MI","districtName":"Milano"},{"nome":"San Giuliano Terme","cap":["56017"],"district":"PI","districtName":"Pisa"},{"nome":"San Giuseppe Jato","cap":["90048"],"district":"PA","districtName":"Palermo"},{"nome":"San Giuseppe Vesuviano","cap":["80047"],"district":"NA","districtName":"Napoli"},{"nome":"San Giustino","cap":["06016"],"district":"PG","districtName":"Perugia"},{"nome":"San Giusto Canavese","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"San Godenzo","cap":["50060"],"district":"FI","districtName":"Firenze"},{"nome":"San Gregorio d'Ippona","cap":["89853"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"San Gregorio da Sassola","cap":["00010"],"district":"RM","districtName":"Roma"},{"nome":"San Gregorio di Catania","cap":["95027"],"district":"CT","districtName":"Catania"},{"nome":"San Gregorio Magno","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"San Gregorio Matese","cap":["81010"],"district":"CE","districtName":"Caserta"},{"nome":"San Gregorio nelle Alpi","cap":["32030"],"district":"BL","districtName":"Belluno"},{"nome":"San Lazzaro di Savena","cap":["40068"],"district":"BO","districtName":"Bologna"},{"nome":"San Leo","cap":["47865"],"district":"RN","districtName":"Rimini"},{"nome":"San Leonardo","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"San Leonardo in Passiria","cap":["39015"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"San Leucio del Sannio","cap":["82010"],"district":"BN","districtName":"Benevento"},{"nome":"San Lorenzello","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"San Lorenzo","cap":["89069"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"San Lorenzo al Mare","cap":["18017"],"district":"IM","districtName":"Imperia"},{"nome":"San Lorenzo Bellizzi","cap":["87070"],"district":"CS","districtName":"Cosenza"},{"nome":"San Lorenzo del Vallo","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"San Lorenzo di Sebato","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"San Lorenzo Dorsino","cap":["38078"],"district":"TN","districtName":"Trento"},{"nome":"San Lorenzo in Campo","cap":["61047"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"San Lorenzo Isontino","cap":["34070"],"district":"GO","districtName":"Gorizia"},{"nome":"San Lorenzo Maggiore","cap":["82034"],"district":"BN","districtName":"Benevento"},{"nome":"San Lorenzo Nuovo","cap":["01020"],"district":"VT","districtName":"Viterbo"},{"nome":"San Luca","cap":["89030"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"San Lucido","cap":["87038"],"district":"CS","districtName":"Cosenza"},{"nome":"San Lupo","cap":["82034"],"district":"BN","districtName":"Benevento"},{"nome":"San Mango d'Aquino","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"San Mango Piemonte","cap":["84090"],"district":"SA","districtName":"Salerno"},{"nome":"San Mango sul Calore","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"San Marcellino","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"San Marcello","cap":["60030"],"district":"AN","districtName":"Ancona"},{"nome":"San Marcello Piteglio","cap":["51028"],"district":"PT","districtName":"Pistoia"},{"nome":"San Marco Argentano","cap":["87018"],"district":"CS","districtName":"Cosenza"},{"nome":"San Marco d'Alunzio","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"San Marco dei Cavoti","cap":["82029"],"district":"BN","districtName":"Benevento"},{"nome":"San Marco Evangelista","cap":["81020"],"district":"CE","districtName":"Caserta"},{"nome":"San Marco in Lamis","cap":["71014"],"district":"FG","districtName":"Foggia"},{"nome":"San Marco la Catola","cap":["71030"],"district":"FG","districtName":"Foggia"},{"nome":"San Martino al Tagliamento","cap":["33098"],"district":"PN","districtName":"Pordenone"},{"nome":"San Martino Alfieri","cap":["14010"],"district":"AT","districtName":"Asti"},{"nome":"San Martino Buon Albergo","cap":["37036"],"district":"VR","districtName":"Verona"},{"nome":"San Martino Canavese","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"San Martino d'Agri","cap":["85030"],"district":"PZ","districtName":"Potenza"},{"nome":"San Martino dall'Argine","cap":["46010"],"district":"MN","districtName":"Mantova"},{"nome":"San Martino del Lago","cap":["26040"],"district":"CR","districtName":"Cremona"},{"nome":"San Martino di Finita","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"San Martino di Lupari","cap":["35018"],"district":"PD","districtName":"Padova"},{"nome":"San Martino di Venezze","cap":["45030"],"district":"RO","districtName":"Rovigo"},{"nome":"San Martino in Badia","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"San Martino in Passiria","cap":["39010"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"San Martino in Pensilis","cap":["86046"],"district":"CB","districtName":"Campobasso"},{"nome":"San Martino in Rio","cap":["42018"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"San Martino in Strada","cap":["26817"],"district":"LO","districtName":"Lodi"},{"nome":"San Martino Sannita","cap":["82010"],"district":"BN","districtName":"Benevento"},{"nome":"San Martino Siccomario","cap":["27028"],"district":"PV","districtName":"Pavia"},{"nome":"San Martino sulla Marrucina","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"San Martino Valle Caudina","cap":["83018"],"district":"AV","districtName":"Avellino"},{"nome":"San Marzano di San Giuseppe","cap":["74020"],"district":"TA","districtName":"Taranto"},{"nome":"San Marzano Oliveto","cap":["14050"],"district":"AT","districtName":"Asti"},{"nome":"San Marzano sul Sarno","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"San Massimo","cap":["86027"],"district":"CB","districtName":"Campobasso"},{"nome":"San Maurizio Canavese","cap":["10077"],"district":"TO","districtName":"Torino"},{"nome":"San Maurizio d'Opaglio","cap":["28017"],"district":"NO","districtName":"Novara"},{"nome":"San Mauro Castelverde","cap":["90010"],"district":"PA","districtName":"Palermo"},{"nome":"San Mauro Cilento","cap":["84070"],"district":"SA","districtName":"Salerno"},{"nome":"San Mauro di Saline","cap":["37030"],"district":"VR","districtName":"Verona"},{"nome":"San Mauro Forte","cap":["75010"],"district":"MT","districtName":"Matera"},{"nome":"San Mauro la Bruca","cap":["84070"],"district":"SA","districtName":"Salerno"},{"nome":"San Mauro Marchesato","cap":["88831"],"district":"KR","districtName":"Crotone"},{"nome":"San Mauro Pascoli","cap":["47030"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"San Mauro Torinese","cap":["10099"],"district":"TO","districtName":"Torino"},{"nome":"San Michele al Tagliamento","cap":["30028"],"district":"VE","districtName":"Venezia"},{"nome":"San Michele all'Adige","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"San Michele di Ganzaria","cap":["95040"],"district":"CT","districtName":"Catania"},{"nome":"San Michele di Serino","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"San Michele Mondovì","cap":["12080"],"district":"CN","districtName":"Cuneo"},{"nome":"San Michele Salentino","cap":["72018"],"district":"BR","districtName":"Brindisi"},{"nome":"San Miniato","cap":["56028"],"district":"PI","districtName":"Pisa"},{"nome":"San Nazzaro","cap":["82018"],"district":"BN","districtName":"Benevento"},{"nome":"San Nazzaro Sesia","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"San Nazzaro Val Cavargna","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"San Nicandro Garganico","cap":["71015"],"district":"FG","districtName":"Foggia"},{"nome":"San Nicola Arcella","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"San Nicola Baronia","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"San Nicola da Crissa","cap":["89821"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"San Nicola dell'Alto","cap":["88817"],"district":"KR","districtName":"Crotone"},{"nome":"San Nicola la Strada","cap":["81020"],"district":"CE","districtName":"Caserta"},{"nome":"San Nicola Manfredi","cap":["82010"],"district":"BN","districtName":"Benevento"},{"nome":"San Nicolò d'Arcidano","cap":["09097"],"district":"OR","districtName":"Oristano"},{"nome":"San Nicolò di Comelico","cap":["32040"],"district":"BL","districtName":"Belluno"},{"nome":"San Nicolò Gerrei","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"San Pancrazio","cap":["39010"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"San Pancrazio Salentino","cap":["72026"],"district":"BR","districtName":"Brindisi"},{"nome":"San Paolo","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"San Paolo Albanese","cap":["85030"],"district":"PZ","districtName":"Potenza"},{"nome":"San Paolo Bel Sito","cap":["80030"],"district":"NA","districtName":"Napoli"},{"nome":"San Paolo d'Argon","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"San Paolo di Civitate","cap":["71010"],"district":"FG","districtName":"Foggia"},{"nome":"San Paolo di Jesi","cap":["60038"],"district":"AN","districtName":"Ancona"},{"nome":"San Paolo Solbrito","cap":["14010"],"district":"AT","districtName":"Asti"},{"nome":"San Pellegrino Terme","cap":["24016"],"district":"BG","districtName":"Bergamo"},{"nome":"San Pier d'Isonzo","cap":["34070"],"district":"GO","districtName":"Gorizia"},{"nome":"San Pier Niceto","cap":["98045"],"district":"ME","districtName":"Messina"},{"nome":"San Piero Patti","cap":["98068"],"district":"ME","districtName":"Messina"},{"nome":"San Pietro a Maida","cap":["88025"],"district":"CZ","districtName":"Catanzaro"},{"nome":"San Pietro al Natisone","cap":["33049"],"district":"UD","districtName":"Udine"},{"nome":"San Pietro al Tanagro","cap":["84030"],"district":"SA","districtName":"Salerno"},{"nome":"San Pietro Apostolo","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"San Pietro Avellana","cap":["86088"],"district":"IS","districtName":"Isernia"},{"nome":"San Pietro Clarenza","cap":["95030"],"district":"CT","districtName":"Catania"},{"nome":"San Pietro di Cadore","cap":["32040"],"district":"BL","districtName":"Belluno"},{"nome":"San Pietro di Caridà","cap":["89020"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"San Pietro di Feletto","cap":["31020"],"district":"TV","districtName":"Treviso"},{"nome":"San Pietro di Morubio","cap":["37050"],"district":"VR","districtName":"Verona"},{"nome":"San Pietro in Amantea","cap":["87030"],"district":"CS","districtName":"Cosenza"},{"nome":"San Pietro in Cariano","cap":["37029"],"district":"VR","districtName":"Verona"},{"nome":"San Pietro in Casale","cap":["40018"],"district":"BO","districtName":"Bologna"},{"nome":"San Pietro in Cerro","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"San Pietro in Gu","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"San Pietro in Guarano","cap":["87047"],"district":"CS","districtName":"Cosenza"},{"nome":"San Pietro in Lama","cap":["73010"],"district":"LE","districtName":"Lecce"},{"nome":"San Pietro Infine","cap":["81049"],"district":"CE","districtName":"Caserta"},{"nome":"San Pietro Mosezzo","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"San Pietro Mussolino","cap":["36070"],"district":"VI","districtName":"Vicenza"},{"nome":"San Pietro Val Lemina","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"San Pietro Vernotico","cap":["72027"],"district":"BR","districtName":"Brindisi"},{"nome":"San Pietro Viminario","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"San Pio delle Camere","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"San Polo d'Enza","cap":["42020"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"San Polo dei Cavalieri","cap":["00010"],"district":"RM","districtName":"Roma"},{"nome":"San Polo di Piave","cap":["31020"],"district":"TV","districtName":"Treviso"},{"nome":"San Polo Matese","cap":["86020"],"district":"CB","districtName":"Campobasso"},{"nome":"San Ponso","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"San Possidonio","cap":["41039"],"district":"MO","districtName":"Modena"},{"nome":"San Potito Sannitico","cap":["81016"],"district":"CE","districtName":"Caserta"},{"nome":"San Potito Ultra","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"San Prisco","cap":["81054"],"district":"CE","districtName":"Caserta"},{"nome":"San Procopio","cap":["89020"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"San Prospero","cap":["41030"],"district":"MO","districtName":"Modena"},{"nome":"San Quirico d'Orcia","cap":["53027"],"district":"SI","districtName":"Siena"},{"nome":"San Quirino","cap":["33080"],"district":"PN","districtName":"Pordenone"},{"nome":"San Raffaele Cimena","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"San Roberto","cap":["89050"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"San Rocco al Porto","cap":["26865"],"district":"LO","districtName":"Lodi"},{"nome":"San Romano in Garfagnana","cap":["55038"],"district":"LU","districtName":"Lucca"},{"nome":"San Rufo","cap":["84030"],"district":"SA","districtName":"Salerno"},{"nome":"San Salvatore di Fitalia","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"San Salvatore Monferrato","cap":["15046"],"district":"AL","districtName":"Alessandria"},{"nome":"San Salvatore Telesino","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"San Salvo","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"San Sebastiano al Vesuvio","cap":["80040"],"district":"NA","districtName":"Napoli"},{"nome":"San Sebastiano Curone","cap":["15056"],"district":"AL","districtName":"Alessandria"},{"nome":"San Sebastiano da Po","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"San Secondo di Pinerolo","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"San Secondo Parmense","cap":["43017"],"district":"PR","districtName":"Parma"},{"nome":"San Severino Lucano","cap":["85030"],"district":"PZ","districtName":"Potenza"},{"nome":"San Severino Marche","cap":["62027"],"district":"MC","districtName":"Macerata"},{"nome":"San Severo","cap":["71016"],"district":"FG","districtName":"Foggia"},{"nome":"San Siro","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"San Sossio Baronia","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"San Sostene","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"San Sosti","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"San Sperate","cap":["09026"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"San Stino di Livenza","cap":["30029"],"district":"VE","districtName":"Venezia"},{"nome":"San Tammaro","cap":["81050"],"district":"CE","districtName":"Caserta"},{"nome":"San Teodoro","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"San Teodoro","cap":["07052"],"district":"SS","districtName":"Sassari"},{"nome":"San Tomaso Agordino","cap":["32020"],"district":"BL","districtName":"Belluno"},{"nome":"San Valentino in Abruzzo Citeriore","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"San Valentino Torio","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"San Venanzo","cap":["05010"],"district":"TR","districtName":"Terni"},{"nome":"San Vendemiano","cap":["31020"],"district":"TV","districtName":"Treviso"},{"nome":"San Vero Milis","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"San Vincenzo","cap":["57027"],"district":"LI","districtName":"Livorno"},{"nome":"San Vincenzo La Costa","cap":["87030"],"district":"CS","districtName":"Cosenza"},{"nome":"San Vincenzo Valle Roveto","cap":["67050"],"district":"AQ","districtName":"L'Aquila"},{"nome":"San Vitaliano","cap":["80030"],"district":"NA","districtName":"Napoli"},{"nome":"San Vito","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"San Vito al Tagliamento","cap":["33078"],"district":"PN","districtName":"Pordenone"},{"nome":"San Vito al Torre","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"San Vito Chietino","cap":["66038"],"district":"CH","districtName":"Chieti"},{"nome":"San Vito dei Normanni","cap":["72019"],"district":"BR","districtName":"Brindisi"},{"nome":"San Vito di Cadore","cap":["32046"],"district":"BL","districtName":"Belluno"},{"nome":"San Vito di Fagagna","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"San Vito di Leguzzano","cap":["36030"],"district":"VI","districtName":"Vicenza"},{"nome":"San Vito Lo Capo","cap":["91010"],"district":"TP","districtName":"Trapani"},{"nome":"San Vito Romano","cap":["00030"],"district":"RM","districtName":"Roma"},{"nome":"San Vito sullo Ionio","cap":["88067"],"district":"CZ","districtName":"Catanzaro"},{"nome":"San Vittore del Lazio","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"San Vittore Olona","cap":["20028"],"district":"MI","districtName":"Milano"},{"nome":"San Zeno di Montagna","cap":["37010"],"district":"VR","districtName":"Verona"},{"nome":"San Zeno Naviglio","cap":["25010"],"district":"BS","districtName":"Brescia"},{"nome":"San Zenone al Lambro","cap":["20070"],"district":"MI","districtName":"Milano"},{"nome":"San Zenone al Po","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"San Zenone degli Ezzelini","cap":["31020"],"district":"TV","districtName":"Treviso"},{"nome":"Sanarica","cap":["73030"],"district":"LE","districtName":"Lecce"},{"nome":"Sandigliano","cap":["13876"],"district":"BI","districtName":"Biella"},{"nome":"Sandrigo","cap":["36066"],"district":"VI","districtName":"Vicenza"},{"nome":"Sanfrè","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Sanfront","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Sangano","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Sangiano","cap":["21038"],"district":"VA","districtName":"Varese"},{"nome":"Sangineto","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Sanguinetto","cap":["37058"],"district":"VR","districtName":"Verona"},{"nome":"Sanluri","cap":["09025"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Sannazzaro de' Burgondi","cap":["27039"],"district":"PV","districtName":"Pavia"},{"nome":"Sannicandro di Bari","cap":["70028"],"district":"BA","districtName":"Bari"},{"nome":"Sannicola","cap":["73017"],"district":"LE","districtName":"Lecce"},{"nome":"Sanremo","cap":["18038"],"district":"IM","districtName":"Imperia"},{"nome":"Sansepolcro","cap":["52037"],"district":"AR","districtName":"Arezzo"},{"nome":"Sant'Agapito","cap":["86070"],"district":"IS","districtName":"Isernia"},{"nome":"Sant'Agata Bolognese","cap":["40019"],"district":"BO","districtName":"Bologna"},{"nome":"Sant'Agata de' Goti","cap":["82019"],"district":"BN","districtName":"Benevento"},{"nome":"Sant'Agata del Bianco","cap":["89030"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Sant'Agata di Esaro","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Sant'Agata di Militello","cap":["98076"],"district":"ME","districtName":"Messina"},{"nome":"Sant'Agata di Puglia","cap":["71028"],"district":"FG","districtName":"Foggia"},{"nome":"Sant'Agata Feltria","cap":["47866"],"district":"RN","districtName":"Rimini"},{"nome":"Sant'Agata Fossili","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Sant'Agata li Battiati","cap":["95030"],"district":"CT","districtName":"Catania"},{"nome":"Sant'Agata sul Santerno","cap":["48020"],"district":"RA","districtName":"Ravenna"},{"nome":"Sant'Agnello","cap":["80065"],"district":"NA","districtName":"Napoli"},{"nome":"Sant'Albano Stura","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Sant'Alessio con Vialone","cap":["27016"],"district":"PV","districtName":"Pavia"},{"nome":"Sant'Alessio in Aspromonte","cap":["89050"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Sant'Alessio Siculo","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Sant'Alfio","cap":["95010"],"district":"CT","districtName":"Catania"},{"nome":"Sant'Ambrogio di Torino","cap":["10057"],"district":"TO","districtName":"Torino"},{"nome":"Sant'Ambrogio di Valpolicella","cap":["37015"],"district":"VR","districtName":"Verona"},{"nome":"Sant'Ambrogio sul Garigliano","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Sant'Anastasia","cap":["80048"],"district":"NA","districtName":"Napoli"},{"nome":"Sant'Anatolia di Narco","cap":["06040"],"district":"PG","districtName":"Perugia"},{"nome":"Sant'Andrea Apostolo dello Ionio","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Sant'Andrea del Garigliano","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Sant'Andrea di Conza","cap":["83053"],"district":"AV","districtName":"Avellino"},{"nome":"Sant'Andrea Frius","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Sant'Angelo a Cupolo","cap":["82010"],"district":"BN","districtName":"Benevento"},{"nome":"Sant'Angelo a Fasanella","cap":["84027"],"district":"SA","districtName":"Salerno"},{"nome":"Sant'Angelo a Scala","cap":["83010"],"district":"AV","districtName":"Avellino"},{"nome":"Sant'Angelo all'Esca","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"Sant'Angelo d'Alife","cap":["81017"],"district":"CE","districtName":"Caserta"},{"nome":"Sant'Angelo dei Lombardi","cap":["83054"],"district":"AV","districtName":"Avellino"},{"nome":"Sant'Angelo del Pesco","cap":["86080"],"district":"IS","districtName":"Isernia"},{"nome":"Sant'Angelo di Brolo","cap":["98060"],"district":"ME","districtName":"Messina"},{"nome":"Sant'Angelo di Piove di Sacco","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Sant'Angelo in Pontano","cap":["62020"],"district":"MC","districtName":"Macerata"},{"nome":"Sant'Angelo in Vado","cap":["61048"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Sant'Angelo Le Fratte","cap":["85050"],"district":"PZ","districtName":"Potenza"},{"nome":"Sant'Angelo Limosano","cap":["86020"],"district":"CB","districtName":"Campobasso"},{"nome":"Sant'Angelo Lodigiano","cap":["26866"],"district":"LO","districtName":"Lodi"},{"nome":"Sant'Angelo Lomellina","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Sant'Angelo Muxaro","cap":["92020"],"district":"AG","districtName":"Agrigento"},{"nome":"Sant'Angelo Romano","cap":["00010"],"district":"RM","districtName":"Roma"},{"nome":"Sant'Anna Arresi","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Sant'Anna d'Alfaedo","cap":["37020"],"district":"VR","districtName":"Verona"},{"nome":"Sant'Antimo","cap":["80029"],"district":"NA","districtName":"Napoli"},{"nome":"Sant'Antioco","cap":["09017"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Sant'Antonino di Susa","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Sant'Antonio Abate","cap":["80057"],"district":"NA","districtName":"Napoli"},{"nome":"Sant'Antonio di Gallura","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Sant'Apollinare","cap":["03048"],"district":"FR","districtName":"Frosinone"},{"nome":"Sant'Arcangelo","cap":["85037"],"district":"PZ","districtName":"Potenza"},{"nome":"Sant'Arcangelo Trimonte","cap":["82021"],"district":"BN","districtName":"Benevento"},{"nome":"Sant'Arpino","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Sant'Arsenio","cap":["84037"],"district":"SA","districtName":"Salerno"},{"nome":"Sant'Egidio alla Vibrata","cap":["64016"],"district":"TE","districtName":"Teramo"},{"nome":"Sant'Egidio del Monte Albino","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"Sant'Elena","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Sant'Elena Sannita","cap":["86095"],"district":"IS","districtName":"Isernia"},{"nome":"Sant'Elia a Pianisi","cap":["86048"],"district":"CB","districtName":"Campobasso"},{"nome":"Sant'Elia Fiumerapido","cap":["03049"],"district":"FR","districtName":"Frosinone"},{"nome":"Sant'Elpidio a Mare","cap":["63811"],"district":"FM","districtName":"Fermo"},{"nome":"Sant'Eufemia a Maiella","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Sant'Eufemia d'Aspromonte","cap":["89027"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Sant'Eusanio del Sangro","cap":["66037"],"district":"CH","districtName":"Chieti"},{"nome":"Sant'Eusanio Forconese","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Sant'Ilario d'Enza","cap":["42049"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Sant'Ilario dello Ionio","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Sant'Ippolito","cap":["61040"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Sant'Olcese","cap":["16010"],"district":"GE","districtName":"Genova"},{"nome":"Sant'Omero","cap":["64027"],"district":"TE","districtName":"Teramo"},{"nome":"Sant'Omobono Terme","cap":["24038"],"district":"BG","districtName":"Bergamo"},{"nome":"Sant'Onofrio","cap":["89843"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Sant'Oreste","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Sant'Orsola Terme","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Sant'Urbano","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Santa Brigida","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Santa Caterina Albanese","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Santa Caterina dello Ionio","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Santa Caterina Villarmosa","cap":["93018"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Santa Cesarea Terme","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Santa Cristina d'Aspromonte","cap":["89056"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Santa Cristina e Bissone","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Santa Cristina Gela","cap":["90030"],"district":"PA","districtName":"Palermo"},{"nome":"Santa Cristina Valgardena","cap":["39047"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Santa Croce Camerina","cap":["97017"],"district":"RG","districtName":"Ragusa"},{"nome":"Santa Croce del Sannio","cap":["82020"],"district":"BN","districtName":"Benevento"},{"nome":"Santa Croce di Magliano","cap":["86047"],"district":"CB","districtName":"Campobasso"},{"nome":"Santa Croce sull'Arno","cap":["56029"],"district":"PI","districtName":"Pisa"},{"nome":"Santa Domenica Talao","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Santa Domenica Vittoria","cap":["98030"],"district":"ME","districtName":"Messina"},{"nome":"Santa Elisabetta","cap":["92020"],"district":"AG","districtName":"Agrigento"},{"nome":"Santa Fiora","cap":["58037"],"district":"GR","districtName":"Grosseto"},{"nome":"Santa Flavia","cap":["90017"],"district":"PA","districtName":"Palermo"},{"nome":"Santa Giuletta","cap":["27046"],"district":"PV","districtName":"Pavia"},{"nome":"Santa Giusta","cap":["09096"],"district":"OR","districtName":"Oristano"},{"nome":"Santa Giustina","cap":["32035"],"district":"BL","districtName":"Belluno"},{"nome":"Santa Giustina in Colle","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Santa Luce","cap":["56040"],"district":"PI","districtName":"Pisa"},{"nome":"Santa Lucia del Mela","cap":["98046"],"district":"ME","districtName":"Messina"},{"nome":"Santa Lucia di Piave","cap":["31025"],"district":"TV","districtName":"Treviso"},{"nome":"Santa Lucia di Serino","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Santa Margherita di Belice","cap":["92018"],"district":"AG","districtName":"Agrigento"},{"nome":"Santa Margherita di Staffora","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Santa Margherita Ligure","cap":["16038"],"district":"GE","districtName":"Genova"},{"nome":"Santa Maria a Monte","cap":["56020"],"district":"PI","districtName":"Pisa"},{"nome":"Santa Maria a Vico","cap":["81028"],"district":"CE","districtName":"Caserta"},{"nome":"Santa Maria Capua Vetere","cap":["81055"],"district":"CE","districtName":"Caserta"},{"nome":"Santa Maria Coghinas","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Santa Maria del Cedro","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Santa Maria del Molise","cap":["86096"],"district":"IS","districtName":"Isernia"},{"nome":"Santa Maria della Versa","cap":["27047"],"district":"PV","districtName":"Pavia"},{"nome":"Santa Maria di Licodia","cap":["95038"],"district":"CT","districtName":"Catania"},{"nome":"Santa Maria di Sala","cap":["30036"],"district":"VE","districtName":"Venezia"},{"nome":"Santa Maria Hoè","cap":["23889"],"district":"LC","districtName":"Lecco"},{"nome":"Santa Maria Imbaro","cap":["66030"],"district":"CH","districtName":"Chieti"},{"nome":"Santa Maria la Carità","cap":["80050"],"district":"NA","districtName":"Napoli"},{"nome":"Santa Maria la Fossa","cap":["81050"],"district":"CE","districtName":"Caserta"},{"nome":"Santa Maria la Longa","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Santa Maria Maggiore","cap":["28857"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Santa Maria Nuova","cap":["60030"],"district":"AN","districtName":"Ancona"},{"nome":"Santa Marina","cap":["84067"],"district":"SA","districtName":"Salerno"},{"nome":"Santa Marina Salina","cap":["98050"],"district":"ME","districtName":"Messina"},{"nome":"Santa Marinella","cap":["00058"],"district":"RM","districtName":"Roma"},{"nome":"Santa Ninfa","cap":["91029"],"district":"TP","districtName":"Trapani"},{"nome":"Santa Paolina","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Santa Severina","cap":["88832"],"district":"KR","districtName":"Crotone"},{"nome":"Santa Sofia","cap":["47018"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Santa Sofia d'Epiro","cap":["87048"],"district":"CS","districtName":"Cosenza"},{"nome":"Santa Teresa di Riva","cap":["98028"],"district":"ME","districtName":"Messina"},{"nome":"Santa Teresa Gallura","cap":["07028"],"district":"SS","districtName":"Sassari"},{"nome":"Santa Venerina","cap":["95010"],"district":"CT","districtName":"Catania"},{"nome":"Santa Vittoria d'Alba","cap":["12069"],"district":"CN","districtName":"Cuneo"},{"nome":"Santa Vittoria in Matenano","cap":["63854"],"district":"FM","districtName":"Fermo"},{"nome":"Santadi","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Santarcangelo di Romagna","cap":["47822"],"district":"RN","districtName":"Rimini"},{"nome":"Sante Marie","cap":["67067"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Santena","cap":["10026"],"district":"TO","districtName":"Torino"},{"nome":"Santeramo in Colle","cap":["70029"],"district":"BA","districtName":"Bari"},{"nome":"Santhià","cap":["13048"],"district":"VC","districtName":"Vercelli"},{"nome":"Santi Cosma e Damiano","cap":["04020"],"district":"LT","districtName":"Latina"},{"nome":"Santo Stefano al Mare","cap":["18010"],"district":"IM","districtName":"Imperia"},{"nome":"Santo Stefano Belbo","cap":["12058"],"district":"CN","districtName":"Cuneo"},{"nome":"Santo Stefano d'Aveto","cap":["16049"],"district":"GE","districtName":"Genova"},{"nome":"Santo Stefano del Sole","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"Santo Stefano di Cadore","cap":["32045"],"district":"BL","districtName":"Belluno"},{"nome":"Santo Stefano di Camastra","cap":["98077"],"district":"ME","districtName":"Messina"},{"nome":"Santo Stefano di Magra","cap":["19037"],"district":"SP","districtName":"La Spezia"},{"nome":"Santo Stefano di Rogliano","cap":["87056"],"district":"CS","districtName":"Cosenza"},{"nome":"Santo Stefano di Sessanio","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Santo Stefano in Aspromonte","cap":["89057"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Santo Stefano Lodigiano","cap":["26849"],"district":"LO","districtName":"Lodi"},{"nome":"Santo Stefano Quisquina","cap":["92020"],"district":"AG","districtName":"Agrigento"},{"nome":"Santo Stefano Roero","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Santo Stefano Ticino","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Santomenna","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Santopadre","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Santorso","cap":["36014"],"district":"VI","districtName":"Vicenza"},{"nome":"Santu Lussurgiu","cap":["09075"],"district":"OR","districtName":"Oristano"},{"nome":"Sanza","cap":["84030"],"district":"SA","districtName":"Salerno"},{"nome":"Sanzeno","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Saonara","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Saponara","cap":["98047"],"district":"ME","districtName":"Messina"},{"nome":"Sappada","cap":["33012"],"district":"UD","districtName":"Udine"},{"nome":"Sapri","cap":["84073"],"district":"SA","districtName":"Salerno"},{"nome":"Saracena","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Saracinesco","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Sarcedo","cap":["36030"],"district":"VI","districtName":"Vicenza"},{"nome":"Sarconi","cap":["85050"],"district":"PZ","districtName":"Potenza"},{"nome":"Sardara","cap":["09030"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Sardigliano","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Sarego","cap":["36040"],"district":"VI","districtName":"Vicenza"},{"nome":"Sarentino","cap":["39058"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Sarezzano","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Sarezzo","cap":["25068"],"district":"BS","districtName":"Brescia"},{"nome":"Sarmato","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Sarmede","cap":["31026"],"district":"TV","districtName":"Treviso"},{"nome":"Sarnano","cap":["62028"],"district":"MC","districtName":"Macerata"},{"nome":"Sarnico","cap":["24067"],"district":"BG","districtName":"Bergamo"},{"nome":"Sarno","cap":["84087"],"district":"SA","districtName":"Salerno"},{"nome":"Sarnonico","cap":["38011"],"district":"TN","districtName":"Trento"},{"nome":"Saronno","cap":["21047"],"district":"VA","districtName":"Varese"},{"nome":"Sarre","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Sarroch","cap":["09018"],"district":"CA","districtName":"Cagliari"},{"nome":"Sarsina","cap":["47027"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Sarteano","cap":["53047"],"district":"SI","districtName":"Siena"},{"nome":"Sartirana Lomellina","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Sarule","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Sarzana","cap":["19038"],"district":"SP","districtName":"La Spezia"},{"nome":"Sassano","cap":["84038"],"district":"SA","districtName":"Salerno"},{"nome":"Sassari","cap":["07100"],"district":"SS","districtName":"Sassari"},{"nome":"Sassello","cap":["17046"],"district":"SV","districtName":"Savona"},{"nome":"Sassetta","cap":["57020"],"district":"LI","districtName":"Livorno"},{"nome":"Sassinoro","cap":["82026"],"district":"BN","districtName":"Benevento"},{"nome":"Sasso di Castalda","cap":["85050"],"district":"PZ","districtName":"Potenza"},{"nome":"Sasso Marconi","cap":["40037"],"district":"BO","districtName":"Bologna"},{"nome":"Sassocorvaro Auditore","cap":["61028"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Sassofeltrio","cap":["61013"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Sassoferrato","cap":["60041"],"district":"AN","districtName":"Ancona"},{"nome":"Sassuolo","cap":["41049"],"district":"MO","districtName":"Modena"},{"nome":"Satriano","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Satriano di Lucania","cap":["85050"],"district":"PZ","districtName":"Potenza"},{"nome":"Sauris","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Sauze d'Oulx","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Sauze di Cesana","cap":["10054"],"district":"TO","districtName":"Torino"},{"nome":"Sava","cap":["74028"],"district":"TA","districtName":"Taranto"},{"nome":"Savelli","cap":["88825"],"district":"KR","districtName":"Crotone"},{"nome":"Saviano","cap":["80039"],"district":"NA","districtName":"Napoli"},{"nome":"Savigliano","cap":["12038"],"district":"CN","districtName":"Cuneo"},{"nome":"Savignano Irpino","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Savignano sul Panaro","cap":["41056"],"district":"MO","districtName":"Modena"},{"nome":"Savignano sul Rubicone","cap":["47039"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Savignone","cap":["16010"],"district":"GE","districtName":"Genova"},{"nome":"Saviore dell'Adamello","cap":["25040"],"district":"BS","districtName":"Brescia"},{"nome":"Savoca","cap":["98038"],"district":"ME","districtName":"Messina"},{"nome":"Savogna","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Savogna d'Isonzo","cap":["34070"],"district":"GO","districtName":"Gorizia"},{"nome":"Savoia di Lucania","cap":["85050"],"district":"PZ","districtName":"Potenza"},{"nome":"Savona","cap":["17100"],"district":"SV","districtName":"Savona"},{"nome":"Scafa","cap":["65027"],"district":"PE","districtName":"Pescara"},{"nome":"Scafati","cap":["84018"],"district":"SA","districtName":"Salerno"},{"nome":"Scagnello","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Scala","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"Scala Coeli","cap":["87060"],"district":"CS","districtName":"Cosenza"},{"nome":"Scaldasole","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Scalea","cap":["87029"],"district":"CS","districtName":"Cosenza"},{"nome":"Scalenghe","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Scaletta Zanclea","cap":["98029"],"district":"ME","districtName":"Messina"},{"nome":"Scampitella","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"Scandale","cap":["88831"],"district":"KR","districtName":"Crotone"},{"nome":"Scandiano","cap":["42019"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Scandicci","cap":["50018"],"district":"FI","districtName":"Firenze"},{"nome":"Scandolara Ravara","cap":["26040"],"district":"CR","districtName":"Cremona"},{"nome":"Scandolara Ripa d'Oglio","cap":["26047"],"district":"CR","districtName":"Cremona"},{"nome":"Scandriglia","cap":["02038"],"district":"RI","districtName":"Rieti"},{"nome":"Scanno","cap":["67038"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Scano di Montiferro","cap":["09078"],"district":"OR","districtName":"Oristano"},{"nome":"Scansano","cap":["58054"],"district":"GR","districtName":"Grosseto"},{"nome":"Scanzano Jonico","cap":["75020"],"district":"MT","districtName":"Matera"},{"nome":"Scanzorosciate","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Scapoli","cap":["86070"],"district":"IS","districtName":"Isernia"},{"nome":"Scarlino","cap":["58020"],"district":"GR","districtName":"Grosseto"},{"nome":"Scarmagno","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Scarnafigi","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Scarperia e San Piero","cap":["50038"],"district":"FI","districtName":"Firenze"},{"nome":"Scena","cap":["39017"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Scerni","cap":["66020"],"district":"CH","districtName":"Chieti"},{"nome":"Scheggia e Pascelupo","cap":["06027"],"district":"PG","districtName":"Perugia"},{"nome":"Scheggino","cap":["06040"],"district":"PG","districtName":"Perugia"},{"nome":"Schiavi di Abruzzo","cap":["66045"],"district":"CH","districtName":"Chieti"},{"nome":"Schiavon","cap":["36060"],"district":"VI","districtName":"Vicenza"},{"nome":"Schignano","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Schilpario","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Schio","cap":["36015"],"district":"VI","districtName":"Vicenza"},{"nome":"Schivenoglia","cap":["46020"],"district":"MN","districtName":"Mantova"},{"nome":"Sciacca","cap":["92019"],"district":"AG","districtName":"Agrigento"},{"nome":"Sciara","cap":["90020"],"district":"PA","districtName":"Palermo"},{"nome":"Scicli","cap":["97018"],"district":"RG","districtName":"Ragusa"},{"nome":"Scido","cap":["89010"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Scigliano","cap":["87057"],"district":"CS","districtName":"Cosenza"},{"nome":"Scilla","cap":["89058"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Scillato","cap":["90020"],"district":"PA","districtName":"Palermo"},{"nome":"Sciolze","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Scisciano","cap":["80030"],"district":"NA","districtName":"Napoli"},{"nome":"Sclafani Bagni","cap":["90020"],"district":"PA","districtName":"Palermo"},{"nome":"Scontrone","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Scopa","cap":["13027"],"district":"VC","districtName":"Vercelli"},{"nome":"Scopello","cap":["13028"],"district":"VC","districtName":"Vercelli"},{"nome":"Scoppito","cap":["67019"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Scordia","cap":["95048"],"district":"CT","districtName":"Catania"},{"nome":"Scorrano","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Scorzè","cap":["30037"],"district":"VE","districtName":"Venezia"},{"nome":"Scurcola Marsicana","cap":["67068"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Scurelle","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Scurzolengo","cap":["14030"],"district":"AT","districtName":"Asti"},{"nome":"Seborga","cap":["18012"],"district":"IM","districtName":"Imperia"},{"nome":"Secinaro","cap":["67029"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Seclì","cap":["73050"],"district":"LE","districtName":"Lecce"},{"nome":"Secugnago","cap":["26826"],"district":"LO","districtName":"Lodi"},{"nome":"Sedegliano","cap":["33039"],"district":"UD","districtName":"Udine"},{"nome":"Sedico","cap":["32036"],"district":"BL","districtName":"Belluno"},{"nome":"Sedilo","cap":["09076"],"district":"OR","districtName":"Oristano"},{"nome":"Sedini","cap":["07035"],"district":"SS","districtName":"Sassari"},{"nome":"Sedriano","cap":["20018"],"district":"MI","districtName":"Milano"},{"nome":"Sedrina","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Sefro","cap":["62025"],"district":"MC","districtName":"Macerata"},{"nome":"Segariu","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Seggiano","cap":["58038"],"district":"GR","districtName":"Grosseto"},{"nome":"Segni","cap":["00037"],"district":"RM","districtName":"Roma"},{"nome":"Segonzano","cap":["38047"],"district":"TN","districtName":"Trento"},{"nome":"Segrate","cap":["20090"],"district":"MI","districtName":"Milano"},{"nome":"Segusino","cap":["31040"],"district":"TV","districtName":"Treviso"},{"nome":"Selargius","cap":["09047"],"district":"CA","districtName":"Cagliari"},{"nome":"Selci","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Selegas","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Sella Giudicarie","cap":["38087"],"district":"TN","districtName":"Trento"},{"nome":"Sellano","cap":["06030"],"district":"PG","districtName":"Perugia"},{"nome":"Sellero","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Sellia","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Sellia Marina","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Selva dei Molini","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Selva di Cadore","cap":["32020"],"district":"BL","districtName":"Belluno"},{"nome":"Selva di Progno","cap":["37030"],"district":"VR","districtName":"Verona"},{"nome":"Selva di Val Gardena","cap":["39048"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Selvazzano Dentro","cap":["35030"],"district":"PD","districtName":"Padova"},{"nome":"Selvino","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Semestene","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Semiana","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Seminara","cap":["89028"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Semproniano","cap":["58055"],"district":"GR","districtName":"Grosseto"},{"nome":"Senago","cap":["20030"],"district":"MI","districtName":"Milano"},{"nome":"Senale-San Felice","cap":["39010"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Senales","cap":["39020"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Seneghe","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Senerchia","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"Seniga","cap":["25020"],"district":"BS","districtName":"Brescia"},{"nome":"Senigallia","cap":["60019"],"district":"AN","districtName":"Ancona"},{"nome":"Senis","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Senise","cap":["85038"],"district":"PZ","districtName":"Potenza"},{"nome":"Senna Comasco","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Senna Lodigiana","cap":["26856"],"district":"LO","districtName":"Lodi"},{"nome":"Sennariolo","cap":["09078"],"district":"OR","districtName":"Oristano"},{"nome":"Sennori","cap":["07036"],"district":"SS","districtName":"Sassari"},{"nome":"Senorbì","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Sepino","cap":["86017"],"district":"CB","districtName":"Campobasso"},{"nome":"Sequals","cap":["33090"],"district":"PN","districtName":"Pordenone"},{"nome":"Seravezza","cap":["55047"],"district":"LU","districtName":"Lucca"},{"nome":"Serdiana","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Seregno","cap":["20831"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Seren del Grappa","cap":["32030"],"district":"BL","districtName":"Belluno"},{"nome":"Sergnano","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Seriate","cap":["24068"],"district":"BG","districtName":"Bergamo"},{"nome":"Serina","cap":["24017"],"district":"BG","districtName":"Bergamo"},{"nome":"Serino","cap":["83028"],"district":"AV","districtName":"Avellino"},{"nome":"Serle","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Sermide e Felonica","cap":["46028"],"district":"MN","districtName":"Mantova"},{"nome":"Sermoneta","cap":["04013"],"district":"LT","districtName":"Latina"},{"nome":"Sernaglia della Battaglia","cap":["31020"],"district":"TV","districtName":"Treviso"},{"nome":"Sernio","cap":["23030"],"district":"SO","districtName":"Sondrio"},{"nome":"Serole","cap":["14050"],"district":"AT","districtName":"Asti"},{"nome":"Serra d'Aiello","cap":["87030"],"district":"CS","districtName":"Cosenza"},{"nome":"Serra de' Conti","cap":["60030"],"district":"AN","districtName":"Ancona"},{"nome":"Serra Riccò","cap":["16010"],"district":"GE","districtName":"Genova"},{"nome":"Serra San Bruno","cap":["89822"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Serra San Quirico","cap":["60048"],"district":"AN","districtName":"Ancona"},{"nome":"Serra Sant'Abbondio","cap":["61040"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Serracapriola","cap":["71010"],"district":"FG","districtName":"Foggia"},{"nome":"Serradifalco","cap":["93010"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Serralunga d'Alba","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Serralunga di Crea","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Serramanna","cap":["09038"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Serramazzoni","cap":["41028"],"district":"MO","districtName":"Modena"},{"nome":"Serramezzana","cap":["84070"],"district":"SA","districtName":"Salerno"},{"nome":"Serramonacesca","cap":["65025"],"district":"PE","districtName":"Pescara"},{"nome":"Serrapetrona","cap":["62020"],"district":"MC","districtName":"Macerata"},{"nome":"Serrara Fontana","cap":["80081"],"district":"NA","districtName":"Napoli"},{"nome":"Serrastretta","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Serrata","cap":["89020"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Serravalle a Po","cap":["46030"],"district":"MN","districtName":"Mantova"},{"nome":"Serravalle di Chienti","cap":["62038"],"district":"MC","districtName":"Macerata"},{"nome":"Serravalle Langhe","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Serravalle Pistoiese","cap":["51034"],"district":"PT","districtName":"Pistoia"},{"nome":"Serravalle Scrivia","cap":["15069"],"district":"AL","districtName":"Alessandria"},{"nome":"Serravalle Sesia","cap":["13037"],"district":"VC","districtName":"Vercelli"},{"nome":"Serre","cap":["84028"],"district":"SA","districtName":"Salerno"},{"nome":"Serrenti","cap":["09027"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Serri","cap":["09063"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Serrone","cap":["03010"],"district":"FR","districtName":"Frosinone"},{"nome":"Sersale","cap":["88054"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Servigliano","cap":["63839"],"district":"FM","districtName":"Fermo"},{"nome":"Sessa Aurunca","cap":["81037"],"district":"CE","districtName":"Caserta"},{"nome":"Sessa Cilento","cap":["84074"],"district":"SA","districtName":"Salerno"},{"nome":"Sessame","cap":["14058"],"district":"AT","districtName":"Asti"},{"nome":"Sessano del Molise","cap":["86097"],"district":"IS","districtName":"Isernia"},{"nome":"Sesta Godano","cap":["19020"],"district":"SP","districtName":"La Spezia"},{"nome":"Sestino","cap":["52038"],"district":"AR","districtName":"Arezzo"},{"nome":"Sesto","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Sesto al Reghena","cap":["33079"],"district":"PN","districtName":"Pordenone"},{"nome":"Sesto Calende","cap":["21018"],"district":"VA","districtName":"Varese"},{"nome":"Sesto Campano","cap":["86078"],"district":"IS","districtName":"Isernia"},{"nome":"Sesto ed Uniti","cap":["26028"],"district":"CR","districtName":"Cremona"},{"nome":"Sesto Fiorentino","cap":["50019"],"district":"FI","districtName":"Firenze"},{"nome":"Sesto San Giovanni","cap":["20099"],"district":"MI","districtName":"Milano"},{"nome":"Sestola","cap":["41029"],"district":"MO","districtName":"Modena"},{"nome":"Sestri Levante","cap":["16039"],"district":"GE","districtName":"Genova"},{"nome":"Sestriere","cap":["10058"],"district":"TO","districtName":"Torino"},{"nome":"Sestu","cap":["09028"],"district":"CA","districtName":"Cagliari"},{"nome":"Settala","cap":["20090"],"district":"MI","districtName":"Milano"},{"nome":"Settefrati","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Settime","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Settimo Milanese","cap":["20019"],"district":"MI","districtName":"Milano"},{"nome":"Settimo Rottaro","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Settimo San Pietro","cap":["09060"],"district":"CA","districtName":"Cagliari"},{"nome":"Settimo Torinese","cap":["10036"],"district":"TO","districtName":"Torino"},{"nome":"Settimo Vittone","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Settingiano","cap":["88040"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Setzu","cap":["09029"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Seui","cap":["09064"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Seulo","cap":["09065"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Seveso","cap":["20822"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Sezzadio","cap":["15079"],"district":"AL","districtName":"Alessandria"},{"nome":"Sezze","cap":["04018"],"district":"LT","districtName":"Latina"},{"nome":"Sfruz","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Sgonico","cap":["34010"],"district":"TS","districtName":"Trieste"},{"nome":"Sgurgola","cap":["03010"],"district":"FR","districtName":"Frosinone"},{"nome":"Siamaggiore","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Siamanna","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Siano","cap":["84088"],"district":"SA","districtName":"Salerno"},{"nome":"Siapiccia","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Sicignano degli Alburni","cap":["84029"],"district":"SA","districtName":"Salerno"},{"nome":"Siculiana","cap":["92010"],"district":"AG","districtName":"Agrigento"},{"nome":"Siddi","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Siderno","cap":["89048"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Siena","cap":["53100"],"district":"SI","districtName":"Siena"},{"nome":"Sigillo","cap":["06028"],"district":"PG","districtName":"Perugia"},{"nome":"Signa","cap":["50058"],"district":"FI","districtName":"Firenze"},{"nome":"Silandro","cap":["39028"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Silanus","cap":["08017"],"district":"NU","districtName":"Nuoro"},{"nome":"Silea","cap":["31057"],"district":"TV","districtName":"Treviso"},{"nome":"Siligo","cap":["07040"],"district":"SS","districtName":"Sassari"},{"nome":"Siliqua","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Silius","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Sillano Giuncugnano","cap":["55039"],"district":"LU","districtName":"Lucca"},{"nome":"Sillavengo","cap":["28064"],"district":"NO","districtName":"Novara"},{"nome":"Silvano d'Orba","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Silvano Pietra","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Silvi","cap":["64028"],"district":"TE","districtName":"Teramo"},{"nome":"Simala","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Simaxis","cap":["09088"],"district":"OR","districtName":"Oristano"},{"nome":"Simbario","cap":["89822"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Simeri Crichi","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Sinagra","cap":["98069"],"district":"ME","districtName":"Messina"},{"nome":"Sinalunga","cap":["53048"],"district":"SI","districtName":"Siena"},{"nome":"Sindia","cap":["08018"],"district":"NU","districtName":"Nuoro"},{"nome":"Sini","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Sinio","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Siniscola","cap":["08029"],"district":"NU","districtName":"Nuoro"},{"nome":"Sinnai","cap":["09048"],"district":"CA","districtName":"Cagliari"},{"nome":"Sinopoli","cap":["89020"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Siracusa","cap":["96100"],"district":"SR","districtName":"Siracusa"},{"nome":"Sirignano","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Siris","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Sirmione","cap":["25019"],"district":"BS","districtName":"Brescia"},{"nome":"Sirolo","cap":["60020"],"district":"AN","districtName":"Ancona"},{"nome":"Sirone","cap":["23844"],"district":"LC","districtName":"Lecco"},{"nome":"Sirtori","cap":["23896"],"district":"LC","districtName":"Lecco"},{"nome":"Sissa Trecasali","cap":["43018"],"district":"PR","districtName":"Parma"},{"nome":"Siurgus Donigala","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Siziano","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Sizzano","cap":["28070"],"district":"NO","districtName":"Novara"},{"nome":"Sluderno","cap":["39020"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Smerillo","cap":["63856"],"district":"FM","districtName":"Fermo"},{"nome":"Soave","cap":["37038"],"district":"VR","districtName":"Verona"},{"nome":"Socchieve","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Soddì","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Sogliano al Rubicone","cap":["47030"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Sogliano Cavour","cap":["73010"],"district":"LE","districtName":"Lecce"},{"nome":"Soglio","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Soiano del Lago","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Solagna","cap":["36020"],"district":"VI","districtName":"Vicenza"},{"nome":"Solarino","cap":["96010"],"district":"SR","districtName":"Siracusa"},{"nome":"Solaro","cap":["20020"],"district":"MI","districtName":"Milano"},{"nome":"Solarolo","cap":["48027"],"district":"RA","districtName":"Ravenna"},{"nome":"Solarolo Rainerio","cap":["26030"],"district":"CR","districtName":"Cremona"},{"nome":"Solarussa","cap":["09077"],"district":"OR","districtName":"Oristano"},{"nome":"Solbiate Arno","cap":["21048"],"district":"VA","districtName":"Varese"},{"nome":"Solbiate con Cagno","cap":["22043"],"district":"CO","districtName":"Como"},{"nome":"Solbiate Olona","cap":["21058"],"district":"VA","districtName":"Varese"},{"nome":"Soldano","cap":["18036"],"district":"IM","districtName":"Imperia"},{"nome":"Soleminis","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Solero","cap":["15029"],"district":"AL","districtName":"Alessandria"},{"nome":"Solesino","cap":["35047"],"district":"PD","districtName":"Padova"},{"nome":"Soleto","cap":["73010"],"district":"LE","districtName":"Lecce"},{"nome":"Solferino","cap":["46040"],"district":"MN","districtName":"Mantova"},{"nome":"Soliera","cap":["41019"],"district":"MO","districtName":"Modena"},{"nome":"Solignano","cap":["43046"],"district":"PR","districtName":"Parma"},{"nome":"Solofra","cap":["83029"],"district":"AV","districtName":"Avellino"},{"nome":"Solonghello","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Solopaca","cap":["82036"],"district":"BN","districtName":"Benevento"},{"nome":"Solto Collina","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Solza","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Somaglia","cap":["26867"],"district":"LO","districtName":"Lodi"},{"nome":"Somano","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Somma Lombardo","cap":["21019"],"district":"VA","districtName":"Varese"},{"nome":"Somma Vesuviana","cap":["80049"],"district":"NA","districtName":"Napoli"},{"nome":"Sommacampagna","cap":["37066"],"district":"VR","districtName":"Verona"},{"nome":"Sommariva del Bosco","cap":["12048"],"district":"CN","districtName":"Cuneo"},{"nome":"Sommariva Perno","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Sommatino","cap":["93019"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Sommo","cap":["27048"],"district":"PV","districtName":"Pavia"},{"nome":"Sona","cap":["37060"],"district":"VR","districtName":"Verona"},{"nome":"Soncino","cap":["26029"],"district":"CR","districtName":"Cremona"},{"nome":"Sondalo","cap":["23035"],"district":"SO","districtName":"Sondrio"},{"nome":"Sondrio","cap":["23100"],"district":"SO","districtName":"Sondrio"},{"nome":"Songavazzo","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Sonico","cap":["25048"],"district":"BS","districtName":"Brescia"},{"nome":"Sonnino","cap":["04010"],"district":"LT","districtName":"Latina"},{"nome":"Sora","cap":["03039"],"district":"FR","districtName":"Frosinone"},{"nome":"Soraga di Fassa","cap":["38030"],"district":"TN","districtName":"Trento"},{"nome":"Soragna","cap":["43019"],"district":"PR","districtName":"Parma"},{"nome":"Sorano","cap":["58010"],"district":"GR","districtName":"Grosseto"},{"nome":"Sorbo San Basile","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Sorbo Serpico","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"Sorbolo Mezzani","cap":["43058"],"district":"PR","districtName":"Parma"},{"nome":"Sordevolo","cap":["13817"],"district":"BI","districtName":"Biella"},{"nome":"Sordio","cap":["26858"],"district":"LO","districtName":"Lodi"},{"nome":"Soresina","cap":["26015"],"district":"CR","districtName":"Cremona"},{"nome":"Sorgà","cap":["37060"],"district":"VR","districtName":"Verona"},{"nome":"Sorgono","cap":["08038"],"district":"NU","districtName":"Nuoro"},{"nome":"Sori","cap":["16031"],"district":"GE","districtName":"Genova"},{"nome":"Sorianello","cap":["89831"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Soriano Calabro","cap":["89831"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Soriano nel Cimino","cap":["01038"],"district":"VT","districtName":"Viterbo"},{"nome":"Sorico","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Soriso","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Sorisole","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Sormano","cap":["22030"],"district":"CO","districtName":"Como"},{"nome":"Sorradile","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Sorrento","cap":["80067"],"district":"NA","districtName":"Napoli"},{"nome":"Sorso","cap":["07037"],"district":"SS","districtName":"Sassari"},{"nome":"Sortino","cap":["96010"],"district":"SR","districtName":"Siracusa"},{"nome":"Sospiro","cap":["26048"],"district":"CR","districtName":"Cremona"},{"nome":"Sospirolo","cap":["32037"],"district":"BL","districtName":"Belluno"},{"nome":"Sossano","cap":["36040"],"district":"VI","districtName":"Vicenza"},{"nome":"Sostegno","cap":["13868"],"district":"BI","districtName":"Biella"},{"nome":"Sotto il Monte Giovanni XXIII","cap":["24039"],"district":"BG","districtName":"Bergamo"},{"nome":"Sover","cap":["38048"],"district":"TN","districtName":"Trento"},{"nome":"Soverato","cap":["88068"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Sovere","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Soveria Mannelli","cap":["88049"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Soveria Simeri","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Soverzene","cap":["32010"],"district":"BL","districtName":"Belluno"},{"nome":"Sovicille","cap":["53018"],"district":"SI","districtName":"Siena"},{"nome":"Sovico","cap":["20845"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Sovizzo","cap":["36050"],"district":"VI","districtName":"Vicenza"},{"nome":"Sovramonte","cap":["32030"],"district":"BL","districtName":"Belluno"},{"nome":"Sozzago","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"Spadafora","cap":["98048"],"district":"ME","districtName":"Messina"},{"nome":"Spadola","cap":["89822"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Sparanise","cap":["81056"],"district":"CE","districtName":"Caserta"},{"nome":"Sparone","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Specchia","cap":["73040"],"district":"LE","districtName":"Lecce"},{"nome":"Spello","cap":["06038"],"district":"PG","districtName":"Perugia"},{"nome":"Sperlinga","cap":["94010"],"district":"EN","districtName":"Enna"},{"nome":"Sperlonga","cap":["04029"],"district":"LT","districtName":"Latina"},{"nome":"Sperone","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Spessa","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Spezzano Albanese","cap":["87019"],"district":"CS","districtName":"Cosenza"},{"nome":"Spezzano della Sila","cap":["87058"],"district":"CS","districtName":"Cosenza"},{"nome":"Spiazzo","cap":["38088"],"district":"TN","districtName":"Trento"},{"nome":"Spigno Monferrato","cap":["15018"],"district":"AL","districtName":"Alessandria"},{"nome":"Spigno Saturnia","cap":["04020"],"district":"LT","districtName":"Latina"},{"nome":"Spilamberto","cap":["41057"],"district":"MO","districtName":"Modena"},{"nome":"Spilimbergo","cap":["33097"],"district":"PN","districtName":"Pordenone"},{"nome":"Spilinga","cap":["89864"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Spinadesco","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Spinazzola","cap":["76014"],"district":"BT","districtName":"Barletta-Andria-Trani"},{"nome":"Spinea","cap":["30038"],"district":"VE","districtName":"Venezia"},{"nome":"Spineda","cap":["26030"],"district":"CR","districtName":"Cremona"},{"nome":"Spinete","cap":["86020"],"district":"CB","districtName":"Campobasso"},{"nome":"Spineto Scrivia","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Spinetoli","cap":["63078"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Spino d'Adda","cap":["26016"],"district":"CR","districtName":"Cremona"},{"nome":"Spinone al Lago","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Spinoso","cap":["85039"],"district":"PZ","districtName":"Potenza"},{"nome":"Spirano","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Spoleto","cap":["06049"],"district":"PG","districtName":"Perugia"},{"nome":"Spoltore","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Spongano","cap":["73038"],"district":"LE","districtName":"Lecce"},{"nome":"Spormaggiore","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Sporminore","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Spotorno","cap":["17028"],"district":"SV","districtName":"Savona"},{"nome":"Spresiano","cap":["31027"],"district":"TV","districtName":"Treviso"},{"nome":"Spriana","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Squillace","cap":["88069"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Squinzano","cap":["73018"],"district":"LE","districtName":"Lecce"},{"nome":"Staffolo","cap":["60039"],"district":"AN","districtName":"Ancona"},{"nome":"Stagno Lombardo","cap":["26049"],"district":"CR","districtName":"Cremona"},{"nome":"Staiti","cap":["89030"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Stalettì","cap":["88069"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Stanghella","cap":["35048"],"district":"PD","districtName":"Padova"},{"nome":"Staranzano","cap":["34079"],"district":"GO","districtName":"Gorizia"},{"nome":"Statte","cap":["74010"],"district":"TA","districtName":"Taranto"},{"nome":"Stazzano","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Stazzema","cap":["55040"],"district":"LU","districtName":"Lucca"},{"nome":"Stazzona","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Stefanaconi","cap":["89843"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Stella","cap":["17044"],"district":"SV","districtName":"Savona"},{"nome":"Stella Cilento","cap":["84070"],"district":"SA","districtName":"Salerno"},{"nome":"Stellanello","cap":["17020"],"district":"SV","districtName":"Savona"},{"nome":"Stelvio","cap":["39029"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Stenico","cap":["38070"],"district":"TN","districtName":"Trento"},{"nome":"Sternatia","cap":["73010"],"district":"LE","districtName":"Lecce"},{"nome":"Stezzano","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Stienta","cap":["45039"],"district":"RO","districtName":"Rovigo"},{"nome":"Stigliano","cap":["75018"],"district":"MT","districtName":"Matera"},{"nome":"Stignano","cap":["89040"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Stilo","cap":["89049"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Stimigliano","cap":["02048"],"district":"RI","districtName":"Rieti"},{"nome":"Stintino","cap":["07040"],"district":"SS","districtName":"Sassari"},{"nome":"Stio","cap":["84075"],"district":"SA","districtName":"Salerno"},{"nome":"Stornara","cap":["71047"],"district":"FG","districtName":"Foggia"},{"nome":"Stornarella","cap":["71048"],"district":"FG","districtName":"Foggia"},{"nome":"Storo","cap":["38089"],"district":"TN","districtName":"Trento"},{"nome":"Stra","cap":["30039"],"district":"VE","districtName":"Venezia"},{"nome":"Stradella","cap":["27049"],"district":"PV","districtName":"Pavia"},{"nome":"Strambinello","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Strambino","cap":["10019"],"district":"TO","districtName":"Torino"},{"nome":"Strangolagalli","cap":["03020"],"district":"FR","districtName":"Frosinone"},{"nome":"Stregna","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Strembo","cap":["38080"],"district":"TN","districtName":"Trento"},{"nome":"Stresa","cap":["28838"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Strevi","cap":["15019"],"district":"AL","districtName":"Alessandria"},{"nome":"Striano","cap":["80040"],"district":"NA","districtName":"Napoli"},{"nome":"Strona","cap":["13823"],"district":"BI","districtName":"Biella"},{"nome":"Stroncone","cap":["05039"],"district":"TR","districtName":"Terni"},{"nome":"Strongoli","cap":["88816"],"district":"KR","districtName":"Crotone"},{"nome":"Stroppiana","cap":["13010"],"district":"VC","districtName":"Vercelli"},{"nome":"Stroppo","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Strozza","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Sturno","cap":["83055"],"district":"AV","districtName":"Avellino"},{"nome":"Suardi","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Subbiano","cap":["52010"],"district":"AR","districtName":"Arezzo"},{"nome":"Subiaco","cap":["00028"],"district":"RM","districtName":"Roma"},{"nome":"Succivo","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Sueglio","cap":["23835"],"district":"LC","districtName":"Lecco"},{"nome":"Suelli","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Suello","cap":["23867"],"district":"LC","districtName":"Lecco"},{"nome":"Suisio","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Sulbiate","cap":["20884"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Sulmona","cap":["67039"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Sulzano","cap":["25058"],"district":"BS","districtName":"Brescia"},{"nome":"Sumirago","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Summonte","cap":["83010"],"district":"AV","districtName":"Avellino"},{"nome":"Suni","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Suno","cap":["28019"],"district":"NO","districtName":"Novara"},{"nome":"Supersano","cap":["73040"],"district":"LE","districtName":"Lecce"},{"nome":"Supino","cap":["03019"],"district":"FR","districtName":"Frosinone"},{"nome":"Surano","cap":["73030"],"district":"LE","districtName":"Lecce"},{"nome":"Surbo","cap":["73010"],"district":"LE","districtName":"Lecce"},{"nome":"Susa","cap":["10059"],"district":"TO","districtName":"Torino"},{"nome":"Susegana","cap":["31058"],"district":"TV","districtName":"Treviso"},{"nome":"Sustinente","cap":["46030"],"district":"MN","districtName":"Mantova"},{"nome":"Sutera","cap":["93010"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Sutri","cap":["01015"],"district":"VT","districtName":"Viterbo"},{"nome":"Sutrio","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Suvereto","cap":["57028"],"district":"LI","districtName":"Livorno"},{"nome":"Suzzara","cap":["46029"],"district":"MN","districtName":"Mantova"},{"nome":"Taceno","cap":["23837"],"district":"LC","districtName":"Lecco"},{"nome":"Tadasuni","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Taggia","cap":["18018"],"district":"IM","districtName":"Imperia"},{"nome":"Tagliacozzo","cap":["67069"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Taglio di Po","cap":["45019"],"district":"RO","districtName":"Rovigo"},{"nome":"Tagliolo Monferrato","cap":["15070"],"district":"AL","districtName":"Alessandria"},{"nome":"Taibon Agordino","cap":["32027"],"district":"BL","districtName":"Belluno"},{"nome":"Taino","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Taipana","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Talamello","cap":["47867"],"district":"RN","districtName":"Rimini"},{"nome":"Talamona","cap":["23018"],"district":"SO","districtName":"Sondrio"},{"nome":"Talana","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Taleggio","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Talla","cap":["52010"],"district":"AR","districtName":"Arezzo"},{"nome":"Talmassons","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"Tambre","cap":["32010"],"district":"BL","districtName":"Belluno"},{"nome":"Taormina","cap":["98039"],"district":"ME","districtName":"Messina"},{"nome":"Tarano","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Taranta Peligna","cap":["66018"],"district":"CH","districtName":"Chieti"},{"nome":"Tarantasca","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Taranto","cap":["74121","74122","74123"],"district":"TA","districtName":"Taranto"},{"nome":"Tarcento","cap":["33017"],"district":"UD","districtName":"Udine"},{"nome":"Tarquinia","cap":["01016"],"district":"VT","districtName":"Viterbo"},{"nome":"Tarsia","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Tartano","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Tarvisio","cap":["33018"],"district":"UD","districtName":"Udine"},{"nome":"Tarzo","cap":["31020"],"district":"TV","districtName":"Treviso"},{"nome":"Tassarolo","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Taurano","cap":["83020"],"district":"AV","districtName":"Avellino"},{"nome":"Taurasi","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Taurianova","cap":["89029"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Taurisano","cap":["73056"],"district":"LE","districtName":"Lecce"},{"nome":"Tavagnacco","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Tavagnasco","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Tavazzano con Villavesco","cap":["26838"],"district":"LO","districtName":"Lodi"},{"nome":"Tavenna","cap":["86030"],"district":"CB","districtName":"Campobasso"},{"nome":"Taverna","cap":["88055"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Tavernerio","cap":["22038"],"district":"CO","districtName":"Como"},{"nome":"Tavernola Bergamasca","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Tavernole sul Mella","cap":["25060"],"district":"BS","districtName":"Brescia"},{"nome":"Taviano","cap":["73057"],"district":"LE","districtName":"Lecce"},{"nome":"Tavigliano","cap":["13811"],"district":"BI","districtName":"Biella"},{"nome":"Tavoleto","cap":["61020"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Tavullia","cap":["61010"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Teana","cap":["85032"],"district":"PZ","districtName":"Potenza"},{"nome":"Teano","cap":["81057"],"district":"CE","districtName":"Caserta"},{"nome":"Teggiano","cap":["84039"],"district":"SA","districtName":"Salerno"},{"nome":"Teglio","cap":["23036"],"district":"SO","districtName":"Sondrio"},{"nome":"Teglio Veneto","cap":["30025"],"district":"VE","districtName":"Venezia"},{"nome":"Telese Terme","cap":["82037"],"district":"BN","districtName":"Benevento"},{"nome":"Telgate","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Telti","cap":["07020"],"district":"SS","districtName":"Sassari"},{"nome":"Telve","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Telve di Sopra","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Tempio Pausania","cap":["07029"],"district":"SS","districtName":"Sassari"},{"nome":"Temù","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Tenna","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Tenno","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Teolo","cap":["35037"],"district":"PD","districtName":"Padova"},{"nome":"Teora","cap":["83056"],"district":"AV","districtName":"Avellino"},{"nome":"Teramo","cap":["64100"],"district":"TE","districtName":"Teramo"},{"nome":"Terdobbiate","cap":["28070"],"district":"NO","districtName":"Novara"},{"nome":"Terelle","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Terento","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Terenzo","cap":["43040"],"district":"PR","districtName":"Parma"},{"nome":"Tergu","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Terlano","cap":["39018"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Terlizzi","cap":["70038"],"district":"BA","districtName":"Bari"},{"nome":"Terme Vigliatore","cap":["98050"],"district":"ME","districtName":"Messina"},{"nome":"Termeno sulla strada del vino","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Termini Imerese","cap":["90018"],"district":"PA","districtName":"Palermo"},{"nome":"Termoli","cap":["86039"],"district":"CB","districtName":"Campobasso"},{"nome":"Ternate","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Ternengo","cap":["13844"],"district":"BI","districtName":"Biella"},{"nome":"Terni","cap":["05100"],"district":"TR","districtName":"Terni"},{"nome":"Terno d'Isola","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Terracina","cap":["04019"],"district":"LT","districtName":"Latina"},{"nome":"Terragnolo","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Terralba","cap":["09098"],"district":"OR","districtName":"Oristano"},{"nome":"Terranova da Sibari","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Terranova dei Passerini","cap":["26827"],"district":"LO","districtName":"Lodi"},{"nome":"Terranova di Pollino","cap":["85030"],"district":"PZ","districtName":"Potenza"},{"nome":"Terranova Sappo Minulio","cap":["89010"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Terranuova Bracciolini","cap":["52028"],"district":"AR","districtName":"Arezzo"},{"nome":"Terrasini","cap":["90049"],"district":"PA","districtName":"Palermo"},{"nome":"Terrassa Padovana","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Terravecchia","cap":["87060"],"district":"CS","districtName":"Cosenza"},{"nome":"Terrazzo","cap":["37040"],"district":"VR","districtName":"Verona"},{"nome":"Terre d'Adige","cap":["38097"],"district":"TN","districtName":"Trento"},{"nome":"Terre del Reno","cap":["44047"],"district":"FE","districtName":"Ferrara"},{"nome":"Terre Roveresche","cap":["61038"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Terricciola","cap":["56030"],"district":"PI","districtName":"Pisa"},{"nome":"Terruggia","cap":["15030"],"district":"AL","districtName":"Alessandria"},{"nome":"Tertenia","cap":["08047"],"district":"NU","districtName":"Nuoro"},{"nome":"Terzigno","cap":["80040"],"district":"NA","districtName":"Napoli"},{"nome":"Terzo","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Terzo d'Aquileia","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Terzolas","cap":["38027"],"district":"TN","districtName":"Trento"},{"nome":"Terzorio","cap":["18010"],"district":"IM","districtName":"Imperia"},{"nome":"Tesero","cap":["38038"],"district":"TN","districtName":"Trento"},{"nome":"Tesimo","cap":["39010"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Tessennano","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Testico","cap":["17020"],"district":"SV","districtName":"Savona"},{"nome":"Teti","cap":["08030"],"district":"NU","districtName":"Nuoro"},{"nome":"Teulada","cap":["09019"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Teverola","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Tezze sul Brenta","cap":["36056"],"district":"VI","districtName":"Vicenza"},{"nome":"Thiene","cap":["36016"],"district":"VI","districtName":"Vicenza"},{"nome":"Thiesi","cap":["07047"],"district":"SS","districtName":"Sassari"},{"nome":"Tiana","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Ticengo","cap":["26020"],"district":"CR","districtName":"Cremona"},{"nome":"Ticineto","cap":["15040"],"district":"AL","districtName":"Alessandria"},{"nome":"Tiggiano","cap":["73030"],"district":"LE","districtName":"Lecce"},{"nome":"Tiglieto","cap":["16010"],"district":"GE","districtName":"Genova"},{"nome":"Tigliole","cap":["14016"],"district":"AT","districtName":"Asti"},{"nome":"Tignale","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Tinnura","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Tione degli Abruzzi","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Tione di Trento","cap":["38079"],"district":"TN","districtName":"Trento"},{"nome":"Tirano","cap":["23037"],"district":"SO","districtName":"Sondrio"},{"nome":"Tires","cap":["39050"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Tiriolo","cap":["88056"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Tirolo","cap":["39019"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Tissi","cap":["07040"],"district":"SS","districtName":"Sassari"},{"nome":"Tito","cap":["85050"],"district":"PZ","districtName":"Potenza"},{"nome":"Tivoli","cap":["00019"],"district":"RM","districtName":"Roma"},{"nome":"Tizzano Val Parma","cap":["43028"],"district":"PR","districtName":"Parma"},{"nome":"Toano","cap":["42010"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Tocco Caudio","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Tocco da Casauria","cap":["65028"],"district":"PE","districtName":"Pescara"},{"nome":"Toceno","cap":["28858"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Todi","cap":["06059"],"district":"PG","districtName":"Perugia"},{"nome":"Toffia","cap":["02039"],"district":"RI","districtName":"Rieti"},{"nome":"Toirano","cap":["17055"],"district":"SV","districtName":"Savona"},{"nome":"Tolentino","cap":["62029"],"district":"MC","districtName":"Macerata"},{"nome":"Tolfa","cap":["00059"],"district":"RM","districtName":"Roma"},{"nome":"Tollegno","cap":["13818"],"district":"BI","districtName":"Biella"},{"nome":"Tollo","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Tolmezzo","cap":["33028"],"district":"UD","districtName":"Udine"},{"nome":"Tolve","cap":["85017"],"district":"PZ","districtName":"Potenza"},{"nome":"Tombolo","cap":["35019"],"district":"PD","districtName":"Padova"},{"nome":"Ton","cap":["38010"],"district":"TN","districtName":"Trento"},{"nome":"Tonara","cap":["08039"],"district":"NU","districtName":"Nuoro"},{"nome":"Tonco","cap":["14039"],"district":"AT","districtName":"Asti"},{"nome":"Tonengo","cap":["14023"],"district":"AT","districtName":"Asti"},{"nome":"Tonezza del Cimone","cap":["36040"],"district":"VI","districtName":"Vicenza"},{"nome":"Tora e Piccilli","cap":["81044"],"district":"CE","districtName":"Caserta"},{"nome":"Torano Castello","cap":["87010"],"district":"CS","districtName":"Cosenza"},{"nome":"Torano Nuovo","cap":["64010"],"district":"TE","districtName":"Teramo"},{"nome":"Torbole Casaglia","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Torcegno","cap":["38050"],"district":"TN","districtName":"Trento"},{"nome":"Torchiara","cap":["84076"],"district":"SA","districtName":"Salerno"},{"nome":"Torchiarolo","cap":["72020"],"district":"BR","districtName":"Brindisi"},{"nome":"Torella dei Lombardi","cap":["83057"],"district":"AV","districtName":"Avellino"},{"nome":"Torella del Sannio","cap":["86028"],"district":"CB","districtName":"Campobasso"},{"nome":"Torgiano","cap":["06089"],"district":"PG","districtName":"Perugia"},{"nome":"Torgnon","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Torino","cap":["10121","10122","10123","10124","10125","10126","10127","10128","10129","10130","10131","10132","10133","10134","10135","10136","10137","10138","10139","10140","10141","10142","10143","10144","10145","10146","10147","10148","10149","10150","10151","10152","10153","10154","10155","10156"],"district":"TO","districtName":"Torino"},{"nome":"Torino di Sangro","cap":["66020"],"district":"CH","districtName":"Chieti"},{"nome":"Toritto","cap":["70020"],"district":"BA","districtName":"Bari"},{"nome":"Torlino Vimercati","cap":["26017"],"district":"CR","districtName":"Cremona"},{"nome":"Tornaco","cap":["28070"],"district":"NO","districtName":"Novara"},{"nome":"Tornareccio","cap":["66046"],"district":"CH","districtName":"Chieti"},{"nome":"Tornata","cap":["26030"],"district":"CR","districtName":"Cremona"},{"nome":"Tornimparte","cap":["67049"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Torno","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Tornolo","cap":["43059"],"district":"PR","districtName":"Parma"},{"nome":"Toro","cap":["86018"],"district":"CB","districtName":"Campobasso"},{"nome":"Torpè","cap":["08020"],"district":"NU","districtName":"Nuoro"},{"nome":"Torraca","cap":["84030"],"district":"SA","districtName":"Salerno"},{"nome":"Torralba","cap":["07048"],"district":"SS","districtName":"Sassari"},{"nome":"Torrazza Coste","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Torrazza Piemonte","cap":["10037"],"district":"TO","districtName":"Torino"},{"nome":"Torrazzo","cap":["13884"],"district":"BI","districtName":"Biella"},{"nome":"Torre Annunziata","cap":["80058"],"district":"NA","districtName":"Napoli"},{"nome":"Torre Beretti e Castellaro","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Torre Boldone","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Torre Bormida","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Torre Cajetani","cap":["03010"],"district":"FR","districtName":"Frosinone"},{"nome":"Torre Canavese","cap":["10010"],"district":"TO","districtName":"Torino"},{"nome":"Torre d'Arese","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Torre d'Isola","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Torre de' Busi","cap":["23806"],"district":"BG","districtName":"Bergamo"},{"nome":"Torre de' Negri","cap":["27011"],"district":"PV","districtName":"Pavia"},{"nome":"Torre de' Passeri","cap":["65029"],"district":"PE","districtName":"Pescara"},{"nome":"Torre de' Picenardi","cap":["26038"],"district":"CR","districtName":"Cremona"},{"nome":"Torre de' Roveri","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Torre del Greco","cap":["80059"],"district":"NA","districtName":"Napoli"},{"nome":"Torre di Mosto","cap":["30020"],"district":"VE","districtName":"Venezia"},{"nome":"Torre di Ruggiero","cap":["88060"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Torre di Santa Maria","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Torre Le Nocelle","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Torre Mondovì","cap":["12080"],"district":"CN","districtName":"Cuneo"},{"nome":"Torre Orsaia","cap":["84077"],"district":"SA","districtName":"Salerno"},{"nome":"Torre Pallavicina","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Torre Pellice","cap":["10066"],"district":"TO","districtName":"Torino"},{"nome":"Torre San Giorgio","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Torre San Patrizio","cap":["63814"],"district":"FM","districtName":"Fermo"},{"nome":"Torre Santa Susanna","cap":["72028"],"district":"BR","districtName":"Brindisi"},{"nome":"Torreano","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Torrebelvicino","cap":["36036"],"district":"VI","districtName":"Vicenza"},{"nome":"Torrebruna","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Torrecuso","cap":["82030"],"district":"BN","districtName":"Benevento"},{"nome":"Torreglia","cap":["35038"],"district":"PD","districtName":"Padova"},{"nome":"Torregrotta","cap":["98040"],"district":"ME","districtName":"Messina"},{"nome":"Torremaggiore","cap":["71017"],"district":"FG","districtName":"Foggia"},{"nome":"Torrenova","cap":["98070"],"district":"ME","districtName":"Messina"},{"nome":"Torresina","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Torretta","cap":["90040"],"district":"PA","districtName":"Palermo"},{"nome":"Torrevecchia Pia","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Torrevecchia Teatina","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Torri del Benaco","cap":["37010"],"district":"VR","districtName":"Verona"},{"nome":"Torri di Quartesolo","cap":["36040"],"district":"VI","districtName":"Vicenza"},{"nome":"Torri in Sabina","cap":["02049"],"district":"RI","districtName":"Rieti"},{"nome":"Torrice","cap":["03020"],"district":"FR","districtName":"Frosinone"},{"nome":"Torricella","cap":["74020"],"district":"TA","districtName":"Taranto"},{"nome":"Torricella del Pizzo","cap":["26040"],"district":"CR","districtName":"Cremona"},{"nome":"Torricella in Sabina","cap":["02030"],"district":"RI","districtName":"Rieti"},{"nome":"Torricella Peligna","cap":["66019"],"district":"CH","districtName":"Chieti"},{"nome":"Torricella Sicura","cap":["64010"],"district":"TE","districtName":"Teramo"},{"nome":"Torricella Verzate","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Torriglia","cap":["16029"],"district":"GE","districtName":"Genova"},{"nome":"Torrile","cap":["43056"],"district":"PR","districtName":"Parma"},{"nome":"Torrioni","cap":["83010"],"district":"AV","districtName":"Avellino"},{"nome":"Torrita di Siena","cap":["53049"],"district":"SI","districtName":"Siena"},{"nome":"Torrita Tiberina","cap":["00060"],"district":"RM","districtName":"Roma"},{"nome":"Tortolì","cap":["08048"],"district":"NU","districtName":"Nuoro"},{"nome":"Tortona","cap":["15057"],"district":"AL","districtName":"Alessandria"},{"nome":"Tortora","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Tortorella","cap":["84030"],"district":"SA","districtName":"Salerno"},{"nome":"Tortoreto","cap":["64018"],"district":"TE","districtName":"Teramo"},{"nome":"Tortorici","cap":["98078"],"district":"ME","districtName":"Messina"},{"nome":"Torviscosa","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Toscolano-Maderno","cap":["25088"],"district":"BS","districtName":"Brescia"},{"nome":"Tossicia","cap":["64049"],"district":"TE","districtName":"Teramo"},{"nome":"Tovo di Sant'Agata","cap":["23030"],"district":"SO","districtName":"Sondrio"},{"nome":"Tovo San Giacomo","cap":["17020"],"district":"SV","districtName":"Savona"},{"nome":"Trabia","cap":["90019"],"district":"PA","districtName":"Palermo"},{"nome":"Tradate","cap":["21049"],"district":"VA","districtName":"Varese"},{"nome":"Tramatza","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Trambileno","cap":["38068"],"district":"TN","districtName":"Trento"},{"nome":"Tramonti","cap":["84010"],"district":"SA","districtName":"Salerno"},{"nome":"Tramonti di Sopra","cap":["33090"],"district":"PN","districtName":"Pordenone"},{"nome":"Tramonti di Sotto","cap":["33090"],"district":"PN","districtName":"Pordenone"},{"nome":"Tramutola","cap":["85057"],"district":"PZ","districtName":"Potenza"},{"nome":"Trana","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Trani","cap":["76125"],"district":"BT","districtName":"Barletta-Andria-Trani"},{"nome":"Traona","cap":["23019"],"district":"SO","districtName":"Sondrio"},{"nome":"Trapani","cap":["91100"],"district":"TP","districtName":"Trapani"},{"nome":"Trappeto","cap":["90040"],"district":"PA","districtName":"Palermo"},{"nome":"Trarego Viggiona","cap":["28826"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Trasacco","cap":["67059"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Trasaghis","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Trasquera","cap":["28868"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Tratalias","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Travacò Siccomario","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Travagliato","cap":["25039"],"district":"BS","districtName":"Brescia"},{"nome":"Travedona-Monate","cap":["21028"],"district":"VA","districtName":"Varese"},{"nome":"Traversella","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Traversetolo","cap":["43029"],"district":"PR","districtName":"Parma"},{"nome":"Traves","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Travesio","cap":["33090"],"district":"PN","districtName":"Pordenone"},{"nome":"Travo","cap":["29020"],"district":"PC","districtName":"Piacenza"},{"nome":"Tre Ville","cap":["38095"],"district":"TN","districtName":"Trento"},{"nome":"Trebaseleghe","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Trebisacce","cap":["87075"],"district":"CS","districtName":"Cosenza"},{"nome":"Trecase","cap":["80040"],"district":"NA","districtName":"Napoli"},{"nome":"Trecastagni","cap":["95039"],"district":"CT","districtName":"Catania"},{"nome":"Trecastelli","cap":["60012"],"district":"AN","districtName":"Ancona"},{"nome":"Trecate","cap":["28069"],"district":"NO","districtName":"Novara"},{"nome":"Trecchina","cap":["85049"],"district":"PZ","districtName":"Potenza"},{"nome":"Trecenta","cap":["45027"],"district":"RO","districtName":"Rovigo"},{"nome":"Tredozio","cap":["47019"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Treglio","cap":["66030"],"district":"CH","districtName":"Chieti"},{"nome":"Tregnago","cap":["37039"],"district":"VR","districtName":"Verona"},{"nome":"Treia","cap":["62010"],"district":"MC","districtName":"Macerata"},{"nome":"Treiso","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Tremestieri Etneo","cap":["95030"],"district":"CT","districtName":"Catania"},{"nome":"Tremezzina","cap":["22016"],"district":"CO","districtName":"Como"},{"nome":"Tremosine sul Garda","cap":["25010"],"district":"BS","districtName":"Brescia"},{"nome":"Trentinara","cap":["84070"],"district":"SA","districtName":"Salerno"},{"nome":"Trento","cap":["38121","38122","38123"],"district":"TN","districtName":"Trento"},{"nome":"Trentola Ducenta","cap":["81038"],"district":"CE","districtName":"Caserta"},{"nome":"Trenzano","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Treppo Grande","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Treppo Ligosullo","cap":["33014"],"district":"UD","districtName":"Udine"},{"nome":"Trepuzzi","cap":["73019"],"district":"LE","districtName":"Lecce"},{"nome":"Trequanda","cap":["53020"],"district":"SI","districtName":"Siena"},{"nome":"Tresana","cap":["54012"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Trescore Balneario","cap":["24069"],"district":"BG","districtName":"Bergamo"},{"nome":"Trescore Cremasco","cap":["26017"],"district":"CR","districtName":"Cremona"},{"nome":"Tresignana","cap":["44039"],"district":"FE","districtName":"Ferrara"},{"nome":"Tresivio","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Tresnuraghes","cap":["09079"],"district":"OR","districtName":"Oristano"},{"nome":"Trevenzuolo","cap":["37060"],"district":"VR","districtName":"Verona"},{"nome":"Trevi","cap":["06039"],"district":"PG","districtName":"Perugia"},{"nome":"Trevi nel Lazio","cap":["03010"],"district":"FR","districtName":"Frosinone"},{"nome":"Trevico","cap":["83058"],"district":"AV","districtName":"Avellino"},{"nome":"Treviglio","cap":["24047"],"district":"BG","districtName":"Bergamo"},{"nome":"Trevignano","cap":["31040"],"district":"TV","districtName":"Treviso"},{"nome":"Trevignano Romano","cap":["00069"],"district":"RM","districtName":"Roma"},{"nome":"Treville","cap":["15030"],"district":"AL","districtName":"Alessandria"},{"nome":"Treviolo","cap":["24048"],"district":"BG","districtName":"Bergamo"},{"nome":"Treviso","cap":["31100"],"district":"TV","districtName":"Treviso"},{"nome":"Treviso Bresciano","cap":["25070"],"district":"BS","districtName":"Brescia"},{"nome":"Trezzano Rosa","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Trezzano sul Naviglio","cap":["20090"],"district":"MI","districtName":"Milano"},{"nome":"Trezzo sull'Adda","cap":["20056"],"district":"MI","districtName":"Milano"},{"nome":"Trezzo Tinella","cap":["12050"],"district":"CN","districtName":"Cuneo"},{"nome":"Trezzone","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Tribano","cap":["35020"],"district":"PD","districtName":"Padova"},{"nome":"Tribiano","cap":["20067"],"district":"MI","districtName":"Milano"},{"nome":"Tribogna","cap":["16030"],"district":"GE","districtName":"Genova"},{"nome":"Tricarico","cap":["75019"],"district":"MT","districtName":"Matera"},{"nome":"Tricase","cap":["73039"],"district":"LE","districtName":"Lecce"},{"nome":"Tricerro","cap":["13038"],"district":"VC","districtName":"Vercelli"},{"nome":"Tricesimo","cap":["33019"],"district":"UD","districtName":"Udine"},{"nome":"Triei","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Trieste","cap":["34121","34122","34123","34124","34125","34126","34127","34128","34129","34130","34131","34132","34133","34134","34135","34136","34137","34138","34139","34140","34141","34142","34143","34144","34145","34146","34147","34148","34149","34150","34151"],"district":"TS","districtName":"Trieste"},{"nome":"Triggiano","cap":["70019"],"district":"BA","districtName":"Bari"},{"nome":"Trigolo","cap":["26018"],"district":"CR","districtName":"Cremona"},{"nome":"Trinità","cap":["12049"],"district":"CN","districtName":"Cuneo"},{"nome":"Trinità d'Agultu e Vignola","cap":["07038"],"district":"SS","districtName":"Sassari"},{"nome":"Trinitapoli","cap":["76015"],"district":"BT","districtName":"Barletta-Andria-Trani"},{"nome":"Trino","cap":["13039"],"district":"VC","districtName":"Vercelli"},{"nome":"Triora","cap":["18010"],"district":"IM","districtName":"Imperia"},{"nome":"Tripi","cap":["98060"],"district":"ME","districtName":"Messina"},{"nome":"Trisobbio","cap":["15070"],"district":"AL","districtName":"Alessandria"},{"nome":"Trissino","cap":["36070"],"district":"VI","districtName":"Vicenza"},{"nome":"Triuggio","cap":["20844"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Trivento","cap":["86029"],"district":"CB","districtName":"Campobasso"},{"nome":"Trivigliano","cap":["03010"],"district":"FR","districtName":"Frosinone"},{"nome":"Trivignano Udinese","cap":["33050"],"district":"UD","districtName":"Udine"},{"nome":"Trivigno","cap":["85018"],"district":"PZ","districtName":"Potenza"},{"nome":"Trivolzio","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Trodena nel parco naturale","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Trofarello","cap":["10028"],"district":"TO","districtName":"Torino"},{"nome":"Troia","cap":["71029"],"district":"FG","districtName":"Foggia"},{"nome":"Troina","cap":["94018"],"district":"EN","districtName":"Enna"},{"nome":"Tromello","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Trontano","cap":["28859"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Tronzano Lago Maggiore","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Tronzano Vercellese","cap":["13049"],"district":"VC","districtName":"Vercelli"},{"nome":"Tropea","cap":["89861"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Trovo","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Truccazzano","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Tubre","cap":["39020"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Tufara","cap":["86010"],"district":"CB","districtName":"Campobasso"},{"nome":"Tufillo","cap":["66050"],"district":"CH","districtName":"Chieti"},{"nome":"Tufino","cap":["80030"],"district":"NA","districtName":"Napoli"},{"nome":"Tufo","cap":["83010"],"district":"AV","districtName":"Avellino"},{"nome":"Tuglie","cap":["73058"],"district":"LE","districtName":"Lecce"},{"nome":"Tuili","cap":["09029"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Tula","cap":["07010"],"district":"SS","districtName":"Sassari"},{"nome":"Tuoro sul Trasimeno","cap":["06069"],"district":"PG","districtName":"Perugia"},{"nome":"Turania","cap":["02020"],"district":"RI","districtName":"Rieti"},{"nome":"Turano Lodigiano","cap":["26828"],"district":"LO","districtName":"Lodi"},{"nome":"Turate","cap":["22078"],"district":"CO","districtName":"Como"},{"nome":"Turbigo","cap":["20029"],"district":"MI","districtName":"Milano"},{"nome":"Turi","cap":["70010"],"district":"BA","districtName":"Bari"},{"nome":"Turri","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Turriaco","cap":["34070"],"district":"GO","districtName":"Gorizia"},{"nome":"Turrivalignani","cap":["65020"],"district":"PE","districtName":"Pescara"},{"nome":"Tursi","cap":["75028"],"district":"MT","districtName":"Matera"},{"nome":"Tusa","cap":["98079"],"district":"ME","districtName":"Messina"},{"nome":"Tuscania","cap":["01017"],"district":"VT","districtName":"Viterbo"},{"nome":"Ubiale Clanezzo","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Uboldo","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Ucria","cap":["98060"],"district":"ME","districtName":"Messina"},{"nome":"Udine","cap":["33100"],"district":"UD","districtName":"Udine"},{"nome":"Ugento","cap":["73059"],"district":"LE","districtName":"Lecce"},{"nome":"Uggiano la Chiesa","cap":["73020"],"district":"LE","districtName":"Lecce"},{"nome":"Uggiate-Trevano","cap":["22029"],"district":"CO","districtName":"Como"},{"nome":"Ulà Tirso","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Ulassai","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Ultimo","cap":["39016"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Umbertide","cap":["06019"],"district":"PG","districtName":"Perugia"},{"nome":"Umbriatico","cap":["88823"],"district":"KR","districtName":"Crotone"},{"nome":"Urago d'Oglio","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Uras","cap":["09099"],"district":"OR","districtName":"Oristano"},{"nome":"Urbana","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Urbania","cap":["61049"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Urbe","cap":["17048"],"district":"SV","districtName":"Savona"},{"nome":"Urbino","cap":["61029"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Urbisaglia","cap":["62010"],"district":"MC","districtName":"Macerata"},{"nome":"Urgnano","cap":["24059"],"district":"BG","districtName":"Bergamo"},{"nome":"Uri","cap":["07040"],"district":"SS","districtName":"Sassari"},{"nome":"Ururi","cap":["86049"],"district":"CB","districtName":"Campobasso"},{"nome":"Urzulei","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Uscio","cap":["16036"],"district":"GE","districtName":"Genova"},{"nome":"Usellus","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Usini","cap":["07049"],"district":"SS","districtName":"Sassari"},{"nome":"Usmate Velate","cap":["20865"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Ussana","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Ussaramanna","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Ussassai","cap":["08040"],"district":"NU","districtName":"Nuoro"},{"nome":"Usseaux","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Usseglio","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Ussita","cap":["62039"],"district":"MC","districtName":"Macerata"},{"nome":"Ustica","cap":["90051"],"district":"PA","districtName":"Palermo"},{"nome":"Uta","cap":["09068"],"district":"CA","districtName":"Cagliari"},{"nome":"Uzzano","cap":["51010"],"district":"PT","districtName":"Pistoia"},{"nome":"Vaccarizzo Albanese","cap":["87060"],"district":"CS","districtName":"Cosenza"},{"nome":"Vacone","cap":["02040"],"district":"RI","districtName":"Rieti"},{"nome":"Vacri","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Vadena","cap":["39051"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Vado Ligure","cap":["17047"],"district":"SV","districtName":"Savona"},{"nome":"Vagli Sotto","cap":["55030"],"district":"LU","districtName":"Lucca"},{"nome":"Vaglia","cap":["50036"],"district":"FI","districtName":"Firenze"},{"nome":"Vaglio Basilicata","cap":["85010"],"district":"PZ","districtName":"Potenza"},{"nome":"Vaglio Serra","cap":["14049"],"district":"AT","districtName":"Asti"},{"nome":"Vaiano","cap":["59021"],"district":"PO","districtName":"Prato"},{"nome":"Vaiano Cremasco","cap":["26010"],"district":"CR","districtName":"Cremona"},{"nome":"Vaie","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Vailate","cap":["26019"],"district":"CR","districtName":"Cremona"},{"nome":"Vairano Patenora","cap":["81058"],"district":"CE","districtName":"Caserta"},{"nome":"Vajont","cap":["33080"],"district":"PN","districtName":"Pordenone"},{"nome":"Val Brembilla","cap":["24012"],"district":"BG","districtName":"Bergamo"},{"nome":"Val della Torre","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Val di Chy","cap":["10039"],"district":"TO","districtName":"Torino"},{"nome":"Val di Nizza","cap":["27050"],"district":"PV","districtName":"Pavia"},{"nome":"Val di Vizze","cap":["39049"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Val di Zoldo","cap":["32012"],"district":"BL","districtName":"Belluno"},{"nome":"Val Liona","cap":["36044"],"district":"VI","districtName":"Vicenza"},{"nome":"Val Masino","cap":["23010"],"district":"SO","districtName":"Sondrio"},{"nome":"Val Rezzo","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Valbondione","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Valbrembo","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Valbrenta","cap":["36029"],"district":"VI","districtName":"Vicenza"},{"nome":"Valbrevenna","cap":["16010"],"district":"GE","districtName":"Genova"},{"nome":"Valbrona","cap":["22039"],"district":"CO","districtName":"Como"},{"nome":"Valchiusa","cap":["10089"],"district":"TO","districtName":"Torino"},{"nome":"Valdagno","cap":["36078"],"district":"VI","districtName":"Vicenza"},{"nome":"Valdaone","cap":["38091"],"district":"TN","districtName":"Trento"},{"nome":"Valdaora","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Valdastico","cap":["36040"],"district":"VI","districtName":"Vicenza"},{"nome":"Valdengo","cap":["13855"],"district":"BI","districtName":"Biella"},{"nome":"Valderice","cap":["91019"],"district":"TP","districtName":"Trapani"},{"nome":"Valdidentro","cap":["23038"],"district":"SO","districtName":"Sondrio"},{"nome":"Valdieri","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Valdilana","cap":["13835"],"district":"BI","districtName":"Biella"},{"nome":"Valdina","cap":["98040"],"district":"ME","districtName":"Messina"},{"nome":"Valdisotto","cap":["23030"],"district":"SO","districtName":"Sondrio"},{"nome":"Valdobbiadene","cap":["31049"],"district":"TV","districtName":"Treviso"},{"nome":"Valduggia","cap":["13018"],"district":"VC","districtName":"Vercelli"},{"nome":"Valeggio","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Valeggio sul Mincio","cap":["37067"],"district":"VR","districtName":"Verona"},{"nome":"Valentano","cap":["01018"],"district":"VT","districtName":"Viterbo"},{"nome":"Valenza","cap":["15048"],"district":"AL","districtName":"Alessandria"},{"nome":"Valenzano","cap":["70010"],"district":"BA","districtName":"Bari"},{"nome":"Valera Fratta","cap":["26859"],"district":"LO","districtName":"Lodi"},{"nome":"Valfabbrica","cap":["06029"],"district":"PG","districtName":"Perugia"},{"nome":"Valfenera","cap":["14017"],"district":"AT","districtName":"Asti"},{"nome":"Valfloriana","cap":["38040"],"district":"TN","districtName":"Trento"},{"nome":"Valfornace","cap":["62031"],"district":"MC","districtName":"Macerata"},{"nome":"Valfurva","cap":["23030"],"district":"SO","districtName":"Sondrio"},{"nome":"Valganna","cap":["21039"],"district":"VA","districtName":"Varese"},{"nome":"Valgioie","cap":["10094"],"district":"TO","districtName":"Torino"},{"nome":"Valgoglio","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Valgrana","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Valgreghentino","cap":["23857"],"district":"LC","districtName":"Lecco"},{"nome":"Valgrisenche","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Valguarnera Caropepe","cap":["94019"],"district":"EN","districtName":"Enna"},{"nome":"Vallada Agordina","cap":["32020"],"district":"BL","districtName":"Belluno"},{"nome":"Vallanzengo","cap":["13847"],"district":"BI","districtName":"Biella"},{"nome":"Vallarsa","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Vallata","cap":["83059"],"district":"AV","districtName":"Avellino"},{"nome":"Valle Agricola","cap":["81010"],"district":"CE","districtName":"Caserta"},{"nome":"Valle Aurina","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Valle Cannobina","cap":["28827"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Valle Castellana","cap":["64010"],"district":"TE","districtName":"Teramo"},{"nome":"Valle dell'Angelo","cap":["84070"],"district":"SA","districtName":"Salerno"},{"nome":"Valle di Cadore","cap":["32040"],"district":"BL","districtName":"Belluno"},{"nome":"Valle di Casies","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Valle di Maddaloni","cap":["81020"],"district":"CE","districtName":"Caserta"},{"nome":"Valle Lomellina","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Valle Salimbene","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Valle San Nicolao","cap":["13847"],"district":"BI","districtName":"Biella"},{"nome":"Vallebona","cap":["18012"],"district":"IM","districtName":"Imperia"},{"nome":"Vallecorsa","cap":["03020"],"district":"FR","districtName":"Frosinone"},{"nome":"Vallecrosia","cap":["18019"],"district":"IM","districtName":"Imperia"},{"nome":"Valledolmo","cap":["90029"],"district":"PA","districtName":"Palermo"},{"nome":"Valledoria","cap":["07039"],"district":"SS","districtName":"Sassari"},{"nome":"Vallefiorita","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Vallefoglia","cap":["61022"],"district":"PU","districtName":"Pesaro e Urbino"},{"nome":"Vallelaghi","cap":["38096"],"district":"TN","districtName":"Trento"},{"nome":"Vallelonga","cap":["89821"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Vallelunga Pratameno","cap":["93010"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Vallemaio","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Vallepietra","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Vallerano","cap":["01030"],"district":"VT","districtName":"Viterbo"},{"nome":"Vallermosa","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Vallerotonda","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Vallesaccarda","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"Valleve","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Valli del Pasubio","cap":["36030"],"district":"VI","districtName":"Vicenza"},{"nome":"Vallinfreda","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Vallio Terme","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Vallo della Lucania","cap":["84078"],"district":"SA","districtName":"Salerno"},{"nome":"Vallo di Nera","cap":["06040"],"district":"PG","districtName":"Perugia"},{"nome":"Vallo Torinese","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Valloriate","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Valmacca","cap":["15040"],"district":"AL","districtName":"Alessandria"},{"nome":"Valmadrera","cap":["23868"],"district":"LC","districtName":"Lecco"},{"nome":"Valmontone","cap":["00038"],"district":"RM","districtName":"Roma"},{"nome":"Valmorea","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Valmozzola","cap":["43050"],"district":"PR","districtName":"Parma"},{"nome":"Valnegra","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Valpelline","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Valperga","cap":["10087"],"district":"TO","districtName":"Torino"},{"nome":"Valprato Soana","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Valsamoggia","cap":["40053"],"district":"BO","districtName":"Bologna"},{"nome":"Valsavarenche","cap":["11010"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Valsinni","cap":["75029"],"district":"MT","districtName":"Matera"},{"nome":"Valsolda","cap":["22010"],"district":"CO","districtName":"Como"},{"nome":"Valstrona","cap":["28897"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Valtopina","cap":["06030"],"district":"PG","districtName":"Perugia"},{"nome":"Valtorta","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Valtournenche","cap":["11028"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Valva","cap":["84020"],"district":"SA","districtName":"Salerno"},{"nome":"Valvarrone","cap":["23836"],"district":"LC","districtName":"Lecco"},{"nome":"Valvasone Arzene","cap":["33098"],"district":"PN","districtName":"Pordenone"},{"nome":"Valverde","cap":["95028"],"district":"CT","districtName":"Catania"},{"nome":"Valvestino","cap":["25080"],"district":"BS","districtName":"Brescia"},{"nome":"Vandoies","cap":["39030"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Vanzaghello","cap":["20020"],"district":"MI","districtName":"Milano"},{"nome":"Vanzago","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Vanzone con San Carlo","cap":["28879"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Vaprio d'Adda","cap":["20069"],"district":"MI","districtName":"Milano"},{"nome":"Vaprio d'Agogna","cap":["28010"],"district":"NO","districtName":"Novara"},{"nome":"Varallo","cap":["13019"],"district":"VC","districtName":"Vercelli"},{"nome":"Varallo Pombia","cap":["28040"],"district":"NO","districtName":"Novara"},{"nome":"Varano Borghi","cap":["21020"],"district":"VA","districtName":"Varese"},{"nome":"Varano de' Melegari","cap":["43040"],"district":"PR","districtName":"Parma"},{"nome":"Varapodio","cap":["89010"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Varazze","cap":["17019"],"district":"SV","districtName":"Savona"},{"nome":"Varco Sabino","cap":["02020"],"district":"RI","districtName":"Rieti"},{"nome":"Varedo","cap":["20814"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Varenna","cap":["23829"],"district":"LC","districtName":"Lecco"},{"nome":"Varese","cap":["21100"],"district":"VA","districtName":"Varese"},{"nome":"Varese Ligure","cap":["19028"],"district":"SP","districtName":"La Spezia"},{"nome":"Varisella","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Varmo","cap":["33030"],"district":"UD","districtName":"Udine"},{"nome":"Varna","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Varsi","cap":["43049"],"district":"PR","districtName":"Parma"},{"nome":"Varzi","cap":["27057"],"district":"PV","districtName":"Pavia"},{"nome":"Varzo","cap":["28868"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Vasanello","cap":["01030"],"district":"VT","districtName":"Viterbo"},{"nome":"Vasia","cap":["18020"],"district":"IM","districtName":"Imperia"},{"nome":"Vasto","cap":["66054"],"district":"CH","districtName":"Chieti"},{"nome":"Vastogirardi","cap":["86089"],"district":"IS","districtName":"Isernia"},{"nome":"Vauda Canavese","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Vazzano","cap":["89834"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Vazzola","cap":["31028"],"district":"TV","districtName":"Treviso"},{"nome":"Vecchiano","cap":["56019"],"district":"PI","districtName":"Pisa"},{"nome":"Vedano al Lambro","cap":["20854"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Vedano Olona","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Vedelago","cap":["31050"],"district":"TV","districtName":"Treviso"},{"nome":"Vedeseta","cap":["24010"],"district":"BG","districtName":"Bergamo"},{"nome":"Veduggio con Colzano","cap":["20837"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Veggiano","cap":["35030"],"district":"PD","districtName":"Padova"},{"nome":"Veglie","cap":["73010"],"district":"LE","districtName":"Lecce"},{"nome":"Veglio","cap":["13824"],"district":"BI","districtName":"Biella"},{"nome":"Vejano","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Veleso","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Velezzo Lomellina","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Velletri","cap":["00049"],"district":"RM","districtName":"Roma"},{"nome":"Vellezzo Bellini","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Velo d'Astico","cap":["36010"],"district":"VI","districtName":"Vicenza"},{"nome":"Velo Veronese","cap":["37030"],"district":"VR","districtName":"Verona"},{"nome":"Velturno","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Venafro","cap":["86079"],"district":"IS","districtName":"Isernia"},{"nome":"Venaria Reale","cap":["10078"],"district":"TO","districtName":"Torino"},{"nome":"Venarotta","cap":["63091"],"district":"AP","districtName":"Ascoli Piceno"},{"nome":"Venasca","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Venaus","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Vendone","cap":["17032"],"district":"SV","districtName":"Savona"},{"nome":"Venegono Inferiore","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Venegono Superiore","cap":["21040"],"district":"VA","districtName":"Varese"},{"nome":"Venetico","cap":["98040"],"district":"ME","districtName":"Messina"},{"nome":"Venezia","cap":["30121","30122","30123","30124","30125","30126","30127","30128","30129","30130","30131","30132","30133","30134","30135","30136","30137","30138","30139","30140","30141","30142","30143","30144","30145","30146","30147","30148","30149","30150","30151","30152","30153","30154","30155","30156","30157","30158","30159","30160","30161","30162","30163","30164","30165","30166","30167","30168","30169","30170","30171","30172","30173","30174","30175","30176"],"district":"VE","districtName":"Venezia"},{"nome":"Veniano","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Venosa","cap":["85029"],"district":"PZ","districtName":"Potenza"},{"nome":"Ventasso","cap":["42032"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Venticano","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Ventimiglia","cap":["18039"],"district":"IM","districtName":"Imperia"},{"nome":"Ventimiglia di Sicilia","cap":["90020"],"district":"PA","districtName":"Palermo"},{"nome":"Ventotene","cap":["04031"],"district":"LT","districtName":"Latina"},{"nome":"Venzone","cap":["33010"],"district":"UD","districtName":"Udine"},{"nome":"Verano","cap":["39010"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Verano Brianza","cap":["20843"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Verbania","cap":["28921","28922","28923","28924","28925"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Verbicaro","cap":["87020"],"district":"CS","districtName":"Cosenza"},{"nome":"Vercana","cap":["22013"],"district":"CO","districtName":"Como"},{"nome":"Verceia","cap":["23020"],"district":"SO","districtName":"Sondrio"},{"nome":"Vercelli","cap":["13100"],"district":"VC","districtName":"Vercelli"},{"nome":"Vercurago","cap":["23808"],"district":"LC","districtName":"Lecco"},{"nome":"Verdellino","cap":["24040"],"district":"BG","districtName":"Bergamo"},{"nome":"Verdello","cap":["24049"],"district":"BG","districtName":"Bergamo"},{"nome":"Verderio","cap":["23879"],"district":"LC","districtName":"Lecco"},{"nome":"Verduno","cap":["12060"],"district":"CN","districtName":"Cuneo"},{"nome":"Vergato","cap":["40038"],"district":"BO","districtName":"Bologna"},{"nome":"Verghereto","cap":["47028"],"district":"FC","districtName":"Forlì-Cesena"},{"nome":"Vergiate","cap":["21029"],"district":"VA","districtName":"Varese"},{"nome":"Vermezzo con Zelo","cap":["20071"],"district":"MI","districtName":"Milano"},{"nome":"Vermiglio","cap":["38029"],"district":"TN","districtName":"Trento"},{"nome":"Vernante","cap":["12019"],"district":"CN","districtName":"Cuneo"},{"nome":"Vernasca","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Vernate","cap":["20080"],"district":"MI","districtName":"Milano"},{"nome":"Vernazza","cap":["19018"],"district":"SP","districtName":"La Spezia"},{"nome":"Vernio","cap":["59024"],"district":"PO","districtName":"Prato"},{"nome":"Vernole","cap":["73029"],"district":"LE","districtName":"Lecce"},{"nome":"Verolanuova","cap":["25028"],"district":"BS","districtName":"Brescia"},{"nome":"Verolavecchia","cap":["25029"],"district":"BS","districtName":"Brescia"},{"nome":"Verolengo","cap":["10038"],"district":"TO","districtName":"Torino"},{"nome":"Veroli","cap":["03029"],"district":"FR","districtName":"Frosinone"},{"nome":"Verona","cap":["37121","37122","37123","37124","37125","37126","37127","37128","37129","37130","37131","37132","37133","37134","37135","37136","37137","37138","37139","37140","37141","37142"],"district":"VR","districtName":"Verona"},{"nome":"Veronella","cap":["37040"],"district":"VR","districtName":"Verona"},{"nome":"Verrayes","cap":["11020"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Verrès","cap":["11029"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Verretto","cap":["27053"],"district":"PV","districtName":"Pavia"},{"nome":"Verrone","cap":["13871"],"district":"BI","districtName":"Biella"},{"nome":"Verrua Po","cap":["27040"],"district":"PV","districtName":"Pavia"},{"nome":"Verrua Savoia","cap":["10020"],"district":"TO","districtName":"Torino"},{"nome":"Vertemate con Minoprio","cap":["22070"],"district":"CO","districtName":"Como"},{"nome":"Vertova","cap":["24029"],"district":"BG","districtName":"Bergamo"},{"nome":"Verucchio","cap":["47826"],"district":"RN","districtName":"Rimini"},{"nome":"Vervio","cap":["23030"],"district":"SO","districtName":"Sondrio"},{"nome":"Verzegnis","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Verzino","cap":["88819"],"district":"KR","districtName":"Crotone"},{"nome":"Verzuolo","cap":["12039"],"district":"CN","districtName":"Cuneo"},{"nome":"Vescovana","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Vescovato","cap":["26039"],"district":"CR","districtName":"Cremona"},{"nome":"Vesime","cap":["14059"],"district":"AT","districtName":"Asti"},{"nome":"Vespolate","cap":["28079"],"district":"NO","districtName":"Novara"},{"nome":"Vessalico","cap":["18026"],"district":"IM","districtName":"Imperia"},{"nome":"Vestenanova","cap":["37030"],"district":"VR","districtName":"Verona"},{"nome":"Vestignè","cap":["10030"],"district":"TO","districtName":"Torino"},{"nome":"Vestone","cap":["25078"],"district":"BS","districtName":"Brescia"},{"nome":"Vetralla","cap":["01019"],"district":"VT","districtName":"Viterbo"},{"nome":"Vetto","cap":["42020"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Vezza d'Alba","cap":["12040"],"district":"CN","districtName":"Cuneo"},{"nome":"Vezza d'Oglio","cap":["25059"],"district":"BS","districtName":"Brescia"},{"nome":"Vezzano Ligure","cap":["19020"],"district":"SP","districtName":"La Spezia"},{"nome":"Vezzano sul Crostolo","cap":["42030"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Vezzi Portio","cap":["17028"],"district":"SV","districtName":"Savona"},{"nome":"Viadana","cap":["46019"],"district":"MN","districtName":"Mantova"},{"nome":"Viadanica","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Viagrande","cap":["95029"],"district":"CT","districtName":"Catania"},{"nome":"Viale","cap":["14010"],"district":"AT","districtName":"Asti"},{"nome":"Vialfrè","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Viano","cap":["42030"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Viareggio","cap":["55049"],"district":"LU","districtName":"Lucca"},{"nome":"Viarigi","cap":["14030"],"district":"AT","districtName":"Asti"},{"nome":"Vibo Valentia","cap":["89900"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Vibonati","cap":["84079"],"district":"SA","districtName":"Salerno"},{"nome":"Vicalvi","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Vicari","cap":["90020"],"district":"PA","districtName":"Palermo"},{"nome":"Vicchio","cap":["50039"],"district":"FI","districtName":"Firenze"},{"nome":"Vicenza","cap":["36100"],"district":"VI","districtName":"Vicenza"},{"nome":"Vico del Gargano","cap":["71018"],"district":"FG","districtName":"Foggia"},{"nome":"Vico Equense","cap":["80069"],"district":"NA","districtName":"Napoli"},{"nome":"Vico nel Lazio","cap":["03010"],"district":"FR","districtName":"Frosinone"},{"nome":"Vicoforte","cap":["12080"],"district":"CN","districtName":"Cuneo"},{"nome":"Vicoli","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Vicolungo","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"Vicopisano","cap":["56010"],"district":"PI","districtName":"Pisa"},{"nome":"Vicovaro","cap":["00029"],"district":"RM","districtName":"Roma"},{"nome":"Viddalba","cap":["07030"],"district":"SS","districtName":"Sassari"},{"nome":"Vidigulfo","cap":["27018"],"district":"PV","districtName":"Pavia"},{"nome":"Vidor","cap":["31020"],"district":"TV","districtName":"Treviso"},{"nome":"Vidracco","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Vieste","cap":["71019"],"district":"FG","districtName":"Foggia"},{"nome":"Vietri di Potenza","cap":["85058"],"district":"PZ","districtName":"Potenza"},{"nome":"Vietri sul Mare","cap":["84019"],"district":"SA","districtName":"Salerno"},{"nome":"Viganò","cap":["23897"],"district":"LC","districtName":"Lecco"},{"nome":"Vigano San Martino","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Vigarano Mainarda","cap":["44049"],"district":"FE","districtName":"Ferrara"},{"nome":"Vigasio","cap":["37068"],"district":"VR","districtName":"Verona"},{"nome":"Vigevano","cap":["27029"],"district":"PV","districtName":"Pavia"},{"nome":"Viggianello","cap":["85040"],"district":"PZ","districtName":"Potenza"},{"nome":"Viggiano","cap":["85059"],"district":"PZ","districtName":"Potenza"},{"nome":"Viggiù","cap":["21059"],"district":"VA","districtName":"Varese"},{"nome":"Vighizzolo d'Este","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Vigliano Biellese","cap":["13856"],"district":"BI","districtName":"Biella"},{"nome":"Vigliano d'Asti","cap":["14040"],"district":"AT","districtName":"Asti"},{"nome":"Vignale Monferrato","cap":["15049"],"district":"AL","districtName":"Alessandria"},{"nome":"Vignanello","cap":["01039"],"district":"VT","districtName":"Viterbo"},{"nome":"Vignate","cap":["20060"],"district":"MI","districtName":"Milano"},{"nome":"Vignola","cap":["41058"],"district":"MO","districtName":"Modena"},{"nome":"Vignola-Falesina","cap":["38057"],"district":"TN","districtName":"Trento"},{"nome":"Vignole Borbera","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Vignolo","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Vignone","cap":["28819"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Vigo di Cadore","cap":["32040"],"district":"BL","districtName":"Belluno"},{"nome":"Vigodarzere","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Vigolo","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Vigolzone","cap":["29020"],"district":"PC","districtName":"Piacenza"},{"nome":"Vigone","cap":["10067"],"district":"TO","districtName":"Torino"},{"nome":"Vigonovo","cap":["30030"],"district":"VE","districtName":"Venezia"},{"nome":"Vigonza","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Viguzzolo","cap":["15058"],"district":"AL","districtName":"Alessandria"},{"nome":"Villa Bartolomea","cap":["37049"],"district":"VR","districtName":"Verona"},{"nome":"Villa Basilica","cap":["55019"],"district":"LU","districtName":"Lucca"},{"nome":"Villa Biscossi","cap":["27035"],"district":"PV","districtName":"Pavia"},{"nome":"Villa Carcina","cap":["25069"],"district":"BS","districtName":"Brescia"},{"nome":"Villa Castelli","cap":["72029"],"district":"BR","districtName":"Brindisi"},{"nome":"Villa Celiera","cap":["65010"],"district":"PE","districtName":"Pescara"},{"nome":"Villa Collemandina","cap":["55030"],"district":"LU","districtName":"Lucca"},{"nome":"Villa Cortese","cap":["20020"],"district":"MI","districtName":"Milano"},{"nome":"Villa d'Adda","cap":["24030"],"district":"BG","districtName":"Bergamo"},{"nome":"Villa d'Almè","cap":["24018"],"district":"BG","districtName":"Bergamo"},{"nome":"Villa d'Ogna","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Villa del Bosco","cap":["13868"],"district":"BI","districtName":"Biella"},{"nome":"Villa del Conte","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Villa di Briano","cap":["81030"],"district":"CE","districtName":"Caserta"},{"nome":"Villa di Chiavenna","cap":["23029"],"district":"SO","districtName":"Sondrio"},{"nome":"Villa di Serio","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Villa di Tirano","cap":["23030"],"district":"SO","districtName":"Sondrio"},{"nome":"Villa Estense","cap":["35040"],"district":"PD","districtName":"Padova"},{"nome":"Villa Faraldi","cap":["18010"],"district":"IM","districtName":"Imperia"},{"nome":"Villa Guardia","cap":["22079"],"district":"CO","districtName":"Como"},{"nome":"Villa Lagarina","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Villa Latina","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Villa Literno","cap":["81039"],"district":"CE","districtName":"Caserta"},{"nome":"Villa Minozzo","cap":["42030"],"district":"RE","districtName":"Reggio nell'Emilia"},{"nome":"Villa San Giovanni","cap":["89018"],"district":"RC","districtName":"Reggio Calabria"},{"nome":"Villa San Giovanni in Tuscia","cap":["01010"],"district":"VT","districtName":"Viterbo"},{"nome":"Villa San Pietro","cap":["09050"],"district":"CA","districtName":"Cagliari"},{"nome":"Villa San Secondo","cap":["14020"],"district":"AT","districtName":"Asti"},{"nome":"Villa Sant'Angelo","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Villa Sant'Antonio","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Villa Santa Lucia","cap":["03030"],"district":"FR","districtName":"Frosinone"},{"nome":"Villa Santa Lucia degli Abruzzi","cap":["67020"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Villa Santa Maria","cap":["66047"],"district":"CH","districtName":"Chieti"},{"nome":"Villa Santina","cap":["33029"],"district":"UD","districtName":"Udine"},{"nome":"Villa Santo Stefano","cap":["03020"],"district":"FR","districtName":"Frosinone"},{"nome":"Villa Verde","cap":["09090"],"district":"OR","districtName":"Oristano"},{"nome":"Villabassa","cap":["39039"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Villabate","cap":["90039"],"district":"PA","districtName":"Palermo"},{"nome":"Villachiara","cap":["25030"],"district":"BS","districtName":"Brescia"},{"nome":"Villacidro","cap":["09039"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Villadeati","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Villadose","cap":["45010"],"district":"RO","districtName":"Rovigo"},{"nome":"Villadossola","cap":["28844"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Villafalletto","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Villafranca d'Asti","cap":["14018"],"district":"AT","districtName":"Asti"},{"nome":"Villafranca di Verona","cap":["37069"],"district":"VR","districtName":"Verona"},{"nome":"Villafranca in Lunigiana","cap":["54028"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Villafranca Padovana","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Villafranca Piemonte","cap":["10068"],"district":"TO","districtName":"Torino"},{"nome":"Villafranca Sicula","cap":["92020"],"district":"AG","districtName":"Agrigento"},{"nome":"Villafranca Tirrena","cap":["98049"],"district":"ME","districtName":"Messina"},{"nome":"Villafrati","cap":["90030"],"district":"PA","districtName":"Palermo"},{"nome":"Villaga","cap":["36021"],"district":"VI","districtName":"Vicenza"},{"nome":"Villagrande Strisaili","cap":["08049"],"district":"NU","districtName":"Nuoro"},{"nome":"Villalago","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Villalba","cap":["93010"],"district":"CL","districtName":"Caltanissetta"},{"nome":"Villalfonsina","cap":["66020"],"district":"CH","districtName":"Chieti"},{"nome":"Villalvernia","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Villamagna","cap":["66010"],"district":"CH","districtName":"Chieti"},{"nome":"Villamaina","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"Villamar","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Villamarzana","cap":["45030"],"district":"RO","districtName":"Rovigo"},{"nome":"Villamassargia","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Villamiroglio","cap":["15020"],"district":"AL","districtName":"Alessandria"},{"nome":"Villandro","cap":["39040"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Villanova Biellese","cap":["13877"],"district":"BI","districtName":"Biella"},{"nome":"Villanova Canavese","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Villanova d'Albenga","cap":["17038"],"district":"SV","districtName":"Savona"},{"nome":"Villanova d'Ardenghi","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Villanova d'Asti","cap":["14019"],"district":"AT","districtName":"Asti"},{"nome":"Villanova del Battista","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Villanova del Ghebbo","cap":["45020"],"district":"RO","districtName":"Rovigo"},{"nome":"Villanova del Sillaro","cap":["26818"],"district":"LO","districtName":"Lodi"},{"nome":"Villanova di Camposampiero","cap":["35010"],"district":"PD","districtName":"Padova"},{"nome":"Villanova Marchesana","cap":["45030"],"district":"RO","districtName":"Rovigo"},{"nome":"Villanova Mondovì","cap":["12089"],"district":"CN","districtName":"Cuneo"},{"nome":"Villanova Monferrato","cap":["15030"],"district":"AL","districtName":"Alessandria"},{"nome":"Villanova Monteleone","cap":["07019"],"district":"SS","districtName":"Sassari"},{"nome":"Villanova Solaro","cap":["12030"],"district":"CN","districtName":"Cuneo"},{"nome":"Villanova sull'Arda","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Villanova Truschedu","cap":["09084"],"district":"OR","districtName":"Oristano"},{"nome":"Villanova Tulo","cap":["09066"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Villanovaforru","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Villanovafranca","cap":["09020"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Villanterio","cap":["27019"],"district":"PV","districtName":"Pavia"},{"nome":"Villanuova sul Clisi","cap":["25089"],"district":"BS","districtName":"Brescia"},{"nome":"Villaperuccio","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Villapiana","cap":["87076"],"district":"CS","districtName":"Cosenza"},{"nome":"Villaputzu","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Villar Dora","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Villar Focchiardo","cap":["10050"],"district":"TO","districtName":"Torino"},{"nome":"Villar Pellice","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Villar Perosa","cap":["10069"],"district":"TO","districtName":"Torino"},{"nome":"Villar San Costanzo","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Villarbasse","cap":["10090"],"district":"TO","districtName":"Torino"},{"nome":"Villarboit","cap":["13030"],"district":"VC","districtName":"Vercelli"},{"nome":"Villareggia","cap":["10030"],"district":"TO","districtName":"Torino"},{"nome":"Villaricca","cap":["80010"],"district":"NA","districtName":"Napoli"},{"nome":"Villaromagnano","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Villarosa","cap":["94010"],"district":"EN","districtName":"Enna"},{"nome":"Villasalto","cap":["09040"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Villasanta","cap":["20852"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Villasimius","cap":["09049"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Villasor","cap":["09034"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Villaspeciosa","cap":["09010"],"district":"SU","districtName":"Sud Sardegna"},{"nome":"Villastellone","cap":["10029"],"district":"TO","districtName":"Torino"},{"nome":"Villata","cap":["13010"],"district":"VC","districtName":"Vercelli"},{"nome":"Villaurbana","cap":["09080"],"district":"OR","districtName":"Oristano"},{"nome":"Villavallelonga","cap":["67050"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Villaverla","cap":["36030"],"district":"VI","districtName":"Vicenza"},{"nome":"Ville d'Anaunia","cap":["38019"],"district":"TN","districtName":"Trento"},{"nome":"Ville di Fiemme","cap":["38033","38030"],"district":"TN","districtName":"Trento"},{"nome":"Villeneuve","cap":["11018"],"district":"AO","districtName":"Valle d'Aosta/Vallée d'Aoste"},{"nome":"Villesse","cap":["34070"],"district":"GO","districtName":"Gorizia"},{"nome":"Villetta Barrea","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Villette","cap":["28856"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Villimpenta","cap":["46039"],"district":"MN","districtName":"Mantova"},{"nome":"Villongo","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Villorba","cap":["31020"],"district":"TV","districtName":"Treviso"},{"nome":"Vilminore di Scalve","cap":["24020"],"district":"BG","districtName":"Bergamo"},{"nome":"Vimercate","cap":["20871"],"district":"MB","districtName":"Monza e della Brianza"},{"nome":"Vimodrone","cap":["20090"],"district":"MI","districtName":"Milano"},{"nome":"Vinadio","cap":["12010"],"district":"CN","districtName":"Cuneo"},{"nome":"Vinchiaturo","cap":["86019"],"district":"CB","districtName":"Campobasso"},{"nome":"Vinchio","cap":["14040"],"district":"AT","districtName":"Asti"},{"nome":"Vinci","cap":["50059"],"district":"FI","districtName":"Firenze"},{"nome":"Vinovo","cap":["10048"],"district":"TO","districtName":"Torino"},{"nome":"Vinzaglio","cap":["28060"],"district":"NO","districtName":"Novara"},{"nome":"Viola","cap":["12070"],"district":"CN","districtName":"Cuneo"},{"nome":"Vione","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Vipiteno","cap":["39049"],"district":"BZ","districtName":"Bolzano/Bozen"},{"nome":"Virle Piemonte","cap":["10060"],"district":"TO","districtName":"Torino"},{"nome":"Visano","cap":["25010"],"district":"BS","districtName":"Brescia"},{"nome":"Vische","cap":["10030"],"district":"TO","districtName":"Torino"},{"nome":"Visciano","cap":["80030"],"district":"NA","districtName":"Napoli"},{"nome":"Visco","cap":["33040"],"district":"UD","districtName":"Udine"},{"nome":"Visone","cap":["15010"],"district":"AL","districtName":"Alessandria"},{"nome":"Visso","cap":["62039"],"district":"MC","districtName":"Macerata"},{"nome":"Vistarino","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Vistrorio","cap":["10080"],"district":"TO","districtName":"Torino"},{"nome":"Vita","cap":["91010"],"district":"TP","districtName":"Trapani"},{"nome":"Viterbo","cap":["01100"],"district":"VT","districtName":"Viterbo"},{"nome":"Viticuso","cap":["03040"],"district":"FR","districtName":"Frosinone"},{"nome":"Vito d'Asio","cap":["33090"],"district":"PN","districtName":"Pordenone"},{"nome":"Vitorchiano","cap":["01030"],"district":"VT","districtName":"Viterbo"},{"nome":"Vittoria","cap":["97019"],"district":"RG","districtName":"Ragusa"},{"nome":"Vittorio Veneto","cap":["31029"],"district":"TV","districtName":"Treviso"},{"nome":"Vittorito","cap":["67030"],"district":"AQ","districtName":"L'Aquila"},{"nome":"Vittuone","cap":["20010"],"district":"MI","districtName":"Milano"},{"nome":"Vitulano","cap":["82038"],"district":"BN","districtName":"Benevento"},{"nome":"Vitulazio","cap":["81041"],"district":"CE","districtName":"Caserta"},{"nome":"Viù","cap":["10070"],"district":"TO","districtName":"Torino"},{"nome":"Vivaro","cap":["33099"],"district":"PN","districtName":"Pordenone"},{"nome":"Vivaro Romano","cap":["00020"],"district":"RM","districtName":"Roma"},{"nome":"Viverone","cap":["13886"],"district":"BI","districtName":"Biella"},{"nome":"Vizzini","cap":["95049"],"district":"CT","districtName":"Catania"},{"nome":"Vizzola Ticino","cap":["21010"],"district":"VA","districtName":"Varese"},{"nome":"Vizzolo Predabissi","cap":["20070"],"district":"MI","districtName":"Milano"},{"nome":"Vo'","cap":["35030"],"district":"PD","districtName":"Padova"},{"nome":"Vobarno","cap":["25079"],"district":"BS","districtName":"Brescia"},{"nome":"Vobbia","cap":["16010"],"district":"GE","districtName":"Genova"},{"nome":"Vocca","cap":["13020"],"district":"VC","districtName":"Vercelli"},{"nome":"Vodo Cadore","cap":["32040"],"district":"BL","districtName":"Belluno"},{"nome":"Voghera","cap":["27058"],"district":"PV","districtName":"Pavia"},{"nome":"Voghiera","cap":["44019"],"district":"FE","districtName":"Ferrara"},{"nome":"Vogogna","cap":["28805"],"district":"VB","districtName":"Verbano-Cusio-Ossola"},{"nome":"Volano","cap":["38060"],"district":"TN","districtName":"Trento"},{"nome":"Volla","cap":["80040"],"district":"NA","districtName":"Napoli"},{"nome":"Volongo","cap":["26030"],"district":"CR","districtName":"Cremona"},{"nome":"Volpago del Montello","cap":["31040"],"district":"TV","districtName":"Treviso"},{"nome":"Volpara","cap":["27047"],"district":"PV","districtName":"Pavia"},{"nome":"Volpedo","cap":["15059"],"district":"AL","districtName":"Alessandria"},{"nome":"Volpeglino","cap":["15050"],"district":"AL","districtName":"Alessandria"},{"nome":"Volpiano","cap":["10088"],"district":"TO","districtName":"Torino"},{"nome":"Volta Mantovana","cap":["46049"],"district":"MN","districtName":"Mantova"},{"nome":"Voltaggio","cap":["15060"],"district":"AL","districtName":"Alessandria"},{"nome":"Voltago Agordino","cap":["32020"],"district":"BL","districtName":"Belluno"},{"nome":"Volterra","cap":["56048"],"district":"PI","districtName":"Pisa"},{"nome":"Voltido","cap":["26030"],"district":"CR","districtName":"Cremona"},{"nome":"Volturara Appula","cap":["71030"],"district":"FG","districtName":"Foggia"},{"nome":"Volturara Irpina","cap":["83050"],"district":"AV","districtName":"Avellino"},{"nome":"Volturino","cap":["71030"],"district":"FG","districtName":"Foggia"},{"nome":"Volvera","cap":["10040"],"district":"TO","districtName":"Torino"},{"nome":"Vottignasco","cap":["12020"],"district":"CN","districtName":"Cuneo"},{"nome":"Zaccanopoli","cap":["89867"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Zafferana Etnea","cap":["95019"],"district":"CT","districtName":"Catania"},{"nome":"Zagarise","cap":["88050"],"district":"CZ","districtName":"Catanzaro"},{"nome":"Zagarolo","cap":["00039"],"district":"RM","districtName":"Roma"},{"nome":"Zambrone","cap":["89868"],"district":"VV","districtName":"Vibo Valentia"},{"nome":"Zandobbio","cap":["24060"],"district":"BG","districtName":"Bergamo"},{"nome":"Zanè","cap":["36010"],"district":"VI","districtName":"Vicenza"},{"nome":"Zanica","cap":["24050"],"district":"BG","districtName":"Bergamo"},{"nome":"Zapponeta","cap":["71030"],"district":"FG","districtName":"Foggia"},{"nome":"Zavattarello","cap":["27059"],"district":"PV","districtName":"Pavia"},{"nome":"Zeccone","cap":["27010"],"district":"PV","districtName":"Pavia"},{"nome":"Zeddiani","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Zelbio","cap":["22020"],"district":"CO","districtName":"Como"},{"nome":"Zelo Buon Persico","cap":["26839"],"district":"LO","districtName":"Lodi"},{"nome":"Zeme","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Zenevredo","cap":["27049"],"district":"PV","districtName":"Pavia"},{"nome":"Zenson di Piave","cap":["31050"],"district":"TV","districtName":"Treviso"},{"nome":"Zerba","cap":["29020"],"district":"PC","districtName":"Piacenza"},{"nome":"Zerbo","cap":["27017"],"district":"PV","districtName":"Pavia"},{"nome":"Zerbolò","cap":["27020"],"district":"PV","districtName":"Pavia"},{"nome":"Zerfaliu","cap":["09070"],"district":"OR","districtName":"Oristano"},{"nome":"Zeri","cap":["54029"],"district":"MS","districtName":"Massa-Carrara"},{"nome":"Zermeghedo","cap":["36050"],"district":"VI","districtName":"Vicenza"},{"nome":"Zero Branco","cap":["31059"],"district":"TV","districtName":"Treviso"},{"nome":"Zevio","cap":["37059"],"district":"VR","districtName":"Verona"},{"nome":"Ziano di Fiemme","cap":["38030"],"district":"TN","districtName":"Trento"},{"nome":"Ziano Piacentino","cap":["29010"],"district":"PC","districtName":"Piacenza"},{"nome":"Zibido San Giacomo","cap":["20080"],"district":"MI","districtName":"Milano"},{"nome":"Zignago","cap":["19020"],"district":"SP","districtName":"La Spezia"},{"nome":"Zimella","cap":["37040"],"district":"VR","districtName":"Verona"},{"nome":"Zimone","cap":["13887"],"district":"BI","districtName":"Biella"},{"nome":"Zinasco","cap":["27030"],"district":"PV","districtName":"Pavia"},{"nome":"Zoagli","cap":["16035"],"district":"GE","districtName":"Genova"},{"nome":"Zocca","cap":["41059"],"district":"MO","districtName":"Modena"},{"nome":"Zogno","cap":["24019"],"district":"BG","districtName":"Bergamo"},{"nome":"Zola Predosa","cap":["40069"],"district":"BO","districtName":"Bologna"},{"nome":"Zollino","cap":["73010"],"district":"LE","districtName":"Lecce"},{"nome":"Zone","cap":["25050"],"district":"BS","districtName":"Brescia"},{"nome":"Zoppè di Cadore","cap":["32010"],"district":"BL","districtName":"Belluno"},{"nome":"Zoppola","cap":["33080"],"district":"PN","districtName":"Pordenone"},{"nome":"Zovencedo","cap":["36020"],"district":"VI","districtName":"Vicenza"},{"nome":"Zubiena","cap":["13888"],"district":"BI","districtName":"Biella"},{"nome":"Zuccarello","cap":["17039"],"district":"SV","districtName":"Savona"},{"nome":"Zugliano","cap":["36030"],"district":"VI","districtName":"Vicenza"},{"nome":"Zuglio","cap":["33020"],"district":"UD","districtName":"Udine"},{"nome":"Zumaglia","cap":["13848"],"district":"BI","districtName":"Biella"},{"nome":"Zumpano","cap":["87040"],"district":"CS","districtName":"Cosenza"},{"nome":"Zungoli","cap":["83030"],"district":"AV","districtName":"Avellino"},{"nome":"Zungri","cap":["89867"],"district":"VV","districtName":"Vibo Valentia"}]

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Members__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteMember=function(_Component){_inherits(DeleteMember,_Component);function DeleteMember(){_classCallCheck(this,DeleteMember);return _possibleConstructorReturn(this,(DeleteMember.__proto__||Object.getPrototypeOf(DeleteMember)).apply(this,arguments));}_createClass(DeleteMember,[{key:'deleteMembers',value:function deleteMembers(){this.props.deleteMembers({id:this.props.member.id});}},{key:'render',value:function render(){var _this2=this;var ajaxStatus=this.props.members.ajaxStatus;var m=this.props.member;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Eliminare anagrafica'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-modal',onClick:function onClick(){return _this2.props.hideModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})),m.name,' ',m.surname,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submit-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ajax-error'},ajaxStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.props.hideModal();}},'annulla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.deleteMembers();}},'elimna'))));}}]);return DeleteMember;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{deleteMembers:__WEBPACK_IMPORTED_MODULE_2__actions_Members__["q" /* deleteMembers */]})(DeleteMember));

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_Receipts__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_Members__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_Courses__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DualRing__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Error__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AjaxSpinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Receipts_ReceiptDetails__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Receipts_EditReceipt__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Receipts_DeleteReceipt__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Utils_Service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__options_json__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__options_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__options_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={showDelete:false,showEdit:false,receipt:{},search:'',search_course:'',search_subscription:'',search_payment:''};var Receipts=function(_Component){_inherits(Receipts,_Component);function Receipts(){_classCallCheck(this,Receipts);var _this=_possibleConstructorReturn(this,(Receipts.__proto__||Object.getPrototypeOf(Receipts)).call(this));_this.showDelete=_this.showDelete.bind(_this);_this.showEdit=_this.showEdit.bind(_this);_this.hideModal=_this.hideModal.bind(_this);_this.escFunction=_this.escFunction.bind(_this);_this.state=initialState;return _this;}_createClass(Receipts,[{key:'escFunction',value:function escFunction(event){if(event.keyCode===27){this.hideModal();}}},{key:'componentWillMount',value:function componentWillMount(){if(this.props.receipts.list===null){this.reloadReceipts();}if(this.props.members.list===null){this.props.loadMembers();}if(this.props.courses.list===null){this.props.loadCourses();}}},{key:'showDelete',value:function showDelete(receipt){this.setState({showDelete:true,receipt:receipt});}},{key:'showEdit',value:function showEdit(receipt){this.setState({showEdit:true,receipt:receipt});}},{key:'newReceipt',value:function newReceipt(subscription){this.setState({showEdit:true,receipt:{id:null,subscription:subscription,number:'',account_holder:'',amount:'',causal:'',emission_date:'',payment_mode:'',notes:''}});}},{key:'hideModal',value:function hideModal(){this.setState({showDelete:false,showEdit:false});}},{key:'reloadReceipts',value:function reloadReceipts(){this.props.loadReceipts();this.props.loadMembers();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this2=this;if(prevProps.receipts.ajaxSpinner&&!this.props.receipts.ajaxSpinner&&this.props.receipts.ajaxStatus===null){this.hideModal();this.props.loadMembers();}if(prevProps.receipts.ajaxSpinner&&!this.props.receipts.ajaxSpinner&&this.props.receipts.ajaxStatus!==null){setTimeout(function(){_this2.props.clearAjaxCall('');},3000);}}},{key:'filterList',value:function filterList(list){var _this3=this;if(list===null){return null;}return list.filter(function(item){return _this3.state.search_course===''?true:item.course_id.toString()===_this3.state.search_course;}).filter(function(el){return el.number.toString().indexOf(_this3.state.search.toLowerCase())>=0||el.cumulative.toLowerCase().indexOf(_this3.state.search.toLowerCase())>=0||el.account_holder_name_surname.toLowerCase().indexOf(_this3.state.search.toLowerCase())>=0;}).filter(function(item){return _this3.state.search_payment===''?true:item.payment_mode.toString()===_this3.state.search_payment;}).filter(function(item){return _this3.state.search_subscription===''?true:item.subscription.toString()===_this3.state.search_subscription;});}},{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('keydown',this.escFunction,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('keydown',this.escFunction,false);}},{key:'render',value:function render(){var _this4=this;var _props$receipts=this.props.receipts,list=_props$receipts.list,last=_props$receipts.last,error=_props$receipts.error,loading=_props$receipts.loading,ajaxSpinner=_props$receipts.ajaxSpinner;var filteredList=this.filterList(list);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-title'},'Ricevute'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-descr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ul-filter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Cerca ricevute',onChange:function onChange(event){return _this4.setState({search:event.target.value});},value:this.state.search})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({search_course:event.target.value});},value:this.state.search_course},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Tutti i corsi'),this.props.courses.list!==null&&this.props.courses.list.map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:o.id},o.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({search_payment:event.target.value});},value:this.state.search_payment},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Tutti i tipi di pagamento'),__WEBPACK_IMPORTED_MODULE_13__options_json__["paymentTypes"].map(function(o,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:o.value},o.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({search_subscription:event.target.value});},value:this.state.search_subscription},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'Tutti i tipi di ricevuta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'true'},'Quota associativa'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'false'},'Ricevuta'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ph-trend'},last!==null&&last.number!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'trend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'group'},'numero Ultima ricevuta:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,last.number)),last!==null&&last.number!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'trend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'group'},'data Ultima ricevuta:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(last.emission_date).format('ll')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ph-btn'},Object(__WEBPACK_IMPORTED_MODULE_12__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this4.newReceipt(true);},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-handshake'}),' quota associativa')),Object(__WEBPACK_IMPORTED_MODULE_12__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this4.newReceipt(false);},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-receipt'}),' ricevuta')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this4.reloadReceipts();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-redo-alt'}),' ricarica'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-count'},filteredList!==null&&filteredList.length+(filteredList.length===1?' risultato':' risultati'),filteredList===null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-sync fa-spin'}))),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__DualRing__["a" /* default */],null),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Error__["a" /* default */],{error:error}),filteredList!==null&&filteredList.sort(function(a,b){return b.emission_date-a.emission_date||b.id-a.id;}).map(function(r,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Receipts_ReceiptDetails__["a" /* default */],{key:index,receipt:r,showDelete:_this4.showDelete,showEdit:_this4.showEdit});}),this.state.showEdit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Receipts_EditReceipt__["a" /* default */],{receipt:this.state.receipt,hideModal:this.hideModal}),this.state.showDelete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Receipts_DeleteReceipt__["a" /* default */],{receipt:this.state.receipt,hideModal:this.hideModal}),ajaxSpinner&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AjaxSpinner__["a" /* default */],null));}}]);return Receipts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{loadReceipts:__WEBPACK_IMPORTED_MODULE_3__actions_Receipts__["l" /* loadReceipts */],saveReceipts:__WEBPACK_IMPORTED_MODULE_3__actions_Receipts__["m" /* saveReceipts */],deleteReceipts:__WEBPACK_IMPORTED_MODULE_3__actions_Receipts__["k" /* deleteReceipts */],clearAjaxCall:__WEBPACK_IMPORTED_MODULE_3__actions_Receipts__["j" /* clearAjaxCall */],loadMembers:__WEBPACK_IMPORTED_MODULE_4__actions_Members__["s" /* loadMembers */],loadCourses:__WEBPACK_IMPORTED_MODULE_5__actions_Courses__["l" /* loadCourses */]})(Receipts));

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Uris__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__environment__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReceiptDetails=function(_PureComponent){_inherits(ReceiptDetails,_PureComponent);function ReceiptDetails(){_classCallCheck(this,ReceiptDetails);return _possibleConstructorReturn(this,(ReceiptDetails.__proto__||Object.getPrototypeOf(ReceiptDetails)).apply(this,arguments));}_createClass(ReceiptDetails,[{key:'render',value:function render(){var _this2=this;var r=this.props.receipt;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'row-item '+r.color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Data'),__WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(r.emission_date).format('ll')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Intestatario'),r.account_holder_name_surname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Numero ricevuta'),r.number>0?r.number:r.cumulative),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'info-amount '+(r.amount<0?'red':'green')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Importo'),Object(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__["money"])(r.amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'info-buttons'},r.subscription&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-handshake',title:'Quota associativa'}),!r.subscription&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-receipt',title:'Ricevuta'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__["generateUrl"])(__WEBPACK_IMPORTED_MODULE_3__environment__["a" /* ENV */].production,__WEBPACK_IMPORTED_MODULE_2__Uris__["a" /* URIS */].pdf,r.id,r.checksum),className:'lnk-edits',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-file-pdf'})),Object(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-edits',onClick:function onClick(){return _this2.props.showEdit(r);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-edit'})),Object(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-edits',onClick:function onClick(){return _this2.props.showDelete(r);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-trash-alt'}))));}}]);return ReceiptDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (ReceiptDetails);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_Receipts__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Utils_Service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__options_json__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__options_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__options_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditReceipt=function(_Component){_inherits(EditReceipt,_Component);function EditReceipt(){_classCallCheck(this,EditReceipt);return _possibleConstructorReturn(this,(EditReceipt.__proto__||Object.getPrototypeOf(EditReceipt)).apply(this,arguments));}_createClass(EditReceipt,[{key:'saveReceipts',value:function saveReceipts(){var _this2=this;var r=this.state;if(r.account_holder===''||r.amount===''||r.id!==null&&(r.number===''||r.account_holder===''||r.amount==='')){this.props.saveReceiptsFailure('Tutti i dati sono obbligatori');setTimeout(function(){_this2.props.clearAjaxCall('');},3000);}else{this.props.saveReceipts({id:r.id,number:r.number!==''?r.number:r.cumulative,account_holder:r.account_holder,amount:r.amount,causal:r.causal,emission_date:r.emission_date!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(r.emission_date).startOf('day').unix():'',payment_mode:r.payment_mode!==''?r.payment_mode:__WEBPACK_IMPORTED_MODULE_6__options_json__["paymentTypes"][0].value,subscription:r.subscription!==''?r.subscription:null,notes:r.notes,send_mail:this.canBeMailed(r.account_holder)?r.send_mail:false,regenerate_pdf:r.regenerate_pdf});}}},{key:'canBeMailed',value:function canBeMailed(){var _this3=this;var cur=(this.props.members.list||[]).filter(function(obj){return obj.id===parseInt(_this3.state.account_holder,10);})[0];if(cur!==undefined){return Object(__WEBPACK_IMPORTED_MODULE_5__Utils_Service__["validMail"])(cur.email);}return false;}},{key:'componentWillMount',value:function componentWillMount(){var r=this.props.receipt;var ll=this.props.receipts.list;var causal='';if(r.id===null){if(ll!==null&&ll.length>0){var last=ll.filter(function(item){return item.subscription===r.subscription;});if(last.length>0){causal=last[0].causal;}}}else{causal=r.causal;}this.setState({id:r.id,number:r.number>0?r.number:r.cumulative,account_holder:r.account_holder,amount:r.amount,causal:causal,emission_date:r.emission_date!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(r.emission_date).format('YYYY-MM-DD'):__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),payment_mode:r.payment_mode,subscription:r.subscription,notes:r.notes,send_mail:false,regenerate_pdf:r.id===null});}},{key:'render',value:function render(){var _this4=this;var ajaxStatus=this.props.receipts.ajaxStatus;var list=this.props.members.list;var r=this.state;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,r.id!==null?'Modifica':'Nuova','\xA0',r.subscription?'quota associativa':'ricevuta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-modal',onClick:function onClick(){return _this4.props.hideModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Numero ricevuta \xA0',r.id===null&&'(lasciare vuoto se deve essere generata automaticamente)',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',onChange:function onChange(event){return _this4.setState({number:event.target.value});},value:r.number})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Importo',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',placeholder:'Importo',onChange:function onChange(event){return _this4.setState({amount:event.target.value});},value:r.amount})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Intestatario',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({account_holder:event.target.value});},value:r.account_holder},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),list!==null&&// .filter((item) => {
//   return (r.subscription) ? (item.active.toString() === 'false') : (item.active.toString() === 'true')
// }).
list.sort(function(a,b){return a.surname>b.surname?1:b.surname>a.surname?-1:0;}).map(function(m,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:m.id},m.surname,' ',m.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Causale',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Causale',onChange:function onChange(event){return _this4.setState({causal:event.target.value});},value:r.causal})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Data emissione',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',placeholder:'Data emissione'// disabled={r.id !== null}
,onChange:function onChange(event){return _this4.setState({emission_date:event.target.value});},value:r.emission_date})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Modalit\xE0 pagamento',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this4.setState({payment_mode:event.target.value});},value:r.payment_mode},__WEBPACK_IMPORTED_MODULE_6__options_json__["paymentTypes"].map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:i.value},i.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Note',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Note',onChange:function onChange(event){return _this4.setState({notes:event.target.value});},value:r.notes})),this.canBeMailed()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'check-container'},'Invia ricevuta via mail',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(event){return _this4.setState({send_mail:event.target.checked});},value:r.send_mail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'checkmark'})),r.id!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'check-container'},'Rigenera PDF ricevuta',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',onChange:function onChange(event){return _this4.setState({regenerate_pdf:event.target.checked});},checked:r.regenerate_pdf,value:r.regenerate_pdf}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'checkmark'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submit-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ajax-error'},ajaxStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this4.props.hideModal();}},'annulla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this4.saveReceipts();}},'salva'))));}}]);return EditReceipt;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{saveReceipts:__WEBPACK_IMPORTED_MODULE_3__actions_Receipts__["m" /* saveReceipts */],saveReceiptsFailure:__WEBPACK_IMPORTED_MODULE_3__actions_Receipts__["n" /* saveReceiptsFailure */],clearAjaxCall:__WEBPACK_IMPORTED_MODULE_3__actions_Receipts__["j" /* clearAjaxCall */]})(EditReceipt));

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Utils_Service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_Receipts__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteReceipt=function(_Component){_inherits(DeleteReceipt,_Component);function DeleteReceipt(){_classCallCheck(this,DeleteReceipt);return _possibleConstructorReturn(this,(DeleteReceipt.__proto__||Object.getPrototypeOf(DeleteReceipt)).apply(this,arguments));}_createClass(DeleteReceipt,[{key:'deleteReceipts',value:function deleteReceipts(){this.props.deleteReceipts({id:this.props.receipt.id});}},{key:'render',value:function render(){var _this2=this;var ajaxStatus=this.props.receipts.ajaxStatus;var r=this.props.receipt;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Modal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Eliminare ricevuta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-modal',onClick:function onClick(){return _this2.props.hideModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'delete-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Numero'),r.number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Data'),__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(r.emission_date).format('ll')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Importo'),Object(__WEBPACK_IMPORTED_MODULE_3__Utils_Service__["money"])(r.amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Intestatario'),r.account_holder_name_surname)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submit-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ajax-error'},ajaxStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.props.hideModal();}},'annulla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.deleteReceipts();}},'elimna'))));}}]);return DeleteReceipt;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{deleteReceipts:__WEBPACK_IMPORTED_MODULE_4__actions_Receipts__["k" /* deleteReceipts */]})(DeleteReceipt));

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Club__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DualRing__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Error__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AjaxSpinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Club_ClubDetails__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Club_EditClub__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Utils_Service__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={showDelete:false,showEdit:false,course:{}};var Club=function(_Component){_inherits(Club,_Component);function Club(){_classCallCheck(this,Club);var _this=_possibleConstructorReturn(this,(Club.__proto__||Object.getPrototypeOf(Club)).call(this));_this.showEdit=_this.showEdit.bind(_this);_this.hideModal=_this.hideModal.bind(_this);_this.escFunction=_this.escFunction.bind(_this);_this._handleImageChange=_this._handleImageChange.bind(_this);_this.state=initialState;return _this;}_createClass(Club,[{key:'escFunction',value:function escFunction(event){if(event.keyCode===27){this.hideModal();}}},{key:'_handleImageChange',value:function _handleImageChange(e){var _this2=this;e.preventDefault();var reader=new window.FileReader();if(e.target.files.length>0){var file=e.target.files[0];this.props.uploadSignatureStarted();reader.onloadend=function(){_this2.props.uploadSignature({image:reader.result});};reader.readAsDataURL(file);}}},{key:'componentWillMount',value:function componentWillMount(){if(this.props.club.info===null){this.props.loadClub();}}},{key:'showEdit',value:function showEdit(){this.setState({showEdit:true});}},{key:'hideModal',value:function hideModal(){this.setState(initialState);}},{key:'reloadClub',value:function reloadClub(){this.props.loadClub();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this3=this;if(prevProps.club.ajaxSpinner&&!this.props.club.ajaxSpinner&&this.props.club.ajaxStatus===null){this.hideModal();}if(prevProps.club.ajaxSpinner&&!this.props.club.ajaxSpinner&&this.props.club.ajaxStatus!==null){setTimeout(function(){_this3.props.clearAjaxCall('');},3000);}}},{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('keydown',this.escFunction,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('keydown',this.escFunction,false);}},{key:'render',value:function render(){var _this4=this;var _props$club=this.props.club,info=_props$club.info,error=_props$club.error,loading=_props$club.loading,ajaxSpinner=_props$club.ajaxSpinner;var list=this.props.fiscalyear.list;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-title'},'Associazione'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-descr txt'},'Per la generazione delle ricevute e la contabilit\xE0 \xE8 indispensabile inserire i dati di inizio e fine anno fiscale',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'L\'anno fiscale viene generato automaticamente dal sistema, non serve cambiarlo tutti gli anni.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ph-btn'},Object(__WEBPACK_IMPORTED_MODULE_8__Utils_Service__["grantAdmin"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this._handleSubmit,className:'hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'upload_avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',ref:function ref(_ref){return _this4.upload=_ref;},id:'upload_avatar',className:'upld',onChange:this._handleImageChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(e){return _this4.upload.click();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-signature'}),' carica firma')),Object(__WEBPACK_IMPORTED_MODULE_8__Utils_Service__["grantAdmin"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this4.showEdit();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-edit'}),' modifica')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this4.reloadClub();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-redo-alt'}),' ricarica')))),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DualRing__["a" /* default */],null),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Error__["a" /* default */],{error:error}),info!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Club_ClubDetails__["a" /* default */],{info:info,fiscalyear:list,showDelete:this.showDelete,showEdit:this.showEdit}),this.state.showEdit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Club_EditClub__["a" /* default */],{info:info,hideModal:this.hideModal}),ajaxSpinner&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AjaxSpinner__["a" /* default */],null));}}]);return Club;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{loadClub:__WEBPACK_IMPORTED_MODULE_2__actions_Club__["l" /* loadClub */],saveClub:__WEBPACK_IMPORTED_MODULE_2__actions_Club__["m" /* saveClub */],clearAjaxCall:__WEBPACK_IMPORTED_MODULE_2__actions_Club__["k" /* clearAjaxCall */],uploadSignature:__WEBPACK_IMPORTED_MODULE_2__actions_Club__["n" /* uploadSignature */],uploadSignatureStarted:__WEBPACK_IMPORTED_MODULE_2__actions_Club__["o" /* uploadSignatureStarted */]})(Club));

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClubDetails=function(_Component){_inherits(ClubDetails,_Component);function ClubDetails(){_classCallCheck(this,ClubDetails);return _possibleConstructorReturn(this,(ClubDetails.__proto__||Object.getPrototypeOf(ClubDetails)).apply(this,arguments));}_createClass(ClubDetails,[{key:'render',value:function render(){var c=this.props.info;var f=this.props.fiscalyear;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'club-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Nome'),c.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Indirizzo'),c.address),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'CAP'),c.postal_code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Citt\xE0'),c.city),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Provincia'),c.country),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Codice fiscale'),c.fiscal_code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Partita IVA'),c.vat),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Iban'),c.iban),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Indirizzo e-mail'),c.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Nome e-mail'),c.email_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Inizio anno fiscale'),c.start_date!==''?__WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(c.start_date).format('DD MMMM'):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Fine anno fiscale'),c.end_date!==''?__WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(c.end_date).format('DD MMMM'):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'club-info sign'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:c.signature,className:'img',alt:'signature'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'club-info fy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Anni fiscali presenti'),f!==null&&f.map(function(y,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(y.start_date).format('ll'),' - ',__WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(y.end_date).format('ll'));})));}}]);return ClubDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ClubDetails);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_Club__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__geo_json__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__geo_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__geo_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditClub=function(_Component){_inherits(EditClub,_Component);function EditClub(){_classCallCheck(this,EditClub);return _possibleConstructorReturn(this,(EditClub.__proto__||Object.getPrototypeOf(EditClub)).apply(this,arguments));}_createClass(EditClub,[{key:'saveClub',value:function saveClub(){var c=this.state;this.props.saveClub({name:c.name,address:c.address,postal_code:c.postal_code,city:c.city,country:c.country,fiscal_code:c.fiscal_code,vat:c.vat,iban:c.iban,start_date:c.start_date!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(c.start_date).startOf('day').unix():null,end_date:c.end_date!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(c.end_date).startOf('day').unix():null,email:c.email,email_name:c.email_name});}},{key:'componentWillMount',value:function componentWillMount(){var c=this.props.info;this.setState({name:c.name,address:c.address,postal_code:c.postal_code,city:c.city,country:c.country,fiscal_code:c.fiscal_code,vat:c.vat,iban:c.iban,start_date:c.start_date!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(c.start_date).format('YYYY-MM-DD'):'',end_date:c.end_date!==''?__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(c.end_date).format('YYYY-MM-DD'):'',email:c.email,email_name:c.email_name});}},{key:'render',value:function render(){var _this2=this;var ajaxStatus=this.props.club.ajaxStatus;var c=this.state;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Modal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Modifica anagrafica'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-modal',onClick:function onClick(){return _this2.props.hideModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Nome',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Nome',onChange:function onChange(event){return _this2.setState({name:event.target.value});},value:c.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Indirizzo',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Indirizzo',onChange:function onChange(event){return _this2.setState({address:event.target.value});},value:c.address})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'CAP',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',placeholder:'CAP',onChange:function onChange(event){return _this2.setState({postal_code:event.target.value});},value:c.postal_code})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Citt\xE0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Citt\xE0',onChange:function onChange(event){return _this2.setState({city:event.target.value});},value:c.city})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Provincia',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this2.setState({country:event.target.value});},value:this.state.country},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''}),__WEBPACK_IMPORTED_MODULE_5__geo_json__["countries"].map(function(c,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:c.label},c.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Codice fiscale',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Codice fiscale',onChange:function onChange(event){return _this2.setState({fiscal_code:event.target.value});},value:c.fiscal_code})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Partita IVA',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Partita IVA',onChange:function onChange(event){return _this2.setState({vat:event.target.value});},value:c.vat})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Iban',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Iban',onChange:function onChange(event){return _this2.setState({iban:event.target.value});},value:c.iban})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Inizio anno fiscale',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',placeholder:'Inizio anno fiscale',disabled:true,onChange:function onChange(event){return _this2.setState({start_date:event.target.value});},value:c.start_date})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Fine anno fiscale',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'date',placeholder:'Fine anno fiscale',disabled:true,onChange:function onChange(event){return _this2.setState({end_date:event.target.value});},value:c.end_date})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'E-mail',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'email',placeholder:'E-mail',onChange:function onChange(event){return _this2.setState({email:event.target.value});},value:c.email})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Nome e-mail',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Nome e-mail',onChange:function onChange(event){return _this2.setState({email_name:event.target.value});},value:c.email_name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submit-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ajax-error'},ajaxStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.props.hideModal();}},'annulla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.saveClub();}},'salva'))));}}]);return EditClub;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{saveClub:__WEBPACK_IMPORTED_MODULE_3__actions_Club__["m" /* saveClub */]})(EditClub));

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Instructors__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DualRing__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Error__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AjaxSpinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Instructors_InstructorDetails__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Instructors_EditInstructor__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Instructors_DeleteInstructor__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Utils_Service__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={showDelete:false,showEdit:false,instructor:{}};var Instructors=function(_Component){_inherits(Instructors,_Component);function Instructors(){_classCallCheck(this,Instructors);var _this=_possibleConstructorReturn(this,(Instructors.__proto__||Object.getPrototypeOf(Instructors)).call(this));_this.showDelete=_this.showDelete.bind(_this);_this.showEdit=_this.showEdit.bind(_this);_this.hideModal=_this.hideModal.bind(_this);_this.escFunction=_this.escFunction.bind(_this);_this.state=initialState;return _this;}_createClass(Instructors,[{key:'escFunction',value:function escFunction(event){if(event.keyCode===27){this.hideModal();}}},{key:'componentWillMount',value:function componentWillMount(){if(this.props.instructors.list===null){this.reloadInstructors();}}},{key:'showDelete',value:function showDelete(instructor){this.setState({showDelete:true,instructor:instructor});}},{key:'showEdit',value:function showEdit(instructor){this.setState({showEdit:true,instructor:instructor});}},{key:'newInstructor',value:function newInstructor(){this.setState({showEdit:true,instructor:{id:null,name:'',email:'',password:'',grant:1}});}},{key:'hideModal',value:function hideModal(){this.setState({showDelete:false,showEdit:false});}},{key:'reloadInstructors',value:function reloadInstructors(){this.props.loadInstructors();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this2=this;if(prevProps.instructors.ajaxSpinner&&!this.props.instructors.ajaxSpinner&&this.props.instructors.ajaxStatus===null){this.hideModal();}if(prevProps.instructors.ajaxSpinner&&!this.props.instructors.ajaxSpinner&&this.props.instructors.ajaxStatus!==null){setTimeout(function(){_this2.props.clearAjaxCall('');},3000);}}},{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('keydown',this.escFunction,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('keydown',this.escFunction,false);}},{key:'render',value:function render(){var _this3=this;var _props$instructors=this.props.instructors,list=_props$instructors.list,error=_props$instructors.error,loading=_props$instructors.loading,ajaxSpinner=_props$instructors.ajaxSpinner;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-title'},'Istruttori'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-descr txt'},'Gli Istruttori hanno accesso alla console di gestione.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'I permessi sono di 3 tipi:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ul-standard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Ospite: solo visualizzazione'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Utente: visualizzazione e modifica dei dati personali'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Amministratore: permessi completi'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ph-btn'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_Service__["grantAdmin"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3.newInstructor();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-user-plus'}),' aggiungi')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3.reloadInstructors();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-redo-alt'}),' ricarica'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-count'},list!==null&&list.length+(list.length===1?' risultato':' risultati'),list===null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-sync fa-spin'}))),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DualRing__["a" /* default */],null),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Error__["a" /* default */],{error:error}),list!==null&&list.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Instructors_InstructorDetails__["a" /* default */],{key:index,instructor:i,showDelete:_this3.showDelete,showEdit:_this3.showEdit});}),this.state.showEdit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Instructors_EditInstructor__["a" /* default */],{instructor:this.state.instructor,hideModal:this.hideModal}),this.state.showDelete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Instructors_DeleteInstructor__["a" /* default */],{instructor:this.state.instructor,hideModal:this.hideModal}),ajaxSpinner&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AjaxSpinner__["a" /* default */],null));}}]);return Instructors;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{loadInstructors:__WEBPACK_IMPORTED_MODULE_2__actions_Instructors__["l" /* loadInstructors */],saveInstructors:__WEBPACK_IMPORTED_MODULE_2__actions_Instructors__["m" /* saveInstructors */],deleteInstructors:__WEBPACK_IMPORTED_MODULE_2__actions_Instructors__["k" /* deleteInstructors */],clearAjaxCall:__WEBPACK_IMPORTED_MODULE_2__actions_Instructors__["j" /* clearAjaxCall */]})(Instructors));

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Utils_Service__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InstructorDetails=function(_PureComponent){_inherits(InstructorDetails,_PureComponent);function InstructorDetails(){_classCallCheck(this,InstructorDetails);return _possibleConstructorReturn(this,(InstructorDetails.__proto__||Object.getPrototypeOf(InstructorDetails)).apply(this,arguments));}_createClass(InstructorDetails,[{key:'render',value:function render(){var _this2=this;var i=this.props.instructor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'row-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Nome'),i.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Email'),i.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'info-buttons'},Object(__WEBPACK_IMPORTED_MODULE_1__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-edits',onClick:function onClick(){return _this2.props.showEdit(i);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-edit'})),Object(__WEBPACK_IMPORTED_MODULE_1__Utils_Service__["grantAdmin"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-edits',onClick:function onClick(){return _this2.props.showDelete(i);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-trash-alt'}))));}}]);return InstructorDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (InstructorDetails);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Instructors__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var grant_values=[{value:1,label:'Ospite'},{value:3,label:'Utente'},{value:5,label:'Amministratore'}];var EditInstructor=function(_Component){_inherits(EditInstructor,_Component);function EditInstructor(){_classCallCheck(this,EditInstructor);return _possibleConstructorReturn(this,(EditInstructor.__proto__||Object.getPrototypeOf(EditInstructor)).apply(this,arguments));}_createClass(EditInstructor,[{key:'saveInstructors',value:function saveInstructors(){this.props.saveInstructors(this.state);}},{key:'componentWillMount',value:function componentWillMount(){var i=this.props.instructor;this.setState({id:i.id,name:i.name,password:'',email:i.email,grant:i.grant});}},{key:'render',value:function render(){var _this2=this;var ajaxStatus=this.props.instructors.ajaxStatus;var i=this.state;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,i.id!==null?'Modifica':'Aggiungi',' istruttore'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-modal',onClick:function onClick(){return _this2.props.hideModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Nome',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Nome',onChange:function onChange(event){return _this2.setState({name:event.target.value});},value:i.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Email',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'email',placeholder:'Email',onChange:function onChange(event){return _this2.setState({email:event.target.value});},value:i.email})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Password ',i.id!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'(lasciare vuota se non la si vuole cambiare)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Password',onChange:function onChange(event){return _this2.setState({password:event.target.value});},value:i.password})),Object(__WEBPACK_IMPORTED_MODULE_4__Utils_Service__["grantAdmin"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Permessi',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this2.setState({grant:event.target.value});},value:i.grant},grant_values.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:i.value},i.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submit-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ajax-error'},ajaxStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.props.hideModal();}},'annulla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.saveInstructors();}},'salva'))));}}]);return EditInstructor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{saveInstructors:__WEBPACK_IMPORTED_MODULE_2__actions_Instructors__["m" /* saveInstructors */]})(EditInstructor));

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Instructors__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteInstructor=function(_Component){_inherits(DeleteInstructor,_Component);function DeleteInstructor(){_classCallCheck(this,DeleteInstructor);return _possibleConstructorReturn(this,(DeleteInstructor.__proto__||Object.getPrototypeOf(DeleteInstructor)).apply(this,arguments));}_createClass(DeleteInstructor,[{key:'deleteInstructors',value:function deleteInstructors(){this.props.deleteInstructors({id:this.props.instructor.id});}},{key:'render',value:function render(){var _this2=this;var ajaxStatus=this.props.instructors.ajaxStatus;var i=this.props.instructor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Eliminare istruttore'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-modal',onClick:function onClick(){return _this2.props.hideModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})),i.name,' - ',i.email,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submit-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ajax-error'},ajaxStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.props.hideModal();}},'annulla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.deleteInstructors();}},'elimna'))));}}]);return DeleteInstructor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{deleteInstructors:__WEBPACK_IMPORTED_MODULE_2__actions_Instructors__["k" /* deleteInstructors */]})(DeleteInstructor));

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_chartjs_2__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DualRing__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Error__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_Dashboard__ = __webpack_require__(92);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var chartOptions={scales:{yAxes:[{ticks:{beginAtZero:true}}],xAxes:[{ticks:{display:false}}]},responsive:true,maintainAspectRatio:false,legend:{onClick:function onClick(e){return e.stopPropagation();}}};var Dashboard=function(_Component){_inherits(Dashboard,_Component);function Dashboard(){_classCallCheck(this,Dashboard);return _possibleConstructorReturn(this,(Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).apply(this,arguments));}_createClass(Dashboard,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.dashboard.charts===null){this.reloadDashboard();}}},{key:'reloadDashboard',value:function reloadDashboard(){this.props.loadDashboard();}},{key:'render',value:function render(){var _this2=this;var _props$dashboard=this.props.dashboard,charts=_props$dashboard.charts,error=_props$dashboard.error,loading=_props$dashboard.loading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-title'},'Dashboard'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-descr txt'},'Statistiche presenze per i tuoi corsi'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ph-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.reloadDashboard();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-redo-alt'}),' ricarica')))),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DualRing__["a" /* default */],null),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Error__["a" /* default */],{error:error}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'con-chart'},charts!==null&&charts.map(function(s,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_chartjs_2__["a" /* Line */],{data:s,width:100,options:chartOptions}));})));}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{loadDashboard:__WEBPACK_IMPORTED_MODULE_5__actions_Dashboard__["d" /* loadDashboard */]})(Dashboard));

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export Doughnut */
/* unused harmony export Pie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Line; });
/* unused harmony export Bar */
/* unused harmony export HorizontalBar */
/* unused harmony export Radar */
/* unused harmony export Polar */
/* unused harmony export Bubble */
/* unused harmony export Scatter */
/* unused harmony export defaults */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_keyBy__);
/* unused harmony reexport Chart */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var NODE_ENV = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}) && "production";

var ChartComponent = function (_React$Component) {
  _inherits(ChartComponent, _React$Component);

  function ChartComponent() {
    var _temp, _this, _ret;

    _classCallCheck(this, ChartComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleOnClick = function (event) {
      var instance = _this.chartInstance;

      var _this$props = _this.props,
          getDatasetAtEvent = _this$props.getDatasetAtEvent,
          getElementAtEvent = _this$props.getElementAtEvent,
          getElementsAtEvent = _this$props.getElementsAtEvent,
          onElementsClick = _this$props.onElementsClick;


      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
    }, _this.ref = function (element) {
      _this.element = element;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ChartComponent.prototype.componentWillMount = function componentWillMount() {
    this.chartInstance = undefined;
  };

  ChartComponent.prototype.componentDidMount = function componentDidMount() {
    this.renderChart();
  };

  ChartComponent.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.props.redraw) {
      this.chartInstance.destroy();
      this.renderChart();
      return;
    }

    this.updateChart();
  };

  ChartComponent.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _props = this.props,
        redraw = _props.redraw,
        type = _props.type,
        options = _props.options,
        plugins = _props.plugins,
        legend = _props.legend,
        height = _props.height,
        width = _props.width;


    if (nextProps.redraw === true) {
      return true;
    }

    if (height !== nextProps.height || width !== nextProps.width) {
      return true;
    }

    if (type !== nextProps.type) {
      return true;
    }

    if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(legend, nextProps.legend)) {
      return true;
    }

    if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(options, nextProps.options)) {
      return true;
    }

    var nextData = this.transformDataProp(nextProps);

    if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(this.shadowDataProp, nextData)) {
      return true;
    }

    return !__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(plugins, nextProps.plugins);
  };

  ChartComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.chartInstance.destroy();
  };

  ChartComponent.prototype.transformDataProp = function transformDataProp(props) {
    var data = props.data;

    if (typeof data == 'function') {
      var node = this.element;
      return data(node);
    } else {
      return data;
    }
  };

  // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
  // this makes impossible to compare the current and next data changes
  // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
  // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617


  ChartComponent.prototype.memoizeDataProps = function memoizeDataProps() {
    if (!this.props.data) {
      return;
    }

    var data = this.transformDataProp(this.props);

    this.shadowDataProp = _extends({}, data, {
      datasets: data.datasets && data.datasets.map(function (set) {
        return _extends({}, set);
      })
    });

    return data;
  };

  ChartComponent.prototype.checkDatasets = function checkDatasets(datasets) {
    var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
    var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
    var multipleDatasets = datasets.length > 1;

    if (isDev && multipleDatasets && !usingCustomKeyProvider) {
      var shouldWarn = false;
      datasets.forEach(function (dataset) {
        if (!dataset.label) {
          shouldWarn = true;
        }
      });

      if (shouldWarn) {
        console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
      }
    }
  };

  ChartComponent.prototype.updateChart = function updateChart() {
    var _this2 = this;

    var options = this.props.options;


    var data = this.memoizeDataProps(this.props);

    if (!this.chartInstance) return;

    if (options) {
      this.chartInstance.options = __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.helpers.configMerge(this.chartInstance.options, options);
    }

    // Pipe datasets to chart instance datasets enabling
    // seamless transitions
    var currentDatasets = this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
    var nextDatasets = data.datasets || [];
    this.checkDatasets(currentDatasets);

    var currentDatasetsIndexed = __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default()(currentDatasets, this.props.datasetKeyProvider);

    // We can safely replace the dataset array, as long as we retain the _meta property
    // on each dataset.
    this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
      var current = currentDatasetsIndexed[_this2.props.datasetKeyProvider(next)];

      if (current && current.type === next.type) {
        // The data array must be edited in place. As chart.js adds listeners to it.
        current.data.splice(next.data.length);
        next.data.forEach(function (point, pid) {
          current.data[pid] = next.data[pid];
        });

        var _data = next.data,
            otherProps = _objectWithoutProperties(next, ['data']);
        // Merge properties. Notice a weakness here. If a property is removed
        // from next, it will be retained by current and never disappears.
        // Workaround is to set value to null or undefined in next.


        return _extends({}, current, otherProps);
      } else {
        return next;
      }
    });

    var datasets = data.datasets,
        rest = _objectWithoutProperties(data, ['datasets']);

    this.chartInstance.config.data = _extends({}, this.chartInstance.config.data, rest);

    this.chartInstance.update();
  };

  ChartComponent.prototype.renderChart = function renderChart() {
    var _props2 = this.props,
        options = _props2.options,
        legend = _props2.legend,
        type = _props2.type,
        redraw = _props2.redraw,
        plugins = _props2.plugins;

    var node = this.element;
    var data = this.memoizeDataProps();

    if (typeof legend !== 'undefined' && !__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(ChartComponent.defaultProps.legend, legend)) {
      options.legend = legend;
    }

    this.chartInstance = new __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a(node, {
      type: type,
      data: data,
      options: options,
      plugins: plugins
    });
  };

  ChartComponent.prototype.render = function render() {
    var _props3 = this.props,
        height = _props3.height,
        width = _props3.width,
        onElementsClick = _props3.onElementsClick,
        id = _props3.id;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', {
      ref: this.ref,
      height: height,
      width: width,
      id: id,
      onClick: this.handleOnClick
    });
  };

  return ChartComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ChartComponent.getLabelAsKey = function (d) {
  return d.label;
};

ChartComponent.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]).isRequired,
  getDatasetAtEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getElementAtEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getElementsAtEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  legend: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onElementsClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  plugins: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object),
  redraw: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  type: function type(props, propName, componentName) {
    if (!__WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.controllers[props[propName]]) {
      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
    }
  },
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  datasetKeyProvider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
ChartComponent.defaultProps = {
  legend: {
    display: true,
    position: 'bottom'
  },
  type: 'doughnut',
  height: 150,
  width: 300,
  redraw: false,
  options: {},
  datasetKeyProvider: ChartComponent.getLabelAsKey
};


/* unused harmony default export */ var _unused_webpack_default_export = (ChartComponent);

var Doughnut = function (_React$Component2) {
  _inherits(Doughnut, _React$Component2);

  function Doughnut() {
    _classCallCheck(this, Doughnut);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Doughnut.prototype.render = function render() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref) {
        return _this4.chartInstance = _ref && _ref.chartInstance;
      },
      type: 'doughnut'
    }));
  };

  return Doughnut;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Pie = function (_React$Component3) {
  _inherits(Pie, _React$Component3);

  function Pie() {
    _classCallCheck(this, Pie);

    return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
  }

  Pie.prototype.render = function render() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref2) {
        return _this6.chartInstance = _ref2 && _ref2.chartInstance;
      },
      type: 'pie'
    }));
  };

  return Pie;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Line = function (_React$Component4) {
  _inherits(Line, _React$Component4);

  function Line() {
    _classCallCheck(this, Line);

    return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
  }

  Line.prototype.render = function render() {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref3) {
        return _this8.chartInstance = _ref3 && _ref3.chartInstance;
      },
      type: 'line'
    }));
  };

  return Line;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Bar = function (_React$Component5) {
  _inherits(Bar, _React$Component5);

  function Bar() {
    _classCallCheck(this, Bar);

    return _possibleConstructorReturn(this, _React$Component5.apply(this, arguments));
  }

  Bar.prototype.render = function render() {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref4) {
        return _this10.chartInstance = _ref4 && _ref4.chartInstance;
      },
      type: 'bar'
    }));
  };

  return Bar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var HorizontalBar = function (_React$Component6) {
  _inherits(HorizontalBar, _React$Component6);

  function HorizontalBar() {
    _classCallCheck(this, HorizontalBar);

    return _possibleConstructorReturn(this, _React$Component6.apply(this, arguments));
  }

  HorizontalBar.prototype.render = function render() {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref5) {
        return _this12.chartInstance = _ref5 && _ref5.chartInstance;
      },
      type: 'horizontalBar'
    }));
  };

  return HorizontalBar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Radar = function (_React$Component7) {
  _inherits(Radar, _React$Component7);

  function Radar() {
    _classCallCheck(this, Radar);

    return _possibleConstructorReturn(this, _React$Component7.apply(this, arguments));
  }

  Radar.prototype.render = function render() {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref6) {
        return _this14.chartInstance = _ref6 && _ref6.chartInstance;
      },
      type: 'radar'
    }));
  };

  return Radar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Polar = function (_React$Component8) {
  _inherits(Polar, _React$Component8);

  function Polar() {
    _classCallCheck(this, Polar);

    return _possibleConstructorReturn(this, _React$Component8.apply(this, arguments));
  }

  Polar.prototype.render = function render() {
    var _this16 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref7) {
        return _this16.chartInstance = _ref7 && _ref7.chartInstance;
      },
      type: 'polarArea'
    }));
  };

  return Polar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Bubble = function (_React$Component9) {
  _inherits(Bubble, _React$Component9);

  function Bubble() {
    _classCallCheck(this, Bubble);

    return _possibleConstructorReturn(this, _React$Component9.apply(this, arguments));
  }

  Bubble.prototype.render = function render() {
    var _this18 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref8) {
        return _this18.chartInstance = _ref8 && _ref8.chartInstance;
      },
      type: 'bubble'
    }));
  };

  return Bubble;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Scatter = function (_React$Component10) {
  _inherits(Scatter, _React$Component10);

  function Scatter() {
    _classCallCheck(this, Scatter);

    return _possibleConstructorReturn(this, _React$Component10.apply(this, arguments));
  }

  Scatter.prototype.render = function render() {
    var _this20 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref9) {
        return _this20.chartInstance = _ref9 && _ref9.chartInstance;
      },
      type: 'scatter'
    }));
  };

  return Scatter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var defaults = __WEBPACK_IMPORTED_MODULE_2_chart_js___default.a.defaults;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(86)))

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @namespace Chart
 */
var Chart = __webpack_require__(252)();

Chart.helpers = __webpack_require__(1);

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
__webpack_require__(256)(Chart);

Chart.defaults = __webpack_require__(3);
Chart.Element = __webpack_require__(14);
Chart.elements = __webpack_require__(22);
Chart.Interaction = __webpack_require__(95);
Chart.layouts = __webpack_require__(30);
Chart.platform = __webpack_require__(96);
Chart.plugins = __webpack_require__(97);
Chart.Ticks = __webpack_require__(31);

__webpack_require__(267)(Chart);
__webpack_require__(268)(Chart);
__webpack_require__(269)(Chart);
__webpack_require__(270)(Chart);
__webpack_require__(271)(Chart);
__webpack_require__(272)(Chart);

__webpack_require__(273)(Chart);
__webpack_require__(274)(Chart);
__webpack_require__(275)(Chart);
__webpack_require__(276)(Chart);
__webpack_require__(277)(Chart);
__webpack_require__(278)(Chart);

// Controllers must be loaded after elements
// See Chart.core.datasetController.dataElementType
__webpack_require__(279)(Chart);
__webpack_require__(280)(Chart);
__webpack_require__(281)(Chart);
__webpack_require__(282)(Chart);
__webpack_require__(283)(Chart);
__webpack_require__(284)(Chart);
__webpack_require__(285)(Chart);

__webpack_require__(286)(Chart);
__webpack_require__(287)(Chart);
__webpack_require__(288)(Chart);
__webpack_require__(289)(Chart);
__webpack_require__(290)(Chart);
__webpack_require__(291)(Chart);
__webpack_require__(292)(Chart);

// Loading built-it plugins
var plugins = __webpack_require__(293);
for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		Chart.plugins.register(plugins[k]);
	}
}

Chart.platform.initialize();

module.exports = Chart;
if (typeof window !== 'undefined') {
	window.Chart = Chart;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
Chart.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
Chart.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
Chart.pluginService = Chart.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
Chart.PluginBase = Chart.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
Chart.canvasHelpers = Chart.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
Chart.layoutService = Chart.layouts;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);

defaults._set('global', {
	responsive: true,
	responsiveAnimationDuration: 0,
	maintainAspectRatio: true,
	events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	showLines: true,

	// Element defaults defined in element extensions
	elements: {},

	// Layout options such as padding
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

module.exports = function() {

	// Occupy the global variable of Chart, and create a simple base class
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};

	Chart.Chart = Chart;

	return Chart;
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(41);

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

module.exports = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.easingEffects = effects;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(41);

/**
 * @namespace Chart.helpers.canvas
 */
var exports = module.exports = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {Number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {Number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {Number} width - The rectangle's width.
	 * @param {Number} height - The rectangle's height.
	 * @param {Number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var rx = Math.min(radius, width / 2);
			var ry = Math.min(radius, height / 2);

			ctx.moveTo(x + rx, y);
			ctx.lineTo(x + width - rx, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + ry);
			ctx.lineTo(x + width, y + height - ry);
			ctx.quadraticCurveTo(x + width, y + height, x + width - rx, y + height);
			ctx.lineTo(x + rx, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - ry);
			ctx.lineTo(x, y + ry);
			ctx.quadraticCurveTo(x, y, x + rx, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y) {
		var type, edgeLength, xOffset, yOffset, height, size;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		switch (style) {
		// Default includes circle
		default:
			ctx.beginPath();
			ctx.arc(x, y, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.fill();
			break;
		case 'triangle':
			ctx.beginPath();
			edgeLength = 3 * radius / Math.sqrt(3);
			height = edgeLength * Math.sqrt(3) / 2;
			ctx.moveTo(x - edgeLength / 2, y + height / 3);
			ctx.lineTo(x + edgeLength / 2, y + height / 3);
			ctx.lineTo(x, y - 2 * height / 3);
			ctx.closePath();
			ctx.fill();
			break;
		case 'rect':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
			ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
			break;
		case 'rectRounded':
			var offset = radius / Math.SQRT2;
			var leftX = x - offset;
			var topY = y - offset;
			var sideSize = Math.SQRT2 * radius;
			ctx.beginPath();
			this.roundedRect(ctx, leftX, topY, sideSize, sideSize, radius / 2);
			ctx.closePath();
			ctx.fill();
			break;
		case 'rectRot':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.moveTo(x - size, y);
			ctx.lineTo(x, y + size);
			ctx.lineTo(x + size, y);
			ctx.lineTo(x, y - size);
			ctx.closePath();
			ctx.fill();
			break;
		case 'cross':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'crossRot':
			ctx.beginPath();
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'star':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'line':
			ctx.beginPath();
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'dash':
			ctx.beginPath();
			ctx.moveTo(x, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		}

		ctx.stroke();
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		if (target.steppedLine) {
			if ((target.steppedLine === 'after' && !flip) || (target.steppedLine !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.clear = exports.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports.roundedRect.apply(exports, arguments);
	ctx.closePath();
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(41);

/**
 * @alias Chart.helpers.options
 * @namespace
 */
module.exports = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {Number|String} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {Number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {Number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		default:
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {Number|Object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {Object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array[]} inputs - An array of values, falling back to the last value.
	 * @param {Object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {Number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index) {
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
			}
			if (index !== undefined && helpers.isArray(value)) {
				value = value[index];
			}
			if (value !== undefined) {
				return value;
			}
		}
	}
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */
/* global document: false */


var color = __webpack_require__(94);
var defaults = __webpack_require__(3);
var helpers = __webpack_require__(1);

module.exports = function(Chart) {

	// -- Basic js utility methods

	helpers.configMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				var tval = target[key] || {};
				var sval = source[key];

				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = helpers.scaleMerge(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers.merge(tval, [Chart.scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.scaleMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;

					if (!target[key]) {
						target[key] = [];
					}

					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = helpers.valueOrDefault(scale.type, key === 'xAxes' ? 'category' : 'linear');

						if (i >= target[key].length) {
							target[key].push({});
						}

						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers.merge(target[key][i], [Chart.scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers.merge(target[key][i], scale);
						}
					}
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.where = function(collection, filterCallback) {
		if (helpers.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
	};
	helpers.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers.log10 = Math.log10 ?
		function(x) {
			return Math.log10(x);
		} :
		function(x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);

			return isPowerOf10 ? powerOf10 : exponent;
		};
	helpers.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};
	// Gets the angle from vertical upright to the point about a centre.
	helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};
	helpers.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};
	helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers.EPSILON = Number.EPSILON || 1e-14;
	helpers.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers.niceNum = function(range, round) {
		var exponent = Math.floor(helpers.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.currentTarget || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	// Private helper to get a constraint dimension
	// @param domNode : the node to check the constraint on
	// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
	// @param percentageProperty : property of parent to use when calculating width as a percentage
	// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = domNode.parentNode;
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	helpers.getMaximumWidth = function(domNode) {
		var container = domNode.parentNode;
		if (!container) {
			return domNode.clientWidth;
		}

		var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
		var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
		var w = container.clientWidth - paddingLeft - paddingRight;
		var cw = helpers.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers.getMaximumHeight = function(domNode) {
		var container = domNode.parentNode;
		if (!container) {
			return domNode.clientHeight;
		}

		var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
		var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
		var h = container.clientHeight - paddingTop - paddingBottom;
		var ch = helpers.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || window.devicePixelRatio || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		helpers.each(arrayOfThings, function(thing) {
			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
				longest = helpers.measureText(ctx, data, gc, longest, thing);
			} else if (helpers.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				helpers.each(thing, function(nestedThing) {
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
						longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
					}
				});
			}
		});

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (var i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};
	helpers.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers.each(arrayOfThings, function(thing) {
			if (helpers.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers.color = !color ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = defaults.global.defaultColor;
			}

			return color(value);
		};

	helpers.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern) ?
			colorValue :
			helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(258);

var convert = function() {
   return new Converter();
}

for (var func in conversions) {
  // export Raw versions
  convert[func + "Raw"] =  (function(func) {
    // accept array or plain args
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      return conversions[func](arg);
    }
  })(func);

  var pair = /(\w+)2(\w+)/.exec(func),
      from = pair[1],
      to = pair[2];

  // export rgb2hsl and ["rgb"]["hsl"]
  convert[from] = convert[from] || {};

  convert[from][to] = convert[func] = (function(func) { 
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      
      var val = conversions[func](arg);
      if (typeof val == "string" || val === undefined)
        return val; // keyword

      for (var i = 0; i < val.length; i++)
        val[i] = Math.round(val[i]);
      return val;
    }
  })(func);
}


/* Converter does lazy conversion and caching */
var Converter = function() {
   this.convs = {};
};

/* Either get the values for a space or
  set the values for a space, depending on args */
Converter.prototype.routeSpace = function(space, args) {
   var values = args[0];
   if (values === undefined) {
      // color.rgb()
      return this.getValues(space);
   }
   // color.rgb(10, 10, 10)
   if (typeof values == "number") {
      values = Array.prototype.slice.call(args);        
   }

   return this.setValues(space, values);
};
  
/* Set the values for a space, invalidating cache */
Converter.prototype.setValues = function(space, values) {
   this.space = space;
   this.convs = {};
   this.convs[space] = values;
   return this;
};

/* Get the values for a space. If there's already
  a conversion for the space, fetch it, otherwise
  compute it */
Converter.prototype.getValues = function(space) {
   var vals = this.convs[space];
   if (!vals) {
      var fspace = this.space,
          from = this.convs[fspace];
      vals = convert[fspace][space](from);

      this.convs[space] = vals;
   }
  return vals;
};

["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
   Converter.prototype[space] = function(vals) {
      return this.routeSpace(space, arguments);
   }
});

module.exports = convert;

/***/ }),
/* 258 */
/***/ (function(module, exports) {

/* MIT license */

module.exports = {
  rgb2hsl: rgb2hsl,
  rgb2hsv: rgb2hsv,
  rgb2hwb: rgb2hwb,
  rgb2cmyk: rgb2cmyk,
  rgb2keyword: rgb2keyword,
  rgb2xyz: rgb2xyz,
  rgb2lab: rgb2lab,
  rgb2lch: rgb2lch,

  hsl2rgb: hsl2rgb,
  hsl2hsv: hsl2hsv,
  hsl2hwb: hsl2hwb,
  hsl2cmyk: hsl2cmyk,
  hsl2keyword: hsl2keyword,

  hsv2rgb: hsv2rgb,
  hsv2hsl: hsv2hsl,
  hsv2hwb: hsv2hwb,
  hsv2cmyk: hsv2cmyk,
  hsv2keyword: hsv2keyword,

  hwb2rgb: hwb2rgb,
  hwb2hsl: hwb2hsl,
  hwb2hsv: hwb2hsv,
  hwb2cmyk: hwb2cmyk,
  hwb2keyword: hwb2keyword,

  cmyk2rgb: cmyk2rgb,
  cmyk2hsl: cmyk2hsl,
  cmyk2hsv: cmyk2hsv,
  cmyk2hwb: cmyk2hwb,
  cmyk2keyword: cmyk2keyword,

  keyword2rgb: keyword2rgb,
  keyword2hsl: keyword2hsl,
  keyword2hsv: keyword2hsv,
  keyword2hwb: keyword2hwb,
  keyword2cmyk: keyword2cmyk,
  keyword2lab: keyword2lab,
  keyword2xyz: keyword2xyz,

  xyz2rgb: xyz2rgb,
  xyz2lab: xyz2lab,
  xyz2lch: xyz2lch,

  lab2xyz: lab2xyz,
  lab2rgb: lab2rgb,
  lab2lch: lab2lch,

  lch2lab: lch2lab,
  lch2xyz: lch2xyz,
  lch2rgb: lch2rgb
}


function rgb2hsl(rgb) {
  var r = rgb[0]/255,
      g = rgb[1]/255,
      b = rgb[2]/255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, l;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g)/ delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  l = (min + max) / 2;

  if (max == min)
    s = 0;
  else if (l <= 0.5)
    s = delta / (max + min);
  else
    s = delta / (2 - max - min);

  return [h, s * 100, l * 100];
}

function rgb2hsv(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, v;

  if (max == 0)
    s = 0;
  else
    s = (delta/max * 1000)/10;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g) / delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  v = ((max / 255) * 1000) / 10;

  return [h, s, v];
}

function rgb2hwb(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      h = rgb2hsl(rgb)[0],
      w = 1/255 * Math.min(r, Math.min(g, b)),
      b = 1 - 1/255 * Math.max(r, Math.max(g, b));

  return [h, w * 100, b * 100];
}

function rgb2cmyk(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255,
      c, m, y, k;

  k = Math.min(1 - r, 1 - g, 1 - b);
  c = (1 - r - k) / (1 - k) || 0;
  m = (1 - g - k) / (1 - k) || 0;
  y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
}

function rgb2keyword(rgb) {
  return reverseKeywords[JSON.stringify(rgb)];
}

function rgb2xyz(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255;

  // assume sRGB
  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

  return [x * 100, y *100, z * 100];
}

function rgb2lab(rgb) {
  var xyz = rgb2xyz(rgb),
        x = xyz[0],
        y = xyz[1],
        z = xyz[2],
        l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function rgb2lch(args) {
  return lab2lch(rgb2lab(args));
}

function hsl2rgb(hsl) {
  var h = hsl[0] / 360,
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      t1, t2, t3, rgb, val;

  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }

  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  t1 = 2 * l - t2;

  rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * - (i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;

    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;

    rgb[i] = val * 255;
  }

  return rgb;
}

function hsl2hsv(hsl) {
  var h = hsl[0],
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      sv, v;

  if(l === 0) {
      // no need to do calc on black
      // also avoids divide by 0 error
      return [0, 0, 0];
  }

  l *= 2;
  s *= (l <= 1) ? l : 2 - l;
  v = (l + s) / 2;
  sv = (2 * s) / (l + s);
  return [h, sv * 100, v * 100];
}

function hsl2hwb(args) {
  return rgb2hwb(hsl2rgb(args));
}

function hsl2cmyk(args) {
  return rgb2cmyk(hsl2rgb(args));
}

function hsl2keyword(args) {
  return rgb2keyword(hsl2rgb(args));
}


function hsv2rgb(hsv) {
  var h = hsv[0] / 60,
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      hi = Math.floor(h) % 6;

  var f = h - Math.floor(h),
      p = 255 * v * (1 - s),
      q = 255 * v * (1 - (s * f)),
      t = 255 * v * (1 - (s * (1 - f))),
      v = 255 * v;

  switch(hi) {
    case 0:
      return [v, t, p];
    case 1:
      return [q, v, p];
    case 2:
      return [p, v, t];
    case 3:
      return [p, q, v];
    case 4:
      return [t, p, v];
    case 5:
      return [v, p, q];
  }
}

function hsv2hsl(hsv) {
  var h = hsv[0],
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      sl, l;

  l = (2 - s) * v;
  sl = s * v;
  sl /= (l <= 1) ? l : 2 - l;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
}

function hsv2hwb(args) {
  return rgb2hwb(hsv2rgb(args))
}

function hsv2cmyk(args) {
  return rgb2cmyk(hsv2rgb(args));
}

function hsv2keyword(args) {
  return rgb2keyword(hsv2rgb(args));
}

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
function hwb2rgb(hwb) {
  var h = hwb[0] / 360,
      wh = hwb[1] / 100,
      bl = hwb[2] / 100,
      ratio = wh + bl,
      i, v, f, n;

  // wh + bl cant be > 1
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }

  i = Math.floor(6 * h);
  v = 1 - bl;
  f = 6 * h - i;
  if ((i & 0x01) != 0) {
    f = 1 - f;
  }
  n = wh + f * (v - wh);  // linear interpolation

  switch (i) {
    default:
    case 6:
    case 0: r = v; g = n; b = wh; break;
    case 1: r = n; g = v; b = wh; break;
    case 2: r = wh; g = v; b = n; break;
    case 3: r = wh; g = n; b = v; break;
    case 4: r = n; g = wh; b = v; break;
    case 5: r = v; g = wh; b = n; break;
  }

  return [r * 255, g * 255, b * 255];
}

function hwb2hsl(args) {
  return rgb2hsl(hwb2rgb(args));
}

function hwb2hsv(args) {
  return rgb2hsv(hwb2rgb(args));
}

function hwb2cmyk(args) {
  return rgb2cmyk(hwb2rgb(args));
}

function hwb2keyword(args) {
  return rgb2keyword(hwb2rgb(args));
}

function cmyk2rgb(cmyk) {
  var c = cmyk[0] / 100,
      m = cmyk[1] / 100,
      y = cmyk[2] / 100,
      k = cmyk[3] / 100,
      r, g, b;

  r = 1 - Math.min(1, c * (1 - k) + k);
  g = 1 - Math.min(1, m * (1 - k) + k);
  b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
}

function cmyk2hsl(args) {
  return rgb2hsl(cmyk2rgb(args));
}

function cmyk2hsv(args) {
  return rgb2hsv(cmyk2rgb(args));
}

function cmyk2hwb(args) {
  return rgb2hwb(cmyk2rgb(args));
}

function cmyk2keyword(args) {
  return rgb2keyword(cmyk2rgb(args));
}


function xyz2rgb(xyz) {
  var x = xyz[0] / 100,
      y = xyz[1] / 100,
      z = xyz[2] / 100,
      r, g, b;

  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

  // assume sRGB
  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
    : r = (r * 12.92);

  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
    : g = (g * 12.92);

  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
    : b = (b * 12.92);

  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);

  return [r * 255, g * 255, b * 255];
}

function xyz2lab(xyz) {
  var x = xyz[0],
      y = xyz[1],
      z = xyz[2],
      l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function xyz2lch(args) {
  return lab2lch(xyz2lab(args));
}

function lab2xyz(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      x, y, z, y2;

  if (l <= 8) {
    y = (l * 100) / 903.3;
    y2 = (7.787 * (y / 100)) + (16 / 116);
  } else {
    y = 100 * Math.pow((l + 16) / 116, 3);
    y2 = Math.pow(y / 100, 1/3);
  }

  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);

  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);

  return [x, y, z];
}

function lab2lch(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      hr, h, c;

  hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  c = Math.sqrt(a * a + b * b);
  return [l, c, h];
}

function lab2rgb(args) {
  return xyz2rgb(lab2xyz(args));
}

function lch2lab(lch) {
  var l = lch[0],
      c = lch[1],
      h = lch[2],
      a, b, hr;

  hr = h / 360 * 2 * Math.PI;
  a = c * Math.cos(hr);
  b = c * Math.sin(hr);
  return [l, a, b];
}

function lch2xyz(args) {
  return lab2xyz(lch2lab(args));
}

function lch2rgb(args) {
  return lab2rgb(lch2lab(args));
}

function keyword2rgb(keyword) {
  return cssKeywords[keyword];
}

function keyword2hsl(args) {
  return rgb2hsl(keyword2rgb(args));
}

function keyword2hsv(args) {
  return rgb2hsv(keyword2rgb(args));
}

function keyword2hwb(args) {
  return rgb2hwb(keyword2rgb(args));
}

function keyword2cmyk(args) {
  return rgb2cmyk(keyword2rgb(args));
}

function keyword2lab(args) {
  return rgb2lab(keyword2rgb(args));
}

function keyword2xyz(args) {
  return rgb2xyz(keyword2rgb(args));
}

var cssKeywords = {
  aliceblue:  [240,248,255],
  antiquewhite: [250,235,215],
  aqua: [0,255,255],
  aquamarine: [127,255,212],
  azure:  [240,255,255],
  beige:  [245,245,220],
  bisque: [255,228,196],
  black:  [0,0,0],
  blanchedalmond: [255,235,205],
  blue: [0,0,255],
  blueviolet: [138,43,226],
  brown:  [165,42,42],
  burlywood:  [222,184,135],
  cadetblue:  [95,158,160],
  chartreuse: [127,255,0],
  chocolate:  [210,105,30],
  coral:  [255,127,80],
  cornflowerblue: [100,149,237],
  cornsilk: [255,248,220],
  crimson:  [220,20,60],
  cyan: [0,255,255],
  darkblue: [0,0,139],
  darkcyan: [0,139,139],
  darkgoldenrod:  [184,134,11],
  darkgray: [169,169,169],
  darkgreen:  [0,100,0],
  darkgrey: [169,169,169],
  darkkhaki:  [189,183,107],
  darkmagenta:  [139,0,139],
  darkolivegreen: [85,107,47],
  darkorange: [255,140,0],
  darkorchid: [153,50,204],
  darkred:  [139,0,0],
  darksalmon: [233,150,122],
  darkseagreen: [143,188,143],
  darkslateblue:  [72,61,139],
  darkslategray:  [47,79,79],
  darkslategrey:  [47,79,79],
  darkturquoise:  [0,206,209],
  darkviolet: [148,0,211],
  deeppink: [255,20,147],
  deepskyblue:  [0,191,255],
  dimgray:  [105,105,105],
  dimgrey:  [105,105,105],
  dodgerblue: [30,144,255],
  firebrick:  [178,34,34],
  floralwhite:  [255,250,240],
  forestgreen:  [34,139,34],
  fuchsia:  [255,0,255],
  gainsboro:  [220,220,220],
  ghostwhite: [248,248,255],
  gold: [255,215,0],
  goldenrod:  [218,165,32],
  gray: [128,128,128],
  green:  [0,128,0],
  greenyellow:  [173,255,47],
  grey: [128,128,128],
  honeydew: [240,255,240],
  hotpink:  [255,105,180],
  indianred:  [205,92,92],
  indigo: [75,0,130],
  ivory:  [255,255,240],
  khaki:  [240,230,140],
  lavender: [230,230,250],
  lavenderblush:  [255,240,245],
  lawngreen:  [124,252,0],
  lemonchiffon: [255,250,205],
  lightblue:  [173,216,230],
  lightcoral: [240,128,128],
  lightcyan:  [224,255,255],
  lightgoldenrodyellow: [250,250,210],
  lightgray:  [211,211,211],
  lightgreen: [144,238,144],
  lightgrey:  [211,211,211],
  lightpink:  [255,182,193],
  lightsalmon:  [255,160,122],
  lightseagreen:  [32,178,170],
  lightskyblue: [135,206,250],
  lightslategray: [119,136,153],
  lightslategrey: [119,136,153],
  lightsteelblue: [176,196,222],
  lightyellow:  [255,255,224],
  lime: [0,255,0],
  limegreen:  [50,205,50],
  linen:  [250,240,230],
  magenta:  [255,0,255],
  maroon: [128,0,0],
  mediumaquamarine: [102,205,170],
  mediumblue: [0,0,205],
  mediumorchid: [186,85,211],
  mediumpurple: [147,112,219],
  mediumseagreen: [60,179,113],
  mediumslateblue:  [123,104,238],
  mediumspringgreen:  [0,250,154],
  mediumturquoise:  [72,209,204],
  mediumvioletred:  [199,21,133],
  midnightblue: [25,25,112],
  mintcream:  [245,255,250],
  mistyrose:  [255,228,225],
  moccasin: [255,228,181],
  navajowhite:  [255,222,173],
  navy: [0,0,128],
  oldlace:  [253,245,230],
  olive:  [128,128,0],
  olivedrab:  [107,142,35],
  orange: [255,165,0],
  orangered:  [255,69,0],
  orchid: [218,112,214],
  palegoldenrod:  [238,232,170],
  palegreen:  [152,251,152],
  paleturquoise:  [175,238,238],
  palevioletred:  [219,112,147],
  papayawhip: [255,239,213],
  peachpuff:  [255,218,185],
  peru: [205,133,63],
  pink: [255,192,203],
  plum: [221,160,221],
  powderblue: [176,224,230],
  purple: [128,0,128],
  rebeccapurple: [102, 51, 153],
  red:  [255,0,0],
  rosybrown:  [188,143,143],
  royalblue:  [65,105,225],
  saddlebrown:  [139,69,19],
  salmon: [250,128,114],
  sandybrown: [244,164,96],
  seagreen: [46,139,87],
  seashell: [255,245,238],
  sienna: [160,82,45],
  silver: [192,192,192],
  skyblue:  [135,206,235],
  slateblue:  [106,90,205],
  slategray:  [112,128,144],
  slategrey:  [112,128,144],
  snow: [255,250,250],
  springgreen:  [0,255,127],
  steelblue:  [70,130,180],
  tan:  [210,180,140],
  teal: [0,128,128],
  thistle:  [216,191,216],
  tomato: [255,99,71],
  turquoise:  [64,224,208],
  violet: [238,130,238],
  wheat:  [245,222,179],
  white:  [255,255,255],
  whitesmoke: [245,245,245],
  yellow: [255,255,0],
  yellowgreen:  [154,205,50]
};

var reverseKeywords = {};
for (var key in cssKeywords) {
  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
}


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var colorNames = __webpack_require__(260);

module.exports = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
}

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3})$/i,
       hex =  /^#([a-fA-F0-9]{6})$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr);
   if (match) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
   }
   else if (match = string.match(hex)) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorNames[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgb) {
   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
              + hexDouble(rgb[2]);
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorNames) {
   reverseNames[colorNames[name]] = name;
}


/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var Element = __webpack_require__(14);
var helpers = __webpack_require__(1);

defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		}
	}
});

module.exports = Element.extend({
	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var	angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += 2.0 * Math.PI;
			}
			while (angle > endAngle) {
				angle -= 2.0 * Math.PI;
			}
			while (angle < startAngle) {
				angle += 2.0 * Math.PI;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var sA = vm.startAngle;
		var eA = vm.endAngle;

		ctx.beginPath();

		ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
		ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);

		ctx.closePath();
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;

		ctx.fillStyle = vm.backgroundColor;

		ctx.fill();
		ctx.lineJoin = 'bevel';

		if (vm.borderWidth) {
			ctx.stroke();
		}
	}
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var Element = __webpack_require__(14);
var helpers = __webpack_require__(1);

var globalDefaults = defaults.global;

defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

module.exports = Element.extend({
	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var index, current, previous, currentVM;

		// If we are looping, adding the first point again
		if (me._loop && points.length) {
			points.push(points[0]);
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();
		lastDrawnIndex = -1;

		for (index = 0; index < points.length; ++index) {
			current = points[index];
			previous = helpers.previousItem(points, index);
			currentVM = current._view;

			// First point moves to it's starting position no matter what
			if (index === 0) {
				if (!currentVM.skip) {
					ctx.moveTo(currentVM.x, currentVM.y);
					lastDrawnIndex = index;
				}
			} else {
				previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];

				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers.canvas.lineTo(ctx, previous._view, current._view);
					}
					lastDrawnIndex = index;
				}
			}
		}

		ctx.stroke();
		ctx.restore();
	}
});


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var Element = __webpack_require__(14);
var helpers = __webpack_require__(1);

var defaultColor = defaults.global.defaultColor;

defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderColor: defaultColor,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

module.exports = Element.extend({
	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var model = this._model;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var color = helpers.color;
		var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
		var ratio = 0;

		if (vm.skip) {
			return;
		}

		ctx.strokeStyle = vm.borderColor || defaultColor;
		ctx.lineWidth = helpers.valueOrDefault(vm.borderWidth, defaults.global.elements.point.borderWidth);
		ctx.fillStyle = vm.backgroundColor || defaultColor;

		// Cliping for Points.
		// going out from inner charArea?
		if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right * errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom * errMargin < model.y))) {
			// Point fade out
			if (model.x < chartArea.left) {
				ratio = (x - model.x) / (chartArea.left - model.x);
			} else if (chartArea.right * errMargin < model.x) {
				ratio = (model.x - x) / (model.x - chartArea.right);
			} else if (model.y < chartArea.top) {
				ratio = (y - model.y) / (chartArea.top - model.y);
			} else if (chartArea.bottom * errMargin < model.y) {
				ratio = (model.y - y) / (model.y - chartArea.bottom);
			}
			ratio = Math.round(ratio * 100) / 100;
			ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
			ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
		}

		helpers.canvas.drawPoint(ctx, pointStyle, radius, x, y);
	}
});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var Element = __webpack_require__(14);

defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: defaults.global.defaultColor,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(bar) {
	return bar._view.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(bar) {
	var vm = bar._view;
	var x1, x2, y1, y2;

	if (isVertical(bar)) {
		// vertical
		var halfWidth = vm.width / 2;
		x1 = vm.x - halfWidth;
		x2 = vm.x + halfWidth;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		// horizontal bar
		var halfHeight = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - halfHeight;
		y2 = vm.y + halfHeight;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

module.exports = Element.extend({
	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var left, right, top, bottom, signX, signY, borderSkipped;
		var borderWidth = vm.borderWidth;

		if (!vm.horizontal) {
			// bar
			left = vm.x - vm.width / 2;
			right = vm.x + vm.width / 2;
			top = vm.y;
			bottom = vm.base;
			signX = 1;
			signY = bottom > top ? 1 : -1;
			borderSkipped = vm.borderSkipped || 'bottom';
		} else {
			// horizontal bar
			left = vm.base;
			right = vm.x;
			top = vm.y - vm.height / 2;
			bottom = vm.y + vm.height / 2;
			signX = right > left ? 1 : -1;
			signY = 1;
			borderSkipped = vm.borderSkipped || 'left';
		}

		// Canvas doesn't allow us to stroke inside the width so we can
		// adjust the sizes to fit if we're setting a stroke on the line
		if (borderWidth) {
			// borderWidth shold be less than bar width and bar height.
			var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
			borderWidth = borderWidth > barSize ? barSize : borderWidth;
			var halfStroke = borderWidth / 2;
			// Adjust borderWidth when bar top position is near vm.base(zero).
			var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
			var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
			var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
			var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
			// not become a vertical line?
			if (borderLeft !== borderRight) {
				top = borderTop;
				bottom = borderBottom;
			}
			// not become a horizontal line?
			if (borderTop !== borderBottom) {
				left = borderLeft;
				right = borderRight;
			}
		}

		ctx.beginPath();
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = borderWidth;

		// Corner points, from bottom-left to bottom-right clockwise
		// | 1 2 |
		// | 0 3 |
		var corners = [
			[left, bottom],
			[left, top],
			[right, top],
			[right, bottom]
		];

		// Find first (starting) corner with fallback to 'bottom'
		var borders = ['bottom', 'left', 'top', 'right'];
		var startCorner = borders.indexOf(borderSkipped, 0);
		if (startCorner === -1) {
			startCorner = 0;
		}

		function cornerAt(index) {
			return corners[(startCorner + index) % 4];
		}

		// Draw rectangle from 'startCorner'
		var corner = cornerAt(0);
		ctx.moveTo(corner[0], corner[1]);

		for (var i = 1; i < 4; i++) {
			corner = cornerAt(i);
			ctx.lineTo(corner[0], corner[1]);
		}

		ctx.fill();
		if (borderWidth) {
			ctx.stroke();
		}
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		var inRange = false;

		if (this._view) {
			var bounds = getBarBounds(this);
			inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inLabelRange: function(mouseX, mouseY) {
		var me = this;
		if (!me._view) {
			return false;
		}

		var inRange = false;
		var bounds = getBarBounds(me);

		if (isVertical(me)) {
			inRange = mouseX >= bounds.left && mouseX <= bounds.right;
		} else {
			inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inXRange: function(mouseX) {
		var bounds = getBarBounds(this);
		return mouseX >= bounds.left && mouseX <= bounds.right;
	},

	inYRange: function(mouseY) {
		var bounds = getBarBounds(this);
		return mouseY >= bounds.top && mouseY <= bounds.bottom;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(this)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;
		return vm.width * Math.abs(vm.y - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});


/***/ }),
/* 265 */
/***/ (function(module, exports) {

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

module.exports = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Chart.Platform implementation for targeting a web browser
 */



var helpers = __webpack_require__(1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {Number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addEventListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeEventListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var resizer = document.createElement('div');
	var cls = CSS_PREFIX + 'size-monitor';
	var maxSize = 1000000;
	var style =
		'position:absolute;' +
		'left:0;' +
		'top:0;' +
		'right:0;' +
		'bottom:0;' +
		'overflow:hidden;' +
		'pointer-events:none;' +
		'visibility:hidden;' +
		'z-index:-1;';

	resizer.style.cssText = style;
	resizer.className = cls;
	resizer.innerHTML =
		'<div class="' + cls + '-expand" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:' + maxSize + 'px;' +
				'height:' + maxSize + 'px;' +
				'left:0;' +
				'top:0">' +
			'</div>' +
		'</div>' +
		'<div class="' + cls + '-shrink" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:200%;' +
				'height:200%;' +
				'left:0; ' +
				'top:0">' +
			'</div>' +
		'</div>';

	var expand = resizer.childNodes[0];
	var shrink = resizer.childNodes[1];

	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};
	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addEventListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addEventListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers.each(ANIMATION_START_EVENTS, function(type) {
		addEventListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers.each(ANIMATION_START_EVENTS, function(type) {
			removeEventListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			return listener(createEvent('resize', chart));
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

function injectCSS(platform, css) {
	// http://stackoverflow.com/q/3922139
	var style = platform._style || document.createElement('style');
	if (!platform._style) {
		platform._style = style;
		css = '/* Chart.js */\n' + css;
		style.setAttribute('type', 'text/css');
		document.getElementsByTagName('head')[0].appendChild(style);
	}

	style.appendChild(document.createTextNode(css));
}

module.exports = {
	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	initialize: function() {
		var keyframes = 'from{opacity:0.99}to{opacity:1}';

		injectCSS(this,
			// DOM rendering detection
			// https://davidwalsh.name/detect-node-insertion
			'@-webkit-keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'@keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'.' + CSS_RENDER_MONITOR + '{' +
				'-webkit-animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
				'animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
			'}'
		);
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addEventListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas, listener);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeEventListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.addEvent = addEventListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.removeEvent = removeEventListener;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */


var defaults = __webpack_require__(3);
var Element = __webpack_require__(14);
var helpers = __webpack_require__(1);

defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers.noop,
		onComplete: helpers.noop
	}
});

module.exports = function(Chart) {

	Chart.Animation = Element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service

		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});

	Chart.animationService = {
		frameDuration: 17,
		animations: [],
		dropFrames: 0,
		request: null,

		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {Number} duration - The animation duration in ms.
		 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;

			animation.chart = chart;

			if (!lazy) {
				chart.animating = true;
			}

			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}

			animations.push(animation);

			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},

		cancelAnimation: function(chart) {
			var index = helpers.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});

			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},

		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},

		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
			var startTime = Date.now();
			var framesToDrop = 0;

			if (me.dropFrames > 1) {
				framesToDrop = Math.floor(me.dropFrames);
				me.dropFrames = me.dropFrames % 1;
			}

			me.advance(1 + framesToDrop);

			var endTime = Date.now();

			me.dropFrames += (endTime - startTime) / me.frameDuration;

			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},

		/**
		 * @private
		 */
		advance: function(count) {
			var animations = this.animations;
			var animation, chart;
			var i = 0;

			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;

				animation.currentStep = (animation.currentStep || 0) + count;
				animation.currentStep = Math.min(animation.currentStep, animation.numSteps);

				helpers.callback(animation.render, [chart, animation], chart);
				helpers.callback(animation.onAnimationProgress, [animation], chart);

				if (animation.currentStep >= animation.numSteps) {
					helpers.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};

	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});

};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var helpers = __webpack_require__(1);
var Interaction = __webpack_require__(95);
var layouts = __webpack_require__(30);
var platform = __webpack_require__(96);
var plugins = __webpack_require__(97);

module.exports = function(Chart) {

	// Create a dictionary of chart types, to allow for extension of existing types
	Chart.types = {};

	// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
	// Destroy method on the chart will remove the instance of the chart from this reference.
	Chart.instances = {};

	// Controllers available for dataset visualization eg. bar, line, slice, etc.
	Chart.controllers = {};

	/**
	 * Initializes the given config with global and chart default values.
	 */
	function initConfig(config) {
		config = config || {};

		// Do NOT use configMerge() for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];

		config.options = helpers.configMerge(
			defaults.global,
			defaults[config.type],
			config.options || {});

		return config;
	}

	/**
	 * Updates the config of the chart
	 * @param chart {Chart} chart to update the options for
	 */
	function updateConfig(chart) {
		var newOptions = chart.options;

		helpers.each(chart.scales, function(scale) {
			layouts.removeBox(chart, scale);
		});

		newOptions = helpers.configMerge(
			Chart.defaults.global,
			Chart.defaults[chart.config.type],
			newOptions);

		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();
		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}

	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}

	helpers.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;

			config = initConfig(config);

			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;

			me.id = helpers.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;

			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception

			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;

			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});

			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}

			me.initialize();
			me.update();
		},

		/**
		 * @private
		 */
		initialize: function() {
			var me = this;

			// Before init plugin notification
			plugins.notify(me, 'beforeInit');

			helpers.retinaScale(me, me.options.devicePixelRatio);

			me.bindEvents();

			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}

			// Make sure scales have IDs and are built before we build any controllers.
			me.ensureScalesHaveIDs();
			me.buildOrUpdateScales();
			me.initToolTip();

			// After init plugin notification
			plugins.notify(me, 'afterInit');

			return me;
		},

		clear: function() {
			helpers.canvas.clear(this);
			return this;
		},

		stop: function() {
			// Stops any current animation loop occurring
			Chart.animationService.cancelAnimation(this);
			return this;
		},

		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.

			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collased
			var newWidth = Math.max(0, Math.floor(helpers.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas)));

			if (me.width === newWidth && me.height === newHeight) {
				return;
			}

			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';

			helpers.retinaScale(me, options.devicePixelRatio);

			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				plugins.notify(me, 'resize', [newSize]);

				// Notify of resize
				if (me.options.onResize) {
					me.options.onResize(me, newSize);
				}

				me.stop();
				me.update(me.options.responsiveAnimationDuration);
			}
		},

		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;

			helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
			});

			helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
			});

			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},

		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildOrUpdateScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function(obj, id) {
				obj[id] = false;
				return obj;
			}, {});

			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}

			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}

			helpers.each(items, function(item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = helpers.valueOrDefault(scaleOptions.type, item.dtype);

				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}

				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}

				scale.mergeTicksOptions();

				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers.each(updated, function(hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});

			me.scales = scales;

			Chart.scaleService.addScalesToLayout(this);
		},

		buildOrUpdateControllers: function() {
			var me = this;
			var types = [];
			var newControllers = [];

			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				var meta = me.getDatasetMeta(datasetIndex);
				var type = dataset.type || me.config.type;

				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(datasetIndex);
					meta = me.getDatasetMeta(datasetIndex);
				}
				meta.type = type;

				types.push(meta.type);

				if (meta.controller) {
					meta.controller.updateIndex(datasetIndex);
					meta.controller.linkScales();
				} else {
					var ControllerClass = Chart.controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}

					meta.controller = new ControllerClass(me, datasetIndex);
					newControllers.push(meta.controller);
				}
			}, me);

			return newControllers;
		},

		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},

		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},

		update: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			updateConfig(me);

			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			plugins._invalidate(me);

			if (plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}

			// In case the entire data object changed
			me.tooltip._data = me.data;

			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();

			// Make sure all dataset controllers have correct meta data counts
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
			}, me);

			me.updateLayout();

			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
			}

			me.updateDatasets();

			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();

			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];

			// Do this before render so that any plugins that need final scale updates can use it
			plugins.notify(me, 'afterUpdate');

			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},

		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;

			if (plugins.notify(me, 'beforeLayout') === false) {
				return;
			}

			layouts.update(this, this.width, this.height);

			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			plugins.notify(me, 'afterScaleUpdate');
			plugins.notify(me, 'afterLayout');
		},

		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}

			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}

			plugins.notify(me, 'afterDatasetsUpdate');
		},

		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};

			if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}

			meta.controller.update();

			plugins.notify(me, 'afterDatasetUpdate', [args]);
		},

		render: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			var duration = config.duration;
			var lazy = config.lazy;

			if (plugins.notify(me, 'beforeRender') === false) {
				return;
			}

			var animationOptions = me.options.animation;
			var onComplete = function(animation) {
				plugins.notify(me, 'afterRender');
				helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};

			if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
				var animation = new Chart.Animation({
					numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,

					render: function(chart, animationObject) {
						var easingFunction = helpers.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;

						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},

					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});

				Chart.animationService.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();

				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new Chart.Animation({numSteps: 0, chart: me}));
			}

			return me;
		},

		draw: function(easingValue) {
			var me = this;

			me.clear();

			if (helpers.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}

			me.transition(easingValue);

			if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}

			// Draw all the scales
			helpers.each(me.boxes, function(box) {
				box.draw(me.chartArea);
			}, me);

			if (me.scale) {
				me.scale.draw();
			}

			me.drawDatasets(easingValue);
			me._drawTooltip(easingValue);

			plugins.notify(me, 'afterDraw', [easingValue]);
		},

		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;

			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}

			me.tooltip.transition(easingValue);
		},

		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}

			// Draw datasets reversed to support proper line stacking
			for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
				if (me.isDatasetVisible(i)) {
					me.drawDataset(i, easingValue);
				}
			}

			plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},

		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(index, easingValue) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}

			meta.controller.draw(easingValue);

			plugins.notify(me, 'afterDatasetDraw', [args]);
		},

		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}

			tooltip.draw();

			plugins.notify(me, 'afterTooltipDraw', [args]);
		},

		// Get the single element that was clicked on
		// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		getElementAtEvent: function(e) {
			return Interaction.modes.single(this, e);
		},

		getElementsAtEvent: function(e) {
			return Interaction.modes.label(this, e, {intersect: true});
		},

		getElementsAtXAxis: function(e) {
			return Interaction.modes['x-axis'](this, e, {intersect: true});
		},

		getElementsAtEventForMode: function(e, mode, options) {
			var method = Interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}

			return [];
		},

		getDatasetAtEvent: function(e) {
			return Interaction.modes.dataset(this, e, {intersect: true});
		},

		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}

			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null
				};
			}

			return meta;
		},

		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},

		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);

			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},

		generateLegend: function() {
			return this.options.legendCallback(this);
		},

		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];

			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},

		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;

			me.stop();

			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}

			if (canvas) {
				me.unbindEvents();
				helpers.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}

			plugins.notify(me, 'destroy');

			delete Chart.instances[me.id];
		},

		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},

		initToolTip: function() {
			var me = this;
			me.tooltip = new Chart.Tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},

		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};

			helpers.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});

			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};

				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},

		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}

			delete me._listeners;
			helpers.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},

		updateHoverStyle: function(elements, mode, enabled) {
			var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
			var element, i, ilen;

			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[method](element);
				}
			}
		},

		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;

			if (plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}

			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;

			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start
					? tooltip.handleEvent(e)
					: changed | tooltip.handleEvent(e);
			}

			plugins.notify(me, 'afterEvent', [e]);

			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();

				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render(me.options.hover.animationDuration, true);
			}

			me._bufferedRender = false;
			me._bufferedRequest = null;

			return me;
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {Boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;

			me.lastActive = me.lastActive || [];

			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}

			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}

			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}

			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}

			changed = !helpers.arrayEquals(me.active, me.lastActive);

			// Remember Last Actives
			me.lastActive = me.active;

			return changed;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);

module.exports = function(Chart) {

	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}

		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});

		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];

			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);

					helpers.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});

					return res;
				}
			});
		});
	}

	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}

		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}

		if (listeners.length > 0) {
			return;
		}

		arrayEvents.forEach(function(key) {
			delete array[key];
		});

		delete array._chartjs;
	}

	// Base class for all dataset controllers (line, bar, etc)
	Chart.DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};

	helpers.extend(Chart.DatasetController.prototype, {

		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,

		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,

		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
		},

		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},

		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();

			if (meta.xAxisID === null || !(meta.xAxisID in me.chart.scales)) {
				meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in me.chart.scales)) {
				meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
			}
		},

		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},

		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},

		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},

		reset: function() {
			this.update(true);
		},

		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},

		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},

		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},

		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;

			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}

			meta.dataset = meta.dataset || me.createMetaDataset();
		},

		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},

		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);

			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}

				listenArrayEvents(data, me);
				me._data = data;
			}

			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},

		update: helpers.noop,

		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}

			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},

		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			if (meta.dataset) {
				meta.dataset.draw();
			}

			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},

		removeHoverStyle: function(element, elementOpts) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var model = element._model;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
		},

		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var getHoverColor = helpers.getHoverColor;
			var model = element._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;

			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},

		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},

		/**
		 * @private
		 */
		onDataPush: function() {
			this.insertElements(this.getDataset().data.length - 1, arguments.length);
		},

		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},

		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},

		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},

		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});

	Chart.DatasetController.extend = helpers.inherits;
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var helpers = __webpack_require__(1);
var layouts = __webpack_require__(30);

module.exports = function(Chart) {

	Chart.scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers

		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers.merge({}, [defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				layouts.addBox(chart, scale);
			});
		}
	};
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var Element = __webpack_require__(14);
var helpers = __webpack_require__(1);
var Ticks = __webpack_require__(31);

defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0, 0, 0, 0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// line height
		lineHeight: 1.2,

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: Ticks.formatters.values,
		minor: {},
		major: {}
	}
});

function labelsFromTicks(ticks) {
	var labels = [];
	var i, ilen;

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		labels.push(ticks[i].label);
	}

	return labels;
}

function getLineValue(scale, index, offsetGridLines) {
	var lineValue = scale.getPixelForTick(index);

	if (offsetGridLines) {
		if (index === 0) {
			lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
		}
	}
	return lineValue;
}

module.exports = function(Chart) {

	function computeTextSize(context, tick, font) {
		return helpers.isArray(tick) ?
			helpers.longestText(context, font, tick) :
			context.measureText(tick).width;
	}

	function parseFontOptions(options) {
		var valueOrDefault = helpers.valueOrDefault;
		var globalDefaults = defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var style = valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
		var family = valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);

		return {
			size: size,
			style: style,
			family: family,
			font: helpers.fontString(size, style, family)
		};
	}

	function parseLineHeight(options) {
		return helpers.options.toLineHeight(
			helpers.valueOrDefault(options.lineHeight, 1.2),
			helpers.valueOrDefault(options.fontSize, defaults.global.defaultFontSize));
	}

	Chart.Scale = Element.extend({
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},

		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},

		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type

		mergeTicksOptions: function() {
			var ticks = this.options.ticks;
			if (ticks.minor === false) {
				ticks.minor = {
					display: false
				};
			}
			if (ticks.major === false) {
				ticks.major = {
					display: false
				};
			}
			for (var key in ticks) {
				if (key !== 'major' && key !== 'minor') {
					if (typeof ticks.minor[key] === 'undefined') {
						ticks.minor[key] = ticks[key];
					}
					if (typeof ticks.major[key] === 'undefined') {
						ticks.major[key] = ticks[key];
					}
				}
			}
		},
		beforeUpdate: function() {
			helpers.callback(this.options.beforeUpdate, [this]);
		},
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var i, ilen, labels, label, ticks, tick;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
			me.longestTextCache = me.longestTextCache || {};

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();

			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();

			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.

			me.beforeBuildTicks();

			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];

			me.afterBuildTicks();

			me.beforeTickToLabelConversion();

			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;

			me.afterTickToLabelConversion();

			me.ticks = labels;   // BACKWARD COMPATIBILITY

			// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!

			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = labels.length; i < ilen; ++i) {
				label = labels[i];
				tick = ticks[i];
				if (!tick) {
					ticks.push(tick = {
						label: label,
						major: false
					});
				} else {
					tick.label = label;
				}
			}

			me._ticks = ticks;

			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: function() {
			helpers.callback(this.options.afterUpdate, [this]);
		},

		//

		beforeSetDimensions: function() {
			helpers.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers.callback(this.options.afterSetDimensions, [this]);
		},

		// Data limits
		beforeDataLimits: function() {
			helpers.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers.noop,
		afterDataLimits: function() {
			helpers.callback(this.options.afterDataLimits, [this]);
		},

		//
		beforeBuildTicks: function() {
			helpers.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers.noop,
		afterBuildTicks: function() {
			helpers.callback(this.options.afterBuildTicks, [this]);
		},

		beforeTickToLabelConversion: function() {
			helpers.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers.callback(this.options.afterTickToLabelConversion, [this]);
		},

		//

		beforeCalculateTickRotation: function() {
			helpers.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var context = me.ctx;
			var tickOpts = me.options.ticks;
			var labels = labelsFromTicks(me._ticks);

			// Get the width of each grid by calculating the difference
			// between x offsets between 0 and 1.
			var tickFont = parseFontOptions(tickOpts);
			context.font = tickFont.font;

			var labelRotation = tickOpts.minRotation || 0;

			if (labels.length && me.options.display && me.isHorizontal()) {
				var originalLabelWidth = helpers.longestText(context, tickFont.font, labels, me.longestTextCache);
				var labelWidth = originalLabelWidth;
				var cosRotation, sinRotation;

				// Allow 3 pixels x2 padding either side for label readability
				var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;

				// Max label rotation can be set or default to 90 - also act as a loop counter
				while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
					var angleRadians = helpers.toRadians(labelRotation);
					cosRotation = Math.cos(angleRadians);
					sinRotation = Math.sin(angleRadians);

					if (sinRotation * originalLabelWidth > me.maxHeight) {
						// go back one step
						labelRotation--;
						break;
					}

					labelRotation++;
					labelWidth = cosRotation * originalLabelWidth;
				}
			}

			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers.callback(this.options.afterCalculateTickRotation, [this]);
		},

		//

		beforeFit: function() {
			helpers.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};

			var labels = labelsFromTicks(me._ticks);

			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = opts.display;
			var isHorizontal = me.isHorizontal();

			var tickFont = parseFontOptions(tickOpts);
			var tickMarkLength = opts.gridLines.tickMarkLength;

			// Width
			if (isHorizontal) {
				// subtract the margins to line up with the chartArea if we are a full width scale
				minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
			} else {
				minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			}

			// height
			if (isHorizontal) {
				minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			} else {
				minSize.height = me.maxHeight; // fill all the height
			}

			// Are we showing a title for the scale?
			if (scaleLabelOpts.display && display) {
				var scaleLabelLineHeight = parseLineHeight(scaleLabelOpts);
				var scaleLabelPadding = helpers.options.toPadding(scaleLabelOpts.padding);
				var deltaHeight = scaleLabelLineHeight + scaleLabelPadding.height;

				if (isHorizontal) {
					minSize.height += deltaHeight;
				} else {
					minSize.width += deltaHeight;
				}
			}

			// Don't bother fitting the ticks if we are not showing them
			if (tickOpts.display && display) {
				var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, labels, me.longestTextCache);
				var tallestLabelHeightInLines = helpers.numberOfLabelLines(labels);
				var lineSpace = tickFont.size * 0.5;
				var tickPadding = me.options.ticks.padding;

				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					me.longestLabelWidth = largestTextWidth;

					var angleRadians = helpers.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);

					// TODO - improve this calculation
					var labelHeight = (sinRotation * largestTextWidth)
						+ (tickFont.size * tallestLabelHeightInLines)
						+ (lineSpace * (tallestLabelHeightInLines - 1))
						+ lineSpace; // padding

					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

					me.ctx.font = tickFont.font;
					var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.font);
					var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.font);

					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (me.labelRotation !== 0) {
						me.paddingLeft = opts.position === 'bottom' ? (cosRotation * firstLabelWidth) + 3 : (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
						me.paddingRight = opts.position === 'bottom' ? (cosRotation * lineSpace) + 3 : (cosRotation * lastLabelWidth) + 3;
					} else {
						me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
						me.paddingRight = lastLabelWidth / 2 + 3;
					}
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					if (tickOpts.mirror) {
						largestTextWidth = 0;
					} else {
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						largestTextWidth += tickPadding + lineSpace;
					}

					minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);

					me.paddingTop = tickFont.size / 2;
					me.paddingBottom = tickFont.size / 2;
				}
			}

			me.handleMargins();

			me.width = minSize.width;
			me.height = minSize.height;
		},

		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
				me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
				me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
				me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
			}
		},

		afterFit: function() {
			helpers.callback(this.options.afterFit, [this]);
		},

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
		isFullWidth: function() {
			return (this.options.fullWidth);
		},

		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (helpers.isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if (typeof rawValue === 'number' && !isFinite(rawValue)) {
				return NaN;
			}
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}

			// Value is good, return it
			return rawValue;
		},

		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers.noop,

		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers.noop,

		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers.noop,

		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var pixel = (tickWidth * index) + me.paddingLeft;

				if (offset) {
					pixel += tickWidth / 2;
				}

				var finalVal = me.left + Math.round(pixel);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
			return me.top + (index * (innerHeight / (me._ticks.length - 1)));
		},

		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var valueOffset = (innerWidth * decimal) + me.paddingLeft;

				var finalVal = me.left + Math.round(valueOffset);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			return me.top + (decimal * me.height);
		},

		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},

		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},

		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var skipRatio;
			var me = this;
			var isHorizontal = me.isHorizontal();
			var optionTicks = me.options.ticks.minor;
			var tickCount = ticks.length;
			var labelRotationRadians = helpers.toRadians(me.labelRotation);
			var cosRotation = Math.cos(labelRotationRadians);
			var longestRotatedLabel = me.longestLabelWidth * cosRotation;
			var result = [];
			var i, tick, shouldSkip;

			// figure out the maximum number of gridlines to show
			var maxTicks;
			if (optionTicks.maxTicksLimit) {
				maxTicks = optionTicks.maxTicksLimit;
			}

			if (isHorizontal) {
				skipRatio = false;

				if ((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount > (me.width - (me.paddingLeft + me.paddingRight))) {
					skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount) / (me.width - (me.paddingLeft + me.paddingRight)));
				}

				// if they defined a max number of optionTicks,
				// increase skipRatio until that number is met
				if (maxTicks && tickCount > maxTicks) {
					skipRatio = Math.max(skipRatio, Math.floor(tickCount / maxTicks));
				}
			}

			for (i = 0; i < tickCount; i++) {
				tick = ticks[i];

				// Since we always show the last tick,we need may need to hide the last shown one before
				shouldSkip = (skipRatio > 1 && i % skipRatio > 0) || (i % skipRatio === 0 && i + skipRatio >= tickCount);
				if (shouldSkip && i !== tickCount - 1) {
					// leave tick in place but make sure it's not displayed (#4635)
					delete tick.label;
				}
				result.push(tick);
			}
			return result;
		},

		// Actually draw the scale on the canvas
		// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
		draw: function(chartArea) {
			var me = this;
			var options = me.options;
			if (!options.display) {
				return;
			}

			var context = me.ctx;
			var globalDefaults = defaults.global;
			var optionTicks = options.ticks.minor;
			var optionMajorTicks = options.ticks.major || optionTicks;
			var gridLines = options.gridLines;
			var scaleLabel = options.scaleLabel;

			var isRotated = me.labelRotation !== 0;
			var isHorizontal = me.isHorizontal();

			var ticks = optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
			var tickFontColor = helpers.valueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
			var tickFont = parseFontOptions(optionTicks);
			var majorTickFontColor = helpers.valueOrDefault(optionMajorTicks.fontColor, globalDefaults.defaultFontColor);
			var majorTickFont = parseFontOptions(optionMajorTicks);

			var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;

			var scaleLabelFontColor = helpers.valueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
			var scaleLabelFont = parseFontOptions(scaleLabel);
			var scaleLabelPadding = helpers.options.toPadding(scaleLabel.padding);
			var labelRotationRadians = helpers.toRadians(me.labelRotation);

			var itemsToDraw = [];

			var axisWidth = me.options.gridLines.lineWidth;
			var xTickStart = options.position === 'right' ? me.right : me.right - axisWidth - tl;
			var xTickEnd = options.position === 'right' ? me.right + tl : me.right;
			var yTickStart = options.position === 'bottom' ? me.top + axisWidth : me.bottom - tl - axisWidth;
			var yTickEnd = options.position === 'bottom' ? me.top + axisWidth + tl : me.bottom + axisWidth;

			helpers.each(ticks, function(tick, index) {
				// autoskipper skipped this tick (#4635)
				if (helpers.isNullOrUndef(tick.label)) {
					return;
				}

				var label = tick.label;
				var lineWidth, lineColor, borderDash, borderDashOffset;
				if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash;
					borderDashOffset = gridLines.zeroLineBorderDashOffset;
				} else {
					lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, index);
					lineColor = helpers.valueAtIndexOrDefault(gridLines.color, index);
					borderDash = helpers.valueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
					borderDashOffset = helpers.valueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
				}

				// Common properties
				var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
				var textAlign = 'middle';
				var textBaseline = 'middle';
				var tickPadding = optionTicks.padding;

				if (isHorizontal) {
					var labelYOffset = tl + tickPadding;

					if (options.position === 'bottom') {
						// bottom
						textBaseline = !isRotated ? 'top' : 'middle';
						textAlign = !isRotated ? 'center' : 'right';
						labelY = me.top + labelYOffset;
					} else {
						// top
						textBaseline = !isRotated ? 'bottom' : 'middle';
						textAlign = !isRotated ? 'center' : 'left';
						labelY = me.bottom - labelYOffset;
					}

					var xLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (xLineValue < me.left) {
						lineColor = 'rgba(0,0,0,0)';
					}
					xLineValue += helpers.aliasPixel(lineWidth);

					labelX = me.getPixelForTick(index) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)

					tx1 = tx2 = x1 = x2 = xLineValue;
					ty1 = yTickStart;
					ty2 = yTickEnd;
					y1 = chartArea.top;
					y2 = chartArea.bottom + axisWidth;
				} else {
					var isLeft = options.position === 'left';
					var labelXOffset;

					if (optionTicks.mirror) {
						textAlign = isLeft ? 'left' : 'right';
						labelXOffset = tickPadding;
					} else {
						textAlign = isLeft ? 'right' : 'left';
						labelXOffset = tl + tickPadding;
					}

					labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;

					var yLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (yLineValue < me.top) {
						lineColor = 'rgba(0,0,0,0)';
					}
					yLineValue += helpers.aliasPixel(lineWidth);

					labelY = me.getPixelForTick(index) + optionTicks.labelOffset;

					tx1 = xTickStart;
					tx2 = xTickEnd;
					x1 = chartArea.left;
					x2 = chartArea.right + axisWidth;
					ty1 = ty2 = y1 = y2 = yLineValue;
				}

				itemsToDraw.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					labelX: labelX,
					labelY: labelY,
					glWidth: lineWidth,
					glColor: lineColor,
					glBorderDash: borderDash,
					glBorderDashOffset: borderDashOffset,
					rotation: -1 * labelRotationRadians,
					label: label,
					major: tick.major,
					textBaseline: textBaseline,
					textAlign: textAlign
				});
			});

			// Draw all of the tick labels, tick marks, and grid lines at the correct places
			helpers.each(itemsToDraw, function(itemToDraw) {
				if (gridLines.display) {
					context.save();
					context.lineWidth = itemToDraw.glWidth;
					context.strokeStyle = itemToDraw.glColor;
					if (context.setLineDash) {
						context.setLineDash(itemToDraw.glBorderDash);
						context.lineDashOffset = itemToDraw.glBorderDashOffset;
					}

					context.beginPath();

					if (gridLines.drawTicks) {
						context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
						context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
					}

					if (gridLines.drawOnChartArea) {
						context.moveTo(itemToDraw.x1, itemToDraw.y1);
						context.lineTo(itemToDraw.x2, itemToDraw.y2);
					}

					context.stroke();
					context.restore();
				}

				if (optionTicks.display) {
					// Make sure we draw text in the correct color and font
					context.save();
					context.translate(itemToDraw.labelX, itemToDraw.labelY);
					context.rotate(itemToDraw.rotation);
					context.font = itemToDraw.major ? majorTickFont.font : tickFont.font;
					context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
					context.textBaseline = itemToDraw.textBaseline;
					context.textAlign = itemToDraw.textAlign;

					var label = itemToDraw.label;
					if (helpers.isArray(label)) {
						var lineCount = label.length;
						var lineHeight = tickFont.size * 1.5;
						var y = me.isHorizontal() ? 0 : -lineHeight * (lineCount - 1) / 2;

						for (var i = 0; i < lineCount; ++i) {
							// We just make sure the multiline element is a string here..
							context.fillText('' + label[i], 0, y);
							// apply same lineSpacing as calculated @ L#320
							y += lineHeight;
						}
					} else {
						context.fillText(label, 0, 0);
					}
					context.restore();
				}
			});

			if (scaleLabel.display) {
				// Draw the scale label
				var scaleLabelX;
				var scaleLabelY;
				var rotation = 0;
				var halfLineHeight = parseLineHeight(scaleLabel) / 2;

				if (isHorizontal) {
					scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
					scaleLabelY = options.position === 'bottom'
						? me.bottom - halfLineHeight - scaleLabelPadding.bottom
						: me.top + halfLineHeight + scaleLabelPadding.top;
				} else {
					var isLeft = options.position === 'left';
					scaleLabelX = isLeft
						? me.left + halfLineHeight + scaleLabelPadding.top
						: me.right - halfLineHeight - scaleLabelPadding.top;
					scaleLabelY = me.top + ((me.bottom - me.top) / 2);
					rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
				}

				context.save();
				context.translate(scaleLabelX, scaleLabelY);
				context.rotate(rotation);
				context.textAlign = 'center';
				context.textBaseline = 'middle';
				context.fillStyle = scaleLabelFontColor; // render in correct colour
				context.font = scaleLabelFont.font;
				context.fillText(scaleLabel.labelString, 0, 0);
				context.restore();
			}

			if (gridLines.drawBorder) {
				// Draw the line at the edge of the axis
				context.lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, 0);
				context.strokeStyle = helpers.valueAtIndexOrDefault(gridLines.color, 0);
				var x1 = me.left;
				var x2 = me.right + axisWidth;
				var y1 = me.top;
				var y2 = me.bottom + axisWidth;

				var aliasPixel = helpers.aliasPixel(context.lineWidth);
				if (isHorizontal) {
					y1 = y2 = options.position === 'top' ? me.bottom : me.top;
					y1 += aliasPixel;
					y2 += aliasPixel;
				} else {
					x1 = x2 = options.position === 'left' ? me.right : me.left;
					x1 += aliasPixel;
					x2 += aliasPixel;
				}

				context.beginPath();
				context.moveTo(x1, y1);
				context.lineTo(x2, y2);
				context.stroke();
			}
		}
	});
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var Element = __webpack_require__(14);
var helpers = __webpack_require__(1);

defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers.noop,
			title: function(tooltipItems, data) {
				// Pick first xLabel for now
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];

					if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				label += tooltipItem.yLabel;
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers.noop,
			footer: helpers.noop,
			afterFooter: helpers.noop
		}
	}
});

module.exports = function(Chart) {

	/**
 	 * Helper method to merge the opacity into a color
 	 */
	function mergeOpacity(colorString, opacity) {
		var color = helpers.color(colorString);
		return color.alpha(opacity * color.alpha()).rgbaString();
	}

	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}

		return base;
	}

	// Private helper to create a tooltip item model
	// @param element : the chart element (point, arc, bar) to create the tooltip item for
	// @return : new tooltip item
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;

		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}

	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {Object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = defaults.global;
		var valueOrDefault = helpers.valueOrDefault;

		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,

			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,

			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,

			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,

			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}

	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;

		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;

		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;

		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;

		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};

		ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers.each(model.title, maxLineWidth);

		// Body width
		ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers.each(body, function(bodyItem) {
			helpers.each(bodyItem.before, maxLineWidth);
			helpers.each(bodyItem.lines, maxLineWidth);
			helpers.each(bodyItem.after, maxLineWidth);
		});

		// Reset back to 0
		widthPadding = 0;

		// Footer width
		ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers.each(model.footer, maxLineWidth);

		// Add padding
		width += 2 * model.xPadding;

		return {
			width: width,
			height: height
		};
	}

	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';

		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}

		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;

		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}

		olf = function(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};

		if (lf(model.x)) {
			xAlign = 'left';

			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';

			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}

		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}

	/**
	 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;

		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;

		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}

		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}

		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}

		return {
			x: x,
			y: y
		};
	}

	Chart.Tooltip = Element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},

		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;

			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeTitle);
			lines = pushOrConcat(lines, title);
			lines = pushOrConcat(lines, afterTitle);

			return lines;
		},

		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			var lines = this._options.callbacks.beforeBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];

			helpers.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));

				bodyItems.push(bodyItem);
			});

			return bodyItems;
		},

		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			var lines = this._options.callbacks.afterBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;

			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeFooter);
			lines = pushOrConcat(lines, footer);
			lines = pushOrConcat(lines, afterFooter);

			return lines;
		},

		update: function(changed) {
			var me = this;
			var opts = me._options;

			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;

			var data = me._data;

			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};

			var i, len;

			if (active.length) {
				model.opacity = 1;

				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = Chart.Tooltip.positioners[opts.position].call(me, active, me._eventPosition);

				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}

				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}

				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}

				// Determine colors for boxes
				helpers.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});


				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);

				// Initial positioning and colors
				model.x = Math.round(tooltipPosition.x);
				model.y = Math.round(tooltipPosition.y);
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;

				// data points
				model.dataPoints = tooltipItems;

				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}

			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;

			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;

			me._model = model;

			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}

			return me;
		},
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;

			if (yAlign === 'center') {
				y2 = ptY + (height / 2);

				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;

					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;

					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
		drawTitle: function(pt, vm, ctx, opacity) {
			var title = vm.title;

			if (title.length) {
				ctx.textAlign = vm._titleAlign;
				ctx.textBaseline = 'top';

				var titleFontSize = vm.titleFontSize;
				var titleSpacing = vm.titleSpacing;

				ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
				ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

				var i, len;
				for (i = 0, len = title.length; i < len; ++i) {
					ctx.fillText(title[i], pt.x, pt.y);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing

					if (i + 1 === title.length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
		drawBody: function(pt, vm, ctx, opacity) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var body = vm.body;

			ctx.textAlign = vm._bodyAlign;
			ctx.textBaseline = 'top';
			ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

			// Before Body
			var xLinePadding = 0;
			var fillLineOfText = function(line) {
				ctx.fillText(line, pt.x + xLinePadding, pt.y);
				pt.y += bodyFontSize + bodySpacing;
			};

			// Before body lines
			ctx.fillStyle = mergeOpacity(vm.bodyFontColor, opacity);
			helpers.each(vm.beforeBody, fillLineOfText);

			var drawColorBoxes = vm.displayColors;
			xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;

			// Draw body lines now
			helpers.each(body, function(bodyItem, i) {
				var textColor = mergeOpacity(vm.labelTextColors[i], opacity);
				ctx.fillStyle = textColor;
				helpers.each(bodyItem.before, fillLineOfText);

				helpers.each(bodyItem.lines, function(line) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
						ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
						ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Inner square
						ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
						ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}

					fillLineOfText(line);
				});

				helpers.each(bodyItem.after, fillLineOfText);
			});

			// Reset back to 0 for after body
			xLinePadding = 0;

			// After body lines
			helpers.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
		drawFooter: function(pt, vm, ctx, opacity) {
			var footer = vm.footer;

			if (footer.length) {
				pt.y += vm.footerMarginTop;

				ctx.textAlign = vm._footerAlign;
				ctx.textBaseline = 'top';

				ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
				ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

				helpers.each(footer, function(line) {
					ctx.fillText(line, pt.x, pt.y);
					pt.y += vm.footerFontSize + vm.footerSpacing;
				});
			}
		},
		drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
			ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
			ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;

			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();

			ctx.fill();

			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;

			if (vm.opacity === 0) {
				return;
			}

			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};

			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

			if (this._options.enabled && hasTooltipContent) {
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize, opacity);

				// Draw Title, Body, and Footer
				pt.x += vm.xPadding;
				pt.y += vm.yPadding;

				// Titles
				this.drawTitle(pt, vm, ctx, opacity);

				// Body
				this.drawBody(pt, vm, ctx, opacity);

				// Footer
				this.drawFooter(pt, vm, ctx, opacity);
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {Boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;

			me._lastActive = me._lastActive || [];

			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			}

			// Remember Last Actives
			changed = !helpers.arrayEquals(me._active, me._lastActive);

			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;

				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};

					me.update(true);
					me.pivot();
				}
			}

			return changed;
		}
	});

	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	Chart.Tooltip.positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {Point} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}

			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}

			return {
				x: Math.round(x / count),
				y: Math.round(y / count)
			};
		},

		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {Point} the position of the event in canvas coordinates
		 * @returns {Point} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers.distanceBetweenPoints(eventPosition, center);

					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}

			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}

			return {
				x: x,
				y: y
			};
		}
	};
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {Array<Number>} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var spacing;
	if (generationOptions.stepSize && generationOptions.stepSize > 0) {
		spacing = generationOptions.stepSize;
	} else {
		var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
		spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
	}
	var niceMin = Math.floor(dataRange.min / spacing) * spacing;
	var niceMax = Math.ceil(dataRange.max / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
		// If very close to our whole number, use it.
		if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
			niceMin = generationOptions.min;
			niceMax = generationOptions.max;
		}
	}

	var numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	var precision = 1;
	if (spacing < 1) {
		precision = Math.pow(10, spacing.toString().length - 2);
		niceMin = Math.round(niceMin * precision) / precision;
		niceMax = Math.round(niceMax * precision) / precision;
	}
	ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * precision) / precision);
	}
	ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);

	return ticks;
}


module.exports = function(Chart) {

	var noop = helpers.noop;

	Chart.LinearScaleBase = Chart.Scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return Chart.Scale.prototype.getRightValue.call(this, value);
		},

		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers.sign(me.min);
				var maxSign = helpers.sign(me.max);

				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}

			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}

			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}

			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}

			if (me.min === me.max) {
				me.max++;

				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
		getTickLimit: noop,
		handleDirectionalChanges: noop,

		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);

			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				stepSize: helpers.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

			me.handleDirectionalChanges();

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);

			Chart.Scale.prototype.convertTicksToLabels.call(me);
		}
	});
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	// Default config for a category scale
	var defaultConfig = {
		position: 'bottom'
	};

	var DatasetScale = Chart.Scale.extend({
		/**
		* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
		* else fall back to data.labels
		* @private
		*/
		getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
		},

		determineDataLimits: function() {
			var me = this;
			var labels = me.getLabels();
			me.minIndex = 0;
			me.maxIndex = labels.length - 1;
			var findIndex;

			if (me.options.ticks.min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(me.options.ticks.min);
				me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
			}

			if (me.options.ticks.max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(me.options.ticks.max);
				me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
			}

			me.min = labels[me.minIndex];
			me.max = labels[me.maxIndex];
		},

		buildTicks: function() {
			var me = this;
			var labels = me.getLabels();
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var isHorizontal = me.isHorizontal();

			if (data.yLabels && !isHorizontal) {
				return me.getRightValue(data.datasets[datasetIndex].data[index]);
			}
			return me.ticks[index - me.minIndex];
		},

		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index) {
			var me = this;
			var offset = me.options.offset;
			// 1 is added because we need the length but we have the indexes
			var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);

			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			var valueCategory;
			if (value !== undefined && value !== null) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				var labels = me.getLabels();
				value = valueCategory || value;
				var idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
			}

			if (me.isHorizontal()) {
				var valueWidth = me.width / offsetAmt;
				var widthOffset = (valueWidth * (index - me.minIndex));

				if (offset) {
					widthOffset += (valueWidth / 2);
				}

				return me.left + Math.round(widthOffset);
			}
			var valueHeight = me.height / offsetAmt;
			var heightOffset = (valueHeight * (index - me.minIndex));

			if (offset) {
				heightOffset += (valueHeight / 2);
			}

			return me.top + Math.round(heightOffset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var offset = me.options.offset;
			var value;
			var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
			var horz = me.isHorizontal();
			var valueDimension = (horz ? me.width : me.height) / offsetAmt;

			pixel -= horz ? me.left : me.top;

			if (offset) {
				pixel -= (valueDimension / 2);
			}

			if (pixel <= 0) {
				value = 0;
			} else {
				value = Math.round(pixel / valueDimension);
			}

			return value + me.minIndex;
		},
		getBasePixel: function() {
			return this.bottom;
		}
	});

	Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);

};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var helpers = __webpack_require__(1);
var Ticks = __webpack_require__(31);

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',
		ticks: {
			callback: Ticks.formatters.linear
		}
	};

	var LinearScale = Chart.LinearScaleBase.extend({

		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			var DEFAULT_MIN = 0;
			var DEFAULT_MAX = 1;

			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// First Calculate the range
			me.min = null;
			me.max = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = {
							positiveValues: [],
							negativeValues: []
						};
					}

					// Store these per type
					var positiveValues = valuesPerStack[key].positiveValues;
					var negativeValues = valuesPerStack[key].negativeValues;

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							positiveValues[index] = positiveValues[index] || 0;
							negativeValues[index] = negativeValues[index] || 0;

							if (opts.relativePoints) {
								positiveValues[index] = 100;
							} else if (value < 0) {
								negativeValues[index] += value;
							} else {
								positiveValues[index] += value;
							}
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
					var minVal = helpers.min(values);
					var maxVal = helpers.max(values);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
						});
					}
				});
			}

			me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			this.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var maxTicks;
			var me = this;
			var tickOpts = me.options.ticks;

			if (me.isHorizontal()) {
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
			} else {
				// The factor of 2 used to scale the font size has been experimentally determined.
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, defaults.global.defaultFontSize);
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
			}

			return maxTicks;
		},
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		// Utils
		getPixelForValue: function(value) {
			// This must be called after fit has been run so that
			// this.left, this.top, this.right, and this.bottom have been defined
			var me = this;
			var start = me.start;

			var rightValue = +me.getRightValue(value);
			var pixel;
			var range = me.end - start;

			if (me.isHorizontal()) {
				pixel = me.left + (me.width / range * (rightValue - start));
			} else {
				pixel = me.bottom - (me.height / range * (rightValue - start));
			}
			return pixel;
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var innerDimension = isHorizontal ? me.width : me.height;
			var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
			return me.start + ((me.end - me.start) * offset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticksAsNumbers[index]);
		}
	});
	Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);

};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(1);
var Ticks = __webpack_require__(31);

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {Array<Number>} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	var valueOrDefault = helpers.valueOrDefault;

	// Figure out what the max number of ticks we can support it is based on the size of
	// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
	// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
	// the graph
	var tickVal = valueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));

	var endExp = Math.floor(helpers.log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(helpers.log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(helpers.log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}


module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',

		// label settings
		ticks: {
			callback: Ticks.formatters.logarithmic
		}
	};

	var LogarithmicScale = Chart.Scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// Calculate Range
			me.min = null;
			me.max = null;
			me.minNotZero = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}

						helpers.each(dataset.data, function(rawValue, index) {
							var values = valuesPerStack[key];
							var value = +me.getRightValue(rawValue);
							// invalid, hidden and negative values are ignored
							if (isNaN(value) || meta.data[index].hidden || value < 0) {
								return;
							}
							values[index] = values[index] || 0;
							values[index] += value;
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					}
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							// invalid, hidden and negative values are ignored
							if (isNaN(value) || meta.data[index].hidden || value < 0) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}

							if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
								me.minNotZero = value;
							}
						});
					}
				});
			}

			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},
		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var valueOrDefault = helpers.valueOrDefault;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;

			me.min = valueOrDefault(tickOpts.min, me.min);
			me.max = valueOrDefault(tickOpts.max, me.max);

			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(helpers.log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0
					? Math.pow(10, Math.floor(helpers.log10(me.min)) + 1)
					: DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(helpers.log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var reverse = !me.isHorizontal();

			var generationOptions = {
				min: tickOpts.min,
				max: tickOpts.max
			};
			var ticks = me.ticks = generateTicks(generationOptions, me);

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();

			Chart.Scale.prototype.convertTicksToLabels.call(this);
		},
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.tickValues[index]);
		},
		/**
		 * Returns the value of the first tick.
		 * @param {Number} value - The minimum not zero value.
		 * @return {Number} The first tick value.
		 * @private
		 */
		_getFirstTickValue: function(value) {
			var exp = Math.floor(helpers.log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));

			return significand * Math.pow(10, exp);
		},
		getPixelForValue: function(value) {
			var me = this;
			var reverse = me.options.ticks.reverse;
			var log10 = helpers.log10;
			var firstTickValue = me._getFirstTickValue(me.minNotZero);
			var offset = 0;
			var innerDimension, pixel, start, end, sign;

			value = +me.getRightValue(value);
			if (reverse) {
				start = me.end;
				end = me.start;
				sign = -1;
			} else {
				start = me.start;
				end = me.end;
				sign = 1;
			}
			if (me.isHorizontal()) {
				innerDimension = me.width;
				pixel = reverse ? me.right : me.left;
			} else {
				innerDimension = me.height;
				sign *= -1; // invert, since the upper-left corner of the canvas is at pixel (0, 0)
				pixel = reverse ? me.top : me.bottom;
			}
			if (value !== start) {
				if (start === 0) { // include zero tick
					offset = helpers.getValueOrDefault(
						me.options.ticks.fontSize,
						Chart.defaults.global.defaultFontSize
					);
					innerDimension -= offset;
					start = firstTickValue;
				}
				if (value !== 0) {
					offset += innerDimension / (log10(end) - log10(start)) * (log10(value) - log10(start));
				}
				pixel += sign * offset;
			}
			return pixel;
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var reverse = me.options.ticks.reverse;
			var log10 = helpers.log10;
			var firstTickValue = me._getFirstTickValue(me.minNotZero);
			var innerDimension, start, end, value;

			if (reverse) {
				start = me.end;
				end = me.start;
			} else {
				start = me.start;
				end = me.end;
			}
			if (me.isHorizontal()) {
				innerDimension = me.width;
				value = reverse ? me.right - pixel : pixel - me.left;
			} else {
				innerDimension = me.height;
				value = reverse ? pixel - me.top : me.bottom - pixel;
			}
			if (value !== start) {
				if (start === 0) { // include zero tick
					var offset = helpers.getValueOrDefault(
						me.options.ticks.fontSize,
						Chart.defaults.global.defaultFontSize
					);
					value -= offset;
					innerDimension -= offset;
					start = firstTickValue;
				}
				value *= log10(end) - log10(start);
				value /= innerDimension;
				value = Math.pow(10, log10(start) + value);
			}
			return value;
		}
	});
	Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);

};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var helpers = __webpack_require__(1);
var Ticks = __webpack_require__(31);

module.exports = function(Chart) {

	var globalDefaults = defaults.global;

	var defaultConfig = {
		display: true,

		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',

		angleLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1
		},

		gridLines: {
			circular: false
		},

		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,

			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',

			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,

			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,

			callback: Ticks.formatters.linear
		},

		pointLabels: {
			// Boolean - if true, show point labels
			display: true,

			// Number - Point label font size in pixels
			fontSize: 10,

			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};

	function getValueCount(scale) {
		var opts = scale.options;
		return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
	}

	function getPointLabelFontOptions(scale) {
		var pointLabelOptions = scale.options.pointLabels;
		var fontSize = helpers.valueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
		var fontStyle = helpers.valueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
		var fontFamily = helpers.valueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
		var font = helpers.fontString(fontSize, fontStyle, fontFamily);

		return {
			size: fontSize,
			style: fontStyle,
			family: fontFamily,
			font: font
		};
	}

	function measureLabelSize(ctx, fontSize, label) {
		if (helpers.isArray(label)) {
			return {
				w: helpers.longestText(ctx, ctx.font, label),
				h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
			};
		}

		return {
			w: ctx.measureText(label).width,
			h: fontSize
		};
	}

	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size - 5,
				end: pos
			};
		}

		return {
			start: pos,
			end: pos + size + 5
		};
	}

	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
		/*
		 * Right, this is really confusing and there is a lot of maths going on here
		 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		 *
		 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		 *
		 * Solution:
		 *
		 * We assume the radius of the polygon is half the size of the canvas at first
		 * at each index we check if the text overlaps.
		 *
		 * Where it does, we store that angle and that index.
		 *
		 * After finding the largest index and angle we calculate how much we need to remove
		 * from the shape radius to move the point inwards by that x.
		 *
		 * We average the left and right distances to get the maximum shape radius that can fit in the box
		 * along with labels.
		 *
		 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		 * on each side, removing that from the size, halving it and adding the left x protrusion width.
		 *
		 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		 * and position it in the most space efficient manner
		 *
		 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
		 */

		var plFont = getPointLabelFontOptions(scale);

		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		var furthestLimits = {
			r: scale.width,
			l: 0,
			t: scale.height,
			b: 0
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;

		scale.ctx.font = plFont.font;
		scale._pointLabelSizes = [];

		var valueCount = getValueCount(scale);
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, largestPossibleRadius);
			textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
			scale._pointLabelSizes[i] = textSize;

			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}

			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}

			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}

			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}

		scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
	}

	/**
	 * Helper function to fit a radial linear scale with no point labels
	 */
	function fit(scale) {
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		scale.drawingArea = Math.round(largestPossibleRadius);
		scale.setCenterPoint(0, 0, 0, 0);
	}

	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}

		return 'right';
	}

	function fillText(ctx, text, position, fontSize) {
		if (helpers.isArray(text)) {
			var y = position.y;
			var spacing = 1.5 * fontSize;

			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += spacing;
			}
		} else {
			ctx.fillText(text, position.x, position.y);
		}
	}

	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}

	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var angleLineOpts = opts.angleLines;
		var pointLabelOpts = opts.pointLabels;

		ctx.lineWidth = angleLineOpts.lineWidth;
		ctx.strokeStyle = angleLineOpts.color;

		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);

		// Point Label Font
		var plFont = getPointLabelFontOptions(scale);

		ctx.textBaseline = 'top';

		for (var i = getValueCount(scale) - 1; i >= 0; i--) {
			if (angleLineOpts.display) {
				var outerPosition = scale.getPointPosition(i, outerDistance);
				ctx.beginPath();
				ctx.moveTo(scale.xCenter, scale.yCenter);
				ctx.lineTo(outerPosition.x, outerPosition.y);
				ctx.stroke();
				ctx.closePath();
			}

			if (pointLabelOpts.display) {
				// Extra 3px out for some label spacing
				var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);

				// Keep this in loop since we may support array properties here
				var pointLabelFontColor = helpers.valueAtIndexOrDefault(pointLabelOpts.fontColor, i, globalDefaults.defaultFontColor);
				ctx.font = plFont.font;
				ctx.fillStyle = pointLabelFontColor;

				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians);
				ctx.textAlign = getTextAlignForAngle(angle);
				adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
				fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
			}
		}
	}

	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		ctx.strokeStyle = helpers.valueAtIndexOrDefault(gridLineOpts.color, index - 1);
		ctx.lineWidth = helpers.valueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);

		if (scale.options.gridLines.circular) {
			// Draw circular arcs between the points
			ctx.beginPath();
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.stroke();
		} else {
			// Draw straight lines connecting each index
			var valueCount = getValueCount(scale);

			if (valueCount === 0) {
				return;
			}

			ctx.beginPath();
			var pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);

			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}

			ctx.closePath();
			ctx.stroke();
		}
	}

	function numberOrZero(param) {
		return helpers.isNumber(param) ? param : 0;
	}

	var LinearRadialScale = Chart.LinearScaleBase.extend({
		setDimensions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.xCenter = Math.round(me.width / 2);
			me.yCenter = Math.round(me.height / 2);

			var minSize = helpers.min([me.height, me.width]);
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
		},
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;

			helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);

					helpers.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});

			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var tickOpts = this.options.ticks;
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
		},
		convertTicksToLabels: function() {
			var me = this;

			Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);

			// Point labels
			me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		fit: function() {
			if (this.options.pointLabels.display) {
				fitWithPointLabels(this);
			} else {
				fit(this);
			}
		},
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);

			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);

			me.drawingArea = Math.min(
				Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = me.height - bottomMovement - me.drawingArea;

			me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
		},

		getIndexAngle: function(index) {
			var angleMultiplier = (Math.PI * 2) / getValueCount(this);
			var startAngle = this.chart.options && this.chart.options.startAngle ?
				this.chart.options.startAngle :
				0;

			var startAngleRadians = startAngle * Math.PI * 2 / 360;

			// Start from the top instead of right, so remove a quarter of the circle
			return index * angleMultiplier + startAngleRadians;
		},
		getDistanceFromCenterForValue: function(value) {
			var me = this;

			if (value === null) {
				return 0; // null always in center
			}

			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
				y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
			};
		},
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},

		getBasePosition: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.getPointPositionForValue(0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},

		draw: function() {
			var me = this;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var tickOpts = opts.ticks;
			var valueOrDefault = helpers.valueOrDefault;

			if (opts.display) {
				var ctx = me.ctx;
				var startAngle = this.getIndexAngle(0);

				// Tick Font
				var tickFontSize = valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = valueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = valueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);

				helpers.each(me.ticks, function(label, index) {
					// Don't draw a centre value (if it is minimum)
					if (index > 0 || tickOpts.reverse) {
						var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

						// Draw circular lines around the scale
						if (gridLineOpts.display && index !== 0) {
							drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
						}

						if (tickOpts.display) {
							var tickFontColor = valueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
							ctx.font = tickLabelFont;

							ctx.save();
							ctx.translate(me.xCenter, me.yCenter);
							ctx.rotate(startAngle);

							if (tickOpts.showLabelBackdrop) {
								var labelWidth = ctx.measureText(label).width;
								ctx.fillStyle = tickOpts.backdropColor;
								ctx.fillRect(
									-labelWidth / 2 - tickOpts.backdropPaddingX,
									-yCenterOffset - tickFontSize / 2 - tickOpts.backdropPaddingY,
									labelWidth + tickOpts.backdropPaddingX * 2,
									tickFontSize + tickOpts.backdropPaddingY * 2
								);
							}

							ctx.textAlign = 'center';
							ctx.textBaseline = 'middle';
							ctx.fillStyle = tickFontColor;
							ctx.fillText(label, 0, -yCenterOffset);
							ctx.restore();
						}
					}
				});

				if (opts.angleLines.display || opts.pointLabels.display) {
					drawPointLabels(me);
				}
			}
		}
	});
	Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);

};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */


var moment = __webpack_require__(4);
moment = typeof moment === 'function' ? moment : window.moment;

var defaults = __webpack_require__(3);
var helpers = __webpack_require__(1);

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
	},
	second: {
		common: true,
		size: 1000,
		steps: [1, 2, 5, 10, 30]
	},
	minute: {
		common: true,
		size: 60000,
		steps: [1, 2, 5, 10, 30]
	},
	hour: {
		common: true,
		size: 3600000,
		steps: [1, 2, 3, 6, 12]
	},
	day: {
		common: true,
		size: 86400000,
		steps: [1, 2, 5]
	},
	week: {
		common: false,
		size: 604800000,
		steps: [1, 2, 3, 4]
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: [1, 2, 3]
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: [1, 2, 3, 4]
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {Number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {String} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from http://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

/**
 * Convert the given value to a moment object using the given time options.
 * @see http://momentjs.com/docs/#/parsing/
 */
function momentify(value, options) {
	var parser = options.parser;
	var format = options.parser || options.format;

	if (typeof parser === 'function') {
		return parser(value);
	}

	if (typeof value === 'string' && typeof format === 'string') {
		return moment(value, format);
	}

	if (!(value instanceof moment)) {
		value = moment(value);
	}

	if (value.isValid()) {
		return value;
	}

	// Labels are in an incompatible moment format and no `parser` has been provided.
	// The user might still use the deprecated `format` option to convert his inputs.
	if (typeof format === 'function') {
		return format(value);
	}

	return value;
}

function parse(input, scale) {
	if (helpers.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = momentify(scale.getRightValue(input), options);
	if (!value.isValid()) {
		return null;
	}

	if (options.round) {
		value.startOf(options.round);
	}

	return value.valueOf();
}

/**
 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
 */
function determineStepSize(min, max, unit, capacity) {
	var range = max - min;
	var interval = INTERVALS[unit];
	var milliseconds = interval.size;
	var steps = interval.steps;
	var i, ilen, factor;

	if (!steps) {
		return Math.ceil(range / (capacity * milliseconds));
	}

	for (i = 0, ilen = steps.length; i < ilen; ++i) {
		factor = steps[i];
		if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
			break;
		}
	}

	return factor;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(ticks, minUnit, min, max) {
	var duration = moment.duration(moment(max).diff(moment(min)));
	var ilen = UNITS.length;
	var i, unit;

	for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && duration.as(unit) >= ticks.length) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(min, max, capacity, options) {
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var major = determineMajorUnit(minor);
	var stepSize = helpers.valueOrDefault(timeOpts.stepSize, timeOpts.unitStepSize);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var majorTicksEnabled = options.ticks.major.enabled;
	var interval = INTERVALS[minor];
	var first = moment(min);
	var last = moment(max);
	var ticks = [];
	var time;

	if (!stepSize) {
		stepSize = determineStepSize(min, max, minor, capacity);
	}

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = first.isoWeekday(weekday);
		last = last.isoWeekday(weekday);
	}

	// Align first/last ticks on unit
	first = first.startOf(weekday ? 'day' : minor);
	last = last.startOf(weekday ? 'day' : minor);

	// Make sure that the last tick include max
	if (last < max) {
		last.add(1, minor);
	}

	time = moment(first);

	if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
		// Align the first tick on the previous `minor` unit aligned on the `major` unit:
		// we first aligned time on the previous `major` unit then add the number of full
		// stepSize there is between first and the previous major time.
		time.startOf(major);
		time.add(~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
	}

	for (; time < last; time.add(stepSize, minor)) {
		ticks.push(+time);
	}

	ticks.push(+time);

	return ticks;
}

/**
 * Returns the right and left offsets from edges in the form of {left, right}.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var left = 0;
	var right = 0;
	var upper, lower;

	if (options.offset && ticks.length) {
		if (!options.time.min) {
			upper = ticks.length > 1 ? ticks[1] : max;
			lower = ticks[0];
			left = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
		if (!options.time.max) {
			upper = ticks[ticks.length - 1];
			lower = ticks.length > 1 ? ticks[ticks.length - 2] : min;
			right = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
	}

	return {left: left, right: right};
}

function ticksFromTimestamps(values, majorUnit) {
	var ticks = [];
	var i, ilen, value, major;

	for (i = 0, ilen = values.length; i < ilen; ++i) {
		value = values[i];
		major = majorUnit ? value === +moment(value).startOf(majorUnit) : false;

		ticks.push({
			value: value,
			major: major
		});
	}

	return ticks;
}

function determineLabelFormat(data, timeOpts) {
	var i, momentDate, hasTime;
	var ilen = data.length;

	// find the label with the most parts (milliseconds, minutes, etc.)
	// format all labels with the same level of detail as the most specific label
	for (i = 0; i < ilen; i++) {
		momentDate = momentify(data[i], timeOpts);
		if (momentDate.millisecond() !== 0) {
			return 'MMM D, YYYY h:mm:ss.SSS a';
		}
		if (momentDate.second() !== 0 || momentDate.minute() !== 0 || momentDate.hour() !== 0) {
			hasTime = true;
		}
	}
	if (hasTime) {
		return 'MMM D, YYYY h:mm:ss a';
	}
	return 'MMM D, YYYY';
}

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'bottom',

		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',

		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',

		time: {
			parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',

			// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
			displayFormats: {
				millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
				second: 'h:mm:ss a', // 11:20:01 AM
				minute: 'h:mm a', // 11:20 AM
				hour: 'hA', // 5PM
				day: 'MMM D', // Sep 4
				week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
				month: 'MMM YYYY', // Sept 2015
				quarter: '[Q]Q - YYYY', // Q3
				year: 'YYYY' // 2015
			},
		},
		ticks: {
			autoSkip: false,

			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',

			major: {
				enabled: false
			}
		}
	};

	var TimeScale = Chart.Scale.extend({
		initialize: function() {
			if (!moment) {
				throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
			}

			this.mergeTicksOptions();

			Chart.Scale.prototype.initialize.call(this);
		},

		update: function() {
			var me = this;
			var options = me.options;

			// DEPRECATIONS: output a message only one time per update
			if (options.time && options.time.format) {
				console.warn('options.time.format is deprecated and replaced by options.time.parser.');
			}

			return Chart.Scale.prototype.update.apply(me, arguments);
		},

		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return Chart.Scale.prototype.getRightValue.call(this, rawValue);
		},

		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var timeOpts = me.options.time;
			var unit = timeOpts.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp;

			// Convert labels to timestamps
			for (i = 0, ilen = chart.data.labels.length; i < ilen; ++i) {
				labels.push(parse(chart.data.labels[i], me));
			}

			// Convert data to timestamps
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;

					// Let's consider that all data have the same format.
					if (helpers.isObject(data[0])) {
						datasets[i] = [];

						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(data[j], me);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						timestamps.push.apply(timestamps, labels);
						datasets[i] = labels.slice(0);
					}
				} else {
					datasets[i] = [];
				}
			}

			if (labels.length) {
				// Sort labels **after** data have been converted
				labels = arrayUnique(labels).sort(sorter);
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}

			if (timestamps.length) {
				timestamps = arrayUnique(timestamps).sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}

			min = parse(timeOpts.min, me) || min;
			max = parse(timeOpts.max, me) || max;

			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +moment().startOf(unit) : min;
			max = max === MIN_INTEGER ? +moment().endOf(unit) + 1 : max;

			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);

			// PRIVATE
			me._horizontal = me.isHorizontal();
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},

		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var timeOpts = options.time;
			var timestamps = [];
			var ticks = [];
			var i, ilen, timestamp;

			switch (options.ticks.source) {
			case 'data':
				timestamps = me._timestamps.data;
				break;
			case 'labels':
				timestamps = me._timestamps.labels;
				break;
			case 'auto':
			default:
				timestamps = generate(min, max, me.getLabelCapacity(min), options);
			}

			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}

			// Enforce limits with user min/max options
			min = parse(timeOpts.min, me) || min;
			max = parse(timeOpts.max, me) || max;

			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}

			me.min = min;
			me.max = max;

			// PRIVATE
			me._unit = timeOpts.unit || determineUnitForFormatting(ticks, timeOpts.minUnit, me.min, me.max);
			me._majorUnit = determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);
			me._labelFormat = determineLabelFormat(me._timestamps.data, timeOpts);

			return ticksFromTimestamps(ticks, me._majorUnit);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];

			if (helpers.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return momentify(label, timeOpts).format(timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}

			return momentify(label, timeOpts).format(me._labelFormat);
		},

		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(tick, index, ticks, formatOverride) {
			var me = this;
			var options = me.options;
			var time = tick.valueOf();
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var majorTime = tick.clone().startOf(majorUnit).valueOf();
			var majorTickOpts = options.ticks.major;
			var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
			var label = tick.format(formatOverride ? formatOverride : major ? majorFormat : minorFormat);
			var tickOpts = major ? majorTickOpts : options.ticks.minor;
			var formatter = helpers.valueOrDefault(tickOpts.callback, tickOpts.userCallback);

			return formatter ? formatter(label, index, ticks) : label;
		},

		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;

			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(moment(ticks[i].value), i, ticks));
			}

			return labels;
		},

		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = interpolate(me._table, 'time', time, 'pos');

			return start + size * (me._offsets.left + pos) / (me._offsets.left + 1 + me._offsets.right);
		},

		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;

			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}

			if (time === null) {
				time = parse(value, me);
			}

			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},

		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},

		getValueForPixel: function(pixel) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = (size ? (pixel - start) / size : 0) * (me._offsets.left + 1 + me._offsets.left) - me._offsets.right;
			var time = interpolate(me._table, 'pos', pos, 'time');

			return moment(time);
		},

		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers.toRadians(ticksOpts.maxRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = helpers.valueOrDefault(ticksOpts.fontSize, defaults.global.defaultFontSize);

			return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
		},

		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;

			var formatOverride = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation

			var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, [], formatOverride);
			var tickLabelWidth = me.getLabelWidth(exampleLabel);
			var innerWidth = me.isHorizontal() ? me.width : me.height;

			var capacity = Math.floor(innerWidth / tickLabelWidth);
			return capacity > 0 ? capacity : 1;
		}
	});

	Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var elements = __webpack_require__(22);
var helpers = __webpack_require__(1);

defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',

			// Specific to Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			position: 'left',
			type: 'category',

			// Specific to Horizontal Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		callbacks: {
			title: function(item, data) {
				// Pick first xLabel for now
				var title = '';

				if (item.length > 0) {
					if (item[0].yLabel) {
						title = item[0].yLabel;
					} else if (data.labels.length > 0 && item[0].index < data.labels.length) {
						title = data.labels[item[0].index];
					}
				}

				return title;
			},

			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				return datasetLabel + ': ' + item.xLabel;
			}
		},
		mode: 'index',
		axis: 'y'
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale.isHorizontal() ? scale.width : scale.height;
	var ticks = scale.getTicks();
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, pixels[i] - pixels[i - 1]);
	}

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, curr - prev) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var size, ratio;

	if (helpers.isNullOrUndef(thickness)) {
		size = ruler.min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale end extremity.
		prev = curr - (next === null ? ruler.end - curr : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - ((curr - prev) / 2) * percent;
	size = ((next - prev) / 2) * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

module.exports = function(Chart) {

	Chart.controllers.bar = Chart.DatasetController.extend({

		dataElementType: elements.Rectangle,

		initialize: function() {
			var me = this;
			var meta;

			Chart.DatasetController.prototype.initialize.apply(me, arguments);

			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
		},

		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;

			me._ruler = me.getRuler();

			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},

		updateElement: function(rectangle, index, reset) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var custom = rectangle.custom || {};
			var rectangleOptions = chart.options.elements.rectangle;

			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;

			rectangle._model = {
				datasetLabel: dataset.label,
				label: chart.data.labels[index],
				borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
				backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
				borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
				borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
			};

			me.updateElementGeometry(rectangle, index, reset);

			rectangle.pivot();
		},

		/**
		 * @private
		 */
		updateElementGeometry: function(rectangle, index, reset) {
			var me = this;
			var model = rectangle._model;
			var vscale = me.getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);

			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},

		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getValueScale: function() {
			return this.getScaleForId(this.getValueScaleId());
		},

		/**
		 * @private
		 */
		getIndexScale: function() {
			return this.getScaleForId(this.getIndexScaleId());
		},

		/**
		 * Returns the stacks based on groups and bar visibility.
		 * @param {Number} [last] - The dataset index
		 * @returns {Array} The stack list
		 * @private
		 */
		_getStacks: function(last) {
			var me = this;
			var chart = me.chart;
			var scale = me.getIndexScale();
			var stacked = scale.options.stacked;
			var ilen = last === undefined ? chart.data.datasets.length : last + 1;
			var stacks = [];
			var i, meta;

			for (i = 0; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				if (meta.bar && chart.isDatasetVisible(i) &&
					(stacked === false ||
					(stacked === true && stacks.indexOf(meta.stack) === -1) ||
					(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
					stacks.push(meta.stack);
				}
			}

			return stacks;
		},

		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function() {
			return this._getStacks().length;
		},

		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @param {Number} [datasetIndex] - The dataset index
		 * @param {String} [name] - The stack name to find
		 * @returns {Number} The stack index
		 * @private
		 */
		getStackIndex: function(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = (name !== undefined)
				? stacks.indexOf(name)
				: -1; // indexOf returns -1 if element is not present

			return (index === -1)
				? stacks.length - 1
				: index;
		},

		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me.getIndexScale();
			var stackCount = me.getStackCount();
			var datasetIndex = me.index;
			var isHorizontal = scale.isHorizontal();
			var start = isHorizontal ? scale.left : scale.top;
			var end = start + (isHorizontal ? scale.width : scale.height);
			var pixels = [];
			var i, ilen, min;

			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, datasetIndex));
			}

			min = helpers.isNullOrUndef(scale.options.barThickness)
				? computeMinSampleSize(scale, pixels)
				: -1;

			return {
				min: min,
				pixels: pixels,
				start: start,
				end: end,
				stackCount: stackCount,
				scale: scale
			};
		},

		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var scale = me.getValueScale();
			var datasets = chart.data.datasets;
			var value = scale.getRightValue(datasets[datasetIndex].data[index]);
			var stacked = scale.options.stacked;
			var stack = meta.stack;
			var start = 0;
			var i, imeta, ivalue, base, head, size;

			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < datasetIndex; ++i) {
					imeta = chart.getDatasetMeta(i);

					if (imeta.bar &&
						imeta.stack === stack &&
						imeta.controller.getValueScaleId() === scale.id &&
						chart.isDatasetVisible(i)) {

						ivalue = scale.getRightValue(datasets[i].data[index]);
						if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}

			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + value);
			size = (head - base) / 2;

			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},

		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler) {
			var me = this;
			var options = ruler.scale.options;
			var range = options.barThickness === 'flex'
				? computeFlexCategoryTraits(index, ruler, options)
				: computeFitCategoryTraits(index, ruler, options);

			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
			var size = Math.min(
				helpers.valueOrDefault(options.maxBarThickness, Infinity),
				range.chunk * range.ratio);

			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me.getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;

			helpers.canvas.clipArea(chart.ctx, chart.chartArea);

			for (; i < ilen; ++i) {
				if (!isNaN(scale.getRightValue(dataset.data[i]))) {
					rects[i].draw();
				}
			}

			helpers.canvas.unclipArea(chart.ctx);
		},

		setHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;
			var rectangleElementOptions = this.chart.options.elements.rectangle;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
		}
	});

	Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var elements = __webpack_require__(22);
var helpers = __webpack_require__(1);

defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});


module.exports = function(Chart) {

	Chart.controllers.bubble = Chart.DatasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,

		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},

		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;

			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};

			point.pivot();
		},

		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;

			model.backgroundColor = helpers.valueOrDefault(options.hoverBackgroundColor, helpers.getHoverColor(options.backgroundColor));
			model.borderColor = helpers.valueOrDefault(options.hoverBorderColor, helpers.getHoverColor(options.borderColor));
			model.borderWidth = helpers.valueOrDefault(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},

		/**
		 * @protected
		 */
		removeHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;

			model.backgroundColor = options.backgroundColor;
			model.borderColor = options.borderColor;
			model.borderWidth = options.borderWidth;
			model.radius = options.radius;
		},

		/**
		 * @private
		 */
		_resolveElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var dataset = datasets[me.index];
			var custom = point.custom || {};
			var options = chart.options.elements.point;
			var resolve = helpers.options.resolve;
			var data = dataset.data[index];
			var values = {};
			var i, ilen, key;

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			var keys = [
				'backgroundColor',
				'borderColor',
				'borderWidth',
				'hoverBackgroundColor',
				'hoverBorderColor',
				'hoverBorderWidth',
				'hoverRadius',
				'hitRadius',
				'pointStyle'
			];

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}

			// Custom radius resolution
			values.radius = resolve([
				custom.radius,
				data ? data.r : undefined,
				dataset.radius,
				options.radius
			], context, index);

			return values;
		}
	});
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var elements = __webpack_require__(22);
var helpers = __webpack_require__(1);

defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc && arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: Math.PI * -0.5,

	// The total circumference of the chart.
	circumference: Math.PI * 2.0,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

defaults._set('pie', helpers.clone(defaults.doughnut));
defaults._set('pie', {
	cutoutPercentage: 0
});

module.exports = function(Chart) {

	Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;

			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}

			return ringIndex;
		},

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth;
			var availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth;
			var minSize = Math.min(availableWidth, availableHeight);
			var offset = {x: 0, y: 0};
			var meta = me.getMeta();
			var cutoutPercentage = opts.cutoutPercentage;
			var circumference = opts.circumference;

			// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
			if (circumference < Math.PI * 2.0) {
				var startAngle = opts.rotation % (Math.PI * 2.0);
				startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
				var endAngle = startAngle + circumference;
				var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
				var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
				var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
				var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
				var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
				var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
				var cutout = cutoutPercentage / 100.0;
				var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
				var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
				var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
				minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
				offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
			}

			chart.borderWidth = me.getMaxBorderWidth(meta.data);
			chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
			chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
			chart.offsetX = offset.x * chart.outerRadius;
			chart.offsetY = offset.y * chart.outerRadius;

			meta.total = me.calculateTotal();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,

				// Desired view properties
				_model: {
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});

			var model = arc._model;
			// Resets the visual styles
			this.removeHoverStyle(arc);

			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}

				model.endAngle = model.startAngle + model.circumference;
			}

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;

			helpers.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});

			/* if (total === 0) {
				total = NaN;
			}*/

			return total;
		},

		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return (Math.PI * 2.0) * (Math.abs(value) / total);
			}
			return 0;
		},

		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var max = 0;
			var index = this.index;
			var length = arcs.length;
			var borderWidth;
			var hoverWidth;

			for (var i = 0; i < length; i++) {
				borderWidth = arcs[i]._model ? arcs[i]._model.borderWidth : 0;
				hoverWidth = arcs[i]._chart ? arcs[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
			return max;
		}
	});
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var elements = __webpack_require__(22);
var helpers = __webpack_require__(1);

defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

module.exports = function(Chart) {

	function lineEnabled(dataset, options) {
		return helpers.valueOrDefault(dataset.showLine, options.showLines);
	}

	Chart.controllers.line = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var lineElementOptions = options.elements.line;
			var scale = me.getScaleForId(meta.yAxisID);
			var i, ilen, custom;
			var dataset = me.getDataset();
			var showLine = lineEnabled(dataset, options);

			// Update Line
			if (showLine) {
				custom = line.custom || {};

				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}

				// Utility
				line._scale = scale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = {
					// Appearance
					// The default behavior of lines is to break at null values, according
					// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
					// This option gives lines the ability to span gaps
					spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					steppedLine: custom.steppedLine ? custom.steppedLine : helpers.valueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
					cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.valueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
				};

				line.pivot();
			}

			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}

			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}

			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},

		getPointBackgroundColor: function(point, index) {
			var backgroundColor = this.chart.options.elements.point.backgroundColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.backgroundColor) {
				backgroundColor = custom.backgroundColor;
			} else if (dataset.pointBackgroundColor) {
				backgroundColor = helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
			} else if (dataset.backgroundColor) {
				backgroundColor = dataset.backgroundColor;
			}

			return backgroundColor;
		},

		getPointBorderColor: function(point, index) {
			var borderColor = this.chart.options.elements.point.borderColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.borderColor) {
				borderColor = custom.borderColor;
			} else if (dataset.pointBorderColor) {
				borderColor = helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
			} else if (dataset.borderColor) {
				borderColor = dataset.borderColor;
			}

			return borderColor;
		},

		getPointBorderWidth: function(point, index) {
			var borderWidth = this.chart.options.elements.point.borderWidth;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (!isNaN(custom.borderWidth)) {
				borderWidth = custom.borderWidth;
			} else if (!isNaN(dataset.pointBorderWidth) || helpers.isArray(dataset.pointBorderWidth)) {
				borderWidth = helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
			} else if (!isNaN(dataset.borderWidth)) {
				borderWidth = dataset.borderWidth;
			}

			return borderWidth;
		},

		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var yScale = me.getScaleForId(meta.yAxisID);
			var xScale = me.getScaleForId(meta.xAxisID);
			var pointOptions = me.chart.options.elements.point;
			var x, y;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._datasetIndex = datasetIndex;
			point._index = index;

			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
				pointStyle: custom.pointStyle || helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
				backgroundColor: me.getPointBackgroundColor(point, index),
				borderColor: me.getPointBorderColor(point, index),
				borderWidth: me.getPointBorderWidth(point, index),
				tension: meta.dataset._model ? meta.dataset._model.tension : 0,
				steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
				// Tooltip
				hitRadius: custom.hitRadius || helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
			};
		},

		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var yScale = me.getScaleForId(meta.yAxisID);
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta;

			if (yScale.options.stacked) {
				for (i = 0; i < datasetIndex; i++) {
					ds = chart.data.datasets[i];
					dsMeta = chart.getDatasetMeta(i);
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
						var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}

				var rightValue = Number(yScale.getRightValue(value));
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}

			return yScale.getPixelForValue(value);
		},

		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = (meta.data || []);
			var i, ilen, point, model, controlPoints;

			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}

			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}

			if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
				helpers.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					point = points[i];
					model = point._model;
					controlPoints = helpers.splineCurve(
						helpers.previousItem(points, i)._model,
						model,
						helpers.nextItem(points, i)._model,
						meta.dataset._model.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}

			if (me.chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
					model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
					model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
				}
			}
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var ilen = points.length;
			var i = 0;

			helpers.canvas.clipArea(chart.ctx, area);

			if (lineEnabled(me.getDataset(), chart.options)) {
				meta.dataset.draw();
			}

			helpers.canvas.unclipArea(chart.ctx);

			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			model.radius = custom.hoverRadius || helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var me = this;
			var dataset = me.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}

			model.radius = custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
			model.backgroundColor = me.getPointBackgroundColor(point, index);
			model.borderColor = me.getPointBorderColor(point, index);
			model.borderWidth = me.getPointBorderWidth(point, index);
		}
	});
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var elements = __webpack_require__(22);
var helpers = __webpack_require__(1);

defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.polarArea = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var meta = me.getMeta();
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
			chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;

			meta.count = me.countVisibleElements();

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;

			var circumference = me.calculateCircumference(dataset.data[index]);
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;

			// If there is NaN data before us, we need to calculate the starting angle correctly.
			// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
			var visibleCount = 0;
			var meta = me.getMeta();
			for (var i = 0; i < index; ++i) {
				if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
					++visibleCount;
				}
			}

			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = datasetStartAngle + (circumference * visibleCount);
			var endAngle = startAngle + (arc.hidden ? 0 : circumference);

			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});

			// Apply border and fill style
			me.removeHoverStyle(arc);

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;

			helpers.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});

			return count;
		},

		calculateCircumference: function(value) {
			var count = this.getMeta().count;
			if (count > 0 && !isNaN(value)) {
				return (2 * Math.PI) / count;
			}
			return 0;
		}
	});
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var elements = __webpack_require__(22);
var helpers = __webpack_require__(1);

defaults._set('radar', {
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			tension: 0 // no bezier in radar
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.radar = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data;
			var custom = line.custom || {};
			var dataset = me.getDataset();
			var lineElementOptions = me.chart.options.elements.line;
			var scale = me.chart.scale;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
				dataset.lineTension = dataset.tension;
			}

			helpers.extend(meta.dataset, {
				// Utility
				_datasetIndex: me.index,
				_scale: scale,
				// Data
				_children: points,
				_loop: true,
				// Model
				_model: {
					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
				}
			});

			meta.dataset.pivot();

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			}, me);

			// Update bezier control points
			me.updateBezierControlPoints();
		},
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointElementOptions = me.chart.options.elements.point;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			helpers.extend(point, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
					y: reset ? scale.yCenter : pointPosition.y,

					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
					radius: custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
					pointStyle: custom.pointStyle ? custom.pointStyle : helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),

					// Tooltip
					hitRadius: custom.hitRadius ? custom.hitRadius : helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
				}
			});

			point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
		},
		updateBezierControlPoints: function() {
			var chartArea = this.chart.chartArea;
			var meta = this.getMeta();

			helpers.each(meta.data, function(point, index) {
				var model = point._model;
				var controlPoints = helpers.splineCurve(
					helpers.previousItem(meta.data, index, true)._model,
					model,
					helpers.nextItem(meta.data, index, true)._model,
					model.tension
				);

				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
				model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);

				model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
				model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);

				// Now pivot the point for animation
				point.pivot();
			});
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;

			model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;
			var pointElementOptions = this.chart.options.elements.point;

			model.radius = custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius);
			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
		}
	});
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);

defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	showLines: false,

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

module.exports = function(Chart) {

	// Scatter charts use line controllers
	Chart.controllers.scatter = Chart.controllers.line;

};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Bar = function(context, config) {
		config.type = 'bar';

		return new Chart(context, config);
	};

};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Bubble = function(context, config) {
		config.type = 'bubble';
		return new Chart(context, config);
	};

};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Line = function(context, config) {
		config.type = 'line';

		return new Chart(context, config);
	};

};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.PolarArea = function(context, config) {
		config.type = 'polarArea';

		return new Chart(context, config);
	};

};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Radar = function(context, config) {
		config.type = 'radar';

		return new Chart(context, config);
	};

};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {
	Chart.Scatter = function(context, config) {
		config.type = 'scatter';
		return new Chart(context, config);
	};
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};
module.exports.filler = __webpack_require__(294);
module.exports.legend = __webpack_require__(295);
module.exports.title = __webpack_require__(296);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Plugin based on discussion from the following Chart.js issues:
 * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
 * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
 */



var defaults = __webpack_require__(3);
var elements = __webpack_require__(22);
var helpers = __webpack_require__(1);

defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePosition) {
		target = scale.getBasePosition();
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (typeof target === 'number' && isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1;

	ctx.beginPath();

	for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

module.exports = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetDraw: function(chart, args) {
		var meta = args.meta.$filler;
		if (!meta) {
			return;
		}

		var ctx = chart.ctx;
		var el = meta.el;
		var view = el._view;
		var points = el._children || [];
		var mapper = meta.mapper;
		var color = view.backgroundColor || defaults.global.defaultColor;

		if (mapper && color && points.length) {
			helpers.canvas.clipArea(ctx, chart.chartArea);
			doFill(ctx, points, mapper, view, color, el._loop);
			helpers.canvas.unclipArea(ctx);
		}
	}
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var Element = __webpack_require__(14);
var helpers = __webpack_require__(1);
var layouts = __webpack_require__(30);

var noop = helpers.noop;

defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var data = chart.data;
				return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
					return {
						text: dataset.label,
						fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
						hidden: !chart.isDatasetVisible(i),
						lineCap: dataset.borderCapStyle,
						lineDash: dataset.borderDash,
						lineDashOffset: dataset.borderDashOffset,
						lineJoin: dataset.borderJoinStyle,
						lineWidth: dataset.borderWidth,
						strokeStyle: dataset.borderColor,
						pointStyle: dataset.pointStyle,

						// Below is extra data used for toggling the datasets
						datasetIndex: i
					};
				}, this) : [];
			}
		}
	},

	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');
		for (var i = 0; i < chart.data.datasets.length; i++) {
			text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
			if (chart.data.datasets[i].label) {
				text.push(chart.data.datasets[i].label);
			}
			text.push('</li>');
		}
		text.push('</ul>');
		return text.join('');
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param labelopts {Object} the label options on the legend
 * @param fontSize {Number} the label font size
 * @return {Number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle ?
		fontSize * Math.SQRT2 :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = Element.extend({

	initialize: function(config) {
		helpers.extend(this, config);

		// Contains hit boxes for each dataset (in dataset order)
		this.legendHitBoxes = [];

		// Are we in doughnut mode which has a different data type
		this.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop,

	//

	beforeSetDimensions: noop,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop,

	//

	beforeBuildLabels: noop,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop,

	//

	beforeFit: noop,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var globalDefault = defaults.global;
		var valueOrDefault = helpers.valueOrDefault;
		var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
		var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
		var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
		var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (display) {
			ctx.font = labelFont;

			if (isHorizontal) {
				// Labels

				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;

				ctx.textAlign = 'left';
				ctx.textBaseline = 'top';

				helpers.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

					if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
						totalHeight += fontSize + (labelOpts.padding);
						lineWidths[lineWidths.length] = me.left;
					}

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};

					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});

				minSize.height += totalHeight;

			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;
				var itemHeight = fontSize + vPadding;

				helpers.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

					// If too tall, go to new column
					if (currentColHeight + itemHeight > minSize.height) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width

						currentColWidth = 0;
						currentColHeight = 0;
					}

					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += itemHeight;

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});

				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				minSize.width += totalWidth;
			}
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefault = defaults.global;
		var lineDefault = globalDefault.elements.line;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (opts.display) {
			var ctx = me.ctx;
			var valueOrDefault = helpers.valueOrDefault;
			var fontColor = valueOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
			var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
			var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
			var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
			var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
			var cursor;

			// Canvas setup
			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont;

			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;

			// current position
			var drawLegendBox = function(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}

				// Set the ctx for the box
				ctx.save();

				ctx.fillStyle = valueOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
				ctx.lineCap = valueOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
				var isLineWidthZero = (valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);

				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault(legendItem.lineDash, lineDefault.borderDash));
				}

				if (opts.labels && opts.labels.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = fontSize * Math.SQRT2 / 2;
					var offSet = radius / Math.SQRT2;
					var centerX = x + offSet;
					var centerY = y + offSet;

					// Draw pointStyle as legend symbol
					helpers.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
				} else {
					// Draw box as legend symbol
					if (!isLineWidthZero) {
						ctx.strokeRect(x, y, boxWidth, fontSize);
					}
					ctx.fillRect(x, y, boxWidth, fontSize);
				}

				ctx.restore();
			};
			var fillText = function(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = boxWidth + halfFontSize + x;
				var yMiddle = y + halfFontSize;

				ctx.fillText(legendItem.text, xLeft, yMiddle);

				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(xLeft + textWidth, yMiddle);
					ctx.stroke();
				}
			};

			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + ((legendWidth - lineWidths[0]) / 2),
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + labelOpts.padding,
					line: 0
				};
			}

			var itemHeight = fontSize + labelOpts.padding;
			helpers.each(me.legendItems, function(legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + (fontSize / 2) + textWidth;
				var x = cursor.x;
				var y = cursor.y;

				if (isHorizontal) {
					if (x + width >= legendWidth) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
					}
				} else if (y + itemHeight > me.bottom) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					y = cursor.y = me.top + labelOpts.padding;
					cursor.line++;
				}

				drawLegendBox(x, y, legendItem);

				hitboxes[i].left = x;
				hitboxes[i].top = y;

				// Fill the actual label
				fillText(x, y, legendItem, textWidth);

				if (isHorizontal) {
					cursor.x += width + (labelOpts.padding);
				} else {
					cursor.y += itemHeight;
				}

			});
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @return {Boolean} true if a change occured
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var changed = false;

		if (type === 'mousemove') {
			if (!opts.onHover) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		var x = e.x;
		var y = e.y;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			var lh = me.legendHitBoxes;
			for (var i = 0; i < lh.length; ++i) {
				var hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					if (type === 'click') {
						// use e.native for backwards compatibility
						opts.onClick.call(me, e.native, me.legendItems[i]);
						changed = true;
						break;
					} else if (type === 'mousemove') {
						// use e.native for backwards compatibility
						opts.onHover.call(me, e.native, me.legendItems[i]);
						changed = true;
						break;
					}
				}
			}
		}

		return changed;
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	layouts.configure(chart, legend, legendOpts);
	layouts.addBox(chart, legend);
	chart.legend = legend;
}

module.exports = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers.mergeIf(legendOpts, defaults.global.legend);

			if (legend) {
				layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(3);
var Element = __webpack_require__(14);
var helpers = __webpack_require__(1);
var layouts = __webpack_require__(30);

var noop = helpers.noop;

defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		lineHeight: 1.2,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = Element.extend({
	initialize: function(config) {
		var me = this;
		helpers.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop,

	//

	beforeSetDimensions: noop,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop,

	//

	beforeBuildLabels: noop,
	buildLabels: noop,
	afterBuildLabels: noop,

	//

	beforeFit: noop,
	fit: function() {
		var me = this;
		var valueOrDefault = helpers.valueOrDefault;
		var opts = me.options;
		var display = opts.display;
		var fontSize = valueOrDefault(opts.fontSize, defaults.global.defaultFontSize);
		var minSize = me.minSize;
		var lineCount = helpers.isArray(opts.text) ? opts.text.length : 1;
		var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
		var textSize = display ? (lineCount * lineHeight) + (opts.padding * 2) : 0;

		if (me.isHorizontal()) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = textSize;
		} else {
			minSize.width = textSize;
			minSize.height = me.maxHeight; // fill all the height
		}

		me.width = minSize.width;
		me.height = minSize.height;

	},
	afterFit: noop,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var valueOrDefault = helpers.valueOrDefault;
		var opts = me.options;
		var globalDefaults = defaults.global;

		if (opts.display) {
			var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize);
			var fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle);
			var fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily);
			var titleFont = helpers.fontString(fontSize, fontStyle, fontFamily);
			var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;

			ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
			ctx.font = titleFont;

			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + ((right - left) / 2); // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + ((bottom - top) / 2);
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}

			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';

			var text = opts.text;
			if (helpers.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}

			ctx.restore();
		}
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	layouts.configure(chart, title, titleOpts);
	layouts.addBox(chart, title);
	chart.titleBlock = title;
}

module.exports = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers.mergeIf(titleOpts, defaults.global.title);

			if (titleBlock) {
				layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(62);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(98),
    equalArrays = __webpack_require__(103),
    equalByTag = __webpack_require__(332),
    equalObjects = __webpack_require__(336),
    getTag = __webpack_require__(354),
    isArray = __webpack_require__(18),
    isBuffer = __webpack_require__(105),
    isTypedArray = __webpack_require__(107);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 299 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(43);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(43);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(43);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(43);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(42);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 306 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 307 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(42),
    Map = __webpack_require__(63),
    MapCache = __webpack_require__(64);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(100),
    isMasked = __webpack_require__(312),
    isObject = __webpack_require__(45),
    toSource = __webpack_require__(102);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(44);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 311 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(313);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(17);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(316),
    ListCache = __webpack_require__(42),
    Map = __webpack_require__(63);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(317),
    hashDelete = __webpack_require__(318),
    hashGet = __webpack_require__(319),
    hashHas = __webpack_require__(320),
    hashSet = __webpack_require__(321);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(46);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(46);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(46);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(46);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(47);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(47);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(47);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(47);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(64),
    setCacheAdd = __webpack_require__(328),
    setCacheHas = __webpack_require__(329);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(44),
    Uint8Array = __webpack_require__(333),
    eq = __webpack_require__(99),
    equalArrays = __webpack_require__(103),
    mapToArray = __webpack_require__(334),
    setToArray = __webpack_require__(335);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(17);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(337);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(338),
    getSymbols = __webpack_require__(340),
    keys = __webpack_require__(48);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(339),
    isArray = __webpack_require__(18);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 339 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(341),
    stubArray = __webpack_require__(342);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 341 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(344),
    isArguments = __webpack_require__(104),
    isArray = __webpack_require__(18),
    isBuffer = __webpack_require__(105),
    isIndex = __webpack_require__(106),
    isTypedArray = __webpack_require__(107);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(32),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 346 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(32),
    isLength = __webpack_require__(65),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(101);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(351),
    nativeKeys = __webpack_require__(352);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(353);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(355),
    Map = __webpack_require__(63),
    Promise = __webpack_require__(356),
    Set = __webpack_require__(357),
    WeakMap = __webpack_require__(358),
    baseGetTag = __webpack_require__(32),
    toSource = __webpack_require__(102);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(360),
    findIndex = __webpack_require__(379);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67),
    isArrayLike = __webpack_require__(66),
    keys = __webpack_require__(48);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(362),
    getMatchData = __webpack_require__(363),
    matchesStrictComparable = __webpack_require__(109);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(98),
    baseIsEqual = __webpack_require__(62);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(108),
    keys = __webpack_require__(48);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(62),
    get = __webpack_require__(365),
    hasIn = __webpack_require__(372),
    isKey = __webpack_require__(68),
    isStrictComparable = __webpack_require__(108),
    matchesStrictComparable = __webpack_require__(109),
    toKey = __webpack_require__(50);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(110);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(367);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(368);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(64);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(370);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(44),
    arrayMap = __webpack_require__(371),
    isArray = __webpack_require__(18),
    isSymbol = __webpack_require__(49);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 371 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(373),
    hasPath = __webpack_require__(374);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(111),
    isArguments = __webpack_require__(104),
    isArray = __webpack_require__(18),
    isIndex = __webpack_require__(106),
    isLength = __webpack_require__(65),
    toKey = __webpack_require__(50);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 375 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(377),
    basePropertyDeep = __webpack_require__(378),
    isKey = __webpack_require__(68),
    toKey = __webpack_require__(50);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 377 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(110);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(380),
    baseIteratee = __webpack_require__(67),
    toInteger = __webpack_require__(381);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 380 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(382);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(383);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(384),
    isObject = __webpack_require__(45),
    isSymbol = __webpack_require__(49);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(385);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 385 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(387),
    createAggregator = __webpack_require__(389);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(388);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(24);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(390),
    baseAggregator = __webpack_require__(391),
    baseIteratee = __webpack_require__(67),
    isArray = __webpack_require__(18);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 390 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(392);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(393),
    createBaseEach = __webpack_require__(396);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(394),
    keys = __webpack_require__(48);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(395);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 395 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(66);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Howitworks=function(_Component){_inherits(Howitworks,_Component);function Howitworks(){_classCallCheck(this,Howitworks);return _possibleConstructorReturn(this,(Howitworks.__proto__||Object.getPrototypeOf(Howitworks)).apply(this,arguments));}_createClass(Howitworks,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inside centralize'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'A cosa serve'),'ClubHub server per gestire in toto una associaizone sportiva',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Quanto costa'),'Costa 129,00 \u20AC per ogni anno fiscale',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Vuoi provarlo?'),'Accedi con questi dati se vuoi fare un test:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Utente amministratore'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'user: test_admin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'password: test_admin')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Utente con limitazioni'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'user: test_user'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'password: test_user')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Come fare per attivare il proprio account'),'Scrivere a mauro.sala@gmail.com per ricevere informazioni e modalit\xE0 di accesso'));}}]);return Howitworks;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Howitworks);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Notes__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DualRing__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Error__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AjaxSpinner__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Notes_NotesDetails__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Notes_EditNote__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Notes_DeleteNote__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Utils_Service__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={showDelete:false,showEdit:false,note:{}};var Notes=function(_Component){_inherits(Notes,_Component);function Notes(){_classCallCheck(this,Notes);var _this=_possibleConstructorReturn(this,(Notes.__proto__||Object.getPrototypeOf(Notes)).call(this));_this.showDelete=_this.showDelete.bind(_this);_this.showEdit=_this.showEdit.bind(_this);_this.hideModal=_this.hideModal.bind(_this);_this.escFunction=_this.escFunction.bind(_this);_this.state=initialState;return _this;}_createClass(Notes,[{key:'escFunction',value:function escFunction(event){if(event.keyCode===27){this.hideModal();}}},{key:'componentWillMount',value:function componentWillMount(){if(this.props.notes.list===null){this.reloadNotes();}}},{key:'showDelete',value:function showDelete(note){this.setState({showDelete:true,note:note});}},{key:'showEdit',value:function showEdit(note){this.setState({showEdit:true,note:note});}},{key:'newNote',value:function newNote(){this.setState({showEdit:true,note:{id:null,title:'',message:'',share:0}});}},{key:'hideModal',value:function hideModal(){this.setState({showDelete:false,showEdit:false});}},{key:'reloadNotes',value:function reloadNotes(){this.props.loadNotes();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this2=this;if(prevProps.notes.ajaxSpinner&&!this.props.notes.ajaxSpinner&&this.props.notes.ajaxStatus===null){this.hideModal();}if(prevProps.notes.ajaxSpinner&&!this.props.notes.ajaxSpinner&&this.props.notes.ajaxStatus!==null){setTimeout(function(){_this2.props.clearAjaxCall('');},3000);}}},{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('keydown',this.escFunction,false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('keydown',this.escFunction,false);}},{key:'render',value:function render(){var _this3=this;var _props$notes=this.props.notes,list=_props$notes.list,error=_props$notes.error,loading=_props$notes.loading,ajaxSpinner=_props$notes.ajaxSpinner;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-title'},'Note'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-descr txt'},'Le note possono essere private o condivise con gli altri membri della tua associazione'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'ph-btn'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_Service__["grant"])()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3.newNote();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-sticky-note'}),' aggiungi')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3.reloadNotes();},className:'lnk-tools'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-redo-alt'}),' ricarica'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ph-count'},list!==null&&list.length+(list.length===1?' risultato':' risultati'),list===null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-sync fa-spin'}))),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DualRing__["a" /* default */],null),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Error__["a" /* default */],{error:error}),list!==null&&list.map(function(n,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Notes_NotesDetails__["a" /* default */],{key:index,note:n,showDelete:_this3.showDelete,showEdit:_this3.showEdit});}),this.state.showEdit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Notes_EditNote__["a" /* default */],{note:this.state.note,hideModal:this.hideModal}),this.state.showDelete&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Notes_DeleteNote__["a" /* default */],{note:this.state.note,hideModal:this.hideModal}),ajaxSpinner&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AjaxSpinner__["a" /* default */],null));}}]);return Notes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{loadNotes:__WEBPACK_IMPORTED_MODULE_2__actions_Notes__["l" /* loadNotes */],saveNotes:__WEBPACK_IMPORTED_MODULE_2__actions_Notes__["m" /* saveNotes */],deleteNotes:__WEBPACK_IMPORTED_MODULE_2__actions_Notes__["k" /* deleteNotes */],clearAjaxCall:__WEBPACK_IMPORTED_MODULE_2__actions_Notes__["j" /* clearAjaxCall */]})(Notes));

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_Service__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Utils_Service__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotesDetails=function(_PureComponent){_inherits(NotesDetails,_PureComponent);function NotesDetails(){_classCallCheck(this,NotesDetails);return _possibleConstructorReturn(this,(NotesDetails.__proto__||Object.getPrototypeOf(NotesDetails)).apply(this,arguments));}_createClass(NotesDetails,[{key:'render',value:function render(){var _this2=this;var n=this.props.note;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'row-item '+n.color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Autore'),n.author),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Titolo'),n.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Nota'),n.message.split('\n').map(function(item,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',{key:key},item,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'info-buttons'},n.share===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'far fa-eye-slash'}),n.share===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-lock'}),n.share===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-globe'}),Object(__WEBPACK_IMPORTED_MODULE_1__Utils_Service__["grant"])()&&(Object(__WEBPACK_IMPORTED_MODULE_1__Utils_Service__["grantMy"])(n.owner)||n.share===2)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-edits',onClick:function onClick(){return _this2.props.showEdit(n);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-edit'})),Object(__WEBPACK_IMPORTED_MODULE_1__Utils_Service__["grant"])()&&(Object(__WEBPACK_IMPORTED_MODULE_1__Utils_Service__["grantMy"])(n.owner)||n.share===2)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-edits',onClick:function onClick(){return _this2.props.showDelete(n);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-trash-alt'}))));}}]);return NotesDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (NotesDetails);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Notes__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var colors=[{value:'orange',name:'Arancione'},{value:'deep-orange',name:'Arancione scuro'},{value:'amber',name:'Ambra'},{value:'brown',name:'Marrone'},{value:'blue-grey',name:'Blu grigio'},{value:'blue',name:'Blu'},{value:'light-blue',name:'Blu chiaro'},{value:'yellow',name:'Giallo'},{value:'lime',name:'Lime'},{value:'cyan',name:'Ciano'},{value:'purple',name:'Porpora'},{value:'deep-purple',name:'Viola scuro'},{value:'indigo',name:'Indaco'},{value:'pink',name:'Rosa'},{value:'red',name:'Rosso'},{value:'green',name:'Verde'},{value:'light-green',name:'Verde chiaro'},{value:'teal',name:'Verde acqua'}];var EditNote=function(_Component){_inherits(EditNote,_Component);function EditNote(){_classCallCheck(this,EditNote);return _possibleConstructorReturn(this,(EditNote.__proto__||Object.getPrototypeOf(EditNote)).apply(this,arguments));}_createClass(EditNote,[{key:'saveNotes',value:function saveNotes(){var _this2=this;var s=this.state;if(s.title!==''&&s.message!==''){this.props.saveNotes(s);}else{this.props.saveNotesFailure('Titolo e nota sono obbligatori');setTimeout(function(){_this2.props.clearAjaxCall('');},3000);}}},{key:'componentWillMount',value:function componentWillMount(){var i=this.props.note;var rnd=Math.floor(Math.random()*colors.length);this.setState({id:i.id,title:i.title,color:i.id===null?colors[rnd].value:i.color,message:i.message,share:i.share});}},{key:'render',value:function render(){var _this3=this;var ajaxStatus=this.props.notes.ajaxStatus;var c=this.state;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,c.id!==null?'Modifica':'Aggiungi',' nota'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-modal',onClick:function onClick(){return _this3.props.hideModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Colore',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this3.setState({color:event.target.value});},value:c.color},colors.map(function(c,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:c.value},c.name);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cc-prev '+this.state.color})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Titolo',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Nome',onChange:function onChange(event){return _this3.setState({title:event.target.value});},value:c.title})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Nota',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Nota',onChange:function onChange(event){return _this3.setState({message:event.target.value});},value:c.message,className:'area-note'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Condivisione',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this3.setState({share:event.target.value});},value:c.share},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0},'Privata'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:1},'Condivisa'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:2},'Condivisa e modificabile'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submit-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ajax-error'},ajaxStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this3.props.hideModal();}},'annulla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this3.saveNotes();}},'salva'))));}}]);return EditNote;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{saveNotes:__WEBPACK_IMPORTED_MODULE_2__actions_Notes__["m" /* saveNotes */],saveNotesFailure:__WEBPACK_IMPORTED_MODULE_2__actions_Notes__["n" /* saveNotesFailure */],clearAjaxCall:__WEBPACK_IMPORTED_MODULE_2__actions_Notes__["j" /* clearAjaxCall */]})(EditNote));

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_Notes__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteNote=function(_Component){_inherits(DeleteNote,_Component);function DeleteNote(){_classCallCheck(this,DeleteNote);return _possibleConstructorReturn(this,(DeleteNote.__proto__||Object.getPrototypeOf(DeleteNote)).apply(this,arguments));}_createClass(DeleteNote,[{key:'deleteNotes',value:function deleteNotes(){this.props.deleteNotes({id:this.props.note.id});}},{key:'render',value:function render(){var _this2=this;var ajaxStatus=this.props.notes.ajaxStatus;var n=this.props.note;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Eliminare nota'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-close-modal',onClick:function onClick(){return _this2.props.hideModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})),n.title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'submit-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ajax-error'},ajaxStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.props.hideModal();}},'annulla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'lnk-submit',onClick:function onClick(){return _this2.deleteNotes();}},'elimna'))));}}]);return DeleteNote;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return state;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,{deleteNotes:__WEBPACK_IMPORTED_MODULE_2__actions_Notes__["k" /* deleteNotes */]})(DeleteNote));

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.c8dac272.js